/*! @preserve
 * AgoraRTM Web SDK 1.4.0 - commit: v1.4.0-0-g2c45f3b
 * Copyright (C) 2018-2020 Agora Lab.
 * This file is licensed under the AGORA, INC. SDK LICENSE AGREEMENT
 * A copy of this license may be found at https://www.agora.io/en/sdk-license-agreement/
 */
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).AgoraRTM = t();
}(this, function () {
  "use strict";

  var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  function unwrapExports(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }

  function createCommonjsModule(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }

  var _global = createCommonjsModule(function (e) {
    var t = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = t);
  }),
      _core = createCommonjsModule(function (e) {
    var t = e.exports = {
      version: "2.6.9"
    };
    "number" == typeof __e && (__e = t);
  }),
      _core_1 = _core.version,
      _isObject = function _isObject(e) {
    return "object" == typeof e ? null !== e : "function" == typeof e;
  },
      _anObject = function _anObject(e) {
    if (!_isObject(e)) throw TypeError(e + " is not an object!");
    return e;
  },
      _fails = function _fails(e) {
    try {
      return !!e();
    } catch (e) {
      return !0;
    }
  },
      _descriptors = !_fails(function () {
    return 7 != Object.defineProperty({}, "a", {
      get: function get() {
        return 7;
      }
    }).a;
  }),
      document$1 = _global.document,
      is = _isObject(document$1) && _isObject(document$1.createElement),
      _domCreate = function _domCreate(e) {
    return is ? document$1.createElement(e) : {};
  },
      _ie8DomDefine = !_descriptors && !_fails(function () {
    return 7 != Object.defineProperty(_domCreate("div"), "a", {
      get: function get() {
        return 7;
      }
    }).a;
  }),
      _toPrimitive = function _toPrimitive(e, t) {
    if (!_isObject(e)) return e;
    var r, n;
    if (t && "function" == typeof (r = e.toString) && !_isObject(n = r.call(e))) return n;
    if ("function" == typeof (r = e.valueOf) && !_isObject(n = r.call(e))) return n;
    if (!t && "function" == typeof (r = e.toString) && !_isObject(n = r.call(e))) return n;
    throw TypeError("Can't convert object to primitive value");
  },
      dP = Object.defineProperty,
      f = _descriptors ? Object.defineProperty : function (e, t, r) {
    if (_anObject(e), t = _toPrimitive(t, !0), _anObject(r), _ie8DomDefine) try {
      return dP(e, t, r);
    } catch (e) {}
    if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
    return "value" in r && (e[t] = r.value), e;
  },
      _objectDp = {
    f: f
  },
      _propertyDesc = function _propertyDesc(e, t) {
    return {
      enumerable: !(1 & e),
      configurable: !(2 & e),
      writable: !(4 & e),
      value: t
    };
  },
      _hide = _descriptors ? function (e, t, r) {
    return _objectDp.f(e, t, _propertyDesc(1, r));
  } : function (e, t, r) {
    return e[t] = r, e;
  },
      hasOwnProperty = {}.hasOwnProperty,
      _has = function _has(e, t) {
    return hasOwnProperty.call(e, t);
  },
      id = 0,
      px = Math.random(),
      _uid = function _uid(e) {
    return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++id + px).toString(36));
  },
      _library = !1,
      _shared = createCommonjsModule(function (e) {
    var t = _global["__core-js_shared__"] || (_global["__core-js_shared__"] = {});
    (e.exports = function (e, r) {
      return t[e] || (t[e] = void 0 !== r ? r : {});
    })("versions", []).push({
      version: _core.version,
      mode: "global",
      copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
    });
  }),
      _functionToString = _shared("native-function-to-string", Function.toString),
      _redefine = createCommonjsModule(function (e) {
    var t = _uid("src"),
        r = ("" + _functionToString).split("toString");

    _core.inspectSource = function (e) {
      return _functionToString.call(e);
    }, (e.exports = function (e, n, o, i) {
      var s = "function" == typeof o;
      s && (_has(o, "name") || _hide(o, "name", n)), e[n] !== o && (s && (_has(o, t) || _hide(o, t, e[n] ? "" + e[n] : r.join(String(n)))), e === _global ? e[n] = o : i ? e[n] ? e[n] = o : _hide(e, n, o) : (delete e[n], _hide(e, n, o)));
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && this[t] || _functionToString.call(this);
    });
  }),
      _aFunction = function _aFunction(e) {
    if ("function" != typeof e) throw TypeError(e + " is not a function!");
    return e;
  },
      _ctx = function _ctx(e, t, r) {
    if (_aFunction(e), void 0 === t) return e;

    switch (r) {
      case 1:
        return function (r) {
          return e.call(t, r);
        };

      case 2:
        return function (r, n) {
          return e.call(t, r, n);
        };

      case 3:
        return function (r, n, o) {
          return e.call(t, r, n, o);
        };
    }

    return function () {
      return e.apply(t, arguments);
    };
  },
      PROTOTYPE = "prototype",
      $export = function $export(e, t, r) {
    var n,
        o,
        i,
        s,
        a = e & $export.F,
        u = e & $export.G,
        l = e & $export.S,
        c = e & $export.P,
        p = e & $export.B,
        f = u ? _global : l ? _global[t] || (_global[t] = {}) : (_global[t] || {})[PROTOTYPE],
        d = u ? _core : _core[t] || (_core[t] = {}),
        g = d[PROTOTYPE] || (d[PROTOTYPE] = {});

    for (n in u && (r = t), r) {
      i = ((o = !a && f && void 0 !== f[n]) ? f : r)[n], s = p && o ? _ctx(i, _global) : c && "function" == typeof i ? _ctx(Function.call, i) : i, f && _redefine(f, n, i, e & $export.U), d[n] != i && _hide(d, n, s), c && g[n] != i && (g[n] = i);
    }
  };

  _global.core = _core, $export.F = 1, $export.G = 2, $export.S = 4, $export.P = 8, $export.B = 16, $export.W = 32, $export.U = 64, $export.R = 128;

  var _export = $export,
      toString = {}.toString,
      _cof = function _cof(e) {
    return toString.call(e).slice(8, -1);
  },
      _iobject = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
    return "String" == _cof(e) ? e.split("") : Object(e);
  },
      _defined = function _defined(e) {
    if (null == e) throw TypeError("Can't call method on  " + e);
    return e;
  },
      _toIobject = function _toIobject(e) {
    return _iobject(_defined(e));
  },
      ceil = Math.ceil,
      floor = Math.floor,
      _toInteger = function _toInteger(e) {
    return isNaN(e = +e) ? 0 : (e > 0 ? floor : ceil)(e);
  },
      min = Math.min,
      _toLength = function _toLength(e) {
    return e > 0 ? min(_toInteger(e), 9007199254740991) : 0;
  },
      max = Math.max,
      min$1 = Math.min,
      _toAbsoluteIndex = function _toAbsoluteIndex(e, t) {
    return (e = _toInteger(e)) < 0 ? max(e + t, 0) : min$1(e, t);
  },
      _arrayIncludes = function _arrayIncludes(e) {
    return function (t, r, n) {
      var o,
          i = _toIobject(t),
          s = _toLength(i.length),
          a = _toAbsoluteIndex(n, s);

      if (e && r != r) {
        for (; s > a;) {
          if ((o = i[a++]) != o) return !0;
        }
      } else for (; s > a; a++) {
        if ((e || a in i) && i[a] === r) return e || a || 0;
      }

      return !e && -1;
    };
  },
      shared = _shared("keys"),
      _sharedKey = function _sharedKey(e) {
    return shared[e] || (shared[e] = _uid(e));
  },
      arrayIndexOf = _arrayIncludes(!1),
      IE_PROTO = _sharedKey("IE_PROTO"),
      _objectKeysInternal = function _objectKeysInternal(e, t) {
    var r,
        n = _toIobject(e),
        o = 0,
        i = [];

    for (r in n) {
      r != IE_PROTO && _has(n, r) && i.push(r);
    }

    for (; t.length > o;) {
      _has(n, r = t[o++]) && (~arrayIndexOf(i, r) || i.push(r));
    }

    return i;
  },
      _enumBugKeys = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),
      _objectKeys = Object.keys || function (e) {
    return _objectKeysInternal(e, _enumBugKeys);
  },
      f$1 = {}.propertyIsEnumerable,
      _objectPie = {
    f: f$1
  },
      isEnum = _objectPie.f,
      _objectToArray = function _objectToArray(e) {
    return function (t) {
      for (var r, n = _toIobject(t), o = _objectKeys(n), i = o.length, s = 0, a = []; i > s;) {
        r = o[s++], _descriptors && !isEnum.call(n, r) || a.push(e ? [r, n[r]] : n[r]);
      }

      return a;
    };
  },
      $entries = _objectToArray(!0);

  _export(_export.S, "Object", {
    entries: function entries(e) {
      return $entries(e);
    }
  });

  var $values = _objectToArray(!1);

  _export(_export.S, "Object", {
    values: function values(e) {
      return $values(e);
    }
  });

  var _toObject = function _toObject(e) {
    return Object(_defined(e));
  },
      _arrayFill = function _arrayFill(e) {
    for (var t = _toObject(this), r = _toLength(t.length), n = arguments.length, o = _toAbsoluteIndex(n > 1 ? arguments[1] : void 0, r), i = n > 2 ? arguments[2] : void 0, s = void 0 === i ? r : _toAbsoluteIndex(i, r); s > o;) {
      t[o++] = e;
    }

    return t;
  },
      _wks = createCommonjsModule(function (e) {
    var t = _shared("wks"),
        r = _global.Symbol,
        n = "function" == typeof r;

    (e.exports = function (e) {
      return t[e] || (t[e] = n && r[e] || (n ? r : _uid)("Symbol." + e));
    }).store = t;
  }),
      UNSCOPABLES = _wks("unscopables"),
      ArrayProto = Array.prototype;

  null == ArrayProto[UNSCOPABLES] && _hide(ArrayProto, UNSCOPABLES, {});

  var _addToUnscopables = function _addToUnscopables(e) {
    ArrayProto[UNSCOPABLES][e] = !0;
  };

  _export(_export.P, "Array", {
    fill: _arrayFill
  }), _addToUnscopables("fill");

  var _stringRepeat = function _stringRepeat(e) {
    var t = String(_defined(this)),
        r = "",
        n = _toInteger(e);

    if (n < 0 || n == 1 / 0) throw RangeError("Count can't be negative");

    for (; n > 0; (n >>>= 1) && (t += t)) {
      1 & n && (r += t);
    }

    return r;
  },
      _stringPad = function _stringPad(e, t, r, n) {
    var o = String(_defined(e)),
        i = o.length,
        s = void 0 === r ? " " : String(r),
        a = _toLength(t);

    if (a <= i || "" == s) return o;

    var u = a - i,
        l = _stringRepeat.call(s, Math.ceil(u / s.length));

    return l.length > u && (l = l.slice(0, u)), n ? l + o : o + l;
  },
      navigator$1 = _global.navigator,
      _userAgent = navigator$1 && navigator$1.userAgent || "",
      WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(_userAgent);

  _export(_export.P + _export.F * WEBKIT_BUG, "String", {
    padEnd: function padEnd(e) {
      return _stringPad(this, e, arguments.length > 1 ? arguments[1] : void 0, !1);
    }
  });

  var WEBKIT_BUG$1 = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(_userAgent);

  _export(_export.P + _export.F * WEBKIT_BUG$1, "String", {
    padStart: function padStart(e) {
      return _stringPad(this, e, arguments.length > 1 ? arguments[1] : void 0, !0);
    }
  });

  var MATCH = _wks("match"),
      _isRegexp = function _isRegexp(e) {
    var t;
    return _isObject(e) && (void 0 !== (t = e[MATCH]) ? !!t : "RegExp" == _cof(e));
  },
      _stringContext = function _stringContext(e, t, r) {
    if (_isRegexp(t)) throw TypeError("String#" + r + " doesn't accept regex!");
    return String(_defined(e));
  },
      MATCH$1 = _wks("match"),
      _failsIsRegexp = function _failsIsRegexp(e) {
    var t = /./;

    try {
      "/./"[e](t);
    } catch (r) {
      try {
        return t[MATCH$1] = !1, !"/./"[e](t);
      } catch (e) {}
    }

    return !0;
  },
      STARTS_WITH = "startsWith",
      $startsWith = ""[STARTS_WITH];

  _export(_export.P + _export.F * _failsIsRegexp(STARTS_WITH), "String", {
    startsWith: function startsWith(e) {
      var t = _stringContext(this, e, STARTS_WITH),
          r = _toLength(Math.min(arguments.length > 1 ? arguments[1] : void 0, t.length)),
          n = String(e);

      return $startsWith ? $startsWith.call(t, n, r) : t.slice(r, r + n.length) === n;
    }
  });

  var ENDS_WITH = "endsWith",
      $endsWith = ""[ENDS_WITH];

  _export(_export.P + _export.F * _failsIsRegexp(ENDS_WITH), "String", {
    endsWith: function endsWith(e) {
      var t = _stringContext(this, e, ENDS_WITH),
          r = arguments.length > 1 ? arguments[1] : void 0,
          n = _toLength(t.length),
          o = void 0 === r ? n : Math.min(_toLength(r), n),
          i = String(e);

      return $endsWith ? $endsWith.call(t, i, o) : t.slice(o - i.length, o) === i;
    }
  });

  var $includes = _arrayIncludes(!0);

  _export(_export.P, "Array", {
    includes: function includes(e) {
      return $includes(this, e, arguments.length > 1 ? arguments[1] : void 0);
    }
  }), _addToUnscopables("includes");

  var _iterCall = function _iterCall(e, t, r, n) {
    try {
      return n ? t(_anObject(r)[0], r[1]) : t(r);
    } catch (t) {
      var o = e.return;
      throw void 0 !== o && _anObject(o.call(e)), t;
    }
  },
      _iterators = {},
      ITERATOR = _wks("iterator"),
      ArrayProto$1 = Array.prototype,
      _isArrayIter = function _isArrayIter(e) {
    return void 0 !== e && (_iterators.Array === e || ArrayProto$1[ITERATOR] === e);
  },
      _createProperty = function _createProperty(e, t, r) {
    t in e ? _objectDp.f(e, t, _propertyDesc(0, r)) : e[t] = r;
  },
      TAG = _wks("toStringTag"),
      ARG = "Arguments" == _cof(function () {
    return arguments;
  }()),
      tryGet = function tryGet(e, t) {
    try {
      return e[t];
    } catch (e) {}
  },
      _classof = function _classof(e) {
    var t, r, n;
    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = tryGet(t = Object(e), TAG)) ? r : ARG ? _cof(t) : "Object" == (n = _cof(t)) && "function" == typeof t.callee ? "Arguments" : n;
  },
      ITERATOR$1 = _wks("iterator"),
      core_getIteratorMethod = _core.getIteratorMethod = function (e) {
    if (null != e) return e[ITERATOR$1] || e["@@iterator"] || _iterators[_classof(e)];
  },
      ITERATOR$2 = _wks("iterator"),
      SAFE_CLOSING = !1;

  try {
    var riter = [7][ITERATOR$2]();
    riter.return = function () {
      SAFE_CLOSING = !0;
    }, Array.from(riter, function () {
      throw 2;
    });
  } catch (e) {}

  var _iterDetect = function _iterDetect(e, t) {
    if (!t && !SAFE_CLOSING) return !1;
    var r = !1;

    try {
      var n = [7],
          o = n[ITERATOR$2]();
      o.next = function () {
        return {
          done: r = !0
        };
      }, n[ITERATOR$2] = function () {
        return o;
      }, e(n);
    } catch (e) {}

    return r;
  };

  _export(_export.S + _export.F * !_iterDetect(function (e) {
    Array.from(e);
  }), "Array", {
    from: function from(e) {
      var t,
          r,
          n,
          o,
          i = _toObject(e),
          s = "function" == typeof this ? this : Array,
          a = arguments.length,
          u = a > 1 ? arguments[1] : void 0,
          l = void 0 !== u,
          c = 0,
          p = core_getIteratorMethod(i);

      if (l && (u = _ctx(u, a > 2 ? arguments[2] : void 0, 2)), null == p || s == Array && _isArrayIter(p)) for (r = new s(t = _toLength(i.length)); t > c; c++) {
        _createProperty(r, c, l ? u(i[c], c) : i[c]);
      } else for (o = p.call(i), r = new s(); !(n = o.next()).done; c++) {
        _createProperty(r, c, l ? _iterCall(o, u, [n.value, c], !0) : n.value);
      }
      return r.length = c, r;
    }
  });

  var INCLUDES = "includes";

  _export(_export.P + _export.F * _failsIsRegexp(INCLUDES), "String", {
    includes: function includes(e) {
      return !!~_stringContext(this, e, INCLUDES).indexOf(e, arguments.length > 1 ? arguments[1] : void 0);
    }
  });

  var _iterStep = function _iterStep(e, t) {
    return {
      value: t,
      done: !!e
    };
  },
      _objectDps = _descriptors ? Object.defineProperties : function (e, t) {
    _anObject(e);

    for (var r, n = _objectKeys(t), o = n.length, i = 0; o > i;) {
      _objectDp.f(e, r = n[i++], t[r]);
    }

    return e;
  },
      document$2 = _global.document,
      _html = document$2 && document$2.documentElement,
      IE_PROTO$1 = _sharedKey("IE_PROTO"),
      Empty = function Empty() {},
      PROTOTYPE$1 = "prototype",
      _createDict = function createDict() {
    var e,
        t = _domCreate("iframe"),
        r = _enumBugKeys.length;

    for (t.style.display = "none", _html.appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), _createDict = e.F; r--;) {
      delete _createDict[PROTOTYPE$1][_enumBugKeys[r]];
    }

    return _createDict();
  },
      _objectCreate = Object.create || function (e, t) {
    var r;
    return null !== e ? (Empty[PROTOTYPE$1] = _anObject(e), r = new Empty(), Empty[PROTOTYPE$1] = null, r[IE_PROTO$1] = e) : r = _createDict(), void 0 === t ? r : _objectDps(r, t);
  },
      def = _objectDp.f,
      TAG$1 = _wks("toStringTag"),
      _setToStringTag = function _setToStringTag(e, t, r) {
    e && !_has(e = r ? e : e.prototype, TAG$1) && def(e, TAG$1, {
      configurable: !0,
      value: t
    });
  },
      IteratorPrototype = {};

  _hide(IteratorPrototype, _wks("iterator"), function () {
    return this;
  });

  var _iterCreate = function _iterCreate(e, t, r) {
    e.prototype = _objectCreate(IteratorPrototype, {
      next: _propertyDesc(1, r)
    }), _setToStringTag(e, t + " Iterator");
  },
      IE_PROTO$2 = _sharedKey("IE_PROTO"),
      ObjectProto = Object.prototype,
      _objectGpo = Object.getPrototypeOf || function (e) {
    return e = _toObject(e), _has(e, IE_PROTO$2) ? e[IE_PROTO$2] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? ObjectProto : null;
  },
      ITERATOR$3 = _wks("iterator"),
      BUGGY = !([].keys && "next" in [].keys()),
      FF_ITERATOR = "@@iterator",
      KEYS = "keys",
      VALUES = "values",
      returnThis = function returnThis() {
    return this;
  },
      _iterDefine = function _iterDefine(e, t, r, n, o, i, s) {
    _iterCreate(r, t, n);

    var a,
        u,
        l,
        c = function c(e) {
      if (!BUGGY && e in g) return g[e];

      switch (e) {
        case KEYS:
        case VALUES:
          return function () {
            return new r(this, e);
          };
      }

      return function () {
        return new r(this, e);
      };
    },
        p = t + " Iterator",
        f = o == VALUES,
        d = !1,
        g = e.prototype,
        h = g[ITERATOR$3] || g[FF_ITERATOR] || o && g[o],
        b = h || c(o),
        y = o ? f ? c("entries") : b : void 0,
        _ = "Array" == t && g.entries || h;

    if (_ && (l = _objectGpo(_.call(new e()))) !== Object.prototype && l.next && (_setToStringTag(l, p, !0), "function" != typeof l[ITERATOR$3] && _hide(l, ITERATOR$3, returnThis)), f && h && h.name !== VALUES && (d = !0, b = function b() {
      return h.call(this);
    }), (BUGGY || d || !g[ITERATOR$3]) && _hide(g, ITERATOR$3, b), _iterators[t] = b, _iterators[p] = returnThis, o) if (a = {
      values: f ? b : c(VALUES),
      keys: i ? b : c(KEYS),
      entries: y
    }, s) for (u in a) {
      u in g || _redefine(g, u, a[u]);
    } else _export(_export.P + _export.F * (BUGGY || d), t, a);
    return a;
  },
      es6_array_iterator = _iterDefine(Array, "Array", function (e, t) {
    this._t = _toIobject(e), this._i = 0, this._k = t;
  }, function () {
    var e = this._t,
        t = this._k,
        r = this._i++;
    return !e || r >= e.length ? (this._t = void 0, _iterStep(1)) : _iterStep(0, "keys" == t ? r : "values" == t ? e[r] : [r, e[r]]);
  }, "values");

  _iterators.Arguments = _iterators.Array, _addToUnscopables("keys"), _addToUnscopables("values"), _addToUnscopables("entries");

  var _sameValue = Object.is || function (e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  },
      builtinExec = RegExp.prototype.exec,
      _regexpExecAbstract = function _regexpExecAbstract(e, t) {
    var r = e.exec;

    if ("function" == typeof r) {
      var n = r.call(e, t);
      if ("object" != typeof n) throw new TypeError("RegExp exec method returned something other than an Object or null");
      return n;
    }

    if ("RegExp" !== _classof(e)) throw new TypeError("RegExp#exec called on incompatible receiver");
    return builtinExec.call(e, t);
  },
      _flags = function _flags() {
    var e = _anObject(this),
        t = "";

    return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
  },
      nativeExec = RegExp.prototype.exec,
      nativeReplace = String.prototype.replace,
      patchedExec = nativeExec,
      LAST_INDEX = "lastIndex",
      UPDATES_LAST_INDEX_WRONG = function () {
    var e = /a/,
        t = /b*/g;
    return nativeExec.call(e, "a"), nativeExec.call(t, "a"), 0 !== e[LAST_INDEX] || 0 !== t[LAST_INDEX];
  }(),
      NPCG_INCLUDED = void 0 !== /()??/.exec("")[1],
      PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

  PATCH && (patchedExec = function patchedExec(e) {
    var t,
        r,
        n,
        o,
        i = this;
    return NPCG_INCLUDED && (r = new RegExp("^" + i.source + "$(?!\\s)", _flags.call(i))), UPDATES_LAST_INDEX_WRONG && (t = i[LAST_INDEX]), n = nativeExec.call(i, e), UPDATES_LAST_INDEX_WRONG && n && (i[LAST_INDEX] = i.global ? n.index + n[0].length : t), NPCG_INCLUDED && n && n.length > 1 && nativeReplace.call(n[0], r, function () {
      for (o = 1; o < arguments.length - 2; o++) {
        void 0 === arguments[o] && (n[o] = void 0);
      }
    }), n;
  });
  var _regexpExec = patchedExec;

  _export({
    target: "RegExp",
    proto: !0,
    forced: _regexpExec !== /./.exec
  }, {
    exec: _regexpExec
  });

  var SPECIES = _wks("species"),
      REPLACE_SUPPORTS_NAMED_GROUPS = !_fails(function () {
    var e = /./;
    return e.exec = function () {
      var e = [];
      return e.groups = {
        a: "7"
      }, e;
    }, "7" !== "".replace(e, "$<a>");
  }),
      SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function () {
    var e = /(?:)/,
        t = e.exec;

    e.exec = function () {
      return t.apply(this, arguments);
    };

    var r = "ab".split(e);
    return 2 === r.length && "a" === r[0] && "b" === r[1];
  }(),
      _fixReWks = function _fixReWks(e, t, r) {
    var n = _wks(e),
        o = !_fails(function () {
      var t = {};
      return t[n] = function () {
        return 7;
      }, 7 != ""[e](t);
    }),
        i = o ? !_fails(function () {
      var t = !1,
          r = /a/;
      return r.exec = function () {
        return t = !0, null;
      }, "split" === e && (r.constructor = {}, r.constructor[SPECIES] = function () {
        return r;
      }), r[n](""), !t;
    }) : void 0;

    if (!o || !i || "replace" === e && !REPLACE_SUPPORTS_NAMED_GROUPS || "split" === e && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
      var s = /./[n],
          a = r(_defined, n, ""[e], function (e, t, r, n, i) {
        return t.exec === _regexpExec ? o && !i ? {
          done: !0,
          value: s.call(t, r, n)
        } : {
          done: !0,
          value: e.call(r, t, n)
        } : {
          done: !1
        };
      }),
          u = a[0],
          l = a[1];
      _redefine(String.prototype, e, u), _hide(RegExp.prototype, n, 2 == t ? function (e, t) {
        return l.call(e, this, t);
      } : function (e) {
        return l.call(e, this);
      });
    }
  };

  _fixReWks("search", 1, function (e, t, r, n) {
    return [function (r) {
      var n = e(this),
          o = null == r ? void 0 : r[t];
      return void 0 !== o ? o.call(r, n) : new RegExp(r)[t](String(n));
    }, function (e) {
      var t = n(r, e, this);
      if (t.done) return t.value;

      var o = _anObject(e),
          i = String(this),
          s = o.lastIndex;

      _sameValue(s, 0) || (o.lastIndex = 0);

      var a = _regexpExecAbstract(o, i);

      return _sameValue(o.lastIndex, s) || (o.lastIndex = s), null === a ? -1 : a.index;
    }];
  });

  var SPECIES$1 = _wks("species"),
      _speciesConstructor = function _speciesConstructor(e, t) {
    var r,
        n = _anObject(e).constructor;

    return void 0 === n || null == (r = _anObject(n)[SPECIES$1]) ? t : _aFunction(r);
  },
      _stringAt = function _stringAt(e) {
    return function (t, r) {
      var n,
          o,
          i = String(_defined(t)),
          s = _toInteger(r),
          a = i.length;

      return s < 0 || s >= a ? e ? "" : void 0 : (n = i.charCodeAt(s)) < 55296 || n > 56319 || s + 1 === a || (o = i.charCodeAt(s + 1)) < 56320 || o > 57343 ? e ? i.charAt(s) : n : e ? i.slice(s, s + 2) : o - 56320 + (n - 55296 << 10) + 65536;
    };
  },
      at = _stringAt(!0),
      _advanceStringIndex = function _advanceStringIndex(e, t, r) {
    return t + (r ? at(e, t).length : 1);
  },
      $min = Math.min,
      $push = [].push,
      $SPLIT = "split",
      LENGTH = "length",
      LAST_INDEX$1 = "lastIndex",
      MAX_UINT32 = 4294967295,
      SUPPORTS_Y = !_fails(function () {
    RegExp(MAX_UINT32, "y");
  });

  _fixReWks("split", 2, function (e, t, r, n) {
    var o;
    return o = "c" == "abbc"[$SPLIT](/(b)*/)[1] || 4 != "test"[$SPLIT](/(?:)/, -1)[LENGTH] || 2 != "ab"[$SPLIT](/(?:ab)*/)[LENGTH] || 4 != "."[$SPLIT](/(.?)(.?)/)[LENGTH] || "."[$SPLIT](/()()/)[LENGTH] > 1 || ""[$SPLIT](/.?/)[LENGTH] ? function (e, t) {
      var n = String(this);
      if (void 0 === e && 0 === t) return [];
      if (!_isRegexp(e)) return r.call(n, e, t);

      for (var o, i, s, a = [], u = (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.unicode ? "u" : "") + (e.sticky ? "y" : ""), l = 0, c = void 0 === t ? MAX_UINT32 : t >>> 0, p = new RegExp(e.source, u + "g"); (o = _regexpExec.call(p, n)) && !((i = p[LAST_INDEX$1]) > l && (a.push(n.slice(l, o.index)), o[LENGTH] > 1 && o.index < n[LENGTH] && $push.apply(a, o.slice(1)), s = o[0][LENGTH], l = i, a[LENGTH] >= c));) {
        p[LAST_INDEX$1] === o.index && p[LAST_INDEX$1]++;
      }

      return l === n[LENGTH] ? !s && p.test("") || a.push("") : a.push(n.slice(l)), a[LENGTH] > c ? a.slice(0, c) : a;
    } : "0"[$SPLIT](void 0, 0)[LENGTH] ? function (e, t) {
      return void 0 === e && 0 === t ? [] : r.call(this, e, t);
    } : r, [function (r, n) {
      var i = e(this),
          s = null == r ? void 0 : r[t];
      return void 0 !== s ? s.call(r, i, n) : o.call(String(i), r, n);
    }, function (e, t) {
      var i = n(o, e, this, t, o !== r);
      if (i.done) return i.value;

      var s = _anObject(e),
          a = String(this),
          u = _speciesConstructor(s, RegExp),
          l = s.unicode,
          c = (s.ignoreCase ? "i" : "") + (s.multiline ? "m" : "") + (s.unicode ? "u" : "") + (SUPPORTS_Y ? "y" : "g"),
          p = new u(SUPPORTS_Y ? s : "^(?:" + s.source + ")", c),
          f = void 0 === t ? MAX_UINT32 : t >>> 0;

      if (0 === f) return [];
      if (0 === a.length) return null === _regexpExecAbstract(p, a) ? [a] : [];

      for (var d = 0, g = 0, h = []; g < a.length;) {
        p.lastIndex = SUPPORTS_Y ? g : 0;

        var b,
            y = _regexpExecAbstract(p, SUPPORTS_Y ? a : a.slice(g));

        if (null === y || (b = $min(_toLength(p.lastIndex + (SUPPORTS_Y ? 0 : g)), a.length)) === d) g = _advanceStringIndex(a, g, l);else {
          if (h.push(a.slice(d, g)), h.length === f) return h;

          for (var _ = 1; _ <= y.length - 1; _++) {
            if (h.push(y[_]), h.length === f) return h;
          }

          g = d = b;
        }
      }

      return h.push(a.slice(d)), h;
    }];
  });

  var _strictMethod = function _strictMethod(e, t) {
    return !!e && _fails(function () {
      t ? e.call(null, function () {}, 1) : e.call(null);
    });
  },
      $sort = [].sort,
      test = [1, 2, 3];

  _export(_export.P + _export.F * (_fails(function () {
    test.sort(void 0);
  }) || !_fails(function () {
    test.sort(null);
  }) || !_strictMethod($sort)), "Array", {
    sort: function sort(e) {
      return void 0 === e ? $sort.call(_toObject(this)) : $sort.call(_toObject(this), _aFunction(e));
    }
  });

  for (var ITERATOR$4 = _wks("iterator"), TO_STRING_TAG = _wks("toStringTag"), ArrayValues = _iterators.Array, DOMIterables = {
    CSSRuleList: !0,
    CSSStyleDeclaration: !1,
    CSSValueList: !1,
    ClientRectList: !1,
    DOMRectList: !1,
    DOMStringList: !1,
    DOMTokenList: !0,
    DataTransferItemList: !1,
    FileList: !1,
    HTMLAllCollection: !1,
    HTMLCollection: !1,
    HTMLFormElement: !1,
    HTMLSelectElement: !1,
    MediaList: !0,
    MimeTypeArray: !1,
    NamedNodeMap: !1,
    NodeList: !0,
    PaintRequestList: !1,
    Plugin: !1,
    PluginArray: !1,
    SVGLengthList: !1,
    SVGNumberList: !1,
    SVGPathSegList: !1,
    SVGPointList: !1,
    SVGStringList: !1,
    SVGTransformList: !1,
    SourceBufferList: !1,
    StyleSheetList: !0,
    TextTrackCueList: !1,
    TextTrackList: !1,
    TouchList: !1
  }, collections = _objectKeys(DOMIterables), i = 0; i < collections.length; i++) {
    var NAME = collections[i],
        explicit = DOMIterables[NAME],
        Collection = _global[NAME],
        proto = Collection && Collection.prototype,
        key;
    if (proto && (proto[ITERATOR$4] || _hide(proto, ITERATOR$4, ArrayValues), proto[TO_STRING_TAG] || _hide(proto, TO_STRING_TAG, NAME), _iterators[NAME] = ArrayValues, explicit)) for (key in es6_array_iterator) {
      proto[key] || _redefine(proto, key, es6_array_iterator[key], !0);
    }
  }

  var dP$1 = _objectDp.f,
      FProto = Function.prototype,
      nameRE = /^\s*function ([^ (]*)/,
      NAME$1 = "name";
  NAME$1 in FProto || _descriptors && dP$1(FProto, NAME$1, {
    configurable: !0,
    get: function get() {
      try {
        return ("" + this).match(nameRE)[1];
      } catch (e) {
        return "";
      }
    }
  }), _descriptors && "g" != /./g.flags && _objectDp.f(RegExp.prototype, "flags", {
    configurable: !0,
    get: _flags
  });

  var TO_STRING = "toString",
      $toString = /./[TO_STRING],
      define = function define(e) {
    _redefine(RegExp.prototype, TO_STRING, e, !0);
  };

  _fails(function () {
    return "/a/b" != $toString.call({
      source: "a",
      flags: "b"
    });
  }) ? define(function () {
    var e = _anObject(this);

    return "/".concat(e.source, "/", "flags" in e ? e.flags : !_descriptors && e instanceof RegExp ? _flags.call(e) : void 0);
  }) : $toString.name != TO_STRING && define(function () {
    return $toString.call(this);
  });
  var test$1 = {};

  function _typeof(e) {
    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function asyncGeneratorStep(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  function _classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass(e, t, r) {
    return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
  }

  function _defineProperty(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function ownKeys(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function _objectSpread2(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ownKeys(r, !0).forEach(function (t) {
        _defineProperty(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(r).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function _inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf(e, t);
  }

  function _getPrototypeOf(e) {
    return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _setPrototypeOf(e, t) {
    return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }

  function _construct(e, t, r) {
    return (_construct = isNativeReflectConstruct() ? Reflect.construct : function (e, t, r) {
      var n = [null];
      n.push.apply(n, t);
      var o = new (Function.bind.apply(e, n))();
      return r && _setPrototypeOf(o, r.prototype), o;
    }).apply(null, arguments);
  }

  function _isNativeFunction(e) {
    return -1 !== Function.toString.call(e).indexOf("[native code]");
  }

  function _wrapNativeSuper(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (_wrapNativeSuper = function _wrapNativeSuper(e) {
      if (null === e || !_isNativeFunction(e)) return e;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, r);
      }

      function r() {
        return _construct(e, arguments, _getPrototypeOf(this).constructor);
      }

      return r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), _setPrototypeOf(r, e);
    })(e);
  }

  function _objectWithoutPropertiesLoose(e, t) {
    if (null == e) return {};
    var r,
        n,
        o = {},
        i = Object.keys(e);

    for (n = 0; n < i.length; n++) {
      r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
    }

    return o;
  }

  function _objectWithoutProperties(e, t) {
    if (null == e) return {};

    var r,
        n,
        o = _objectWithoutPropertiesLoose(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (n = 0; n < i.length; n++) {
        r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }
    }

    return o;
  }

  function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _possibleConstructorReturn(e, t) {
    return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
  }

  function _superPropBase(e, t) {
    for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = _getPrototypeOf(e));) {
      ;
    }

    return e;
  }

  function _get(e, t, r) {
    return (_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, r) {
      var n = _superPropBase(e, t);

      if (n) {
        var o = Object.getOwnPropertyDescriptor(n, t);
        return o.get ? o.get.call(r) : o.value;
      }
    })(e, t, r || e);
  }

  function _slicedToArray(e, t) {
    return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _nonIterableRest();
  }

  function _toConsumableArray(e) {
    return _arrayWithoutHoles(e) || _iterableToArray(e) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  function _arrayWithHoles(e) {
    if (Array.isArray(e)) return e;
  }

  function _iterableToArray(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _iterableToArrayLimit(e, t) {
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  test$1[_wks("toStringTag")] = "z", test$1 + "" != "[object z]" && _redefine(Object.prototype, "toString", function () {
    return "[object " + _classof(this) + "]";
  }, !0);

  var max$1 = Math.max,
      min$2 = Math.min,
      floor$1 = Math.floor,
      SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g,
      SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g,
      maybeToString = function maybeToString(e) {
    return void 0 === e ? e : String(e);
  };

  _fixReWks("replace", 2, function (e, t, r, n) {
    return [function (n, o) {
      var i = e(this),
          s = null == n ? void 0 : n[t];
      return void 0 !== s ? s.call(n, i, o) : r.call(String(i), n, o);
    }, function (e, t) {
      var i = n(r, e, this, t);
      if (i.done) return i.value;

      var s = _anObject(e),
          a = String(this),
          u = "function" == typeof t;

      u || (t = String(t));
      var l = s.global;

      if (l) {
        var c = s.unicode;
        s.lastIndex = 0;
      }

      for (var p = [];;) {
        var f = _regexpExecAbstract(s, a);

        if (null === f) break;
        if (p.push(f), !l) break;
        "" === String(f[0]) && (s.lastIndex = _advanceStringIndex(a, _toLength(s.lastIndex), c));
      }

      for (var d = "", g = 0, h = 0; h < p.length; h++) {
        f = p[h];

        for (var b = String(f[0]), y = max$1(min$2(_toInteger(f.index), a.length), 0), _ = [], m = 1; m < f.length; m++) {
          _.push(maybeToString(f[m]));
        }

        var v = f.groups;

        if (u) {
          var E = [b].concat(_, y, a);
          void 0 !== v && E.push(v);
          var O = String(t.apply(void 0, E));
        } else O = o(b, a, y, _, v, t);

        y >= g && (d += a.slice(g, y) + O, g = y + b.length);
      }

      return d + a.slice(g);
    }];

    function o(e, t, n, o, i, s) {
      var a = n + e.length,
          u = o.length,
          l = SUBSTITUTION_SYMBOLS_NO_NAMED;
      return void 0 !== i && (i = _toObject(i), l = SUBSTITUTION_SYMBOLS), r.call(s, l, function (r, s) {
        var l;

        switch (s.charAt(0)) {
          case "$":
            return "$";

          case "&":
            return e;

          case "`":
            return t.slice(0, n);

          case "'":
            return t.slice(a);

          case "<":
            l = i[s.slice(1, -1)];
            break;

          default:
            var c = +s;
            if (0 === c) return r;

            if (c > u) {
              var p = floor$1(c / 10);
              return 0 === p ? r : p <= u ? void 0 === o[p - 1] ? s.charAt(1) : o[p - 1] + s.charAt(1) : r;
            }

            l = o[c - 1];
        }

        return void 0 === l ? "" : l;
      });
    }
  });

  var f$2 = _wks,
      _wksExt = {
    f: f$2
  },
      defineProperty = _objectDp.f,
      _wksDefine = function _wksDefine(e) {
    var t = _core.Symbol || (_core.Symbol = _global.Symbol || {});
    "_" == e.charAt(0) || e in t || defineProperty(t, e, {
      value: _wksExt.f(e)
    });
  };

  _wksDefine("asyncIterator");

  var _meta = createCommonjsModule(function (e) {
    var t = _uid("meta"),
        r = _objectDp.f,
        n = 0,
        o = Object.isExtensible || function () {
      return !0;
    },
        i = !_fails(function () {
      return o(Object.preventExtensions({}));
    }),
        s = function s(e) {
      r(e, t, {
        value: {
          i: "O" + ++n,
          w: {}
        }
      });
    },
        a = e.exports = {
      KEY: t,
      NEED: !1,
      fastKey: function fastKey(e, r) {
        if (!_isObject(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;

        if (!_has(e, t)) {
          if (!o(e)) return "F";
          if (!r) return "E";
          s(e);
        }

        return e[t].i;
      },
      getWeak: function getWeak(e, r) {
        if (!_has(e, t)) {
          if (!o(e)) return !0;
          if (!r) return !1;
          s(e);
        }

        return e[t].w;
      },
      onFreeze: function onFreeze(e) {
        return i && a.NEED && o(e) && !_has(e, t) && s(e), e;
      }
    };
  }),
      _meta_1 = _meta.KEY,
      _meta_2 = _meta.NEED,
      _meta_3 = _meta.fastKey,
      _meta_4 = _meta.getWeak,
      _meta_5 = _meta.onFreeze,
      f$3 = Object.getOwnPropertySymbols,
      _objectGops = {
    f: f$3
  },
      _enumKeys = function _enumKeys(e) {
    var t = _objectKeys(e),
        r = _objectGops.f;

    if (r) for (var n, o = r(e), i = _objectPie.f, s = 0; o.length > s;) {
      i.call(e, n = o[s++]) && t.push(n);
    }
    return t;
  },
      _isArray = Array.isArray || function (e) {
    return "Array" == _cof(e);
  },
      hiddenKeys = _enumBugKeys.concat("length", "prototype"),
      f$4 = Object.getOwnPropertyNames || function (e) {
    return _objectKeysInternal(e, hiddenKeys);
  },
      _objectGopn = {
    f: f$4
  },
      gOPN = _objectGopn.f,
      toString$1 = {}.toString,
      windowNames = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
      getWindowNames = function getWindowNames(e) {
    try {
      return gOPN(e);
    } catch (e) {
      return windowNames.slice();
    }
  },
      f$5 = function f$5(e) {
    return windowNames && "[object Window]" == toString$1.call(e) ? getWindowNames(e) : gOPN(_toIobject(e));
  },
      _objectGopnExt = {
    f: f$5
  },
      gOPD = Object.getOwnPropertyDescriptor,
      f$6 = _descriptors ? gOPD : function (e, t) {
    if (e = _toIobject(e), t = _toPrimitive(t, !0), _ie8DomDefine) try {
      return gOPD(e, t);
    } catch (e) {}
    if (_has(e, t)) return _propertyDesc(!_objectPie.f.call(e, t), e[t]);
  },
      _objectGopd = {
    f: f$6
  },
      META = _meta.KEY,
      gOPD$1 = _objectGopd.f,
      dP$2 = _objectDp.f,
      gOPN$1 = _objectGopnExt.f,
      _$Symbol = _global.Symbol,
      $JSON = _global.JSON,
      _stringify = $JSON && $JSON.stringify,
      PROTOTYPE$2 = "prototype",
      HIDDEN = _wks("_hidden"),
      TO_PRIMITIVE = _wks("toPrimitive"),
      isEnum$1 = {}.propertyIsEnumerable,
      SymbolRegistry = _shared("symbol-registry"),
      AllSymbols = _shared("symbols"),
      OPSymbols = _shared("op-symbols"),
      ObjectProto$1 = Object[PROTOTYPE$2],
      USE_NATIVE = "function" == typeof _$Symbol && !!_objectGops.f,
      QObject = _global.QObject,
      setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild,
      setSymbolDesc = _descriptors && _fails(function () {
    return 7 != _objectCreate(dP$2({}, "a", {
      get: function get() {
        return dP$2(this, "a", {
          value: 7
        }).a;
      }
    })).a;
  }) ? function (e, t, r) {
    var n = gOPD$1(ObjectProto$1, t);
    n && delete ObjectProto$1[t], dP$2(e, t, r), n && e !== ObjectProto$1 && dP$2(ObjectProto$1, t, n);
  } : dP$2,
      wrap = function wrap(e) {
    var t = AllSymbols[e] = _objectCreate(_$Symbol[PROTOTYPE$2]);

    return t._k = e, t;
  },
      isSymbol = USE_NATIVE && "symbol" == typeof _$Symbol.iterator ? function (e) {
    return "symbol" == typeof e;
  } : function (e) {
    return e instanceof _$Symbol;
  },
      $defineProperty = function $defineProperty(e, t, r) {
    return e === ObjectProto$1 && $defineProperty(OPSymbols, t, r), _anObject(e), t = _toPrimitive(t, !0), _anObject(r), _has(AllSymbols, t) ? (r.enumerable ? (_has(e, HIDDEN) && e[HIDDEN][t] && (e[HIDDEN][t] = !1), r = _objectCreate(r, {
      enumerable: _propertyDesc(0, !1)
    })) : (_has(e, HIDDEN) || dP$2(e, HIDDEN, _propertyDesc(1, {})), e[HIDDEN][t] = !0), setSymbolDesc(e, t, r)) : dP$2(e, t, r);
  },
      $defineProperties = function $defineProperties(e, t) {
    _anObject(e);

    for (var r, n = _enumKeys(t = _toIobject(t)), o = 0, i = n.length; i > o;) {
      $defineProperty(e, r = n[o++], t[r]);
    }

    return e;
  },
      $create = function $create(e, t) {
    return void 0 === t ? _objectCreate(e) : $defineProperties(_objectCreate(e), t);
  },
      $propertyIsEnumerable = function $propertyIsEnumerable(e) {
    var t = isEnum$1.call(this, e = _toPrimitive(e, !0));
    return !(this === ObjectProto$1 && _has(AllSymbols, e) && !_has(OPSymbols, e)) && (!(t || !_has(this, e) || !_has(AllSymbols, e) || _has(this, HIDDEN) && this[HIDDEN][e]) || t);
  },
      $getOwnPropertyDescriptor = function $getOwnPropertyDescriptor(e, t) {
    if (e = _toIobject(e), t = _toPrimitive(t, !0), e !== ObjectProto$1 || !_has(AllSymbols, t) || _has(OPSymbols, t)) {
      var r = gOPD$1(e, t);
      return !r || !_has(AllSymbols, t) || _has(e, HIDDEN) && e[HIDDEN][t] || (r.enumerable = !0), r;
    }
  },
      $getOwnPropertyNames = function $getOwnPropertyNames(e) {
    for (var t, r = gOPN$1(_toIobject(e)), n = [], o = 0; r.length > o;) {
      _has(AllSymbols, t = r[o++]) || t == HIDDEN || t == META || n.push(t);
    }

    return n;
  },
      $getOwnPropertySymbols = function $getOwnPropertySymbols(e) {
    for (var t, r = e === ObjectProto$1, n = gOPN$1(r ? OPSymbols : _toIobject(e)), o = [], i = 0; n.length > i;) {
      !_has(AllSymbols, t = n[i++]) || r && !_has(ObjectProto$1, t) || o.push(AllSymbols[t]);
    }

    return o;
  };

  USE_NATIVE || (_$Symbol = function $Symbol() {
    if (this instanceof _$Symbol) throw TypeError("Symbol is not a constructor!");

    var e = _uid(arguments.length > 0 ? arguments[0] : void 0),
        t = function t(r) {
      this === ObjectProto$1 && t.call(OPSymbols, r), _has(this, HIDDEN) && _has(this[HIDDEN], e) && (this[HIDDEN][e] = !1), setSymbolDesc(this, e, _propertyDesc(1, r));
    };

    return _descriptors && setter && setSymbolDesc(ObjectProto$1, e, {
      configurable: !0,
      set: t
    }), wrap(e);
  }, _redefine(_$Symbol[PROTOTYPE$2], "toString", function () {
    return this._k;
  }), _objectGopd.f = $getOwnPropertyDescriptor, _objectDp.f = $defineProperty, _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames, _objectPie.f = $propertyIsEnumerable, _objectGops.f = $getOwnPropertySymbols, _descriptors && !_library && _redefine(ObjectProto$1, "propertyIsEnumerable", $propertyIsEnumerable, !0), _wksExt.f = function (e) {
    return wrap(_wks(e));
  }), _export(_export.G + _export.W + _export.F * !USE_NATIVE, {
    Symbol: _$Symbol
  });

  for (var es6Symbols = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), j = 0; es6Symbols.length > j;) {
    _wks(es6Symbols[j++]);
  }

  for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) {
    _wksDefine(wellKnownSymbols[k++]);
  }

  _export(_export.S + _export.F * !USE_NATIVE, "Symbol", {
    for: function _for(e) {
      return _has(SymbolRegistry, e += "") ? SymbolRegistry[e] : SymbolRegistry[e] = _$Symbol(e);
    },
    keyFor: function keyFor(e) {
      if (!isSymbol(e)) throw TypeError(e + " is not a symbol!");

      for (var t in SymbolRegistry) {
        if (SymbolRegistry[t] === e) return t;
      }
    },
    useSetter: function useSetter() {
      setter = !0;
    },
    useSimple: function useSimple() {
      setter = !1;
    }
  }), _export(_export.S + _export.F * !USE_NATIVE, "Object", {
    create: $create,
    defineProperty: $defineProperty,
    defineProperties: $defineProperties,
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    getOwnPropertyNames: $getOwnPropertyNames,
    getOwnPropertySymbols: $getOwnPropertySymbols
  });

  var FAILS_ON_PRIMITIVES = _fails(function () {
    _objectGops.f(1);
  });

  _export(_export.S + _export.F * FAILS_ON_PRIMITIVES, "Object", {
    getOwnPropertySymbols: function getOwnPropertySymbols(e) {
      return _objectGops.f(_toObject(e));
    }
  }), $JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
    var e = _$Symbol();

    return "[null]" != _stringify([e]) || "{}" != _stringify({
      a: e
    }) || "{}" != _stringify(Object(e));
  })), "JSON", {
    stringify: function stringify(e) {
      for (var t, r, n = [e], o = 1; arguments.length > o;) {
        n.push(arguments[o++]);
      }

      if (r = t = n[1], (_isObject(t) || void 0 !== e) && !isSymbol(e)) return _isArray(t) || (t = function t(e, _t) {
        if ("function" == typeof r && (_t = r.call(this, e, _t)), !isSymbol(_t)) return _t;
      }), n[1] = t, _stringify.apply($JSON, n);
    }
  }), _$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide(_$Symbol[PROTOTYPE$2], TO_PRIMITIVE, _$Symbol[PROTOTYPE$2].valueOf), _setToStringTag(_$Symbol, "Symbol"), _setToStringTag(Math, "Math", !0), _setToStringTag(_global.JSON, "JSON", !0), function (e) {
    var t = function () {
      try {
        return !!Symbol.iterator;
      } catch (e) {
        return !1;
      }
    }(),
        r = function r(e) {
      var r = {
        next: function next() {
          var t = e.shift();
          return {
            done: void 0 === t,
            value: t
          };
        }
      };
      return t && (r[Symbol.iterator] = function () {
        return r;
      }), r;
    },
        n = function n(e) {
      return encodeURIComponent(e).replace(/%20/g, "+");
    },
        o = function o(e) {
      return decodeURIComponent(String(e).replace(/\+/g, " "));
    };

    (function () {
      try {
        var t = e.URLSearchParams;
        return "a=1" === new t("?a=1").toString() && "function" == typeof t.prototype.set;
      } catch (e) {
        return !1;
      }
    })() || function () {
      var o = function e(t) {
        Object.defineProperty(this, "_entries", {
          writable: !0,
          value: {}
        });

        var r = _typeof(t);

        if ("undefined" === r) ;else if ("string" === r) "" !== t && this._fromString(t);else if (t instanceof e) {
          var n = this;
          t.forEach(function (e, t) {
            n.append(t, e);
          });
        } else {
          if (null === t || "object" !== r) throw new TypeError("Unsupported input's type for URLSearchParams");
          if ("[object Array]" === Object.prototype.toString.call(t)) for (var o = 0; o < t.length; o++) {
            var i = t[o];
            if ("[object Array]" !== Object.prototype.toString.call(i) && 2 === i.length) throw new TypeError("Expected [string, any] as entry at index " + o + " of URLSearchParams's input");
            this.append(i[0], i[1]);
          } else for (var s in t) {
            t.hasOwnProperty(s) && this.append(s, t[s]);
          }
        }
      },
          i = o.prototype;

      i.append = function (e, t) {
        e in this._entries ? this._entries[e].push(String(t)) : this._entries[e] = [String(t)];
      }, i.delete = function (e) {
        delete this._entries[e];
      }, i.get = function (e) {
        return e in this._entries ? this._entries[e][0] : null;
      }, i.getAll = function (e) {
        return e in this._entries ? this._entries[e].slice(0) : [];
      }, i.has = function (e) {
        return e in this._entries;
      }, i.set = function (e, t) {
        this._entries[e] = [String(t)];
      }, i.forEach = function (e, t) {
        var r;

        for (var n in this._entries) {
          if (this._entries.hasOwnProperty(n)) {
            r = this._entries[n];

            for (var o = 0; o < r.length; o++) {
              e.call(t, r[o], n, this);
            }
          }
        }
      }, i.keys = function () {
        var e = [];
        return this.forEach(function (t, r) {
          e.push(r);
        }), r(e);
      }, i.values = function () {
        var e = [];
        return this.forEach(function (t) {
          e.push(t);
        }), r(e);
      }, i.entries = function () {
        var e = [];
        return this.forEach(function (t, r) {
          e.push([r, t]);
        }), r(e);
      }, t && (i[Symbol.iterator] = i.entries), i.toString = function () {
        var e = [];
        return this.forEach(function (t, r) {
          e.push(n(r) + "=" + n(t));
        }), e.join("&");
      }, e.URLSearchParams = o;
    }();
    var i = e.URLSearchParams.prototype;
    "function" != typeof i.sort && (i.sort = function () {
      var e = this,
          t = [];
      this.forEach(function (r, n) {
        t.push([n, r]), e._entries || e.delete(n);
      }), t.sort(function (e, t) {
        return e[0] < t[0] ? -1 : e[0] > t[0] ? 1 : 0;
      }), e._entries && (e._entries = {});

      for (var r = 0; r < t.length; r++) {
        this.append(t[r][0], t[r][1]);
      }
    }), "function" != typeof i._fromString && Object.defineProperty(i, "_fromString", {
      enumerable: !1,
      configurable: !1,
      writable: !1,
      value: function value(e) {
        if (this._entries) this._entries = {};else {
          var t = [];
          this.forEach(function (e, r) {
            t.push(r);
          });

          for (var r = 0; r < t.length; r++) {
            this.delete(t[r]);
          }
        }
        var n,
            i = (e = e.replace(/^\?/, "")).split("&");

        for (r = 0; r < i.length; r++) {
          n = i[r].split("="), this.append(o(n[0]), n.length > 1 ? o(n[1]) : "");
        }
      }
    });
  }(void 0 !== commonjsGlobal ? commonjsGlobal : "undefined" != typeof window ? window : "undefined" != typeof self ? self : commonjsGlobal), function (e) {
    var t, r, n;

    if (function () {
      try {
        var t = new e.URL("b", "http://a");
        return t.pathname = "c%20d", "http://a/c%20d" === t.href && t.searchParams;
      } catch (e) {
        return !1;
      }
    }() || (t = e.URL, n = (r = function r(t, _r) {
      "string" != typeof t && (t = String(t));
      var n,
          o = document;

      if (_r && (void 0 === e.location || _r !== e.location.href)) {
        (n = (o = document.implementation.createHTMLDocument("")).createElement("base")).href = _r, o.head.appendChild(n);

        try {
          if (0 !== n.href.indexOf(_r)) throw new Error(n.href);
        } catch (e) {
          throw new Error("URL unable to set base " + _r + " due to " + e);
        }
      }

      var i = o.createElement("a");
      if (i.href = t, n && (o.body.appendChild(i), i.href = i.href), ":" === i.protocol || !/:/.test(i.href)) throw new TypeError("Invalid URL");
      Object.defineProperty(this, "_anchorElement", {
        value: i
      });
      var s = new e.URLSearchParams(this.search),
          a = !0,
          u = !0,
          l = this;
      ["append", "delete", "set"].forEach(function (e) {
        var t = s[e];

        s[e] = function () {
          t.apply(s, arguments), a && (u = !1, l.search = s.toString(), u = !0);
        };
      }), Object.defineProperty(this, "searchParams", {
        value: s,
        enumerable: !0
      });
      var c = void 0;
      Object.defineProperty(this, "_updateSearchParams", {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: function value() {
          this.search !== c && (c = this.search, u && (a = !1, this.searchParams._fromString(this.search), a = !0));
        }
      });
    }).prototype, ["hash", "host", "hostname", "port", "protocol"].forEach(function (e) {
      !function (e) {
        Object.defineProperty(n, e, {
          get: function get() {
            return this._anchorElement[e];
          },
          set: function set(t) {
            this._anchorElement[e] = t;
          },
          enumerable: !0
        });
      }(e);
    }), Object.defineProperty(n, "search", {
      get: function get() {
        return this._anchorElement.search;
      },
      set: function set(e) {
        this._anchorElement.search = e, this._updateSearchParams();
      },
      enumerable: !0
    }), Object.defineProperties(n, {
      toString: {
        get: function get() {
          var e = this;
          return function () {
            return e.href;
          };
        }
      },
      href: {
        get: function get() {
          return this._anchorElement.href.replace(/\?$/, "");
        },
        set: function set(e) {
          this._anchorElement.href = e, this._updateSearchParams();
        },
        enumerable: !0
      },
      pathname: {
        get: function get() {
          return this._anchorElement.pathname.replace(/(^\/?)/, "/");
        },
        set: function set(e) {
          this._anchorElement.pathname = e;
        },
        enumerable: !0
      },
      origin: {
        get: function get() {
          var e = {
            "http:": 80,
            "https:": 443,
            "ftp:": 21
          }[this._anchorElement.protocol],
              t = this._anchorElement.port != e && "" !== this._anchorElement.port;
          return this._anchorElement.protocol + "//" + this._anchorElement.hostname + (t ? ":" + this._anchorElement.port : "");
        },
        enumerable: !0
      },
      password: {
        get: function get() {
          return "";
        },
        set: function set(e) {},
        enumerable: !0
      },
      username: {
        get: function get() {
          return "";
        },
        set: function set(e) {},
        enumerable: !0
      }
    }), r.createObjectURL = function (e) {
      return t.createObjectURL.apply(t, arguments);
    }, r.revokeObjectURL = function (e) {
      return t.revokeObjectURL.apply(t, arguments);
    }, e.URL = r), void 0 !== e.location && !("origin" in e.location)) {
      var o = function o() {
        return e.location.protocol + "//" + e.location.hostname + (e.location.port ? ":" + e.location.port : "");
      };

      try {
        Object.defineProperty(e.location, "origin", {
          get: o,
          enumerable: !0
        });
      } catch (t) {
        setInterval(function () {
          e.location.origin = o();
        }, 100);
      }
    }
  }(void 0 !== commonjsGlobal ? commonjsGlobal : "undefined" != typeof window ? window : "undefined" != typeof self ? self : commonjsGlobal);

  var $at = _stringAt(!0);

  _iterDefine(String, "String", function (e) {
    this._t = String(e), this._i = 0;
  }, function () {
    var e,
        t = this._t,
        r = this._i;
    return r >= t.length ? {
      value: void 0,
      done: !0
    } : (e = $at(t, r), this._i += e.length, {
      value: e,
      done: !1
    });
  });

  for (var TYPED = _uid("typed_array"), VIEW = _uid("view"), ABV = !(!_global.ArrayBuffer || !_global.DataView), CONSTR = ABV, i$1 = 0, l = 9, Typed, TypedArrayConstructors = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); i$1 < l;) {
    (Typed = _global[TypedArrayConstructors[i$1++]]) ? (_hide(Typed.prototype, TYPED, !0), _hide(Typed.prototype, VIEW, !0)) : CONSTR = !1;
  }

  var _typed = {
    ABV: ABV,
    CONSTR: CONSTR,
    TYPED: TYPED,
    VIEW: VIEW
  },
      _redefineAll = function _redefineAll(e, t, r) {
    for (var n in t) {
      _redefine(e, n, t[n], r);
    }

    return e;
  },
      _anInstance = function _anInstance(e, t, r, n) {
    if (!(e instanceof t) || void 0 !== n && n in e) throw TypeError(r + ": incorrect invocation!");
    return e;
  },
      _toIndex = function _toIndex(e) {
    if (void 0 === e) return 0;

    var t = _toInteger(e),
        r = _toLength(t);

    if (t !== r) throw RangeError("Wrong length!");
    return r;
  },
      _typedBuffer = createCommonjsModule(function (e, t) {
    var r = _objectGopn.f,
        n = _objectDp.f,
        o = "prototype",
        i = "Wrong index!",
        _s2 = _global.ArrayBuffer,
        _a = _global.DataView,
        u = _global.Math,
        l = _global.RangeError,
        c = _global.Infinity,
        p = _s2,
        f = u.abs,
        d = u.pow,
        g = u.floor,
        h = u.log,
        b = u.LN2,
        y = _descriptors ? "_b" : "buffer",
        _ = _descriptors ? "_l" : "byteLength",
        m = _descriptors ? "_o" : "byteOffset";

    function v(e, t, r) {
      var n,
          o,
          i,
          s = new Array(r),
          a = 8 * r - t - 1,
          u = (1 << a) - 1,
          l = u >> 1,
          p = 23 === t ? d(2, -24) - d(2, -77) : 0,
          y = 0,
          _ = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

      for ((e = f(e)) != e || e === c ? (o = e != e ? 1 : 0, n = u) : (n = g(h(e) / b), e * (i = d(2, -n)) < 1 && (n--, i *= 2), (e += n + l >= 1 ? p / i : p * d(2, 1 - l)) * i >= 2 && (n++, i /= 2), n + l >= u ? (o = 0, n = u) : n + l >= 1 ? (o = (e * i - 1) * d(2, t), n += l) : (o = e * d(2, l - 1) * d(2, t), n = 0)); t >= 8; s[y++] = 255 & o, o /= 256, t -= 8) {
        ;
      }

      for (n = n << t | o, a += t; a > 0; s[y++] = 255 & n, n /= 256, a -= 8) {
        ;
      }

      return s[--y] |= 128 * _, s;
    }

    function E(e, t, r) {
      var n,
          o = 8 * r - t - 1,
          i = (1 << o) - 1,
          s = i >> 1,
          a = o - 7,
          u = r - 1,
          l = e[u--],
          p = 127 & l;

      for (l >>= 7; a > 0; p = 256 * p + e[u], u--, a -= 8) {
        ;
      }

      for (n = p & (1 << -a) - 1, p >>= -a, a += t; a > 0; n = 256 * n + e[u], u--, a -= 8) {
        ;
      }

      if (0 === p) p = 1 - s;else {
        if (p === i) return n ? NaN : l ? -c : c;
        n += d(2, t), p -= s;
      }
      return (l ? -1 : 1) * n * d(2, p - t);
    }

    function O(e) {
      return e[3] << 24 | e[2] << 16 | e[1] << 8 | e[0];
    }

    function I(e) {
      return [255 & e];
    }

    function $(e) {
      return [255 & e, e >> 8 & 255];
    }

    function S(e) {
      return [255 & e, e >> 8 & 255, e >> 16 & 255, e >> 24 & 255];
    }

    function w(e) {
      return v(e, 52, 8);
    }

    function R(e) {
      return v(e, 23, 4);
    }

    function A(e, t, r) {
      n(e[o], t, {
        get: function get() {
          return this[r];
        }
      });
    }

    function T(e, t, r, n) {
      var o = _toIndex(+r);

      if (o + t > e[_]) throw l(i);
      var s = e[y]._b,
          a = o + e[m],
          u = s.slice(a, a + t);
      return n ? u : u.reverse();
    }

    function N(e, t, r, n, o, s) {
      var a = _toIndex(+r);

      if (a + t > e[_]) throw l(i);

      for (var u = e[y]._b, c = a + e[m], p = n(+o), f = 0; f < t; f++) {
        u[c + f] = p[s ? f : t - f - 1];
      }
    }

    if (_typed.ABV) {
      if (!_fails(function () {
        _s2(1);
      }) || !_fails(function () {
        new _s2(-1);
      }) || _fails(function () {
        return new _s2(), new _s2(1.5), new _s2(NaN), "ArrayBuffer" != _s2.name;
      })) {
        for (var L, P = (_s2 = function s(e) {
          return _anInstance(this, _s2), new p(_toIndex(e));
        })[o] = p[o], C = r(p), k = 0; C.length > k;) {
          (L = C[k++]) in _s2 || _hide(_s2, L, p[L]);
        }

        P.constructor = _s2;
      }

      var x = new _a(new _s2(2)),
          M = _a[o].setInt8;
      x.setInt8(0, 2147483648), x.setInt8(1, 2147483649), !x.getInt8(0) && x.getInt8(1) || _redefineAll(_a[o], {
        setInt8: function setInt8(e, t) {
          M.call(this, e, t << 24 >> 24);
        },
        setUint8: function setUint8(e, t) {
          M.call(this, e, t << 24 >> 24);
        }
      }, !0);
    } else _s2 = function _s(e) {
      _anInstance(this, _s2, "ArrayBuffer");

      var t = _toIndex(e);

      this._b = _arrayFill.call(new Array(t), 0), this[_] = t;
    }, _a = function a(e, t, r) {
      _anInstance(this, _a, "DataView"), _anInstance(e, _s2, "DataView");

      var n = e[_],
          o = _toInteger(t);

      if (o < 0 || o > n) throw l("Wrong offset!");
      if (o + (r = void 0 === r ? n - o : _toLength(r)) > n) throw l("Wrong length!");
      this[y] = e, this[m] = o, this[_] = r;
    }, _descriptors && (A(_s2, "byteLength", "_l"), A(_a, "buffer", "_b"), A(_a, "byteLength", "_l"), A(_a, "byteOffset", "_o")), _redefineAll(_a[o], {
      getInt8: function getInt8(e) {
        return T(this, 1, e)[0] << 24 >> 24;
      },
      getUint8: function getUint8(e) {
        return T(this, 1, e)[0];
      },
      getInt16: function getInt16(e) {
        var t = T(this, 2, e, arguments[1]);
        return (t[1] << 8 | t[0]) << 16 >> 16;
      },
      getUint16: function getUint16(e) {
        var t = T(this, 2, e, arguments[1]);
        return t[1] << 8 | t[0];
      },
      getInt32: function getInt32(e) {
        return O(T(this, 4, e, arguments[1]));
      },
      getUint32: function getUint32(e) {
        return O(T(this, 4, e, arguments[1])) >>> 0;
      },
      getFloat32: function getFloat32(e) {
        return E(T(this, 4, e, arguments[1]), 23, 4);
      },
      getFloat64: function getFloat64(e) {
        return E(T(this, 8, e, arguments[1]), 52, 8);
      },
      setInt8: function setInt8(e, t) {
        N(this, 1, e, I, t);
      },
      setUint8: function setUint8(e, t) {
        N(this, 1, e, I, t);
      },
      setInt16: function setInt16(e, t) {
        N(this, 2, e, $, t, arguments[2]);
      },
      setUint16: function setUint16(e, t) {
        N(this, 2, e, $, t, arguments[2]);
      },
      setInt32: function setInt32(e, t) {
        N(this, 4, e, S, t, arguments[2]);
      },
      setUint32: function setUint32(e, t) {
        N(this, 4, e, S, t, arguments[2]);
      },
      setFloat32: function setFloat32(e, t) {
        N(this, 4, e, R, t, arguments[2]);
      },
      setFloat64: function setFloat64(e, t) {
        N(this, 8, e, w, t, arguments[2]);
      }
    });

    _setToStringTag(_s2, "ArrayBuffer"), _setToStringTag(_a, "DataView"), _hide(_a[o], _typed.VIEW, !0), t.ArrayBuffer = _s2, t.DataView = _a;
  }),
      SPECIES$2 = _wks("species"),
      _arraySpeciesConstructor = function _arraySpeciesConstructor(e) {
    var t;
    return _isArray(e) && ("function" != typeof (t = e.constructor) || t !== Array && !_isArray(t.prototype) || (t = void 0), _isObject(t) && null === (t = t[SPECIES$2]) && (t = void 0)), void 0 === t ? Array : t;
  },
      _arraySpeciesCreate = function _arraySpeciesCreate(e, t) {
    return new (_arraySpeciesConstructor(e))(t);
  },
      _arrayMethods = function _arrayMethods(e, t) {
    var r = 1 == e,
        n = 2 == e,
        o = 3 == e,
        i = 4 == e,
        s = 6 == e,
        a = 5 == e || s,
        u = t || _arraySpeciesCreate;
    return function (t, l, c) {
      for (var p, f, d = _toObject(t), g = _iobject(d), h = _ctx(l, c, 3), b = _toLength(g.length), y = 0, _ = r ? u(t, b) : n ? u(t, 0) : void 0; b > y; y++) {
        if ((a || y in g) && (f = h(p = g[y], y, d), e)) if (r) _[y] = f;else if (f) switch (e) {
          case 3:
            return !0;

          case 5:
            return p;

          case 6:
            return y;

          case 2:
            _.push(p);

        } else if (i) return !1;
      }

      return s ? -1 : o || i ? i : _;
    };
  },
      SPECIES$3 = _wks("species"),
      _setSpecies = function _setSpecies(e) {
    var t = _global[e];
    _descriptors && t && !t[SPECIES$3] && _objectDp.f(t, SPECIES$3, {
      configurable: !0,
      get: function get() {
        return this;
      }
    });
  },
      _arrayCopyWithin = [].copyWithin || function (e, t) {
    var r = _toObject(this),
        n = _toLength(r.length),
        o = _toAbsoluteIndex(e, n),
        i = _toAbsoluteIndex(t, n),
        s = arguments.length > 2 ? arguments[2] : void 0,
        a = Math.min((void 0 === s ? n : _toAbsoluteIndex(s, n)) - i, n - o),
        u = 1;

    for (i < o && o < i + a && (u = -1, i += a - 1, o += a - 1); a-- > 0;) {
      i in r ? r[o] = r[i] : delete r[o], o += u, i += u;
    }

    return r;
  },
      _typedArray = createCommonjsModule(function (e) {
    if (_descriptors) {
      var t = _library,
          r = _global,
          n = _fails,
          o = _export,
          i = _typed,
          s = _typedBuffer,
          a = _ctx,
          u = _anInstance,
          l = _propertyDesc,
          c = _hide,
          p = _redefineAll,
          f = _toInteger,
          d = _toLength,
          g = _toIndex,
          h = _toAbsoluteIndex,
          b = _toPrimitive,
          y = _has,
          _ = _classof,
          m = _isObject,
          v = _toObject,
          E = _isArrayIter,
          O = _objectCreate,
          I = _objectGpo,
          $ = _objectGopn.f,
          S = core_getIteratorMethod,
          w = _uid,
          R = _wks,
          A = _arrayMethods,
          T = _arrayIncludes,
          N = _speciesConstructor,
          L = es6_array_iterator,
          P = _iterators,
          C = _iterDetect,
          k = _setSpecies,
          x = _arrayFill,
          M = _arrayCopyWithin,
          q = _objectDp,
          j = _objectGopd,
          U = q.f,
          D = j.f,
          G = r.RangeError,
          B = r.TypeError,
          F = r.Uint8Array,
          V = Array.prototype,
          H = s.ArrayBuffer,
          W = s.DataView,
          z = A(0),
          K = A(2),
          J = A(3),
          Y = A(4),
          X = A(5),
          Q = A(6),
          Z = T(!0),
          ee = T(!1),
          te = L.values,
          re = L.keys,
          ne = L.entries,
          oe = V.lastIndexOf,
          ie = V.reduce,
          se = V.reduceRight,
          ae = V.join,
          ue = V.sort,
          le = V.slice,
          ce = V.toString,
          pe = V.toLocaleString,
          fe = R("iterator"),
          de = R("toStringTag"),
          ge = w("typed_constructor"),
          he = w("def_constructor"),
          be = i.CONSTR,
          ye = i.TYPED,
          _e = i.VIEW,
          me = A(1, function (e, t) {
        return $e(N(e, e[he]), t);
      }),
          ve = n(function () {
        return 1 === new F(new Uint16Array([1]).buffer)[0];
      }),
          Ee = !!F && !!F.prototype.set && n(function () {
        new F(1).set({});
      }),
          Oe = function Oe(e, t) {
        var r = f(e);
        if (r < 0 || r % t) throw G("Wrong offset!");
        return r;
      },
          Ie = function Ie(e) {
        if (m(e) && ye in e) return e;
        throw B(e + " is not a typed array!");
      },
          $e = function $e(e, t) {
        if (!(m(e) && ge in e)) throw B("It is not a typed array constructor!");
        return new e(t);
      },
          Se = function Se(e, t) {
        return we(N(e, e[he]), t);
      },
          we = function we(e, t) {
        for (var r = 0, n = t.length, o = $e(e, n); n > r;) {
          o[r] = t[r++];
        }

        return o;
      },
          Re = function Re(e, t, r) {
        U(e, t, {
          get: function get() {
            return this._d[r];
          }
        });
      },
          Ae = function Ae(e) {
        var t,
            r,
            n,
            o,
            i,
            s,
            u = v(e),
            l = arguments.length,
            c = l > 1 ? arguments[1] : void 0,
            p = void 0 !== c,
            f = S(u);

        if (null != f && !E(f)) {
          for (s = f.call(u), n = [], t = 0; !(i = s.next()).done; t++) {
            n.push(i.value);
          }

          u = n;
        }

        for (p && l > 2 && (c = a(c, arguments[2], 2)), t = 0, r = d(u.length), o = $e(this, r); r > t; t++) {
          o[t] = p ? c(u[t], t) : u[t];
        }

        return o;
      },
          Te = function Te() {
        for (var e = 0, t = arguments.length, r = $e(this, t); t > e;) {
          r[e] = arguments[e++];
        }

        return r;
      },
          Ne = !!F && n(function () {
        pe.call(new F(1));
      }),
          Le = function Le() {
        return pe.apply(Ne ? le.call(Ie(this)) : Ie(this), arguments);
      },
          Pe = {
        copyWithin: function copyWithin(e, t) {
          return M.call(Ie(this), e, t, arguments.length > 2 ? arguments[2] : void 0);
        },
        every: function every(e) {
          return Y(Ie(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        fill: function fill(e) {
          return x.apply(Ie(this), arguments);
        },
        filter: function filter(e) {
          return Se(this, K(Ie(this), e, arguments.length > 1 ? arguments[1] : void 0));
        },
        find: function find(e) {
          return X(Ie(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        findIndex: function findIndex(e) {
          return Q(Ie(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        forEach: function forEach(e) {
          z(Ie(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        indexOf: function indexOf(e) {
          return ee(Ie(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        includes: function includes(e) {
          return Z(Ie(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        join: function join(e) {
          return ae.apply(Ie(this), arguments);
        },
        lastIndexOf: function lastIndexOf(e) {
          return oe.apply(Ie(this), arguments);
        },
        map: function map(e) {
          return me(Ie(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        reduce: function reduce(e) {
          return ie.apply(Ie(this), arguments);
        },
        reduceRight: function reduceRight(e) {
          return se.apply(Ie(this), arguments);
        },
        reverse: function reverse() {
          for (var e, t = Ie(this).length, r = Math.floor(t / 2), n = 0; n < r;) {
            e = this[n], this[n++] = this[--t], this[t] = e;
          }

          return this;
        },
        some: function some(e) {
          return J(Ie(this), e, arguments.length > 1 ? arguments[1] : void 0);
        },
        sort: function sort(e) {
          return ue.call(Ie(this), e);
        },
        subarray: function subarray(e, t) {
          var r = Ie(this),
              n = r.length,
              o = h(e, n);
          return new (N(r, r[he]))(r.buffer, r.byteOffset + o * r.BYTES_PER_ELEMENT, d((void 0 === t ? n : h(t, n)) - o));
        }
      },
          Ce = function Ce(e, t) {
        return Se(this, le.call(Ie(this), e, t));
      },
          ke = function ke(e) {
        Ie(this);
        var t = Oe(arguments[1], 1),
            r = this.length,
            n = v(e),
            o = d(n.length),
            i = 0;
        if (o + t > r) throw G("Wrong length!");

        for (; i < o;) {
          this[t + i] = n[i++];
        }
      },
          xe = {
        entries: function entries() {
          return ne.call(Ie(this));
        },
        keys: function keys() {
          return re.call(Ie(this));
        },
        values: function values() {
          return te.call(Ie(this));
        }
      },
          Me = function Me(e, t) {
        return m(e) && e[ye] && "symbol" != typeof t && t in e && String(+t) == String(t);
      },
          qe = function qe(e, t) {
        return Me(e, t = b(t, !0)) ? l(2, e[t]) : D(e, t);
      },
          je = function je(e, t, r) {
        return !(Me(e, t = b(t, !0)) && m(r) && y(r, "value")) || y(r, "get") || y(r, "set") || r.configurable || y(r, "writable") && !r.writable || y(r, "enumerable") && !r.enumerable ? U(e, t, r) : (e[t] = r.value, e);
      };

      be || (j.f = qe, q.f = je), o(o.S + o.F * !be, "Object", {
        getOwnPropertyDescriptor: qe,
        defineProperty: je
      }), n(function () {
        ce.call({});
      }) && (ce = pe = function pe() {
        return ae.call(this);
      });
      var Ue = p({}, Pe);
      p(Ue, xe), c(Ue, fe, xe.values), p(Ue, {
        slice: Ce,
        set: ke,
        constructor: function constructor() {},
        toString: ce,
        toLocaleString: Le
      }), Re(Ue, "buffer", "b"), Re(Ue, "byteOffset", "o"), Re(Ue, "byteLength", "l"), Re(Ue, "length", "e"), U(Ue, de, {
        get: function get() {
          return this[ye];
        }
      }), e.exports = function (e, s, a, l) {
        var p = e + ((l = !!l) ? "Clamped" : "") + "Array",
            f = "get" + e,
            h = "set" + e,
            b = r[p],
            y = b || {},
            v = b && I(b),
            E = !b || !i.ABV,
            S = {},
            w = b && b.prototype,
            R = function R(e, t) {
          U(e, t, {
            get: function get() {
              return function (e, t) {
                var r = e._d;
                return r.v[f](t * s + r.o, ve);
              }(this, t);
            },
            set: function set(e) {
              return function (e, t, r) {
                var n = e._d;
                l && (r = (r = Math.round(r)) < 0 ? 0 : r > 255 ? 255 : 255 & r), n.v[h](t * s + n.o, r, ve);
              }(this, t, e);
            },
            enumerable: !0
          });
        };

        E ? (b = a(function (e, t, r, n) {
          u(e, b, p, "_d");
          var o,
              i,
              a,
              l,
              f = 0,
              h = 0;

          if (m(t)) {
            if (!(t instanceof H || "ArrayBuffer" == (l = _(t)) || "SharedArrayBuffer" == l)) return ye in t ? we(b, t) : Ae.call(b, t);
            o = t, h = Oe(r, s);
            var y = t.byteLength;

            if (void 0 === n) {
              if (y % s) throw G("Wrong length!");
              if ((i = y - h) < 0) throw G("Wrong length!");
            } else if ((i = d(n) * s) + h > y) throw G("Wrong length!");

            a = i / s;
          } else a = g(t), o = new H(i = a * s);

          for (c(e, "_d", {
            b: o,
            o: h,
            l: i,
            e: a,
            v: new W(o)
          }); f < a;) {
            R(e, f++);
          }
        }), w = b.prototype = O(Ue), c(w, "constructor", b)) : n(function () {
          b(1);
        }) && n(function () {
          new b(-1);
        }) && C(function (e) {
          new b(), new b(null), new b(1.5), new b(e);
        }, !0) || (b = a(function (e, t, r, n) {
          var o;
          return u(e, b, p), m(t) ? t instanceof H || "ArrayBuffer" == (o = _(t)) || "SharedArrayBuffer" == o ? void 0 !== n ? new y(t, Oe(r, s), n) : void 0 !== r ? new y(t, Oe(r, s)) : new y(t) : ye in t ? we(b, t) : Ae.call(b, t) : new y(g(t));
        }), z(v !== Function.prototype ? $(y).concat($(v)) : $(y), function (e) {
          e in b || c(b, e, y[e]);
        }), b.prototype = w, t || (w.constructor = b));
        var A = w[fe],
            T = !!A && ("values" == A.name || null == A.name),
            N = xe.values;
        c(b, ge, !0), c(w, ye, p), c(w, _e, !0), c(w, he, b), (l ? new b(1)[de] == p : de in w) || U(w, de, {
          get: function get() {
            return p;
          }
        }), S[p] = b, o(o.G + o.W + o.F * (b != y), S), o(o.S, p, {
          BYTES_PER_ELEMENT: s
        }), o(o.S + o.F * n(function () {
          y.of.call(b, 1);
        }), p, {
          from: Ae,
          of: Te
        }), "BYTES_PER_ELEMENT" in w || c(w, "BYTES_PER_ELEMENT", s), o(o.P, p, Pe), k(p), o(o.P + o.F * Ee, p, {
          set: ke
        }), o(o.P + o.F * !T, p, xe), t || w.toString == ce || (w.toString = ce), o(o.P + o.F * n(function () {
          new b(1).slice();
        }), p, {
          slice: Ce
        }), o(o.P + o.F * (n(function () {
          return [1, 2].toLocaleString() != new b([1, 2]).toLocaleString();
        }) || !n(function () {
          w.toLocaleString.call([1, 2]);
        })), p, {
          toLocaleString: Le
        }), P[p] = T ? A : N, t || T || c(w, fe, N);
      };
    } else e.exports = function () {};
  });

  _typedArray("Uint8", 1, function (e) {
    return function (t, r, n) {
      return e(this, t, r, n);
    };
  });

  var _forOf = createCommonjsModule(function (e) {
    var t = {},
        r = {},
        n = e.exports = function (e, n, o, i, s) {
      var a,
          u,
          l,
          c,
          p = s ? function () {
        return e;
      } : core_getIteratorMethod(e),
          f = _ctx(o, i, n ? 2 : 1),
          d = 0;

      if ("function" != typeof p) throw TypeError(e + " is not iterable!");

      if (_isArrayIter(p)) {
        for (a = _toLength(e.length); a > d; d++) {
          if ((c = n ? f(_anObject(u = e[d])[0], u[1]) : f(e[d])) === t || c === r) return c;
        }
      } else for (l = p.call(e); !(u = l.next()).done;) {
        if ((c = _iterCall(l, f, u.value, n)) === t || c === r) return c;
      }
    };

    n.BREAK = t, n.RETURN = r;
  }),
      _invoke = function _invoke(e, t, r) {
    var n = void 0 === r;

    switch (t.length) {
      case 0:
        return n ? e() : e.call(r);

      case 1:
        return n ? e(t[0]) : e.call(r, t[0]);

      case 2:
        return n ? e(t[0], t[1]) : e.call(r, t[0], t[1]);

      case 3:
        return n ? e(t[0], t[1], t[2]) : e.call(r, t[0], t[1], t[2]);

      case 4:
        return n ? e(t[0], t[1], t[2], t[3]) : e.call(r, t[0], t[1], t[2], t[3]);
    }

    return e.apply(r, t);
  },
      process$1 = _global.process,
      setTask = _global.setImmediate,
      clearTask = _global.clearImmediate,
      MessageChannel = _global.MessageChannel,
      Dispatch = _global.Dispatch,
      counter = 0,
      queue = {},
      ONREADYSTATECHANGE = "onreadystatechange",
      defer,
      channel,
      port,
      run = function run() {
    var e = +this;

    if (queue.hasOwnProperty(e)) {
      var t = queue[e];
      delete queue[e], t();
    }
  },
      listener = function listener(e) {
    run.call(e.data);
  };

  setTask && clearTask || (setTask = function setTask(e) {
    for (var t = [], r = 1; arguments.length > r;) {
      t.push(arguments[r++]);
    }

    return queue[++counter] = function () {
      _invoke("function" == typeof e ? e : Function(e), t);
    }, defer(counter), counter;
  }, clearTask = function clearTask(e) {
    delete queue[e];
  }, "process" == _cof(process$1) ? defer = function defer(e) {
    process$1.nextTick(_ctx(run, e, 1));
  } : Dispatch && Dispatch.now ? defer = function defer(e) {
    Dispatch.now(_ctx(run, e, 1));
  } : MessageChannel ? (channel = new MessageChannel(), port = channel.port2, channel.port1.onmessage = listener, defer = _ctx(port.postMessage, port, 1)) : _global.addEventListener && "function" == typeof postMessage && !_global.importScripts ? (defer = function defer(e) {
    _global.postMessage(e + "", "*");
  }, _global.addEventListener("message", listener, !1)) : defer = ONREADYSTATECHANGE in _domCreate("script") ? function (e) {
    _html.appendChild(_domCreate("script"))[ONREADYSTATECHANGE] = function () {
      _html.removeChild(this), run.call(e);
    };
  } : function (e) {
    setTimeout(_ctx(run, e, 1), 0);
  });

  var _task = {
    set: setTask,
    clear: clearTask
  },
      macrotask = _task.set,
      Observer = _global.MutationObserver || _global.WebKitMutationObserver,
      process$2 = _global.process,
      Promise$1 = _global.Promise,
      isNode = "process" == _cof(process$2),
      _microtask = function _microtask() {
    var e,
        t,
        r,
        n = function n() {
      var n, o;

      for (isNode && (n = process$2.domain) && n.exit(); e;) {
        o = e.fn, e = e.next;

        try {
          o();
        } catch (n) {
          throw e ? r() : t = void 0, n;
        }
      }

      t = void 0, n && n.enter();
    };

    if (isNode) r = function r() {
      process$2.nextTick(n);
    };else if (!Observer || _global.navigator && _global.navigator.standalone) {
      if (Promise$1 && Promise$1.resolve) {
        var o = Promise$1.resolve(void 0);

        r = function r() {
          o.then(n);
        };
      } else r = function r() {
        macrotask.call(_global, n);
      };
    } else {
      var i = !0,
          s = document.createTextNode("");
      new Observer(n).observe(s, {
        characterData: !0
      }), r = function r() {
        s.data = i = !i;
      };
    }
    return function (n) {
      var o = {
        fn: n,
        next: void 0
      };
      t && (t.next = o), e || (e = o, r()), t = o;
    };
  };

  function PromiseCapability(e) {
    var t, r;
    this.promise = new e(function (e, n) {
      if (void 0 !== t || void 0 !== r) throw TypeError("Bad Promise constructor");
      t = e, r = n;
    }), this.resolve = _aFunction(t), this.reject = _aFunction(r);
  }

  var f$7 = function f$7(e) {
    return new PromiseCapability(e);
  },
      _newPromiseCapability = {
    f: f$7
  },
      _perform = function _perform(e) {
    try {
      return {
        e: !1,
        v: e()
      };
    } catch (e) {
      return {
        e: !0,
        v: e
      };
    }
  },
      _promiseResolve = function _promiseResolve(e, t) {
    if (_anObject(e), _isObject(t) && t.constructor === e) return t;

    var r = _newPromiseCapability.f(e);

    return (0, r.resolve)(t), r.promise;
  },
      task = _task.set,
      microtask = _microtask(),
      PROMISE = "Promise",
      TypeError$1 = _global.TypeError,
      process$3 = _global.process,
      versions = process$3 && process$3.versions,
      v8 = versions && versions.v8 || "",
      _$Promise = _global[PROMISE],
      isNode$1 = "process" == _classof(process$3),
      empty = function empty() {},
      Internal,
      newGenericPromiseCapability,
      OwnPromiseCapability,
      Wrapper,
      newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f,
      USE_NATIVE$1 = !!function () {
    try {
      var e = _$Promise.resolve(1),
          t = (e.constructor = {})[_wks("species")] = function (e) {
        e(empty, empty);
      };

      return (isNode$1 || "function" == typeof PromiseRejectionEvent) && e.then(empty) instanceof t && 0 !== v8.indexOf("6.6") && -1 === _userAgent.indexOf("Chrome/66");
    } catch (e) {}
  }(),
      isThenable = function isThenable(e) {
    var t;
    return !(!_isObject(e) || "function" != typeof (t = e.then)) && t;
  },
      notify = function notify(e, t) {
    if (!e._n) {
      e._n = !0;
      var r = e._c;
      microtask(function () {
        for (var n = e._v, o = 1 == e._s, i = 0, s = function s(t) {
          var r,
              i,
              s,
              a = o ? t.ok : t.fail,
              u = t.resolve,
              l = t.reject,
              c = t.domain;

          try {
            a ? (o || (2 == e._h && onHandleUnhandled(e), e._h = 1), !0 === a ? r = n : (c && c.enter(), r = a(n), c && (c.exit(), s = !0)), r === t.promise ? l(TypeError$1("Promise-chain cycle")) : (i = isThenable(r)) ? i.call(r, u, l) : u(r)) : l(n);
          } catch (e) {
            c && !s && c.exit(), l(e);
          }
        }; r.length > i;) {
          s(r[i++]);
        }

        e._c = [], e._n = !1, t && !e._h && onUnhandled(e);
      });
    }
  },
      onUnhandled = function onUnhandled(e) {
    task.call(_global, function () {
      var t,
          r,
          n,
          o = e._v,
          i = isUnhandled(e);
      if (i && (t = _perform(function () {
        isNode$1 ? process$3.emit("unhandledRejection", o, e) : (r = _global.onunhandledrejection) ? r({
          promise: e,
          reason: o
        }) : (n = _global.console) && n.error && n.error("Unhandled promise rejection", o);
      }), e._h = isNode$1 || isUnhandled(e) ? 2 : 1), e._a = void 0, i && t.e) throw t.v;
    });
  },
      isUnhandled = function isUnhandled(e) {
    return 1 !== e._h && 0 === (e._a || e._c).length;
  },
      onHandleUnhandled = function onHandleUnhandled(e) {
    task.call(_global, function () {
      var t;
      isNode$1 ? process$3.emit("rejectionHandled", e) : (t = _global.onrejectionhandled) && t({
        promise: e,
        reason: e._v
      });
    });
  },
      $reject = function $reject(e) {
    var t = this;
    t._d || (t._d = !0, (t = t._w || t)._v = e, t._s = 2, t._a || (t._a = t._c.slice()), notify(t, !0));
  },
      $resolve = function $resolve(e) {
    var t,
        r = this;

    if (!r._d) {
      r._d = !0, r = r._w || r;

      try {
        if (r === e) throw TypeError$1("Promise can't be resolved itself");
        (t = isThenable(e)) ? microtask(function () {
          var n = {
            _w: r,
            _d: !1
          };

          try {
            t.call(e, _ctx($resolve, n, 1), _ctx($reject, n, 1));
          } catch (e) {
            $reject.call(n, e);
          }
        }) : (r._v = e, r._s = 1, notify(r, !1));
      } catch (e) {
        $reject.call({
          _w: r,
          _d: !1
        }, e);
      }
    }
  };

  USE_NATIVE$1 || (_$Promise = function $Promise(e) {
    _anInstance(this, _$Promise, PROMISE, "_h"), _aFunction(e), Internal.call(this);

    try {
      e(_ctx($resolve, this, 1), _ctx($reject, this, 1));
    } catch (e) {
      $reject.call(this, e);
    }
  }, Internal = function Internal(e) {
    this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
  }, Internal.prototype = _redefineAll(_$Promise.prototype, {
    then: function then(e, t) {
      var r = newPromiseCapability(_speciesConstructor(this, _$Promise));
      return r.ok = "function" != typeof e || e, r.fail = "function" == typeof t && t, r.domain = isNode$1 ? process$3.domain : void 0, this._c.push(r), this._a && this._a.push(r), this._s && notify(this, !1), r.promise;
    },
    catch: function _catch(e) {
      return this.then(void 0, e);
    }
  }), OwnPromiseCapability = function OwnPromiseCapability() {
    var e = new Internal();
    this.promise = e, this.resolve = _ctx($resolve, e, 1), this.reject = _ctx($reject, e, 1);
  }, _newPromiseCapability.f = newPromiseCapability = function newPromiseCapability(e) {
    return e === _$Promise || e === Wrapper ? new OwnPromiseCapability(e) : newGenericPromiseCapability(e);
  }), _export(_export.G + _export.W + _export.F * !USE_NATIVE$1, {
    Promise: _$Promise
  }), _setToStringTag(_$Promise, PROMISE), _setSpecies(PROMISE), Wrapper = _core[PROMISE], _export(_export.S + _export.F * !USE_NATIVE$1, PROMISE, {
    reject: function reject(e) {
      var t = newPromiseCapability(this);
      return (0, t.reject)(e), t.promise;
    }
  }), _export(_export.S + _export.F * !USE_NATIVE$1, PROMISE, {
    resolve: function resolve(e) {
      return _promiseResolve(this, e);
    }
  }), _export(_export.S + _export.F * !(USE_NATIVE$1 && _iterDetect(function (e) {
    _$Promise.all(e).catch(empty);
  })), PROMISE, {
    all: function all(e) {
      var t = this,
          r = newPromiseCapability(t),
          n = r.resolve,
          o = r.reject,
          i = _perform(function () {
        var r = [],
            i = 0,
            s = 1;
        _forOf(e, !1, function (e) {
          var a = i++,
              u = !1;
          r.push(void 0), s++, t.resolve(e).then(function (e) {
            u || (u = !0, r[a] = e, --s || n(r));
          }, o);
        }), --s || n(r);
      });

      return i.e && o(i.v), r.promise;
    },
    race: function race(e) {
      var t = this,
          r = newPromiseCapability(t),
          n = r.reject,
          o = _perform(function () {
        _forOf(e, !1, function (e) {
          t.resolve(e).then(r.resolve, n);
        });
      });

      return o.e && n(o.v), r.promise;
    }
  });
  var webcryptoShim = createCommonjsModule(function (e) {
    /**
    	   * @file Web Cryptography API shim
    	   * @author Artem S Vybornov <vybornov@gmail.com>
    	   * @license MIT
    	   */
    var t, r;
    t = "undefined" != typeof self ? self : commonjsGlobal, r = function r(e) {
      if ("function" != typeof Promise) throw "Promise support required";
      var t = e.crypto || e.msCrypto;

      if (t) {
        var r = t.subtle || t.webkitSubtle;

        if (r) {
          var n = e.Crypto || t.constructor || Object,
              o = e.SubtleCrypto || r.constructor || Object,
              i = (e.CryptoKey || e.Key || Object, e.navigator.userAgent.indexOf("Edge/") > -1),
              s = !!e.msCrypto && !i,
              a = !t.subtle && !!t.webkitSubtle;

          if (s || a) {
            var u = {
              KoZIhvcNAQEB: "1.2.840.113549.1.1.1"
            },
                l = {
              "1.2.840.113549.1.1.1": "KoZIhvcNAQEB"
            };

            if (["generateKey", "importKey", "unwrapKey"].forEach(function (e) {
              var n = r[e];

              r[e] = function (o, i, u) {
                var l,
                    c,
                    m,
                    I,
                    $,
                    S = [].slice.call(arguments);

                switch (e) {
                  case "generateKey":
                    l = h(o), c = i, m = u;
                    break;

                  case "importKey":
                    l = h(u), c = S[3], m = S[4], "jwk" === o && ((i = y(i)).alg || (i.alg = b(l)), i.key_ops || (i.key_ops = "oct" !== i.kty ? "d" in i ? m.filter(O) : m.filter(E) : m.slice()), S[1] = (I = y(i), s && (I.extractable = I.ext, delete I.ext), d(unescape(encodeURIComponent(JSON.stringify(I)))).buffer));
                    break;

                  case "unwrapKey":
                    l = S[4], c = S[5], m = S[6], S[2] = u._key;
                }

                if ("generateKey" === e && "HMAC" === l.name && l.hash) return l.length = l.length || {
                  "SHA-1": 512,
                  "SHA-256": 512,
                  "SHA-384": 1024,
                  "SHA-512": 1024
                }[l.hash.name], r.importKey("raw", t.getRandomValues(new Uint8Array(l.length + 7 >> 3)), l, c, m);
                if (a && "generateKey" === e && "RSASSA-PKCS1-v1_5" === l.name && (!l.modulusLength || l.modulusLength >= 2048)) return (o = h(o)).name = "RSAES-PKCS1-v1_5", delete o.hash, r.generateKey(o, !0, ["encrypt", "decrypt"]).then(function (e) {
                  return Promise.all([r.exportKey("jwk", e.publicKey), r.exportKey("jwk", e.privateKey)]);
                }).then(function (e) {
                  return e[0].alg = e[1].alg = b(l), e[0].key_ops = m.filter(E), e[1].key_ops = m.filter(O), Promise.all([r.importKey("jwk", e[0], l, !0, e[0].key_ops), r.importKey("jwk", e[1], l, c, e[1].key_ops)]);
                }).then(function (e) {
                  return {
                    publicKey: e[0],
                    privateKey: e[1]
                  };
                });
                if ((a || s && "SHA-1" === (l.hash || {}).name) && "importKey" === e && "jwk" === o && "HMAC" === l.name && "oct" === i.kty) return r.importKey("raw", d(f(i.k)), u, S[3], S[4]);
                if (a && "importKey" === e && ("spki" === o || "pkcs8" === o)) return r.importKey("jwk", function (e) {
                  var t = _(e),
                      r = !1;

                  t.length > 2 && (r = !0, t.shift());
                  var n = {
                    ext: !0
                  };

                  switch (t[0][0]) {
                    case "1.2.840.113549.1.1.1":
                      var o = ["n", "e", "d", "p", "q", "dp", "dq", "qi"],
                          i = _(t[1]);

                      r && i.shift();

                      for (var s = 0; s < i.length; s++) {
                        i[s][0] || (i[s] = i[s].subarray(1)), n[o[s]] = p(g(i[s]));
                      }

                      n.kty = "RSA";
                      break;

                    default:
                      throw new TypeError("Unsupported key type");
                  }

                  return n;
                }(i), u, S[3], S[4]);
                if (s && "unwrapKey" === e) return r.decrypt(S[3], u, i).then(function (e) {
                  return r.importKey(o, e, S[4], S[5], S[6]);
                });

                try {
                  $ = n.apply(r, S);
                } catch (e) {
                  return Promise.reject(e);
                }

                return s && ($ = new Promise(function (e, t) {
                  $.onabort = $.onerror = function (e) {
                    t(e);
                  }, $.oncomplete = function (t) {
                    e(t.target.result);
                  };
                })), $ = $.then(function (e) {
                  return "HMAC" === l.name && (l.length || (l.length = 8 * e.algorithm.length)), 0 == l.name.search("RSA") && (l.modulusLength || (l.modulusLength = (e.publicKey || e).algorithm.modulusLength), l.publicExponent || (l.publicExponent = (e.publicKey || e).algorithm.publicExponent)), e = e.publicKey && e.privateKey ? {
                    publicKey: new v(e.publicKey, l, c, m.filter(E)),
                    privateKey: new v(e.privateKey, l, c, m.filter(O))
                  } : new v(e, l, c, m);
                });
              };
            }), ["exportKey", "wrapKey"].forEach(function (e) {
              var t = r[e];

              r[e] = function (n, o, i) {
                var u,
                    l = [].slice.call(arguments);

                switch (e) {
                  case "exportKey":
                    l[1] = o._key;
                    break;

                  case "wrapKey":
                    l[1] = o._key, l[2] = i._key;
                }

                if ((a || s && "SHA-1" === (o.algorithm.hash || {}).name) && "exportKey" === e && "jwk" === n && "HMAC" === o.algorithm.name && (l[0] = "raw"), !a || "exportKey" !== e || "spki" !== n && "pkcs8" !== n || (l[0] = "jwk"), s && "wrapKey" === e) return r.exportKey(n, o).then(function (e) {
                  return "jwk" === n && (e = d(unescape(encodeURIComponent(JSON.stringify(y(e)))))), r.encrypt(l[3], i, e);
                });

                try {
                  u = t.apply(r, l);
                } catch (e) {
                  return Promise.reject(e);
                }

                return s && (u = new Promise(function (e, t) {
                  u.onabort = u.onerror = function (e) {
                    t(e);
                  }, u.oncomplete = function (t) {
                    e(t.target.result);
                  };
                })), "exportKey" === e && "jwk" === n && (u = u.then(function (e) {
                  return (a || s && "SHA-1" === (o.algorithm.hash || {}).name) && "HMAC" === o.algorithm.name ? {
                    kty: "oct",
                    alg: b(o.algorithm),
                    key_ops: o.usages.slice(),
                    ext: !0,
                    k: p(g(e))
                  } : ((e = y(e)).alg || (e.alg = b(o.algorithm)), e.key_ops || (e.key_ops = "public" === o.type ? o.usages.filter(E) : "private" === o.type ? o.usages.filter(O) : o.usages.slice()), e);
                })), !a || "exportKey" !== e || "spki" !== n && "pkcs8" !== n || (u = u.then(function (e) {
                  return e = function (e) {
                    var t,
                        r = [["", null]],
                        n = !1;

                    switch (e.kty) {
                      case "RSA":
                        for (var o = ["n", "e", "d", "p", "q", "dp", "dq", "qi"], i = [], s = 0; s < o.length && o[s] in e; s++) {
                          var a = i[s] = d(f(e[o[s]]));
                          128 & a[0] && (i[s] = new Uint8Array(a.length + 1), i[s].set(a, 1));
                        }

                        i.length > 2 && (n = !0, i.unshift(new Uint8Array([0]))), r[0][0] = "1.2.840.113549.1.1.1", t = i;
                        break;

                      default:
                        throw new TypeError("Unsupported key type");
                    }

                    return r.push(new Uint8Array(m(t)).buffer), n ? r.unshift(new Uint8Array([0])) : r[1] = {
                      tag: 3,
                      value: r[1]
                    }, new Uint8Array(m(r)).buffer;
                  }(y(e));
                })), u;
              };
            }), ["encrypt", "decrypt", "sign", "verify"].forEach(function (e) {
              var t = r[e];

              r[e] = function (n, o, i, a) {
                if (s && (!i.byteLength || a && !a.byteLength)) throw new Error("Empy input is not allowed");
                var u,
                    l = [].slice.call(arguments),
                    c = h(n);

                if (s && ("encrypt" === e || "decrypt" === e) && o.algorithm.hash && (l[0].hash = l[0].hash || o.algorithm.hash), s && "decrypt" === e && "AES-GCM" === c.name) {
                  var p = n.tagLength >> 3;
                  l[2] = (i.buffer || i).slice(0, i.byteLength - p), n.tag = (i.buffer || i).slice(i.byteLength - p);
                }

                l[1] = o._key;

                try {
                  u = t.apply(r, l);
                } catch (e) {
                  return Promise.reject(e);
                }

                return s && (u = new Promise(function (t, r) {
                  u.onabort = u.onerror = function (e) {
                    r(e);
                  }, u.oncomplete = function (r) {
                    r = r.target.result;

                    if ("encrypt" === e && r instanceof AesGcmEncryptResult) {
                      var n = r.ciphertext,
                          o = r.tag;
                      (r = new Uint8Array(n.byteLength + o.byteLength)).set(new Uint8Array(n), 0), r.set(new Uint8Array(o), n.byteLength), r = r.buffer;
                    }

                    t(r);
                  };
                })), u;
              };
            }), s) {
              var c = r.digest;
              r.digest = function (e, t) {
                if (!t.byteLength) throw new Error("Empy input is not allowed");
                var n;

                try {
                  n = c.call(r, e, t);
                } catch (e) {
                  return Promise.reject(e);
                }

                return n = new Promise(function (e, t) {
                  n.onabort = n.onerror = function (e) {
                    t(e);
                  }, n.oncomplete = function (t) {
                    e(t.target.result);
                  };
                });
              }, e.crypto = Object.create(t, {
                getRandomValues: {
                  value: function value(e) {
                    return t.getRandomValues(e);
                  }
                },
                subtle: {
                  value: r
                }
              }), e.CryptoKey = v;
            }

            a && (t.subtle = r, e.Crypto = n, e.SubtleCrypto = o, e.CryptoKey = v);
          }
        }
      }

      function p(e) {
        return btoa(e).replace(/\=+$/, "").replace(/\+/g, "-").replace(/\//g, "_");
      }

      function f(e) {
        return e = (e += "===").slice(0, -e.length % 4), atob(e.replace(/-/g, "+").replace(/_/g, "/"));
      }

      function d(e) {
        for (var t = new Uint8Array(e.length), r = 0; r < e.length; r++) {
          t[r] = e.charCodeAt(r);
        }

        return t;
      }

      function g(e) {
        return e instanceof ArrayBuffer && (e = new Uint8Array(e)), String.fromCharCode.apply(String, e);
      }

      function h(e) {
        var t = {
          name: (e.name || e || "").toUpperCase().replace("V", "v")
        };

        switch (t.name) {
          case "SHA-1":
          case "SHA-256":
          case "SHA-384":
          case "SHA-512":
            break;

          case "AES-CBC":
          case "AES-GCM":
          case "AES-KW":
            e.length && (t.length = e.length);
            break;

          case "HMAC":
            e.hash && (t.hash = h(e.hash)), e.length && (t.length = e.length);
            break;

          case "RSAES-PKCS1-v1_5":
            e.publicExponent && (t.publicExponent = new Uint8Array(e.publicExponent)), e.modulusLength && (t.modulusLength = e.modulusLength);
            break;

          case "RSASSA-PKCS1-v1_5":
          case "RSA-OAEP":
            e.hash && (t.hash = h(e.hash)), e.publicExponent && (t.publicExponent = new Uint8Array(e.publicExponent)), e.modulusLength && (t.modulusLength = e.modulusLength);
            break;

          default:
            throw new SyntaxError("Bad algorithm name");
        }

        return t;
      }

      function b(e) {
        return {
          HMAC: {
            "SHA-1": "HS1",
            "SHA-256": "HS256",
            "SHA-384": "HS384",
            "SHA-512": "HS512"
          },
          "RSASSA-PKCS1-v1_5": {
            "SHA-1": "RS1",
            "SHA-256": "RS256",
            "SHA-384": "RS384",
            "SHA-512": "RS512"
          },
          "RSAES-PKCS1-v1_5": {
            "": "RSA1_5"
          },
          "RSA-OAEP": {
            "SHA-1": "RSA-OAEP",
            "SHA-256": "RSA-OAEP-256"
          },
          "AES-KW": {
            128: "A128KW",
            192: "A192KW",
            256: "A256KW"
          },
          "AES-GCM": {
            128: "A128GCM",
            192: "A192GCM",
            256: "A256GCM"
          },
          "AES-CBC": {
            128: "A128CBC",
            192: "A192CBC",
            256: "A256CBC"
          }
        }[e.name][(e.hash || {}).name || e.length || ""];
      }

      function y(e) {
        (e instanceof ArrayBuffer || e instanceof Uint8Array) && (e = JSON.parse(decodeURIComponent(escape(g(e)))));
        var t = {
          kty: e.kty,
          alg: e.alg,
          ext: e.ext || e.extractable
        };

        switch (t.kty) {
          case "oct":
            t.k = e.k;

          case "RSA":
            ["n", "e", "d", "p", "q", "dp", "dq", "qi", "oth"].forEach(function (r) {
              r in e && (t[r] = e[r]);
            });
            break;

          default:
            throw new TypeError("Unsupported key type");
        }

        return t;
      }

      function _(e, t) {
        if (e instanceof ArrayBuffer && (e = new Uint8Array(e)), t || (t = {
          pos: 0,
          end: e.length
        }), t.end - t.pos < 2 || t.end > e.length) throw new RangeError("Malformed DER");
        var r,
            n = e[t.pos++],
            o = e[t.pos++];

        if (o >= 128) {
          if (o &= 127, t.end - t.pos < o) throw new RangeError("Malformed DER");

          for (var i = 0; o--;) {
            i <<= 8, i |= e[t.pos++];
          }

          o = i;
        }

        if (t.end - t.pos < o) throw new RangeError("Malformed DER");

        switch (n) {
          case 2:
            r = e.subarray(t.pos, t.pos += o);
            break;

          case 3:
            if (e[t.pos++]) throw new Error("Unsupported bit string");
            o--;

          case 4:
            r = new Uint8Array(e.subarray(t.pos, t.pos += o)).buffer;
            break;

          case 5:
            r = null;
            break;

          case 6:
            var s = btoa(g(e.subarray(t.pos, t.pos += o)));
            if (!(s in u)) throw new Error("Unsupported OBJECT ID " + s);
            r = u[s];
            break;

          case 48:
            r = [];

            for (var a = t.pos + o; t.pos < a;) {
              r.push(_(e, t));
            }

            break;

          default:
            throw new Error("Unsupported DER tag 0x" + n.toString(16));
        }

        return r;
      }

      function m(e, t) {
        t || (t = []);
        var r = 0,
            n = 0,
            o = t.length + 2;

        if (t.push(0, 0), e instanceof Uint8Array) {
          r = 2, n = e.length;

          for (var i = 0; i < n; i++) {
            t.push(e[i]);
          }
        } else if (e instanceof ArrayBuffer) {
          r = 4, n = e.byteLength, e = new Uint8Array(e);

          for (i = 0; i < n; i++) {
            t.push(e[i]);
          }
        } else if (null === e) r = 5, n = 0;else if ("string" == typeof e && e in l) {
          var s = d(atob(l[e]));
          r = 6, n = s.length;

          for (i = 0; i < n; i++) {
            t.push(s[i]);
          }
        } else if (e instanceof Array) {
          for (i = 0; i < e.length; i++) {
            m(e[i], t);
          }

          r = 48, n = t.length - o;
        } else {
          if (!("object" === _typeof(e) && 3 === e.tag && e.value instanceof ArrayBuffer)) throw new Error("Unsupported DER value " + e);
          r = 3, n = (e = new Uint8Array(e.value)).byteLength, t.push(0);

          for (i = 0; i < n; i++) {
            t.push(e[i]);
          }

          n++;
        }

        if (n >= 128) {
          var a = n;
          n = 4;

          for (t.splice(o, 0, a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, 255 & a); n > 1 && !(a >> 24);) {
            a <<= 8, n--;
          }

          n < 4 && t.splice(o, 4 - n), n |= 128;
        }

        return t.splice(o - 2, 2, r, n), t;
      }

      function v(e, t, r, n) {
        Object.defineProperties(this, {
          _key: {
            value: e
          },
          type: {
            value: e.type,
            enumerable: !0
          },
          extractable: {
            value: void 0 === r ? e.extractable : r,
            enumerable: !0
          },
          algorithm: {
            value: void 0 === t ? e.algorithm : t,
            enumerable: !0
          },
          usages: {
            value: void 0 === n ? e.usages : n,
            enumerable: !0
          }
        });
      }

      function E(e) {
        return "verify" === e || "encrypt" === e || "wrapKey" === e;
      }

      function O(e) {
        return "sign" === e || "decrypt" === e || "unwrapKey" === e;
      }
    }, e.exports ? e.exports = r(t) : r(t);
  }),
      support = {
    searchParams: "URLSearchParams" in self,
    iterable: "Symbol" in self && "iterator" in Symbol,
    blob: "FileReader" in self && "Blob" in self && function () {
      try {
        return new Blob(), !0;
      } catch (e) {
        return !1;
      }
    }(),
    formData: "FormData" in self,
    arrayBuffer: "ArrayBuffer" in self
  };

  function isDataView(e) {
    return e && DataView.prototype.isPrototypeOf(e);
  }

  if (support.arrayBuffer) var viewClasses = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
      isArrayBufferView = ArrayBuffer.isView || function (e) {
    return e && viewClasses.indexOf(Object.prototype.toString.call(e)) > -1;
  };

  function normalizeName(e) {
    if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
    return e.toLowerCase();
  }

  function normalizeValue(e) {
    return "string" != typeof e && (e = String(e)), e;
  }

  function iteratorFor(e) {
    var t = {
      next: function next() {
        var t = e.shift();
        return {
          done: void 0 === t,
          value: t
        };
      }
    };
    return support.iterable && (t[Symbol.iterator] = function () {
      return t;
    }), t;
  }

  function Headers(e) {
    this.map = {}, e instanceof Headers ? e.forEach(function (e, t) {
      this.append(t, e);
    }, this) : Array.isArray(e) ? e.forEach(function (e) {
      this.append(e[0], e[1]);
    }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
      this.append(t, e[t]);
    }, this);
  }

  function consumed(e) {
    if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
    e.bodyUsed = !0;
  }

  function fileReaderReady(e) {
    return new Promise(function (t, r) {
      e.onload = function () {
        t(e.result);
      }, e.onerror = function () {
        r(e.error);
      };
    });
  }

  function readBlobAsArrayBuffer(e) {
    var t = new FileReader(),
        r = fileReaderReady(t);
    return t.readAsArrayBuffer(e), r;
  }

  function readBlobAsText(e) {
    var t = new FileReader(),
        r = fileReaderReady(t);
    return t.readAsText(e), r;
  }

  function readArrayBufferAsText(e) {
    for (var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++) {
      r[n] = String.fromCharCode(t[n]);
    }

    return r.join("");
  }

  function bufferClone(e) {
    if (e.slice) return e.slice(0);
    var t = new Uint8Array(e.byteLength);
    return t.set(new Uint8Array(e)), t.buffer;
  }

  function Body() {
    return this.bodyUsed = !1, this._initBody = function (e) {
      this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : support.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : support.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : support.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : support.arrayBuffer && support.blob && isDataView(e) ? (this._bodyArrayBuffer = bufferClone(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || isArrayBufferView(e)) ? this._bodyArrayBuffer = bufferClone(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : support.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
    }, support.blob && (this.blob = function () {
      var e = consumed(this);
      if (e) return e;
      if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
      if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
      if (this._bodyFormData) throw new Error("could not read FormData body as blob");
      return Promise.resolve(new Blob([this._bodyText]));
    }, this.arrayBuffer = function () {
      return this._bodyArrayBuffer ? consumed(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(readBlobAsArrayBuffer);
    }), this.text = function () {
      var e = consumed(this);
      if (e) return e;
      if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
      if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      if (this._bodyFormData) throw new Error("could not read FormData body as text");
      return Promise.resolve(this._bodyText);
    }, support.formData && (this.formData = function () {
      return this.text().then(decode);
    }), this.json = function () {
      return this.text().then(JSON.parse);
    }, this;
  }

  Headers.prototype.append = function (e, t) {
    e = normalizeName(e), t = normalizeValue(t);
    var r = this.map[e];
    this.map[e] = r ? r + ", " + t : t;
  }, Headers.prototype.delete = function (e) {
    delete this.map[normalizeName(e)];
  }, Headers.prototype.get = function (e) {
    return e = normalizeName(e), this.has(e) ? this.map[e] : null;
  }, Headers.prototype.has = function (e) {
    return this.map.hasOwnProperty(normalizeName(e));
  }, Headers.prototype.set = function (e, t) {
    this.map[normalizeName(e)] = normalizeValue(t);
  }, Headers.prototype.forEach = function (e, t) {
    for (var r in this.map) {
      this.map.hasOwnProperty(r) && e.call(t, this.map[r], r, this);
    }
  }, Headers.prototype.keys = function () {
    var e = [];
    return this.forEach(function (t, r) {
      e.push(r);
    }), iteratorFor(e);
  }, Headers.prototype.values = function () {
    var e = [];
    return this.forEach(function (t) {
      e.push(t);
    }), iteratorFor(e);
  }, Headers.prototype.entries = function () {
    var e = [];
    return this.forEach(function (t, r) {
      e.push([r, t]);
    }), iteratorFor(e);
  }, support.iterable && (Headers.prototype[Symbol.iterator] = Headers.prototype.entries);
  var methods = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];

  function normalizeMethod(e) {
    var t = e.toUpperCase();
    return methods.indexOf(t) > -1 ? t : e;
  }

  function Request(e, t) {
    var r = (t = t || {}).body;

    if (e instanceof Request) {
      if (e.bodyUsed) throw new TypeError("Already read");
      this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new Headers(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, r || null == e._bodyInit || (r = e._bodyInit, e.bodyUsed = !0);
    } else this.url = String(e);

    if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new Headers(t.headers)), this.method = normalizeMethod(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && r) throw new TypeError("Body not allowed for GET or HEAD requests");

    this._initBody(r);
  }

  function decode(e) {
    var t = new FormData();
    return e.trim().split("&").forEach(function (e) {
      if (e) {
        var r = e.split("="),
            n = r.shift().replace(/\+/g, " "),
            o = r.join("=").replace(/\+/g, " ");
        t.append(decodeURIComponent(n), decodeURIComponent(o));
      }
    }), t;
  }

  function parseHeaders(e) {
    var t = new Headers();
    return e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
      var r = e.split(":"),
          n = r.shift().trim();

      if (n) {
        var o = r.join(":").trim();
        t.append(n, o);
      }
    }), t;
  }

  function Response(e, t) {
    t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new Headers(t.headers), this.url = t.url || "", this._initBody(e);
  }

  Request.prototype.clone = function () {
    return new Request(this, {
      body: this._bodyInit
    });
  }, Body.call(Request.prototype), Body.call(Response.prototype), Response.prototype.clone = function () {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    });
  }, Response.error = function () {
    var e = new Response(null, {
      status: 0,
      statusText: ""
    });
    return e.type = "error", e;
  };
  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (e, t) {
    if (-1 === redirectStatuses.indexOf(t)) throw new RangeError("Invalid status code");
    return new Response(null, {
      status: t,
      headers: {
        location: e
      }
    });
  };

  var DOMException$1 = self.DOMException;

  try {
    new DOMException$1();
  } catch (e) {
    DOMException$1 = function DOMException$1(e, t) {
      this.message = e, this.name = t;
      var r = Error(e);
      this.stack = r.stack;
    }, DOMException$1.prototype = Object.create(Error.prototype), DOMException$1.prototype.constructor = DOMException$1;
  }

  function fetch(e, t) {
    return new Promise(function (r, n) {
      var o = new Request(e, t);
      if (o.signal && o.signal.aborted) return n(new DOMException$1("Aborted", "AbortError"));
      var i = new XMLHttpRequest();

      function s() {
        i.abort();
      }

      i.onload = function () {
        var e = {
          status: i.status,
          statusText: i.statusText,
          headers: parseHeaders(i.getAllResponseHeaders() || "")
        };
        e.url = "responseURL" in i ? i.responseURL : e.headers.get("X-Request-URL");
        var t = "response" in i ? i.response : i.responseText;
        r(new Response(t, e));
      }, i.onerror = function () {
        n(new TypeError("Network request failed"));
      }, i.ontimeout = function () {
        n(new TypeError("Network request failed"));
      }, i.onabort = function () {
        n(new DOMException$1("Aborted", "AbortError"));
      }, i.open(o.method, o.url, !0), "include" === o.credentials ? i.withCredentials = !0 : "omit" === o.credentials && (i.withCredentials = !1), "responseType" in i && support.blob && (i.responseType = "blob"), o.headers.forEach(function (e, t) {
        i.setRequestHeader(t, e);
      }), o.signal && (o.signal.addEventListener("abort", s), i.onreadystatechange = function () {
        4 === i.readyState && o.signal.removeEventListener("abort", s);
      }), i.send(void 0 === o._bodyInit ? null : o._bodyInit);
    });
  }

  function get(e, t) {
    var r,
        n,
        o = arguments.length < 3 ? e : arguments[2];
    return _anObject(e) === o ? e[t] : (r = _objectGopd.f(e, t)) ? _has(r, "value") ? r.value : void 0 !== r.get ? r.get.call(o) : void 0 : _isObject(n = _objectGpo(e)) ? get(n, t, o) : void 0;
  }

  fetch.polyfill = !0, self.fetch || (self.fetch = fetch, self.Headers = Headers, self.Request = Request, self.Response = Response), _export(_export.S, "Reflect", {
    get: get
  });

  var check = function check(e, t) {
    if (_anObject(e), !_isObject(t) && null !== t) throw TypeError(t + ": can't set as prototype!");
  },
      _setProto = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? function (e, t, r) {
      try {
        (r = _ctx(Function.call, _objectGopd.f(Object.prototype, "__proto__").set, 2))(e, []), t = !(e instanceof Array);
      } catch (e) {
        t = !0;
      }

      return function (e, n) {
        return check(e, n), t ? e.__proto__ = n : r(e, n), e;
      };
    }({}, !1) : void 0),
    check: check
  };

  _export(_export.S, "Object", {
    setPrototypeOf: _setProto.set
  }), function () {
    function e(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function t(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function r(e, r, n) {
      return r && t(e.prototype, r), n && t(e, n), e;
    }

    function n(e) {
      return (n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function o(e, t) {
      return (o = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function i(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function s(e, t, r) {
      return (s = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, r) {
        var o = function (e, t) {
          for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = n(e));) {
            ;
          }

          return e;
        }(e, t);

        if (o) {
          var i = Object.getOwnPropertyDescriptor(o, t);
          return i.get ? i.get.call(r) : i.value;
        }
      })(e, t, r || e);
    }

    var a = function () {
      function t() {
        e(this, t), Object.defineProperty(this, "listeners", {
          value: {},
          writable: !0,
          configurable: !0
        });
      }

      return r(t, [{
        key: "addEventListener",
        value: function value(e, t) {
          e in this.listeners || (this.listeners[e] = []), this.listeners[e].push(t);
        }
      }, {
        key: "removeEventListener",
        value: function value(e, t) {
          if (e in this.listeners) for (var r = this.listeners[e], n = 0, o = r.length; n < o; n++) {
            if (r[n] === t) return void r.splice(n, 1);
          }
        }
      }, {
        key: "dispatchEvent",
        value: function value(e) {
          var t = this;

          if (e.type in this.listeners) {
            for (var r = function r(_r2) {
              setTimeout(function () {
                return _r2.call(t, e);
              });
            }, n = this.listeners[e.type], o = 0, i = n.length; o < i; o++) {
              r(n[o]);
            }

            return !e.defaultPrevented;
          }
        }
      }]), t;
    }(),
        u = function (t) {
      function u() {
        var t, r, o;
        return e(this, u), (r = this, o = n(u).call(this), t = !o || "object" !== _typeof(o) && "function" != typeof o ? i(r) : o).listeners || a.call(i(t)), Object.defineProperty(i(t), "aborted", {
          value: !1,
          writable: !0,
          configurable: !0
        }), Object.defineProperty(i(t), "onabort", {
          value: null,
          writable: !0,
          configurable: !0
        }), t;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && o(e, t);
      }(u, t), r(u, [{
        key: "toString",
        value: function value() {
          return "[object AbortSignal]";
        }
      }, {
        key: "dispatchEvent",
        value: function value(e) {
          "abort" === e.type && (this.aborted = !0, "function" == typeof this.onabort && this.onabort.call(this, e)), s(n(u.prototype), "dispatchEvent", this).call(this, e);
        }
      }]), u;
    }(a),
        l = function () {
      function t() {
        e(this, t), Object.defineProperty(this, "signal", {
          value: new u(),
          writable: !0,
          configurable: !0
        });
      }

      return r(t, [{
        key: "abort",
        value: function value() {
          var e;

          try {
            e = new Event("abort");
          } catch (t) {
            "undefined" != typeof document ? document.createEvent ? (e = document.createEvent("Event")).initEvent("abort", !1, !1) : (e = document.createEventObject()).type = "abort" : e = {
              type: "abort",
              bubbles: !1,
              cancelable: !1
            };
          }

          this.signal.dispatchEvent(e);
        }
      }, {
        key: "toString",
        value: function value() {
          return "[object AbortController]";
        }
      }]), t;
    }();

    "undefined" != typeof Symbol && Symbol.toStringTag && (l.prototype[Symbol.toStringTag] = "AbortController", u.prototype[Symbol.toStringTag] = "AbortSignal"), function (e) {
      (function (e) {
        return e.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL ? (console.log("__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill"), !0) : "function" == typeof e.Request && !e.Request.prototype.hasOwnProperty("signal") || !e.AbortController;
      })(e) && (e.AbortController = l, e.AbortSignal = u);
    }("undefined" != typeof self ? self : commonjsGlobal);
  }(), _export(_export.S, "Math", {
    clz32: function clz32(e) {
      return (e >>>= 0) ? 31 - Math.floor(Math.log(e + .5) * Math.LOG2E) : 32;
    }
  });

  var log = Math.log,
      LN2 = Math.LN2,
      clz32 = Math.clz32 || function (e) {
    return 31 - log(e >>> 0) / LN2 | 0;
  },
      fromCharCode = String.fromCharCode,
      Object_prototype_toString = {}.toString,
      NativeUint8Array = window.Uint8Array,
      patchedU8Array = NativeUint8Array || Array,
      ArrayBufferString = Object_prototype_toString.call((window.ArrayBuffer || patchedU8Array).prototype);

  function decoderReplacer(e) {
    var t = e.charCodeAt(0) << 24,
        r = 0 | clz32(~t),
        n = 0,
        o = 0 | e.length,
        i = "";

    if (r < 5 && o >= r) {
      for (t = t << r >>> 24 + r, n = 1; n < r; n = n + 1 | 0) {
        t = t << 6 | 63 & e.charCodeAt(n);
      }

      t <= 65535 ? i += fromCharCode(t) : t <= 1114111 ? i += fromCharCode(55296 + ((t = t - 65536 | 0) >> 10) | 0, 56320 + (1023 & t) | 0) : n = 0;
    }

    for (; n < o; n = n + 1 | 0) {
      i += "�";
    }

    return i;
  }

  function TextDecoder$1() {}

  function encoderReplacer(e) {
    var t = 0 | e.charCodeAt(0);

    if (t >= 55296 && t <= 56319) {
      var r = 0 | e.charCodeAt(1);
      if (r != r) return fromCharCode(239, 191, 189);
      if (!(r >= 56320 && r <= 57343)) return fromCharCode(239, 191, 189);
      if ((t = (t - 55296 << 10) + r - 56320 + 65536 | 0) > 65535) return fromCharCode(240 | t >>> 18, 128 | t >>> 12 & 63, 128 | t >>> 6 & 63, 128 | 63 & t);
    }

    return t <= 127 ? e : t <= 2047 ? fromCharCode(192 | t >>> 6, 128 | 63 & t) : fromCharCode(224 | t >>> 12, 128 | t >>> 6 & 63, 128 | 63 & t);
  }

  function TextEncoder$1() {}

  TextDecoder$1.prototype.decode = function (e) {
    var t = e && e.buffer || e;
    if (Object_prototype_toString.call(t) !== ArrayBufferString) throw Error("Failed to execute 'decode' on 'TextDecoder': The provided value is not of type '(ArrayBuffer or ArrayBufferView)'");

    for (var r = NativeUint8Array ? new patchedU8Array(t) : t, n = "", o = 0, i = 0 | r.length; o < i; o = o + 32768 | 0) {
      n += fromCharCode.apply(0, r[NativeUint8Array ? "slice" : "subarray"](o, o + 32768 | 0));
    }

    return n.replace(/[\xc0-\xff][\x80-\xbf]*/g, decoderReplacer);
  }, window.TextDecoder || (window.TextDecoder = TextDecoder$1), TextEncoder$1.prototype.encode = function (e) {
    for (var t = void 0 === e ? "" : ("" + e).replace(/[\x80-\uD7ff\uDC00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]?/g, encoderReplacer), r = 0 | t.length, n = new patchedU8Array(r), o = 0; o < r; o = o + 1 | 0) {
      n[o] = t.charCodeAt(o);
    }

    return n;
  }, window.TextEncoder || (window.TextEncoder = TextEncoder$1), _export(_export.P + _export.R, "Promise", {
    finally: function _finally(e) {
      var t = _speciesConstructor(this, _core.Promise || _global.Promise),
          r = "function" == typeof e;

      return this.then(r ? function (r) {
        return _promiseResolve(t, e()).then(function () {
          return r;
        });
      } : e, r ? function (r) {
        return _promiseResolve(t, e()).then(function () {
          throw r;
        });
      } : e);
    }
  });

  var $find = _arrayMethods(6),
      KEY = "findIndex",
      forced = !0,
      RtmStatusCode;

  KEY in [] && Array(1)[KEY](function () {
    forced = !1;
  }), _export(_export.P + _export.F * forced, "Array", {
    findIndex: function findIndex(e) {
      return $find(this, e, arguments.length > 1 ? arguments[1] : void 0);
    }
  }), _addToUnscopables(KEY), function (e) {
    var t, r, n, o, i, s, a, u, l, c;
    !function (e) {
      e.LOGIN = "LOGIN", e.LOGIN_SUCCESS = "LOGIN_SUCCESS", e.LOGIN_FAILURE = "LOGIN_FAILURE", e.LOGIN_TIMEOUT = "LOGIN_TIMEOUT", e.INTERRUPTED = "INTERRUPTED", e.LOGOUT = "LOGOUT", e.BANNED_BY_SERVER = "BANNED_BY_SERVER", e.REMOTE_LOGIN = "REMOTE_LOGIN";
    }(t || (t = {})), e.ConnectionChangeReason = t, function (e) {
      e.DISCONNECTED = "DISCONNECTED", e.CONNECTING = "CONNECTING", e.CONNECTED = "CONNECTED", e.RECONNECTING = "RECONNECTING", e.ABORTED = "ABORTED";
    }(r || (r = {})), e.ConnectionState = r, function (e) {
      e.IDLE = "IDLE", e.SENT_TO_REMOTE = "SENT_TO_REMOTE", e.RECEIVED_BY_REMOTE = "RECEIVED_BY_REMOTE", e.ACCEPTED_BY_REMOTE = "ACCEPTED_BY_REMOTE", e.REFUSED_BY_REMOTE = "REFUSED_BY_REMOTE", e.CANCELED = "CANCELED", e.FAILURE = "FAILURE";
    }(n || (n = {})), e.LocalInvitationState = n, function (e) {
      e.INVITATION_RECEIVED = "INVITATION_RECEIVED", e.ACCEPT_SENT_TO_LOCAL = "ACCEPT_SENT_TO_LOCAL", e.REFUSED = "REFUSED", e.ACCEPTED = "ACCEPTED", e.CANCELED = "CANCELED", e.FAILURE = "FAILURE";
    }(o || (o = {})), e.RemoteInvitationState = o, function (e) {
      e.UNKNOWN = "UNKNOWN", e.PEER_NO_RESPONSE = "PEER_NO_RESPONSE", e.INVITATION_EXPIRE = "INVITATION_EXPIRE", e.PEER_OFFLINE = "PEER_OFFLINE", e.NOT_LOGGEDIN = "NOT_LOGGEDIN";
    }(i || (i = {})), e.LocalInvitationFailureReason = i, function (e) {
      e.UNKNOWN = "UNKNOWN", e.PEER_OFFLINE = "PEER_OFFLINE", e.ACCEPT_FAILURE = "ACCEPT_FAILURE", e.INVITATION_EXPIRE = "INVITATION_EXPIRE";
    }(s || (s = {})), e.RemoteInvitationFailureReason = s, function (e) {
      e.ONLINE = "ONLINE", e.UNREACHABLE = "UNREACHABLE", e.OFFLINE = "OFFLINE";
    }(a || (a = {})), e.PeerOnlineState = a, function (e) {
      e.ONLINE_STATUS = "ONLINE_STATUS";
    }(u || (u = {})), e.PeerSubscriptionOption = u, function (e) {
      e.TEXT = "TEXT", e.RAW = "RAW", e.IMAGE = "IMAGE", e.FILE = "FILE";
    }(l || (l = {})), e.MessageType = l, function (e) {
      e.CN = "CN", e.NA = "NA", e.EU = "EU", e.AS = "AS", e.JP = "JP", e.IN = "IN", e.GLOB = "GLOB", e.OC = "OC", e.SA = "SA", e.AF = "AF", e.OVS = "OVS";
    }(c || (c = {})), e.AreaCode = c;
  }(RtmStatusCode || (RtmStatusCode = {}));

  var RtmStatusCode$1 = RtmStatusCode,
      runtime_1 = createCommonjsModule(function (e) {
    var t = function (e) {
      var t,
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = "function" == typeof Symbol ? Symbol : {},
          i = o.iterator || "@@iterator",
          s = o.asyncIterator || "@@asyncIterator",
          a = o.toStringTag || "@@toStringTag";

      function u(e, t, r, n) {
        var o = t && t.prototype instanceof h ? t : h,
            i = Object.create(o.prototype),
            s = new R(n || []);
        return i._invoke = function (e, t, r) {
          var n = c;
          return function (o, i) {
            if (n === f) throw new Error("Generator is already running");

            if (n === d) {
              if ("throw" === o) throw i;
              return T();
            }

            for (r.method = o, r.arg = i;;) {
              var s = r.delegate;

              if (s) {
                var a = $(s, r);

                if (a) {
                  if (a === g) continue;
                  return a;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if (n === c) throw n = d, r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = f;
              var u = l(e, t, r);

              if ("normal" === u.type) {
                if (n = r.done ? d : p, u.arg === g) continue;
                return {
                  value: u.arg,
                  done: r.done
                };
              }

              "throw" === u.type && (n = d, r.method = "throw", r.arg = u.arg);
            }
          };
        }(e, r, s), i;
      }

      function l(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      e.wrap = u;
      var c = "suspendedStart",
          p = "suspendedYield",
          f = "executing",
          d = "completed",
          g = {};

      function h() {}

      function b() {}

      function y() {}

      var _ = {};

      _[i] = function () {
        return this;
      };

      var m = Object.getPrototypeOf,
          v = m && m(m(A([])));
      v && v !== r && n.call(v, i) && (_ = v);
      var E = y.prototype = h.prototype = Object.create(_);

      function O(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }

      function I(e) {
        var t;

        this._invoke = function (r, o) {
          function i() {
            return new Promise(function (t, i) {
              !function t(r, o, i, s) {
                var a = l(e[r], e, o);

                if ("throw" !== a.type) {
                  var u = a.arg,
                      c = u.value;
                  return c && "object" === _typeof(c) && n.call(c, "__await") ? Promise.resolve(c.__await).then(function (e) {
                    t("next", e, i, s);
                  }, function (e) {
                    t("throw", e, i, s);
                  }) : Promise.resolve(c).then(function (e) {
                    u.value = e, i(u);
                  }, function (e) {
                    return t("throw", e, i, s);
                  });
                }

                s(a.arg);
              }(r, o, t, i);
            });
          }

          return t = t ? t.then(i, i) : i();
        };
      }

      function $(e, r) {
        var n = e.iterator[r.method];

        if (n === t) {
          if (r.delegate = null, "throw" === r.method) {
            if (e.iterator.return && (r.method = "return", r.arg = t, $(e, r), "throw" === r.method)) return g;
            r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return g;
        }

        var o = l(n, e.iterator, r.arg);
        if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, g;
        var i = o.arg;
        return i ? i.done ? (r[e.resultName] = i.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, g) : i : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, g);
      }

      function S(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function w(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function R(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(S, this), this.reset(!0);
      }

      function A(e) {
        if (e) {
          var r = e[i];
          if (r) return r.call(e);
          if ("function" == typeof e.next) return e;

          if (!isNaN(e.length)) {
            var o = -1,
                s = function r() {
              for (; ++o < e.length;) {
                if (n.call(e, o)) return r.value = e[o], r.done = !1, r;
              }

              return r.value = t, r.done = !0, r;
            };

            return s.next = s;
          }
        }

        return {
          next: T
        };
      }

      function T() {
        return {
          value: t,
          done: !0
        };
      }

      return b.prototype = E.constructor = y, y.constructor = b, y[a] = b.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, y) : (e.__proto__ = y, a in e || (e[a] = "GeneratorFunction")), e.prototype = Object.create(E), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, O(I.prototype), I.prototype[s] = function () {
        return this;
      }, e.AsyncIterator = I, e.async = function (t, r, n, o) {
        var i = new I(u(t, r, n, o));
        return e.isGeneratorFunction(r) ? i : i.next().then(function (e) {
          return e.done ? e.value : i.next();
        });
      }, O(E), E[a] = "Generator", E[i] = function () {
        return this;
      }, E.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];

        for (var r in e) {
          t.push(r);
        }

        return t.reverse(), function r() {
          for (; t.length;) {
            var n = t.pop();
            if (n in e) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, e.values = A, R.prototype = {
        constructor: R,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(w), !e) for (var r in this) {
            "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var r = this;

          function o(n, o) {
            return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var s = this.tryEntries[i],
                a = s.completion;
            if ("root" === s.tryLoc) return o("end");

            if (s.tryLoc <= this.prev) {
              var u = n.call(s, "catchLoc"),
                  l = n.call(s, "finallyLoc");

              if (u && l) {
                if (this.prev < s.catchLoc) return o(s.catchLoc, !0);
                if (this.prev < s.finallyLoc) return o(s.finallyLoc);
              } else if (u) {
                if (this.prev < s.catchLoc) return o(s.catchLoc, !0);
              } else {
                if (!l) throw new Error("try statement without catch or finally");
                if (this.prev < s.finallyLoc) return o(s.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var s = i ? i.completion : {};
          return s.type = e, s.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, g) : this.complete(s);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), g;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), w(r), g;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                w(r);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
          return this.delegate = {
            iterator: A(e),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = t), g;
        }
      }, e;
    }(e.exports);

    try {
      regeneratorRuntime = t;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(t);
    }
  }),
      regenerator = runtime_1,
      setPrototypeOf = _setProto.set,
      _inheritIfRequired = function _inheritIfRequired(e, t, r) {
    var n,
        o = t.constructor;
    return o !== r && "function" == typeof o && (n = o.prototype) !== r.prototype && _isObject(n) && setPrototypeOf && setPrototypeOf(e, n), e;
  },
      dP$3 = _objectDp.f,
      gOPN$2 = _objectGopn.f,
      _$RegExp = _global.RegExp,
      Base = _$RegExp,
      proto$1 = _$RegExp.prototype,
      re1 = /a/g,
      re2 = /a/g,
      CORRECT_NEW = new _$RegExp(re1) !== re1;

  if (_descriptors && (!CORRECT_NEW || _fails(function () {
    return re2[_wks("match")] = !1, _$RegExp(re1) != re1 || _$RegExp(re2) == re2 || "/a/i" != _$RegExp(re1, "i");
  }))) {
    _$RegExp = function $RegExp(e, t) {
      var r = this instanceof _$RegExp,
          n = _isRegexp(e),
          o = void 0 === t;

      return !r && n && e.constructor === _$RegExp && o ? e : _inheritIfRequired(CORRECT_NEW ? new Base(n && !o ? e.source : e, t) : Base((n = e instanceof _$RegExp) ? e.source : e, n && o ? _flags.call(e) : t), r ? this : proto$1, _$RegExp);
    };

    for (var proxy = function proxy(e) {
      (e in _$RegExp) || dP$3(_$RegExp, e, {
        configurable: !0,
        get: function get() {
          return Base[e];
        },
        set: function set(t) {
          Base[e] = t;
        }
      });
    }, keys = gOPN$2(Base), i$2 = 0; keys.length > i$2;) {
      proxy(keys[i$2++]);
    }

    proto$1.constructor = _$RegExp, _$RegExp.prototype = proto$1, _redefine(_global, "RegExp", _$RegExp);
  }

  _setSpecies("RegExp");

  var freeGlobal = "object" == _typeof(commonjsGlobal) && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal,
      _freeGlobal = freeGlobal,
      freeSelf = "object" == ("undefined" == typeof self ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
      root = _freeGlobal || freeSelf || Function("return this")(),
      _root = root,
      _Symbol2 = _root.Symbol,
      _Symbol = _Symbol2,
      objectProto = Object.prototype,
      hasOwnProperty$1 = objectProto.hasOwnProperty,
      nativeObjectToString = objectProto.toString,
      symToStringTag = _Symbol ? _Symbol.toStringTag : void 0;

  function getRawTag(e) {
    var t = hasOwnProperty$1.call(e, symToStringTag),
        r = e[symToStringTag];

    try {
      e[symToStringTag] = void 0;
      var n = !0;
    } catch (e) {}

    var o = nativeObjectToString.call(e);
    return n && (t ? e[symToStringTag] = r : delete e[symToStringTag]), o;
  }

  var _getRawTag = getRawTag,
      objectProto$1 = Object.prototype,
      nativeObjectToString$1 = objectProto$1.toString;

  function objectToString(e) {
    return nativeObjectToString$1.call(e);
  }

  var _objectToString = objectToString,
      nullTag = "[object Null]",
      undefinedTag = "[object Undefined]",
      symToStringTag$1 = _Symbol ? _Symbol.toStringTag : void 0;

  function baseGetTag(e) {
    return null == e ? void 0 === e ? undefinedTag : nullTag : symToStringTag$1 && symToStringTag$1 in Object(e) ? _getRawTag(e) : _objectToString(e);
  }

  var _baseGetTag = baseGetTag;

  function isObject(e) {
    var t = _typeof(e);

    return null != e && ("object" == t || "function" == t);
  }

  var isObject_1 = isObject,
      asyncTag = "[object AsyncFunction]",
      funcTag = "[object Function]",
      genTag = "[object GeneratorFunction]",
      proxyTag = "[object Proxy]";

  function isFunction(e) {
    if (!isObject_1(e)) return !1;

    var t = _baseGetTag(e);

    return t == funcTag || t == genTag || t == asyncTag || t == proxyTag;
  }

  var isFunction_1 = isFunction,
      coreJsData = _root["__core-js_shared__"],
      _coreJsData = coreJsData,
      maskSrcKey = (uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || ""), uid ? "Symbol(src)_1." + uid : ""),
      uid;

  function isMasked(e) {
    return !!maskSrcKey && maskSrcKey in e;
  }

  var _isMasked = isMasked,
      funcProto = Function.prototype,
      funcToString = funcProto.toString;

  function toSource(e) {
    if (null != e) {
      try {
        return funcToString.call(e);
      } catch (e) {}

      try {
        return e + "";
      } catch (e) {}
    }

    return "";
  }

  var _toSource = toSource,
      reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reIsHostCtor = /^\[object .+?Constructor\]$/,
      funcProto$1 = Function.prototype,
      objectProto$2 = Object.prototype,
      funcToString$1 = funcProto$1.toString,
      hasOwnProperty$2 = objectProto$2.hasOwnProperty,
      reIsNative = RegExp("^" + funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

  function baseIsNative(e) {
    return !(!isObject_1(e) || _isMasked(e)) && (isFunction_1(e) ? reIsNative : reIsHostCtor).test(_toSource(e));
  }

  var _baseIsNative = baseIsNative;

  function getValue(e, t) {
    return null == e ? void 0 : e[t];
  }

  var _getValue = getValue;

  function getNative(e, t) {
    var r = _getValue(e, t);

    return _baseIsNative(r) ? r : void 0;
  }

  var _getNative = getNative,
      nativeCreate = _getNative(Object, "create"),
      _nativeCreate = nativeCreate;

  function hashClear() {
    this.__data__ = _nativeCreate ? _nativeCreate(null) : {}, this.size = 0;
  }

  var _hashClear = hashClear;

  function hashDelete(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }

  var _hashDelete = hashDelete,
      HASH_UNDEFINED = "__lodash_hash_undefined__",
      objectProto$3 = Object.prototype,
      hasOwnProperty$3 = objectProto$3.hasOwnProperty;

  function hashGet(e) {
    var t = this.__data__;

    if (_nativeCreate) {
      var r = t[e];
      return r === HASH_UNDEFINED ? void 0 : r;
    }

    return hasOwnProperty$3.call(t, e) ? t[e] : void 0;
  }

  var _hashGet = hashGet,
      objectProto$4 = Object.prototype,
      hasOwnProperty$4 = objectProto$4.hasOwnProperty;

  function hashHas(e) {
    var t = this.__data__;
    return _nativeCreate ? void 0 !== t[e] : hasOwnProperty$4.call(t, e);
  }

  var _hashHas = hashHas,
      HASH_UNDEFINED$1 = "__lodash_hash_undefined__";

  function hashSet(e, t) {
    var r = this.__data__;
    return this.size += this.has(e) ? 0 : 1, r[e] = _nativeCreate && void 0 === t ? HASH_UNDEFINED$1 : t, this;
  }

  var _hashSet = hashSet;

  function Hash(e) {
    var t = -1,
        r = null == e ? 0 : e.length;

    for (this.clear(); ++t < r;) {
      var n = e[t];
      this.set(n[0], n[1]);
    }
  }

  Hash.prototype.clear = _hashClear, Hash.prototype.delete = _hashDelete, Hash.prototype.get = _hashGet, Hash.prototype.has = _hashHas, Hash.prototype.set = _hashSet;
  var _Hash = Hash;

  function listCacheClear() {
    this.__data__ = [], this.size = 0;
  }

  var _listCacheClear = listCacheClear;

  function eq(e, t) {
    return e === t || e != e && t != t;
  }

  var eq_1 = eq;

  function assocIndexOf(e, t) {
    for (var r = e.length; r--;) {
      if (eq_1(e[r][0], t)) return r;
    }

    return -1;
  }

  var _assocIndexOf = assocIndexOf,
      arrayProto = Array.prototype,
      splice = arrayProto.splice;

  function listCacheDelete(e) {
    var t = this.__data__,
        r = _assocIndexOf(t, e);

    return !(r < 0) && (r == t.length - 1 ? t.pop() : splice.call(t, r, 1), --this.size, !0);
  }

  var _listCacheDelete = listCacheDelete;

  function listCacheGet(e) {
    var t = this.__data__,
        r = _assocIndexOf(t, e);

    return r < 0 ? void 0 : t[r][1];
  }

  var _listCacheGet = listCacheGet;

  function listCacheHas(e) {
    return _assocIndexOf(this.__data__, e) > -1;
  }

  var _listCacheHas = listCacheHas;

  function listCacheSet(e, t) {
    var r = this.__data__,
        n = _assocIndexOf(r, e);

    return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
  }

  var _listCacheSet = listCacheSet;

  function ListCache(e) {
    var t = -1,
        r = null == e ? 0 : e.length;

    for (this.clear(); ++t < r;) {
      var n = e[t];
      this.set(n[0], n[1]);
    }
  }

  ListCache.prototype.clear = _listCacheClear, ListCache.prototype.delete = _listCacheDelete, ListCache.prototype.get = _listCacheGet, ListCache.prototype.has = _listCacheHas, ListCache.prototype.set = _listCacheSet;

  var _ListCache = ListCache,
      Map$1 = _getNative(_root, "Map"),
      _Map = Map$1;

  function mapCacheClear() {
    this.size = 0, this.__data__ = {
      hash: new _Hash(),
      map: new (_Map || _ListCache)(),
      string: new _Hash()
    };
  }

  var _mapCacheClear = mapCacheClear;

  function isKeyable(e) {
    var t = _typeof(e);

    return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
  }

  var _isKeyable = isKeyable;

  function getMapData(e, t) {
    var r = e.__data__;
    return _isKeyable(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
  }

  var _getMapData = getMapData;

  function mapCacheDelete(e) {
    var t = _getMapData(this, e).delete(e);

    return this.size -= t ? 1 : 0, t;
  }

  var _mapCacheDelete = mapCacheDelete;

  function mapCacheGet(e) {
    return _getMapData(this, e).get(e);
  }

  var _mapCacheGet = mapCacheGet;

  function mapCacheHas(e) {
    return _getMapData(this, e).has(e);
  }

  var _mapCacheHas = mapCacheHas;

  function mapCacheSet(e, t) {
    var r = _getMapData(this, e),
        n = r.size;

    return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
  }

  var _mapCacheSet = mapCacheSet;

  function MapCache(e) {
    var t = -1,
        r = null == e ? 0 : e.length;

    for (this.clear(); ++t < r;) {
      var n = e[t];
      this.set(n[0], n[1]);
    }
  }

  MapCache.prototype.clear = _mapCacheClear, MapCache.prototype.delete = _mapCacheDelete, MapCache.prototype.get = _mapCacheGet, MapCache.prototype.has = _mapCacheHas, MapCache.prototype.set = _mapCacheSet;
  var _MapCache = MapCache,
      HASH_UNDEFINED$2 = "__lodash_hash_undefined__";

  function setCacheAdd(e) {
    return this.__data__.set(e, HASH_UNDEFINED$2), this;
  }

  var _setCacheAdd = setCacheAdd;

  function setCacheHas(e) {
    return this.__data__.has(e);
  }

  var _setCacheHas = setCacheHas;

  function SetCache(e) {
    var t = -1,
        r = null == e ? 0 : e.length;

    for (this.__data__ = new _MapCache(); ++t < r;) {
      this.add(e[t]);
    }
  }

  SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd, SetCache.prototype.has = _setCacheHas;
  var _SetCache = SetCache;

  function baseFindIndex(e, t, r, n) {
    for (var o = e.length, i = r + (n ? 1 : -1); n ? i-- : ++i < o;) {
      if (t(e[i], i, e)) return i;
    }

    return -1;
  }

  var _baseFindIndex = baseFindIndex;

  function baseIsNaN(e) {
    return e != e;
  }

  var _baseIsNaN = baseIsNaN;

  function strictIndexOf(e, t, r) {
    for (var n = r - 1, o = e.length; ++n < o;) {
      if (e[n] === t) return n;
    }

    return -1;
  }

  var _strictIndexOf = strictIndexOf;

  function baseIndexOf(e, t, r) {
    return t == t ? _strictIndexOf(e, t, r) : _baseFindIndex(e, _baseIsNaN, r);
  }

  var _baseIndexOf = baseIndexOf;

  function arrayIncludes(e, t) {
    return !!(null == e ? 0 : e.length) && _baseIndexOf(e, t, 0) > -1;
  }

  var _arrayIncludes$1 = arrayIncludes;

  function arrayIncludesWith(e, t, r) {
    for (var n = -1, o = null == e ? 0 : e.length; ++n < o;) {
      if (r(t, e[n])) return !0;
    }

    return !1;
  }

  var _arrayIncludesWith = arrayIncludesWith;

  function cacheHas(e, t) {
    return e.has(t);
  }

  var _cacheHas = cacheHas,
      Set$1 = _getNative(_root, "Set"),
      _Set = Set$1;

  function noop() {}

  var noop_1 = noop;

  function setToArray(e) {
    var t = -1,
        r = Array(e.size);
    return e.forEach(function (e) {
      r[++t] = e;
    }), r;
  }

  var _setToArray = setToArray,
      INFINITY = 1 / 0,
      createSet = _Set && 1 / _setToArray(new _Set([, -0]))[1] == INFINITY ? function (e) {
    return new _Set(e);
  } : noop_1,
      _createSet = createSet,
      LARGE_ARRAY_SIZE = 200;

  function baseUniq(e, t, r) {
    var n = -1,
        o = _arrayIncludes$1,
        i = e.length,
        s = !0,
        a = [],
        u = a;
    if (r) s = !1, o = _arrayIncludesWith;else if (i >= LARGE_ARRAY_SIZE) {
      var l = t ? null : _createSet(e);
      if (l) return _setToArray(l);
      s = !1, o = _cacheHas, u = new _SetCache();
    } else u = t ? [] : a;

    e: for (; ++n < i;) {
      var c = e[n],
          p = t ? t(c) : c;

      if (c = r || 0 !== c ? c : 0, s && p == p) {
        for (var f = u.length; f--;) {
          if (u[f] === p) continue e;
        }

        t && u.push(p), a.push(c);
      } else o(u, p, r) || (u !== a && u.push(p), a.push(c));
    }

    return a;
  }

  var _baseUniq = baseUniq;

  function uniq(e) {
    return e && e.length ? _baseUniq(e) : [];
  }

  var uniq_1 = uniq;

  function fromPairs(e) {
    for (var t = -1, r = null == e ? 0 : e.length, n = {}; ++t < r;) {
      var o = e[t];
      n[o[0]] = o[1];
    }

    return n;
  }

  var fromPairs_1 = fromPairs;

  function arrayMap(e, t) {
    for (var r = -1, n = null == e ? 0 : e.length, o = Array(n); ++r < n;) {
      o[r] = t(e[r], r, e);
    }

    return o;
  }

  var _arrayMap = arrayMap;

  function stackClear() {
    this.__data__ = new _ListCache(), this.size = 0;
  }

  var _stackClear = stackClear;

  function stackDelete(e) {
    var t = this.__data__,
        r = t.delete(e);
    return this.size = t.size, r;
  }

  var _stackDelete = stackDelete;

  function stackGet(e) {
    return this.__data__.get(e);
  }

  var _stackGet = stackGet;

  function stackHas(e) {
    return this.__data__.has(e);
  }

  var _stackHas = stackHas,
      LARGE_ARRAY_SIZE$1 = 200;

  function stackSet(e, t) {
    var r = this.__data__;

    if (r instanceof _ListCache) {
      var n = r.__data__;
      if (!_Map || n.length < LARGE_ARRAY_SIZE$1 - 1) return n.push([e, t]), this.size = ++r.size, this;
      r = this.__data__ = new _MapCache(n);
    }

    return r.set(e, t), this.size = r.size, this;
  }

  var _stackSet = stackSet;

  function Stack(e) {
    var t = this.__data__ = new _ListCache(e);
    this.size = t.size;
  }

  Stack.prototype.clear = _stackClear, Stack.prototype.delete = _stackDelete, Stack.prototype.get = _stackGet, Stack.prototype.has = _stackHas, Stack.prototype.set = _stackSet;
  var _Stack = Stack;

  function arrayEach(e, t) {
    for (var r = -1, n = null == e ? 0 : e.length; ++r < n && !1 !== t(e[r], r, e);) {
      ;
    }

    return e;
  }

  var _arrayEach = arrayEach,
      defineProperty$1 = function () {
    try {
      var e = _getNative(Object, "defineProperty");

      return e({}, "", {}), e;
    } catch (e) {}
  }(),
      _defineProperty$1 = defineProperty$1;

  function baseAssignValue(e, t, r) {
    "__proto__" == t && _defineProperty$1 ? _defineProperty$1(e, t, {
      configurable: !0,
      enumerable: !0,
      value: r,
      writable: !0
    }) : e[t] = r;
  }

  var _baseAssignValue = baseAssignValue,
      objectProto$5 = Object.prototype,
      hasOwnProperty$5 = objectProto$5.hasOwnProperty;

  function assignValue(e, t, r) {
    var n = e[t];
    hasOwnProperty$5.call(e, t) && eq_1(n, r) && (void 0 !== r || t in e) || _baseAssignValue(e, t, r);
  }

  var _assignValue = assignValue;

  function copyObject(e, t, r, n) {
    var o = !r;
    r || (r = {});

    for (var i = -1, s = t.length; ++i < s;) {
      var a = t[i],
          u = n ? n(r[a], e[a], a, r, e) : void 0;
      void 0 === u && (u = e[a]), o ? _baseAssignValue(r, a, u) : _assignValue(r, a, u);
    }

    return r;
  }

  var _copyObject = copyObject;

  function baseTimes(e, t) {
    for (var r = -1, n = Array(e); ++r < e;) {
      n[r] = t(r);
    }

    return n;
  }

  var _baseTimes = baseTimes;

  function isObjectLike(e) {
    return null != e && "object" == _typeof(e);
  }

  var isObjectLike_1 = isObjectLike,
      argsTag = "[object Arguments]";

  function baseIsArguments(e) {
    return isObjectLike_1(e) && _baseGetTag(e) == argsTag;
  }

  var _baseIsArguments = baseIsArguments,
      objectProto$6 = Object.prototype,
      hasOwnProperty$6 = objectProto$6.hasOwnProperty,
      propertyIsEnumerable = objectProto$6.propertyIsEnumerable,
      isArguments = _baseIsArguments(function () {
    return arguments;
  }()) ? _baseIsArguments : function (e) {
    return isObjectLike_1(e) && hasOwnProperty$6.call(e, "callee") && !propertyIsEnumerable.call(e, "callee");
  },
      isArguments_1 = isArguments,
      isArray = Array.isArray,
      isArray_1 = isArray;

  function stubFalse() {
    return !1;
  }

  var stubFalse_1 = stubFalse,
      isBuffer_1 = createCommonjsModule(function (e, t) {
    var r = t && !t.nodeType && t,
        n = r && e && !e.nodeType && e,
        o = n && n.exports === r ? _root.Buffer : void 0,
        i = (o ? o.isBuffer : void 0) || stubFalse_1;
    e.exports = i;
  }),
      MAX_SAFE_INTEGER = 9007199254740991,
      reIsUint = /^(?:0|[1-9]\d*)$/;

  function isIndex(e, t) {
    var r = _typeof(e);

    return !!(t = null == t ? MAX_SAFE_INTEGER : t) && ("number" == r || "symbol" != r && reIsUint.test(e)) && e > -1 && e % 1 == 0 && e < t;
  }

  var _isIndex = isIndex,
      MAX_SAFE_INTEGER$1 = 9007199254740991;

  function isLength(e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER$1;
  }

  var isLength_1 = isLength,
      argsTag$1 = "[object Arguments]",
      arrayTag = "[object Array]",
      boolTag = "[object Boolean]",
      dateTag = "[object Date]",
      errorTag = "[object Error]",
      funcTag$1 = "[object Function]",
      mapTag = "[object Map]",
      numberTag = "[object Number]",
      objectTag = "[object Object]",
      regexpTag = "[object RegExp]",
      setTag = "[object Set]",
      stringTag = "[object String]",
      weakMapTag = "[object WeakMap]",
      arrayBufferTag = "[object ArrayBuffer]",
      dataViewTag = "[object DataView]",
      float32Tag = "[object Float32Array]",
      float64Tag = "[object Float64Array]",
      int8Tag = "[object Int8Array]",
      int16Tag = "[object Int16Array]",
      int32Tag = "[object Int32Array]",
      uint8Tag = "[object Uint8Array]",
      uint8ClampedTag = "[object Uint8ClampedArray]",
      uint16Tag = "[object Uint16Array]",
      uint32Tag = "[object Uint32Array]",
      typedArrayTags = {};

  function baseIsTypedArray(e) {
    return isObjectLike_1(e) && isLength_1(e.length) && !!typedArrayTags[_baseGetTag(e)];
  }

  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0, typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = !1;
  var _baseIsTypedArray = baseIsTypedArray;

  function baseUnary(e) {
    return function (t) {
      return e(t);
    };
  }

  var _baseUnary = baseUnary,
      _nodeUtil = createCommonjsModule(function (e, t) {
    var r = t && !t.nodeType && t,
        n = r && e && !e.nodeType && e,
        o = n && n.exports === r && _freeGlobal.process,
        i = function () {
      try {
        var e = n && n.require && n.require("util").types;

        return e || o && o.binding && o.binding("util");
      } catch (e) {}
    }();

    e.exports = i;
  }),
      nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray,
      isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray,
      isTypedArray_1 = isTypedArray,
      objectProto$7 = Object.prototype,
      hasOwnProperty$7 = objectProto$7.hasOwnProperty;

  function arrayLikeKeys(e, t) {
    var r = isArray_1(e),
        n = !r && isArguments_1(e),
        o = !r && !n && isBuffer_1(e),
        i = !r && !n && !o && isTypedArray_1(e),
        s = r || n || o || i,
        a = s ? _baseTimes(e.length, String) : [],
        u = a.length;

    for (var l in e) {
      !t && !hasOwnProperty$7.call(e, l) || s && ("length" == l || o && ("offset" == l || "parent" == l) || i && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || _isIndex(l, u)) || a.push(l);
    }

    return a;
  }

  var _arrayLikeKeys = arrayLikeKeys,
      objectProto$8 = Object.prototype;

  function isPrototype(e) {
    var t = e && e.constructor;
    return e === ("function" == typeof t && t.prototype || objectProto$8);
  }

  var _isPrototype = isPrototype,
      _objectSap = function _objectSap(e, t) {
    var r = (_core.Object || {})[e] || Object[e],
        n = {};
    n[e] = t(r), _export(_export.S + _export.F * _fails(function () {
      r(1);
    }), "Object", n);
  };

  function overArg(e, t) {
    return function (r) {
      return e(t(r));
    };
  }

  _objectSap("keys", function () {
    return function (e) {
      return _objectKeys(_toObject(e));
    };
  });

  var _overArg = overArg,
      nativeKeys = _overArg(Object.keys, Object),
      _nativeKeys = nativeKeys,
      objectProto$9 = Object.prototype,
      hasOwnProperty$8 = objectProto$9.hasOwnProperty;

  function baseKeys(e) {
    if (!_isPrototype(e)) return _nativeKeys(e);
    var t = [];

    for (var r in Object(e)) {
      hasOwnProperty$8.call(e, r) && "constructor" != r && t.push(r);
    }

    return t;
  }

  var _baseKeys = baseKeys;

  function isArrayLike(e) {
    return null != e && isLength_1(e.length) && !isFunction_1(e);
  }

  var isArrayLike_1 = isArrayLike;

  function keys$1(e) {
    return isArrayLike_1(e) ? _arrayLikeKeys(e) : _baseKeys(e);
  }

  var keys_1 = keys$1;

  function baseAssign(e, t) {
    return e && _copyObject(t, keys_1(t), e);
  }

  var _baseAssign = baseAssign;

  function nativeKeysIn(e) {
    var t = [];
    if (null != e) for (var r in Object(e)) {
      t.push(r);
    }
    return t;
  }

  var _nativeKeysIn = nativeKeysIn,
      objectProto$a = Object.prototype,
      hasOwnProperty$9 = objectProto$a.hasOwnProperty;

  function baseKeysIn(e) {
    if (!isObject_1(e)) return _nativeKeysIn(e);

    var t = _isPrototype(e),
        r = [];

    for (var n in e) {
      ("constructor" != n || !t && hasOwnProperty$9.call(e, n)) && r.push(n);
    }

    return r;
  }

  var _baseKeysIn = baseKeysIn;

  function keysIn$1(e) {
    return isArrayLike_1(e) ? _arrayLikeKeys(e, !0) : _baseKeysIn(e);
  }

  var keysIn_1 = keysIn$1;

  function baseAssignIn(e, t) {
    return e && _copyObject(t, keysIn_1(t), e);
  }

  var _baseAssignIn = baseAssignIn,
      _cloneBuffer = createCommonjsModule(function (e, t) {
    var r = t && !t.nodeType && t,
        n = r && e && !e.nodeType && e,
        o = n && n.exports === r ? _root.Buffer : void 0,
        i = o ? o.allocUnsafe : void 0;

    e.exports = function (e, t) {
      if (t) return e.slice();
      var r = e.length,
          n = i ? i(r) : new e.constructor(r);
      return e.copy(n), n;
    };
  });

  function copyArray(e, t) {
    var r = -1,
        n = e.length;

    for (t || (t = Array(n)); ++r < n;) {
      t[r] = e[r];
    }

    return t;
  }

  var _copyArray = copyArray;

  function arrayFilter(e, t) {
    for (var r = -1, n = null == e ? 0 : e.length, o = 0, i = []; ++r < n;) {
      var s = e[r];
      t(s, r, e) && (i[o++] = s);
    }

    return i;
  }

  var _arrayFilter = arrayFilter;

  function stubArray() {
    return [];
  }

  var stubArray_1 = stubArray,
      objectProto$b = Object.prototype,
      propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable,
      nativeGetSymbols = Object.getOwnPropertySymbols,
      getSymbols = nativeGetSymbols ? function (e) {
    return null == e ? [] : (e = Object(e), _arrayFilter(nativeGetSymbols(e), function (t) {
      return propertyIsEnumerable$1.call(e, t);
    }));
  } : stubArray_1,
      _getSymbols = getSymbols;

  function copySymbols(e, t) {
    return _copyObject(e, _getSymbols(e), t);
  }

  var _copySymbols = copySymbols;

  function arrayPush(e, t) {
    for (var r = -1, n = t.length, o = e.length; ++r < n;) {
      e[o + r] = t[r];
    }

    return e;
  }

  var _arrayPush = arrayPush,
      getPrototype = _overArg(Object.getPrototypeOf, Object),
      _getPrototype = getPrototype,
      nativeGetSymbols$1 = Object.getOwnPropertySymbols,
      getSymbolsIn = nativeGetSymbols$1 ? function (e) {
    for (var t = []; e;) {
      _arrayPush(t, _getSymbols(e)), e = _getPrototype(e);
    }

    return t;
  } : stubArray_1,
      _getSymbolsIn = getSymbolsIn;

  function copySymbolsIn(e, t) {
    return _copyObject(e, _getSymbolsIn(e), t);
  }

  var _copySymbolsIn = copySymbolsIn;

  function baseGetAllKeys(e, t, r) {
    var n = t(e);
    return isArray_1(e) ? n : _arrayPush(n, r(e));
  }

  var _baseGetAllKeys = baseGetAllKeys;

  function getAllKeys(e) {
    return _baseGetAllKeys(e, keys_1, _getSymbols);
  }

  var _getAllKeys = getAllKeys;

  function getAllKeysIn(e) {
    return _baseGetAllKeys(e, keysIn_1, _getSymbolsIn);
  }

  var _getAllKeysIn = getAllKeysIn,
      DataView$1 = _getNative(_root, "DataView"),
      _DataView = DataView$1,
      Promise$2 = _getNative(_root, "Promise"),
      _Promise = Promise$2,
      WeakMap = _getNative(_root, "WeakMap"),
      _WeakMap = WeakMap,
      mapTag$1 = "[object Map]",
      objectTag$1 = "[object Object]",
      promiseTag = "[object Promise]",
      setTag$1 = "[object Set]",
      weakMapTag$1 = "[object WeakMap]",
      dataViewTag$1 = "[object DataView]",
      dataViewCtorString = _toSource(_DataView),
      mapCtorString = _toSource(_Map),
      promiseCtorString = _toSource(_Promise),
      setCtorString = _toSource(_Set),
      weakMapCtorString = _toSource(_WeakMap),
      getTag = _baseGetTag;

  (_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1 || _Map && getTag(new _Map()) != mapTag$1 || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag$1 || _WeakMap && getTag(new _WeakMap()) != weakMapTag$1) && (getTag = function getTag(e) {
    var t = _baseGetTag(e),
        r = t == objectTag$1 ? e.constructor : void 0,
        n = r ? _toSource(r) : "";

    if (n) switch (n) {
      case dataViewCtorString:
        return dataViewTag$1;

      case mapCtorString:
        return mapTag$1;

      case promiseCtorString:
        return promiseTag;

      case setCtorString:
        return setTag$1;

      case weakMapCtorString:
        return weakMapTag$1;
    }
    return t;
  });
  var _getTag = getTag,
      objectProto$c = Object.prototype,
      hasOwnProperty$a = objectProto$c.hasOwnProperty;

  function initCloneArray(e) {
    var t = e.length,
        r = new e.constructor(t);
    return t && "string" == typeof e[0] && hasOwnProperty$a.call(e, "index") && (r.index = e.index, r.input = e.input), r;
  }

  var _initCloneArray = initCloneArray,
      Uint8Array$1 = _root.Uint8Array,
      _Uint8Array = Uint8Array$1;

  function cloneArrayBuffer(e) {
    var t = new e.constructor(e.byteLength);
    return new _Uint8Array(t).set(new _Uint8Array(e)), t;
  }

  var _cloneArrayBuffer = cloneArrayBuffer;

  function cloneDataView(e, t) {
    var r = t ? _cloneArrayBuffer(e.buffer) : e.buffer;
    return new e.constructor(r, e.byteOffset, e.byteLength);
  }

  var _cloneDataView = cloneDataView,
      reFlags = /\w*$/;

  function cloneRegExp(e) {
    var t = new e.constructor(e.source, reFlags.exec(e));
    return t.lastIndex = e.lastIndex, t;
  }

  var _cloneRegExp = cloneRegExp,
      symbolProto = _Symbol ? _Symbol.prototype : void 0,
      symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;

  function cloneSymbol(e) {
    return symbolValueOf ? Object(symbolValueOf.call(e)) : {};
  }

  var _cloneSymbol = cloneSymbol;

  function cloneTypedArray(e, t) {
    var r = t ? _cloneArrayBuffer(e.buffer) : e.buffer;
    return new e.constructor(r, e.byteOffset, e.length);
  }

  var _cloneTypedArray = cloneTypedArray,
      boolTag$1 = "[object Boolean]",
      dateTag$1 = "[object Date]",
      mapTag$2 = "[object Map]",
      numberTag$1 = "[object Number]",
      regexpTag$1 = "[object RegExp]",
      setTag$2 = "[object Set]",
      stringTag$1 = "[object String]",
      symbolTag = "[object Symbol]",
      arrayBufferTag$1 = "[object ArrayBuffer]",
      dataViewTag$2 = "[object DataView]",
      float32Tag$1 = "[object Float32Array]",
      float64Tag$1 = "[object Float64Array]",
      int8Tag$1 = "[object Int8Array]",
      int16Tag$1 = "[object Int16Array]",
      int32Tag$1 = "[object Int32Array]",
      uint8Tag$1 = "[object Uint8Array]",
      uint8ClampedTag$1 = "[object Uint8ClampedArray]",
      uint16Tag$1 = "[object Uint16Array]",
      uint32Tag$1 = "[object Uint32Array]";

  function initCloneByTag(e, t, r) {
    var n = e.constructor;

    switch (t) {
      case arrayBufferTag$1:
        return _cloneArrayBuffer(e);

      case boolTag$1:
      case dateTag$1:
        return new n(+e);

      case dataViewTag$2:
        return _cloneDataView(e, r);

      case float32Tag$1:
      case float64Tag$1:
      case int8Tag$1:
      case int16Tag$1:
      case int32Tag$1:
      case uint8Tag$1:
      case uint8ClampedTag$1:
      case uint16Tag$1:
      case uint32Tag$1:
        return _cloneTypedArray(e, r);

      case mapTag$2:
        return new n();

      case numberTag$1:
      case stringTag$1:
        return new n(e);

      case regexpTag$1:
        return _cloneRegExp(e);

      case setTag$2:
        return new n();

      case symbolTag:
        return _cloneSymbol(e);
    }
  }

  var _initCloneByTag = initCloneByTag,
      objectCreate = Object.create,
      baseCreate = function () {
    function e() {}

    return function (t) {
      if (!isObject_1(t)) return {};
      if (objectCreate) return objectCreate(t);
      e.prototype = t;
      var r = new e();
      return e.prototype = void 0, r;
    };
  }(),
      _baseCreate = baseCreate;

  function initCloneObject(e) {
    return "function" != typeof e.constructor || _isPrototype(e) ? {} : _baseCreate(_getPrototype(e));
  }

  var _initCloneObject = initCloneObject,
      mapTag$3 = "[object Map]";

  function baseIsMap(e) {
    return isObjectLike_1(e) && _getTag(e) == mapTag$3;
  }

  var _baseIsMap = baseIsMap,
      nodeIsMap = _nodeUtil && _nodeUtil.isMap,
      isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap,
      isMap_1 = isMap,
      setTag$3 = "[object Set]";

  function baseIsSet(e) {
    return isObjectLike_1(e) && _getTag(e) == setTag$3;
  }

  var _baseIsSet = baseIsSet,
      nodeIsSet = _nodeUtil && _nodeUtil.isSet,
      isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet,
      isSet_1 = isSet,
      CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4,
      argsTag$2 = "[object Arguments]",
      arrayTag$1 = "[object Array]",
      boolTag$2 = "[object Boolean]",
      dateTag$2 = "[object Date]",
      errorTag$1 = "[object Error]",
      funcTag$2 = "[object Function]",
      genTag$1 = "[object GeneratorFunction]",
      mapTag$4 = "[object Map]",
      numberTag$2 = "[object Number]",
      objectTag$2 = "[object Object]",
      regexpTag$2 = "[object RegExp]",
      setTag$4 = "[object Set]",
      stringTag$2 = "[object String]",
      symbolTag$1 = "[object Symbol]",
      weakMapTag$2 = "[object WeakMap]",
      arrayBufferTag$2 = "[object ArrayBuffer]",
      dataViewTag$3 = "[object DataView]",
      float32Tag$2 = "[object Float32Array]",
      float64Tag$2 = "[object Float64Array]",
      int8Tag$2 = "[object Int8Array]",
      int16Tag$2 = "[object Int16Array]",
      int32Tag$2 = "[object Int32Array]",
      uint8Tag$2 = "[object Uint8Array]",
      uint8ClampedTag$2 = "[object Uint8ClampedArray]",
      uint16Tag$2 = "[object Uint16Array]",
      uint32Tag$2 = "[object Uint32Array]",
      cloneableTags = {};

  function baseClone(e, t, r, n, o, i) {
    var s,
        a = t & CLONE_DEEP_FLAG,
        u = t & CLONE_FLAT_FLAG,
        l = t & CLONE_SYMBOLS_FLAG;
    if (r && (s = o ? r(e, n, o, i) : r(e)), void 0 !== s) return s;
    if (!isObject_1(e)) return e;
    var c = isArray_1(e);

    if (c) {
      if (s = _initCloneArray(e), !a) return _copyArray(e, s);
    } else {
      var p = _getTag(e),
          f = p == funcTag$2 || p == genTag$1;

      if (isBuffer_1(e)) return _cloneBuffer(e, a);

      if (p == objectTag$2 || p == argsTag$2 || f && !o) {
        if (s = u || f ? {} : _initCloneObject(e), !a) return u ? _copySymbolsIn(e, _baseAssignIn(s, e)) : _copySymbols(e, _baseAssign(s, e));
      } else {
        if (!cloneableTags[p]) return o ? e : {};
        s = _initCloneByTag(e, p, a);
      }
    }

    i || (i = new _Stack());
    var d = i.get(e);
    if (d) return d;
    i.set(e, s), isSet_1(e) ? e.forEach(function (n) {
      s.add(baseClone(n, t, r, n, e, i));
    }) : isMap_1(e) && e.forEach(function (n, o) {
      s.set(o, baseClone(n, t, r, o, e, i));
    });
    var g = l ? u ? _getAllKeysIn : _getAllKeys : u ? keysIn : keys_1,
        h = c ? void 0 : g(e);
    return _arrayEach(h || e, function (n, o) {
      h && (n = e[o = n]), _assignValue(s, o, baseClone(n, t, r, o, e, i));
    }), s;
  }

  cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] = cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] = cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] = cloneableTags[numberTag$2] = cloneableTags[objectTag$2] = cloneableTags[regexpTag$2] = cloneableTags[setTag$4] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] = cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = !0, cloneableTags[errorTag$1] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = !1;
  var _baseClone = baseClone,
      symbolTag$2 = "[object Symbol]";

  function isSymbol$1(e) {
    return "symbol" == _typeof(e) || isObjectLike_1(e) && _baseGetTag(e) == symbolTag$2;
  }

  var isSymbol_1 = isSymbol$1,
      reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/;

  function isKey(e, t) {
    if (isArray_1(e)) return !1;

    var r = _typeof(e);

    return !("number" != r && "symbol" != r && "boolean" != r && null != e && !isSymbol_1(e)) || reIsPlainProp.test(e) || !reIsDeepProp.test(e) || null != t && e in Object(t);
  }

  var _isKey = isKey,
      FUNC_ERROR_TEXT = "Expected a function";

  function memoize(e, t) {
    if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError(FUNC_ERROR_TEXT);

    var r = function r() {
      var n = arguments,
          o = t ? t.apply(this, n) : n[0],
          i = r.cache;
      if (i.has(o)) return i.get(o);
      var s = e.apply(this, n);
      return r.cache = i.set(o, s) || i, s;
    };

    return r.cache = new (memoize.Cache || _MapCache)(), r;
  }

  memoize.Cache = _MapCache;
  var memoize_1 = memoize,
      MAX_MEMOIZE_SIZE = 500;

  function memoizeCapped(e) {
    var t = memoize_1(e, function (e) {
      return r.size === MAX_MEMOIZE_SIZE && r.clear(), e;
    }),
        r = t.cache;
    return t;
  }

  var _memoizeCapped = memoizeCapped,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      reEscapeChar = /\\(\\)?/g,
      stringToPath = _memoizeCapped(function (e) {
    var t = [];
    return 46 === e.charCodeAt(0) && t.push(""), e.replace(rePropName, function (e, r, n, o) {
      t.push(n ? o.replace(reEscapeChar, "$1") : r || e);
    }), t;
  }),
      _stringToPath = stringToPath,
      INFINITY$1 = 1 / 0,
      symbolProto$1 = _Symbol ? _Symbol.prototype : void 0,
      symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;

  function baseToString(e) {
    if ("string" == typeof e) return e;
    if (isArray_1(e)) return _arrayMap(e, baseToString) + "";
    if (isSymbol_1(e)) return symbolToString ? symbolToString.call(e) : "";
    var t = e + "";
    return "0" == t && 1 / e == -INFINITY$1 ? "-0" : t;
  }

  var _baseToString = baseToString;

  function toString$2(e) {
    return null == e ? "" : _baseToString(e);
  }

  var toString_1 = toString$2;

  function castPath(e, t) {
    return isArray_1(e) ? e : _isKey(e, t) ? [e] : _stringToPath(toString_1(e));
  }

  var _castPath = castPath;

  function last(e) {
    var t = null == e ? 0 : e.length;
    return t ? e[t - 1] : void 0;
  }

  var last_1 = last,
      INFINITY$2 = 1 / 0;

  function toKey(e) {
    if ("string" == typeof e || isSymbol_1(e)) return e;
    var t = e + "";
    return "0" == t && 1 / e == -INFINITY$2 ? "-0" : t;
  }

  var _toKey = toKey;

  function baseGet(e, t) {
    for (var r = 0, n = (t = _castPath(t, e)).length; null != e && r < n;) {
      e = e[_toKey(t[r++])];
    }

    return r && r == n ? e : void 0;
  }

  var _baseGet = baseGet;

  function baseSlice(e, t, r) {
    var n = -1,
        o = e.length;
    t < 0 && (t = -t > o ? 0 : o + t), (r = r > o ? o : r) < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;

    for (var i = Array(o); ++n < o;) {
      i[n] = e[n + t];
    }

    return i;
  }

  var _baseSlice = baseSlice;

  function parent(e, t) {
    return t.length < 2 ? e : _baseGet(e, _baseSlice(t, 0, -1));
  }

  var _parent = parent;

  function baseUnset(e, t) {
    return t = _castPath(t, e), null == (e = _parent(e, t)) || delete e[_toKey(last_1(t))];
  }

  var _baseUnset = baseUnset,
      objectTag$3 = "[object Object]",
      funcProto$2 = Function.prototype,
      objectProto$d = Object.prototype,
      funcToString$2 = funcProto$2.toString,
      hasOwnProperty$b = objectProto$d.hasOwnProperty,
      objectCtorString = funcToString$2.call(Object);

  function isPlainObject(e) {
    if (!isObjectLike_1(e) || _baseGetTag(e) != objectTag$3) return !1;

    var t = _getPrototype(e);

    if (null === t) return !0;
    var r = hasOwnProperty$b.call(t, "constructor") && t.constructor;
    return "function" == typeof r && r instanceof r && funcToString$2.call(r) == objectCtorString;
  }

  var isPlainObject_1 = isPlainObject;

  function customOmitClone(e) {
    return isPlainObject_1(e) ? void 0 : e;
  }

  var _customOmitClone = customOmitClone,
      spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : void 0;

  function isFlattenable(e) {
    return isArray_1(e) || isArguments_1(e) || !!(spreadableSymbol && e && e[spreadableSymbol]);
  }

  var _isFlattenable = isFlattenable;

  function baseFlatten(e, t, r, n, o) {
    var i = -1,
        s = e.length;

    for (r || (r = _isFlattenable), o || (o = []); ++i < s;) {
      var a = e[i];
      t > 0 && r(a) ? t > 1 ? baseFlatten(a, t - 1, r, n, o) : _arrayPush(o, a) : n || (o[o.length] = a);
    }

    return o;
  }

  var _baseFlatten = baseFlatten;

  function flatten(e) {
    return (null == e ? 0 : e.length) ? _baseFlatten(e, 1) : [];
  }

  var flatten_1 = flatten;

  function apply(e, t, r) {
    switch (r.length) {
      case 0:
        return e.call(t);

      case 1:
        return e.call(t, r[0]);

      case 2:
        return e.call(t, r[0], r[1]);

      case 3:
        return e.call(t, r[0], r[1], r[2]);
    }

    return e.apply(t, r);
  }

  var _apply = apply,
      nativeMax = Math.max;

  function overRest(e, t, r) {
    return t = nativeMax(void 0 === t ? e.length - 1 : t, 0), function () {
      for (var n = arguments, o = -1, i = nativeMax(n.length - t, 0), s = Array(i); ++o < i;) {
        s[o] = n[t + o];
      }

      o = -1;

      for (var a = Array(t + 1); ++o < t;) {
        a[o] = n[o];
      }

      return a[t] = r(s), _apply(e, this, a);
    };
  }

  var _overRest = overRest;

  function constant(e) {
    return function () {
      return e;
    };
  }

  var constant_1 = constant;

  function identity(e) {
    return e;
  }

  var identity_1 = identity,
      baseSetToString = _defineProperty$1 ? function (e, t) {
    return _defineProperty$1(e, "toString", {
      configurable: !0,
      enumerable: !1,
      value: constant_1(t),
      writable: !0
    });
  } : identity_1,
      _baseSetToString = baseSetToString,
      HOT_COUNT = 800,
      HOT_SPAN = 16,
      nativeNow = Date.now;

  function shortOut(e) {
    var t = 0,
        r = 0;
    return function () {
      var n = nativeNow(),
          o = HOT_SPAN - (n - r);

      if (r = n, o > 0) {
        if (++t >= HOT_COUNT) return arguments[0];
      } else t = 0;

      return e.apply(void 0, arguments);
    };
  }

  var _shortOut = shortOut,
      setToString = _shortOut(_baseSetToString),
      _setToString = setToString;

  function flatRest(e) {
    return _setToString(_overRest(e, void 0, flatten_1), e + "");
  }

  var _flatRest = flatRest,
      CLONE_DEEP_FLAG$1 = 1,
      CLONE_FLAT_FLAG$1 = 2,
      CLONE_SYMBOLS_FLAG$1 = 4,
      omit = _flatRest(function (e, t) {
    var r = {};
    if (null == e) return r;
    var n = !1;
    t = _arrayMap(t, function (t) {
      return t = _castPath(t, e), n || (n = t.length > 1), t;
    }), _copyObject(e, _getAllKeysIn(e), r), n && (r = _baseClone(r, CLONE_DEEP_FLAG$1 | CLONE_FLAT_FLAG$1 | CLONE_SYMBOLS_FLAG$1, _customOmitClone));

    for (var o = t.length; o--;) {
      _baseUnset(r, t[o]);
    }

    return r;
  }),
      omit_1 = omit;

  function arrayAggregator(e, t, r, n) {
    for (var o = -1, i = null == e ? 0 : e.length; ++o < i;) {
      var s = e[o];
      t(n, s, r(s), e);
    }

    return n;
  }

  var _arrayAggregator = arrayAggregator;

  function createBaseFor(e) {
    return function (t, r, n) {
      for (var o = -1, i = Object(t), s = n(t), a = s.length; a--;) {
        var u = s[e ? a : ++o];
        if (!1 === r(i[u], u, i)) break;
      }

      return t;
    };
  }

  var _createBaseFor = createBaseFor,
      baseFor = _createBaseFor(),
      _baseFor = baseFor;

  function baseForOwn(e, t) {
    return e && _baseFor(e, t, keys_1);
  }

  var _baseForOwn = baseForOwn;

  function createBaseEach(e, t) {
    return function (r, n) {
      if (null == r) return r;
      if (!isArrayLike_1(r)) return e(r, n);

      for (var o = r.length, i = t ? o : -1, s = Object(r); (t ? i-- : ++i < o) && !1 !== n(s[i], i, s);) {
        ;
      }

      return r;
    };
  }

  var _createBaseEach = createBaseEach,
      baseEach = _createBaseEach(_baseForOwn),
      _baseEach = baseEach;

  function baseAggregator(e, t, r, n) {
    return _baseEach(e, function (e, o, i) {
      t(n, e, r(e), i);
    }), n;
  }

  var _baseAggregator = baseAggregator;

  function arraySome(e, t) {
    for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) {
      if (t(e[r], r, e)) return !0;
    }

    return !1;
  }

  var _arraySome = arraySome,
      COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  function equalArrays(e, t, r, n, o, i) {
    var s = r & COMPARE_PARTIAL_FLAG,
        a = e.length,
        u = t.length;
    if (a != u && !(s && u > a)) return !1;
    var l = i.get(e);
    if (l && i.get(t)) return l == t;
    var c = -1,
        p = !0,
        f = r & COMPARE_UNORDERED_FLAG ? new _SetCache() : void 0;

    for (i.set(e, t), i.set(t, e); ++c < a;) {
      var d = e[c],
          g = t[c];
      if (n) var h = s ? n(g, d, c, t, e, i) : n(d, g, c, e, t, i);

      if (void 0 !== h) {
        if (h) continue;
        p = !1;
        break;
      }

      if (f) {
        if (!_arraySome(t, function (e, t) {
          if (!_cacheHas(f, t) && (d === e || o(d, e, r, n, i))) return f.push(t);
        })) {
          p = !1;
          break;
        }
      } else if (d !== g && !o(d, g, r, n, i)) {
        p = !1;
        break;
      }
    }

    return i.delete(e), i.delete(t), p;
  }

  var _equalArrays = equalArrays;

  function mapToArray(e) {
    var t = -1,
        r = Array(e.size);
    return e.forEach(function (e, n) {
      r[++t] = [n, e];
    }), r;
  }

  var _mapToArray = mapToArray,
      COMPARE_PARTIAL_FLAG$1 = 1,
      COMPARE_UNORDERED_FLAG$1 = 2,
      boolTag$3 = "[object Boolean]",
      dateTag$3 = "[object Date]",
      errorTag$2 = "[object Error]",
      mapTag$5 = "[object Map]",
      numberTag$3 = "[object Number]",
      regexpTag$3 = "[object RegExp]",
      setTag$5 = "[object Set]",
      stringTag$3 = "[object String]",
      symbolTag$3 = "[object Symbol]",
      arrayBufferTag$3 = "[object ArrayBuffer]",
      dataViewTag$4 = "[object DataView]",
      symbolProto$2 = _Symbol ? _Symbol.prototype : void 0,
      symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;

  function equalByTag(e, t, r, n, o, i, s) {
    switch (r) {
      case dataViewTag$4:
        if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
        e = e.buffer, t = t.buffer;

      case arrayBufferTag$3:
        return !(e.byteLength != t.byteLength || !i(new _Uint8Array(e), new _Uint8Array(t)));

      case boolTag$3:
      case dateTag$3:
      case numberTag$3:
        return eq_1(+e, +t);

      case errorTag$2:
        return e.name == t.name && e.message == t.message;

      case regexpTag$3:
      case stringTag$3:
        return e == t + "";

      case mapTag$5:
        var a = _mapToArray;

      case setTag$5:
        var u = n & COMPARE_PARTIAL_FLAG$1;
        if (a || (a = _setToArray), e.size != t.size && !u) return !1;
        var l = s.get(e);
        if (l) return l == t;
        n |= COMPARE_UNORDERED_FLAG$1, s.set(e, t);

        var c = _equalArrays(a(e), a(t), n, o, i, s);

        return s.delete(e), c;

      case symbolTag$3:
        if (symbolValueOf$1) return symbolValueOf$1.call(e) == symbolValueOf$1.call(t);
    }

    return !1;
  }

  var _equalByTag = equalByTag,
      COMPARE_PARTIAL_FLAG$2 = 1,
      objectProto$e = Object.prototype,
      hasOwnProperty$c = objectProto$e.hasOwnProperty;

  function equalObjects(e, t, r, n, o, i) {
    var s = r & COMPARE_PARTIAL_FLAG$2,
        a = _getAllKeys(e),
        u = a.length;

    if (u != _getAllKeys(t).length && !s) return !1;

    for (var l = u; l--;) {
      var c = a[l];
      if (!(s ? c in t : hasOwnProperty$c.call(t, c))) return !1;
    }

    var p = i.get(e);
    if (p && i.get(t)) return p == t;
    var f = !0;
    i.set(e, t), i.set(t, e);

    for (var d = s; ++l < u;) {
      var g = e[c = a[l]],
          h = t[c];
      if (n) var b = s ? n(h, g, c, t, e, i) : n(g, h, c, e, t, i);

      if (!(void 0 === b ? g === h || o(g, h, r, n, i) : b)) {
        f = !1;
        break;
      }

      d || (d = "constructor" == c);
    }

    if (f && !d) {
      var y = e.constructor,
          _ = t.constructor;
      y != _ && "constructor" in e && "constructor" in t && !("function" == typeof y && y instanceof y && "function" == typeof _ && _ instanceof _) && (f = !1);
    }

    return i.delete(e), i.delete(t), f;
  }

  var _equalObjects = equalObjects,
      COMPARE_PARTIAL_FLAG$3 = 1,
      argsTag$3 = "[object Arguments]",
      arrayTag$2 = "[object Array]",
      objectTag$4 = "[object Object]",
      objectProto$f = Object.prototype,
      hasOwnProperty$d = objectProto$f.hasOwnProperty;

  function baseIsEqualDeep(e, t, r, n, o, i) {
    var s = isArray_1(e),
        a = isArray_1(t),
        u = s ? arrayTag$2 : _getTag(e),
        l = a ? arrayTag$2 : _getTag(t),
        c = (u = u == argsTag$3 ? objectTag$4 : u) == objectTag$4,
        p = (l = l == argsTag$3 ? objectTag$4 : l) == objectTag$4,
        f = u == l;

    if (f && isBuffer_1(e)) {
      if (!isBuffer_1(t)) return !1;
      s = !0, c = !1;
    }

    if (f && !c) return i || (i = new _Stack()), s || isTypedArray_1(e) ? _equalArrays(e, t, r, n, o, i) : _equalByTag(e, t, u, r, n, o, i);

    if (!(r & COMPARE_PARTIAL_FLAG$3)) {
      var d = c && hasOwnProperty$d.call(e, "__wrapped__"),
          g = p && hasOwnProperty$d.call(t, "__wrapped__");

      if (d || g) {
        var h = d ? e.value() : e,
            b = g ? t.value() : t;
        return i || (i = new _Stack()), o(h, b, r, n, i);
      }
    }

    return !!f && (i || (i = new _Stack()), _equalObjects(e, t, r, n, o, i));
  }

  var _baseIsEqualDeep = baseIsEqualDeep;

  function baseIsEqual(e, t, r, n, o) {
    return e === t || (null == e || null == t || !isObjectLike_1(e) && !isObjectLike_1(t) ? e != e && t != t : _baseIsEqualDeep(e, t, r, n, baseIsEqual, o));
  }

  var _baseIsEqual = baseIsEqual,
      COMPARE_PARTIAL_FLAG$4 = 1,
      COMPARE_UNORDERED_FLAG$2 = 2;

  function baseIsMatch(e, t, r, n) {
    var o = r.length,
        i = o,
        s = !n;
    if (null == e) return !i;

    for (e = Object(e); o--;) {
      var a = r[o];
      if (s && a[2] ? a[1] !== e[a[0]] : !(a[0] in e)) return !1;
    }

    for (; ++o < i;) {
      var u = (a = r[o])[0],
          l = e[u],
          c = a[1];

      if (s && a[2]) {
        if (void 0 === l && !(u in e)) return !1;
      } else {
        var p = new _Stack();
        if (n) var f = n(l, c, u, e, t, p);
        if (!(void 0 === f ? _baseIsEqual(c, l, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, n, p) : f)) return !1;
      }
    }

    return !0;
  }

  var _baseIsMatch = baseIsMatch;

  function isStrictComparable(e) {
    return e == e && !isObject_1(e);
  }

  var _isStrictComparable = isStrictComparable;

  function getMatchData(e) {
    for (var t = keys_1(e), r = t.length; r--;) {
      var n = t[r],
          o = e[n];
      t[r] = [n, o, _isStrictComparable(o)];
    }

    return t;
  }

  var _getMatchData = getMatchData;

  function matchesStrictComparable(e, t) {
    return function (r) {
      return null != r && r[e] === t && (void 0 !== t || e in Object(r));
    };
  }

  var _matchesStrictComparable = matchesStrictComparable;

  function baseMatches(e) {
    var t = _getMatchData(e);

    return 1 == t.length && t[0][2] ? _matchesStrictComparable(t[0][0], t[0][1]) : function (r) {
      return r === e || _baseIsMatch(r, e, t);
    };
  }

  var _baseMatches = baseMatches;

  function get$1(e, t, r) {
    var n = null == e ? void 0 : _baseGet(e, t);
    return void 0 === n ? r : n;
  }

  var get_1 = get$1;

  function baseHasIn(e, t) {
    return null != e && t in Object(e);
  }

  var _baseHasIn = baseHasIn;

  function hasPath(e, t, r) {
    for (var n = -1, o = (t = _castPath(t, e)).length, i = !1; ++n < o;) {
      var s = _toKey(t[n]);

      if (!(i = null != e && r(e, s))) break;
      e = e[s];
    }

    return i || ++n != o ? i : !!(o = null == e ? 0 : e.length) && isLength_1(o) && _isIndex(s, o) && (isArray_1(e) || isArguments_1(e));
  }

  var _hasPath = hasPath;

  function hasIn(e, t) {
    return null != e && _hasPath(e, t, _baseHasIn);
  }

  var hasIn_1 = hasIn,
      COMPARE_PARTIAL_FLAG$5 = 1,
      COMPARE_UNORDERED_FLAG$3 = 2;

  function baseMatchesProperty(e, t) {
    return _isKey(e) && _isStrictComparable(t) ? _matchesStrictComparable(_toKey(e), t) : function (r) {
      var n = get_1(r, e);
      return void 0 === n && n === t ? hasIn_1(r, e) : _baseIsEqual(t, n, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
    };
  }

  var _baseMatchesProperty = baseMatchesProperty;

  function baseProperty(e) {
    return function (t) {
      return null == t ? void 0 : t[e];
    };
  }

  var _baseProperty = baseProperty;

  function basePropertyDeep(e) {
    return function (t) {
      return _baseGet(t, e);
    };
  }

  var _basePropertyDeep = basePropertyDeep;

  function property(e) {
    return _isKey(e) ? _baseProperty(_toKey(e)) : _basePropertyDeep(e);
  }

  var property_1 = property;

  function baseIteratee(e) {
    return "function" == typeof e ? e : null == e ? identity_1 : "object" == _typeof(e) ? isArray_1(e) ? _baseMatchesProperty(e[0], e[1]) : _baseMatches(e) : property_1(e);
  }

  var _baseIteratee = baseIteratee;

  function createAggregator(e, t) {
    return function (r, n) {
      var o = isArray_1(r) ? _arrayAggregator : _baseAggregator,
          i = t ? t() : {};
      return o(r, e, _baseIteratee(n), i);
    };
  }

  var _createAggregator = createAggregator,
      keyBy = _createAggregator(function (e, t, r) {
    _baseAssignValue(e, r, t);
  }),
      keyBy_1 = keyBy;

  function mapValues(e, t) {
    var r = {};
    return t = _baseIteratee(t), _baseForOwn(e, function (e, n, o) {
      _baseAssignValue(r, n, t(e, n, o));
    }), r;
  }

  var mapValues_1 = mapValues,
      _stringWs = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",
      space = "[" + _stringWs + "]",
      non = "​",
      ltrim = RegExp("^" + space + space + "*"),
      rtrim = RegExp(space + space + "*$"),
      exporter = function exporter(e, t, r) {
    var n = {},
        o = _fails(function () {
      return !!_stringWs[e]() || non[e]() != non;
    }),
        i = n[e] = o ? t(trim) : _stringWs[e];

    r && (n[r] = i), _export(_export.P + _export.F * o, "String", n);
  },
      trim = exporter.trim = function (e, t) {
    return e = String(_defined(e)), 1 & t && (e = e.replace(ltrim, "")), 2 & t && (e = e.replace(rtrim, "")), e;
  },
      _stringTrim = exporter,
      gOPN$3 = _objectGopn.f,
      gOPD$2 = _objectGopd.f,
      dP$4 = _objectDp.f,
      $trim = _stringTrim.trim,
      NUMBER = "Number",
      _$Number = _global[NUMBER],
      Base$1 = _$Number,
      proto$2 = _$Number.prototype,
      BROKEN_COF = _cof(_objectCreate(proto$2)) == NUMBER,
      TRIM = ("trim" in String.prototype),
      toNumber = function toNumber(e) {
    var t = _toPrimitive(e, !1);

    if ("string" == typeof t && t.length > 2) {
      var r,
          n,
          o,
          i = (t = TRIM ? t.trim() : $trim(t, 3)).charCodeAt(0);

      if (43 === i || 45 === i) {
        if (88 === (r = t.charCodeAt(2)) || 120 === r) return NaN;
      } else if (48 === i) {
        switch (t.charCodeAt(1)) {
          case 66:
          case 98:
            n = 2, o = 49;
            break;

          case 79:
          case 111:
            n = 8, o = 55;
            break;

          default:
            return +t;
        }

        for (var s, a = t.slice(2), u = 0, l = a.length; u < l; u++) {
          if ((s = a.charCodeAt(u)) < 48 || s > o) return NaN;
        }

        return parseInt(a, n);
      }
    }

    return +t;
  };

  if (!_$Number(" 0o1") || !_$Number("0b1") || _$Number("+0x1")) {
    _$Number = function $Number(e) {
      var t = arguments.length < 1 ? 0 : e,
          r = this;
      return r instanceof _$Number && (BROKEN_COF ? _fails(function () {
        proto$2.valueOf.call(r);
      }) : _cof(r) != NUMBER) ? _inheritIfRequired(new Base$1(toNumber(t)), r, _$Number) : toNumber(t);
    };

    for (var keys$2 = _descriptors ? gOPN$3(Base$1) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), j$1 = 0, key$1; keys$2.length > j$1; j$1++) {
      _has(Base$1, key$1 = keys$2[j$1]) && !_has(_$Number, key$1) && dP$4(_$Number, key$1, gOPD$2(Base$1, key$1));
    }

    _$Number.prototype = proto$2, proto$2.constructor = _$Number, _redefine(_global, NUMBER, _$Number);
  }

  _export(_export.S, "Number", {
    isNaN: function isNaN(e) {
      return e != e;
    }
  });

  var Reflect$1 = _global.Reflect,
      _ownKeys = Reflect$1 && Reflect$1.ownKeys || function (e) {
    var t = _objectGopn.f(_anObject(e)),
        r = _objectGops.f;

    return r ? t.concat(r(e)) : t;
  };

  _export(_export.S, "Reflect", {
    ownKeys: _ownKeys
  });

  var rApply = (_global.Reflect || {}).apply,
      fApply = Function.apply;

  _export(_export.S + _export.F * !_fails(function () {
    rApply(function () {});
  }), "Reflect", {
    apply: function apply(e, t, r) {
      var n = _aFunction(e),
          o = _anObject(r);

      return rApply ? rApply(n, t, o) : fApply.call(n, t, o);
    }
  });

  var R = "object" === ("undefined" == typeof Reflect ? "undefined" : _typeof(Reflect)) ? Reflect : null,
      ReflectApply = R && "function" == typeof R.apply ? R.apply : function (e, t, r) {
    return Function.prototype.apply.call(e, t, r);
  },
      ReflectOwnKeys;

  function ProcessEmitWarning(e) {
    console && console.warn && console.warn(e);
  }

  ReflectOwnKeys = R && "function" == typeof R.ownKeys ? R.ownKeys : Object.getOwnPropertySymbols ? function (e) {
    return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
  } : function (e) {
    return Object.getOwnPropertyNames(e);
  };

  var NumberIsNaN = Number.isNaN || function (e) {
    return e != e;
  };

  function EventEmitter() {
    EventEmitter.init.call(this);
  }

  var events = EventEmitter;
  EventEmitter.EventEmitter = EventEmitter, EventEmitter.prototype._events = void 0, EventEmitter.prototype._eventsCount = 0, EventEmitter.prototype._maxListeners = void 0;
  var defaultMaxListeners = 10;

  function checkListener(e) {
    if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + _typeof(e));
  }

  function _getMaxListeners(e) {
    return void 0 === e._maxListeners ? EventEmitter.defaultMaxListeners : e._maxListeners;
  }

  function _addListener(e, t, r, n) {
    var o, i, s;
    if (checkListener(r), void 0 === (i = e._events) ? (i = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== i.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), i = e._events), s = i[t]), void 0 === s) s = i[t] = r, ++e._eventsCount;else if ("function" == typeof s ? s = i[t] = n ? [r, s] : [s, r] : n ? s.unshift(r) : s.push(r), (o = _getMaxListeners(e)) > 0 && s.length > o && !s.warned) {
      s.warned = !0;
      var a = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      a.name = "MaxListenersExceededWarning", a.emitter = e, a.type = t, a.count = s.length, ProcessEmitWarning(a);
    }
    return e;
  }

  function onceWrapper() {
    if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }

  function _onceWrap(e, t, r) {
    var n = {
      fired: !1,
      wrapFn: void 0,
      target: e,
      type: t,
      listener: r
    },
        o = onceWrapper.bind(n);
    return o.listener = r, n.wrapFn = o, o;
  }

  function _listeners(e, t, r) {
    var n = e._events;
    if (void 0 === n) return [];
    var o = n[t];
    return void 0 === o ? [] : "function" == typeof o ? r ? [o.listener || o] : [o] : r ? unwrapListeners(o) : arrayClone(o, o.length);
  }

  function listenerCount(e) {
    var t = this._events;

    if (void 0 !== t) {
      var r = t[e];
      if ("function" == typeof r) return 1;
      if (void 0 !== r) return r.length;
    }

    return 0;
  }

  function arrayClone(e, t) {
    for (var r = new Array(t), n = 0; n < t; ++n) {
      r[n] = e[n];
    }

    return r;
  }

  function spliceOne(e, t) {
    for (; t + 1 < e.length; t++) {
      e[t] = e[t + 1];
    }

    e.pop();
  }

  function unwrapListeners(e) {
    for (var t = new Array(e.length), r = 0; r < t.length; ++r) {
      t[r] = e[r].listener || e[r];
    }

    return t;
  }

  Object.defineProperty(EventEmitter, "defaultMaxListeners", {
    enumerable: !0,
    get: function get() {
      return defaultMaxListeners;
    },
    set: function set(e) {
      if ("number" != typeof e || e < 0 || NumberIsNaN(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
      defaultMaxListeners = e;
    }
  }), EventEmitter.init = function () {
    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, EventEmitter.prototype.setMaxListeners = function (e) {
    if ("number" != typeof e || e < 0 || NumberIsNaN(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
    return this._maxListeners = e, this;
  }, EventEmitter.prototype.getMaxListeners = function () {
    return _getMaxListeners(this);
  }, EventEmitter.prototype.emit = function (e) {
    for (var t = [], r = 1; r < arguments.length; r++) {
      t.push(arguments[r]);
    }

    var n = "error" === e,
        o = this._events;
    if (void 0 !== o) n = n && void 0 === o.error;else if (!n) return !1;

    if (n) {
      var i;
      if (t.length > 0 && (i = t[0]), i instanceof Error) throw i;
      var s = new Error("Unhandled error." + (i ? " (" + i.message + ")" : ""));
      throw s.context = i, s;
    }

    var a = o[e];
    if (void 0 === a) return !1;
    if ("function" == typeof a) ReflectApply(a, this, t);else {
      var u = a.length,
          l = arrayClone(a, u);

      for (r = 0; r < u; ++r) {
        ReflectApply(l[r], this, t);
      }
    }
    return !0;
  }, EventEmitter.prototype.addListener = function (e, t) {
    return _addListener(this, e, t, !1);
  }, EventEmitter.prototype.on = EventEmitter.prototype.addListener, EventEmitter.prototype.prependListener = function (e, t) {
    return _addListener(this, e, t, !0);
  }, EventEmitter.prototype.once = function (e, t) {
    return checkListener(t), this.on(e, _onceWrap(this, e, t)), this;
  }, EventEmitter.prototype.prependOnceListener = function (e, t) {
    return checkListener(t), this.prependListener(e, _onceWrap(this, e, t)), this;
  }, EventEmitter.prototype.removeListener = function (e, t) {
    var r, n, o, i, s;
    if (checkListener(t), void 0 === (n = this._events)) return this;
    if (void 0 === (r = n[e])) return this;
    if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[e], n.removeListener && this.emit("removeListener", e, r.listener || t));else if ("function" != typeof r) {
      for (o = -1, i = r.length - 1; i >= 0; i--) {
        if (r[i] === t || r[i].listener === t) {
          s = r[i].listener, o = i;
          break;
        }
      }

      if (o < 0) return this;
      0 === o ? r.shift() : spliceOne(r, o), 1 === r.length && (n[e] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", e, s || t);
    }
    return this;
  }, EventEmitter.prototype.off = EventEmitter.prototype.removeListener, EventEmitter.prototype.removeAllListeners = function (e) {
    var t, r, n;
    if (void 0 === (r = this._events)) return this;
    if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[e]), this;

    if (0 === arguments.length) {
      var o,
          i = Object.keys(r);

      for (n = 0; n < i.length; ++n) {
        "removeListener" !== (o = i[n]) && this.removeAllListeners(o);
      }

      return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
    }

    if ("function" == typeof (t = r[e])) this.removeListener(e, t);else if (void 0 !== t) for (n = t.length - 1; n >= 0; n--) {
      this.removeListener(e, t[n]);
    }
    return this;
  }, EventEmitter.prototype.listeners = function (e) {
    return _listeners(this, e, !0);
  }, EventEmitter.prototype.rawListeners = function (e) {
    return _listeners(this, e, !1);
  }, EventEmitter.listenerCount = function (e, t) {
    return "function" == typeof e.listenerCount ? e.listenerCount(t) : listenerCount.call(e, t);
  }, EventEmitter.prototype.listenerCount = listenerCount, EventEmitter.prototype.eventNames = function () {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
  };

  var _validateCollection = function _validateCollection(e, t) {
    if (!_isObject(e) || e._t !== t) throw TypeError("Incompatible receiver, " + t + " required!");
    return e;
  },
      dP$5 = _objectDp.f,
      fastKey = _meta.fastKey,
      SIZE = _descriptors ? "_s" : "size",
      getEntry = function getEntry(e, t) {
    var r,
        n = fastKey(t);
    if ("F" !== n) return e._i[n];

    for (r = e._f; r; r = r.n) {
      if (r.k == t) return r;
    }
  },
      _collectionStrong = {
    getConstructor: function getConstructor(e, t, r, n) {
      var o = e(function (e, i) {
        _anInstance(e, o, t, "_i"), e._t = t, e._i = _objectCreate(null), e._f = void 0, e._l = void 0, e[SIZE] = 0, null != i && _forOf(i, r, e[n], e);
      });
      return _redefineAll(o.prototype, {
        clear: function clear() {
          for (var e = _validateCollection(this, t), r = e._i, n = e._f; n; n = n.n) {
            n.r = !0, n.p && (n.p = n.p.n = void 0), delete r[n.i];
          }

          e._f = e._l = void 0, e[SIZE] = 0;
        },
        delete: function _delete(e) {
          var r = _validateCollection(this, t),
              n = getEntry(r, e);

          if (n) {
            var o = n.n,
                i = n.p;
            delete r._i[n.i], n.r = !0, i && (i.n = o), o && (o.p = i), r._f == n && (r._f = o), r._l == n && (r._l = i), r[SIZE]--;
          }

          return !!n;
        },
        forEach: function forEach(e) {
          _validateCollection(this, t);

          for (var r, n = _ctx(e, arguments.length > 1 ? arguments[1] : void 0, 3); r = r ? r.n : this._f;) {
            for (n(r.v, r.k, this); r && r.r;) {
              r = r.p;
            }
          }
        },
        has: function has(e) {
          return !!getEntry(_validateCollection(this, t), e);
        }
      }), _descriptors && dP$5(o.prototype, "size", {
        get: function get() {
          return _validateCollection(this, t)[SIZE];
        }
      }), o;
    },
    def: function def(e, t, r) {
      var n,
          o,
          i = getEntry(e, t);
      return i ? i.v = r : (e._l = i = {
        i: o = fastKey(t, !0),
        k: t,
        v: r,
        p: n = e._l,
        n: void 0,
        r: !1
      }, e._f || (e._f = i), n && (n.n = i), e[SIZE]++, "F" !== o && (e._i[o] = i)), e;
    },
    getEntry: getEntry,
    setStrong: function setStrong(e, t, r) {
      _iterDefine(e, t, function (e, r) {
        this._t = _validateCollection(e, t), this._k = r, this._l = void 0;
      }, function () {
        for (var e = this._k, t = this._l; t && t.r;) {
          t = t.p;
        }

        return this._t && (this._l = t = t ? t.n : this._t._f) ? _iterStep(0, "keys" == e ? t.k : "values" == e ? t.v : [t.k, t.v]) : (this._t = void 0, _iterStep(1));
      }, r ? "entries" : "values", !r, !0), _setSpecies(t);
    }
  },
      _collection = function _collection(e, t, r, n, o, i) {
    var s = _global[e],
        a = s,
        u = o ? "set" : "add",
        l = a && a.prototype,
        c = {},
        p = function p(e) {
      var t = l[e];

      _redefine(l, e, "delete" == e ? function (e) {
        return !(i && !_isObject(e)) && t.call(this, 0 === e ? 0 : e);
      } : "has" == e ? function (e) {
        return !(i && !_isObject(e)) && t.call(this, 0 === e ? 0 : e);
      } : "get" == e ? function (e) {
        return i && !_isObject(e) ? void 0 : t.call(this, 0 === e ? 0 : e);
      } : "add" == e ? function (e) {
        return t.call(this, 0 === e ? 0 : e), this;
      } : function (e, r) {
        return t.call(this, 0 === e ? 0 : e, r), this;
      });
    };

    if ("function" == typeof a && (i || l.forEach && !_fails(function () {
      new a().entries().next();
    }))) {
      var f = new a(),
          d = f[u](i ? {} : -0, 1) != f,
          g = _fails(function () {
        f.has(1);
      }),
          h = _iterDetect(function (e) {
        new a(e);
      }),
          b = !i && _fails(function () {
        for (var e = new a(), t = 5; t--;) {
          e[u](t, t);
        }

        return !e.has(-0);
      });

      h || ((a = t(function (t, r) {
        _anInstance(t, a, e);

        var n = _inheritIfRequired(new s(), t, a);

        return null != r && _forOf(r, o, n[u], n), n;
      })).prototype = l, l.constructor = a), (g || b) && (p("delete"), p("has"), o && p("get")), (b || d) && p(u), i && l.clear && delete l.clear;
    } else a = n.getConstructor(t, e, o, u), _redefineAll(a.prototype, r), _meta.NEED = !0;

    return _setToStringTag(a, e), c[e] = a, _export(_export.G + _export.W + _export.F * (a != s), c), i || n.setStrong(a, e, o), a;
  },
      MAP = "Map",
      es6_map = _collection(MAP, function (e) {
    return function () {
      return e(this, arguments.length > 0 ? arguments[0] : void 0);
    };
  }, {
    get: function get(e) {
      var t = _collectionStrong.getEntry(_validateCollection(this, MAP), e);

      return t && t.v;
    },
    set: function set(e, t) {
      return _collectionStrong.def(_validateCollection(this, MAP), 0 === e ? 0 : e, t);
    }
  }, _collectionStrong, !0),
      $assign = Object.assign,
      _objectAssign = !$assign || _fails(function () {
    var e = {},
        t = {},
        r = Symbol(),
        n = "abcdefghijklmnopqrst";
    return e[r] = 7, n.split("").forEach(function (e) {
      t[e] = e;
    }), 7 != $assign({}, e)[r] || Object.keys($assign({}, t)).join("") != n;
  }) ? function (e, t) {
    for (var r = _toObject(e), n = arguments.length, o = 1, i = _objectGops.f, s = _objectPie.f; n > o;) {
      for (var a, u = _iobject(arguments[o++]), l = i ? _objectKeys(u).concat(i(u)) : _objectKeys(u), c = l.length, p = 0; c > p;) {
        a = l[p++], _descriptors && !s.call(u, a) || (r[a] = u[a]);
      }
    }

    return r;
  } : $assign,
      _SIZEOF;

  _export(_export.S + _export.F, "Object", {
    assign: _objectAssign
  });

  var EVENT_ALL = "*",
      EVENT_ENABLE = "enable",
      EVENT_DISABLE = "disable",
      SEMAPHORE = Symbol(),
      NO_OP = function NO_OP() {},
      Type;

  !function (e) {
    e[e.U8 = 0] = "U8", e[e.U8C = 1] = "U8C", e[e.I8 = 2] = "I8", e[e.U16 = 3] = "U16", e[e.I16 = 4] = "I16", e[e.U32 = 5] = "U32", e[e.I32 = 6] = "I32", e[e.F32 = 7] = "F32", e[e.F64 = 8] = "F64";
  }(Type || (Type = {}));
  var SIZEOF = (_SIZEOF = {}, _defineProperty(_SIZEOF, 0, 1), _defineProperty(_SIZEOF, 1, 1), _defineProperty(_SIZEOF, 2, 1), _defineProperty(_SIZEOF, 3, 2), _defineProperty(_SIZEOF, 4, 2), _defineProperty(_SIZEOF, 5, 4), _defineProperty(_SIZEOF, 6, 4), _defineProperty(_SIZEOF, 7, 4), _defineProperty(_SIZEOF, 8, 8), _SIZEOF),
      LogLevel;
  !function (e) {
    e[e.FINE = 0] = "FINE", e[e.DEBUG = 1] = "DEBUG", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.SEVERE = 4] = "SEVERE", e[e.NONE = 5] = "NONE";
  }(LogLevel || (LogLevel = {}));
  var assert = "undefined" == typeof process || "1" === process.env.UMBRELLA_ASSERTS ? function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "assertion failed";
    if ("function" == typeof e && !e() || !e) throw new Error("function" == typeof t ? t() : t);
  } : NO_OP,
      meta = _meta.onFreeze;

  _objectSap("freeze", function (e) {
    return function (t) {
      return e && _isObject(t) ? e(meta(t)) : t;
    };
  });

  var NULL_LOGGER = Object.freeze({
    level: LogLevel.NONE,
    fine: function fine() {},
    debug: function debug() {},
    info: function info() {},
    warn: function warn() {},
    severe: function severe() {}
  }),
      mixin = function mixin(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = Reflect.ownKeys(e),
        n = Reflect.ownKeys(t),
        o = Symbol("isa");

    function i(t) {
      var n = r,
          i = Array.isArray(n),
          s = 0;

      for (n = i ? n : n[Symbol.iterator]();;) {
        var a;

        if (i) {
          if (s >= n.length) break;
          a = n[s++];
        } else {
          if ((s = n.next()).done) break;
          a = s.value;
        }

        var u = a,
            l = Object.getOwnPropertyDescriptor(t.prototype, u);
        !l || l.configurable ? Object.defineProperty(t.prototype, u, {
          value: e[u],
          writable: !0
        }) : console.log("not patching: ".concat(t.name, ".").concat(u.toString()));
      }

      return Object.defineProperty(t.prototype, o, {
        value: !0
      }), t;
    }

    var s = n,
        a = Array.isArray(s),
        u = 0;

    for (s = a ? s : s[Symbol.iterator]();;) {
      var l;

      if (a) {
        if (u >= s.length) break;
        l = s[u++];
      } else {
        if ((u = s.next()).done) break;
        l = u.value;
      }

      var c = l;
      Object.defineProperty(i, c, {
        value: t[c],
        enumerable: t.propertyIsEnumerable(c)
      });
    }

    return Object.defineProperty(i, Symbol.hasInstance, {
      value: function value(e) {
        return !!e[o];
      }
    }), i;
  },
      IllegalArgumentError = function (e) {
    function t(e) {
      return _classCallCheck(this, t), _possibleConstructorReturn(this, _getPrototypeOf(t).call(this, "illegal argument(s)" + (void 0 !== e ? ": " + e : "")));
    }

    return _inherits(t, _wrapNativeSuper(Error)), t;
  }(),
      illegalArgs = function illegalArgs(e) {
    throw new IllegalArgumentError(e);
  },
      IllegalArityError = function (e) {
    function t(e) {
      return _classCallCheck(this, t), _possibleConstructorReturn(this, _getPrototypeOf(t).call(this, "illegal arity: ".concat(e)));
    }

    return _inherits(t, _wrapNativeSuper(Error)), t;
  }(),
      IllegalStateError = function (e) {
    function t(e) {
      return _classCallCheck(this, t), _possibleConstructorReturn(this, _getPrototypeOf(t).call(this, "illegal state" + (void 0 !== e ? ": " + e : "")));
    }

    return _inherits(t, _wrapNativeSuper(Error)), t;
  }(),
      UnsupportedOperationError = function (e) {
    function t(e) {
      return _classCallCheck(this, t), _possibleConstructorReturn(this, _getPrototypeOf(t).call(this, "unsupported operation" + (void 0 !== e ? ": " + e : "")));
    }

    return _inherits(t, _wrapNativeSuper(Error)), t;
  }(),
      meta$1 = _meta.onFreeze;

  _objectSap("seal", function (e) {
    return function (t) {
      return e && _isObject(t) ? e(meta$1(t)) : t;
    };
  });

  var IEnableMixin = mixin({
    _enabled: !0,
    isEnabled: function isEnabled() {
      return this._enabled;
    },
    enable: function enable() {
      this._enabled = !0, this.notify && this.notify({
        id: EVENT_ENABLE,
        target: this
      });
    },
    disable: function disable() {
      this._enabled = !1, this.notify && this.notify({
        id: EVENT_DISABLE,
        target: this
      });
    },
    toggle: function toggle() {
      return this._enabled ? this.disable() : this.enable(), this._enabled;
    }
  }),
      inotify_dispatch = function inotify_dispatch(e, t) {
    if (e) for (var r, n = 0, o = e.length; n < o; n++) {
      if ((r = e[n])[0].call(r[1], t), t.canceled) return;
    }
  },
      INotifyMixin = mixin({
    addListener: function addListener(e, t, r) {
      var n = (this._listeners = this._listeners || {})[e];
      return n || (n = this._listeners[e] = []), -1 === this.__listener(n, t, r) && (n.push([t, r]), !0);
    },
    removeListener: function removeListener(e, t, r) {
      if (!this._listeners) return !1;
      var n = this._listeners[e];

      if (n) {
        var o = this.__listener(n, t, r);

        if (-1 !== o) return n.splice(o, 1), !0;
      }

      return !1;
    },
    notify: function notify(e) {
      this._listeners && (void 0 === e.target && (e.target = this), inotify_dispatch(this._listeners[e.id], e), inotify_dispatch(this._listeners[EVENT_ALL], e));
    },
    __listener: function __listener(e, t, r) {
      for (var n = e.length; --n >= 0;) {
        var o = e[n];
        if (o[0] === t && o[1] === r) break;
      }

      return n;
    }
  }),
      IWatchMixin = mixin({
    addWatch: function addWatch(e, t) {
      return this._watches = this._watches || {}, !this._watches[e] && (this._watches[e] = t, !0);
    },
    removeWatch: function removeWatch(e) {
      if (this._watches) return !!this._watches[e] && (delete this._watches[e], !0);
    },
    notifyWatches: function notifyWatches(e, t) {
      if (this._watches) {
        var r = this._watches;

        for (var n in r) {
          r[n](n, e, t);
        }
      }
    }
  }),
      isArrayLike$1 = function isArrayLike$1(e) {
    return null != e && "function" != typeof e && void 0 !== e.length;
  },
      SET = "Set",
      es6_set = _collection(SET, function (e) {
    return function () {
      return e(this, arguments.length > 0 ? arguments[0] : void 0);
    };
  }, {
    add: function add(e) {
      return _collectionStrong.def(_validateCollection(this, SET), e = 0 === e ? 0 : e, e);
    }
  }, _collectionStrong);

  _typedArray("Float64", 8, function (e) {
    return function (t, r, n) {
      return e(this, t, r, n);
    };
  }), _typedArray("Int32", 4, function (e) {
    return function (t, r, n) {
      return e(this, t, r, n);
    };
  }), _typedArray("Int16", 2, function (e) {
    return function (t, r, n) {
      return e(this, t, r, n);
    };
  }), _typedArray("Uint16", 2, function (e) {
    return function (t, r, n) {
      return e(this, t, r, n);
    };
  }), _typedArray("Int8", 1, function (e) {
    return function (t, r, n) {
      return e(this, t, r, n);
    };
  }), _typedArray("Uint8", 1, function (e) {
    return function (t, r, n) {
      return e(this, t, r, n);
    };
  }, !0), _typedArray("Uint32", 4, function (e) {
    return function (t, r, n) {
      return e(this, t, r, n);
    };
  }), _typedArray("Float32", 4, function (e) {
    return function (t, r, n) {
      return e(this, t, r, n);
    };
  });

  var compare = function compare(e, t) {
    return e === t ? 0 : null == e ? null == t ? 0 : -1 : null == t ? null == e ? 0 : 1 : "function" == typeof e.compare ? e.compare(t) : "function" == typeof t.compare ? -t.compare(e) : e < t ? -1 : e > t ? 1 : 0;
  },
      OBJP = Object.getPrototypeOf({}),
      FN = "function",
      STR = "string",
      equiv = function equiv(e, t) {
    var r;
    return e === t || (null == e ? e == t : _typeof(e.equiv) === FN ? e.equiv(t) : null == t ? e == t : _typeof(t.equiv) === FN ? t.equiv(e) : _typeof(e) !== STR && _typeof(t) !== STR && (null != (r = Object.getPrototypeOf(e)) && r !== OBJP || null != (r = Object.getPrototypeOf(t)) && r !== OBJP ? _typeof(e) !== FN && void 0 !== e.length && _typeof(t) !== FN && void 0 !== t.length ? equivArrayLike(e, t) : e instanceof Set && t instanceof Set ? equivSet(e, t) : e instanceof Map && t instanceof Map ? equivMap(e, t) : e instanceof Date && t instanceof Date ? e.getTime() === t.getTime() : e instanceof RegExp && t instanceof RegExp ? e.toString() === t.toString() : e != e && t != t : equivObject(e, t)));
  },
      equivArrayLike = function equivArrayLike(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : equiv,
        n = e.length;
    if (n === t.length) for (; --n >= 0 && r(e[n], t[n]);) {
      ;
    }
    return n < 0;
  },
      equivSet = function equivSet(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : equiv;
    return e.size === t.size && r(_toConsumableArray(e.keys()).sort(), _toConsumableArray(t.keys()).sort());
  },
      equivMap = function equivMap(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : equiv;
    return e.size === t.size && r(_toConsumableArray(e).sort(), _toConsumableArray(t).sort());
  },
      equivObject = function equivObject(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : equiv;
    if (Object.keys(e).length !== Object.keys(t).length) return !1;

    for (var n in e) {
      if (!t.hasOwnProperty(n) || !r(e[n], t[n])) return !1;
    }

    return !0;
  },
      Reduced = function () {
    function e(t) {
      _classCallCheck(this, e), this.value = t;
    }

    return _createClass(e, [{
      key: "deref",
      value: function value() {
        return this.value;
      }
    }]), e;
  }(),
      isReduced = function isReduced(e) {
    return e instanceof Reduced;
  },
      unreduced = function unreduced(e) {
    return e instanceof Reduced ? e.deref() : e;
  },
      _marked2 = regenerator.mark(iterator1);

  function iterator1(e, t) {
    var r, n, o, i, s, a;
    return regenerator.wrap(function (u) {
      for (;;) {
        switch (u.prev = u.next) {
          case 0:
            r = e([NO_OP, NO_OP, function (e, t) {
              return t;
            }])[2], n = t, o = Array.isArray(n), i = 0, n = o ? n : n[Symbol.iterator]();

          case 2:
            if (!o) {
              u.next = 8;
              break;
            }

            if (!(i >= n.length)) {
              u.next = 5;
              break;
            }

            return u.abrupt("break", 25);

          case 5:
            s = n[i++], u.next = 12;
            break;

          case 8:
            if (!(i = n.next()).done) {
              u.next = 11;
              break;
            }

            return u.abrupt("break", 25);

          case 11:
            s = i.value;

          case 12:
            if (a = r(SEMAPHORE, s), !isReduced(a)) {
              u.next = 20;
              break;
            }

            if ((a = unreduced(a.deref())) === SEMAPHORE) {
              u.next = 19;
              break;
            }

            return u.next = 19, a;

          case 19:
            return u.abrupt("return");

          case 20:
            if (a === SEMAPHORE) {
              u.next = 23;
              break;
            }

            return u.next = 23, a;

          case 23:
            u.next = 2;
            break;

          case 25:
          case "end":
            return u.stop();
        }
      }
    }, _marked2);
  }

  var compR = function compR(e, t) {
    return [e[0], e[1], t];
  };

  function map(e, t) {
    return t ? iterator1(map(e), t) : function (t) {
      var r = t[2];
      return compR(t, function (t, n) {
        return r(t, e(n));
      });
    };
  }

  function partial(e) {
    for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
      r[n - 1] = arguments[n];
    }

    var o = r[0],
        i = r[1],
        s = r[2],
        a = r[3],
        u = r[4],
        l = r[5],
        c = r[6],
        p = r[7];

    switch (r.length) {
      case 1:
        return function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
            r[n] = arguments[n];
          }

          return e.apply(void 0, [o].concat(r));
        };

      case 2:
        return function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
            r[n] = arguments[n];
          }

          return e.apply(void 0, [o, i].concat(r));
        };

      case 3:
        return function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
            r[n] = arguments[n];
          }

          return e.apply(void 0, [o, i, s].concat(r));
        };

      case 4:
        return function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
            r[n] = arguments[n];
          }

          return e.apply(void 0, [o, i, s, a].concat(r));
        };

      case 5:
        return function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
            r[n] = arguments[n];
          }

          return e.apply(void 0, [o, i, s, a, u].concat(r));
        };

      case 6:
        return function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
            r[n] = arguments[n];
          }

          return e.apply(void 0, [o, i, s, a, u, l].concat(r));
        };

      case 7:
        return function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
            r[n] = arguments[n];
          }

          return e.apply(void 0, [o, i, s, a, u, l, c].concat(r));
        };

      case 8:
        return function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
            r[n] = arguments[n];
          }

          return e.apply(void 0, [o, i, s, a, u, l, c, p].concat(r));
        };

      default:
        illegalArgs();
    }
  }

  var foo = partial(function (e, t) {
    return e + t;
  }, "a"),
      INV_MAX = 1 / 4294967295,
      ARandom = function () {
    function e() {
      _classCallCheck(this, e);
    }

    return _createClass(e, [{
      key: "float",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
        return this.int() * INV_MAX * e;
      }
    }, {
      key: "norm",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
        return this.int() * INV_MAX * e * 2 - e;
      }
    }, {
      key: "minmax",
      value: function value(e, t) {
        return this.float() * (t - e) + e;
      }
    }, {
      key: "gaussian",
      value: function value() {
        for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 10, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -.5, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, n = 0, o = e; o-- > 0;) {
          n += this.float(r);
        }

        return n / e + t;
      }
    }]), e;
  }(),
      random = Math.random,
      SystemRandom = function (e) {
    function t() {
      return _classCallCheck(this, t), _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
    }

    return _inherits(t, ARandom), _createClass(t, [{
      key: "int",
      value: function value() {
        return 4294967295 * random() >>> 0;
      }
    }, {
      key: "float",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
        return random() * e;
      }
    }]), t;
  }(),
      SYSTEM = new SystemRandom(),
      DCons = function () {
    function e(t) {
      _classCallCheck(this, e), this._length = 0, t && this.into(t);
    }

    return _createClass(e, [{
      key: "copy",
      value: function value() {
        return new e(this);
      }
    }, {
      key: "empty",
      value: function value() {
        return new e();
      }
    }, {
      key: "clear",
      value: function value() {
        this.release();
      }
    }, {
      key: "release",
      value: function value() {
        for (var e, t = this.head; t;) {
          e = t.next, delete t.value, delete t.prev, delete t.next, t = e;
        }

        return delete this.head, delete this.tail, this._length = 0, !0;
      }
    }, {
      key: "compare",
      value: function value(e) {
        var t = this._length;
        if (t < e._length) return -1;
        if (t > e._length) return 1;
        if (0 === t) return 0;

        for (var r = this.head, n = e.head, o = 0; r && 0 == o;) {
          o = compare(r.value, n.value), r = r.next, n = n.next;
        }

        return o;
      }
    }, {
      key: "equiv",
      value: function value(t) {
        if ((t instanceof e || isArrayLike$1(t)) && this._length === t.length) {
          if (0 === this._length) return !0;
          var r = this.head,
              n = t,
              o = Array.isArray(n),
              i = 0;

          for (n = o ? n : n[Symbol.iterator]();;) {
            var s;

            if (o) {
              if (i >= n.length) break;
              s = n[i++];
            } else {
              if ((i = n.next()).done) break;
              s = i.value;
            }

            var a = s;
            if (!equiv(r.value, a)) return !1;
            r = r.next;
          }

          return !0;
        }

        return !1;
      }
    }, {
      key: Symbol.iterator,
      value: regenerator.mark(function e() {
        var t;
        return regenerator.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                t = this.head;

              case 1:
                if (!t) {
                  e.next = 7;
                  break;
                }

                return e.next = 4, t.value;

              case 4:
                t = t.next, e.next = 1;
                break;

              case 7:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })
    }, {
      key: "cycle",
      value: regenerator.mark(function e() {
        return regenerator.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.delegateYield(this, "t0", 2);

              case 2:
                e.next = 0;
                break;

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e, this);
      })
    }, {
      key: "$reduce",
      value: function value(e, t) {
        for (var r = this.head; r && !isReduced(t);) {
          t = e(t, r.value), r = r.next;
        }

        return t;
      }
    }, {
      key: "drop",
      value: function value() {
        var e = this.head;
        if (e) return this.head = e.next, this.head ? delete this.head.prev : delete this.tail, this._length--, e.value;
      }
    }, {
      key: "cons",
      value: function value(e) {
        var t = {
          value: e,
          next: this.head
        };
        return this.head ? this.head.prev = t : this.tail = t, this.head = t, this._length++, this;
      }
    }, {
      key: "insertBefore",
      value: function value(e, t) {
        e || illegalArgs("cell is undefined");
        var r = {
          value: t,
          next: e,
          prev: e.prev
        };
        return e.prev ? e.prev.next = r : this.head = r, e.prev = r, this._length++, this;
      }
    }, {
      key: "insertAfter",
      value: function value(e, t) {
        e || illegalArgs("cell is undefined");
        var r = {
          value: t,
          next: e.next,
          prev: e
        };
        return e.next ? e.next.prev = r : this.tail = r, e.next = r, this._length++, this;
      }
    }, {
      key: "insertBeforeNth",
      value: function value(e, t) {
        return e < 0 && (e += this._length), e <= 0 ? this.cons(t) : (this.ensureIndex(e), this.insertBefore(this.nthCellUnsafe(e), t));
      }
    }, {
      key: "insertAfterNth",
      value: function value(e, t) {
        return e < 0 && (e += this._length), e >= this._length - 1 ? this.push(t) : (this.ensureIndex(e), this.insertAfter(this.nthCellUnsafe(e), t));
      }
    }, {
      key: "insertSorted",
      value: function value(e, t) {
        t = t || compare;

        for (var r = this.head; r;) {
          if (t(e, r.value) <= 0) return this.insertBefore(r, e);
          r = r.next;
        }

        return this.push(e);
      }
    }, {
      key: "find",
      value: function value(e) {
        for (var t = this.head; t;) {
          if (t.value === e) return t;
          t = t.next;
        }
      }
    }, {
      key: "findWith",
      value: function value(e) {
        for (var t = this.head; t;) {
          if (e(t.value)) return t;
          t = t.next;
        }
      }
    }, {
      key: "concat",
      value: function value() {
        for (var e = this.copy(), t = arguments.length, r = new Array(t), n = 0; n < t; n++) {
          r[n] = arguments[n];
        }

        for (var o = 0, i = r; o < i.length; o++) {
          var s = i[o];
          e.into(s);
        }

        return e;
      }
    }, {
      key: "into",
      value: function value(e) {
        var t = e,
            r = Array.isArray(t),
            n = 0;

        for (t = r ? t : t[Symbol.iterator]();;) {
          var o;

          if (r) {
            if (n >= t.length) break;
            o = t[n++];
          } else {
            if ((n = t.next()).done) break;
            o = n.value;
          }

          var i = o;
          this.push(i);
        }
      }
    }, {
      key: "slice",
      value: function value() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.length,
            n = t < 0 ? t + this._length : t,
            o = r < 0 ? r + this._length : r;
        (n < 0 || o < 0) && illegalArgs("invalid indices: ${from} / ${to}");

        for (var i = new e(), s = this.nthCell(n); s && ++n <= o;) {
          i.push(s.value), s = s.next;
        }

        return i;
      }
    }, {
      key: "splice",
      value: function value(t) {
        var r,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            o = arguments.length > 2 ? arguments[2] : void 0;
        "number" == typeof t ? (t < 0 && (t += this._length), this.ensureIndex(t), r = this.nthCellUnsafe(t)) : r = t;
        var i = new e();
        if (n > 0) for (; r && n-- > 0;) {
          this.remove(r), i.push(r.value), r = r.next;
        } else r && (r = r.next);
        if (o) if (r) {
          var s = o,
              a = Array.isArray(s),
              u = 0;

          for (s = a ? s : s[Symbol.iterator]();;) {
            var l;

            if (a) {
              if (u >= s.length) break;
              l = s[u++];
            } else {
              if ((u = s.next()).done) break;
              l = u.value;
            }

            var c = l;
            this.insertBefore(r, c);
          }
        } else {
          var p = o,
              f = Array.isArray(p),
              d = 0;

          for (p = f ? p : p[Symbol.iterator]();;) {
            var g;

            if (f) {
              if (d >= p.length) break;
              g = p[d++];
            } else {
              if ((d = p.next()).done) break;
              g = d.value;
            }

            var h = g;
            this.push(h);
          }
        }
        return i;
      }
    }, {
      key: "remove",
      value: function value(e) {
        return e.prev ? e.prev.next = e.next : this.head = e.next, e.next ? e.next.prev = e.prev : this.tail = e.prev, this._length--, this;
      }
    }, {
      key: "swap",
      value: function value(e, t) {
        if (e !== t) {
          var r = e.value;
          e.value = t.value, t.value = r;
        }

        return this;
      }
    }, {
      key: "push",
      value: function value(e) {
        if (this.tail) {
          var t = {
            value: e,
            prev: this.tail
          };
          return this.tail.next = t, this.tail = t, this._length++, this;
        }

        return this.cons(e);
      }
    }, {
      key: "pop",
      value: function value() {
        var e = this.tail;
        if (e) return this.tail = e.prev, this.tail ? delete this.tail.next : delete this.head, this._length--, e.value;
      }
    }, {
      key: "first",
      value: function value() {
        return this.head && this.head.value;
      }
    }, {
      key: "peek",
      value: function value() {
        return this.tail && this.tail.value;
      }
    }, {
      key: "setHead",
      value: function value(e) {
        return this.head ? (this.head.value = e, this) : this.cons(e);
      }
    }, {
      key: "setTail",
      value: function value(e) {
        return this.tail ? (this.tail.value = e, this) : this.push(e);
      }
    }, {
      key: "setNth",
      value: function value(e, t) {
        var r = this.nthCell(e);
        return !r && illegalArgs("index out of bounds: ".concat(e)), r.value = t, this;
      }
    }, {
      key: "nth",
      value: function value(e, t) {
        var r = this.nthCell(e);
        return r ? r.value : t;
      }
    }, {
      key: "nthCell",
      value: function value(e) {
        if (e < 0 && (e += this._length), !(e < 0 || e >= this._length)) return this.nthCellUnsafe(e);
      }
    }, {
      key: "rotateLeft",
      value: function value() {
        switch (this._length) {
          case 0:
          case 1:
            return this;

          case 2:
            return this.swap(this.head, this.tail);

          default:
            return this.push(this.drop());
        }
      }
    }, {
      key: "rotateRight",
      value: function value() {
        switch (this._length) {
          case 0:
          case 1:
            return this;

          case 2:
            return this.swap(this.head, this.tail);

          default:
            var e = this.peek();
            return this.pop(), this.cons(e);
        }
      }
    }, {
      key: "map",
      value: function value(t) {
        for (var r = new e(), n = this.head; n;) {
          r.push(t(n.value)), n = n.next;
        }

        return r;
      }
    }, {
      key: "filter",
      value: function value(t) {
        for (var r = new e(), n = this.head; n;) {
          t(n.value) && r.push(n.value), n = n.next;
        }

        return r;
      }
    }, {
      key: "reduce",
      value: function value(e, t) {
        for (var r = t, n = this.head; n;) {
          r = e(r, n.value), n = n.next;
        }

        return r;
      }
    }, {
      key: "shuffle",
      value: function value() {
        for (var e = this._length, t = this.tail; e > 1;) {
          var r = Math.floor(Math.random() * e);
          this.swap(this.nthCell(r), t), t = t.prev, e--;
        }

        return this;
      }
    }, {
      key: "reverse",
      value: function value() {
        for (var e = this.head, t = this.tail, r = (this._length >>> 1) + (1 & this._length); e && t && r > 0;) {
          var n = e.value;
          e.value = t.value, t.value = n, e = e.next, t = t.prev, r--;
        }

        return this;
      }
    }, {
      key: "asHead",
      value: function value(e) {
        return e === this.head ? this : (this.remove(e), this.head.prev = e, e.next = this.head, e.prev = void 0, this.head = e, this._length++, this);
      }
    }, {
      key: "asTail",
      value: function value(e) {
        return e === this.tail ? this : (this.remove(e), this.tail.next = e, e.prev = this.tail, e.next = void 0, this.tail = e, this._length++, this);
      }
    }, {
      key: "toString",
      value: function value() {
        for (var e = [], t = this.head; t;) {
          e.push(null != t.value ? String(t.value) : void 0 === t.value ? "undefined" : "null"), t = t.next;
        }

        return e.join(", ");
      }
    }, {
      key: "toJSON",
      value: function value() {
        return _toConsumableArray(this);
      }
    }, {
      key: "ensureIndex",
      value: function value(e) {
        assert(e >= 0 && e < this._length, "index out of range: ".concat(e));
      }
    }, {
      key: "nthCellUnsafe",
      value: function value(e) {
        var t, r;

        for (e <= this._length >> 1 ? (t = this.head, r = "next") : (t = this.tail, r = "prev", e = this._length - e - 1); e-- > 0 && t;) {
          t = t[r];
        }

        return t;
      }
    }, {
      key: "length",
      get: function get() {
        return this._length;
      }
    }]), e;
  }(),
      LRUCache = function () {
    function e(t, r) {
      _classCallCheck(this, e);

      var n = Object.assign({
        maxlen: 1 / 0,
        maxsize: 1 / 0,
        map: function map() {
          return new Map();
        },
        ksize: function ksize() {
          return 0;
        },
        vsize: function vsize() {
          return 0;
        }
      }, r);
      this.map = n.map(), this.items = new DCons(), this._size = 0, this.opts = n, t && this.into(t);
    }

    return _createClass(e, [{
      key: Symbol.iterator,
      value: function value() {
        return this.entries();
      }
    }, {
      key: "entries",
      value: function value() {
        return map(function (e) {
          return [e.k, e];
        }, this.items);
      }
    }, {
      key: "keys",
      value: function value() {
        return map(function (e) {
          return e.k;
        }, this.items);
      }
    }, {
      key: "values",
      value: function value() {
        return map(function (e) {
          return e.v;
        }, this.items);
      }
    }, {
      key: "copy",
      value: function value() {
        var e = this.empty();
        e.items = this.items.copy();

        for (var t = e.items.head; t;) {
          e.map.set(t.value.k, t), t = t.next;
        }

        return e;
      }
    }, {
      key: "empty",
      value: function value() {
        return new e(null, this.opts);
      }
    }, {
      key: "release",
      value: function value() {
        this._size = 0, this.map.clear();
        var e = this.opts.release;

        if (e) {
          for (var t; t = this.items.drop();) {
            e(t.k, t.v);
          }

          return !0;
        }

        return this.items.release();
      }
    }, {
      key: "has",
      value: function value(e) {
        return this.map.has(e);
      }
    }, {
      key: "get",
      value: function value(e, t) {
        var r = this.map.get(e);
        return r ? this.resetEntry(r) : t;
      }
    }, {
      key: "set",
      value: function value(e, t) {
        var r = this.opts.ksize(e) + this.opts.vsize(t),
            n = this.map.get(e);
        return n && (this._size -= n.value.s), this._size += r, this.ensureSize() && (n ? (n.value.v = t, n.value.s = r, this.items.asTail(n)) : (this.items.push({
          k: e,
          v: t,
          s: r
        }), this.map.set(e, this.items.tail))), t;
      }
    }, {
      key: "into",
      value: function value(e) {
        var t = e,
            r = Array.isArray(t),
            n = 0;

        for (t = r ? t : t[Symbol.iterator]();;) {
          var o;

          if (r) {
            if (n >= t.length) break;
            o = t[n++];
          } else {
            if ((n = t.next()).done) break;
            o = n.value;
          }

          var i = o;
          this.set(i[0], i[1]);
        }

        return this;
      }
    }, {
      key: "getSet",
      value: function value(e, t) {
        var r = this,
            n = this.map.get(e);
        return n ? Promise.resolve(this.resetEntry(n)) : t().then(function (t) {
          return r.set(e, t);
        });
      }
    }, {
      key: "delete",
      value: function value(e) {
        var t = this.map.get(e);
        return !!t && (this.removeEntry(t), !0);
      }
    }, {
      key: "resetEntry",
      value: function value(e) {
        return this.items.asTail(e), e.value.v;
      }
    }, {
      key: "ensureSize",
      value: function value() {
        for (var e = this.opts.release, t = this.opts.maxsize, r = this.opts.maxlen; this._size > t || this.length >= r;) {
          var n = this.items.drop();
          if (!n) return !1;
          this.map.delete(n.k), e && e(n.k, n.v), this._size -= n.s;
        }

        return !0;
      }
    }, {
      key: "removeEntry",
      value: function value(e) {
        var t = e.value;
        this.map.delete(t.k), this.items.remove(e), this.opts.release && this.opts.release(t.k, t.v), this._size -= t.s;
      }
    }, {
      key: "length",
      get: function get() {
        return this.items.length;
      }
    }, {
      key: "size",
      get: function get() {
        return this._size;
      }
    }]), e;
  }(),
      TLRUCache = function (e) {
    function t(e, r) {
      return _classCallCheck(this, t), r = Object.assign({
        ttl: 36e5
      }, r), _possibleConstructorReturn(this, _getPrototypeOf(t).call(this, e, r));
    }

    return _inherits(t, LRUCache), _createClass(t, [{
      key: "empty",
      value: function value() {
        return new t(null, this.opts);
      }
    }, {
      key: "has",
      value: function value(e) {
        return void 0 !== this.get(e);
      }
    }, {
      key: "get",
      value: function value(e, t) {
        var r = this.map.get(e);

        if (r) {
          if (r.value.t >= Date.now()) return this.resetEntry(r);
          this.removeEntry(r);
        }

        return t;
      }
    }, {
      key: "set",
      value: function value(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.opts.ttl,
            n = this.opts.ksize(e) + this.opts.vsize(t),
            o = this.map.get(e);

        if (o && (this._size -= o.value.s), this._size += n, this.ensureSize()) {
          var i = Date.now() + r;
          o ? (o.value.v = t, o.value.s = n, o.value.t = i, this.items.asTail(o)) : (this.items.push({
            k: e,
            v: t,
            s: n,
            t: i
          }), this.map.set(e, this.items.tail));
        }

        return t;
      }
    }, {
      key: "getSet",
      value: function value(e, t) {
        var r = this,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.opts.ttl,
            o = this.get(e);
        return o ? Promise.resolve(o) : t().then(function (t) {
          return r.set(e, t, n);
        });
      }
    }, {
      key: "prune",
      value: function value() {
        for (var e = Date.now(), t = this.items.head; t;) {
          t.value.t < e && this.removeEntry(t), t = t.next;
        }
      }
    }, {
      key: "ensureSize",
      value: function value() {
        for (var e = this.opts.maxsize, r = this.opts.maxlen, n = Date.now(), o = this.items.head; o && (this._size > e || this.length >= r);) {
          o.value.t < n && this.removeEntry(o), o = o.next;
        }

        return _get(_getPrototypeOf(t.prototype), "ensureSize", this).call(this);
      }
    }]), t;
  }();

  function createBlob(e, t) {
    e = e || [], "string" == typeof (t = t || {}) && (t = {
      type: t
    });

    try {
      return new Blob(e, t);
    } catch (o) {
      if ("TypeError" !== o.name) throw o;

      for (var r = new ("undefined" != typeof BlobBuilder ? BlobBuilder : "undefined" != typeof MSBlobBuilder ? MSBlobBuilder : "undefined" != typeof MozBlobBuilder ? MozBlobBuilder : WebKitBlobBuilder)(), n = 0; n < e.length; n += 1) {
        r.append(e[n]);
      }

      return r.getBlob(t.type);
    }
  }

  function arrayBufferToBlob(e, t) {
    return createBlob([e], t);
  }

  function blobToArrayBuffer(e) {
    return new Promise(function (t, r) {
      var n = new FileReader();
      n.onloadend = function () {
        var e = n.result || new ArrayBuffer(0);
        t(e);
      }, n.onerror = r, n.readAsArrayBuffer(e);
    });
  }

  function arrayBufferToBinaryString(e) {
    for (var t = "", r = new Uint8Array(e), n = r.byteLength, o = -1; ++o < n;) {
      t += String.fromCharCode(r[o]);
    }

    return t;
  }

  function getType(e) {
    return Object.prototype.toString.call(e).slice(8, -1);
  }

  function isPlainObject$1(e) {
    return "Object" === getType(e) && e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
  }

  function isNil(e) {
    return null == e;
  }

  _fixReWks("match", 1, function (e, t, r, n) {
    return [function (r) {
      var n = e(this),
          o = null == r ? void 0 : r[t];
      return void 0 !== o ? o.call(r, n) : new RegExp(r)[t](String(n));
    }, function (e) {
      var t = n(r, e, this);
      if (t.done) return t.value;

      var o = _anObject(e),
          i = String(this);

      if (!o.global) return _regexpExecAbstract(o, i);
      var s = o.unicode;
      o.lastIndex = 0;

      for (var a, u = [], l = 0; null !== (a = _regexpExecAbstract(o, i));) {
        var c = String(a[0]);
        u[l] = c, "" === c && (o.lastIndex = _advanceStringIndex(i, _toLength(o.lastIndex), s)), l++;
      }

      return 0 === l ? null : u;
    }];
  });

  var isNil_1 = isNil,
      quot = /"/g,
      createHTML = function createHTML(e, t, r, n) {
    var o = String(_defined(e)),
        i = "<" + t;
    return "" !== r && (i += " " + r + '="' + String(n).replace(quot, "&quot;") + '"'), i + ">" + o + "</" + t + ">";
  },
      _stringHtml = function _stringHtml(e, t) {
    var r = {};
    r[e] = t(createHTML), _export(_export.P + _export.F * _fails(function () {
      var t = ""[e]('"');
      return t !== t.toLowerCase() || t.split('"').length > 3;
    }), "String", r);
  };

  _stringHtml("sub", function (e) {
    return function () {
      return e(this, "sub", "", "");
    };
  });

  var long_1 = Long,
      wasm = null;

  try {
    wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11])), {}).exports;
  } catch (e) {}

  function Long(e, t, r) {
    this.low = 0 | e, this.high = 0 | t, this.unsigned = !!r;
  }

  function isLong(e) {
    return !0 === (e && e.__isLong__);
  }

  Long.prototype.__isLong__, Object.defineProperty(Long.prototype, "__isLong__", {
    value: !0
  }), Long.isLong = isLong;
  var INT_CACHE = {},
      UINT_CACHE = {};

  function fromInt(e, t) {
    var r, n, o;
    return t ? (o = 0 <= (e >>>= 0) && e < 256) && (n = UINT_CACHE[e]) ? n : (r = fromBits(e, (0 | e) < 0 ? -1 : 0, !0), o && (UINT_CACHE[e] = r), r) : (o = -128 <= (e |= 0) && e < 128) && (n = INT_CACHE[e]) ? n : (r = fromBits(e, e < 0 ? -1 : 0, !1), o && (INT_CACHE[e] = r), r);
  }

  function fromNumber(e, t) {
    if (isNaN(e)) return t ? UZERO : ZERO;

    if (t) {
      if (e < 0) return UZERO;
      if (e >= TWO_PWR_64_DBL) return MAX_UNSIGNED_VALUE;
    } else {
      if (e <= -TWO_PWR_63_DBL) return MIN_VALUE;
      if (e + 1 >= TWO_PWR_63_DBL) return MAX_VALUE;
    }

    return e < 0 ? fromNumber(-e, t).neg() : fromBits(e % TWO_PWR_32_DBL | 0, e / TWO_PWR_32_DBL | 0, t);
  }

  function fromBits(e, t, r) {
    return new Long(e, t, r);
  }

  Long.fromInt = fromInt, Long.fromNumber = fromNumber, Long.fromBits = fromBits;
  var pow_dbl = Math.pow;

  function fromString(e, t, r) {
    if (0 === e.length) throw Error("empty string");
    if ("NaN" === e || "Infinity" === e || "+Infinity" === e || "-Infinity" === e) return ZERO;
    if ("number" == typeof t ? (r = t, t = !1) : t = !!t, (r = r || 10) < 2 || 36 < r) throw RangeError("radix");
    var n;
    if ((n = e.indexOf("-")) > 0) throw Error("interior hyphen");
    if (0 === n) return fromString(e.substring(1), t, r).neg();

    for (var o = fromNumber(pow_dbl(r, 8)), i = ZERO, s = 0; s < e.length; s += 8) {
      var a = Math.min(8, e.length - s),
          u = parseInt(e.substring(s, s + a), r);

      if (a < 8) {
        var l = fromNumber(pow_dbl(r, a));
        i = i.mul(l).add(fromNumber(u));
      } else i = (i = i.mul(o)).add(fromNumber(u));
    }

    return i.unsigned = t, i;
  }

  function fromValue(e, t) {
    return "number" == typeof e ? fromNumber(e, t) : "string" == typeof e ? fromString(e, t) : fromBits(e.low, e.high, "boolean" == typeof t ? t : e.unsigned);
  }

  Long.fromString = fromString, Long.fromValue = fromValue;
  var TWO_PWR_16_DBL = 65536,
      TWO_PWR_24_DBL = 1 << 24,
      TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL,
      TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL,
      TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2,
      TWO_PWR_24 = fromInt(TWO_PWR_24_DBL),
      ZERO = fromInt(0);
  Long.ZERO = ZERO;
  var UZERO = fromInt(0, !0);
  Long.UZERO = UZERO;
  var ONE = fromInt(1);
  Long.ONE = ONE;
  var UONE = fromInt(1, !0);
  Long.UONE = UONE;
  var NEG_ONE = fromInt(-1);
  Long.NEG_ONE = NEG_ONE;
  var MAX_VALUE = fromBits(-1, 2147483647, !1);
  Long.MAX_VALUE = MAX_VALUE;
  var MAX_UNSIGNED_VALUE = fromBits(-1, -1, !0);
  Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
  var MIN_VALUE = fromBits(0, -2147483648, !1);
  Long.MIN_VALUE = MIN_VALUE;
  var LongPrototype = Long.prototype;
  LongPrototype.toInt = function () {
    return this.unsigned ? this.low >>> 0 : this.low;
  }, LongPrototype.toNumber = function () {
    return this.unsigned ? (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0) : this.high * TWO_PWR_32_DBL + (this.low >>> 0);
  }, LongPrototype.toString = function (e) {
    if ((e = e || 10) < 2 || 36 < e) throw RangeError("radix");
    if (this.isZero()) return "0";

    if (this.isNegative()) {
      if (this.eq(MIN_VALUE)) {
        var t = fromNumber(e),
            r = this.div(t),
            n = r.mul(t).sub(this);
        return r.toString(e) + n.toInt().toString(e);
      }

      return "-" + this.neg().toString(e);
    }

    for (var o = fromNumber(pow_dbl(e, 6), this.unsigned), i = this, s = "";;) {
      var a = i.div(o),
          u = (i.sub(a.mul(o)).toInt() >>> 0).toString(e);
      if ((i = a).isZero()) return u + s;

      for (; u.length < 6;) {
        u = "0" + u;
      }

      s = "" + u + s;
    }
  }, LongPrototype.getHighBits = function () {
    return this.high;
  }, LongPrototype.getHighBitsUnsigned = function () {
    return this.high >>> 0;
  }, LongPrototype.getLowBits = function () {
    return this.low;
  }, LongPrototype.getLowBitsUnsigned = function () {
    return this.low >>> 0;
  }, LongPrototype.getNumBitsAbs = function () {
    if (this.isNegative()) return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();

    for (var e = 0 != this.high ? this.high : this.low, t = 31; t > 0 && 0 == (e & 1 << t); t--) {
      ;
    }

    return 0 != this.high ? t + 33 : t + 1;
  }, LongPrototype.isZero = function () {
    return 0 === this.high && 0 === this.low;
  }, LongPrototype.eqz = LongPrototype.isZero, LongPrototype.isNegative = function () {
    return !this.unsigned && this.high < 0;
  }, LongPrototype.isPositive = function () {
    return this.unsigned || this.high >= 0;
  }, LongPrototype.isOdd = function () {
    return 1 == (1 & this.low);
  }, LongPrototype.isEven = function () {
    return 0 == (1 & this.low);
  }, LongPrototype.equals = function (e) {
    return isLong(e) || (e = fromValue(e)), (this.unsigned === e.unsigned || this.high >>> 31 != 1 || e.high >>> 31 != 1) && this.high === e.high && this.low === e.low;
  }, LongPrototype.eq = LongPrototype.equals, LongPrototype.notEquals = function (e) {
    return !this.eq(e);
  }, LongPrototype.neq = LongPrototype.notEquals, LongPrototype.ne = LongPrototype.notEquals, LongPrototype.lessThan = function (e) {
    return this.comp(e) < 0;
  }, LongPrototype.lt = LongPrototype.lessThan, LongPrototype.lessThanOrEqual = function (e) {
    return this.comp(e) <= 0;
  }, LongPrototype.lte = LongPrototype.lessThanOrEqual, LongPrototype.le = LongPrototype.lessThanOrEqual, LongPrototype.greaterThan = function (e) {
    return this.comp(e) > 0;
  }, LongPrototype.gt = LongPrototype.greaterThan, LongPrototype.greaterThanOrEqual = function (e) {
    return this.comp(e) >= 0;
  }, LongPrototype.gte = LongPrototype.greaterThanOrEqual, LongPrototype.ge = LongPrototype.greaterThanOrEqual, LongPrototype.compare = function (e) {
    if (isLong(e) || (e = fromValue(e)), this.eq(e)) return 0;
    var t = this.isNegative(),
        r = e.isNegative();
    return t && !r ? -1 : !t && r ? 1 : this.unsigned ? e.high >>> 0 > this.high >>> 0 || e.high === this.high && e.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(e).isNegative() ? -1 : 1;
  }, LongPrototype.comp = LongPrototype.compare, LongPrototype.negate = function () {
    return !this.unsigned && this.eq(MIN_VALUE) ? MIN_VALUE : this.not().add(ONE);
  }, LongPrototype.neg = LongPrototype.negate, LongPrototype.add = function (e) {
    isLong(e) || (e = fromValue(e));
    var t = this.high >>> 16,
        r = 65535 & this.high,
        n = this.low >>> 16,
        o = 65535 & this.low,
        i = e.high >>> 16,
        s = 65535 & e.high,
        a = e.low >>> 16,
        u = 0,
        l = 0,
        c = 0,
        p = 0;
    return c += (p += o + (65535 & e.low)) >>> 16, l += (c += n + a) >>> 16, u += (l += r + s) >>> 16, u += t + i, fromBits((c &= 65535) << 16 | (p &= 65535), (u &= 65535) << 16 | (l &= 65535), this.unsigned);
  }, LongPrototype.subtract = function (e) {
    return isLong(e) || (e = fromValue(e)), this.add(e.neg());
  }, LongPrototype.sub = LongPrototype.subtract, LongPrototype.multiply = function (e) {
    if (this.isZero()) return ZERO;
    if (isLong(e) || (e = fromValue(e)), wasm) return fromBits(wasm.mul(this.low, this.high, e.low, e.high), wasm.get_high(), this.unsigned);
    if (e.isZero()) return ZERO;
    if (this.eq(MIN_VALUE)) return e.isOdd() ? MIN_VALUE : ZERO;
    if (e.eq(MIN_VALUE)) return this.isOdd() ? MIN_VALUE : ZERO;
    if (this.isNegative()) return e.isNegative() ? this.neg().mul(e.neg()) : this.neg().mul(e).neg();
    if (e.isNegative()) return this.mul(e.neg()).neg();
    if (this.lt(TWO_PWR_24) && e.lt(TWO_PWR_24)) return fromNumber(this.toNumber() * e.toNumber(), this.unsigned);
    var t = this.high >>> 16,
        r = 65535 & this.high,
        n = this.low >>> 16,
        o = 65535 & this.low,
        i = e.high >>> 16,
        s = 65535 & e.high,
        a = e.low >>> 16,
        u = 65535 & e.low,
        l = 0,
        c = 0,
        p = 0,
        f = 0;
    return p += (f += o * u) >>> 16, c += (p += n * u) >>> 16, p &= 65535, c += (p += o * a) >>> 16, l += (c += r * u) >>> 16, c &= 65535, l += (c += n * a) >>> 16, c &= 65535, l += (c += o * s) >>> 16, l += t * u + r * a + n * s + o * i, fromBits((p &= 65535) << 16 | (f &= 65535), (l &= 65535) << 16 | (c &= 65535), this.unsigned);
  }, LongPrototype.mul = LongPrototype.multiply, LongPrototype.divide = function (e) {
    if (isLong(e) || (e = fromValue(e)), e.isZero()) throw Error("division by zero");
    var t, r, n;
    if (wasm) return this.unsigned || -2147483648 !== this.high || -1 !== e.low || -1 !== e.high ? fromBits((this.unsigned ? wasm.div_u : wasm.div_s)(this.low, this.high, e.low, e.high), wasm.get_high(), this.unsigned) : this;
    if (this.isZero()) return this.unsigned ? UZERO : ZERO;

    if (this.unsigned) {
      if (e.unsigned || (e = e.toUnsigned()), e.gt(this)) return UZERO;
      if (e.gt(this.shru(1))) return UONE;
      n = UZERO;
    } else {
      if (this.eq(MIN_VALUE)) return e.eq(ONE) || e.eq(NEG_ONE) ? MIN_VALUE : e.eq(MIN_VALUE) ? ONE : (t = this.shr(1).div(e).shl(1)).eq(ZERO) ? e.isNegative() ? ONE : NEG_ONE : (r = this.sub(e.mul(t)), n = t.add(r.div(e)));
      if (e.eq(MIN_VALUE)) return this.unsigned ? UZERO : ZERO;
      if (this.isNegative()) return e.isNegative() ? this.neg().div(e.neg()) : this.neg().div(e).neg();
      if (e.isNegative()) return this.div(e.neg()).neg();
      n = ZERO;
    }

    for (r = this; r.gte(e);) {
      t = Math.max(1, Math.floor(r.toNumber() / e.toNumber()));

      for (var o = Math.ceil(Math.log(t) / Math.LN2), i = o <= 48 ? 1 : pow_dbl(2, o - 48), s = fromNumber(t), a = s.mul(e); a.isNegative() || a.gt(r);) {
        a = (s = fromNumber(t -= i, this.unsigned)).mul(e);
      }

      s.isZero() && (s = ONE), n = n.add(s), r = r.sub(a);
    }

    return n;
  }, LongPrototype.div = LongPrototype.divide, LongPrototype.modulo = function (e) {
    return isLong(e) || (e = fromValue(e)), wasm ? fromBits((this.unsigned ? wasm.rem_u : wasm.rem_s)(this.low, this.high, e.low, e.high), wasm.get_high(), this.unsigned) : this.sub(this.div(e).mul(e));
  }, LongPrototype.mod = LongPrototype.modulo, LongPrototype.rem = LongPrototype.modulo, LongPrototype.not = function () {
    return fromBits(~this.low, ~this.high, this.unsigned);
  }, LongPrototype.and = function (e) {
    return isLong(e) || (e = fromValue(e)), fromBits(this.low & e.low, this.high & e.high, this.unsigned);
  }, LongPrototype.or = function (e) {
    return isLong(e) || (e = fromValue(e)), fromBits(this.low | e.low, this.high | e.high, this.unsigned);
  }, LongPrototype.xor = function (e) {
    return isLong(e) || (e = fromValue(e)), fromBits(this.low ^ e.low, this.high ^ e.high, this.unsigned);
  }, LongPrototype.shiftLeft = function (e) {
    return isLong(e) && (e = e.toInt()), 0 == (e &= 63) ? this : e < 32 ? fromBits(this.low << e, this.high << e | this.low >>> 32 - e, this.unsigned) : fromBits(0, this.low << e - 32, this.unsigned);
  }, LongPrototype.shl = LongPrototype.shiftLeft, LongPrototype.shiftRight = function (e) {
    return isLong(e) && (e = e.toInt()), 0 == (e &= 63) ? this : e < 32 ? fromBits(this.low >>> e | this.high << 32 - e, this.high >> e, this.unsigned) : fromBits(this.high >> e - 32, this.high >= 0 ? 0 : -1, this.unsigned);
  }, LongPrototype.shr = LongPrototype.shiftRight, LongPrototype.shiftRightUnsigned = function (e) {
    if (isLong(e) && (e = e.toInt()), 0 === (e &= 63)) return this;
    var t = this.high;
    return e < 32 ? fromBits(this.low >>> e | t << 32 - e, t >>> e, this.unsigned) : fromBits(32 === e ? t : t >>> e - 32, 0, this.unsigned);
  }, LongPrototype.shru = LongPrototype.shiftRightUnsigned, LongPrototype.shr_u = LongPrototype.shiftRightUnsigned, LongPrototype.toSigned = function () {
    return this.unsigned ? fromBits(this.low, this.high, !1) : this;
  }, LongPrototype.toUnsigned = function () {
    return this.unsigned ? this : fromBits(this.low, this.high, !0);
  }, LongPrototype.toBytes = function (e) {
    return e ? this.toBytesLE() : this.toBytesBE();
  }, LongPrototype.toBytesLE = function () {
    var e = this.high,
        t = this.low;
    return [255 & t, t >>> 8 & 255, t >>> 16 & 255, t >>> 24, 255 & e, e >>> 8 & 255, e >>> 16 & 255, e >>> 24];
  }, LongPrototype.toBytesBE = function () {
    var e = this.high,
        t = this.low;
    return [e >>> 24, e >>> 16 & 255, e >>> 8 & 255, 255 & e, t >>> 24, t >>> 16 & 255, t >>> 8 & 255, 255 & t];
  }, Long.fromBytes = function (e, t, r) {
    return r ? Long.fromBytesLE(e, t) : Long.fromBytesBE(e, t);
  }, Long.fromBytesLE = function (e, t) {
    return new Long(e[0] | e[1] << 8 | e[2] << 16 | e[3] << 24, e[4] | e[5] << 8 | e[6] << 16 | e[7] << 24, t);
  }, Long.fromBytesBE = function (e, t) {
    return new Long(e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7], e[0] << 24 | e[1] << 16 | e[2] << 8 | e[3], t);
  };

  var _extendStatics2 = function _extendStatics(e, t) {
    return (_extendStatics2 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var r in t) {
        t.hasOwnProperty(r) && (e[r] = t[r]);
      }
    })(e, t);
  };

  function __extends(e, t) {
    function r() {
      this.constructor = e;
    }

    _extendStatics2(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
  }

  function isFunction$1(e) {
    return "function" == typeof e;
  }

  var _enable_super_gross_mode_that_will_cause_bad_things = !1,
      config = {
    Promise: void 0,

    set useDeprecatedSynchronousErrorHandling(e) {
      e && new Error().stack;
      _enable_super_gross_mode_that_will_cause_bad_things = e;
    },

    get useDeprecatedSynchronousErrorHandling() {
      return _enable_super_gross_mode_that_will_cause_bad_things;
    }

  };

  function hostReportError(e) {
    setTimeout(function () {
      throw e;
    }, 0);
  }

  var empty$1 = {
    closed: !0,
    next: function next(e) {},
    error: function error(e) {
      if (config.useDeprecatedSynchronousErrorHandling) throw e;
      hostReportError(e);
    },
    complete: function complete() {}
  },
      isArray$1 = Array.isArray || function (e) {
    return e && "number" == typeof e.length;
  };

  function isObject$1(e) {
    return null !== e && "object" === _typeof(e);
  }

  function UnsubscriptionErrorImpl(e) {
    return Error.call(this), this.message = e ? e.length + " errors occurred during unsubscription:\n" + e.map(function (e, t) {
      return t + 1 + ") " + e.toString();
    }).join("\n  ") : "", this.name = "UnsubscriptionError", this.errors = e, this;
  }

  UnsubscriptionErrorImpl.prototype = Object.create(Error.prototype);

  var UnsubscriptionError = UnsubscriptionErrorImpl,
      Subscription = function () {
    function e(e) {
      this.closed = !1, this._parentOrParents = null, this._subscriptions = null, e && (this._unsubscribe = e);
    }

    var t;
    return e.prototype.unsubscribe = function () {
      var t;

      if (!this.closed) {
        var r = this._parentOrParents,
            n = this._unsubscribe,
            o = this._subscriptions;
        if (this.closed = !0, this._parentOrParents = null, this._subscriptions = null, r instanceof e) r.remove(this);else if (null !== r) for (var i = 0; i < r.length; ++i) {
          r[i].remove(this);
        }
        if (isFunction$1(n)) try {
          n.call(this);
        } catch (e) {
          t = e instanceof UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
        }

        if (isArray$1(o)) {
          i = -1;

          for (var s = o.length; ++i < s;) {
            var a = o[i];
            if (isObject$1(a)) try {
              a.unsubscribe();
            } catch (e) {
              t = t || [], e instanceof UnsubscriptionError ? t = t.concat(flattenUnsubscriptionErrors(e.errors)) : t.push(e);
            }
          }
        }

        if (t) throw new UnsubscriptionError(t);
      }
    }, e.prototype.add = function (t) {
      var r = t;
      if (!t) return e.EMPTY;

      switch (_typeof(t)) {
        case "function":
          r = new e(t);

        case "object":
          if (r === this || r.closed || "function" != typeof r.unsubscribe) return r;
          if (this.closed) return r.unsubscribe(), r;

          if (!(r instanceof e)) {
            var n = r;
            (r = new e())._subscriptions = [n];
          }

          break;

        default:
          throw new Error("unrecognized teardown " + t + " added to Subscription.");
      }

      var o = r._parentOrParents;
      if (null === o) r._parentOrParents = this;else if (o instanceof e) {
        if (o === this) return r;
        r._parentOrParents = [o, this];
      } else {
        if (-1 !== o.indexOf(this)) return r;
        o.push(this);
      }
      var i = this._subscriptions;
      return null === i ? this._subscriptions = [r] : i.push(r), r;
    }, e.prototype.remove = function (e) {
      var t = this._subscriptions;

      if (t) {
        var r = t.indexOf(e);
        -1 !== r && t.splice(r, 1);
      }
    }, e.EMPTY = ((t = new e()).closed = !0, t), e;
  }();

  function flattenUnsubscriptionErrors(e) {
    return e.reduce(function (e, t) {
      return e.concat(t instanceof UnsubscriptionError ? t.errors : t);
    }, []);
  }

  var rxSubscriber = "function" == typeof Symbol ? Symbol("rxSubscriber") : "@@rxSubscriber_" + Math.random(),
      Subscriber = function (e) {
    function t(r, n, o) {
      var i = e.call(this) || this;

      switch (i.syncErrorValue = null, i.syncErrorThrown = !1, i.syncErrorThrowable = !1, i.isStopped = !1, arguments.length) {
        case 0:
          i.destination = empty$1;
          break;

        case 1:
          if (!r) {
            i.destination = empty$1;
            break;
          }

          if ("object" === _typeof(r)) {
            r instanceof t ? (i.syncErrorThrowable = r.syncErrorThrowable, i.destination = r, r.add(i)) : (i.syncErrorThrowable = !0, i.destination = new SafeSubscriber(i, r));
            break;
          }

        default:
          i.syncErrorThrowable = !0, i.destination = new SafeSubscriber(i, r, n, o);
      }

      return i;
    }

    return __extends(t, e), t.prototype[rxSubscriber] = function () {
      return this;
    }, t.create = function (e, r, n) {
      var o = new t(e, r, n);
      return o.syncErrorThrowable = !1, o;
    }, t.prototype.next = function (e) {
      this.isStopped || this._next(e);
    }, t.prototype.error = function (e) {
      this.isStopped || (this.isStopped = !0, this._error(e));
    }, t.prototype.complete = function () {
      this.isStopped || (this.isStopped = !0, this._complete());
    }, t.prototype.unsubscribe = function () {
      this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this));
    }, t.prototype._next = function (e) {
      this.destination.next(e);
    }, t.prototype._error = function (e) {
      this.destination.error(e), this.unsubscribe();
    }, t.prototype._complete = function () {
      this.destination.complete(), this.unsubscribe();
    }, t.prototype._unsubscribeAndRecycle = function () {
      var e = this._parentOrParents;
      return this._parentOrParents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parentOrParents = e, this;
    }, t;
  }(Subscription),
      SafeSubscriber = function (e) {
    function t(t, r, n, o) {
      var i,
          s = e.call(this) || this;
      s._parentSubscriber = t;
      var a = s;
      return isFunction$1(r) ? i = r : r && (i = r.next, n = r.error, o = r.complete, r !== empty$1 && (isFunction$1((a = Object.create(r)).unsubscribe) && s.add(a.unsubscribe.bind(a)), a.unsubscribe = s.unsubscribe.bind(s))), s._context = a, s._next = i, s._error = n, s._complete = o, s;
    }

    return __extends(t, e), t.prototype.next = function (e) {
      if (!this.isStopped && this._next) {
        var t = this._parentSubscriber;
        config.useDeprecatedSynchronousErrorHandling && t.syncErrorThrowable ? this.__tryOrSetError(t, this._next, e) && this.unsubscribe() : this.__tryOrUnsub(this._next, e);
      }
    }, t.prototype.error = function (e) {
      if (!this.isStopped) {
        var t = this._parentSubscriber,
            r = config.useDeprecatedSynchronousErrorHandling;
        if (this._error) r && t.syncErrorThrowable ? (this.__tryOrSetError(t, this._error, e), this.unsubscribe()) : (this.__tryOrUnsub(this._error, e), this.unsubscribe());else if (t.syncErrorThrowable) r ? (t.syncErrorValue = e, t.syncErrorThrown = !0) : hostReportError(e), this.unsubscribe();else {
          if (this.unsubscribe(), r) throw e;
          hostReportError(e);
        }
      }
    }, t.prototype.complete = function () {
      var e = this;

      if (!this.isStopped) {
        var t = this._parentSubscriber;

        if (this._complete) {
          var r = function r() {
            return e._complete.call(e._context);
          };

          config.useDeprecatedSynchronousErrorHandling && t.syncErrorThrowable ? (this.__tryOrSetError(t, r), this.unsubscribe()) : (this.__tryOrUnsub(r), this.unsubscribe());
        } else this.unsubscribe();
      }
    }, t.prototype.__tryOrUnsub = function (e, t) {
      try {
        e.call(this._context, t);
      } catch (e) {
        if (this.unsubscribe(), config.useDeprecatedSynchronousErrorHandling) throw e;
        hostReportError(e);
      }
    }, t.prototype.__tryOrSetError = function (e, t, r) {
      if (!config.useDeprecatedSynchronousErrorHandling) throw new Error("bad call");

      try {
        t.call(this._context, r);
      } catch (t) {
        return config.useDeprecatedSynchronousErrorHandling ? (e.syncErrorValue = t, e.syncErrorThrown = !0, !0) : (hostReportError(t), !0);
      }

      return !1;
    }, t.prototype._unsubscribe = function () {
      var e = this._parentSubscriber;
      this._context = null, this._parentSubscriber = null, e.unsubscribe();
    }, t;
  }(Subscriber);

  function canReportError(e) {
    for (; e;) {
      var t = e,
          r = t.closed,
          n = t.destination,
          o = t.isStopped;
      if (r || o) return !1;
      e = n && n instanceof Subscriber ? n : null;
    }

    return !0;
  }

  function toSubscriber(e, t, r) {
    if (e) {
      if (e instanceof Subscriber) return e;
      if (e[rxSubscriber]) return e[rxSubscriber]();
    }

    return e || t || r ? new Subscriber(e, t, r) : new Subscriber(empty$1);
  }

  var observable = "function" == typeof Symbol && Symbol.observable || "@@observable";

  function noop$1() {}

  function pipe() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    return pipeFromArray(e);
  }

  function pipeFromArray(e) {
    return e ? 1 === e.length ? e[0] : function (t) {
      return e.reduce(function (e, t) {
        return t(e);
      }, t);
    } : noop$1;
  }

  var Observable = function () {
    function e(e) {
      this._isScalar = !1, e && (this._subscribe = e);
    }

    return e.prototype.lift = function (t) {
      var r = new e();
      return r.source = this, r.operator = t, r;
    }, e.prototype.subscribe = function (e, t, r) {
      var n = this.operator,
          o = toSubscriber(e, t, r);
      if (n ? o.add(n.call(o, this.source)) : o.add(this.source || config.useDeprecatedSynchronousErrorHandling && !o.syncErrorThrowable ? this._subscribe(o) : this._trySubscribe(o)), config.useDeprecatedSynchronousErrorHandling && o.syncErrorThrowable && (o.syncErrorThrowable = !1, o.syncErrorThrown)) throw o.syncErrorValue;
      return o;
    }, e.prototype._trySubscribe = function (e) {
      try {
        return this._subscribe(e);
      } catch (t) {
        config.useDeprecatedSynchronousErrorHandling && (e.syncErrorThrown = !0, e.syncErrorValue = t), canReportError(e) ? e.error(t) : console.warn(t);
      }
    }, e.prototype.forEach = function (e, t) {
      var r = this;
      return new (t = getPromiseCtor(t))(function (t, n) {
        var o;
        o = r.subscribe(function (t) {
          try {
            e(t);
          } catch (e) {
            n(e), o && o.unsubscribe();
          }
        }, n, t);
      });
    }, e.prototype._subscribe = function (e) {
      var t = this.source;
      return t && t.subscribe(e);
    }, e.prototype[observable] = function () {
      return this;
    }, e.prototype.pipe = function () {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }

      return 0 === e.length ? this : pipeFromArray(e)(this);
    }, e.prototype.toPromise = function (e) {
      var t = this;
      return new (e = getPromiseCtor(e))(function (e, r) {
        var n;
        t.subscribe(function (e) {
          return n = e;
        }, function (e) {
          return r(e);
        }, function () {
          return e(n);
        });
      });
    }, e.create = function (t) {
      return new e(t);
    }, e;
  }();

  function getPromiseCtor(e) {
    if (e || (e = config.Promise || Promise), !e) throw new Error("no Promise impl found");
    return e;
  }

  function ObjectUnsubscribedErrorImpl() {
    return Error.call(this), this.message = "object unsubscribed", this.name = "ObjectUnsubscribedError", this;
  }

  ObjectUnsubscribedErrorImpl.prototype = Object.create(Error.prototype);

  var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl,
      SubjectSubscription = function (e) {
    function t(t, r) {
      var n = e.call(this) || this;
      return n.subject = t, n.subscriber = r, n.closed = !1, n;
    }

    return __extends(t, e), t.prototype.unsubscribe = function () {
      if (!this.closed) {
        this.closed = !0;
        var e = this.subject,
            t = e.observers;

        if (this.subject = null, t && 0 !== t.length && !e.isStopped && !e.closed) {
          var r = t.indexOf(this.subscriber);
          -1 !== r && t.splice(r, 1);
        }
      }
    }, t;
  }(Subscription),
      SubjectSubscriber = function (e) {
    function t(t) {
      var r = e.call(this, t) || this;
      return r.destination = t, r;
    }

    return __extends(t, e), t;
  }(Subscriber),
      Subject = function (e) {
    function t() {
      var t = e.call(this) || this;
      return t.observers = [], t.closed = !1, t.isStopped = !1, t.hasError = !1, t.thrownError = null, t;
    }

    return __extends(t, e), t.prototype[rxSubscriber] = function () {
      return new SubjectSubscriber(this);
    }, t.prototype.lift = function (e) {
      var t = new AnonymousSubject(this, this);
      return t.operator = e, t;
    }, t.prototype.next = function (e) {
      if (this.closed) throw new ObjectUnsubscribedError();
      if (!this.isStopped) for (var t = this.observers, r = t.length, n = t.slice(), o = 0; o < r; o++) {
        n[o].next(e);
      }
    }, t.prototype.error = function (e) {
      if (this.closed) throw new ObjectUnsubscribedError();
      this.hasError = !0, this.thrownError = e, this.isStopped = !0;

      for (var t = this.observers, r = t.length, n = t.slice(), o = 0; o < r; o++) {
        n[o].error(e);
      }

      this.observers.length = 0;
    }, t.prototype.complete = function () {
      if (this.closed) throw new ObjectUnsubscribedError();
      this.isStopped = !0;

      for (var e = this.observers, t = e.length, r = e.slice(), n = 0; n < t; n++) {
        r[n].complete();
      }

      this.observers.length = 0;
    }, t.prototype.unsubscribe = function () {
      this.isStopped = !0, this.closed = !0, this.observers = null;
    }, t.prototype._trySubscribe = function (t) {
      if (this.closed) throw new ObjectUnsubscribedError();
      return e.prototype._trySubscribe.call(this, t);
    }, t.prototype._subscribe = function (e) {
      if (this.closed) throw new ObjectUnsubscribedError();
      return this.hasError ? (e.error(this.thrownError), Subscription.EMPTY) : this.isStopped ? (e.complete(), Subscription.EMPTY) : (this.observers.push(e), new SubjectSubscription(this, e));
    }, t.prototype.asObservable = function () {
      var e = new Observable();
      return e.source = this, e;
    }, t.create = function (e, t) {
      return new AnonymousSubject(e, t);
    }, t;
  }(Observable),
      AnonymousSubject = function (e) {
    function t(t, r) {
      var n = e.call(this) || this;
      return n.destination = t, n.source = r, n;
    }

    return __extends(t, e), t.prototype.next = function (e) {
      var t = this.destination;
      t && t.next && t.next(e);
    }, t.prototype.error = function (e) {
      var t = this.destination;
      t && t.error && this.destination.error(e);
    }, t.prototype.complete = function () {
      var e = this.destination;
      e && e.complete && this.destination.complete();
    }, t.prototype._subscribe = function (e) {
      return this.source ? this.source.subscribe(e) : Subscription.EMPTY;
    }, t;
  }(Subject);

  function refCount() {
    return function (e) {
      return e.lift(new RefCountOperator(e));
    };
  }

  var RefCountOperator = function () {
    function e(e) {
      this.connectable = e;
    }

    return e.prototype.call = function (e, t) {
      var r = this.connectable;
      r._refCount++;
      var n = new RefCountSubscriber(e, r),
          o = t.subscribe(n);
      return n.closed || (n.connection = r.connect()), o;
    }, e;
  }(),
      RefCountSubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.connectable = r, n;
    }

    return __extends(t, e), t.prototype._unsubscribe = function () {
      var e = this.connectable;

      if (e) {
        this.connectable = null;
        var t = e._refCount;
        if (t <= 0) this.connection = null;else if (e._refCount = t - 1, t > 1) this.connection = null;else {
          var r = this.connection,
              n = e._connection;
          this.connection = null, !n || r && n !== r || n.unsubscribe();
        }
      } else this.connection = null;
    }, t;
  }(Subscriber),
      ConnectableObservable = function (e) {
    function t(t, r) {
      var n = e.call(this) || this;
      return n.source = t, n.subjectFactory = r, n._refCount = 0, n._isComplete = !1, n;
    }

    return __extends(t, e), t.prototype._subscribe = function (e) {
      return this.getSubject().subscribe(e);
    }, t.prototype.getSubject = function () {
      var e = this._subject;
      return e && !e.isStopped || (this._subject = this.subjectFactory()), this._subject;
    }, t.prototype.connect = function () {
      var e = this._connection;
      return e || (this._isComplete = !1, (e = this._connection = new Subscription()).add(this.source.subscribe(new ConnectableSubscriber(this.getSubject(), this))), e.closed && (this._connection = null, e = Subscription.EMPTY)), e;
    }, t.prototype.refCount = function () {
      return refCount()(this);
    }, t;
  }(Observable),
      connectableProto = ConnectableObservable.prototype,
      connectableObservableDescriptor = {
    operator: {
      value: null
    },
    _refCount: {
      value: 0,
      writable: !0
    },
    _subject: {
      value: null,
      writable: !0
    },
    _connection: {
      value: null,
      writable: !0
    },
    _subscribe: {
      value: connectableProto._subscribe
    },
    _isComplete: {
      value: connectableProto._isComplete,
      writable: !0
    },
    getSubject: {
      value: connectableProto.getSubject
    },
    connect: {
      value: connectableProto.connect
    },
    refCount: {
      value: connectableProto.refCount
    }
  },
      ConnectableSubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.connectable = r, n;
    }

    return __extends(t, e), t.prototype._error = function (t) {
      this._unsubscribe(), e.prototype._error.call(this, t);
    }, t.prototype._complete = function () {
      this.connectable._isComplete = !0, this._unsubscribe(), e.prototype._complete.call(this);
    }, t.prototype._unsubscribe = function () {
      var e = this.connectable;

      if (e) {
        this.connectable = null;
        var t = e._connection;
        e._refCount = 0, e._subject = null, e._connection = null, t && t.unsubscribe();
      }
    }, t;
  }(SubjectSubscriber),
      GroupedObservable = function (e) {
    function t(t, r, n) {
      var o = e.call(this) || this;
      return o.key = t, o.groupSubject = r, o.refCountSubscription = n, o;
    }

    return __extends(t, e), t.prototype._subscribe = function (e) {
      var t = new Subscription(),
          r = this.refCountSubscription,
          n = this.groupSubject;
      return r && !r.closed && t.add(new InnerRefCountSubscription(r)), t.add(n.subscribe(e)), t;
    }, t;
  }(Observable),
      InnerRefCountSubscription = function (e) {
    function t(t) {
      var r = e.call(this) || this;
      return r.parent = t, t.count++, r;
    }

    return __extends(t, e), t.prototype.unsubscribe = function () {
      var t = this.parent;
      t.closed || this.closed || (e.prototype.unsubscribe.call(this), t.count -= 1, 0 === t.count && t.attemptedToUnsubscribe && t.unsubscribe());
    }, t;
  }(Subscription),
      BehaviorSubject = function (e) {
    function t(t) {
      var r = e.call(this) || this;
      return r._value = t, r;
    }

    return __extends(t, e), Object.defineProperty(t.prototype, "value", {
      get: function get() {
        return this.getValue();
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype._subscribe = function (t) {
      var r = e.prototype._subscribe.call(this, t);

      return r && !r.closed && t.next(this._value), r;
    }, t.prototype.getValue = function () {
      if (this.hasError) throw this.thrownError;
      if (this.closed) throw new ObjectUnsubscribedError();
      return this._value;
    }, t.prototype.next = function (t) {
      e.prototype.next.call(this, this._value = t);
    }, t;
  }(Subject),
      Action = function (e) {
    function t(t, r) {
      return e.call(this) || this;
    }

    return __extends(t, e), t.prototype.schedule = function (e, t) {
      return this;
    }, t;
  }(Subscription),
      AsyncAction = function (e) {
    function t(t, r) {
      var n = e.call(this, t, r) || this;
      return n.scheduler = t, n.work = r, n.pending = !1, n;
    }

    return __extends(t, e), t.prototype.schedule = function (e, t) {
      if (void 0 === t && (t = 0), this.closed) return this;
      this.state = e;
      var r = this.id,
          n = this.scheduler;
      return null != r && (this.id = this.recycleAsyncId(n, r, t)), this.pending = !0, this.delay = t, this.id = this.id || this.requestAsyncId(n, this.id, t), this;
    }, t.prototype.requestAsyncId = function (e, t, r) {
      return void 0 === r && (r = 0), setInterval(e.flush.bind(e, this), r);
    }, t.prototype.recycleAsyncId = function (e, t, r) {
      if (void 0 === r && (r = 0), null !== r && this.delay === r && !1 === this.pending) return t;
      clearInterval(t);
    }, t.prototype.execute = function (e, t) {
      if (this.closed) return new Error("executing a cancelled action");
      this.pending = !1;

      var r = this._execute(e, t);

      if (r) return r;
      !1 === this.pending && null != this.id && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
    }, t.prototype._execute = function (e, t) {
      var r = !1,
          n = void 0;

      try {
        this.work(e);
      } catch (e) {
        r = !0, n = !!e && e || new Error(e);
      }

      if (r) return this.unsubscribe(), n;
    }, t.prototype._unsubscribe = function () {
      var e = this.id,
          t = this.scheduler,
          r = t.actions,
          n = r.indexOf(this);
      this.work = null, this.state = null, this.pending = !1, this.scheduler = null, -1 !== n && r.splice(n, 1), null != e && (this.id = this.recycleAsyncId(t, e, null)), this.delay = null;
    }, t;
  }(Action),
      QueueAction = function (e) {
    function t(t, r) {
      var n = e.call(this, t, r) || this;
      return n.scheduler = t, n.work = r, n;
    }

    return __extends(t, e), t.prototype.schedule = function (t, r) {
      return void 0 === r && (r = 0), r > 0 ? e.prototype.schedule.call(this, t, r) : (this.delay = r, this.state = t, this.scheduler.flush(this), this);
    }, t.prototype.execute = function (t, r) {
      return r > 0 || this.closed ? e.prototype.execute.call(this, t, r) : this._execute(t, r);
    }, t.prototype.requestAsyncId = function (t, r, n) {
      return void 0 === n && (n = 0), null !== n && n > 0 || null === n && this.delay > 0 ? e.prototype.requestAsyncId.call(this, t, r, n) : t.flush(this);
    }, t;
  }(AsyncAction),
      Scheduler = function () {
    function e(t, r) {
      void 0 === r && (r = e.now), this.SchedulerAction = t, this.now = r;
    }

    return e.prototype.schedule = function (e, t, r) {
      return void 0 === t && (t = 0), new this.SchedulerAction(this, e).schedule(r, t);
    }, e.now = function () {
      return Date.now();
    }, e;
  }(),
      AsyncScheduler = function (e) {
    function t(r, n) {
      void 0 === n && (n = Scheduler.now);
      var o = e.call(this, r, function () {
        return t.delegate && t.delegate !== o ? t.delegate.now() : n();
      }) || this;
      return o.actions = [], o.active = !1, o.scheduled = void 0, o;
    }

    return __extends(t, e), t.prototype.schedule = function (r, n, o) {
      return void 0 === n && (n = 0), t.delegate && t.delegate !== this ? t.delegate.schedule(r, n, o) : e.prototype.schedule.call(this, r, n, o);
    }, t.prototype.flush = function (e) {
      var t = this.actions;
      if (this.active) t.push(e);else {
        var r;
        this.active = !0;

        do {
          if (r = e.execute(e.state, e.delay)) break;
        } while (e = t.shift());

        if (this.active = !1, r) {
          for (; e = t.shift();) {
            e.unsubscribe();
          }

          throw r;
        }
      }
    }, t;
  }(Scheduler),
      QueueScheduler = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return __extends(t, e), t;
  }(AsyncScheduler),
      queue$1 = new QueueScheduler(QueueAction),
      EMPTY = new Observable(function (e) {
    return e.complete();
  });

  function empty$2(e) {
    return e ? emptyScheduled(e) : EMPTY;
  }

  function emptyScheduled(e) {
    return new Observable(function (t) {
      return e.schedule(function () {
        return t.complete();
      });
    });
  }

  function isScheduler(e) {
    return e && "function" == typeof e.schedule;
  }

  var subscribeToArray = function subscribeToArray(e) {
    return function (t) {
      for (var r = 0, n = e.length; r < n && !t.closed; r++) {
        t.next(e[r]);
      }

      t.complete();
    };
  },
      NotificationKind;

  function scheduleArray(e, t) {
    return new Observable(function (r) {
      var n = new Subscription(),
          o = 0;
      return n.add(t.schedule(function () {
        o !== e.length ? (r.next(e[o++]), r.closed || n.add(this.schedule())) : r.complete();
      })), n;
    });
  }

  function fromArray(e, t) {
    return t ? scheduleArray(e, t) : new Observable(subscribeToArray(e));
  }

  function of() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    var r = e[e.length - 1];
    return isScheduler(r) ? (e.pop(), scheduleArray(e, r)) : fromArray(e);
  }

  function throwError(e, t) {
    return new Observable(t ? function (r) {
      return t.schedule(dispatch, 0, {
        error: e,
        subscriber: r
      });
    } : function (t) {
      return t.error(e);
    });
  }

  function dispatch(e) {
    var t = e.error;
    e.subscriber.error(t);
  }

  NotificationKind || (NotificationKind = {});

  var Notification = function () {
    function e(e, t, r) {
      this.kind = e, this.value = t, this.error = r, this.hasValue = "N" === e;
    }

    return e.prototype.observe = function (e) {
      switch (this.kind) {
        case "N":
          return e.next && e.next(this.value);

        case "E":
          return e.error && e.error(this.error);

        case "C":
          return e.complete && e.complete();
      }
    }, e.prototype.do = function (e, t, r) {
      switch (this.kind) {
        case "N":
          return e && e(this.value);

        case "E":
          return t && t(this.error);

        case "C":
          return r && r();
      }
    }, e.prototype.accept = function (e, t, r) {
      return e && "function" == typeof e.next ? this.observe(e) : this.do(e, t, r);
    }, e.prototype.toObservable = function () {
      switch (this.kind) {
        case "N":
          return of(this.value);

        case "E":
          return throwError(this.error);

        case "C":
          return empty$2();
      }

      throw new Error("unexpected notification kind value");
    }, e.createNext = function (t) {
      return void 0 !== t ? new e("N", t) : e.undefinedValueNotification;
    }, e.createError = function (t) {
      return new e("E", void 0, t);
    }, e.createComplete = function () {
      return e.completeNotification;
    }, e.completeNotification = new e("C"), e.undefinedValueNotification = new e("N", void 0), e;
  }();

  function observeOn(e, t) {
    return void 0 === t && (t = 0), function (r) {
      return r.lift(new ObserveOnOperator(e, t));
    };
  }

  var ObserveOnOperator = function () {
    function e(e, t) {
      void 0 === t && (t = 0), this.scheduler = e, this.delay = t;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new ObserveOnSubscriber(e, this.scheduler, this.delay));
    }, e;
  }(),
      ObserveOnSubscriber = function (e) {
    function t(t, r, n) {
      void 0 === n && (n = 0);
      var o = e.call(this, t) || this;
      return o.scheduler = r, o.delay = n, o;
    }

    return __extends(t, e), t.dispatch = function (e) {
      var t = e.notification,
          r = e.destination;
      t.observe(r), this.unsubscribe();
    }, t.prototype.scheduleMessage = function (e) {
      this.destination.add(this.scheduler.schedule(t.dispatch, this.delay, new ObserveOnMessage(e, this.destination)));
    }, t.prototype._next = function (e) {
      this.scheduleMessage(Notification.createNext(e));
    }, t.prototype._error = function (e) {
      this.scheduleMessage(Notification.createError(e)), this.unsubscribe();
    }, t.prototype._complete = function () {
      this.scheduleMessage(Notification.createComplete()), this.unsubscribe();
    }, t;
  }(Subscriber),
      ObserveOnMessage = function () {
    return function (e, t) {
      this.notification = e, this.destination = t;
    };
  }(),
      ReplaySubject = function (e) {
    function t(t, r, n) {
      void 0 === t && (t = Number.POSITIVE_INFINITY), void 0 === r && (r = Number.POSITIVE_INFINITY);
      var o = e.call(this) || this;
      return o.scheduler = n, o._events = [], o._infiniteTimeWindow = !1, o._bufferSize = t < 1 ? 1 : t, o._windowTime = r < 1 ? 1 : r, r === Number.POSITIVE_INFINITY ? (o._infiniteTimeWindow = !0, o.next = o.nextInfiniteTimeWindow) : o.next = o.nextTimeWindow, o;
    }

    return __extends(t, e), t.prototype.nextInfiniteTimeWindow = function (t) {
      var r = this._events;
      r.push(t), r.length > this._bufferSize && r.shift(), e.prototype.next.call(this, t);
    }, t.prototype.nextTimeWindow = function (t) {
      this._events.push(new ReplayEvent(this._getNow(), t)), this._trimBufferThenGetEvents(), e.prototype.next.call(this, t);
    }, t.prototype._subscribe = function (e) {
      var t,
          r = this._infiniteTimeWindow,
          n = r ? this._events : this._trimBufferThenGetEvents(),
          o = this.scheduler,
          i = n.length;
      if (this.closed) throw new ObjectUnsubscribedError();
      if (this.isStopped || this.hasError ? t = Subscription.EMPTY : (this.observers.push(e), t = new SubjectSubscription(this, e)), o && e.add(e = new ObserveOnSubscriber(e, o)), r) for (var s = 0; s < i && !e.closed; s++) {
        e.next(n[s]);
      } else for (s = 0; s < i && !e.closed; s++) {
        e.next(n[s].value);
      }
      return this.hasError ? e.error(this.thrownError) : this.isStopped && e.complete(), t;
    }, t.prototype._getNow = function () {
      return (this.scheduler || queue$1).now();
    }, t.prototype._trimBufferThenGetEvents = function () {
      for (var e = this._getNow(), t = this._bufferSize, r = this._windowTime, n = this._events, o = n.length, i = 0; i < o && !(e - n[i].time < r);) {
        i++;
      }

      return o > t && (i = Math.max(i, o - t)), i > 0 && n.splice(0, i), n;
    }, t;
  }(Subject),
      ReplayEvent = function () {
    return function (e, t) {
      this.time = e, this.value = t;
    };
  }(),
      AsyncSubject = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.value = null, t.hasNext = !1, t.hasCompleted = !1, t;
    }

    return __extends(t, e), t.prototype._subscribe = function (t) {
      return this.hasError ? (t.error(this.thrownError), Subscription.EMPTY) : this.hasCompleted && this.hasNext ? (t.next(this.value), t.complete(), Subscription.EMPTY) : e.prototype._subscribe.call(this, t);
    }, t.prototype.next = function (e) {
      this.hasCompleted || (this.value = e, this.hasNext = !0);
    }, t.prototype.error = function (t) {
      this.hasCompleted || e.prototype.error.call(this, t);
    }, t.prototype.complete = function () {
      this.hasCompleted = !0, this.hasNext && e.prototype.next.call(this, this.value), e.prototype.complete.call(this);
    }, t;
  }(Subject),
      nextHandle = 1,
      tasksByHandle = {};

  function runIfPresent(e) {
    var t = tasksByHandle[e];
    t && t();
  }

  var Immediate = {
    setImmediate: function setImmediate(e) {
      var t = nextHandle++;
      return tasksByHandle[t] = e, Promise.resolve().then(function () {
        return runIfPresent(t);
      }), t;
    },
    clearImmediate: function clearImmediate(e) {
      delete tasksByHandle[e];
    }
  },
      AsapAction = function (e) {
    function t(t, r) {
      var n = e.call(this, t, r) || this;
      return n.scheduler = t, n.work = r, n;
    }

    return __extends(t, e), t.prototype.requestAsyncId = function (t, r, n) {
      return void 0 === n && (n = 0), null !== n && n > 0 ? e.prototype.requestAsyncId.call(this, t, r, n) : (t.actions.push(this), t.scheduled || (t.scheduled = Immediate.setImmediate(t.flush.bind(t, null))));
    }, t.prototype.recycleAsyncId = function (t, r, n) {
      if (void 0 === n && (n = 0), null !== n && n > 0 || null === n && this.delay > 0) return e.prototype.recycleAsyncId.call(this, t, r, n);
      0 === t.actions.length && (Immediate.clearImmediate(r), t.scheduled = void 0);
    }, t;
  }(AsyncAction),
      AsapScheduler = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return __extends(t, e), t.prototype.flush = function (e) {
      this.active = !0, this.scheduled = void 0;
      var t,
          r = this.actions,
          n = -1,
          o = r.length;
      e = e || r.shift();

      do {
        if (t = e.execute(e.state, e.delay)) break;
      } while (++n < o && (e = r.shift()));

      if (this.active = !1, t) {
        for (; ++n < o && (e = r.shift());) {
          e.unsubscribe();
        }

        throw t;
      }
    }, t;
  }(AsyncScheduler),
      asap = new AsapScheduler(AsapAction),
      async = new AsyncScheduler(AsyncAction),
      AnimationFrameAction = function (e) {
    function t(t, r) {
      var n = e.call(this, t, r) || this;
      return n.scheduler = t, n.work = r, n;
    }

    return __extends(t, e), t.prototype.requestAsyncId = function (t, r, n) {
      return void 0 === n && (n = 0), null !== n && n > 0 ? e.prototype.requestAsyncId.call(this, t, r, n) : (t.actions.push(this), t.scheduled || (t.scheduled = requestAnimationFrame(function () {
        return t.flush(null);
      })));
    }, t.prototype.recycleAsyncId = function (t, r, n) {
      if (void 0 === n && (n = 0), null !== n && n > 0 || null === n && this.delay > 0) return e.prototype.recycleAsyncId.call(this, t, r, n);
      0 === t.actions.length && (cancelAnimationFrame(r), t.scheduled = void 0);
    }, t;
  }(AsyncAction),
      AnimationFrameScheduler = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return __extends(t, e), t.prototype.flush = function (e) {
      this.active = !0, this.scheduled = void 0;
      var t,
          r = this.actions,
          n = -1,
          o = r.length;
      e = e || r.shift();

      do {
        if (t = e.execute(e.state, e.delay)) break;
      } while (++n < o && (e = r.shift()));

      if (this.active = !1, t) {
        for (; ++n < o && (e = r.shift());) {
          e.unsubscribe();
        }

        throw t;
      }
    }, t;
  }(AsyncScheduler),
      animationFrame = new AnimationFrameScheduler(AnimationFrameAction),
      VirtualTimeScheduler = function (e) {
    function t(t, r) {
      void 0 === t && (t = VirtualAction), void 0 === r && (r = Number.POSITIVE_INFINITY);
      var n = e.call(this, t, function () {
        return n.frame;
      }) || this;
      return n.maxFrames = r, n.frame = 0, n.index = -1, n;
    }

    return __extends(t, e), t.prototype.flush = function () {
      for (var e, t, r = this.actions, n = this.maxFrames; (t = r[0]) && t.delay <= n && (r.shift(), this.frame = t.delay, !(e = t.execute(t.state, t.delay)));) {
        ;
      }

      if (e) {
        for (; t = r.shift();) {
          t.unsubscribe();
        }

        throw e;
      }
    }, t.frameTimeFactor = 10, t;
  }(AsyncScheduler),
      VirtualAction = function (e) {
    function t(t, r, n) {
      void 0 === n && (n = t.index += 1);
      var o = e.call(this, t, r) || this;
      return o.scheduler = t, o.work = r, o.index = n, o.active = !0, o.index = t.index = n, o;
    }

    return __extends(t, e), t.prototype.schedule = function (r, n) {
      if (void 0 === n && (n = 0), !this.id) return e.prototype.schedule.call(this, r, n);
      this.active = !1;
      var o = new t(this.scheduler, this.work);
      return this.add(o), o.schedule(r, n);
    }, t.prototype.requestAsyncId = function (e, r, n) {
      void 0 === n && (n = 0), this.delay = e.frame + n;
      var o = e.actions;
      return o.push(this), o.sort(t.sortActions), !0;
    }, t.prototype.recycleAsyncId = function (e, t, r) {}, t.prototype._execute = function (t, r) {
      if (!0 === this.active) return e.prototype._execute.call(this, t, r);
    }, t.sortActions = function (e, t) {
      return e.delay === t.delay ? e.index === t.index ? 0 : e.index > t.index ? 1 : -1 : e.delay > t.delay ? 1 : -1;
    }, t;
  }(AsyncAction);

  function identity$1(e) {
    return e;
  }

  function isObservable(e) {
    return !!e && (e instanceof Observable || "function" == typeof e.lift && "function" == typeof e.subscribe);
  }

  function ArgumentOutOfRangeErrorImpl() {
    return Error.call(this), this.message = "argument out of range", this.name = "ArgumentOutOfRangeError", this;
  }

  ArgumentOutOfRangeErrorImpl.prototype = Object.create(Error.prototype);
  var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;

  function EmptyErrorImpl() {
    return Error.call(this), this.message = "no elements in sequence", this.name = "EmptyError", this;
  }

  EmptyErrorImpl.prototype = Object.create(Error.prototype);
  var EmptyError = EmptyErrorImpl;

  function TimeoutErrorImpl() {
    return Error.call(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this;
  }

  TimeoutErrorImpl.prototype = Object.create(Error.prototype);
  var TimeoutError = TimeoutErrorImpl;

  function map$1(e, t) {
    return function (r) {
      if ("function" != typeof e) throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
      return r.lift(new MapOperator(e, t));
    };
  }

  var MapOperator = function () {
    function e(e, t) {
      this.project = e, this.thisArg = t;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new MapSubscriber(e, this.project, this.thisArg));
    }, e;
  }(),
      MapSubscriber = function (e) {
    function t(t, r, n) {
      var o = e.call(this, t) || this;
      return o.project = r, o.count = 0, o.thisArg = n || o, o;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      var t;

      try {
        t = this.project.call(this.thisArg, e, this.count++);
      } catch (e) {
        return void this.destination.error(e);
      }

      this.destination.next(t);
    }, t;
  }(Subscriber);

  function bindCallback(e, t, r) {
    if (t) {
      if (!isScheduler(t)) return function () {
        for (var n = [], o = 0; o < arguments.length; o++) {
          n[o] = arguments[o];
        }

        return bindCallback(e, r).apply(void 0, n).pipe(map$1(function (e) {
          return isArray$1(e) ? t.apply(void 0, e) : t(e);
        }));
      };
      r = t;
    }

    return function () {
      for (var t = [], n = 0; n < arguments.length; n++) {
        t[n] = arguments[n];
      }

      var o,
          i = this,
          s = {
        context: i,
        subject: o,
        callbackFunc: e,
        scheduler: r
      };
      return new Observable(function (n) {
        if (r) {
          var a = {
            args: t,
            subscriber: n,
            params: s
          };
          return r.schedule(dispatch$1, 0, a);
        }

        if (!o) {
          o = new AsyncSubject();

          try {
            e.apply(i, t.concat([function () {
              for (var e = [], t = 0; t < arguments.length; t++) {
                e[t] = arguments[t];
              }

              o.next(e.length <= 1 ? e[0] : e), o.complete();
            }]));
          } catch (e) {
            canReportError(o) ? o.error(e) : console.warn(e);
          }
        }

        return o.subscribe(n);
      });
    };
  }

  function dispatch$1(e) {
    var t = this,
        r = e.args,
        n = e.subscriber,
        o = e.params,
        i = o.callbackFunc,
        s = o.context,
        a = o.scheduler,
        u = o.subject;

    if (!u) {
      u = o.subject = new AsyncSubject();

      try {
        i.apply(s, r.concat([function () {
          for (var e = [], r = 0; r < arguments.length; r++) {
            e[r] = arguments[r];
          }

          var n = e.length <= 1 ? e[0] : e;
          t.add(a.schedule(dispatchNext, 0, {
            value: n,
            subject: u
          }));
        }]));
      } catch (e) {
        u.error(e);
      }
    }

    this.add(u.subscribe(n));
  }

  function dispatchNext(e) {
    var t = e.value,
        r = e.subject;
    r.next(t), r.complete();
  }

  function bindNodeCallback(e, t, r) {
    if (t) {
      if (!isScheduler(t)) return function () {
        for (var n = [], o = 0; o < arguments.length; o++) {
          n[o] = arguments[o];
        }

        return bindNodeCallback(e, r).apply(void 0, n).pipe(map$1(function (e) {
          return isArray$1(e) ? t.apply(void 0, e) : t(e);
        }));
      };
      r = t;
    }

    return function () {
      for (var t = [], n = 0; n < arguments.length; n++) {
        t[n] = arguments[n];
      }

      var o = {
        subject: void 0,
        args: t,
        callbackFunc: e,
        scheduler: r,
        context: this
      };
      return new Observable(function (n) {
        var i = o.context,
            s = o.subject;
        if (r) return r.schedule(dispatch$2, 0, {
          params: o,
          subscriber: n,
          context: i
        });

        if (!s) {
          s = o.subject = new AsyncSubject();

          try {
            e.apply(i, t.concat([function () {
              for (var e = [], t = 0; t < arguments.length; t++) {
                e[t] = arguments[t];
              }

              var r = e.shift();
              r ? s.error(r) : (s.next(e.length <= 1 ? e[0] : e), s.complete());
            }]));
          } catch (e) {
            canReportError(s) ? s.error(e) : console.warn(e);
          }
        }

        return s.subscribe(n);
      });
    };
  }

  function dispatch$2(e) {
    var t = this,
        r = e.params,
        n = e.subscriber,
        o = e.context,
        i = r.callbackFunc,
        s = r.args,
        a = r.scheduler,
        u = r.subject;

    if (!u) {
      u = r.subject = new AsyncSubject();

      try {
        i.apply(o, s.concat([function () {
          for (var e = [], r = 0; r < arguments.length; r++) {
            e[r] = arguments[r];
          }

          var n = e.shift();
          if (n) t.add(a.schedule(dispatchError, 0, {
            err: n,
            subject: u
          }));else {
            var o = e.length <= 1 ? e[0] : e;
            t.add(a.schedule(dispatchNext$1, 0, {
              value: o,
              subject: u
            }));
          }
        }]));
      } catch (e) {
        this.add(a.schedule(dispatchError, 0, {
          err: e,
          subject: u
        }));
      }
    }

    this.add(u.subscribe(n));
  }

  function dispatchNext$1(e) {
    var t = e.value,
        r = e.subject;
    r.next(t), r.complete();
  }

  function dispatchError(e) {
    var t = e.err;
    e.subject.error(t);
  }

  var OuterSubscriber = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return __extends(t, e), t.prototype.notifyNext = function (e, t, r, n, o) {
      this.destination.next(t);
    }, t.prototype.notifyError = function (e, t) {
      this.destination.error(e);
    }, t.prototype.notifyComplete = function (e) {
      this.destination.complete();
    }, t;
  }(Subscriber),
      InnerSubscriber = function (e) {
    function t(t, r, n) {
      var o = e.call(this) || this;
      return o.parent = t, o.outerValue = r, o.outerIndex = n, o.index = 0, o;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      this.parent.notifyNext(this.outerValue, e, this.outerIndex, this.index++, this);
    }, t.prototype._error = function (e) {
      this.parent.notifyError(e, this), this.unsubscribe();
    }, t.prototype._complete = function () {
      this.parent.notifyComplete(this), this.unsubscribe();
    }, t;
  }(Subscriber),
      subscribeToPromise = function subscribeToPromise(e) {
    return function (t) {
      return e.then(function (e) {
        t.closed || (t.next(e), t.complete());
      }, function (e) {
        return t.error(e);
      }).then(null, hostReportError), t;
    };
  };

  function getSymbolIterator() {
    return "function" == typeof Symbol && Symbol.iterator ? Symbol.iterator : "@@iterator";
  }

  var iterator = getSymbolIterator(),
      subscribeToIterable = function subscribeToIterable(e) {
    return function (t) {
      for (var r = e[iterator]();;) {
        var n = r.next();

        if (n.done) {
          t.complete();
          break;
        }

        if (t.next(n.value), t.closed) break;
      }

      return "function" == typeof r.return && t.add(function () {
        r.return && r.return();
      }), t;
    };
  },
      subscribeToObservable = function subscribeToObservable(e) {
    return function (t) {
      var r = e[observable]();
      if ("function" != typeof r.subscribe) throw new TypeError("Provided object does not correctly implement Symbol.observable");
      return r.subscribe(t);
    };
  },
      isArrayLike$2 = function isArrayLike$2(e) {
    return e && "number" == typeof e.length && "function" != typeof e;
  };

  function isPromise(e) {
    return !!e && "function" != typeof e.subscribe && "function" == typeof e.then;
  }

  var subscribeTo = function subscribeTo(e) {
    if (e && "function" == typeof e[observable]) return subscribeToObservable(e);
    if (isArrayLike$2(e)) return subscribeToArray(e);
    if (isPromise(e)) return subscribeToPromise(e);
    if (e && "function" == typeof e[iterator]) return subscribeToIterable(e);
    var t = isObject$1(e) ? "an invalid object" : "'" + e + "'";
    throw new TypeError("You provided " + t + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.");
  };

  function subscribeToResult(e, t, r, n, o) {
    if (void 0 === o && (o = new InnerSubscriber(e, r, n)), !o.closed) return t instanceof Observable ? t.subscribe(o) : subscribeTo(t)(o);
  }

  var NONE = {};

  function combineLatest() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    var r = null,
        n = null;
    return isScheduler(e[e.length - 1]) && (n = e.pop()), "function" == typeof e[e.length - 1] && (r = e.pop()), 1 === e.length && isArray$1(e[0]) && (e = e[0]), fromArray(e, n).lift(new CombineLatestOperator(r));
  }

  var CombineLatestOperator = function () {
    function e(e) {
      this.resultSelector = e;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new CombineLatestSubscriber(e, this.resultSelector));
    }, e;
  }(),
      CombineLatestSubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.resultSelector = r, n.active = 0, n.values = [], n.observables = [], n;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      this.values.push(NONE), this.observables.push(e);
    }, t.prototype._complete = function () {
      var e = this.observables,
          t = e.length;
      if (0 === t) this.destination.complete();else {
        this.active = t, this.toRespond = t;

        for (var r = 0; r < t; r++) {
          var n = e[r];
          this.add(subscribeToResult(this, n, n, r));
        }
      }
    }, t.prototype.notifyComplete = function (e) {
      0 == (this.active -= 1) && this.destination.complete();
    }, t.prototype.notifyNext = function (e, t, r, n, o) {
      var i = this.values,
          s = i[r],
          a = this.toRespond ? s === NONE ? --this.toRespond : this.toRespond : 0;
      i[r] = t, 0 === a && (this.resultSelector ? this._tryResultSelector(i) : this.destination.next(i.slice()));
    }, t.prototype._tryResultSelector = function (e) {
      var t;

      try {
        t = this.resultSelector.apply(this, e);
      } catch (e) {
        return void this.destination.error(e);
      }

      this.destination.next(t);
    }, t;
  }(OuterSubscriber);

  function scheduleObservable(e, t) {
    return new Observable(function (r) {
      var n = new Subscription();
      return n.add(t.schedule(function () {
        var o = e[observable]();
        n.add(o.subscribe({
          next: function next(e) {
            n.add(t.schedule(function () {
              return r.next(e);
            }));
          },
          error: function error(e) {
            n.add(t.schedule(function () {
              return r.error(e);
            }));
          },
          complete: function complete() {
            n.add(t.schedule(function () {
              return r.complete();
            }));
          }
        }));
      })), n;
    });
  }

  function schedulePromise(e, t) {
    return new Observable(function (r) {
      var n = new Subscription();
      return n.add(t.schedule(function () {
        return e.then(function (e) {
          n.add(t.schedule(function () {
            r.next(e), n.add(t.schedule(function () {
              return r.complete();
            }));
          }));
        }, function (e) {
          n.add(t.schedule(function () {
            return r.error(e);
          }));
        });
      })), n;
    });
  }

  function scheduleIterable(e, t) {
    if (!e) throw new Error("Iterable cannot be null");
    return new Observable(function (r) {
      var n,
          o = new Subscription();
      return o.add(function () {
        n && "function" == typeof n.return && n.return();
      }), o.add(t.schedule(function () {
        n = e[iterator](), o.add(t.schedule(function () {
          if (!r.closed) {
            var e, t;

            try {
              var o = n.next();
              e = o.value, t = o.done;
            } catch (e) {
              return void r.error(e);
            }

            t ? r.complete() : (r.next(e), this.schedule());
          }
        }));
      })), o;
    });
  }

  function isInteropObservable(e) {
    return e && "function" == typeof e[observable];
  }

  function isIterable(e) {
    return e && "function" == typeof e[iterator];
  }

  function scheduled(e, t) {
    if (null != e) {
      if (isInteropObservable(e)) return scheduleObservable(e, t);
      if (isPromise(e)) return schedulePromise(e, t);
      if (isArrayLike$2(e)) return scheduleArray(e, t);
      if (isIterable(e) || "string" == typeof e) return scheduleIterable(e, t);
    }

    throw new TypeError((null !== e && _typeof(e) || e) + " is not observable");
  }

  function from(e, t) {
    return t ? scheduled(e, t) : e instanceof Observable ? e : new Observable(subscribeTo(e));
  }

  function mergeMap(e, t, r) {
    return void 0 === r && (r = Number.POSITIVE_INFINITY), "function" == typeof t ? function (n) {
      return n.pipe(mergeMap(function (r, n) {
        return from(e(r, n)).pipe(map$1(function (e, o) {
          return t(r, e, n, o);
        }));
      }, r));
    } : ("number" == typeof t && (r = t), function (t) {
      return t.lift(new MergeMapOperator(e, r));
    });
  }

  var MergeMapOperator = function () {
    function e(e, t) {
      void 0 === t && (t = Number.POSITIVE_INFINITY), this.project = e, this.concurrent = t;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new MergeMapSubscriber(e, this.project, this.concurrent));
    }, e;
  }(),
      MergeMapSubscriber = function (e) {
    function t(t, r, n) {
      void 0 === n && (n = Number.POSITIVE_INFINITY);
      var o = e.call(this, t) || this;
      return o.project = r, o.concurrent = n, o.hasCompleted = !1, o.buffer = [], o.active = 0, o.index = 0, o;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      this.active < this.concurrent ? this._tryNext(e) : this.buffer.push(e);
    }, t.prototype._tryNext = function (e) {
      var t,
          r = this.index++;

      try {
        t = this.project(e, r);
      } catch (e) {
        return void this.destination.error(e);
      }

      this.active++, this._innerSub(t, e, r);
    }, t.prototype._innerSub = function (e, t, r) {
      var n = new InnerSubscriber(this, void 0, void 0);
      this.destination.add(n), subscribeToResult(this, e, t, r, n);
    }, t.prototype._complete = function () {
      this.hasCompleted = !0, 0 === this.active && 0 === this.buffer.length && this.destination.complete(), this.unsubscribe();
    }, t.prototype.notifyNext = function (e, t, r, n, o) {
      this.destination.next(t);
    }, t.prototype.notifyComplete = function (e) {
      var t = this.buffer;
      this.remove(e), this.active--, t.length > 0 ? this._next(t.shift()) : 0 === this.active && this.hasCompleted && this.destination.complete();
    }, t;
  }(OuterSubscriber);

  function mergeAll(e) {
    return void 0 === e && (e = Number.POSITIVE_INFINITY), mergeMap(identity$1, e);
  }

  function concatAll() {
    return mergeAll(1);
  }

  function concat() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    return concatAll()(of.apply(void 0, e));
  }

  function defer$1(e) {
    return new Observable(function (t) {
      var r;

      try {
        r = e();
      } catch (e) {
        return void t.error(e);
      }

      return (r ? from(r) : empty$2()).subscribe(t);
    });
  }

  function forkJoin() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    if (1 === e.length) {
      var r = e[0];
      if (isArray$1(r)) return forkJoinInternal(r, null);

      if (isObject$1(r) && Object.getPrototypeOf(r) === Object.prototype) {
        var n = Object.keys(r);
        return forkJoinInternal(n.map(function (e) {
          return r[e];
        }), n);
      }
    }

    if ("function" == typeof e[e.length - 1]) {
      var o = e.pop();
      return forkJoinInternal(e = 1 === e.length && isArray$1(e[0]) ? e[0] : e, null).pipe(map$1(function (e) {
        return o.apply(void 0, e);
      }));
    }

    return forkJoinInternal(e, null);
  }

  function forkJoinInternal(e, t) {
    return new Observable(function (r) {
      var n = e.length;
      if (0 !== n) for (var o = new Array(n), i = 0, s = 0, a = function a(_a2) {
        var u = from(e[_a2]),
            l = !1;
        r.add(u.subscribe({
          next: function next(e) {
            l || (l = !0, s++), o[_a2] = e;
          },
          error: function error(e) {
            return r.error(e);
          },
          complete: function complete() {
            ++i !== n && l || (s === n && r.next(t ? t.reduce(function (e, t, r) {
              return e[t] = o[r], e;
            }, {}) : o), r.complete());
          }
        }));
      }, u = 0; u < n; u++) {
        a(u);
      } else r.complete();
    });
  }

  function fromEvent(e, t, r, n) {
    return isFunction$1(r) && (n = r, r = void 0), n ? fromEvent(e, t, r).pipe(map$1(function (e) {
      return isArray$1(e) ? n.apply(void 0, e) : n(e);
    })) : new Observable(function (n) {
      setupSubscription(e, t, function (e) {
        arguments.length > 1 ? n.next(Array.prototype.slice.call(arguments)) : n.next(e);
      }, n, r);
    });
  }

  function setupSubscription(e, t, r, n, o) {
    var i;

    if (isEventTarget(e)) {
      var s = e;
      e.addEventListener(t, r, o), i = function i() {
        return s.removeEventListener(t, r, o);
      };
    } else if (isJQueryStyleEventEmitter(e)) {
      var a = e;
      e.on(t, r), i = function i() {
        return a.off(t, r);
      };
    } else if (isNodeStyleEventEmitter(e)) {
      var u = e;
      e.addListener(t, r), i = function i() {
        return u.removeListener(t, r);
      };
    } else {
      if (!e || !e.length) throw new TypeError("Invalid event target");

      for (var l = 0, c = e.length; l < c; l++) {
        setupSubscription(e[l], t, r, n, o);
      }
    }

    n.add(i);
  }

  function isNodeStyleEventEmitter(e) {
    return e && "function" == typeof e.addListener && "function" == typeof e.removeListener;
  }

  function isJQueryStyleEventEmitter(e) {
    return e && "function" == typeof e.on && "function" == typeof e.off;
  }

  function isEventTarget(e) {
    return e && "function" == typeof e.addEventListener && "function" == typeof e.removeEventListener;
  }

  function fromEventPattern(e, t, r) {
    return r ? fromEventPattern(e, t).pipe(map$1(function (e) {
      return isArray$1(e) ? r.apply(void 0, e) : r(e);
    })) : new Observable(function (r) {
      var n,
          o = function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        return r.next(1 === e.length ? e[0] : e);
      };

      try {
        n = e(o);
      } catch (e) {
        return void r.error(e);
      }

      if (isFunction$1(t)) return function () {
        return t(o, n);
      };
    });
  }

  function generate(e, t, r, n, o) {
    var i, s;

    if (1 == arguments.length) {
      var a = e;
      s = a.initialState, t = a.condition, r = a.iterate, i = a.resultSelector || identity$1, o = a.scheduler;
    } else void 0 === n || isScheduler(n) ? (s = e, i = identity$1, o = n) : (s = e, i = n);

    return new Observable(function (e) {
      var n = s;
      if (o) return o.schedule(dispatch$3, 0, {
        subscriber: e,
        iterate: r,
        condition: t,
        resultSelector: i,
        state: n
      });

      for (;;) {
        if (t) {
          var a = void 0;

          try {
            a = t(n);
          } catch (t) {
            return void e.error(t);
          }

          if (!a) {
            e.complete();
            break;
          }
        }

        var u = void 0;

        try {
          u = i(n);
        } catch (t) {
          return void e.error(t);
        }

        if (e.next(u), e.closed) break;

        try {
          n = r(n);
        } catch (t) {
          return void e.error(t);
        }
      }
    });
  }

  function dispatch$3(e) {
    var t = e.subscriber,
        r = e.condition;

    if (!t.closed) {
      if (e.needIterate) try {
        e.state = e.iterate(e.state);
      } catch (e) {
        return void t.error(e);
      } else e.needIterate = !0;

      if (r) {
        var n = void 0;

        try {
          n = r(e.state);
        } catch (e) {
          return void t.error(e);
        }

        if (!n) return void t.complete();
        if (t.closed) return;
      }

      var o;

      try {
        o = e.resultSelector(e.state);
      } catch (e) {
        return void t.error(e);
      }

      if (!t.closed && (t.next(o), !t.closed)) return this.schedule(e);
    }
  }

  function iif(e, t, r) {
    return void 0 === t && (t = EMPTY), void 0 === r && (r = EMPTY), defer$1(function () {
      return e() ? t : r;
    });
  }

  function isNumeric(e) {
    return !isArray$1(e) && e - parseFloat(e) + 1 >= 0;
  }

  function interval(e, t) {
    return void 0 === e && (e = 0), void 0 === t && (t = async), (!isNumeric(e) || e < 0) && (e = 0), t && "function" == typeof t.schedule || (t = async), new Observable(function (r) {
      return r.add(t.schedule(dispatch$4, e, {
        subscriber: r,
        counter: 0,
        period: e
      })), r;
    });
  }

  function dispatch$4(e) {
    var t = e.subscriber,
        r = e.counter,
        n = e.period;
    t.next(r), this.schedule({
      subscriber: t,
      counter: r + 1,
      period: n
    }, n);
  }

  function merge() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    var r = Number.POSITIVE_INFINITY,
        n = null,
        o = e[e.length - 1];
    return isScheduler(o) ? (n = e.pop(), e.length > 1 && "number" == typeof e[e.length - 1] && (r = e.pop())) : "number" == typeof o && (r = e.pop()), null === n && 1 === e.length && e[0] instanceof Observable ? e[0] : mergeAll(r)(fromArray(e, n));
  }

  var NEVER = new Observable(noop$1);

  function never() {
    return NEVER;
  }

  function onErrorResumeNext() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    if (0 === e.length) return EMPTY;
    var r = e[0],
        n = e.slice(1);
    return 1 === e.length && isArray$1(r) ? onErrorResumeNext.apply(void 0, r) : new Observable(function (e) {
      var t = function t() {
        return e.add(onErrorResumeNext.apply(void 0, n).subscribe(e));
      };

      return from(r).subscribe({
        next: function next(t) {
          e.next(t);
        },
        error: t,
        complete: t
      });
    });
  }

  function pairs(e, t) {
    return new Observable(t ? function (r) {
      var n = Object.keys(e),
          o = new Subscription();
      return o.add(t.schedule(dispatch$5, 0, {
        keys: n,
        index: 0,
        subscriber: r,
        subscription: o,
        obj: e
      })), o;
    } : function (t) {
      for (var r = Object.keys(e), n = 0; n < r.length && !t.closed; n++) {
        var o = r[n];
        e.hasOwnProperty(o) && t.next([o, e[o]]);
      }

      t.complete();
    });
  }

  function dispatch$5(e) {
    var t = e.keys,
        r = e.index,
        n = e.subscriber,
        o = e.subscription,
        i = e.obj;
    if (!n.closed) if (r < t.length) {
      var s = t[r];
      n.next([s, i[s]]), o.add(this.schedule({
        keys: t,
        index: r + 1,
        subscriber: n,
        subscription: o,
        obj: i
      }));
    } else n.complete();
  }

  function not(e, t) {
    function r() {
      return !r.pred.apply(r.thisArg, arguments);
    }

    return r.pred = e, r.thisArg = t, r;
  }

  function filter(e, t) {
    return function (r) {
      return r.lift(new FilterOperator(e, t));
    };
  }

  var FilterOperator = function () {
    function e(e, t) {
      this.predicate = e, this.thisArg = t;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new FilterSubscriber(e, this.predicate, this.thisArg));
    }, e;
  }(),
      FilterSubscriber = function (e) {
    function t(t, r, n) {
      var o = e.call(this, t) || this;
      return o.predicate = r, o.thisArg = n, o.count = 0, o;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      var t;

      try {
        t = this.predicate.call(this.thisArg, e, this.count++);
      } catch (e) {
        return void this.destination.error(e);
      }

      t && this.destination.next(e);
    }, t;
  }(Subscriber);

  function partition(e, t, r) {
    return [filter(t, r)(new Observable(subscribeTo(e))), filter(not(t, r))(new Observable(subscribeTo(e)))];
  }

  function race() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    if (1 === e.length) {
      if (!isArray$1(e[0])) return e[0];
      e = e[0];
    }

    return fromArray(e, void 0).lift(new RaceOperator());
  }

  var RaceOperator = function () {
    function e() {}

    return e.prototype.call = function (e, t) {
      return t.subscribe(new RaceSubscriber(e));
    }, e;
  }(),
      RaceSubscriber = function (e) {
    function t(t) {
      var r = e.call(this, t) || this;
      return r.hasFirst = !1, r.observables = [], r.subscriptions = [], r;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      this.observables.push(e);
    }, t.prototype._complete = function () {
      var e = this.observables,
          t = e.length;
      if (0 === t) this.destination.complete();else {
        for (var r = 0; r < t && !this.hasFirst; r++) {
          var n = e[r],
              o = subscribeToResult(this, n, n, r);
          this.subscriptions && this.subscriptions.push(o), this.add(o);
        }

        this.observables = null;
      }
    }, t.prototype.notifyNext = function (e, t, r, n, o) {
      if (!this.hasFirst) {
        this.hasFirst = !0;

        for (var i = 0; i < this.subscriptions.length; i++) {
          if (i !== r) {
            var s = this.subscriptions[i];
            s.unsubscribe(), this.remove(s);
          }
        }

        this.subscriptions = null;
      }

      this.destination.next(t);
    }, t;
  }(OuterSubscriber);

  function range(e, t, r) {
    return void 0 === e && (e = 0), new Observable(function (n) {
      void 0 === t && (t = e, e = 0);
      var o = 0,
          i = e;
      if (r) return r.schedule(dispatch$6, 0, {
        index: o,
        count: t,
        start: e,
        subscriber: n
      });

      for (;;) {
        if (o++ >= t) {
          n.complete();
          break;
        }

        if (n.next(i++), n.closed) break;
      }
    });
  }

  function dispatch$6(e) {
    var t = e.start,
        r = e.index,
        n = e.count,
        o = e.subscriber;
    r >= n ? o.complete() : (o.next(t), o.closed || (e.index = r + 1, e.start = t + 1, this.schedule(e)));
  }

  function timer(e, t, r) {
    void 0 === e && (e = 0);
    var n = -1;
    return isNumeric(t) ? n = Number(t) < 1 ? 1 : Number(t) : isScheduler(t) && (r = t), isScheduler(r) || (r = async), new Observable(function (t) {
      var o = isNumeric(e) ? e : +e - r.now();
      return r.schedule(dispatch$7, o, {
        index: 0,
        period: n,
        subscriber: t
      });
    });
  }

  function dispatch$7(e) {
    var t = e.index,
        r = e.period,
        n = e.subscriber;

    if (n.next(t), !n.closed) {
      if (-1 === r) return n.complete();
      e.index = t + 1, this.schedule(e, r);
    }
  }

  function using(e, t) {
    return new Observable(function (r) {
      var n, o;

      try {
        n = e();
      } catch (e) {
        return void r.error(e);
      }

      try {
        o = t(n);
      } catch (e) {
        return void r.error(e);
      }

      var i = (o ? from(o) : EMPTY).subscribe(r);
      return function () {
        i.unsubscribe(), n && n.unsubscribe();
      };
    });
  }

  function zip() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    var r = e[e.length - 1];
    return "function" == typeof r && e.pop(), fromArray(e, void 0).lift(new ZipOperator(r));
  }

  var ZipOperator = function () {
    function e(e) {
      this.resultSelector = e;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new ZipSubscriber(e, this.resultSelector));
    }, e;
  }(),
      ZipSubscriber = function (e) {
    function t(t, r, n) {
      void 0 === n && (n = Object.create(null));
      var o = e.call(this, t) || this;
      return o.iterators = [], o.active = 0, o.resultSelector = "function" == typeof r ? r : null, o.values = n, o;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      var t = this.iterators;
      isArray$1(e) ? t.push(new StaticArrayIterator(e)) : "function" == typeof e[iterator] ? t.push(new StaticIterator(e[iterator]())) : t.push(new ZipBufferIterator(this.destination, this, e));
    }, t.prototype._complete = function () {
      var e = this.iterators,
          t = e.length;

      if (this.unsubscribe(), 0 !== t) {
        this.active = t;

        for (var r = 0; r < t; r++) {
          var n = e[r];
          if (n.stillUnsubscribed) this.destination.add(n.subscribe(n, r));else this.active--;
        }
      } else this.destination.complete();
    }, t.prototype.notifyInactive = function () {
      this.active--, 0 === this.active && this.destination.complete();
    }, t.prototype.checkIterators = function () {
      for (var e = this.iterators, t = e.length, r = this.destination, n = 0; n < t; n++) {
        if ("function" == typeof (s = e[n]).hasValue && !s.hasValue()) return;
      }

      var o = !1,
          i = [];

      for (n = 0; n < t; n++) {
        var s,
            a = (s = e[n]).next();
        if (s.hasCompleted() && (o = !0), a.done) return void r.complete();
        i.push(a.value);
      }

      this.resultSelector ? this._tryresultSelector(i) : r.next(i), o && r.complete();
    }, t.prototype._tryresultSelector = function (e) {
      var t;

      try {
        t = this.resultSelector.apply(this, e);
      } catch (e) {
        return void this.destination.error(e);
      }

      this.destination.next(t);
    }, t;
  }(Subscriber),
      StaticIterator = function () {
    function e(e) {
      this.iterator = e, this.nextResult = e.next();
    }

    return e.prototype.hasValue = function () {
      return !0;
    }, e.prototype.next = function () {
      var e = this.nextResult;
      return this.nextResult = this.iterator.next(), e;
    }, e.prototype.hasCompleted = function () {
      var e = this.nextResult;
      return e && e.done;
    }, e;
  }(),
      StaticArrayIterator = function () {
    function e(e) {
      this.array = e, this.index = 0, this.length = 0, this.length = e.length;
    }

    return e.prototype[iterator] = function () {
      return this;
    }, e.prototype.next = function (e) {
      var t = this.index++,
          r = this.array;
      return t < this.length ? {
        value: r[t],
        done: !1
      } : {
        value: null,
        done: !0
      };
    }, e.prototype.hasValue = function () {
      return this.array.length > this.index;
    }, e.prototype.hasCompleted = function () {
      return this.array.length === this.index;
    }, e;
  }(),
      ZipBufferIterator = function (e) {
    function t(t, r, n) {
      var o = e.call(this, t) || this;
      return o.parent = r, o.observable = n, o.stillUnsubscribed = !0, o.buffer = [], o.isComplete = !1, o;
    }

    return __extends(t, e), t.prototype[iterator] = function () {
      return this;
    }, t.prototype.next = function () {
      var e = this.buffer;
      return 0 === e.length && this.isComplete ? {
        value: null,
        done: !0
      } : {
        value: e.shift(),
        done: !1
      };
    }, t.prototype.hasValue = function () {
      return this.buffer.length > 0;
    }, t.prototype.hasCompleted = function () {
      return 0 === this.buffer.length && this.isComplete;
    }, t.prototype.notifyComplete = function () {
      this.buffer.length > 0 ? (this.isComplete = !0, this.parent.notifyInactive()) : this.destination.complete();
    }, t.prototype.notifyNext = function (e, t, r, n, o) {
      this.buffer.push(t), this.parent.checkIterators();
    }, t.prototype.subscribe = function (e, t) {
      return subscribeToResult(this, this.observable, this, t);
    }, t;
  }(OuterSubscriber),
      _esm5 = Object.freeze({
    __proto__: null,
    Observable: Observable,
    ConnectableObservable: ConnectableObservable,
    GroupedObservable: GroupedObservable,
    observable: observable,
    Subject: Subject,
    BehaviorSubject: BehaviorSubject,
    ReplaySubject: ReplaySubject,
    AsyncSubject: AsyncSubject,
    asapScheduler: asap,
    asyncScheduler: async,
    queueScheduler: queue$1,
    animationFrameScheduler: animationFrame,
    VirtualTimeScheduler: VirtualTimeScheduler,
    VirtualAction: VirtualAction,
    Scheduler: Scheduler,
    Subscription: Subscription,
    Subscriber: Subscriber,
    Notification: Notification,

    get NotificationKind() {
      return NotificationKind;
    },

    pipe: pipe,
    noop: noop$1,
    identity: identity$1,
    isObservable: isObservable,
    ArgumentOutOfRangeError: ArgumentOutOfRangeError,
    EmptyError: EmptyError,
    ObjectUnsubscribedError: ObjectUnsubscribedError,
    UnsubscriptionError: UnsubscriptionError,
    TimeoutError: TimeoutError,
    bindCallback: bindCallback,
    bindNodeCallback: bindNodeCallback,
    combineLatest: combineLatest,
    concat: concat,
    defer: defer$1,
    empty: empty$2,
    forkJoin: forkJoin,
    from: from,
    fromEvent: fromEvent,
    fromEventPattern: fromEventPattern,
    generate: generate,
    iif: iif,
    interval: interval,
    merge: merge,
    never: never,
    of: of,
    onErrorResumeNext: onErrorResumeNext,
    pairs: pairs,
    partition: partition,
    race: race,
    range: range,
    throwError: throwError,
    timer: timer,
    using: using,
    zip: zip,
    scheduled: scheduled,
    EMPTY: EMPTY,
    NEVER: NEVER,
    config: config
  });

  function catchError(e) {
    return function (t) {
      var r = new CatchOperator(e),
          n = t.lift(r);
      return r.caught = n;
    };
  }

  var CatchOperator = function () {
    function e(e) {
      this.selector = e;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new CatchSubscriber(e, this.selector, this.caught));
    }, e;
  }(),
      CatchSubscriber = function (e) {
    function t(t, r, n) {
      var o = e.call(this, t) || this;
      return o.selector = r, o.caught = n, o;
    }

    return __extends(t, e), t.prototype.error = function (t) {
      if (!this.isStopped) {
        var r = void 0;

        try {
          r = this.selector(t, this.caught);
        } catch (t) {
          return void e.prototype.error.call(this, t);
        }

        this._unsubscribeAndRecycle();

        var n = new InnerSubscriber(this, void 0, void 0);
        this.add(n), subscribeToResult(this, r, void 0, void 0, n);
      }
    }, t;
  }(OuterSubscriber);

  function concatMap(e, t) {
    return mergeMap(e, t, 1);
  }

  function defaultIfEmpty(e) {
    return void 0 === e && (e = null), function (t) {
      return t.lift(new DefaultIfEmptyOperator(e));
    };
  }

  var DefaultIfEmptyOperator = function () {
    function e(e) {
      this.defaultValue = e;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new DefaultIfEmptySubscriber(e, this.defaultValue));
    }, e;
  }(),
      DefaultIfEmptySubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.defaultValue = r, n.isEmpty = !0, n;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      this.isEmpty = !1, this.destination.next(e);
    }, t.prototype._complete = function () {
      this.isEmpty && this.destination.next(this.defaultValue), this.destination.complete();
    }, t;
  }(Subscriber);

  function isDate(e) {
    return e instanceof Date && !isNaN(+e);
  }

  function delay(e, t) {
    void 0 === t && (t = async);
    var r = isDate(e) ? +e - t.now() : Math.abs(e);
    return function (e) {
      return e.lift(new DelayOperator(r, t));
    };
  }

  var DelayOperator = function () {
    function e(e, t) {
      this.delay = e, this.scheduler = t;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new DelaySubscriber(e, this.delay, this.scheduler));
    }, e;
  }(),
      DelaySubscriber = function (e) {
    function t(t, r, n) {
      var o = e.call(this, t) || this;
      return o.delay = r, o.scheduler = n, o.queue = [], o.active = !1, o.errored = !1, o;
    }

    return __extends(t, e), t.dispatch = function (e) {
      for (var t = e.source, r = t.queue, n = e.scheduler, o = e.destination; r.length > 0 && r[0].time - n.now() <= 0;) {
        r.shift().notification.observe(o);
      }

      if (r.length > 0) {
        var i = Math.max(0, r[0].time - n.now());
        this.schedule(e, i);
      } else this.unsubscribe(), t.active = !1;
    }, t.prototype._schedule = function (e) {
      this.active = !0, this.destination.add(e.schedule(t.dispatch, this.delay, {
        source: this,
        destination: this.destination,
        scheduler: e
      }));
    }, t.prototype.scheduleNotification = function (e) {
      if (!0 !== this.errored) {
        var t = this.scheduler,
            r = new DelayMessage(t.now() + this.delay, e);
        this.queue.push(r), !1 === this.active && this._schedule(t);
      }
    }, t.prototype._next = function (e) {
      this.scheduleNotification(Notification.createNext(e));
    }, t.prototype._error = function (e) {
      this.errored = !0, this.queue = [], this.destination.error(e), this.unsubscribe();
    }, t.prototype._complete = function () {
      this.scheduleNotification(Notification.createComplete()), this.unsubscribe();
    }, t;
  }(Subscriber),
      DelayMessage = function () {
    return function (e, t) {
      this.time = e, this.notification = t;
    };
  }();

  function distinct(e, t) {
    return function (r) {
      return r.lift(new DistinctOperator(e, t));
    };
  }

  var DistinctOperator = function () {
    function e(e, t) {
      this.keySelector = e, this.flushes = t;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new DistinctSubscriber(e, this.keySelector, this.flushes));
    }, e;
  }(),
      DistinctSubscriber = function (e) {
    function t(t, r, n) {
      var o = e.call(this, t) || this;
      return o.keySelector = r, o.values = new Set(), n && o.add(subscribeToResult(o, n)), o;
    }

    return __extends(t, e), t.prototype.notifyNext = function (e, t, r, n, o) {
      this.values.clear();
    }, t.prototype.notifyError = function (e, t) {
      this._error(e);
    }, t.prototype._next = function (e) {
      this.keySelector ? this._useKeySelector(e) : this._finalizeNext(e, e);
    }, t.prototype._useKeySelector = function (e) {
      var t,
          r = this.destination;

      try {
        t = this.keySelector(e);
      } catch (e) {
        return void r.error(e);
      }

      this._finalizeNext(t, e);
    }, t.prototype._finalizeNext = function (e, t) {
      var r = this.values;
      r.has(e) || (r.add(e), this.destination.next(t));
    }, t;
  }(OuterSubscriber);

  function throwIfEmpty(e) {
    return void 0 === e && (e = defaultErrorFactory), function (t) {
      return t.lift(new ThrowIfEmptyOperator(e));
    };
  }

  var ThrowIfEmptyOperator = function () {
    function e(e) {
      this.errorFactory = e;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new ThrowIfEmptySubscriber(e, this.errorFactory));
    }, e;
  }(),
      ThrowIfEmptySubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.errorFactory = r, n.hasValue = !1, n;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      this.hasValue = !0, this.destination.next(e);
    }, t.prototype._complete = function () {
      if (this.hasValue) return this.destination.complete();
      var e = void 0;

      try {
        e = this.errorFactory();
      } catch (t) {
        e = t;
      }

      this.destination.error(e);
    }, t;
  }(Subscriber);

  function defaultErrorFactory() {
    return new EmptyError();
  }

  function take(e) {
    return function (t) {
      return 0 === e ? empty$2() : t.lift(new TakeOperator(e));
    };
  }

  var TakeOperator = function () {
    function e(e) {
      if (this.total = e, this.total < 0) throw new ArgumentOutOfRangeError();
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new TakeSubscriber(e, this.total));
    }, e;
  }(),
      TakeSubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.total = r, n.count = 0, n;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      var t = this.total,
          r = ++this.count;
      r <= t && (this.destination.next(e), r === t && (this.destination.complete(), this.unsubscribe()));
    }, t;
  }(Subscriber);

  function exhaustMap(e, t) {
    return t ? function (r) {
      return r.pipe(exhaustMap(function (r, n) {
        return from(e(r, n)).pipe(map$1(function (e, o) {
          return t(r, e, n, o);
        }));
      }));
    } : function (t) {
      return t.lift(new ExhaustMapOperator(e));
    };
  }

  var ExhaustMapOperator = function () {
    function e(e) {
      this.project = e;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new ExhaustMapSubscriber(e, this.project));
    }, e;
  }(),
      ExhaustMapSubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.project = r, n.hasSubscription = !1, n.hasCompleted = !1, n.index = 0, n;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      this.hasSubscription || this.tryNext(e);
    }, t.prototype.tryNext = function (e) {
      var t,
          r = this.index++;

      try {
        t = this.project(e, r);
      } catch (e) {
        return void this.destination.error(e);
      }

      this.hasSubscription = !0, this._innerSub(t, e, r);
    }, t.prototype._innerSub = function (e, t, r) {
      var n = new InnerSubscriber(this, void 0, void 0);
      this.destination.add(n), subscribeToResult(this, e, t, r, n);
    }, t.prototype._complete = function () {
      this.hasCompleted = !0, this.hasSubscription || this.destination.complete(), this.unsubscribe();
    }, t.prototype.notifyNext = function (e, t, r, n, o) {
      this.destination.next(t);
    }, t.prototype.notifyError = function (e) {
      this.destination.error(e);
    }, t.prototype.notifyComplete = function (e) {
      this.destination.remove(e), this.hasSubscription = !1, this.hasCompleted && this.destination.complete();
    }, t;
  }(OuterSubscriber);

  function finalize(e) {
    return function (t) {
      return t.lift(new FinallyOperator(e));
    };
  }

  var FinallyOperator = function () {
    function e(e) {
      this.callback = e;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new FinallySubscriber(e, this.callback));
    }, e;
  }(),
      FinallySubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.add(new Subscription(r)), n;
    }

    return __extends(t, e), t;
  }(Subscriber);

  function first(e, t) {
    var r = arguments.length >= 2;
    return function (n) {
      return n.pipe(e ? filter(function (t, r) {
        return e(t, r, n);
      }) : identity$1, take(1), r ? defaultIfEmpty(t) : throwIfEmpty(function () {
        return new EmptyError();
      }));
    };
  }

  function ignoreElements() {
    return function (e) {
      return e.lift(new IgnoreElementsOperator());
    };
  }

  var IgnoreElementsOperator = function () {
    function e() {}

    return e.prototype.call = function (e, t) {
      return t.subscribe(new IgnoreElementsSubscriber(e));
    }, e;
  }(),
      IgnoreElementsSubscriber = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return __extends(t, e), t.prototype._next = function (e) {}, t;
  }(Subscriber);

  function takeLast(e) {
    return function (t) {
      return 0 === e ? empty$2() : t.lift(new TakeLastOperator(e));
    };
  }

  var TakeLastOperator = function () {
    function e(e) {
      if (this.total = e, this.total < 0) throw new ArgumentOutOfRangeError();
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new TakeLastSubscriber(e, this.total));
    }, e;
  }(),
      TakeLastSubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.total = r, n.ring = new Array(), n.count = 0, n;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      var t = this.ring,
          r = this.total,
          n = this.count++;
      t.length < r ? t.push(e) : t[n % r] = e;
    }, t.prototype._complete = function () {
      var e = this.destination,
          t = this.count;
      if (t > 0) for (var r = this.count >= this.total ? this.total : this.count, n = this.ring, o = 0; o < r; o++) {
        var i = t++ % r;
        e.next(n[i]);
      }
      e.complete();
    }, t;
  }(Subscriber);

  function mapTo(e) {
    return function (t) {
      return t.lift(new MapToOperator(e));
    };
  }

  var MapToOperator = function () {
    function e(e) {
      this.value = e;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new MapToSubscriber(e, this.value));
    }, e;
  }(),
      MapToSubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.value = r, n;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      this.destination.next(this.value);
    }, t;
  }(Subscriber);

  function scan(e, t) {
    var r = !1;
    return arguments.length >= 2 && (r = !0), function (n) {
      return n.lift(new ScanOperator(e, t, r));
    };
  }

  var ScanOperator = function () {
    function e(e, t, r) {
      void 0 === r && (r = !1), this.accumulator = e, this.seed = t, this.hasSeed = r;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new ScanSubscriber(e, this.accumulator, this.seed, this.hasSeed));
    }, e;
  }(),
      ScanSubscriber = function (e) {
    function t(t, r, n, o) {
      var i = e.call(this, t) || this;
      return i.accumulator = r, i._seed = n, i.hasSeed = o, i.index = 0, i;
    }

    return __extends(t, e), Object.defineProperty(t.prototype, "seed", {
      get: function get() {
        return this._seed;
      },
      set: function set(e) {
        this.hasSeed = !0, this._seed = e;
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype._next = function (e) {
      if (this.hasSeed) return this._tryNext(e);
      this.seed = e, this.destination.next(e);
    }, t.prototype._tryNext = function (e) {
      var t,
          r = this.index++;

      try {
        t = this.accumulator(this.seed, e, r);
      } catch (e) {
        this.destination.error(e);
      }

      this.seed = t, this.destination.next(t);
    }, t;
  }(Subscriber);

  function reduce(e, t) {
    return arguments.length >= 2 ? function (r) {
      return pipe(scan(e, t), takeLast(1), defaultIfEmpty(t))(r);
    } : function (t) {
      return pipe(scan(function (t, r, n) {
        return e(t, r, n + 1);
      }), takeLast(1))(t);
    };
  }

  function multicast(e, t) {
    return function (r) {
      var n;
      if (n = "function" == typeof e ? e : function () {
        return e;
      }, "function" == typeof t) return r.lift(new MulticastOperator(n, t));
      var o = Object.create(r, connectableObservableDescriptor);
      return o.source = r, o.subjectFactory = n, o;
    };
  }

  var MulticastOperator = function () {
    function e(e, t) {
      this.subjectFactory = e, this.selector = t;
    }

    return e.prototype.call = function (e, t) {
      var r = this.selector,
          n = this.subjectFactory(),
          o = r(n).subscribe(e);
      return o.add(t.subscribe(n)), o;
    }, e;
  }();

  function retryWhen(e) {
    return function (t) {
      return t.lift(new RetryWhenOperator(e, t));
    };
  }

  var RetryWhenOperator = function () {
    function e(e, t) {
      this.notifier = e, this.source = t;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new RetryWhenSubscriber(e, this.notifier, this.source));
    }, e;
  }(),
      RetryWhenSubscriber = function (e) {
    function t(t, r, n) {
      var o = e.call(this, t) || this;
      return o.notifier = r, o.source = n, o;
    }

    return __extends(t, e), t.prototype.error = function (t) {
      if (!this.isStopped) {
        var r = this.errors,
            n = this.retries,
            o = this.retriesSubscription;
        if (n) this.errors = null, this.retriesSubscription = null;else {
          r = new Subject();

          try {
            n = (0, this.notifier)(r);
          } catch (t) {
            return e.prototype.error.call(this, t);
          }

          o = subscribeToResult(this, n);
        }
        this._unsubscribeAndRecycle(), this.errors = r, this.retries = n, this.retriesSubscription = o, r.next(t);
      }
    }, t.prototype._unsubscribe = function () {
      var e = this.errors,
          t = this.retriesSubscription;
      e && (e.unsubscribe(), this.errors = null), t && (t.unsubscribe(), this.retriesSubscription = null), this.retries = null;
    }, t.prototype.notifyNext = function (e, t, r, n, o) {
      var i = this._unsubscribe;
      this._unsubscribe = null, this._unsubscribeAndRecycle(), this._unsubscribe = i, this.source.subscribe(this);
    }, t;
  }(OuterSubscriber);

  function shareSubjectFactory() {
    return new Subject();
  }

  function share() {
    return function (e) {
      return refCount()(multicast(shareSubjectFactory)(e));
    };
  }

  function shareReplay(e, t, r) {
    var n;
    return n = e && "object" === _typeof(e) ? e : {
      bufferSize: e,
      windowTime: t,
      refCount: !1,
      scheduler: r
    }, function (e) {
      return e.lift(shareReplayOperator(n));
    };
  }

  function shareReplayOperator(e) {
    var t,
        r,
        n = e.bufferSize,
        o = void 0 === n ? Number.POSITIVE_INFINITY : n,
        i = e.windowTime,
        s = void 0 === i ? Number.POSITIVE_INFINITY : i,
        a = e.refCount,
        u = e.scheduler,
        l = 0,
        c = !1,
        p = !1;
    return function (e) {
      l++, t && !c || (c = !1, t = new ReplaySubject(o, s, u), r = e.subscribe({
        next: function next(e) {
          t.next(e);
        },
        error: function error(e) {
          c = !0, t.error(e);
        },
        complete: function complete() {
          p = !0, t.complete();
        }
      }));
      var n = t.subscribe(this);
      this.add(function () {
        l--, n.unsubscribe(), r && !p && a && 0 === l && (r.unsubscribe(), r = void 0, t = void 0);
      });
    };
  }

  var SubscribeOnObservable = function (e) {
    function t(t, r, n) {
      void 0 === r && (r = 0), void 0 === n && (n = asap);
      var o = e.call(this) || this;
      return o.source = t, o.delayTime = r, o.scheduler = n, (!isNumeric(r) || r < 0) && (o.delayTime = 0), n && "function" == typeof n.schedule || (o.scheduler = asap), o;
    }

    return __extends(t, e), t.create = function (e, r, n) {
      return void 0 === r && (r = 0), void 0 === n && (n = asap), new t(e, r, n);
    }, t.dispatch = function (e) {
      var t = e.source,
          r = e.subscriber;
      return this.add(t.subscribe(r));
    }, t.prototype._subscribe = function (e) {
      var r = this.delayTime,
          n = this.source;
      return this.scheduler.schedule(t.dispatch, r, {
        source: n,
        subscriber: e
      });
    }, t;
  }(Observable);

  function subscribeOn(e, t) {
    return void 0 === t && (t = 0), function (r) {
      return r.lift(new SubscribeOnOperator(e, t));
    };
  }

  var SubscribeOnOperator = function () {
    function e(e, t) {
      this.scheduler = e, this.delay = t;
    }

    return e.prototype.call = function (e, t) {
      return new SubscribeOnObservable(t, this.delay, this.scheduler).subscribe(e);
    }, e;
  }();

  function switchMap(e, t) {
    return "function" == typeof t ? function (r) {
      return r.pipe(switchMap(function (r, n) {
        return from(e(r, n)).pipe(map$1(function (e, o) {
          return t(r, e, n, o);
        }));
      }));
    } : function (t) {
      return t.lift(new SwitchMapOperator(e));
    };
  }

  var SwitchMapOperator = function () {
    function e(e) {
      this.project = e;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new SwitchMapSubscriber(e, this.project));
    }, e;
  }(),
      SwitchMapSubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.project = r, n.index = 0, n;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      var t,
          r = this.index++;

      try {
        t = this.project(e, r);
      } catch (e) {
        return void this.destination.error(e);
      }

      this._innerSub(t, e, r);
    }, t.prototype._innerSub = function (e, t, r) {
      var n = this.innerSubscription;
      n && n.unsubscribe();
      var o = new InnerSubscriber(this, void 0, void 0);
      this.destination.add(o), this.innerSubscription = subscribeToResult(this, e, t, r, o);
    }, t.prototype._complete = function () {
      var t = this.innerSubscription;
      t && !t.closed || e.prototype._complete.call(this), this.unsubscribe();
    }, t.prototype._unsubscribe = function () {
      this.innerSubscription = null;
    }, t.prototype.notifyComplete = function (t) {
      this.destination.remove(t), this.innerSubscription = null, this.isStopped && e.prototype._complete.call(this);
    }, t.prototype.notifyNext = function (e, t, r, n, o) {
      this.destination.next(t);
    }, t;
  }(OuterSubscriber);

  function switchAll() {
    return switchMap(identity$1);
  }

  function takeUntil(e) {
    return function (t) {
      return t.lift(new TakeUntilOperator(e));
    };
  }

  var TakeUntilOperator = function () {
    function e(e) {
      this.notifier = e;
    }

    return e.prototype.call = function (e, t) {
      var r = new TakeUntilSubscriber(e),
          n = subscribeToResult(r, this.notifier);
      return n && !r.seenValue ? (r.add(n), t.subscribe(r)) : r;
    }, e;
  }(),
      TakeUntilSubscriber = function (e) {
    function t(t) {
      var r = e.call(this, t) || this;
      return r.seenValue = !1, r;
    }

    return __extends(t, e), t.prototype.notifyNext = function (e, t, r, n, o) {
      this.seenValue = !0, this.complete();
    }, t.prototype.notifyComplete = function () {}, t;
  }(OuterSubscriber);

  function takeWhile(e, t) {
    return void 0 === t && (t = !1), function (r) {
      return r.lift(new TakeWhileOperator(e, t));
    };
  }

  var TakeWhileOperator = function () {
    function e(e, t) {
      this.predicate = e, this.inclusive = t;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new TakeWhileSubscriber(e, this.predicate, this.inclusive));
    }, e;
  }(),
      TakeWhileSubscriber = function (e) {
    function t(t, r, n) {
      var o = e.call(this, t) || this;
      return o.predicate = r, o.inclusive = n, o.index = 0, o;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      var t,
          r = this.destination;

      try {
        t = this.predicate(e, this.index++);
      } catch (e) {
        return void r.error(e);
      }

      this.nextOrComplete(e, t);
    }, t.prototype.nextOrComplete = function (e, t) {
      var r = this.destination;
      Boolean(t) ? r.next(e) : (this.inclusive && r.next(e), r.complete());
    }, t;
  }(Subscriber);

  function tap(e, t, r) {
    return function (n) {
      return n.lift(new DoOperator(e, t, r));
    };
  }

  var DoOperator = function () {
    function e(e, t, r) {
      this.nextOrObserver = e, this.error = t, this.complete = r;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new TapSubscriber(e, this.nextOrObserver, this.error, this.complete));
    }, e;
  }(),
      TapSubscriber = function (e) {
    function t(t, r, n, o) {
      var i = e.call(this, t) || this;
      return i._tapNext = noop$1, i._tapError = noop$1, i._tapComplete = noop$1, i._tapError = n || noop$1, i._tapComplete = o || noop$1, isFunction$1(r) ? (i._context = i, i._tapNext = r) : r && (i._context = r, i._tapNext = r.next || noop$1, i._tapError = r.error || noop$1, i._tapComplete = r.complete || noop$1), i;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      try {
        this._tapNext.call(this._context, e);
      } catch (e) {
        return void this.destination.error(e);
      }

      this.destination.next(e);
    }, t.prototype._error = function (e) {
      try {
        this._tapError.call(this._context, e);
      } catch (e) {
        return void this.destination.error(e);
      }

      this.destination.error(e);
    }, t.prototype._complete = function () {
      try {
        this._tapComplete.call(this._context);
      } catch (e) {
        return void this.destination.error(e);
      }

      return this.destination.complete();
    }, t;
  }(Subscriber),
      defaultThrottleConfig = {
    leading: !0,
    trailing: !1
  };

  function throttleTime(e, t, r) {
    return void 0 === t && (t = async), void 0 === r && (r = defaultThrottleConfig), function (n) {
      return n.lift(new ThrottleTimeOperator(e, t, r.leading, r.trailing));
    };
  }

  var ThrottleTimeOperator = function () {
    function e(e, t, r, n) {
      this.duration = e, this.scheduler = t, this.leading = r, this.trailing = n;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new ThrottleTimeSubscriber(e, this.duration, this.scheduler, this.leading, this.trailing));
    }, e;
  }(),
      ThrottleTimeSubscriber = function (e) {
    function t(t, r, n, o, i) {
      var s = e.call(this, t) || this;
      return s.duration = r, s.scheduler = n, s.leading = o, s.trailing = i, s._hasTrailingValue = !1, s._trailingValue = null, s;
    }

    return __extends(t, e), t.prototype._next = function (e) {
      this.throttled ? this.trailing && (this._trailingValue = e, this._hasTrailingValue = !0) : (this.add(this.throttled = this.scheduler.schedule(dispatchNext$2, this.duration, {
        subscriber: this
      })), this.leading ? this.destination.next(e) : this.trailing && (this._trailingValue = e, this._hasTrailingValue = !0));
    }, t.prototype._complete = function () {
      this._hasTrailingValue ? (this.destination.next(this._trailingValue), this.destination.complete()) : this.destination.complete();
    }, t.prototype.clearThrottle = function () {
      var e = this.throttled;
      e && (this.trailing && this._hasTrailingValue && (this.destination.next(this._trailingValue), this._trailingValue = null, this._hasTrailingValue = !1), e.unsubscribe(), this.remove(e), this.throttled = null);
    }, t;
  }(Subscriber);

  function dispatchNext$2(e) {
    e.subscriber.clearThrottle();
  }

  function timeoutWith(e, t, r) {
    return void 0 === r && (r = async), function (n) {
      var o = isDate(e),
          i = o ? +e - r.now() : Math.abs(e);
      return n.lift(new TimeoutWithOperator(i, o, t, r));
    };
  }

  var TimeoutWithOperator = function () {
    function e(e, t, r, n) {
      this.waitFor = e, this.absoluteTimeout = t, this.withObservable = r, this.scheduler = n;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new TimeoutWithSubscriber(e, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    }, e;
  }(),
      TimeoutWithSubscriber = function (e) {
    function t(t, r, n, o, i) {
      var s = e.call(this, t) || this;
      return s.absoluteTimeout = r, s.waitFor = n, s.withObservable = o, s.scheduler = i, s.action = null, s.scheduleTimeout(), s;
    }

    return __extends(t, e), t.dispatchTimeout = function (e) {
      var t = e.withObservable;
      e._unsubscribeAndRecycle(), e.add(subscribeToResult(e, t));
    }, t.prototype.scheduleTimeout = function () {
      var e = this.action;
      e ? this.action = e.schedule(this, this.waitFor) : this.add(this.action = this.scheduler.schedule(t.dispatchTimeout, this.waitFor, this));
    }, t.prototype._next = function (t) {
      this.absoluteTimeout || this.scheduleTimeout(), e.prototype._next.call(this, t);
    }, t.prototype._unsubscribe = function () {
      this.action = null, this.scheduler = null, this.withObservable = null;
    }, t;
  }(OuterSubscriber);

  function timeout(e, t) {
    return void 0 === t && (t = async), timeoutWith(e, throwError(new TimeoutError()), t);
  }

  function withLatestFrom() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    return function (t) {
      var r;
      "function" == typeof e[e.length - 1] && (r = e.pop());
      var n = e;
      return t.lift(new WithLatestFromOperator(n, r));
    };
  }

  for (var WithLatestFromOperator = function () {
    function e(e, t) {
      this.observables = e, this.project = t;
    }

    return e.prototype.call = function (e, t) {
      return t.subscribe(new WithLatestFromSubscriber(e, this.observables, this.project));
    }, e;
  }(), WithLatestFromSubscriber = function (e) {
    function t(t, r, n) {
      var o = e.call(this, t) || this;
      o.observables = r, o.project = n, o.toRespond = [];
      var i = r.length;
      o.values = new Array(i);

      for (var s = 0; s < i; s++) {
        o.toRespond.push(s);
      }

      for (s = 0; s < i; s++) {
        var a = r[s];
        o.add(subscribeToResult(o, a, a, s));
      }

      return o;
    }

    return __extends(t, e), t.prototype.notifyNext = function (e, t, r, n, o) {
      this.values[r] = t;
      var i = this.toRespond;

      if (i.length > 0) {
        var s = i.indexOf(r);
        -1 !== s && i.splice(s, 1);
      }
    }, t.prototype.notifyComplete = function () {}, t.prototype._next = function (e) {
      if (0 === this.toRespond.length) {
        var t = [e].concat(this.values);
        this.project ? this._tryProject(t) : this.destination.next(t);
      }
    }, t.prototype._tryProject = function (e) {
      var t;

      try {
        t = this.project.apply(this, e);
      } catch (e) {
        return void this.destination.error(e);
      }

      this.destination.next(t);
    }, t;
  }(OuterSubscriber), rngBrowser = createCommonjsModule(function (e) {
    var t = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

    if (t) {
      var r = new Uint8Array(16);

      e.exports = function () {
        return t(r), r;
      };
    } else {
      var n = new Array(16);

      e.exports = function () {
        for (var e, t = 0; t < 16; t++) {
          0 == (3 & t) && (e = 4294967296 * Math.random()), n[t] = e >>> ((3 & t) << 3) & 255;
        }

        return n;
      };
    }
  }), byteToHex = [], i$3 = 0; i$3 < 256; ++i$3) {
    byteToHex[i$3] = (i$3 + 256).toString(16).substr(1);
  }

  function bytesToUuid(e, t) {
    var r = t || 0,
        n = byteToHex;
    return [n[e[r++]], n[e[r++]], n[e[r++]], n[e[r++]], "-", n[e[r++]], n[e[r++]], "-", n[e[r++]], n[e[r++]], "-", n[e[r++]], n[e[r++]], "-", n[e[r++]], n[e[r++]], n[e[r++]], n[e[r++]], n[e[r++]], n[e[r++]]].join("");
  }

  var bytesToUuid_1 = bytesToUuid;

  function v4(e, t, r) {
    var n = t && r || 0;
    "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
    var o = (e = e || {}).random || (e.rng || rngBrowser)();
    if (o[6] = 15 & o[6] | 64, o[8] = 63 & o[8] | 128, t) for (var i = 0; i < 16; ++i) {
      t[n + i] = o[i];
    }
    return t || bytesToUuid_1(o);
  }

  var v4_1 = v4,
      version = "1.4.0",
      BUILD = "v1.4.0-0-g2c45f3b",
      processId = v4_1(),
      WEB_PLATFORM_TYPE = 7,
      VERSION_NO = 4,
      SUBVERSION = 8,
      END_CALL_PREFIX = "AgoraRTMLegacyEndcallCompatibleMessagePrefix",
      MESSAGE_MEDIA_DESCRIPTION_KEY = "media_description",
      MESSAGE_MEDIA_WIDTH_KEY = "media_width",
      MESSAGE_MEDIA_HEIGHT_KEY = "media_height",
      MESSAGE_MEDIA_THUMBNAIL_KEY = "media_thumbnail",
      MESSAGE_MEDIA_THUMBNAILWIDTH_KEY = "media_thumbnailwidth",
      MESSAGE_MEDIA_THUMBNAILHEIGHT_KEY = "media_thumbnailheight",
      MESSAGE_MEDIA_SIZE_KEY = "media_size",
      MESSAGE_MEDIA_ID_KEY = "media_id",
      MESSAGE_MEDIA_FILENAME_KEY = "media_filename",
      AttributeOperationError,
      ChannelMessageError,
      CreateChannelError,
      CreateInstanceError,
      GetMembersError,
      InvitationApiCallError,
      JoinChannelError,
      LeaveChannelError,
      LoginError,
      LogoutError,
      PeerMessageError,
      QueryPeersOnlineStatusError,
      RenewTokenError,
      GetChannelMemberCountErrCode,
      PeerSubscriptionStatusError,
      QueryPeersBySubscriptionOptionError,
      UploadMediaError,
      DownloadMediaError;
  !function (e) {
    e[e.ATTRIBUTE_OPERATION_ERR_FAILURE = 2] = "ATTRIBUTE_OPERATION_ERR_FAILURE", e[e.ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT = 3] = "ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT", e[e.ATTRIBUTE_OPERATION_ERR_SIZE_OVERFLOW = 4] = "ATTRIBUTE_OPERATION_ERR_SIZE_OVERFLOW", e[e.ATTRIBUTE_OPERATION_ERR_TOO_OFTEN = 5] = "ATTRIBUTE_OPERATION_ERR_TOO_OFTEN", e[e.ATTRIBUTE_OPERATION_ERR_USER_NOT_FOUND = 6] = "ATTRIBUTE_OPERATION_ERR_USER_NOT_FOUND", e[e.ATTRIBUTE_OPERATION_ERR_TIMEOUT = 7] = "ATTRIBUTE_OPERATION_ERR_TIMEOUT", e[e.ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN = 102] = "ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN";
  }(AttributeOperationError || (AttributeOperationError = {})), function (e) {
    e[e.CHANNEL_MESSAGE_ERR_FAILURE = 1] = "CHANNEL_MESSAGE_ERR_FAILURE", e[e.CHANNEL_MESSAGE_ERR_TIMEOUT = 2] = "CHANNEL_MESSAGE_ERR_TIMEOUT", e[e.CHANNEL_MESSAGE_ERR_TOO_OFTEN = 3] = "CHANNEL_MESSAGE_ERR_TOO_OFTEN", e[e.CHANNEL_MESSAGE_ERR_INVALID_MESSAGE = 4] = "CHANNEL_MESSAGE_ERR_INVALID_MESSAGE", e[e.CHANNEL_MESSAGE_ERR_NOT_IN_CHANNEL = 5] = "CHANNEL_MESSAGE_ERR_NOT_IN_CHANNEL", e[e.CHANNEL_MESSAGE_ERR_USER_NOT_LOGGED_IN = 102] = "CHANNEL_MESSAGE_ERR_USER_NOT_LOGGED_IN";
  }(ChannelMessageError || (ChannelMessageError = {})), function (e) {
    e[e.CREATE_CHANNEL_ERR_INVALID_ARGUMENT = 1] = "CREATE_CHANNEL_ERR_INVALID_ARGUMENT";
  }(CreateChannelError || (CreateChannelError = {})), function (e) {
    e[e.CREATE_INSTANCE_ERR_INVALID_ARGUMENT = 1] = "CREATE_INSTANCE_ERR_INVALID_ARGUMENT";
  }(CreateInstanceError || (CreateInstanceError = {})), function (e) {
    e[e.GET_MEMBERS_ERR_FAILURE = 1] = "GET_MEMBERS_ERR_FAILURE", e[e.GET_MEMBERS_ERR_REJECTED = 2] = "GET_MEMBERS_ERR_REJECTED", e[e.GET_MEMBERS_ERR_TIMEOUT = 3] = "GET_MEMBERS_ERR_TIMEOUT", e[e.GET_MEMBERS_ERR_TOO_OFTEN = 4] = "GET_MEMBERS_ERR_TOO_OFTEN", e[e.GET_MEMBERS_ERR_NOT_IN_CHANNEL = 5] = "GET_MEMBERS_ERR_NOT_IN_CHANNEL", e[e.GET_MEMBERS_ERR_USER_NOT_LOGGED_IN = 102] = "GET_MEMBERS_ERR_USER_NOT_LOGGED_IN";
  }(GetMembersError || (GetMembersError = {})), function (e) {
    e[e.INVITATION_API_CALL_ERR_INVALID_ARGUMENT = 1] = "INVITATION_API_CALL_ERR_INVALID_ARGUMENT", e[e.INVITATION_API_CALL_ERR_NOT_STARTED = 2] = "INVITATION_API_CALL_ERR_NOT_STARTED", e[e.INVITATION_API_CALL_ERR_ALREADY_END = 3] = "INVITATION_API_CALL_ERR_ALREADY_END", e[e.INVITATION_API_CALL_ERR_ALREADY_ACCEPT = 4] = "INVITATION_API_CALL_ERR_ALREADY_ACCEPT", e[e.INVITATION_API_CALL_ERR_ALREADY_SENT = 5] = "INVITATION_API_CALL_ERR_ALREADY_SENT";
  }(InvitationApiCallError || (InvitationApiCallError = {})), function (e) {
    e[e.JOIN_CHANNEL_ERR_FAILURE = 1] = "JOIN_CHANNEL_ERR_FAILURE", e[e.JOIN_CHANNEL_ERR_REJECTED = 2] = "JOIN_CHANNEL_ERR_REJECTED", e[e.JOIN_CHANNEL_ERR_INVALID_ARGUMENT = 3] = "JOIN_CHANNEL_ERR_INVALID_ARGUMENT", e[e.JOIN_CHANNEL_TIMEOUT = 4] = "JOIN_CHANNEL_TIMEOUT", e[e.JOIN_CHANNEL_ERR_EXCEED_LIMIT = 5] = "JOIN_CHANNEL_ERR_EXCEED_LIMIT", e[e.JOIN_CHANNEL_ERR_ALREADY_JOINED = 6] = "JOIN_CHANNEL_ERR_ALREADY_JOINED", e[e.JOIN_CHANNEL_ERR_TOO_OFTEN = 7] = "JOIN_CHANNEL_ERR_TOO_OFTEN", e[e.JOIN_CHANNEL_ERR_JOIN_SAME_CHANNEL_TOO_OFTEN = 8] = "JOIN_CHANNEL_ERR_JOIN_SAME_CHANNEL_TOO_OFTEN", e[e.JOIN_CHANNEL_ERR_USER_NOT_LOGGED_IN = 102] = "JOIN_CHANNEL_ERR_USER_NOT_LOGGED_IN", e[e.JOIN_CHANNEL_ERR_ABORTED_BY_LEAVE = 201] = "JOIN_CHANNEL_ERR_ABORTED_BY_LEAVE", e[e.JOIN_CHANNEL_ERR_ALREADY_JOINED_CHANNEL_OF_SAME_ID = 202] = "JOIN_CHANNEL_ERR_ALREADY_JOINED_CHANNEL_OF_SAME_ID";
  }(JoinChannelError || (JoinChannelError = {})), function (e) {
    e[e.LEAVE_CHANNEL_ERR_FAILURE = 1] = "LEAVE_CHANNEL_ERR_FAILURE", e[e.LEAVE_CHANNEL_ERR_REJECTED = 2] = "LEAVE_CHANNEL_ERR_REJECTED", e[e.LEAVE_CHANNEL_ERR_NOT_IN_CHANNEL = 3] = "LEAVE_CHANNEL_ERR_NOT_IN_CHANNEL", e[e.LEAVE_CHANNEL_ERR_USER_NOT_LOGGED_IN = 102] = "LEAVE_CHANNEL_ERR_USER_NOT_LOGGED_IN";
  }(LeaveChannelError || (LeaveChannelError = {})), function (e) {
    e[e.LOGIN_ERR_UNKNOWN = 1] = "LOGIN_ERR_UNKNOWN", e[e.LOGIN_ERR_REJECTED = 2] = "LOGIN_ERR_REJECTED", e[e.LOGIN_ERR_INVALID_ARGUMENT = 3] = "LOGIN_ERR_INVALID_ARGUMENT", e[e.LOGIN_ERR_INVALID_APP_ID = 4] = "LOGIN_ERR_INVALID_APP_ID", e[e.LOGIN_ERR_INVALID_TOKEN = 5] = "LOGIN_ERR_INVALID_TOKEN", e[e.LOGIN_ERR_TOKEN_EXPIRED = 6] = "LOGIN_ERR_TOKEN_EXPIRED", e[e.LOGIN_ERR_NOT_AUTHORIZED = 7] = "LOGIN_ERR_NOT_AUTHORIZED", e[e.LOGIN_ERR_ALREADY_LOGIN = 8] = "LOGIN_ERR_ALREADY_LOGIN", e[e.LOGIN_ERR_TIMEOUT = 9] = "LOGIN_ERR_TIMEOUT", e[e.LOGIN_ERR_TOO_OFTEN = 10] = "LOGIN_ERR_TOO_OFTEN", e[e.LOGIN_ERR_ABORTED_BY_LOGOUT = 201] = "LOGIN_ERR_ABORTED_BY_LOGOUT";
  }(LoginError || (LoginError = {})), function (e) {
    e[e.LOGOUT_ERR_USER_NOT_LOGGED_IN = 102] = "LOGOUT_ERR_USER_NOT_LOGGED_IN";
  }(LogoutError || (LogoutError = {})), function (e) {
    e[e.PEER_MESSAGE_ERR_FAILURE = 1] = "PEER_MESSAGE_ERR_FAILURE", e[e.PEER_MESSAGE_ERR_TIMEOUT = 2] = "PEER_MESSAGE_ERR_TIMEOUT", e[e.PEER_MESSAGE_ERR_TOO_OFTEN = 5] = "PEER_MESSAGE_ERR_TOO_OFTEN", e[e.PEER_MESSAGE_ERR_INVALID_USERID = 6] = "PEER_MESSAGE_ERR_INVALID_USERID", e[e.PEER_MESSAGE_ERR_INVALID_MESSAGE = 7] = "PEER_MESSAGE_ERR_INVALID_MESSAGE", e[e.PEER_MESSAGE_ERR_INCOMPATIBLE_MESSAGE = 8] = "PEER_MESSAGE_ERR_INCOMPATIBLE_MESSAGE", e[e.PEER_MESSAGE_ERR_USER_NOT_LOGGED_IN = 102] = "PEER_MESSAGE_ERR_USER_NOT_LOGGED_IN";
  }(PeerMessageError || (PeerMessageError = {})), function (e) {
    e[e.QUERY_PEERS_ONLINE_STATUS_ERR_INVALID_ARGUMENT = 2] = "QUERY_PEERS_ONLINE_STATUS_ERR_INVALID_ARGUMENT", e[e.QUERY_PEERS_ONLINE_STATUS_ERR_REJECTED = 3] = "QUERY_PEERS_ONLINE_STATUS_ERR_REJECTED", e[e.QUERY_PEERS_ONLINE_STATUS_ERR_TIMEOUT = 4] = "QUERY_PEERS_ONLINE_STATUS_ERR_TIMEOUT", e[e.QUERY_PEERS_ONLINE_STATUS_ERR_TOO_OFTEN = 5] = "QUERY_PEERS_ONLINE_STATUS_ERR_TOO_OFTEN", e[e.QUERY_PEERS_ONLINE_STATUS_ERR_USER_NOT_LOGGED_IN = 102] = "QUERY_PEERS_ONLINE_STATUS_ERR_USER_NOT_LOGGED_IN";
  }(QueryPeersOnlineStatusError || (QueryPeersOnlineStatusError = {})), function (e) {
    e[e.RENEW_TOKEN_ERR_FAILURE = 1] = "RENEW_TOKEN_ERR_FAILURE", e[e.RENEW_TOKEN_ERR_INVALID_ARGUMENT = 2] = "RENEW_TOKEN_ERR_INVALID_ARGUMENT", e[e.RENEW_TOKEN_ERR_REJECTED = 3] = "RENEW_TOKEN_ERR_REJECTED", e[e.RENEW_TOKEN_ERR_TOO_OFTEN = 4] = "RENEW_TOKEN_ERR_TOO_OFTEN", e[e.RENEW_TOKEN_ERR_TOKEN_EXPIRED = 5] = "RENEW_TOKEN_ERR_TOKEN_EXPIRED", e[e.RENEW_TOKEN_ERR_INVALID_TOKEN = 6] = "RENEW_TOKEN_ERR_INVALID_TOKEN", e[e.RENEW_TOKEN_ERR_USER_NOT_LOGGED_IN = 102] = "RENEW_TOKEN_ERR_USER_NOT_LOGGED_IN", e[e.RENEW_TOKEN_ERR_ABORTED_BY_LOGOUT = 201] = "RENEW_TOKEN_ERR_ABORTED_BY_LOGOUT";
  }(RenewTokenError || (RenewTokenError = {})), function (e) {
    e[e.GET_CHANNEL_MEMBER_COUNT_ERR_FAILURE = 1] = "GET_CHANNEL_MEMBER_COUNT_ERR_FAILURE", e[e.GET_CHANNEL_MEMBER_COUNT_ERR_INVALID_ARGUMENT = 2] = "GET_CHANNEL_MEMBER_COUNT_ERR_INVALID_ARGUMENT", e[e.GET_CHANNEL_MEMBER_COUNT_ERR_TOO_OFTEN = 3] = "GET_CHANNEL_MEMBER_COUNT_ERR_TOO_OFTEN", e[e.GET_CHANNEL_MEMBER_COUNT_ERR_TIMEOUT = 4] = "GET_CHANNEL_MEMBER_COUNT_ERR_TIMEOUT", e[e.GET_CHANNEL_MEMBER_COUNT_ERR_EXCEED_LIMIT = 5] = "GET_CHANNEL_MEMBER_COUNT_ERR_EXCEED_LIMIT", e[e.GET_CHANNEL_MEMBER_COUNT_ERR_NOT_INITIALIZED = 101] = "GET_CHANNEL_MEMBER_COUNT_ERR_NOT_INITIALIZED", e[e.GET_CHANNEL_MEMBER_COUNT_ERR_USER_NOT_LOGGED_IN = 102] = "GET_CHANNEL_MEMBER_COUNT_ERR_USER_NOT_LOGGED_IN";
  }(GetChannelMemberCountErrCode || (GetChannelMemberCountErrCode = {})), function (e) {
    e[e.PEER_SUBSCRIPTION_STATUS_ERR_FAILURE = 1] = "PEER_SUBSCRIPTION_STATUS_ERR_FAILURE", e[e.PEER_SUBSCRIPTION_STATUS_ERR_INVALID_ARGUMENT = 2] = "PEER_SUBSCRIPTION_STATUS_ERR_INVALID_ARGUMENT", e[e.PEER_SUBSCRIPTION_STATUS_ERR_REJECTED = 3] = "PEER_SUBSCRIPTION_STATUS_ERR_REJECTED", e[e.PEER_SUBSCRIPTION_STATUS_ERR_TIMEOUT = 4] = "PEER_SUBSCRIPTION_STATUS_ERR_TIMEOUT", e[e.PEER_SUBSCRIPTION_STATUS_ERR_TOO_OFTEN = 5] = "PEER_SUBSCRIPTION_STATUS_ERR_TOO_OFTEN", e[e.PEER_SUBSCRIPTION_STATUS_ERR_OVERFLOW = 6] = "PEER_SUBSCRIPTION_STATUS_ERR_OVERFLOW", e[e.PEER_SUBSCRIPTION_STATUS_ERR_USER_NOT_LOGGED_IN = 102] = "PEER_SUBSCRIPTION_STATUS_ERR_USER_NOT_LOGGED_IN";
  }(PeerSubscriptionStatusError || (PeerSubscriptionStatusError = {})), function (e) {
    e[e.QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_FAILURE = 1] = "QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_FAILURE", e[e.QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_TIMEOUT = 2] = "QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_TIMEOUT", e[e.QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_TOO_OFTEN = 3] = "QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_TOO_OFTEN", e[e.QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_USER_NOT_LOGGED_IN = 102] = "QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_USER_NOT_LOGGED_IN";
  }(QueryPeersBySubscriptionOptionError || (QueryPeersBySubscriptionOptionError = {})), function (e) {
    e[e.UPLOAD_MEDIA_ERR_FAILURE = 1] = "UPLOAD_MEDIA_ERR_FAILURE", e[e.UPLOAD_MEDIA_ERR_INVALID_ARGUMENT = 2] = "UPLOAD_MEDIA_ERR_INVALID_ARGUMENT", e[e.UPLOAD_MEDIA_ERR_TIMEOUT = 3] = "UPLOAD_MEDIA_ERR_TIMEOUT", e[e.UPLOAD_MEDIA_ERR_SIZE_OVERFLOW = 4] = "UPLOAD_MEDIA_ERR_SIZE_OVERFLOW", e[e.UPLOAD_MEDIA_ERR_CONCURRENCY_LIMIT_EXCEEDED = 5] = "UPLOAD_MEDIA_ERR_CONCURRENCY_LIMIT_EXCEEDED", e[e.UPLOAD_MEDIA_ERR_INTERRUPTED = 6] = "UPLOAD_MEDIA_ERR_INTERRUPTED", e[e.UPLOAD_MEDIA_ERR_NOT_LOGGED_IN = 102] = "UPLOAD_MEDIA_ERR_NOT_LOGGED_IN";
  }(UploadMediaError || (UploadMediaError = {})), function (e) {
    e[e.DOWNLOAD_MEDIA_ERR_FAILURE = 1] = "DOWNLOAD_MEDIA_ERR_FAILURE", e[e.DOWNLOAD_MEDIA_ERR_INVALID_ARGUMENT = 2] = "DOWNLOAD_MEDIA_ERR_INVALID_ARGUMENT", e[e.DOWNLOAD_MEDIA_ERR_TIMEOUT = 3] = "DOWNLOAD_MEDIA_ERR_TIMEOUT", e[e.DOWNLOAD_MEDIA_ERR_NOT_EXIST = 4] = "DOWNLOAD_MEDIA_ERR_NOT_EXIST", e[e.DOWNLOAD_MEDIA_ERR_CONCURRENCY_LIMIT_EXCEEDED = 5] = "DOWNLOAD_MEDIA_ERR_CONCURRENCY_LIMIT_EXCEEDED", e[e.DOWNLOAD_MEDIA_ERR_INTERRUPTED = 6] = "DOWNLOAD_MEDIA_ERR_INTERRUPTED", e[e.DOWNLOAD_MEDIA_ERR_NOT_LOGGED_IN = 102] = "DOWNLOAD_MEDIA_ERR_NOT_LOGGED_IN";
  }(DownloadMediaError || (DownloadMediaError = {}));
  var ATTRIBUTE_OPERATION_ERR_FAILURE = AttributeOperationError.ATTRIBUTE_OPERATION_ERR_FAILURE,
      ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT = AttributeOperationError.ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT,
      ATTRIBUTE_OPERATION_ERR_SIZE_OVERFLOW = AttributeOperationError.ATTRIBUTE_OPERATION_ERR_SIZE_OVERFLOW,
      ATTRIBUTE_OPERATION_ERR_TOO_OFTEN = AttributeOperationError.ATTRIBUTE_OPERATION_ERR_TOO_OFTEN,
      ATTRIBUTE_OPERATION_ERR_USER_NOT_FOUND = AttributeOperationError.ATTRIBUTE_OPERATION_ERR_USER_NOT_FOUND,
      ATTRIBUTE_OPERATION_ERR_TIMEOUT = AttributeOperationError.ATTRIBUTE_OPERATION_ERR_TIMEOUT,
      ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN = AttributeOperationError.ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN,
      CHANNEL_MESSAGE_ERR_FAILURE = ChannelMessageError.CHANNEL_MESSAGE_ERR_FAILURE,
      CHANNEL_MESSAGE_ERR_TIMEOUT = ChannelMessageError.CHANNEL_MESSAGE_ERR_TIMEOUT,
      CHANNEL_MESSAGE_ERR_TOO_OFTEN = ChannelMessageError.CHANNEL_MESSAGE_ERR_TOO_OFTEN,
      CHANNEL_MESSAGE_ERR_INVALID_MESSAGE = ChannelMessageError.CHANNEL_MESSAGE_ERR_INVALID_MESSAGE,
      CHANNEL_MESSAGE_ERR_NOT_IN_CHANNEL = ChannelMessageError.CHANNEL_MESSAGE_ERR_NOT_IN_CHANNEL,
      CHANNEL_MESSAGE_ERR_USER_NOT_LOGGED_IN = ChannelMessageError.CHANNEL_MESSAGE_ERR_USER_NOT_LOGGED_IN,
      CREATE_CHANNEL_ERR_INVALID_ARGUMENT = CreateChannelError.CREATE_CHANNEL_ERR_INVALID_ARGUMENT,
      CREATE_INSTANCE_ERR_INVALID_ARGUMENT = CreateInstanceError.CREATE_INSTANCE_ERR_INVALID_ARGUMENT,
      GET_CHANNEL_MEMBER_COUNT_ERR_FAILURE = GetChannelMemberCountErrCode.GET_CHANNEL_MEMBER_COUNT_ERR_FAILURE,
      GET_CHANNEL_MEMBER_COUNT_ERR_INVALID_ARGUMENT = GetChannelMemberCountErrCode.GET_CHANNEL_MEMBER_COUNT_ERR_INVALID_ARGUMENT,
      GET_CHANNEL_MEMBER_COUNT_ERR_TOO_OFTEN = GetChannelMemberCountErrCode.GET_CHANNEL_MEMBER_COUNT_ERR_TOO_OFTEN,
      GET_CHANNEL_MEMBER_COUNT_ERR_TIMEOUT = GetChannelMemberCountErrCode.GET_CHANNEL_MEMBER_COUNT_ERR_TIMEOUT,
      GET_CHANNEL_MEMBER_COUNT_ERR_EXCEED_LIMIT = GetChannelMemberCountErrCode.GET_CHANNEL_MEMBER_COUNT_ERR_EXCEED_LIMIT,
      GET_CHANNEL_MEMBER_COUNT_ERR_NOT_INITIALIZED = GetChannelMemberCountErrCode.GET_CHANNEL_MEMBER_COUNT_ERR_NOT_INITIALIZED,
      GET_CHANNEL_MEMBER_COUNT_ERR_USER_NOT_LOGGED_IN = GetChannelMemberCountErrCode.GET_CHANNEL_MEMBER_COUNT_ERR_USER_NOT_LOGGED_IN,
      GET_MEMBERS_ERR_FAILURE = GetMembersError.GET_MEMBERS_ERR_FAILURE,
      GET_MEMBERS_ERR_REJECTED = GetMembersError.GET_MEMBERS_ERR_REJECTED,
      GET_MEMBERS_ERR_TIMEOUT = GetMembersError.GET_MEMBERS_ERR_TIMEOUT,
      GET_MEMBERS_ERR_TOO_OFTEN = GetMembersError.GET_MEMBERS_ERR_TOO_OFTEN,
      GET_MEMBERS_ERR_NOT_IN_CHANNEL = GetMembersError.GET_MEMBERS_ERR_NOT_IN_CHANNEL,
      GET_MEMBERS_ERR_USER_NOT_LOGGED_IN = GetMembersError.GET_MEMBERS_ERR_USER_NOT_LOGGED_IN,
      INVITATION_API_CALL_ERR_INVALID_ARGUMENT = InvitationApiCallError.INVITATION_API_CALL_ERR_INVALID_ARGUMENT,
      INVITATION_API_CALL_ERR_NOT_STARTED = InvitationApiCallError.INVITATION_API_CALL_ERR_NOT_STARTED,
      INVITATION_API_CALL_ERR_ALREADY_END = InvitationApiCallError.INVITATION_API_CALL_ERR_ALREADY_END,
      INVITATION_API_CALL_ERR_ALREADY_ACCEPT = InvitationApiCallError.INVITATION_API_CALL_ERR_ALREADY_ACCEPT,
      INVITATION_API_CALL_ERR_ALREADY_SENT = InvitationApiCallError.INVITATION_API_CALL_ERR_ALREADY_SENT,
      JOIN_CHANNEL_ERR_FAILURE = JoinChannelError.JOIN_CHANNEL_ERR_FAILURE,
      JOIN_CHANNEL_ERR_REJECTED = JoinChannelError.JOIN_CHANNEL_ERR_REJECTED,
      JOIN_CHANNEL_ERR_INVALID_ARGUMENT = JoinChannelError.JOIN_CHANNEL_ERR_INVALID_ARGUMENT,
      JOIN_CHANNEL_TIMEOUT = JoinChannelError.JOIN_CHANNEL_TIMEOUT,
      JOIN_CHANNEL_ERR_EXCEED_LIMIT = JoinChannelError.JOIN_CHANNEL_ERR_EXCEED_LIMIT,
      JOIN_CHANNEL_ERR_ALREADY_JOINED = JoinChannelError.JOIN_CHANNEL_ERR_ALREADY_JOINED,
      JOIN_CHANNEL_ERR_TOO_OFTEN = JoinChannelError.JOIN_CHANNEL_ERR_TOO_OFTEN,
      JOIN_CHANNEL_ERR_USER_NOT_LOGGED_IN = JoinChannelError.JOIN_CHANNEL_ERR_USER_NOT_LOGGED_IN,
      JOIN_CHANNEL_ERR_ALREADY_JOINED_CHANNEL_OF_SAME_ID = JoinChannelError.JOIN_CHANNEL_ERR_ALREADY_JOINED_CHANNEL_OF_SAME_ID,
      LEAVE_CHANNEL_ERR_FAILURE = LeaveChannelError.LEAVE_CHANNEL_ERR_FAILURE,
      LEAVE_CHANNEL_ERR_REJECTED = LeaveChannelError.LEAVE_CHANNEL_ERR_REJECTED,
      LEAVE_CHANNEL_ERR_NOT_IN_CHANNEL = LeaveChannelError.LEAVE_CHANNEL_ERR_NOT_IN_CHANNEL,
      LEAVE_CHANNEL_ERR_USER_NOT_LOGGED_IN = LeaveChannelError.LEAVE_CHANNEL_ERR_USER_NOT_LOGGED_IN,
      LOGIN_ERR_UNKNOWN = LoginError.LOGIN_ERR_UNKNOWN,
      LOGIN_ERR_REJECTED = LoginError.LOGIN_ERR_REJECTED,
      LOGIN_ERR_INVALID_ARGUMENT = LoginError.LOGIN_ERR_INVALID_ARGUMENT,
      LOGIN_ERR_INVALID_APP_ID = LoginError.LOGIN_ERR_INVALID_APP_ID,
      LOGIN_ERR_INVALID_TOKEN = LoginError.LOGIN_ERR_INVALID_TOKEN,
      LOGIN_ERR_TOKEN_EXPIRED = LoginError.LOGIN_ERR_TOKEN_EXPIRED,
      LOGIN_ERR_NOT_AUTHORIZED = LoginError.LOGIN_ERR_NOT_AUTHORIZED,
      LOGIN_ERR_ALREADY_LOGIN = LoginError.LOGIN_ERR_ALREADY_LOGIN,
      LOGIN_ERR_TIMEOUT = LoginError.LOGIN_ERR_TIMEOUT,
      LOGIN_ERR_TOO_OFTEN = LoginError.LOGIN_ERR_TOO_OFTEN,
      LOGOUT_ERR_USER_NOT_LOGGED_IN = LogoutError.LOGOUT_ERR_USER_NOT_LOGGED_IN,
      PEER_MESSAGE_ERR_FAILURE = PeerMessageError.PEER_MESSAGE_ERR_FAILURE,
      PEER_MESSAGE_ERR_TIMEOUT = PeerMessageError.PEER_MESSAGE_ERR_TIMEOUT,
      PEER_MESSAGE_ERR_TOO_OFTEN = PeerMessageError.PEER_MESSAGE_ERR_TOO_OFTEN,
      PEER_MESSAGE_ERR_INVALID_USERID = PeerMessageError.PEER_MESSAGE_ERR_INVALID_USERID,
      PEER_MESSAGE_ERR_INVALID_MESSAGE = PeerMessageError.PEER_MESSAGE_ERR_INVALID_MESSAGE,
      PEER_MESSAGE_ERR_USER_NOT_LOGGED_IN = PeerMessageError.PEER_MESSAGE_ERR_USER_NOT_LOGGED_IN,
      PEER_MESSAGE_ERR_INCOMPATIBLE_MESSAGE = PeerMessageError.PEER_MESSAGE_ERR_INCOMPATIBLE_MESSAGE,
      QUERY_PEERS_ONLINE_STATUS_ERR_INVALID_ARGUMENT = QueryPeersOnlineStatusError.QUERY_PEERS_ONLINE_STATUS_ERR_INVALID_ARGUMENT,
      QUERY_PEERS_ONLINE_STATUS_ERR_REJECTED = QueryPeersOnlineStatusError.QUERY_PEERS_ONLINE_STATUS_ERR_REJECTED,
      QUERY_PEERS_ONLINE_STATUS_ERR_TIMEOUT = QueryPeersOnlineStatusError.QUERY_PEERS_ONLINE_STATUS_ERR_TIMEOUT,
      QUERY_PEERS_ONLINE_STATUS_ERR_TOO_OFTEN = QueryPeersOnlineStatusError.QUERY_PEERS_ONLINE_STATUS_ERR_TOO_OFTEN,
      QUERY_PEERS_ONLINE_STATUS_ERR_USER_NOT_LOGGED_IN = QueryPeersOnlineStatusError.QUERY_PEERS_ONLINE_STATUS_ERR_USER_NOT_LOGGED_IN,
      RENEW_TOKEN_ERR_FAILURE = RenewTokenError.RENEW_TOKEN_ERR_FAILURE,
      RENEW_TOKEN_ERR_INVALID_ARGUMENT = RenewTokenError.RENEW_TOKEN_ERR_INVALID_ARGUMENT,
      RENEW_TOKEN_ERR_REJECTED = RenewTokenError.RENEW_TOKEN_ERR_REJECTED,
      RENEW_TOKEN_ERR_TOO_OFTEN = RenewTokenError.RENEW_TOKEN_ERR_TOO_OFTEN,
      RENEW_TOKEN_ERR_TOKEN_EXPIRED = RenewTokenError.RENEW_TOKEN_ERR_TOKEN_EXPIRED,
      RENEW_TOKEN_ERR_INVALID_TOKEN = RenewTokenError.RENEW_TOKEN_ERR_INVALID_TOKEN,
      RENEW_TOKEN_ERR_USER_NOT_LOGGED_IN = RenewTokenError.RENEW_TOKEN_ERR_USER_NOT_LOGGED_IN,
      PEER_SUBSCRIPTION_STATUS_ERR_FAILURE = PeerSubscriptionStatusError.PEER_SUBSCRIPTION_STATUS_ERR_FAILURE,
      PEER_SUBSCRIPTION_STATUS_ERR_INVALID_ARGUMENT = PeerSubscriptionStatusError.PEER_SUBSCRIPTION_STATUS_ERR_INVALID_ARGUMENT,
      PEER_SUBSCRIPTION_STATUS_ERR_REJECTED = PeerSubscriptionStatusError.PEER_SUBSCRIPTION_STATUS_ERR_REJECTED,
      PEER_SUBSCRIPTION_STATUS_ERR_TIMEOUT = PeerSubscriptionStatusError.PEER_SUBSCRIPTION_STATUS_ERR_TIMEOUT,
      PEER_SUBSCRIPTION_STATUS_ERR_TOO_OFTEN = PeerSubscriptionStatusError.PEER_SUBSCRIPTION_STATUS_ERR_TOO_OFTEN,
      PEER_SUBSCRIPTION_STATUS_ERR_OVERFLOW = PeerSubscriptionStatusError.PEER_SUBSCRIPTION_STATUS_ERR_OVERFLOW,
      PEER_SUBSCRIPTION_STATUS_ERR_USER_NOT_LOGGED_IN = PeerSubscriptionStatusError.PEER_SUBSCRIPTION_STATUS_ERR_USER_NOT_LOGGED_IN,
      QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_FAILURE = QueryPeersBySubscriptionOptionError.QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_FAILURE,
      QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_TIMEOUT = QueryPeersBySubscriptionOptionError.QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_TIMEOUT,
      QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_TOO_OFTEN = QueryPeersBySubscriptionOptionError.QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_TOO_OFTEN,
      QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_USER_NOT_LOGGED_IN = QueryPeersBySubscriptionOptionError.QUERY_PEERS_BY_SUBSCRIPTION_OPTION_ERR_USER_NOT_LOGGED_IN,
      UPLOAD_MEDIA_ERR_FAILURE = UploadMediaError.UPLOAD_MEDIA_ERR_FAILURE,
      UPLOAD_MEDIA_ERR_INVALID_ARGUMENT = UploadMediaError.UPLOAD_MEDIA_ERR_INVALID_ARGUMENT,
      UPLOAD_MEDIA_ERR_TIMEOUT = UploadMediaError.UPLOAD_MEDIA_ERR_TIMEOUT,
      UPLOAD_MEDIA_ERR_SIZE_OVERFLOW = UploadMediaError.UPLOAD_MEDIA_ERR_SIZE_OVERFLOW,
      UPLOAD_MEDIA_ERR_CONCURRENCY_LIMIT_EXCEEDED = UploadMediaError.UPLOAD_MEDIA_ERR_CONCURRENCY_LIMIT_EXCEEDED,
      UPLOAD_MEDIA_ERR_INTERRUPTED = UploadMediaError.UPLOAD_MEDIA_ERR_INTERRUPTED,
      UPLOAD_MEDIA_ERR_NOT_LOGGED_IN = UploadMediaError.UPLOAD_MEDIA_ERR_NOT_LOGGED_IN,
      DOWNLOAD_MEDIA_ERR_FAILURE = DownloadMediaError.DOWNLOAD_MEDIA_ERR_FAILURE,
      DOWNLOAD_MEDIA_ERR_INVALID_ARGUMENT = DownloadMediaError.DOWNLOAD_MEDIA_ERR_INVALID_ARGUMENT,
      DOWNLOAD_MEDIA_ERR_TIMEOUT = DownloadMediaError.DOWNLOAD_MEDIA_ERR_TIMEOUT,
      DOWNLOAD_MEDIA_ERR_NOT_EXIST = DownloadMediaError.DOWNLOAD_MEDIA_ERR_NOT_EXIST,
      DOWNLOAD_MEDIA_ERR_CONCURRENCY_LIMIT_EXCEEDED = DownloadMediaError.DOWNLOAD_MEDIA_ERR_CONCURRENCY_LIMIT_EXCEEDED,
      DOWNLOAD_MEDIA_ERR_INTERRUPTED = DownloadMediaError.DOWNLOAD_MEDIA_ERR_INTERRUPTED,
      DOWNLOAD_MEDIA_ERR_NOT_LOGGED_IN = DownloadMediaError.DOWNLOAD_MEDIA_ERR_NOT_LOGGED_IN;

  function baseSome(e, t) {
    var r;
    return _baseEach(e, function (e, n, o) {
      return !(r = t(e, n, o));
    }), !!r;
  }

  var _baseSome = baseSome;

  function isIterateeCall(e, t, r) {
    if (!isObject_1(r)) return !1;

    var n = _typeof(t);

    return !!("number" == n ? isArrayLike_1(r) && _isIndex(t, r.length) : "string" == n && t in r) && eq_1(r[t], e);
  }

  var _isIterateeCall = isIterateeCall;

  function some(e, t, r) {
    var n = isArray_1(e) ? _arraySome : _baseSome;
    return r && _isIterateeCall(e, t, r) && (t = void 0), n(e, _baseIteratee(t));
  }

  var some_1 = some;

  function baseMap(e, t) {
    var r = -1,
        n = isArrayLike_1(e) ? Array(e.length) : [];
    return _baseEach(e, function (e, o, i) {
      n[++r] = t(e, o, i);
    }), n;
  }

  var _baseMap = baseMap;

  function baseSortBy(e, t) {
    var r = e.length;

    for (e.sort(t); r--;) {
      e[r] = e[r].value;
    }

    return e;
  }

  var _baseSortBy = baseSortBy;

  function compareAscending(e, t) {
    if (e !== t) {
      var r = void 0 !== e,
          n = null === e,
          o = e == e,
          i = isSymbol_1(e),
          s = void 0 !== t,
          a = null === t,
          u = t == t,
          l = isSymbol_1(t);
      if (!a && !l && !i && e > t || i && s && u && !a && !l || n && s && u || !r && u || !o) return 1;
      if (!n && !i && !l && e < t || l && r && o && !n && !i || a && r && o || !s && o || !u) return -1;
    }

    return 0;
  }

  var _compareAscending = compareAscending;

  function compareMultiple(e, t, r) {
    for (var n = -1, o = e.criteria, i = t.criteria, s = o.length, a = r.length; ++n < s;) {
      var u = _compareAscending(o[n], i[n]);

      if (u) return n >= a ? u : u * ("desc" == r[n] ? -1 : 1);
    }

    return e.index - t.index;
  }

  var _compareMultiple = compareMultiple;

  function baseOrderBy(e, t, r) {
    var n = -1;
    t = _arrayMap(t.length ? t : [identity_1], _baseUnary(_baseIteratee));

    var o = _baseMap(e, function (e, r, o) {
      return {
        criteria: _arrayMap(t, function (t) {
          return t(e);
        }),
        index: ++n,
        value: e
      };
    });

    return _baseSortBy(o, function (e, t) {
      return _compareMultiple(e, t, r);
    });
  }

  var _baseOrderBy = baseOrderBy;

  function baseRest(e, t) {
    return _setToString(_overRest(e, t, identity_1), e + "");
  }

  var _baseRest = baseRest,
      sortBy = _baseRest(function (e, t) {
    if (null == e) return [];
    var r = t.length;
    return r > 1 && _isIterateeCall(e, t[0], t[1]) ? t = [] : r > 2 && _isIterateeCall(t[0], t[1], t[2]) && (t = [t[0]]), _baseOrderBy(e, _baseFlatten(t, 1), []);
  }),
      sortBy_1 = sortBy,
      lib_es5 = createCommonjsModule(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = [],
        n = function n(e, t) {
      return new WebSocket(e, t);
    };

    t.normalClosureMessage = "Normal closure", t.default = function (e, o) {
      var i = void 0 === o ? {
        protocols: r,
        makeWebSocket: n
      } : o,
          s = i.protocols,
          a = void 0 === s ? r : s,
          u = i.makeWebSocket,
          l = void 0 === u ? n : u;
      return new _esm5.Observable(function (r) {
        var n,
            o = new _esm5.Subject(),
            i = function i(e) {
          if (n) {
            p();
            var t = new Error("Web socket message factory function called more than once");
            throw r.error(t), t;
          }

          return n = e.subscribe(function (e) {
            s.send(e);
          }), o;
        },
            s = l(e, a),
            u = !1,
            c = !1,
            p = function p() {
          u = !1;
        };

        return s.onopen = function () {
          u = !0, c ? s.close() : r.next(i);
        }, s.onmessage = function (e) {
          o.next(e.data);
        }, s.onerror = function (e) {
          p(), r.error(new Error(e.message));
        }, s.onclose = function (e) {
          u && (p(), c ? (r.complete(), o.complete()) : r.error(new Error(1e3 === e.code ? t.normalClosureMessage : e.reason)));
        }, function () {
          c = !0, n && n.unsubscribe(), u && (p(), s.close());
        };
      });
    };
  });

  unwrapExports(lib_es5);
  var lib_es5_1 = lib_es5.normalClosureMessage;

  function assignMergeValue(e, t, r) {
    (void 0 === r || eq_1(e[t], r)) && (void 0 !== r || t in e) || _baseAssignValue(e, t, r);
  }

  var _assignMergeValue = assignMergeValue;

  function isArrayLikeObject(e) {
    return isObjectLike_1(e) && isArrayLike_1(e);
  }

  var isArrayLikeObject_1 = isArrayLikeObject;

  function safeGet(e, t) {
    if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
  }

  var _safeGet = safeGet;

  function toPlainObject(e) {
    return _copyObject(e, keysIn_1(e));
  }

  var toPlainObject_1 = toPlainObject;

  function baseMergeDeep(e, t, r, n, o, i, s) {
    var a = _safeGet(e, r),
        u = _safeGet(t, r),
        l = s.get(u);

    if (l) _assignMergeValue(e, r, l);else {
      var c = i ? i(a, u, r + "", e, t, s) : void 0,
          p = void 0 === c;

      if (p) {
        var f = isArray_1(u),
            d = !f && isBuffer_1(u),
            g = !f && !d && isTypedArray_1(u);
        c = u, f || d || g ? isArray_1(a) ? c = a : isArrayLikeObject_1(a) ? c = _copyArray(a) : d ? (p = !1, c = _cloneBuffer(u, !0)) : g ? (p = !1, c = _cloneTypedArray(u, !0)) : c = [] : isPlainObject_1(u) || isArguments_1(u) ? (c = a, isArguments_1(a) ? c = toPlainObject_1(a) : isObject_1(a) && !isFunction_1(a) || (c = _initCloneObject(u))) : p = !1;
      }

      p && (s.set(u, c), o(c, u, n, i, s), s.delete(u)), _assignMergeValue(e, r, c);
    }
  }

  var _baseMergeDeep = baseMergeDeep;

  function baseMerge(e, t, r, n, o) {
    e !== t && _baseFor(t, function (i, s) {
      if (o || (o = new _Stack()), isObject_1(i)) _baseMergeDeep(e, t, s, r, baseMerge, n, o);else {
        var a = n ? n(_safeGet(e, s), i, s + "", e, t, o) : void 0;
        void 0 === a && (a = i), _assignMergeValue(e, s, a);
      }
    }, keysIn_1);
  }

  var _baseMerge = baseMerge;

  function createAssigner(e) {
    return _baseRest(function (t, r) {
      var n = -1,
          o = r.length,
          i = o > 1 ? r[o - 1] : void 0,
          s = o > 2 ? r[2] : void 0;

      for (i = e.length > 3 && "function" == typeof i ? (o--, i) : void 0, s && _isIterateeCall(r[0], r[1], s) && (i = o < 3 ? void 0 : i, o = 1), t = Object(t); ++n < o;) {
        var a = r[n];
        a && e(t, a, n, i);
      }

      return t;
    });
  }

  var _createAssigner = createAssigner,
      mergeWith = _createAssigner(function (e, t, r, n) {
    _baseMerge(e, t, r, n);
  }),
      mergeWith_1 = mergeWith,
      __extends$1 = window && window.__extends || function () {
    var _e2 = function e(t, r) {
      return (_e2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) {
          t.hasOwnProperty(r) && (e[r] = t[r]);
        }
      })(t, r);
    };

    return function (t, r) {
      function n() {
        this.constructor = t;
      }

      _e2(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
  }(),
      BucketBySubscriber = function (e) {
    function t(t, r, n, o) {
      var i = e.call(this, t) || this;
      i.count = r, i.hashSelector = n, i.subjectSelector = o, i.index = 0;

      for (var s = i.buckets = new Array(r), a = 0; a < r; ++a) {
        s[a] = o();
      }

      return t.next(s.map(function (e) {
        return e.asObservable();
      })), i;
    }

    return __extends$1(t, e), t.prototype._next = function (e) {
      var t = this.buckets,
          r = this.closed,
          n = this.count,
          o = this.hashSelector;

      if (!r) {
        var i;

        try {
          var s = o(e, this.index++);
          i = Math.abs(Math.floor(s)) % n;
        } catch (e) {
          return void this.error(e);
        }

        t[i].next(e);
      }
    }, t.prototype._error = function (e) {
      var t = this.buckets,
          r = this.closed,
          n = this.destination;
      r || (t.forEach(function (t) {
        return t.error(e);
      }), n.error(e));
    }, t.prototype._complete = function () {
      var e = this.buckets,
          t = this.closed,
          r = this.destination;
      t || (e.forEach(function (e) {
        return e.complete();
      }), r.complete());
    }, t;
  }(Subscriber),
      __extends$2 = window && window.__extends || function () {
    var _e3 = function e(t, r) {
      return (_e3 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) {
          t.hasOwnProperty(r) && (e[r] = t[r]);
        }
      })(t, r);
    };

    return function (t, r) {
      function n() {
        this.constructor = t;
      }

      _e3(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
  }(),
      DeferFinalizeSubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.callback = r, n.kind = "U", n.subscription = void 0, n;
    }

    return __extends$2(t, e), t.prototype.complete = function () {
      var t = this;
      this.kind = "C", this.defer(function () {
        return e.prototype.complete.call(t);
      });
    }, t.prototype.error = function (t) {
      var r = this;
      this.kind = "E", this.defer(function () {
        return e.prototype.error.call(r, t);
      });
    }, t.prototype.unsubscribe = function () {
      var t = this;
      this.defer(function () {
        return e.prototype.unsubscribe.call(t);
      });
    }, t.prototype.defer = function (e) {
      if (this.subscription) this.subscription.add(e);else {
        var t = new Subscription();
        this.subscription = t, t.add(e), from(this.callback(this.kind)).pipe(finalize(function () {
          return t.unsubscribe();
        })).subscribe();
      }
    }, t;
  }(Subscriber),
      __extends$3 = window && window.__extends || function () {
    var _e4 = function e(t, r) {
      return (_e4 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) {
          t.hasOwnProperty(r) && (e[r] = t[r]);
        }
      })(t, r);
    };

    return function (t, r) {
      function n() {
        this.constructor = t;
      }

      _e4(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
  }(),
      InexorablySubscriber = function (e) {
    function t(t, r) {
      var n = e.call(this, t) || this;
      return n.add(new Subscription(function () {
        return r(n.notification);
      })), n;
    }

    return __extends$3(t, e), t.prototype.complete = function () {
      this.notification = new Notification("C"), e.prototype.complete.call(this);
    }, t.prototype.error = function (t) {
      this.notification = new Notification("E", void 0, t), e.prototype.error.call(this, t);
    }, t;
  }(Subscriber);

  function rateLimit(e) {
    for (var t = [], r = 1; r < arguments.length; r++) {
      t[r - 1] = arguments[r];
    }

    var n = 1,
        o = asap;
    1 === t.length ? "number" == typeof t[0] ? n = t[0] : o = t[0] : 2 === t.length && (n = t[0], o = t[1]);
    var i = n || 1;
    return function (t) {
      return t.pipe(scan(function (t, r) {
        var n = o.now(),
            s = n - e;

        if ((t = t.filter(function (e) {
          return e.until > s;
        })).length >= i) {
          var a = t[0],
              u = t[t.length - 1],
              l = a.until + e * Math.floor(t.length / i);
          t.push({
            delay: u.until < n ? l - n : l - u.until,
            until: l,
            value: r
          });
        } else t.push({
          delay: 0,
          until: n,
          value: r
        });

        return t;
      }, []), map$1(function (e) {
        return e[e.length - 1];
      }), concatMap(function (e) {
        var t = of(e.value);
        return e.delay ? t.pipe(delay(e.delay, o)) : t;
      }));
    };
  }

  var __extends$4 = window && window.__extends || function () {
    var _e5 = function e(t, r) {
      return (_e5 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) {
          t.hasOwnProperty(r) && (e[r] = t[r]);
        }
      })(t, r);
    };

    return function (t, r) {
      function n() {
        this.constructor = t;
      }

      _e5(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
    };
  }(),
      UnsubscribeOnSubscriber = function (e) {
    function t(t, r, n) {
      var o = e.call(this, t) || this;
      return o.scheduler = r, o.delay = n, o;
    }

    return __extends$4(t, e), t.prototype.unsubscribe = function () {
      var t = this,
          r = this.delay;
      this.scheduler.schedule(function () {
        return e.prototype.unsubscribe.call(t);
      }, r);
    }, t;
  }(Subscriber),
      defaultProtocols = [],
      defaultWebsocketFactory = function defaultWebsocketFactory(e, t) {
    return new WebSocket(e, t);
  },
      normalClosureMessage = "Normal closure";

  function makeWebSocketObservable(e, t) {
    var r = void 0 === t ? {
      protocols: defaultProtocols,
      makeWebSocket: defaultWebsocketFactory
    } : t,
        n = r.protocols,
        o = void 0 === n ? defaultProtocols : n,
        i = r.makeWebSocket,
        s = void 0 === i ? defaultWebsocketFactory : i;
    return new Observable(function (t) {
      var r,
          n = new Subject(),
          i = function i(e) {
        if (r) {
          c();
          var o = new Error("Web socket message factory function called more than once");
          throw t.error(o), o;
        }

        return r = e.subscribe(function (e) {
          a.send(e);
        }), n;
      },
          a = s(e, o),
          u = !1,
          l = !1,
          c = function c() {
        u = !1;
      };

      return a.onopen = function () {
        u = !0, l ? a.close() : t.next(i);
      }, a.onmessage = function (e) {
        n.next(e.data);
      }, a.onerror = function (e) {
        c(), t.error(new Error(e.message));
      }, a.onclose = function (e) {
        u && (c(), l ? (t.complete(), n.complete()) : t.error(new Error(1e3 === e.code ? normalClosureMessage : e.reason)));
      }, function () {
        l = !0, r && r.unsubscribe(), u && (c(), a.close());
      };
    });
  }

  _export(_export.P + _export.F * _fails(function () {
    return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({
      toISOString: function toISOString() {
        return 1;
      }
    });
  }), "Date", {
    toJSON: function toJSON(e) {
      var t = _toObject(this),
          r = _toPrimitive(t);

      return "number" != typeof r || isFinite(r) ? t.toISOString() : null;
    }
  });

  var floor$2 = Math.floor,
      _isInteger = function _isInteger(e) {
    return !_isObject(e) && isFinite(e) && floor$2(e) === e;
  };

  _export(_export.S, "Number", {
    isInteger: _isInteger
  });

  var aspromise = asPromise;

  function asPromise(e, t) {
    for (var r = new Array(arguments.length - 1), n = 0, o = 2, i = !0; o < arguments.length;) {
      r[n++] = arguments[o++];
    }

    return new Promise(function (o, s) {
      r[n] = function (e) {
        if (i) if (i = !1, e) s(e);else {
          for (var t = new Array(arguments.length - 1), r = 0; r < t.length;) {
            t[r++] = arguments[r];
          }

          o.apply(null, t);
        }
      };

      try {
        e.apply(t || null, r);
      } catch (e) {
        i && (i = !1, s(e));
      }
    });
  }

  var base64_1 = createCommonjsModule(function (e, t) {
    var r = t;

    r.length = function (e) {
      var t = e.length;
      if (!t) return 0;

      for (var r = 0; --t % 4 > 1 && "=" === e.charAt(t);) {
        ++r;
      }

      return Math.ceil(3 * e.length) / 4 - r;
    };

    for (var n = new Array(64), o = new Array(123), i = 0; i < 64;) {
      o[n[i] = i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i - 59 | 43] = i++;
    }

    r.encode = function (e, t, r) {
      for (var o, i = null, s = [], a = 0, u = 0; t < r;) {
        var l = e[t++];

        switch (u) {
          case 0:
            s[a++] = n[l >> 2], o = (3 & l) << 4, u = 1;
            break;

          case 1:
            s[a++] = n[o | l >> 4], o = (15 & l) << 2, u = 2;
            break;

          case 2:
            s[a++] = n[o | l >> 6], s[a++] = n[63 & l], u = 0;
        }

        a > 8191 && ((i || (i = [])).push(String.fromCharCode.apply(String, s)), a = 0);
      }

      return u && (s[a++] = n[o], s[a++] = 61, 1 === u && (s[a++] = 61)), i ? (a && i.push(String.fromCharCode.apply(String, s.slice(0, a))), i.join("")) : String.fromCharCode.apply(String, s.slice(0, a));
    };

    r.decode = function (e, t, r) {
      for (var n, i = r, s = 0, a = 0; a < e.length;) {
        var u = e.charCodeAt(a++);
        if (61 === u && s > 1) break;
        if (void 0 === (u = o[u])) throw Error("invalid encoding");

        switch (s) {
          case 0:
            n = u, s = 1;
            break;

          case 1:
            t[r++] = n << 2 | (48 & u) >> 4, n = u, s = 2;
            break;

          case 2:
            t[r++] = (15 & n) << 4 | (60 & u) >> 2, n = u, s = 3;
            break;

          case 3:
            t[r++] = (3 & n) << 6 | u, s = 0;
        }
      }

      if (1 === s) throw Error("invalid encoding");
      return r - i;
    }, r.test = function (e) {
      return /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/.test(e);
    };
  }),
      eventemitter = EventEmitter$1;

  function EventEmitter$1() {
    this._listeners = {};
  }

  EventEmitter$1.prototype.on = function (e, t, r) {
    return (this._listeners[e] || (this._listeners[e] = [])).push({
      fn: t,
      ctx: r || this
    }), this;
  }, EventEmitter$1.prototype.off = function (e, t) {
    if (void 0 === e) this._listeners = {};else if (void 0 === t) this._listeners[e] = [];else for (var r = this._listeners[e], n = 0; n < r.length;) {
      r[n].fn === t ? r.splice(n, 1) : ++n;
    }
    return this;
  }, EventEmitter$1.prototype.emit = function (e) {
    var t = this._listeners[e];

    if (t) {
      for (var r = [], n = 1; n < arguments.length;) {
        r.push(arguments[n++]);
      }

      for (n = 0; n < t.length;) {
        t[n].fn.apply(t[n++].ctx, r);
      }
    }

    return this;
  };
  var float_1 = factory(factory);

  function factory(e) {
    return "undefined" != typeof Float32Array ? function () {
      var t = new Float32Array([-0]),
          r = new Uint8Array(t.buffer),
          n = 128 === r[3];

      function o(e, n, o) {
        t[0] = e, n[o] = r[0], n[o + 1] = r[1], n[o + 2] = r[2], n[o + 3] = r[3];
      }

      function i(e, n, o) {
        t[0] = e, n[o] = r[3], n[o + 1] = r[2], n[o + 2] = r[1], n[o + 3] = r[0];
      }

      function s(e, n) {
        return r[0] = e[n], r[1] = e[n + 1], r[2] = e[n + 2], r[3] = e[n + 3], t[0];
      }

      function a(e, n) {
        return r[3] = e[n], r[2] = e[n + 1], r[1] = e[n + 2], r[0] = e[n + 3], t[0];
      }

      e.writeFloatLE = n ? o : i, e.writeFloatBE = n ? i : o, e.readFloatLE = n ? s : a, e.readFloatBE = n ? a : s;
    }() : function () {
      function t(e, t, r, n) {
        var o = t < 0 ? 1 : 0;
        if (o && (t = -t), 0 === t) e(1 / t > 0 ? 0 : 2147483648, r, n);else if (isNaN(t)) e(2143289344, r, n);else if (t > 3.4028234663852886e38) e((o << 31 | 2139095040) >>> 0, r, n);else if (t < 1.1754943508222875e-38) e((o << 31 | Math.round(t / 1.401298464324817e-45)) >>> 0, r, n);else {
          var i = Math.floor(Math.log(t) / Math.LN2);
          e((o << 31 | i + 127 << 23 | 8388607 & Math.round(t * Math.pow(2, -i) * 8388608)) >>> 0, r, n);
        }
      }

      function r(e, t, r) {
        var n = e(t, r),
            o = 2 * (n >> 31) + 1,
            i = n >>> 23 & 255,
            s = 8388607 & n;
        return 255 === i ? s ? NaN : o * (1 / 0) : 0 === i ? 1.401298464324817e-45 * o * s : o * Math.pow(2, i - 150) * (s + 8388608);
      }

      e.writeFloatLE = t.bind(null, writeUintLE), e.writeFloatBE = t.bind(null, writeUintBE), e.readFloatLE = r.bind(null, readUintLE), e.readFloatBE = r.bind(null, readUintBE);
    }(), "undefined" != typeof Float64Array ? function () {
      var t = new Float64Array([-0]),
          r = new Uint8Array(t.buffer),
          n = 128 === r[7];

      function o(e, n, o) {
        t[0] = e, n[o] = r[0], n[o + 1] = r[1], n[o + 2] = r[2], n[o + 3] = r[3], n[o + 4] = r[4], n[o + 5] = r[5], n[o + 6] = r[6], n[o + 7] = r[7];
      }

      function i(e, n, o) {
        t[0] = e, n[o] = r[7], n[o + 1] = r[6], n[o + 2] = r[5], n[o + 3] = r[4], n[o + 4] = r[3], n[o + 5] = r[2], n[o + 6] = r[1], n[o + 7] = r[0];
      }

      function s(e, n) {
        return r[0] = e[n], r[1] = e[n + 1], r[2] = e[n + 2], r[3] = e[n + 3], r[4] = e[n + 4], r[5] = e[n + 5], r[6] = e[n + 6], r[7] = e[n + 7], t[0];
      }

      function a(e, n) {
        return r[7] = e[n], r[6] = e[n + 1], r[5] = e[n + 2], r[4] = e[n + 3], r[3] = e[n + 4], r[2] = e[n + 5], r[1] = e[n + 6], r[0] = e[n + 7], t[0];
      }

      e.writeDoubleLE = n ? o : i, e.writeDoubleBE = n ? i : o, e.readDoubleLE = n ? s : a, e.readDoubleBE = n ? a : s;
    }() : function () {
      function t(e, t, r, n, o, i) {
        var s = n < 0 ? 1 : 0;
        if (s && (n = -n), 0 === n) e(0, o, i + t), e(1 / n > 0 ? 0 : 2147483648, o, i + r);else if (isNaN(n)) e(0, o, i + t), e(2146959360, o, i + r);else if (n > 1.7976931348623157e308) e(0, o, i + t), e((s << 31 | 2146435072) >>> 0, o, i + r);else {
          var a;
          if (n < 2.2250738585072014e-308) e((a = n / 5e-324) >>> 0, o, i + t), e((s << 31 | a / 4294967296) >>> 0, o, i + r);else {
            var u = Math.floor(Math.log(n) / Math.LN2);
            1024 === u && (u = 1023), e(4503599627370496 * (a = n * Math.pow(2, -u)) >>> 0, o, i + t), e((s << 31 | u + 1023 << 20 | 1048576 * a & 1048575) >>> 0, o, i + r);
          }
        }
      }

      function r(e, t, r, n, o) {
        var i = e(n, o + t),
            s = e(n, o + r),
            a = 2 * (s >> 31) + 1,
            u = s >>> 20 & 2047,
            l = 4294967296 * (1048575 & s) + i;
        return 2047 === u ? l ? NaN : a * (1 / 0) : 0 === u ? 5e-324 * a * l : a * Math.pow(2, u - 1075) * (l + 4503599627370496);
      }

      e.writeDoubleLE = t.bind(null, writeUintLE, 0, 4), e.writeDoubleBE = t.bind(null, writeUintBE, 4, 0), e.readDoubleLE = r.bind(null, readUintLE, 0, 4), e.readDoubleBE = r.bind(null, readUintBE, 4, 0);
    }(), e;
  }

  function writeUintLE(e, t, r) {
    t[r] = 255 & e, t[r + 1] = e >>> 8 & 255, t[r + 2] = e >>> 16 & 255, t[r + 3] = e >>> 24;
  }

  function writeUintBE(e, t, r) {
    t[r] = e >>> 24, t[r + 1] = e >>> 16 & 255, t[r + 2] = e >>> 8 & 255, t[r + 3] = 255 & e;
  }

  function readUintLE(e, t) {
    return (e[t] | e[t + 1] << 8 | e[t + 2] << 16 | e[t + 3] << 24) >>> 0;
  }

  function readUintBE(e, t) {
    return (e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]) >>> 0;
  }

  var inquire_1 = inquire;

  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch (e) {}

    return null;
  }

  var utf8_1 = createCommonjsModule(function (e, t) {
    var r = t;
    r.length = function (e) {
      for (var t = 0, r = 0, n = 0; n < e.length; ++n) {
        (r = e.charCodeAt(n)) < 128 ? t += 1 : r < 2048 ? t += 2 : 55296 == (64512 & r) && 56320 == (64512 & e.charCodeAt(n + 1)) ? (++n, t += 4) : t += 3;
      }

      return t;
    }, r.read = function (e, t, r) {
      if (r - t < 1) return "";

      for (var n, o = null, i = [], s = 0; t < r;) {
        (n = e[t++]) < 128 ? i[s++] = n : n > 191 && n < 224 ? i[s++] = (31 & n) << 6 | 63 & e[t++] : n > 239 && n < 365 ? (n = ((7 & n) << 18 | (63 & e[t++]) << 12 | (63 & e[t++]) << 6 | 63 & e[t++]) - 65536, i[s++] = 55296 + (n >> 10), i[s++] = 56320 + (1023 & n)) : i[s++] = (15 & n) << 12 | (63 & e[t++]) << 6 | 63 & e[t++], s > 8191 && ((o || (o = [])).push(String.fromCharCode.apply(String, i)), s = 0);
      }

      return o ? (s && o.push(String.fromCharCode.apply(String, i.slice(0, s))), o.join("")) : String.fromCharCode.apply(String, i.slice(0, s));
    }, r.write = function (e, t, r) {
      for (var n, o, i = r, s = 0; s < e.length; ++s) {
        (n = e.charCodeAt(s)) < 128 ? t[r++] = n : n < 2048 ? (t[r++] = n >> 6 | 192, t[r++] = 63 & n | 128) : 55296 == (64512 & n) && 56320 == (64512 & (o = e.charCodeAt(s + 1))) ? (n = 65536 + ((1023 & n) << 10) + (1023 & o), ++s, t[r++] = n >> 18 | 240, t[r++] = n >> 12 & 63 | 128, t[r++] = n >> 6 & 63 | 128, t[r++] = 63 & n | 128) : (t[r++] = n >> 12 | 224, t[r++] = n >> 6 & 63 | 128, t[r++] = 63 & n | 128);
      }

      return r - i;
    };
  }),
      pool_1 = pool;

  function pool(e, t, r) {
    var n = r || 8192,
        o = n >>> 1,
        i = null,
        s = n;
    return function (r) {
      if (r < 1 || r > o) return e(r);
      s + r > n && (i = e(n), s = 0);
      var a = t.call(i, s, s += r);
      return 7 & s && (s = 1 + (7 | s)), a;
    };
  }

  var longbits = LongBits;

  function LongBits(e, t) {
    this.lo = e >>> 0, this.hi = t >>> 0;
  }

  var zero = LongBits.zero = new LongBits(0, 0);
  zero.toNumber = function () {
    return 0;
  }, zero.zzEncode = zero.zzDecode = function () {
    return this;
  }, zero.length = function () {
    return 1;
  };
  var zeroHash = LongBits.zeroHash = "\0\0\0\0\0\0\0\0";
  LongBits.fromNumber = function (e) {
    if (0 === e) return zero;
    var t = e < 0;
    t && (e = -e);
    var r = e >>> 0,
        n = (e - r) / 4294967296 >>> 0;
    return t && (n = ~n >>> 0, r = ~r >>> 0, ++r > 4294967295 && (r = 0, ++n > 4294967295 && (n = 0))), new LongBits(r, n);
  }, LongBits.from = function (e) {
    if ("number" == typeof e) return LongBits.fromNumber(e);

    if (minimal.isString(e)) {
      if (!minimal.Long) return LongBits.fromNumber(parseInt(e, 10));
      e = minimal.Long.fromString(e);
    }

    return e.low || e.high ? new LongBits(e.low >>> 0, e.high >>> 0) : zero;
  }, LongBits.prototype.toNumber = function (e) {
    if (!e && this.hi >>> 31) {
      var t = 1 + ~this.lo >>> 0,
          r = ~this.hi >>> 0;
      return t || (r = r + 1 >>> 0), -(t + 4294967296 * r);
    }

    return this.lo + 4294967296 * this.hi;
  }, LongBits.prototype.toLong = function (e) {
    return minimal.Long ? new minimal.Long(0 | this.lo, 0 | this.hi, Boolean(e)) : {
      low: 0 | this.lo,
      high: 0 | this.hi,
      unsigned: Boolean(e)
    };
  };
  var charCodeAt = String.prototype.charCodeAt;
  LongBits.fromHash = function (e) {
    return e === zeroHash ? zero : new LongBits((charCodeAt.call(e, 0) | charCodeAt.call(e, 1) << 8 | charCodeAt.call(e, 2) << 16 | charCodeAt.call(e, 3) << 24) >>> 0, (charCodeAt.call(e, 4) | charCodeAt.call(e, 5) << 8 | charCodeAt.call(e, 6) << 16 | charCodeAt.call(e, 7) << 24) >>> 0);
  }, LongBits.prototype.toHash = function () {
    return String.fromCharCode(255 & this.lo, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, 255 & this.hi, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
  }, LongBits.prototype.zzEncode = function () {
    var e = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ e) >>> 0, this.lo = (this.lo << 1 ^ e) >>> 0, this;
  }, LongBits.prototype.zzDecode = function () {
    var e = -(1 & this.lo);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ e) >>> 0, this.hi = (this.hi >>> 1 ^ e) >>> 0, this;
  }, LongBits.prototype.length = function () {
    var e = this.lo,
        t = (this.lo >>> 28 | this.hi << 4) >>> 0,
        r = this.hi >>> 24;
    return 0 === r ? 0 === t ? e < 16384 ? e < 128 ? 1 : 2 : e < 2097152 ? 3 : 4 : t < 16384 ? t < 128 ? 5 : 6 : t < 2097152 ? 7 : 8 : r < 128 ? 9 : 10;
  };
  var minimal = createCommonjsModule(function (e, t) {
    var r = t;

    function n(e, t, r) {
      for (var n = Object.keys(t), o = 0; o < n.length; ++o) {
        void 0 !== e[n[o]] && r || (e[n[o]] = t[n[o]]);
      }

      return e;
    }

    function o(e) {
      function t(e, r) {
        if (!(this instanceof t)) return new t(e, r);
        Object.defineProperty(this, "message", {
          get: function get() {
            return e;
          }
        }), Error.captureStackTrace ? Error.captureStackTrace(this, t) : Object.defineProperty(this, "stack", {
          value: new Error().stack || ""
        }), r && n(this, r);
      }

      return (t.prototype = Object.create(Error.prototype)).constructor = t, Object.defineProperty(t.prototype, "name", {
        get: function get() {
          return e;
        }
      }), t.prototype.toString = function () {
        return this.name + ": " + this.message;
      }, t;
    }

    r.asPromise = aspromise, r.base64 = base64_1, r.EventEmitter = eventemitter, r.float = float_1, r.inquire = inquire_1, r.utf8 = utf8_1, r.pool = pool_1, r.LongBits = longbits, r.global = "undefined" != typeof window && window || void 0 !== commonjsGlobal && commonjsGlobal || "undefined" != typeof self && self || commonjsGlobal, r.emptyArray = Object.freeze ? Object.freeze([]) : [], r.emptyObject = Object.freeze ? Object.freeze({}) : {}, r.isNode = Boolean(r.global.process && r.global.process.versions && r.global.process.versions.node), r.isInteger = Number.isInteger || function (e) {
      return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
    }, r.isString = function (e) {
      return "string" == typeof e || e instanceof String;
    }, r.isObject = function (e) {
      return e && "object" === _typeof(e);
    }, r.isset = r.isSet = function (e, t) {
      var r = e[t];
      return !(null == r || !e.hasOwnProperty(t)) && ("object" !== _typeof(r) || (Array.isArray(r) ? r.length : Object.keys(r).length) > 0);
    }, r.Buffer = function () {
      try {
        var e = r.inquire("buffer").Buffer;
        return e.prototype.utf8Write ? e : null;
      } catch (e) {
        return null;
      }
    }(), r._Buffer_from = null, r._Buffer_allocUnsafe = null, r.newBuffer = function (e) {
      return "number" == typeof e ? r.Buffer ? r._Buffer_allocUnsafe(e) : new r.Array(e) : r.Buffer ? r._Buffer_from(e) : "undefined" == typeof Uint8Array ? e : new Uint8Array(e);
    }, r.Array = "undefined" != typeof Uint8Array ? Uint8Array : Array, r.Long = r.global.dcodeIO && r.global.dcodeIO.Long || r.global.Long || r.inquire("long"), r.key2Re = /^true|false|0|1$/, r.key32Re = /^-?(?:0|[1-9][0-9]*)$/, r.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, r.longToHash = function (e) {
      return e ? r.LongBits.from(e).toHash() : r.LongBits.zeroHash;
    }, r.longFromHash = function (e, t) {
      var n = r.LongBits.fromHash(e);
      return r.Long ? r.Long.fromBits(n.lo, n.hi, t) : n.toNumber(Boolean(t));
    }, r.merge = n, r.lcFirst = function (e) {
      return e.charAt(0).toLowerCase() + e.substring(1);
    }, r.newError = o, r.ProtocolError = o("ProtocolError"), r.oneOfGetter = function (e) {
      for (var t = {}, r = 0; r < e.length; ++r) {
        t[e[r]] = 1;
      }

      return function () {
        for (var e = Object.keys(this), r = e.length - 1; r > -1; --r) {
          if (1 === t[e[r]] && void 0 !== this[e[r]] && null !== this[e[r]]) return e[r];
        }
      };
    }, r.oneOfSetter = function (e) {
      return function (t) {
        for (var r = 0; r < e.length; ++r) {
          e[r] !== t && delete this[e[r]];
        }
      };
    }, r.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, r._configure = function () {
      var e = r.Buffer;
      e ? (r._Buffer_from = e.from !== Uint8Array.from && e.from || function (t, r) {
        return new e(t, r);
      }, r._Buffer_allocUnsafe = e.allocUnsafe || function (t) {
        return new e(t);
      }) : r._Buffer_from = r._Buffer_allocUnsafe = null;
    };
  }),
      writer = Writer,
      BufferWriter,
      LongBits$1 = minimal.LongBits,
      base64 = minimal.base64,
      utf8 = minimal.utf8;

  function Op(e, t, r) {
    this.fn = e, this.len = t, this.next = void 0, this.val = r;
  }

  function noop$2() {}

  function State(e) {
    this.head = e.head, this.tail = e.tail, this.len = e.len, this.next = e.states;
  }

  function Writer() {
    this.len = 0, this.head = new Op(noop$2, 0, 0), this.tail = this.head, this.states = null;
  }

  var create = function create() {
    return minimal.Buffer ? function () {
      return (Writer.create = function () {
        return new BufferWriter();
      })();
    } : function () {
      return new Writer();
    };
  };

  function writeByte(e, t, r) {
    t[r] = 255 & e;
  }

  function writeVarint32(e, t, r) {
    for (; e > 127;) {
      t[r++] = 127 & e | 128, e >>>= 7;
    }

    t[r] = e;
  }

  function VarintOp(e, t) {
    this.len = e, this.next = void 0, this.val = t;
  }

  function writeVarint64(e, t, r) {
    for (; e.hi;) {
      t[r++] = 127 & e.lo | 128, e.lo = (e.lo >>> 7 | e.hi << 25) >>> 0, e.hi >>>= 7;
    }

    for (; e.lo > 127;) {
      t[r++] = 127 & e.lo | 128, e.lo = e.lo >>> 7;
    }

    t[r++] = e.lo;
  }

  function writeFixed32(e, t, r) {
    t[r] = 255 & e, t[r + 1] = e >>> 8 & 255, t[r + 2] = e >>> 16 & 255, t[r + 3] = e >>> 24;
  }

  Writer.create = create(), Writer.alloc = function (e) {
    return new minimal.Array(e);
  }, minimal.Array !== Array && (Writer.alloc = minimal.pool(Writer.alloc, minimal.Array.prototype.subarray)), Writer.prototype._push = function (e, t, r) {
    return this.tail = this.tail.next = new Op(e, t, r), this.len += t, this;
  }, VarintOp.prototype = Object.create(Op.prototype), VarintOp.prototype.fn = writeVarint32, Writer.prototype.uint32 = function (e) {
    return this.len += (this.tail = this.tail.next = new VarintOp((e >>>= 0) < 128 ? 1 : e < 16384 ? 2 : e < 2097152 ? 3 : e < 268435456 ? 4 : 5, e)).len, this;
  }, Writer.prototype.int32 = function (e) {
    return e < 0 ? this._push(writeVarint64, 10, LongBits$1.fromNumber(e)) : this.uint32(e);
  }, Writer.prototype.sint32 = function (e) {
    return this.uint32((e << 1 ^ e >> 31) >>> 0);
  }, Writer.prototype.uint64 = function (e) {
    var t = LongBits$1.from(e);
    return this._push(writeVarint64, t.length(), t);
  }, Writer.prototype.int64 = Writer.prototype.uint64, Writer.prototype.sint64 = function (e) {
    var t = LongBits$1.from(e).zzEncode();
    return this._push(writeVarint64, t.length(), t);
  }, Writer.prototype.bool = function (e) {
    return this._push(writeByte, 1, e ? 1 : 0);
  }, Writer.prototype.fixed32 = function (e) {
    return this._push(writeFixed32, 4, e >>> 0);
  }, Writer.prototype.sfixed32 = Writer.prototype.fixed32, Writer.prototype.fixed64 = function (e) {
    var t = LongBits$1.from(e);
    return this._push(writeFixed32, 4, t.lo)._push(writeFixed32, 4, t.hi);
  }, Writer.prototype.sfixed64 = Writer.prototype.fixed64, Writer.prototype.float = function (e) {
    return this._push(minimal.float.writeFloatLE, 4, e);
  }, Writer.prototype.double = function (e) {
    return this._push(minimal.float.writeDoubleLE, 8, e);
  };
  var writeBytes = minimal.Array.prototype.set ? function (e, t, r) {
    t.set(e, r);
  } : function (e, t, r) {
    for (var n = 0; n < e.length; ++n) {
      t[r + n] = e[n];
    }
  };
  Writer.prototype.bytes = function (e) {
    var t = e.length >>> 0;
    if (!t) return this._push(writeByte, 1, 0);

    if (minimal.isString(e)) {
      var r = Writer.alloc(t = base64.length(e));
      base64.decode(e, r, 0), e = r;
    }

    return this.uint32(t)._push(writeBytes, t, e);
  }, Writer.prototype.string = function (e) {
    var t = utf8.length(e);
    return t ? this.uint32(t)._push(utf8.write, t, e) : this._push(writeByte, 1, 0);
  }, Writer.prototype.fork = function () {
    return this.states = new State(this), this.head = this.tail = new Op(noop$2, 0, 0), this.len = 0, this;
  }, Writer.prototype.reset = function () {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op(noop$2, 0, 0), this.len = 0), this;
  }, Writer.prototype.ldelim = function () {
    var e = this.head,
        t = this.tail,
        r = this.len;
    return this.reset().uint32(r), r && (this.tail.next = e.next, this.tail = t, this.len += r), this;
  }, Writer.prototype.finish = function () {
    for (var e = this.head.next, t = this.constructor.alloc(this.len), r = 0; e;) {
      e.fn(e.val, t, r), r += e.len, e = e.next;
    }

    return t;
  }, Writer._configure = function (e) {
    BufferWriter = e, Writer.create = create(), BufferWriter._configure();
  };
  var writer_buffer = BufferWriter$1;

  function BufferWriter$1() {
    writer.call(this);
  }

  function writeStringBuffer(e, t, r) {
    e.length < 40 ? minimal.utf8.write(e, t, r) : t.utf8Write ? t.utf8Write(e, r) : t.write(e, r);
  }

  (BufferWriter$1.prototype = Object.create(writer.prototype)).constructor = BufferWriter$1, BufferWriter$1._configure = function () {
    BufferWriter$1.alloc = minimal._Buffer_allocUnsafe, BufferWriter$1.writeBytesBuffer = minimal.Buffer && minimal.Buffer.prototype instanceof Uint8Array && "set" === minimal.Buffer.prototype.set.name ? function (e, t, r) {
      t.set(e, r);
    } : function (e, t, r) {
      if (e.copy) e.copy(t, r, 0, e.length);else for (var n = 0; n < e.length;) {
        t[r++] = e[n++];
      }
    };
  }, BufferWriter$1.prototype.bytes = function (e) {
    minimal.isString(e) && (e = minimal._Buffer_from(e, "base64"));
    var t = e.length >>> 0;
    return this.uint32(t), t && this._push(BufferWriter$1.writeBytesBuffer, t, e), this;
  }, BufferWriter$1.prototype.string = function (e) {
    var t = minimal.Buffer.byteLength(e);
    return this.uint32(t), t && this._push(writeStringBuffer, t, e), this;
  }, BufferWriter$1._configure();
  var reader = Reader,
      BufferReader,
      LongBits$2 = minimal.LongBits,
      utf8$1 = minimal.utf8;

  function indexOutOfRange(e, t) {
    return RangeError("index out of range: " + e.pos + " + " + (t || 1) + " > " + e.len);
  }

  function Reader(e) {
    this.buf = e, this.pos = 0, this.len = e.length;
  }

  var create_array = "undefined" != typeof Uint8Array ? function (e) {
    if (e instanceof Uint8Array || Array.isArray(e)) return new Reader(e);
    throw Error("illegal buffer");
  } : function (e) {
    if (Array.isArray(e)) return new Reader(e);
    throw Error("illegal buffer");
  },
      create$1 = function create$1() {
    return minimal.Buffer ? function (e) {
      return (Reader.create = function (e) {
        return minimal.Buffer.isBuffer(e) ? new BufferReader(e) : create_array(e);
      })(e);
    } : create_array;
  },
      value;

  function readLongVarint() {
    var e = new LongBits$2(0, 0),
        t = 0;

    if (!(this.len - this.pos > 4)) {
      for (; t < 3; ++t) {
        if (this.pos >= this.len) throw indexOutOfRange(this);
        if (e.lo = (e.lo | (127 & this.buf[this.pos]) << 7 * t) >>> 0, this.buf[this.pos++] < 128) return e;
      }

      return e.lo = (e.lo | (127 & this.buf[this.pos++]) << 7 * t) >>> 0, e;
    }

    for (; t < 4; ++t) {
      if (e.lo = (e.lo | (127 & this.buf[this.pos]) << 7 * t) >>> 0, this.buf[this.pos++] < 128) return e;
    }

    if (e.lo = (e.lo | (127 & this.buf[this.pos]) << 28) >>> 0, e.hi = (e.hi | (127 & this.buf[this.pos]) >> 4) >>> 0, this.buf[this.pos++] < 128) return e;

    if (t = 0, this.len - this.pos > 4) {
      for (; t < 5; ++t) {
        if (e.hi = (e.hi | (127 & this.buf[this.pos]) << 7 * t + 3) >>> 0, this.buf[this.pos++] < 128) return e;
      }
    } else for (; t < 5; ++t) {
      if (this.pos >= this.len) throw indexOutOfRange(this);
      if (e.hi = (e.hi | (127 & this.buf[this.pos]) << 7 * t + 3) >>> 0, this.buf[this.pos++] < 128) return e;
    }

    throw Error("invalid varint encoding");
  }

  function readFixed32_end(e, t) {
    return (e[t - 4] | e[t - 3] << 8 | e[t - 2] << 16 | e[t - 1] << 24) >>> 0;
  }

  function readFixed64() {
    if (this.pos + 8 > this.len) throw indexOutOfRange(this, 8);
    return new LongBits$2(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
  }

  Reader.create = create$1(), Reader.prototype._slice = minimal.Array.prototype.subarray || minimal.Array.prototype.slice, Reader.prototype.uint32 = (value = 4294967295, function () {
    if (value = (127 & this.buf[this.pos]) >>> 0, this.buf[this.pos++] < 128) return value;
    if (value = (value | (127 & this.buf[this.pos]) << 7) >>> 0, this.buf[this.pos++] < 128) return value;
    if (value = (value | (127 & this.buf[this.pos]) << 14) >>> 0, this.buf[this.pos++] < 128) return value;
    if (value = (value | (127 & this.buf[this.pos]) << 21) >>> 0, this.buf[this.pos++] < 128) return value;
    if (value = (value | (15 & this.buf[this.pos]) << 28) >>> 0, this.buf[this.pos++] < 128) return value;
    if ((this.pos += 5) > this.len) throw this.pos = this.len, indexOutOfRange(this, 10);
    return value;
  }), Reader.prototype.int32 = function () {
    return 0 | this.uint32();
  }, Reader.prototype.sint32 = function () {
    var e = this.uint32();
    return e >>> 1 ^ -(1 & e) | 0;
  }, Reader.prototype.bool = function () {
    return 0 !== this.uint32();
  }, Reader.prototype.fixed32 = function () {
    if (this.pos + 4 > this.len) throw indexOutOfRange(this, 4);
    return readFixed32_end(this.buf, this.pos += 4);
  }, Reader.prototype.sfixed32 = function () {
    if (this.pos + 4 > this.len) throw indexOutOfRange(this, 4);
    return 0 | readFixed32_end(this.buf, this.pos += 4);
  }, Reader.prototype.float = function () {
    if (this.pos + 4 > this.len) throw indexOutOfRange(this, 4);
    var e = minimal.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, e;
  }, Reader.prototype.double = function () {
    if (this.pos + 8 > this.len) throw indexOutOfRange(this, 4);
    var e = minimal.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, e;
  }, Reader.prototype.bytes = function () {
    var e = this.uint32(),
        t = this.pos,
        r = this.pos + e;
    if (r > this.len) throw indexOutOfRange(this, e);
    return this.pos += e, Array.isArray(this.buf) ? this.buf.slice(t, r) : t === r ? new this.buf.constructor(0) : this._slice.call(this.buf, t, r);
  }, Reader.prototype.string = function () {
    var e = this.bytes();
    return utf8$1.read(e, 0, e.length);
  }, Reader.prototype.skip = function (e) {
    if ("number" == typeof e) {
      if (this.pos + e > this.len) throw indexOutOfRange(this, e);
      this.pos += e;
    } else do {
      if (this.pos >= this.len) throw indexOutOfRange(this);
    } while (128 & this.buf[this.pos++]);

    return this;
  }, Reader.prototype.skipType = function (e) {
    switch (e) {
      case 0:
        this.skip();
        break;

      case 1:
        this.skip(8);
        break;

      case 2:
        this.skip(this.uint32());
        break;

      case 3:
        for (; 4 != (e = 7 & this.uint32());) {
          this.skipType(e);
        }

        break;

      case 5:
        this.skip(4);
        break;

      default:
        throw Error("invalid wire type " + e + " at offset " + this.pos);
    }

    return this;
  }, Reader._configure = function (e) {
    BufferReader = e, Reader.create = create$1(), BufferReader._configure();
    var t = minimal.Long ? "toLong" : "toNumber";
    minimal.merge(Reader.prototype, {
      int64: function int64() {
        return readLongVarint.call(this)[t](!1);
      },
      uint64: function uint64() {
        return readLongVarint.call(this)[t](!0);
      },
      sint64: function sint64() {
        return readLongVarint.call(this).zzDecode()[t](!1);
      },
      fixed64: function fixed64() {
        return readFixed64.call(this)[t](!0);
      },
      sfixed64: function sfixed64() {
        return readFixed64.call(this)[t](!1);
      }
    });
  };
  var reader_buffer = BufferReader$1;

  function BufferReader$1(e) {
    reader.call(this, e);
  }

  (BufferReader$1.prototype = Object.create(reader.prototype)).constructor = BufferReader$1, BufferReader$1._configure = function () {
    minimal.Buffer && (BufferReader$1.prototype._slice = minimal.Buffer.prototype.slice);
  }, BufferReader$1.prototype.string = function () {
    var e = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + e, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + e, this.len));
  }, BufferReader$1._configure();
  var service = Service;

  function Service(e, t, r) {
    if ("function" != typeof e) throw TypeError("rpcImpl must be a function");
    minimal.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = Boolean(t), this.responseDelimited = Boolean(r);
  }

  (Service.prototype = Object.create(minimal.EventEmitter.prototype)).constructor = Service, Service.prototype.rpcCall = function e(t, r, n, o, i) {
    if (!o) throw TypeError("request must be specified");
    var s = this;
    if (!i) return minimal.asPromise(e, s, t, r, n, o);
    if (s.rpcImpl) try {
      return s.rpcImpl(t, r[s.requestDelimited ? "encodeDelimited" : "encode"](o).finish(), function (e, r) {
        if (e) return s.emit("error", e, t), i(e);

        if (null !== r) {
          if (!(r instanceof n)) try {
            r = n[s.responseDelimited ? "decodeDelimited" : "decode"](r);
          } catch (e) {
            return s.emit("error", e, t), i(e);
          }
          return s.emit("data", r, t), i(null, r);
        }

        s.end(!0);
      });
    } catch (e) {
      return s.emit("error", e, t), void setTimeout(function () {
        i(e);
      }, 0);
    } else setTimeout(function () {
      i(Error("already ended"));
    }, 0);
  }, Service.prototype.end = function (e) {
    return this.rpcImpl && (e || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  };
  var rpc_1 = createCommonjsModule(function (e, t) {
    t.Service = service;
  }),
      roots = {},
      indexMinimal = createCommonjsModule(function (e, t) {
    var r = t;

    function n() {
      r.util._configure(), r.Writer._configure(r.BufferWriter), r.Reader._configure(r.BufferReader);
    }

    r.build = "minimal", r.Writer = writer, r.BufferWriter = writer_buffer, r.Reader = reader, r.BufferReader = reader_buffer, r.util = minimal, r.rpc = rpc_1, r.roots = roots, r.configure = n, n();
  }),
      indexMinimal_1 = indexMinimal.build,
      indexMinimal_2 = indexMinimal.Writer,
      indexMinimal_3 = indexMinimal.BufferWriter,
      indexMinimal_4 = indexMinimal.Reader,
      indexMinimal_5 = indexMinimal.BufferReader,
      indexMinimal_6 = indexMinimal.util,
      indexMinimal_7 = indexMinimal.rpc,
      indexMinimal_8 = indexMinimal.roots,
      indexMinimal_9 = indexMinimal.configure;
  indexMinimal_6.Long = long_1, indexMinimal_9();
  var $Reader = indexMinimal_4,
      $Writer = indexMinimal_2,
      $util = indexMinimal_6,
      $root = indexMinimal_8.default || (indexMinimal_8.default = {});

  $root.URI = function () {
    var e = {},
        t = Object.create(e);
    return t[e[0] = "Unknown"] = 0, t[e[1] = "PingUri"] = 1, t[e[2] = "PongUri"] = 2, t[e[11] = "UserJoinUri"] = 11, t[e[12] = "UserRespUri"] = 12, t[e[21] = "UserQuitUri"] = 21, t[e[22] = "UserDropUri"] = 22, t[e[31] = "GroupEnterUri"] = 31, t[e[32] = "GroupLeaveUri"] = 32, t[e[33] = "GroupReplyUri"] = 33, t[e[36] = "GroupEnterNoticeUri"] = 36, t[e[37] = "GroupLeaveNoticeUri"] = 37, t[e[38] = "GroupEventNoticeUri"] = 38, t[e[39] = "GroupCountNoticeUri"] = 39, t[e[41] = "UserStatusListUri"] = 41, t[e[42] = "UserStatusResultUri"] = 42, t[e[51] = "GroupStatusListUri"] = 51, t[e[52] = "GroupStatusResultUri"] = 52, t[e[55] = "GroupAllUsersListUri"] = 55, t[e[56] = "GroupAllUsersResultUri"] = 56, t[e[100] = "MessageUri"] = 100, t[e[101] = "AckUri"] = 101, t[e[115] = "FileUploadIndexGetUri"] = 115, t[e[116] = "FileUploadIndexRetUri"] = 116, t[e[117] = "FileUploadIndexSetUri"] = 117, t[e[118] = "FileUploadIndexFinUri"] = 118, t[e[119] = "FileUploadIndexErrUri"] = 119, t[e[125] = "FileDownloadIndexGetUri"] = 125, t[e[126] = "FileDownloadIndexRetUri"] = 126, t[e[127] = "FileDownloadIndexErrUri"] = 127, t[e[201] = "UserJoinNoticeUri"] = 201, t[e[202] = "UserQuitNoticeUri"] = 202, t[e[203] = "UserWaitNoticeUri"] = 203, t[e[301] = "UserAttributeGetUri"] = 301, t[e[302] = "UserAttributeRetUri"] = 302, t[e[303] = "UserAttributeSetUri"] = 303, t[e[304] = "UserAttributeModUri"] = 304, t[e[305] = "UserAttributeDelUri"] = 305, t[e[307] = "UserAttributeRspUri"] = 307, t[e[308] = "UserAttributeErrUri"] = 308, t[e[311] = "UserAttributeKeysGetUri"] = 311, t[e[312] = "UserAttributeKeysRetUri"] = 312, t[e[351] = "GroupAttributeGetUri"] = 351, t[e[352] = "GroupAttributeRetUri"] = 352, t[e[353] = "GroupAttributeSetUri"] = 353, t[e[354] = "GroupAttributeModUri"] = 354, t[e[355] = "GroupAttributeDelUri"] = 355, t[e[356] = "GroupAttributeAltUri"] = 356, t[e[357] = "GroupAttributeRspUri"] = 357, t[e[358] = "GroupAttributeErrUri"] = 358, t[e[361] = "GroupAttributeKeysGetUri"] = 361, t[e[362] = "GroupAttributeKeysRetUri"] = 362, t[e[401] = "SubscribeUserStatusUri"] = 401, t[e[402] = "UnsubscribeUserStatusUri"] = 402, t[e[499] = "SubscribeResponseUri"] = 499, t;
  }();

  var Wrapper$1 = $root.Wrapper = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.uri = 0, e.prototype.data = $util.newBuffer([]), e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.uri && Object.hasOwnProperty.call(e, "uri") && t.uint32(8).int32(e.uri), null != e.data && Object.hasOwnProperty.call(e, "data") && t.uint32(18).bytes(e.data), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.Wrapper(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.uri = e.int32();
            break;

          case 2:
            n.data = e.bytes();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.uri && e.hasOwnProperty("uri")) switch (e.uri) {
        default:
          return "uri: enum value expected";

        case 0:
        case 1:
        case 2:
        case 11:
        case 12:
        case 21:
        case 22:
        case 31:
        case 32:
        case 33:
        case 36:
        case 37:
        case 38:
        case 39:
        case 41:
        case 42:
        case 51:
        case 52:
        case 55:
        case 56:
        case 100:
        case 101:
        case 115:
        case 116:
        case 117:
        case 118:
        case 119:
        case 125:
        case 126:
        case 127:
        case 201:
        case 202:
        case 203:
        case 301:
        case 302:
        case 303:
        case 304:
        case 305:
        case 307:
        case 308:
        case 311:
        case 312:
        case 351:
        case 352:
        case 353:
        case 354:
        case 355:
        case 356:
        case 357:
        case 358:
        case 361:
        case 362:
        case 401:
        case 402:
        case 499:
      }
      return null != e.data && e.hasOwnProperty("data") && !(e.data && "number" == typeof e.data.length || $util.isString(e.data)) ? "data: buffer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.Wrapper) return e;
      var t = new $root.Wrapper();

      switch (e.uri) {
        case "Unknown":
        case 0:
          t.uri = 0;
          break;

        case "PingUri":
        case 1:
          t.uri = 1;
          break;

        case "PongUri":
        case 2:
          t.uri = 2;
          break;

        case "UserJoinUri":
        case 11:
          t.uri = 11;
          break;

        case "UserRespUri":
        case 12:
          t.uri = 12;
          break;

        case "UserQuitUri":
        case 21:
          t.uri = 21;
          break;

        case "UserDropUri":
        case 22:
          t.uri = 22;
          break;

        case "GroupEnterUri":
        case 31:
          t.uri = 31;
          break;

        case "GroupLeaveUri":
        case 32:
          t.uri = 32;
          break;

        case "GroupReplyUri":
        case 33:
          t.uri = 33;
          break;

        case "GroupEnterNoticeUri":
        case 36:
          t.uri = 36;
          break;

        case "GroupLeaveNoticeUri":
        case 37:
          t.uri = 37;
          break;

        case "GroupEventNoticeUri":
        case 38:
          t.uri = 38;
          break;

        case "GroupCountNoticeUri":
        case 39:
          t.uri = 39;
          break;

        case "UserStatusListUri":
        case 41:
          t.uri = 41;
          break;

        case "UserStatusResultUri":
        case 42:
          t.uri = 42;
          break;

        case "GroupStatusListUri":
        case 51:
          t.uri = 51;
          break;

        case "GroupStatusResultUri":
        case 52:
          t.uri = 52;
          break;

        case "GroupAllUsersListUri":
        case 55:
          t.uri = 55;
          break;

        case "GroupAllUsersResultUri":
        case 56:
          t.uri = 56;
          break;

        case "MessageUri":
        case 100:
          t.uri = 100;
          break;

        case "AckUri":
        case 101:
          t.uri = 101;
          break;

        case "FileUploadIndexGetUri":
        case 115:
          t.uri = 115;
          break;

        case "FileUploadIndexRetUri":
        case 116:
          t.uri = 116;
          break;

        case "FileUploadIndexSetUri":
        case 117:
          t.uri = 117;
          break;

        case "FileUploadIndexFinUri":
        case 118:
          t.uri = 118;
          break;

        case "FileUploadIndexErrUri":
        case 119:
          t.uri = 119;
          break;

        case "FileDownloadIndexGetUri":
        case 125:
          t.uri = 125;
          break;

        case "FileDownloadIndexRetUri":
        case 126:
          t.uri = 126;
          break;

        case "FileDownloadIndexErrUri":
        case 127:
          t.uri = 127;
          break;

        case "UserJoinNoticeUri":
        case 201:
          t.uri = 201;
          break;

        case "UserQuitNoticeUri":
        case 202:
          t.uri = 202;
          break;

        case "UserWaitNoticeUri":
        case 203:
          t.uri = 203;
          break;

        case "UserAttributeGetUri":
        case 301:
          t.uri = 301;
          break;

        case "UserAttributeRetUri":
        case 302:
          t.uri = 302;
          break;

        case "UserAttributeSetUri":
        case 303:
          t.uri = 303;
          break;

        case "UserAttributeModUri":
        case 304:
          t.uri = 304;
          break;

        case "UserAttributeDelUri":
        case 305:
          t.uri = 305;
          break;

        case "UserAttributeRspUri":
        case 307:
          t.uri = 307;
          break;

        case "UserAttributeErrUri":
        case 308:
          t.uri = 308;
          break;

        case "UserAttributeKeysGetUri":
        case 311:
          t.uri = 311;
          break;

        case "UserAttributeKeysRetUri":
        case 312:
          t.uri = 312;
          break;

        case "GroupAttributeGetUri":
        case 351:
          t.uri = 351;
          break;

        case "GroupAttributeRetUri":
        case 352:
          t.uri = 352;
          break;

        case "GroupAttributeSetUri":
        case 353:
          t.uri = 353;
          break;

        case "GroupAttributeModUri":
        case 354:
          t.uri = 354;
          break;

        case "GroupAttributeDelUri":
        case 355:
          t.uri = 355;
          break;

        case "GroupAttributeAltUri":
        case 356:
          t.uri = 356;
          break;

        case "GroupAttributeRspUri":
        case 357:
          t.uri = 357;
          break;

        case "GroupAttributeErrUri":
        case 358:
          t.uri = 358;
          break;

        case "GroupAttributeKeysGetUri":
        case 361:
          t.uri = 361;
          break;

        case "GroupAttributeKeysRetUri":
        case 362:
          t.uri = 362;
          break;

        case "SubscribeUserStatusUri":
        case 401:
          t.uri = 401;
          break;

        case "UnsubscribeUserStatusUri":
        case 402:
          t.uri = 402;
          break;

        case "SubscribeResponseUri":
        case 499:
          t.uri = 499;
      }

      return null != e.data && ("string" == typeof e.data ? $util.base64.decode(e.data, t.data = $util.newBuffer($util.base64.length(e.data)), 0) : e.data.length && (t.data = e.data)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      return t.defaults && (r.uri = t.enums === String ? "Unknown" : 0, t.bytes === String ? r.data = "" : (r.data = [], t.bytes !== Array && (r.data = $util.newBuffer(r.data)))), null != e.uri && e.hasOwnProperty("uri") && (r.uri = t.enums === String ? $root.URI[e.uri] : e.uri), null != e.data && e.hasOwnProperty("data") && (r.data = t.bytes === String ? $util.base64.encode(e.data, 0, e.data.length) : t.bytes === Array ? Array.prototype.slice.call(e.data) : e.data), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      Ping = $root.Ping = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.ms = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.ms && Object.hasOwnProperty.call(e, "ms") && t.uint32(16).uint64(e.ms), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.Ping(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.ms = e.uint64();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.ms && e.hasOwnProperty("ms") && !($util.isInteger(e.ms) || e.ms && $util.isInteger(e.ms.low) && $util.isInteger(e.ms.high)) ? "ms: integer|Long expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.Ping) return e;
      var t = new $root.Ping();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.ms && ($util.Long ? (t.ms = $util.Long.fromValue(e.ms)).unsigned = !0 : "string" == typeof e.ms ? t.ms = parseInt(e.ms, 10) : "number" == typeof e.ms ? t.ms = e.ms : "object" === _typeof(e.ms) && (t.ms = new $util.LongBits(e.ms.low >>> 0, e.ms.high >>> 0).toNumber(!0))), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var o = new $util.Long(0, 0, !0);
          r.ms = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.ms = t.longs === String ? "0" : 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.ms && e.hasOwnProperty("ms") && ("number" == typeof e.ms ? r.ms = t.longs === String ? String(e.ms) : e.ms : r.ms = t.longs === String ? $util.Long.prototype.toString.call(e.ms) : t.longs === Number ? new $util.LongBits(e.ms.low >>> 0, e.ms.high >>> 0).toNumber(!0) : e.ms), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      Pong = $root.Pong = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.ms = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.ms && Object.hasOwnProperty.call(e, "ms") && t.uint32(16).uint64(e.ms), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.Pong(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.ms = e.uint64();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.ms && e.hasOwnProperty("ms") && !($util.isInteger(e.ms) || e.ms && $util.isInteger(e.ms.low) && $util.isInteger(e.ms.high)) ? "ms: integer|Long expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.Pong) return e;
      var t = new $root.Pong();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.ms && ($util.Long ? (t.ms = $util.Long.fromValue(e.ms)).unsigned = !0 : "string" == typeof e.ms ? t.ms = parseInt(e.ms, 10) : "number" == typeof e.ms ? t.ms = e.ms : "object" === _typeof(e.ms) && (t.ms = new $util.LongBits(e.ms.low >>> 0, e.ms.high >>> 0).toNumber(!0))), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var o = new $util.Long(0, 0, !0);
          r.ms = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.ms = t.longs === String ? "0" : 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.ms && e.hasOwnProperty("ms") && ("number" == typeof e.ms ? r.ms = t.longs === String ? String(e.ms) : e.ms : r.ms = t.longs === String ? $util.Long.prototype.toString.call(e.ms) : t.longs === Number ? new $util.LongBits(e.ms.low >>> 0, e.ms.high >>> 0).toNumber(!0) : e.ms), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserJoin = $root.UserJoin = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.opt = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.instance = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.account = "", e.prototype.ticket = "", e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.opt && Object.hasOwnProperty.call(e, "opt") && t.uint32(16).uint64(e.opt), null != e.instance && Object.hasOwnProperty.call(e, "instance") && t.uint32(24).uint64(e.instance), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(34).string(e.account), null != e.ticket && Object.hasOwnProperty.call(e, "ticket") && t.uint32(42).string(e.ticket), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserJoin(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.opt = e.uint64();
            break;

          case 3:
            n.instance = e.uint64();
            break;

          case 4:
            n.account = e.string();
            break;

          case 5:
            n.ticket = e.string();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.opt && e.hasOwnProperty("opt") && !($util.isInteger(e.opt) || e.opt && $util.isInteger(e.opt.low) && $util.isInteger(e.opt.high)) ? "opt: integer|Long expected" : null != e.instance && e.hasOwnProperty("instance") && !($util.isInteger(e.instance) || e.instance && $util.isInteger(e.instance.low) && $util.isInteger(e.instance.high)) ? "instance: integer|Long expected" : null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account) ? "account: string expected" : null != e.ticket && e.hasOwnProperty("ticket") && !$util.isString(e.ticket) ? "ticket: string expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserJoin) return e;
      var t = new $root.UserJoin();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.opt && ($util.Long ? (t.opt = $util.Long.fromValue(e.opt)).unsigned = !0 : "string" == typeof e.opt ? t.opt = parseInt(e.opt, 10) : "number" == typeof e.opt ? t.opt = e.opt : "object" === _typeof(e.opt) && (t.opt = new $util.LongBits(e.opt.low >>> 0, e.opt.high >>> 0).toNumber(!0))), null != e.instance && ($util.Long ? (t.instance = $util.Long.fromValue(e.instance)).unsigned = !0 : "string" == typeof e.instance ? t.instance = parseInt(e.instance, 10) : "number" == typeof e.instance ? t.instance = e.instance : "object" === _typeof(e.instance) && (t.instance = new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0))), null != e.account && (t.account = String(e.account)), null != e.ticket && (t.ticket = String(e.ticket)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var o = new $util.Long(0, 0, !0);
          r.opt = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.opt = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var i = new $util.Long(0, 0, !0);
          r.instance = t.longs === String ? i.toString() : t.longs === Number ? i.toNumber() : i;
        } else r.instance = t.longs === String ? "0" : 0;

        r.account = "", r.ticket = "";
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.opt && e.hasOwnProperty("opt") && ("number" == typeof e.opt ? r.opt = t.longs === String ? String(e.opt) : e.opt : r.opt = t.longs === String ? $util.Long.prototype.toString.call(e.opt) : t.longs === Number ? new $util.LongBits(e.opt.low >>> 0, e.opt.high >>> 0).toNumber(!0) : e.opt), null != e.instance && e.hasOwnProperty("instance") && ("number" == typeof e.instance ? r.instance = t.longs === String ? String(e.instance) : e.instance : r.instance = t.longs === String ? $util.Long.prototype.toString.call(e.instance) : t.longs === Number ? new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0) : e.instance), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), null != e.ticket && e.hasOwnProperty("ticket") && (r.ticket = e.ticket), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserResp = $root.UserResp = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.account = "", e.prototype.code = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(18).string(e.account), null != e.code && Object.hasOwnProperty.call(e, "code") && t.uint32(24).uint32(e.code), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserResp(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.account = e.string();
            break;

          case 3:
            n.code = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account) ? "account: string expected" : null != e.code && e.hasOwnProperty("code") && !$util.isInteger(e.code) ? "code: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserResp) return e;
      var t = new $root.UserResp();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.account && (t.account = String(e.account)), null != e.code && (t.code = e.code >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.account = "", r.code = 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), null != e.code && e.hasOwnProperty("code") && (r.code = e.code), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserQuit = $root.UserQuit = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.encode = function (e, t) {
      return t || (t = $Writer.create()), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserQuit(); e.pos < r;) {
        var o = e.uint32();
        e.skipType(7 & o);
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null;
    }, e.fromObject = function (e) {
      return e instanceof $root.UserQuit ? e : new $root.UserQuit();
    }, e.toObject = function () {
      return {};
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserDrop = $root.UserDrop = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.code = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.code && Object.hasOwnProperty.call(e, "code") && t.uint32(8).uint32(e.code), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserDrop(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.code = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.code && e.hasOwnProperty("code") && !$util.isInteger(e.code) ? "code: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserDrop) return e;
      var t = new $root.UserDrop();
      return null != e.code && (t.code = e.code >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      return t.defaults && (r.code = 0), null != e.code && e.hasOwnProperty("code") && (r.code = e.code), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupEnter = $root.GroupEnter = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.account = "", e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(18).string(e.account), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupEnter(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.account = e.string();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account) ? "account: string expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupEnter) return e;
      var t = new $root.GroupEnter();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.account && (t.account = String(e.account)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.account = "";
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupLeave = $root.GroupLeave = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.account = "", e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(10).string(e.account), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupLeave(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.account = e.string();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account) ? "account: string expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupLeave) return e;
      var t = new $root.GroupLeave();
      return null != e.account && (t.account = String(e.account)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      return t.defaults && (r.account = ""), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupReply = $root.GroupReply = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.account = "", e.prototype.code = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(18).string(e.account), null != e.code && Object.hasOwnProperty.call(e, "code") && t.uint32(24).uint32(e.code), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupReply(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.account = e.string();
            break;

          case 3:
            n.code = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account) ? "account: string expected" : null != e.code && e.hasOwnProperty("code") && !$util.isInteger(e.code) ? "code: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupReply) return e;
      var t = new $root.GroupReply();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.account && (t.account = String(e.account)), null != e.code && (t.code = e.code >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.account = "", r.code = 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), null != e.code && e.hasOwnProperty("code") && (r.code = e.code), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupLeaveNotice = $root.GroupLeaveNotice = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.user = "", e.prototype.group = "", e.prototype.instance = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.size = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.user && Object.hasOwnProperty.call(e, "user") && t.uint32(18).string(e.user), null != e.group && Object.hasOwnProperty.call(e, "group") && t.uint32(26).string(e.group), null != e.instance && Object.hasOwnProperty.call(e, "instance") && t.uint32(32).uint64(e.instance), null != e.size && Object.hasOwnProperty.call(e, "size") && t.uint32(40).uint32(e.size), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupLeaveNotice(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.user = e.string();
            break;

          case 3:
            n.group = e.string();
            break;

          case 4:
            n.instance = e.uint64();
            break;

          case 5:
            n.size = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.user && e.hasOwnProperty("user") && !$util.isString(e.user) ? "user: string expected" : null != e.group && e.hasOwnProperty("group") && !$util.isString(e.group) ? "group: string expected" : null != e.instance && e.hasOwnProperty("instance") && !($util.isInteger(e.instance) || e.instance && $util.isInteger(e.instance.low) && $util.isInteger(e.instance.high)) ? "instance: integer|Long expected" : null != e.size && e.hasOwnProperty("size") && !$util.isInteger(e.size) ? "size: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupLeaveNotice) return e;
      var t = new $root.GroupLeaveNotice();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.user && (t.user = String(e.user)), null != e.group && (t.group = String(e.group)), null != e.instance && ($util.Long ? (t.instance = $util.Long.fromValue(e.instance)).unsigned = !0 : "string" == typeof e.instance ? t.instance = parseInt(e.instance, 10) : "number" == typeof e.instance ? t.instance = e.instance : "object" === _typeof(e.instance) && (t.instance = new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0))), null != e.size && (t.size = e.size >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        if (r.user = "", r.group = "", $util.Long) {
          var o = new $util.Long(0, 0, !0);
          r.instance = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.instance = t.longs === String ? "0" : 0;

        r.size = 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.user && e.hasOwnProperty("user") && (r.user = e.user), null != e.group && e.hasOwnProperty("group") && (r.group = e.group), null != e.instance && e.hasOwnProperty("instance") && ("number" == typeof e.instance ? r.instance = t.longs === String ? String(e.instance) : e.instance : r.instance = t.longs === String ? $util.Long.prototype.toString.call(e.instance) : t.longs === Number ? new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0) : e.instance), null != e.size && e.hasOwnProperty("size") && (r.size = e.size), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupEnterNotice = $root.GroupEnterNotice = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.user = "", e.prototype.group = "", e.prototype.instance = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.size = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.user && Object.hasOwnProperty.call(e, "user") && t.uint32(18).string(e.user), null != e.group && Object.hasOwnProperty.call(e, "group") && t.uint32(26).string(e.group), null != e.instance && Object.hasOwnProperty.call(e, "instance") && t.uint32(32).uint64(e.instance), null != e.size && Object.hasOwnProperty.call(e, "size") && t.uint32(40).uint32(e.size), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupEnterNotice(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.user = e.string();
            break;

          case 3:
            n.group = e.string();
            break;

          case 4:
            n.instance = e.uint64();
            break;

          case 5:
            n.size = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.user && e.hasOwnProperty("user") && !$util.isString(e.user) ? "user: string expected" : null != e.group && e.hasOwnProperty("group") && !$util.isString(e.group) ? "group: string expected" : null != e.instance && e.hasOwnProperty("instance") && !($util.isInteger(e.instance) || e.instance && $util.isInteger(e.instance.low) && $util.isInteger(e.instance.high)) ? "instance: integer|Long expected" : null != e.size && e.hasOwnProperty("size") && !$util.isInteger(e.size) ? "size: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupEnterNotice) return e;
      var t = new $root.GroupEnterNotice();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.user && (t.user = String(e.user)), null != e.group && (t.group = String(e.group)), null != e.instance && ($util.Long ? (t.instance = $util.Long.fromValue(e.instance)).unsigned = !0 : "string" == typeof e.instance ? t.instance = parseInt(e.instance, 10) : "number" == typeof e.instance ? t.instance = e.instance : "object" === _typeof(e.instance) && (t.instance = new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0))), null != e.size && (t.size = e.size >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        if (r.user = "", r.group = "", $util.Long) {
          var o = new $util.Long(0, 0, !0);
          r.instance = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.instance = t.longs === String ? "0" : 0;

        r.size = 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.user && e.hasOwnProperty("user") && (r.user = e.user), null != e.group && e.hasOwnProperty("group") && (r.group = e.group), null != e.instance && e.hasOwnProperty("instance") && ("number" == typeof e.instance ? r.instance = t.longs === String ? String(e.instance) : e.instance : r.instance = t.longs === String ? $util.Long.prototype.toString.call(e.instance) : t.longs === Number ? new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0) : e.instance), null != e.size && e.hasOwnProperty("size") && (r.size = e.size), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      Message = $root.Message = function () {
    function e(e) {
      if (this.MiscMap = {}, e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.instance = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.dialogue = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.sequence = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.options = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.src = "", e.prototype.dst = "", e.prototype.payload = $util.newBuffer([]), e.prototype.MiscMap = $util.emptyObject, e.prototype.ms = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.instance && Object.hasOwnProperty.call(e, "instance") && t.uint32(8).uint64(e.instance), null != e.dialogue && Object.hasOwnProperty.call(e, "dialogue") && t.uint32(16).uint64(e.dialogue), null != e.sequence && Object.hasOwnProperty.call(e, "sequence") && t.uint32(24).uint64(e.sequence), null != e.options && Object.hasOwnProperty.call(e, "options") && t.uint32(32).uint64(e.options), null != e.src && Object.hasOwnProperty.call(e, "src") && t.uint32(42).string(e.src), null != e.dst && Object.hasOwnProperty.call(e, "dst") && t.uint32(50).string(e.dst), null != e.payload && Object.hasOwnProperty.call(e, "payload") && t.uint32(58).bytes(e.payload), null != e.MiscMap && Object.hasOwnProperty.call(e, "MiscMap")) for (var r = Object.keys(e.MiscMap), n = 0; n < r.length; ++n) {
        t.uint32(66).fork().uint32(10).string(r[n]).uint32(18).bytes(e.MiscMap[r[n]]).ldelim();
      }
      return null != e.ms && Object.hasOwnProperty.call(e, "ms") && t.uint32(72).uint64(e.ms), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r, n = void 0 === t ? e.len : e.pos + t, o = new $root.Message(); e.pos < n;) {
        var i = e.uint32();

        switch (i >>> 3) {
          case 1:
            o.instance = e.uint64();
            break;

          case 2:
            o.dialogue = e.uint64();
            break;

          case 3:
            o.sequence = e.uint64();
            break;

          case 4:
            o.options = e.uint64();
            break;

          case 5:
            o.src = e.string();
            break;

          case 6:
            o.dst = e.string();
            break;

          case 7:
            o.payload = e.bytes();
            break;

          case 8:
            e.skip().pos++, o.MiscMap === $util.emptyObject && (o.MiscMap = {}), r = e.string(), e.pos++, o.MiscMap[r] = e.bytes();
            break;

          case 9:
            o.ms = e.uint64();
            break;

          default:
            e.skipType(7 & i);
        }
      }

      return o;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.instance && e.hasOwnProperty("instance") && !($util.isInteger(e.instance) || e.instance && $util.isInteger(e.instance.low) && $util.isInteger(e.instance.high))) return "instance: integer|Long expected";
      if (null != e.dialogue && e.hasOwnProperty("dialogue") && !($util.isInteger(e.dialogue) || e.dialogue && $util.isInteger(e.dialogue.low) && $util.isInteger(e.dialogue.high))) return "dialogue: integer|Long expected";
      if (null != e.sequence && e.hasOwnProperty("sequence") && !($util.isInteger(e.sequence) || e.sequence && $util.isInteger(e.sequence.low) && $util.isInteger(e.sequence.high))) return "sequence: integer|Long expected";
      if (null != e.options && e.hasOwnProperty("options") && !($util.isInteger(e.options) || e.options && $util.isInteger(e.options.low) && $util.isInteger(e.options.high))) return "options: integer|Long expected";
      if (null != e.src && e.hasOwnProperty("src") && !$util.isString(e.src)) return "src: string expected";
      if (null != e.dst && e.hasOwnProperty("dst") && !$util.isString(e.dst)) return "dst: string expected";
      if (null != e.payload && e.hasOwnProperty("payload") && !(e.payload && "number" == typeof e.payload.length || $util.isString(e.payload))) return "payload: buffer expected";

      if (null != e.MiscMap && e.hasOwnProperty("MiscMap")) {
        if (!$util.isObject(e.MiscMap)) return "MiscMap: object expected";

        for (var t = Object.keys(e.MiscMap), r = 0; r < t.length; ++r) {
          if (!(e.MiscMap[t[r]] && "number" == typeof e.MiscMap[t[r]].length || $util.isString(e.MiscMap[t[r]]))) return "MiscMap: buffer{k:string} expected";
        }
      }

      return null != e.ms && e.hasOwnProperty("ms") && !($util.isInteger(e.ms) || e.ms && $util.isInteger(e.ms.low) && $util.isInteger(e.ms.high)) ? "ms: integer|Long expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.Message) return e;
      var t = new $root.Message();

      if (null != e.instance && ($util.Long ? (t.instance = $util.Long.fromValue(e.instance)).unsigned = !0 : "string" == typeof e.instance ? t.instance = parseInt(e.instance, 10) : "number" == typeof e.instance ? t.instance = e.instance : "object" === _typeof(e.instance) && (t.instance = new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0))), null != e.dialogue && ($util.Long ? (t.dialogue = $util.Long.fromValue(e.dialogue)).unsigned = !0 : "string" == typeof e.dialogue ? t.dialogue = parseInt(e.dialogue, 10) : "number" == typeof e.dialogue ? t.dialogue = e.dialogue : "object" === _typeof(e.dialogue) && (t.dialogue = new $util.LongBits(e.dialogue.low >>> 0, e.dialogue.high >>> 0).toNumber(!0))), null != e.sequence && ($util.Long ? (t.sequence = $util.Long.fromValue(e.sequence)).unsigned = !0 : "string" == typeof e.sequence ? t.sequence = parseInt(e.sequence, 10) : "number" == typeof e.sequence ? t.sequence = e.sequence : "object" === _typeof(e.sequence) && (t.sequence = new $util.LongBits(e.sequence.low >>> 0, e.sequence.high >>> 0).toNumber(!0))), null != e.options && ($util.Long ? (t.options = $util.Long.fromValue(e.options)).unsigned = !0 : "string" == typeof e.options ? t.options = parseInt(e.options, 10) : "number" == typeof e.options ? t.options = e.options : "object" === _typeof(e.options) && (t.options = new $util.LongBits(e.options.low >>> 0, e.options.high >>> 0).toNumber(!0))), null != e.src && (t.src = String(e.src)), null != e.dst && (t.dst = String(e.dst)), null != e.payload && ("string" == typeof e.payload ? $util.base64.decode(e.payload, t.payload = $util.newBuffer($util.base64.length(e.payload)), 0) : e.payload.length && (t.payload = e.payload)), e.MiscMap) {
        if ("object" !== _typeof(e.MiscMap)) throw TypeError(".Message.MiscMap: object expected");
        t.MiscMap = {};

        for (var r = Object.keys(e.MiscMap), n = 0; n < r.length; ++n) {
          "string" == typeof e.MiscMap[r[n]] ? $util.base64.decode(e.MiscMap[r[n]], t.MiscMap[r[n]] = $util.newBuffer($util.base64.length(e.MiscMap[r[n]])), 0) : e.MiscMap[r[n]].length && (t.MiscMap[r[n]] = e.MiscMap[r[n]]);
        }
      }

      return null != e.ms && ($util.Long ? (t.ms = $util.Long.fromValue(e.ms)).unsigned = !0 : "string" == typeof e.ms ? t.ms = parseInt(e.ms, 10) : "number" == typeof e.ms ? t.ms = e.ms : "object" === _typeof(e.ms) && (t.ms = new $util.LongBits(e.ms.low >>> 0, e.ms.high >>> 0).toNumber(!0))), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r,
          n = {};

      if ((t.objects || t.defaults) && (n.MiscMap = {}), t.defaults) {
        if ($util.Long) {
          var o = new $util.Long(0, 0, !0);
          n.instance = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else n.instance = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var i = new $util.Long(0, 0, !0);
          n.dialogue = t.longs === String ? i.toString() : t.longs === Number ? i.toNumber() : i;
        } else n.dialogue = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var s = new $util.Long(0, 0, !0);
          n.sequence = t.longs === String ? s.toString() : t.longs === Number ? s.toNumber() : s;
        } else n.sequence = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var a = new $util.Long(0, 0, !0);
          n.options = t.longs === String ? a.toString() : t.longs === Number ? a.toNumber() : a;
        } else n.options = t.longs === String ? "0" : 0;

        if (n.src = "", n.dst = "", t.bytes === String ? n.payload = "" : (n.payload = [], t.bytes !== Array && (n.payload = $util.newBuffer(n.payload))), $util.Long) {
          var u = new $util.Long(0, 0, !0);
          n.ms = t.longs === String ? u.toString() : t.longs === Number ? u.toNumber() : u;
        } else n.ms = t.longs === String ? "0" : 0;
      }

      if (null != e.instance && e.hasOwnProperty("instance") && ("number" == typeof e.instance ? n.instance = t.longs === String ? String(e.instance) : e.instance : n.instance = t.longs === String ? $util.Long.prototype.toString.call(e.instance) : t.longs === Number ? new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0) : e.instance), null != e.dialogue && e.hasOwnProperty("dialogue") && ("number" == typeof e.dialogue ? n.dialogue = t.longs === String ? String(e.dialogue) : e.dialogue : n.dialogue = t.longs === String ? $util.Long.prototype.toString.call(e.dialogue) : t.longs === Number ? new $util.LongBits(e.dialogue.low >>> 0, e.dialogue.high >>> 0).toNumber(!0) : e.dialogue), null != e.sequence && e.hasOwnProperty("sequence") && ("number" == typeof e.sequence ? n.sequence = t.longs === String ? String(e.sequence) : e.sequence : n.sequence = t.longs === String ? $util.Long.prototype.toString.call(e.sequence) : t.longs === Number ? new $util.LongBits(e.sequence.low >>> 0, e.sequence.high >>> 0).toNumber(!0) : e.sequence), null != e.options && e.hasOwnProperty("options") && ("number" == typeof e.options ? n.options = t.longs === String ? String(e.options) : e.options : n.options = t.longs === String ? $util.Long.prototype.toString.call(e.options) : t.longs === Number ? new $util.LongBits(e.options.low >>> 0, e.options.high >>> 0).toNumber(!0) : e.options), null != e.src && e.hasOwnProperty("src") && (n.src = e.src), null != e.dst && e.hasOwnProperty("dst") && (n.dst = e.dst), null != e.payload && e.hasOwnProperty("payload") && (n.payload = t.bytes === String ? $util.base64.encode(e.payload, 0, e.payload.length) : t.bytes === Array ? Array.prototype.slice.call(e.payload) : e.payload), e.MiscMap && (r = Object.keys(e.MiscMap)).length) {
        n.MiscMap = {};

        for (var l = 0; l < r.length; ++l) {
          n.MiscMap[r[l]] = t.bytes === String ? $util.base64.encode(e.MiscMap[r[l]], 0, e.MiscMap[r[l]].length) : t.bytes === Array ? Array.prototype.slice.call(e.MiscMap[r[l]]) : e.MiscMap[r[l]];
        }
      }

      return null != e.ms && e.hasOwnProperty("ms") && ("number" == typeof e.ms ? n.ms = t.longs === String ? String(e.ms) : e.ms : n.ms = t.longs === String ? $util.Long.prototype.toString.call(e.ms) : t.longs === Number ? new $util.LongBits(e.ms.low >>> 0, e.ms.high >>> 0).toNumber(!0) : e.ms), n;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      Ack = $root.Ack = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.instance = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.dialogue = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.sequence = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.code = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.instance && Object.hasOwnProperty.call(e, "instance") && t.uint32(8).uint64(e.instance), null != e.dialogue && Object.hasOwnProperty.call(e, "dialogue") && t.uint32(16).uint64(e.dialogue), null != e.sequence && Object.hasOwnProperty.call(e, "sequence") && t.uint32(24).uint64(e.sequence), null != e.code && Object.hasOwnProperty.call(e, "code") && t.uint32(32).uint32(e.code), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.Ack(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.instance = e.uint64();
            break;

          case 2:
            n.dialogue = e.uint64();
            break;

          case 3:
            n.sequence = e.uint64();
            break;

          case 4:
            n.code = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.instance && e.hasOwnProperty("instance") && !($util.isInteger(e.instance) || e.instance && $util.isInteger(e.instance.low) && $util.isInteger(e.instance.high)) ? "instance: integer|Long expected" : null != e.dialogue && e.hasOwnProperty("dialogue") && !($util.isInteger(e.dialogue) || e.dialogue && $util.isInteger(e.dialogue.low) && $util.isInteger(e.dialogue.high)) ? "dialogue: integer|Long expected" : null != e.sequence && e.hasOwnProperty("sequence") && !($util.isInteger(e.sequence) || e.sequence && $util.isInteger(e.sequence.low) && $util.isInteger(e.sequence.high)) ? "sequence: integer|Long expected" : null != e.code && e.hasOwnProperty("code") && !$util.isInteger(e.code) ? "code: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.Ack) return e;
      var t = new $root.Ack();
      return null != e.instance && ($util.Long ? (t.instance = $util.Long.fromValue(e.instance)).unsigned = !0 : "string" == typeof e.instance ? t.instance = parseInt(e.instance, 10) : "number" == typeof e.instance ? t.instance = e.instance : "object" === _typeof(e.instance) && (t.instance = new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0))), null != e.dialogue && ($util.Long ? (t.dialogue = $util.Long.fromValue(e.dialogue)).unsigned = !0 : "string" == typeof e.dialogue ? t.dialogue = parseInt(e.dialogue, 10) : "number" == typeof e.dialogue ? t.dialogue = e.dialogue : "object" === _typeof(e.dialogue) && (t.dialogue = new $util.LongBits(e.dialogue.low >>> 0, e.dialogue.high >>> 0).toNumber(!0))), null != e.sequence && ($util.Long ? (t.sequence = $util.Long.fromValue(e.sequence)).unsigned = !0 : "string" == typeof e.sequence ? t.sequence = parseInt(e.sequence, 10) : "number" == typeof e.sequence ? t.sequence = e.sequence : "object" === _typeof(e.sequence) && (t.sequence = new $util.LongBits(e.sequence.low >>> 0, e.sequence.high >>> 0).toNumber(!0))), null != e.code && (t.code = e.code >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.instance = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.instance = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var o = new $util.Long(0, 0, !0);
          r.dialogue = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.dialogue = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var i = new $util.Long(0, 0, !0);
          r.sequence = t.longs === String ? i.toString() : t.longs === Number ? i.toNumber() : i;
        } else r.sequence = t.longs === String ? "0" : 0;

        r.code = 0;
      }

      return null != e.instance && e.hasOwnProperty("instance") && ("number" == typeof e.instance ? r.instance = t.longs === String ? String(e.instance) : e.instance : r.instance = t.longs === String ? $util.Long.prototype.toString.call(e.instance) : t.longs === Number ? new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0) : e.instance), null != e.dialogue && e.hasOwnProperty("dialogue") && ("number" == typeof e.dialogue ? r.dialogue = t.longs === String ? String(e.dialogue) : e.dialogue : r.dialogue = t.longs === String ? $util.Long.prototype.toString.call(e.dialogue) : t.longs === Number ? new $util.LongBits(e.dialogue.low >>> 0, e.dialogue.high >>> 0).toNumber(!0) : e.dialogue), null != e.sequence && e.hasOwnProperty("sequence") && ("number" == typeof e.sequence ? r.sequence = t.longs === String ? String(e.sequence) : e.sequence : r.sequence = t.longs === String ? $util.Long.prototype.toString.call(e.sequence) : t.longs === Number ? new $util.LongBits(e.sequence.low >>> 0, e.sequence.high >>> 0).toNumber(!0) : e.sequence), null != e.code && e.hasOwnProperty("code") && (r.code = e.code), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      FileUploadIndexGet = $root.FileUploadIndexGet = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.hash = $util.newBuffer([]), e.prototype.size = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.hash && Object.hasOwnProperty.call(e, "hash") && t.uint32(18).bytes(e.hash), null != e.size && Object.hasOwnProperty.call(e, "size") && t.uint32(24).uint32(e.size), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.FileUploadIndexGet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.hash = e.bytes();
            break;

          case 3:
            n.size = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.hash && e.hasOwnProperty("hash") && !(e.hash && "number" == typeof e.hash.length || $util.isString(e.hash)) ? "hash: buffer expected" : null != e.size && e.hasOwnProperty("size") && !$util.isInteger(e.size) ? "size: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.FileUploadIndexGet) return e;
      var t = new $root.FileUploadIndexGet();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.hash && ("string" == typeof e.hash ? $util.base64.decode(e.hash, t.hash = $util.newBuffer($util.base64.length(e.hash)), 0) : e.hash.length && (t.hash = e.hash)), null != e.size && (t.size = e.size >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        t.bytes === String ? r.hash = "" : (r.hash = [], t.bytes !== Array && (r.hash = $util.newBuffer(r.hash))), r.size = 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.hash && e.hasOwnProperty("hash") && (r.hash = t.bytes === String ? $util.base64.encode(e.hash, 0, e.hash.length) : t.bytes === Array ? Array.prototype.slice.call(e.hash) : e.hash), null != e.size && e.hasOwnProperty("size") && (r.size = e.size), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      FileUploadIndexRet = $root.FileUploadIndexRet = function () {
    function e(e) {
      if (this.servers = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.unit = 0, e.prototype.servers = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.unit && Object.hasOwnProperty.call(e, "unit") && t.uint32(16).uint32(e.unit), null != e.servers && e.servers.length) {
        t.uint32(26).fork();

        for (var r = 0; r < e.servers.length; ++r) {
          t.uint32(e.servers[r]);
        }

        t.ldelim();
      }

      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.FileUploadIndexRet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.unit = e.uint32();
            break;

          case 3:
            if (n.servers && n.servers.length || (n.servers = []), 2 == (7 & o)) for (var i = e.uint32() + e.pos; e.pos < i;) {
              n.servers.push(e.uint32());
            } else n.servers.push(e.uint32());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.unit && e.hasOwnProperty("unit") && !$util.isInteger(e.unit)) return "unit: integer expected";

      if (null != e.servers && e.hasOwnProperty("servers")) {
        if (!Array.isArray(e.servers)) return "servers: array expected";

        for (var t = 0; t < e.servers.length; ++t) {
          if (!$util.isInteger(e.servers[t])) return "servers: integer[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.FileUploadIndexRet) return e;
      var t = new $root.FileUploadIndexRet();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.unit && (t.unit = e.unit >>> 0), e.servers) {
        if (!Array.isArray(e.servers)) throw TypeError(".FileUploadIndexRet.servers: array expected");
        t.servers = [];

        for (var r = 0; r < e.servers.length; ++r) {
          t.servers[r] = e.servers[r] >>> 0;
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.servers = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.unit = 0;
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.unit && e.hasOwnProperty("unit") && (r.unit = e.unit), e.servers && e.servers.length) {
        r.servers = [];

        for (var o = 0; o < e.servers.length; ++o) {
          r.servers[o] = e.servers[o];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      FileUploadIndexSet = $root.FileUploadIndexSet = function () {
    function e(e) {
      if (this.servers = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.hash = $util.newBuffer([]), e.prototype.unit = 0, e.prototype.servers = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.hash && Object.hasOwnProperty.call(e, "hash") && t.uint32(18).bytes(e.hash), null != e.unit && Object.hasOwnProperty.call(e, "unit") && t.uint32(24).uint32(e.unit), null != e.servers && e.servers.length) {
        t.uint32(34).fork();

        for (var r = 0; r < e.servers.length; ++r) {
          t.uint32(e.servers[r]);
        }

        t.ldelim();
      }

      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.FileUploadIndexSet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.hash = e.bytes();
            break;

          case 3:
            n.unit = e.uint32();
            break;

          case 4:
            if (n.servers && n.servers.length || (n.servers = []), 2 == (7 & o)) for (var i = e.uint32() + e.pos; e.pos < i;) {
              n.servers.push(e.uint32());
            } else n.servers.push(e.uint32());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.hash && e.hasOwnProperty("hash") && !(e.hash && "number" == typeof e.hash.length || $util.isString(e.hash))) return "hash: buffer expected";
      if (null != e.unit && e.hasOwnProperty("unit") && !$util.isInteger(e.unit)) return "unit: integer expected";

      if (null != e.servers && e.hasOwnProperty("servers")) {
        if (!Array.isArray(e.servers)) return "servers: array expected";

        for (var t = 0; t < e.servers.length; ++t) {
          if (!$util.isInteger(e.servers[t])) return "servers: integer[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.FileUploadIndexSet) return e;
      var t = new $root.FileUploadIndexSet();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.hash && ("string" == typeof e.hash ? $util.base64.decode(e.hash, t.hash = $util.newBuffer($util.base64.length(e.hash)), 0) : e.hash.length && (t.hash = e.hash)), null != e.unit && (t.unit = e.unit >>> 0), e.servers) {
        if (!Array.isArray(e.servers)) throw TypeError(".FileUploadIndexSet.servers: array expected");
        t.servers = [];

        for (var r = 0; r < e.servers.length; ++r) {
          t.servers[r] = e.servers[r] >>> 0;
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.servers = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        t.bytes === String ? r.hash = "" : (r.hash = [], t.bytes !== Array && (r.hash = $util.newBuffer(r.hash))), r.unit = 0;
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.hash && e.hasOwnProperty("hash") && (r.hash = t.bytes === String ? $util.base64.encode(e.hash, 0, e.hash.length) : t.bytes === Array ? Array.prototype.slice.call(e.hash) : e.hash), null != e.unit && e.hasOwnProperty("unit") && (r.unit = e.unit), e.servers && e.servers.length) {
        r.servers = [];

        for (var o = 0; o < e.servers.length; ++o) {
          r.servers[o] = e.servers[o];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      FileUploadIndexFin = $root.FileUploadIndexFin = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.zone = 0, e.prototype.unit = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.zone && Object.hasOwnProperty.call(e, "zone") && t.uint32(16).uint32(e.zone), null != e.unit && Object.hasOwnProperty.call(e, "unit") && t.uint32(24).uint32(e.unit), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.FileUploadIndexFin(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.zone = e.uint32();
            break;

          case 3:
            n.unit = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.zone && e.hasOwnProperty("zone") && !$util.isInteger(e.zone) ? "zone: integer expected" : null != e.unit && e.hasOwnProperty("unit") && !$util.isInteger(e.unit) ? "unit: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.FileUploadIndexFin) return e;
      var t = new $root.FileUploadIndexFin();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.zone && (t.zone = e.zone >>> 0), null != e.unit && (t.unit = e.unit >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.zone = 0, r.unit = 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.zone && e.hasOwnProperty("zone") && (r.zone = e.zone), null != e.unit && e.hasOwnProperty("unit") && (r.unit = e.unit), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      FileUploadIndexErr = $root.FileUploadIndexErr = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.code = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.code && Object.hasOwnProperty.call(e, "code") && t.uint32(16).uint32(e.code), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.FileUploadIndexErr(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.code = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.code && e.hasOwnProperty("code") && !$util.isInteger(e.code) ? "code: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.FileUploadIndexErr) return e;
      var t = new $root.FileUploadIndexErr();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.code && (t.code = e.code >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.code = 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.code && e.hasOwnProperty("code") && (r.code = e.code), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      FileDownloadIndexGet = $root.FileDownloadIndexGet = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.zone = 0, e.prototype.hash = $util.newBuffer([]), e.prototype.size = 0, e.prototype.unit = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.zone && Object.hasOwnProperty.call(e, "zone") && t.uint32(16).uint32(e.zone), null != e.hash && Object.hasOwnProperty.call(e, "hash") && t.uint32(26).bytes(e.hash), null != e.size && Object.hasOwnProperty.call(e, "size") && t.uint32(32).uint32(e.size), null != e.unit && Object.hasOwnProperty.call(e, "unit") && t.uint32(40).uint32(e.unit), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.FileDownloadIndexGet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.zone = e.uint32();
            break;

          case 3:
            n.hash = e.bytes();
            break;

          case 4:
            n.size = e.uint32();
            break;

          case 5:
            n.unit = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.zone && e.hasOwnProperty("zone") && !$util.isInteger(e.zone) ? "zone: integer expected" : null != e.hash && e.hasOwnProperty("hash") && !(e.hash && "number" == typeof e.hash.length || $util.isString(e.hash)) ? "hash: buffer expected" : null != e.size && e.hasOwnProperty("size") && !$util.isInteger(e.size) ? "size: integer expected" : null != e.unit && e.hasOwnProperty("unit") && !$util.isInteger(e.unit) ? "unit: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.FileDownloadIndexGet) return e;
      var t = new $root.FileDownloadIndexGet();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.zone && (t.zone = e.zone >>> 0), null != e.hash && ("string" == typeof e.hash ? $util.base64.decode(e.hash, t.hash = $util.newBuffer($util.base64.length(e.hash)), 0) : e.hash.length && (t.hash = e.hash)), null != e.size && (t.size = e.size >>> 0), null != e.unit && (t.unit = e.unit >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.zone = 0, t.bytes === String ? r.hash = "" : (r.hash = [], t.bytes !== Array && (r.hash = $util.newBuffer(r.hash))), r.size = 0, r.unit = 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.zone && e.hasOwnProperty("zone") && (r.zone = e.zone), null != e.hash && e.hasOwnProperty("hash") && (r.hash = t.bytes === String ? $util.base64.encode(e.hash, 0, e.hash.length) : t.bytes === Array ? Array.prototype.slice.call(e.hash) : e.hash), null != e.size && e.hasOwnProperty("size") && (r.size = e.size), null != e.unit && e.hasOwnProperty("unit") && (r.unit = e.unit), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      FileDownloadIndexRet = $root.FileDownloadIndexRet = function () {
    function e(e) {
      if (this.servers = [], this.backups = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.unit = 0, e.prototype.zone = 0, e.prototype.servers = $util.emptyArray, e.prototype.backups = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.unit && Object.hasOwnProperty.call(e, "unit") && t.uint32(16).uint32(e.unit), null != e.zone && Object.hasOwnProperty.call(e, "zone") && t.uint32(24).uint32(e.zone), null != e.servers && e.servers.length) {
        t.uint32(34).fork();

        for (var r = 0; r < e.servers.length; ++r) {
          t.uint32(e.servers[r]);
        }

        t.ldelim();
      }

      if (null != e.backups && e.backups.length) {
        t.uint32(42).fork();

        for (var n = 0; n < e.backups.length; ++n) {
          t.uint32(e.backups[n]);
        }

        t.ldelim();
      }

      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.FileDownloadIndexRet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.unit = e.uint32();
            break;

          case 3:
            n.zone = e.uint32();
            break;

          case 4:
            if (n.servers && n.servers.length || (n.servers = []), 2 == (7 & o)) for (var i = e.uint32() + e.pos; e.pos < i;) {
              n.servers.push(e.uint32());
            } else n.servers.push(e.uint32());
            break;

          case 5:
            if (n.backups && n.backups.length || (n.backups = []), 2 == (7 & o)) for (var s = e.uint32() + e.pos; e.pos < s;) {
              n.backups.push(e.uint32());
            } else n.backups.push(e.uint32());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.unit && e.hasOwnProperty("unit") && !$util.isInteger(e.unit)) return "unit: integer expected";
      if (null != e.zone && e.hasOwnProperty("zone") && !$util.isInteger(e.zone)) return "zone: integer expected";

      if (null != e.servers && e.hasOwnProperty("servers")) {
        if (!Array.isArray(e.servers)) return "servers: array expected";

        for (var t = 0; t < e.servers.length; ++t) {
          if (!$util.isInteger(e.servers[t])) return "servers: integer[] expected";
        }
      }

      if (null != e.backups && e.hasOwnProperty("backups")) {
        if (!Array.isArray(e.backups)) return "backups: array expected";

        for (var r = 0; r < e.backups.length; ++r) {
          if (!$util.isInteger(e.backups[r])) return "backups: integer[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.FileDownloadIndexRet) return e;
      var t = new $root.FileDownloadIndexRet();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.unit && (t.unit = e.unit >>> 0), null != e.zone && (t.zone = e.zone >>> 0), e.servers) {
        if (!Array.isArray(e.servers)) throw TypeError(".FileDownloadIndexRet.servers: array expected");
        t.servers = [];

        for (var r = 0; r < e.servers.length; ++r) {
          t.servers[r] = e.servers[r] >>> 0;
        }
      }

      if (e.backups) {
        if (!Array.isArray(e.backups)) throw TypeError(".FileDownloadIndexRet.backups: array expected");
        t.backups = [];

        for (var n = 0; n < e.backups.length; ++n) {
          t.backups[n] = e.backups[n] >>> 0;
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.servers = [], r.backups = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.unit = 0, r.zone = 0;
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.unit && e.hasOwnProperty("unit") && (r.unit = e.unit), null != e.zone && e.hasOwnProperty("zone") && (r.zone = e.zone), e.servers && e.servers.length) {
        r.servers = [];

        for (var o = 0; o < e.servers.length; ++o) {
          r.servers[o] = e.servers[o];
        }
      }

      if (e.backups && e.backups.length) {
        r.backups = [];

        for (var i = 0; i < e.backups.length; ++i) {
          r.backups[i] = e.backups[i];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      FileDownloadIndexErr = $root.FileDownloadIndexErr = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.code = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.code && Object.hasOwnProperty.call(e, "code") && t.uint32(16).uint32(e.code), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.FileDownloadIndexErr(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.code = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.code && e.hasOwnProperty("code") && !$util.isInteger(e.code) ? "code: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.FileDownloadIndexErr) return e;
      var t = new $root.FileDownloadIndexErr();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.code && (t.code = e.code >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.code = 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.code && e.hasOwnProperty("code") && (r.code = e.code), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupAllUsersList = $root.GroupAllUsersList = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.group = "", e.prototype.pageSize = 0, e.prototype.pageNumber = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.group && Object.hasOwnProperty.call(e, "group") && t.uint32(18).string(e.group), null != e.pageSize && Object.hasOwnProperty.call(e, "pageSize") && t.uint32(24).uint32(e.pageSize), null != e.pageNumber && Object.hasOwnProperty.call(e, "pageNumber") && t.uint32(32).uint32(e.pageNumber), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAllUsersList(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.group = e.string();
            break;

          case 3:
            n.pageSize = e.uint32();
            break;

          case 4:
            n.pageNumber = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.group && e.hasOwnProperty("group") && !$util.isString(e.group) ? "group: string expected" : null != e.pageSize && e.hasOwnProperty("pageSize") && !$util.isInteger(e.pageSize) ? "pageSize: integer expected" : null != e.pageNumber && e.hasOwnProperty("pageNumber") && !$util.isInteger(e.pageNumber) ? "pageNumber: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupAllUsersList) return e;
      var t = new $root.GroupAllUsersList();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.group && (t.group = String(e.group)), null != e.pageSize && (t.pageSize = e.pageSize >>> 0), null != e.pageNumber && (t.pageNumber = e.pageNumber >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.group = "", r.pageSize = 0, r.pageNumber = 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.group && e.hasOwnProperty("group") && (r.group = e.group), null != e.pageSize && e.hasOwnProperty("pageSize") && (r.pageSize = e.pageSize), null != e.pageNumber && e.hasOwnProperty("pageNumber") && (r.pageNumber = e.pageNumber), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupAllUsersResult = $root.GroupAllUsersResult = function () {
    function e(e) {
      if (this.memberInfos = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.group = "", e.prototype.totalSize = 0, e.prototype.pageSize = 0, e.prototype.pageNumber = 0, e.prototype.memberInfos = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.group && Object.hasOwnProperty.call(e, "group") && t.uint32(18).string(e.group), null != e.totalSize && Object.hasOwnProperty.call(e, "totalSize") && t.uint32(24).uint32(e.totalSize), null != e.pageSize && Object.hasOwnProperty.call(e, "pageSize") && t.uint32(32).uint32(e.pageSize), null != e.pageNumber && Object.hasOwnProperty.call(e, "pageNumber") && t.uint32(40).uint32(e.pageNumber), null != e.memberInfos && e.memberInfos.length) for (var r = 0; r < e.memberInfos.length; ++r) {
        $root.GroupAllUsersResult.MemberInfo.encode(e.memberInfos[r], t.uint32(50).fork()).ldelim();
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAllUsersResult(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.group = e.string();
            break;

          case 3:
            n.totalSize = e.uint32();
            break;

          case 4:
            n.pageSize = e.uint32();
            break;

          case 5:
            n.pageNumber = e.uint32();
            break;

          case 6:
            n.memberInfos && n.memberInfos.length || (n.memberInfos = []), n.memberInfos.push($root.GroupAllUsersResult.MemberInfo.decode(e, e.uint32()));
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.group && e.hasOwnProperty("group") && !$util.isString(e.group)) return "group: string expected";
      if (null != e.totalSize && e.hasOwnProperty("totalSize") && !$util.isInteger(e.totalSize)) return "totalSize: integer expected";
      if (null != e.pageSize && e.hasOwnProperty("pageSize") && !$util.isInteger(e.pageSize)) return "pageSize: integer expected";
      if (null != e.pageNumber && e.hasOwnProperty("pageNumber") && !$util.isInteger(e.pageNumber)) return "pageNumber: integer expected";

      if (null != e.memberInfos && e.hasOwnProperty("memberInfos")) {
        if (!Array.isArray(e.memberInfos)) return "memberInfos: array expected";

        for (var t = 0; t < e.memberInfos.length; ++t) {
          var r = $root.GroupAllUsersResult.MemberInfo.verify(e.memberInfos[t]);
          if (r) return "memberInfos." + r;
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupAllUsersResult) return e;
      var t = new $root.GroupAllUsersResult();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.group && (t.group = String(e.group)), null != e.totalSize && (t.totalSize = e.totalSize >>> 0), null != e.pageSize && (t.pageSize = e.pageSize >>> 0), null != e.pageNumber && (t.pageNumber = e.pageNumber >>> 0), e.memberInfos) {
        if (!Array.isArray(e.memberInfos)) throw TypeError(".GroupAllUsersResult.memberInfos: array expected");
        t.memberInfos = [];

        for (var r = 0; r < e.memberInfos.length; ++r) {
          if ("object" !== _typeof(e.memberInfos[r])) throw TypeError(".GroupAllUsersResult.memberInfos: object expected");
          t.memberInfos[r] = $root.GroupAllUsersResult.MemberInfo.fromObject(e.memberInfos[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.memberInfos = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.group = "", r.totalSize = 0, r.pageSize = 0, r.pageNumber = 0;
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.group && e.hasOwnProperty("group") && (r.group = e.group), null != e.totalSize && e.hasOwnProperty("totalSize") && (r.totalSize = e.totalSize), null != e.pageSize && e.hasOwnProperty("pageSize") && (r.pageSize = e.pageSize), null != e.pageNumber && e.hasOwnProperty("pageNumber") && (r.pageNumber = e.pageNumber), e.memberInfos && e.memberInfos.length) {
        r.memberInfos = [];

        for (var o = 0; o < e.memberInfos.length; ++o) {
          r.memberInfos[o] = $root.GroupAllUsersResult.MemberInfo.toObject(e.memberInfos[o], t);
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.MemberInfo = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.account = "", e.prototype.ts = 0, e.encode = function (e, t) {
        return t || (t = $Writer.create()), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(10).string(e.account), null != e.ts && Object.hasOwnProperty.call(e, "ts") && t.uint32(16).uint32(e.ts), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAllUsersResult.MemberInfo(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.account = e.string();
              break;

            case 2:
              n.ts = e.uint32();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account) ? "account: string expected" : null != e.ts && e.hasOwnProperty("ts") && !$util.isInteger(e.ts) ? "ts: integer expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root.GroupAllUsersResult.MemberInfo) return e;
        var t = new $root.GroupAllUsersResult.MemberInfo();
        return null != e.account && (t.account = String(e.account)), null != e.ts && (t.ts = e.ts >>> 0), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};
        return t.defaults && (r.account = "", r.ts = 0), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), null != e.ts && e.hasOwnProperty("ts") && (r.ts = e.ts), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      UserStatusList = $root.UserStatusList = function () {
    function e(e) {
      if (this.users = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.users = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.users && e.users.length) for (var r = 0; r < e.users.length; ++r) {
        t.uint32(18).string(e.users[r]);
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserStatusList(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.users && n.users.length || (n.users = []), n.users.push(e.string());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";

      if (null != e.users && e.hasOwnProperty("users")) {
        if (!Array.isArray(e.users)) return "users: array expected";

        for (var t = 0; t < e.users.length; ++t) {
          if (!$util.isString(e.users[t])) return "users: string[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserStatusList) return e;
      var t = new $root.UserStatusList();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), e.users) {
        if (!Array.isArray(e.users)) throw TypeError(".UserStatusList.users: array expected");
        t.users = [];

        for (var r = 0; r < e.users.length; ++r) {
          t.users[r] = String(e.users[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if ((t.arrays || t.defaults) && (r.users = []), t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), e.users && e.users.length) {
        r.users = [];

        for (var o = 0; o < e.users.length; ++o) {
          r.users[o] = e.users[o];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserStatusResult = $root.UserStatusResult = function () {
    function e(e) {
      if (this.userInfos = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.userInfos = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.userInfos && e.userInfos.length) for (var r = 0; r < e.userInfos.length; ++r) {
        $root.UserStatusResult.UserStatusInfo.encode(e.userInfos[r], t.uint32(18).fork()).ldelim();
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserStatusResult(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.userInfos && n.userInfos.length || (n.userInfos = []), n.userInfos.push($root.UserStatusResult.UserStatusInfo.decode(e, e.uint32()));
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";

      if (null != e.userInfos && e.hasOwnProperty("userInfos")) {
        if (!Array.isArray(e.userInfos)) return "userInfos: array expected";

        for (var t = 0; t < e.userInfos.length; ++t) {
          var r = $root.UserStatusResult.UserStatusInfo.verify(e.userInfos[t]);
          if (r) return "userInfos." + r;
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserStatusResult) return e;
      var t = new $root.UserStatusResult();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), e.userInfos) {
        if (!Array.isArray(e.userInfos)) throw TypeError(".UserStatusResult.userInfos: array expected");
        t.userInfos = [];

        for (var r = 0; r < e.userInfos.length; ++r) {
          if ("object" !== _typeof(e.userInfos[r])) throw TypeError(".UserStatusResult.userInfos: object expected");
          t.userInfos[r] = $root.UserStatusResult.UserStatusInfo.fromObject(e.userInfos[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if ((t.arrays || t.defaults) && (r.userInfos = []), t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), e.userInfos && e.userInfos.length) {
        r.userInfos = [];

        for (var o = 0; o < e.userInfos.length; ++o) {
          r.userInfos[o] = $root.UserStatusResult.UserStatusInfo.toObject(e.userInfos[o], t);
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.UserStatusInfo = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.account = "", e.prototype.ts = 0, e.encode = function (e, t) {
        return t || (t = $Writer.create()), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(10).string(e.account), null != e.ts && Object.hasOwnProperty.call(e, "ts") && t.uint32(16).uint32(e.ts), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserStatusResult.UserStatusInfo(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.account = e.string();
              break;

            case 2:
              n.ts = e.uint32();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account) ? "account: string expected" : null != e.ts && e.hasOwnProperty("ts") && !$util.isInteger(e.ts) ? "ts: integer expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root.UserStatusResult.UserStatusInfo) return e;
        var t = new $root.UserStatusResult.UserStatusInfo();
        return null != e.account && (t.account = String(e.account)), null != e.ts && (t.ts = e.ts >>> 0), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};
        return t.defaults && (r.account = "", r.ts = 0), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), null != e.ts && e.hasOwnProperty("ts") && (r.ts = e.ts), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      UserAttributeGet = $root.UserAttributeGet = function () {
    function e(e) {
      if (this.attributes = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.account = "", e.prototype.attributes = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(18).string(e.account), null != e.attributes && e.attributes.length) for (var r = 0; r < e.attributes.length; ++r) {
        t.uint32(26).string(e.attributes[r]);
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserAttributeGet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.account = e.string();
            break;

          case 3:
            n.attributes && n.attributes.length || (n.attributes = []), n.attributes.push(e.string());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account)) return "account: string expected";

      if (null != e.attributes && e.hasOwnProperty("attributes")) {
        if (!Array.isArray(e.attributes)) return "attributes: array expected";

        for (var t = 0; t < e.attributes.length; ++t) {
          if (!$util.isString(e.attributes[t])) return "attributes: string[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserAttributeGet) return e;
      var t = new $root.UserAttributeGet();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.account && (t.account = String(e.account)), e.attributes) {
        if (!Array.isArray(e.attributes)) throw TypeError(".UserAttributeGet.attributes: array expected");
        t.attributes = [];

        for (var r = 0; r < e.attributes.length; ++r) {
          t.attributes[r] = String(e.attributes[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.attributes = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.account = "";
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), e.attributes && e.attributes.length) {
        r.attributes = [];

        for (var o = 0; o < e.attributes.length; ++o) {
          r.attributes[o] = e.attributes[o];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserAttributeRet = $root.UserAttributeRet = function () {
    function e(e) {
      if (this.attributeInfos = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.attributeInfos = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.attributeInfos && e.attributeInfos.length) for (var r = 0; r < e.attributeInfos.length; ++r) {
        $root.UserAttributeRet.AttributeInfo.encode(e.attributeInfos[r], t.uint32(18).fork()).ldelim();
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserAttributeRet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.attributeInfos && n.attributeInfos.length || (n.attributeInfos = []), n.attributeInfos.push($root.UserAttributeRet.AttributeInfo.decode(e, e.uint32()));
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";

      if (null != e.attributeInfos && e.hasOwnProperty("attributeInfos")) {
        if (!Array.isArray(e.attributeInfos)) return "attributeInfos: array expected";

        for (var t = 0; t < e.attributeInfos.length; ++t) {
          var r = $root.UserAttributeRet.AttributeInfo.verify(e.attributeInfos[t]);
          if (r) return "attributeInfos." + r;
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserAttributeRet) return e;
      var t = new $root.UserAttributeRet();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), e.attributeInfos) {
        if (!Array.isArray(e.attributeInfos)) throw TypeError(".UserAttributeRet.attributeInfos: array expected");
        t.attributeInfos = [];

        for (var r = 0; r < e.attributeInfos.length; ++r) {
          if ("object" !== _typeof(e.attributeInfos[r])) throw TypeError(".UserAttributeRet.attributeInfos: object expected");
          t.attributeInfos[r] = $root.UserAttributeRet.AttributeInfo.fromObject(e.attributeInfos[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if ((t.arrays || t.defaults) && (r.attributeInfos = []), t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), e.attributeInfos && e.attributeInfos.length) {
        r.attributeInfos = [];

        for (var o = 0; o < e.attributeInfos.length; ++o) {
          r.attributeInfos[o] = $root.UserAttributeRet.AttributeInfo.toObject(e.attributeInfos[o], t);
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.AttributeInfo = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.key = "", e.prototype.value = "", e.encode = function (e, t) {
        return t || (t = $Writer.create()), null != e.key && Object.hasOwnProperty.call(e, "key") && t.uint32(10).string(e.key), null != e.value && Object.hasOwnProperty.call(e, "value") && t.uint32(18).string(e.value), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserAttributeRet.AttributeInfo(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.key = e.string();
              break;

            case 2:
              n.value = e.string();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.key && e.hasOwnProperty("key") && !$util.isString(e.key) ? "key: string expected" : null != e.value && e.hasOwnProperty("value") && !$util.isString(e.value) ? "value: string expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root.UserAttributeRet.AttributeInfo) return e;
        var t = new $root.UserAttributeRet.AttributeInfo();
        return null != e.key && (t.key = String(e.key)), null != e.value && (t.value = String(e.value)), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};
        return t.defaults && (r.key = "", r.value = ""), null != e.key && e.hasOwnProperty("key") && (r.key = e.key), null != e.value && e.hasOwnProperty("value") && (r.value = e.value), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      UserAttributeSet = $root.UserAttributeSet = function () {
    function e(e) {
      if (this.attributeInfos = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.account = "", e.prototype.attributeInfos = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(18).string(e.account), null != e.attributeInfos && e.attributeInfos.length) for (var r = 0; r < e.attributeInfos.length; ++r) {
        $root.UserAttributeSet.AttributeInfo.encode(e.attributeInfos[r], t.uint32(26).fork()).ldelim();
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserAttributeSet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.account = e.string();
            break;

          case 3:
            n.attributeInfos && n.attributeInfos.length || (n.attributeInfos = []), n.attributeInfos.push($root.UserAttributeSet.AttributeInfo.decode(e, e.uint32()));
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account)) return "account: string expected";

      if (null != e.attributeInfos && e.hasOwnProperty("attributeInfos")) {
        if (!Array.isArray(e.attributeInfos)) return "attributeInfos: array expected";

        for (var t = 0; t < e.attributeInfos.length; ++t) {
          var r = $root.UserAttributeSet.AttributeInfo.verify(e.attributeInfos[t]);
          if (r) return "attributeInfos." + r;
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserAttributeSet) return e;
      var t = new $root.UserAttributeSet();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.account && (t.account = String(e.account)), e.attributeInfos) {
        if (!Array.isArray(e.attributeInfos)) throw TypeError(".UserAttributeSet.attributeInfos: array expected");
        t.attributeInfos = [];

        for (var r = 0; r < e.attributeInfos.length; ++r) {
          if ("object" !== _typeof(e.attributeInfos[r])) throw TypeError(".UserAttributeSet.attributeInfos: object expected");
          t.attributeInfos[r] = $root.UserAttributeSet.AttributeInfo.fromObject(e.attributeInfos[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.attributeInfos = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.account = "";
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), e.attributeInfos && e.attributeInfos.length) {
        r.attributeInfos = [];

        for (var o = 0; o < e.attributeInfos.length; ++o) {
          r.attributeInfos[o] = $root.UserAttributeSet.AttributeInfo.toObject(e.attributeInfos[o], t);
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.AttributeInfo = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.key = "", e.prototype.value = "", e.encode = function (e, t) {
        return t || (t = $Writer.create()), null != e.key && Object.hasOwnProperty.call(e, "key") && t.uint32(10).string(e.key), null != e.value && Object.hasOwnProperty.call(e, "value") && t.uint32(18).string(e.value), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserAttributeSet.AttributeInfo(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.key = e.string();
              break;

            case 2:
              n.value = e.string();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.key && e.hasOwnProperty("key") && !$util.isString(e.key) ? "key: string expected" : null != e.value && e.hasOwnProperty("value") && !$util.isString(e.value) ? "value: string expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root.UserAttributeSet.AttributeInfo) return e;
        var t = new $root.UserAttributeSet.AttributeInfo();
        return null != e.key && (t.key = String(e.key)), null != e.value && (t.value = String(e.value)), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};
        return t.defaults && (r.key = "", r.value = ""), null != e.key && e.hasOwnProperty("key") && (r.key = e.key), null != e.value && e.hasOwnProperty("value") && (r.value = e.value), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      UserAttributeMod = $root.UserAttributeMod = function () {
    function e(e) {
      if (this.attributeInfos = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.account = "", e.prototype.attributeInfos = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(18).string(e.account), null != e.attributeInfos && e.attributeInfos.length) for (var r = 0; r < e.attributeInfos.length; ++r) {
        $root.UserAttributeMod.AttributeInfo.encode(e.attributeInfos[r], t.uint32(26).fork()).ldelim();
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserAttributeMod(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.account = e.string();
            break;

          case 3:
            n.attributeInfos && n.attributeInfos.length || (n.attributeInfos = []), n.attributeInfos.push($root.UserAttributeMod.AttributeInfo.decode(e, e.uint32()));
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account)) return "account: string expected";

      if (null != e.attributeInfos && e.hasOwnProperty("attributeInfos")) {
        if (!Array.isArray(e.attributeInfos)) return "attributeInfos: array expected";

        for (var t = 0; t < e.attributeInfos.length; ++t) {
          var r = $root.UserAttributeMod.AttributeInfo.verify(e.attributeInfos[t]);
          if (r) return "attributeInfos." + r;
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserAttributeMod) return e;
      var t = new $root.UserAttributeMod();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.account && (t.account = String(e.account)), e.attributeInfos) {
        if (!Array.isArray(e.attributeInfos)) throw TypeError(".UserAttributeMod.attributeInfos: array expected");
        t.attributeInfos = [];

        for (var r = 0; r < e.attributeInfos.length; ++r) {
          if ("object" !== _typeof(e.attributeInfos[r])) throw TypeError(".UserAttributeMod.attributeInfos: object expected");
          t.attributeInfos[r] = $root.UserAttributeMod.AttributeInfo.fromObject(e.attributeInfos[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.attributeInfos = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.account = "";
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), e.attributeInfos && e.attributeInfos.length) {
        r.attributeInfos = [];

        for (var o = 0; o < e.attributeInfos.length; ++o) {
          r.attributeInfos[o] = $root.UserAttributeMod.AttributeInfo.toObject(e.attributeInfos[o], t);
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.AttributeInfo = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.key = "", e.prototype.value = "", e.encode = function (e, t) {
        return t || (t = $Writer.create()), null != e.key && Object.hasOwnProperty.call(e, "key") && t.uint32(10).string(e.key), null != e.value && Object.hasOwnProperty.call(e, "value") && t.uint32(18).string(e.value), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserAttributeMod.AttributeInfo(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.key = e.string();
              break;

            case 2:
              n.value = e.string();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.key && e.hasOwnProperty("key") && !$util.isString(e.key) ? "key: string expected" : null != e.value && e.hasOwnProperty("value") && !$util.isString(e.value) ? "value: string expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root.UserAttributeMod.AttributeInfo) return e;
        var t = new $root.UserAttributeMod.AttributeInfo();
        return null != e.key && (t.key = String(e.key)), null != e.value && (t.value = String(e.value)), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};
        return t.defaults && (r.key = "", r.value = ""), null != e.key && e.hasOwnProperty("key") && (r.key = e.key), null != e.value && e.hasOwnProperty("value") && (r.value = e.value), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      UserAttributeDel = $root.UserAttributeDel = function () {
    function e(e) {
      if (this.attributes = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.account = "", e.prototype.attributes = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(18).string(e.account), null != e.attributes && e.attributes.length) for (var r = 0; r < e.attributes.length; ++r) {
        t.uint32(26).string(e.attributes[r]);
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserAttributeDel(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.account = e.string();
            break;

          case 3:
            n.attributes && n.attributes.length || (n.attributes = []), n.attributes.push(e.string());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account)) return "account: string expected";

      if (null != e.attributes && e.hasOwnProperty("attributes")) {
        if (!Array.isArray(e.attributes)) return "attributes: array expected";

        for (var t = 0; t < e.attributes.length; ++t) {
          if (!$util.isString(e.attributes[t])) return "attributes: string[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserAttributeDel) return e;
      var t = new $root.UserAttributeDel();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.account && (t.account = String(e.account)), e.attributes) {
        if (!Array.isArray(e.attributes)) throw TypeError(".UserAttributeDel.attributes: array expected");
        t.attributes = [];

        for (var r = 0; r < e.attributes.length; ++r) {
          t.attributes[r] = String(e.attributes[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.attributes = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.account = "";
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), e.attributes && e.attributes.length) {
        r.attributes = [];

        for (var o = 0; o < e.attributes.length; ++o) {
          r.attributes[o] = e.attributes[o];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserAttributeErr = $root.UserAttributeErr = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.code = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.code && Object.hasOwnProperty.call(e, "code") && t.uint32(16).uint32(e.code), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserAttributeErr(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.code = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.code && e.hasOwnProperty("code") && !$util.isInteger(e.code) ? "code: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserAttributeErr) return e;
      var t = new $root.UserAttributeErr();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.code && (t.code = e.code >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.code = 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.code && e.hasOwnProperty("code") && (r.code = e.code), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserAttributeKeysGet = $root.UserAttributeKeysGet = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.account = "", e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(18).string(e.account), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserAttributeKeysGet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.account = e.string();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account) ? "account: string expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserAttributeKeysGet) return e;
      var t = new $root.UserAttributeKeysGet();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.account && (t.account = String(e.account)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.account = "";
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserAttributeKeysRet = $root.UserAttributeKeysRet = function () {
    function e(e) {
      if (this.keys = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.keys = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.keys && e.keys.length) for (var r = 0; r < e.keys.length; ++r) {
        t.uint32(18).string(e.keys[r]);
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserAttributeKeysRet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.keys && n.keys.length || (n.keys = []), n.keys.push(e.string());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";

      if (null != e.keys && e.hasOwnProperty("keys")) {
        if (!Array.isArray(e.keys)) return "keys: array expected";

        for (var t = 0; t < e.keys.length; ++t) {
          if (!$util.isString(e.keys[t])) return "keys: string[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserAttributeKeysRet) return e;
      var t = new $root.UserAttributeKeysRet();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), e.keys) {
        if (!Array.isArray(e.keys)) throw TypeError(".UserAttributeKeysRet.keys: array expected");
        t.keys = [];

        for (var r = 0; r < e.keys.length; ++r) {
          t.keys[r] = String(e.keys[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if ((t.arrays || t.defaults) && (r.keys = []), t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), e.keys && e.keys.length) {
        r.keys = [];

        for (var o = 0; o < e.keys.length; ++o) {
          r.keys[o] = e.keys[o];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserAttributeRsp = $root.UserAttributeRsp = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserAttributeRsp(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserAttributeRsp) return e;
      var t = new $root.UserAttributeRsp();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if (t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;
      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupStatusList = $root.GroupStatusList = function () {
    function e(e) {
      if (this.groups = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.groups = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.groups && e.groups.length) for (var r = 0; r < e.groups.length; ++r) {
        t.uint32(18).string(e.groups[r]);
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupStatusList(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.groups && n.groups.length || (n.groups = []), n.groups.push(e.string());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";

      if (null != e.groups && e.hasOwnProperty("groups")) {
        if (!Array.isArray(e.groups)) return "groups: array expected";

        for (var t = 0; t < e.groups.length; ++t) {
          if (!$util.isString(e.groups[t])) return "groups: string[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupStatusList) return e;
      var t = new $root.GroupStatusList();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), e.groups) {
        if (!Array.isArray(e.groups)) throw TypeError(".GroupStatusList.groups: array expected");
        t.groups = [];

        for (var r = 0; r < e.groups.length; ++r) {
          t.groups[r] = String(e.groups[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if ((t.arrays || t.defaults) && (r.groups = []), t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), e.groups && e.groups.length) {
        r.groups = [];

        for (var o = 0; o < e.groups.length; ++o) {
          r.groups[o] = e.groups[o];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupStatusResult = $root.GroupStatusResult = function () {
    function e(e) {
      if (this.groupInfos = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.groupInfos = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.groupInfos && e.groupInfos.length) for (var r = 0; r < e.groupInfos.length; ++r) {
        $root.GroupStatusResult.GroupInfo.encode(e.groupInfos[r], t.uint32(18).fork()).ldelim();
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupStatusResult(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.groupInfos && n.groupInfos.length || (n.groupInfos = []), n.groupInfos.push($root.GroupStatusResult.GroupInfo.decode(e, e.uint32()));
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";

      if (null != e.groupInfos && e.hasOwnProperty("groupInfos")) {
        if (!Array.isArray(e.groupInfos)) return "groupInfos: array expected";

        for (var t = 0; t < e.groupInfos.length; ++t) {
          var r = $root.GroupStatusResult.GroupInfo.verify(e.groupInfos[t]);
          if (r) return "groupInfos." + r;
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupStatusResult) return e;
      var t = new $root.GroupStatusResult();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), e.groupInfos) {
        if (!Array.isArray(e.groupInfos)) throw TypeError(".GroupStatusResult.groupInfos: array expected");
        t.groupInfos = [];

        for (var r = 0; r < e.groupInfos.length; ++r) {
          if ("object" !== _typeof(e.groupInfos[r])) throw TypeError(".GroupStatusResult.groupInfos: object expected");
          t.groupInfos[r] = $root.GroupStatusResult.GroupInfo.fromObject(e.groupInfos[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if ((t.arrays || t.defaults) && (r.groupInfos = []), t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), e.groupInfos && e.groupInfos.length) {
        r.groupInfos = [];

        for (var o = 0; o < e.groupInfos.length; ++o) {
          r.groupInfos[o] = $root.GroupStatusResult.GroupInfo.toObject(e.groupInfos[o], t);
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.GroupInfo = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.group = "", e.prototype.memberCount = 0, e.encode = function (e, t) {
        return t || (t = $Writer.create()), null != e.group && Object.hasOwnProperty.call(e, "group") && t.uint32(10).string(e.group), null != e.memberCount && Object.hasOwnProperty.call(e, "memberCount") && t.uint32(16).uint32(e.memberCount), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupStatusResult.GroupInfo(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.group = e.string();
              break;

            case 2:
              n.memberCount = e.uint32();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.group && e.hasOwnProperty("group") && !$util.isString(e.group) ? "group: string expected" : null != e.memberCount && e.hasOwnProperty("memberCount") && !$util.isInteger(e.memberCount) ? "memberCount: integer expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root.GroupStatusResult.GroupInfo) return e;
        var t = new $root.GroupStatusResult.GroupInfo();
        return null != e.group && (t.group = String(e.group)), null != e.memberCount && (t.memberCount = e.memberCount >>> 0), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};
        return t.defaults && (r.group = "", r.memberCount = 0), null != e.group && e.hasOwnProperty("group") && (r.group = e.group), null != e.memberCount && e.hasOwnProperty("memberCount") && (r.memberCount = e.memberCount), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      GroupCountNotice = $root.GroupCountNotice = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.instance = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.group = "", e.prototype.size = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.instance && Object.hasOwnProperty.call(e, "instance") && t.uint32(8).uint64(e.instance), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(16).uint64(e.seq), null != e.group && Object.hasOwnProperty.call(e, "group") && t.uint32(26).string(e.group), null != e.size && Object.hasOwnProperty.call(e, "size") && t.uint32(32).uint32(e.size), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupCountNotice(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.instance = e.uint64();
            break;

          case 2:
            n.seq = e.uint64();
            break;

          case 3:
            n.group = e.string();
            break;

          case 4:
            n.size = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.instance && e.hasOwnProperty("instance") && !($util.isInteger(e.instance) || e.instance && $util.isInteger(e.instance.low) && $util.isInteger(e.instance.high)) ? "instance: integer|Long expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.group && e.hasOwnProperty("group") && !$util.isString(e.group) ? "group: string expected" : null != e.size && e.hasOwnProperty("size") && !$util.isInteger(e.size) ? "size: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupCountNotice) return e;
      var t = new $root.GroupCountNotice();
      return null != e.instance && ($util.Long ? (t.instance = $util.Long.fromValue(e.instance)).unsigned = !0 : "string" == typeof e.instance ? t.instance = parseInt(e.instance, 10) : "number" == typeof e.instance ? t.instance = e.instance : "object" === _typeof(e.instance) && (t.instance = new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0))), null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.group && (t.group = String(e.group)), null != e.size && (t.size = e.size >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.instance = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.instance = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var o = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.seq = t.longs === String ? "0" : 0;

        r.group = "", r.size = 0;
      }

      return null != e.instance && e.hasOwnProperty("instance") && ("number" == typeof e.instance ? r.instance = t.longs === String ? String(e.instance) : e.instance : r.instance = t.longs === String ? $util.Long.prototype.toString.call(e.instance) : t.longs === Number ? new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0) : e.instance), null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.group && e.hasOwnProperty("group") && (r.group = e.group), null != e.size && e.hasOwnProperty("size") && (r.size = e.size), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupAttributeGet = $root.GroupAttributeGet = function () {
    function e(e) {
      if (this.attributes = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.group = "", e.prototype.attributes = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.group && Object.hasOwnProperty.call(e, "group") && t.uint32(18).string(e.group), null != e.attributes && e.attributes.length) for (var r = 0; r < e.attributes.length; ++r) {
        t.uint32(26).string(e.attributes[r]);
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeGet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.group = e.string();
            break;

          case 3:
            n.attributes && n.attributes.length || (n.attributes = []), n.attributes.push(e.string());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.group && e.hasOwnProperty("group") && !$util.isString(e.group)) return "group: string expected";

      if (null != e.attributes && e.hasOwnProperty("attributes")) {
        if (!Array.isArray(e.attributes)) return "attributes: array expected";

        for (var t = 0; t < e.attributes.length; ++t) {
          if (!$util.isString(e.attributes[t])) return "attributes: string[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupAttributeGet) return e;
      var t = new $root.GroupAttributeGet();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.group && (t.group = String(e.group)), e.attributes) {
        if (!Array.isArray(e.attributes)) throw TypeError(".GroupAttributeGet.attributes: array expected");
        t.attributes = [];

        for (var r = 0; r < e.attributes.length; ++r) {
          t.attributes[r] = String(e.attributes[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.attributes = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.group = "";
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.group && e.hasOwnProperty("group") && (r.group = e.group), e.attributes && e.attributes.length) {
        r.attributes = [];

        for (var o = 0; o < e.attributes.length; ++o) {
          r.attributes[o] = e.attributes[o];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupAttributeRet = $root.GroupAttributeRet = function () {
    function e(e) {
      if (this.attributeMaps = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.attributeMaps = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.attributeMaps && e.attributeMaps.length) for (var r = 0; r < e.attributeMaps.length; ++r) {
        $root.GroupAttributeRet.AttributeMap.encode(e.attributeMaps[r], t.uint32(18).fork()).ldelim();
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeRet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.attributeMaps && n.attributeMaps.length || (n.attributeMaps = []), n.attributeMaps.push($root.GroupAttributeRet.AttributeMap.decode(e, e.uint32()));
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";

      if (null != e.attributeMaps && e.hasOwnProperty("attributeMaps")) {
        if (!Array.isArray(e.attributeMaps)) return "attributeMaps: array expected";

        for (var t = 0; t < e.attributeMaps.length; ++t) {
          var r = $root.GroupAttributeRet.AttributeMap.verify(e.attributeMaps[t]);
          if (r) return "attributeMaps." + r;
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupAttributeRet) return e;
      var t = new $root.GroupAttributeRet();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), e.attributeMaps) {
        if (!Array.isArray(e.attributeMaps)) throw TypeError(".GroupAttributeRet.attributeMaps: array expected");
        t.attributeMaps = [];

        for (var r = 0; r < e.attributeMaps.length; ++r) {
          if ("object" !== _typeof(e.attributeMaps[r])) throw TypeError(".GroupAttributeRet.attributeMaps: object expected");
          t.attributeMaps[r] = $root.GroupAttributeRet.AttributeMap.fromObject(e.attributeMaps[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if ((t.arrays || t.defaults) && (r.attributeMaps = []), t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), e.attributeMaps && e.attributeMaps.length) {
        r.attributeMaps = [];

        for (var o = 0; o < e.attributeMaps.length; ++o) {
          r.attributeMaps[o] = $root.GroupAttributeRet.AttributeMap.toObject(e.attributeMaps[o], t);
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.AttributeMap = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.key = "", e.prototype.value = "", e.prototype.origin = "", e.prototype.ms = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.encode = function (e, t) {
        return t || (t = $Writer.create()), null != e.key && Object.hasOwnProperty.call(e, "key") && t.uint32(10).string(e.key), null != e.value && Object.hasOwnProperty.call(e, "value") && t.uint32(18).string(e.value), null != e.origin && Object.hasOwnProperty.call(e, "origin") && t.uint32(26).string(e.origin), null != e.ms && Object.hasOwnProperty.call(e, "ms") && t.uint32(32).uint64(e.ms), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeRet.AttributeMap(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.key = e.string();
              break;

            case 2:
              n.value = e.string();
              break;

            case 3:
              n.origin = e.string();
              break;

            case 4:
              n.ms = e.uint64();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.key && e.hasOwnProperty("key") && !$util.isString(e.key) ? "key: string expected" : null != e.value && e.hasOwnProperty("value") && !$util.isString(e.value) ? "value: string expected" : null != e.origin && e.hasOwnProperty("origin") && !$util.isString(e.origin) ? "origin: string expected" : null != e.ms && e.hasOwnProperty("ms") && !($util.isInteger(e.ms) || e.ms && $util.isInteger(e.ms.low) && $util.isInteger(e.ms.high)) ? "ms: integer|Long expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root.GroupAttributeRet.AttributeMap) return e;
        var t = new $root.GroupAttributeRet.AttributeMap();
        return null != e.key && (t.key = String(e.key)), null != e.value && (t.value = String(e.value)), null != e.origin && (t.origin = String(e.origin)), null != e.ms && ($util.Long ? (t.ms = $util.Long.fromValue(e.ms)).unsigned = !0 : "string" == typeof e.ms ? t.ms = parseInt(e.ms, 10) : "number" == typeof e.ms ? t.ms = e.ms : "object" === _typeof(e.ms) && (t.ms = new $util.LongBits(e.ms.low >>> 0, e.ms.high >>> 0).toNumber(!0))), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};
        if (t.defaults) if (r.key = "", r.value = "", r.origin = "", $util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.ms = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.ms = t.longs === String ? "0" : 0;
        return null != e.key && e.hasOwnProperty("key") && (r.key = e.key), null != e.value && e.hasOwnProperty("value") && (r.value = e.value), null != e.origin && e.hasOwnProperty("origin") && (r.origin = e.origin), null != e.ms && e.hasOwnProperty("ms") && ("number" == typeof e.ms ? r.ms = t.longs === String ? String(e.ms) : e.ms : r.ms = t.longs === String ? $util.Long.prototype.toString.call(e.ms) : t.longs === Number ? new $util.LongBits(e.ms.low >>> 0, e.ms.high >>> 0).toNumber(!0) : e.ms), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      GroupAttributeSet = $root.GroupAttributeSet = function () {
    function e(e) {
      if (this.attributeInfos = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.group = "", e.prototype.broadcast = !1, e.prototype.attributeInfos = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.group && Object.hasOwnProperty.call(e, "group") && t.uint32(18).string(e.group), null != e.broadcast && Object.hasOwnProperty.call(e, "broadcast") && t.uint32(24).bool(e.broadcast), null != e.attributeInfos && e.attributeInfos.length) for (var r = 0; r < e.attributeInfos.length; ++r) {
        $root.GroupAttributeSet.AttributeInfo.encode(e.attributeInfos[r], t.uint32(34).fork()).ldelim();
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeSet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.group = e.string();
            break;

          case 3:
            n.broadcast = e.bool();
            break;

          case 4:
            n.attributeInfos && n.attributeInfos.length || (n.attributeInfos = []), n.attributeInfos.push($root.GroupAttributeSet.AttributeInfo.decode(e, e.uint32()));
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.group && e.hasOwnProperty("group") && !$util.isString(e.group)) return "group: string expected";
      if (null != e.broadcast && e.hasOwnProperty("broadcast") && "boolean" != typeof e.broadcast) return "broadcast: boolean expected";

      if (null != e.attributeInfos && e.hasOwnProperty("attributeInfos")) {
        if (!Array.isArray(e.attributeInfos)) return "attributeInfos: array expected";

        for (var t = 0; t < e.attributeInfos.length; ++t) {
          var r = $root.GroupAttributeSet.AttributeInfo.verify(e.attributeInfos[t]);
          if (r) return "attributeInfos." + r;
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupAttributeSet) return e;
      var t = new $root.GroupAttributeSet();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.group && (t.group = String(e.group)), null != e.broadcast && (t.broadcast = Boolean(e.broadcast)), e.attributeInfos) {
        if (!Array.isArray(e.attributeInfos)) throw TypeError(".GroupAttributeSet.attributeInfos: array expected");
        t.attributeInfos = [];

        for (var r = 0; r < e.attributeInfos.length; ++r) {
          if ("object" !== _typeof(e.attributeInfos[r])) throw TypeError(".GroupAttributeSet.attributeInfos: object expected");
          t.attributeInfos[r] = $root.GroupAttributeSet.AttributeInfo.fromObject(e.attributeInfos[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.attributeInfos = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.group = "", r.broadcast = !1;
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.group && e.hasOwnProperty("group") && (r.group = e.group), null != e.broadcast && e.hasOwnProperty("broadcast") && (r.broadcast = e.broadcast), e.attributeInfos && e.attributeInfos.length) {
        r.attributeInfos = [];

        for (var o = 0; o < e.attributeInfos.length; ++o) {
          r.attributeInfos[o] = $root.GroupAttributeSet.AttributeInfo.toObject(e.attributeInfos[o], t);
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.AttributeInfo = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.key = "", e.prototype.value = "", e.encode = function (e, t) {
        return t || (t = $Writer.create()), null != e.key && Object.hasOwnProperty.call(e, "key") && t.uint32(10).string(e.key), null != e.value && Object.hasOwnProperty.call(e, "value") && t.uint32(18).string(e.value), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeSet.AttributeInfo(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.key = e.string();
              break;

            case 2:
              n.value = e.string();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.key && e.hasOwnProperty("key") && !$util.isString(e.key) ? "key: string expected" : null != e.value && e.hasOwnProperty("value") && !$util.isString(e.value) ? "value: string expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root.GroupAttributeSet.AttributeInfo) return e;
        var t = new $root.GroupAttributeSet.AttributeInfo();
        return null != e.key && (t.key = String(e.key)), null != e.value && (t.value = String(e.value)), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};
        return t.defaults && (r.key = "", r.value = ""), null != e.key && e.hasOwnProperty("key") && (r.key = e.key), null != e.value && e.hasOwnProperty("value") && (r.value = e.value), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      GroupAttributeMod = $root.GroupAttributeMod = function () {
    function e(e) {
      if (this.attributeInfos = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.group = "", e.prototype.broadcast = !1, e.prototype.attributeInfos = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.group && Object.hasOwnProperty.call(e, "group") && t.uint32(18).string(e.group), null != e.broadcast && Object.hasOwnProperty.call(e, "broadcast") && t.uint32(24).bool(e.broadcast), null != e.attributeInfos && e.attributeInfos.length) for (var r = 0; r < e.attributeInfos.length; ++r) {
        $root.GroupAttributeMod.AttributeInfo.encode(e.attributeInfos[r], t.uint32(34).fork()).ldelim();
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeMod(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.group = e.string();
            break;

          case 3:
            n.broadcast = e.bool();
            break;

          case 4:
            n.attributeInfos && n.attributeInfos.length || (n.attributeInfos = []), n.attributeInfos.push($root.GroupAttributeMod.AttributeInfo.decode(e, e.uint32()));
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.group && e.hasOwnProperty("group") && !$util.isString(e.group)) return "group: string expected";
      if (null != e.broadcast && e.hasOwnProperty("broadcast") && "boolean" != typeof e.broadcast) return "broadcast: boolean expected";

      if (null != e.attributeInfos && e.hasOwnProperty("attributeInfos")) {
        if (!Array.isArray(e.attributeInfos)) return "attributeInfos: array expected";

        for (var t = 0; t < e.attributeInfos.length; ++t) {
          var r = $root.GroupAttributeMod.AttributeInfo.verify(e.attributeInfos[t]);
          if (r) return "attributeInfos." + r;
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupAttributeMod) return e;
      var t = new $root.GroupAttributeMod();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.group && (t.group = String(e.group)), null != e.broadcast && (t.broadcast = Boolean(e.broadcast)), e.attributeInfos) {
        if (!Array.isArray(e.attributeInfos)) throw TypeError(".GroupAttributeMod.attributeInfos: array expected");
        t.attributeInfos = [];

        for (var r = 0; r < e.attributeInfos.length; ++r) {
          if ("object" !== _typeof(e.attributeInfos[r])) throw TypeError(".GroupAttributeMod.attributeInfos: object expected");
          t.attributeInfos[r] = $root.GroupAttributeMod.AttributeInfo.fromObject(e.attributeInfos[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.attributeInfos = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.group = "", r.broadcast = !1;
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.group && e.hasOwnProperty("group") && (r.group = e.group), null != e.broadcast && e.hasOwnProperty("broadcast") && (r.broadcast = e.broadcast), e.attributeInfos && e.attributeInfos.length) {
        r.attributeInfos = [];

        for (var o = 0; o < e.attributeInfos.length; ++o) {
          r.attributeInfos[o] = $root.GroupAttributeMod.AttributeInfo.toObject(e.attributeInfos[o], t);
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.AttributeInfo = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.key = "", e.prototype.value = "", e.encode = function (e, t) {
        return t || (t = $Writer.create()), null != e.key && Object.hasOwnProperty.call(e, "key") && t.uint32(10).string(e.key), null != e.value && Object.hasOwnProperty.call(e, "value") && t.uint32(18).string(e.value), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeMod.AttributeInfo(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.key = e.string();
              break;

            case 2:
              n.value = e.string();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.key && e.hasOwnProperty("key") && !$util.isString(e.key) ? "key: string expected" : null != e.value && e.hasOwnProperty("value") && !$util.isString(e.value) ? "value: string expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root.GroupAttributeMod.AttributeInfo) return e;
        var t = new $root.GroupAttributeMod.AttributeInfo();
        return null != e.key && (t.key = String(e.key)), null != e.value && (t.value = String(e.value)), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};
        return t.defaults && (r.key = "", r.value = ""), null != e.key && e.hasOwnProperty("key") && (r.key = e.key), null != e.value && e.hasOwnProperty("value") && (r.value = e.value), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      GroupAttributeDel = $root.GroupAttributeDel = function () {
    function e(e) {
      if (this.attributes = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.group = "", e.prototype.broadcast = !1, e.prototype.attributes = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.group && Object.hasOwnProperty.call(e, "group") && t.uint32(18).string(e.group), null != e.broadcast && Object.hasOwnProperty.call(e, "broadcast") && t.uint32(24).bool(e.broadcast), null != e.attributes && e.attributes.length) for (var r = 0; r < e.attributes.length; ++r) {
        t.uint32(34).string(e.attributes[r]);
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeDel(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.group = e.string();
            break;

          case 3:
            n.broadcast = e.bool();
            break;

          case 4:
            n.attributes && n.attributes.length || (n.attributes = []), n.attributes.push(e.string());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.group && e.hasOwnProperty("group") && !$util.isString(e.group)) return "group: string expected";
      if (null != e.broadcast && e.hasOwnProperty("broadcast") && "boolean" != typeof e.broadcast) return "broadcast: boolean expected";

      if (null != e.attributes && e.hasOwnProperty("attributes")) {
        if (!Array.isArray(e.attributes)) return "attributes: array expected";

        for (var t = 0; t < e.attributes.length; ++t) {
          if (!$util.isString(e.attributes[t])) return "attributes: string[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupAttributeDel) return e;
      var t = new $root.GroupAttributeDel();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.group && (t.group = String(e.group)), null != e.broadcast && (t.broadcast = Boolean(e.broadcast)), e.attributes) {
        if (!Array.isArray(e.attributes)) throw TypeError(".GroupAttributeDel.attributes: array expected");
        t.attributes = [];

        for (var r = 0; r < e.attributes.length; ++r) {
          t.attributes[r] = String(e.attributes[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.attributes = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.group = "", r.broadcast = !1;
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.group && e.hasOwnProperty("group") && (r.group = e.group), null != e.broadcast && e.hasOwnProperty("broadcast") && (r.broadcast = e.broadcast), e.attributes && e.attributes.length) {
        r.attributes = [];

        for (var o = 0; o < e.attributes.length; ++o) {
          r.attributes[o] = e.attributes[o];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupAttributeAlt = $root.GroupAttributeAlt = function () {
    function e(e) {
      if (this.attributeMaps = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.group = "", e.prototype.instance = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.attributeMaps = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.group && Object.hasOwnProperty.call(e, "group") && t.uint32(18).string(e.group), null != e.instance && Object.hasOwnProperty.call(e, "instance") && t.uint32(24).uint64(e.instance), null != e.attributeMaps && e.attributeMaps.length) for (var r = 0; r < e.attributeMaps.length; ++r) {
        $root.GroupAttributeAlt.AttributeMap.encode(e.attributeMaps[r], t.uint32(34).fork()).ldelim();
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeAlt(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.group = e.string();
            break;

          case 3:
            n.instance = e.uint64();
            break;

          case 4:
            n.attributeMaps && n.attributeMaps.length || (n.attributeMaps = []), n.attributeMaps.push($root.GroupAttributeAlt.AttributeMap.decode(e, e.uint32()));
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";
      if (null != e.group && e.hasOwnProperty("group") && !$util.isString(e.group)) return "group: string expected";
      if (null != e.instance && e.hasOwnProperty("instance") && !($util.isInteger(e.instance) || e.instance && $util.isInteger(e.instance.low) && $util.isInteger(e.instance.high))) return "instance: integer|Long expected";

      if (null != e.attributeMaps && e.hasOwnProperty("attributeMaps")) {
        if (!Array.isArray(e.attributeMaps)) return "attributeMaps: array expected";

        for (var t = 0; t < e.attributeMaps.length; ++t) {
          var r = $root.GroupAttributeAlt.AttributeMap.verify(e.attributeMaps[t]);
          if (r) return "attributeMaps." + r;
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupAttributeAlt) return e;
      var t = new $root.GroupAttributeAlt();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.group && (t.group = String(e.group)), null != e.instance && ($util.Long ? (t.instance = $util.Long.fromValue(e.instance)).unsigned = !0 : "string" == typeof e.instance ? t.instance = parseInt(e.instance, 10) : "number" == typeof e.instance ? t.instance = e.instance : "object" === _typeof(e.instance) && (t.instance = new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0))), e.attributeMaps) {
        if (!Array.isArray(e.attributeMaps)) throw TypeError(".GroupAttributeAlt.attributeMaps: array expected");
        t.attributeMaps = [];

        for (var r = 0; r < e.attributeMaps.length; ++r) {
          if ("object" !== _typeof(e.attributeMaps[r])) throw TypeError(".GroupAttributeAlt.attributeMaps: object expected");
          t.attributeMaps[r] = $root.GroupAttributeAlt.AttributeMap.fromObject(e.attributeMaps[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.attributeMaps = []), t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        if (r.group = "", $util.Long) {
          var o = new $util.Long(0, 0, !0);
          r.instance = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.instance = t.longs === String ? "0" : 0;
      }

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.group && e.hasOwnProperty("group") && (r.group = e.group), null != e.instance && e.hasOwnProperty("instance") && ("number" == typeof e.instance ? r.instance = t.longs === String ? String(e.instance) : e.instance : r.instance = t.longs === String ? $util.Long.prototype.toString.call(e.instance) : t.longs === Number ? new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0) : e.instance), e.attributeMaps && e.attributeMaps.length) {
        r.attributeMaps = [];

        for (var i = 0; i < e.attributeMaps.length; ++i) {
          r.attributeMaps[i] = $root.GroupAttributeAlt.AttributeMap.toObject(e.attributeMaps[i], t);
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.AttributeMap = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.key = "", e.prototype.value = "", e.prototype.origin = "", e.prototype.ms = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.encode = function (e, t) {
        return t || (t = $Writer.create()), null != e.key && Object.hasOwnProperty.call(e, "key") && t.uint32(10).string(e.key), null != e.value && Object.hasOwnProperty.call(e, "value") && t.uint32(18).string(e.value), null != e.origin && Object.hasOwnProperty.call(e, "origin") && t.uint32(26).string(e.origin), null != e.ms && Object.hasOwnProperty.call(e, "ms") && t.uint32(32).uint64(e.ms), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeAlt.AttributeMap(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.key = e.string();
              break;

            case 2:
              n.value = e.string();
              break;

            case 3:
              n.origin = e.string();
              break;

            case 4:
              n.ms = e.uint64();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.key && e.hasOwnProperty("key") && !$util.isString(e.key) ? "key: string expected" : null != e.value && e.hasOwnProperty("value") && !$util.isString(e.value) ? "value: string expected" : null != e.origin && e.hasOwnProperty("origin") && !$util.isString(e.origin) ? "origin: string expected" : null != e.ms && e.hasOwnProperty("ms") && !($util.isInteger(e.ms) || e.ms && $util.isInteger(e.ms.low) && $util.isInteger(e.ms.high)) ? "ms: integer|Long expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root.GroupAttributeAlt.AttributeMap) return e;
        var t = new $root.GroupAttributeAlt.AttributeMap();
        return null != e.key && (t.key = String(e.key)), null != e.value && (t.value = String(e.value)), null != e.origin && (t.origin = String(e.origin)), null != e.ms && ($util.Long ? (t.ms = $util.Long.fromValue(e.ms)).unsigned = !0 : "string" == typeof e.ms ? t.ms = parseInt(e.ms, 10) : "number" == typeof e.ms ? t.ms = e.ms : "object" === _typeof(e.ms) && (t.ms = new $util.LongBits(e.ms.low >>> 0, e.ms.high >>> 0).toNumber(!0))), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};
        if (t.defaults) if (r.key = "", r.value = "", r.origin = "", $util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.ms = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.ms = t.longs === String ? "0" : 0;
        return null != e.key && e.hasOwnProperty("key") && (r.key = e.key), null != e.value && e.hasOwnProperty("value") && (r.value = e.value), null != e.origin && e.hasOwnProperty("origin") && (r.origin = e.origin), null != e.ms && e.hasOwnProperty("ms") && ("number" == typeof e.ms ? r.ms = t.longs === String ? String(e.ms) : e.ms : r.ms = t.longs === String ? $util.Long.prototype.toString.call(e.ms) : t.longs === Number ? new $util.LongBits(e.ms.low >>> 0, e.ms.high >>> 0).toNumber(!0) : e.ms), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      GroupAttributeRsp = $root.GroupAttributeRsp = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeRsp(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupAttributeRsp) return e;
      var t = new $root.GroupAttributeRsp();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if (t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;
      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupAttributeErr = $root.GroupAttributeErr = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.code = 0, e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.code && Object.hasOwnProperty.call(e, "code") && t.uint32(16).uint32(e.code), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeErr(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.code = e.uint32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.code && e.hasOwnProperty("code") && !$util.isInteger(e.code) ? "code: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupAttributeErr) return e;
      var t = new $root.GroupAttributeErr();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.code && (t.code = e.code >>> 0), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.code = 0;
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.code && e.hasOwnProperty("code") && (r.code = e.code), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupAttributeKeysGet = $root.GroupAttributeKeysGet = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.group = "", e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.group && Object.hasOwnProperty.call(e, "group") && t.uint32(18).string(e.group), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeKeysGet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.group = e.string();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.group && e.hasOwnProperty("group") && !$util.isString(e.group) ? "group: string expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupAttributeKeysGet) return e;
      var t = new $root.GroupAttributeKeysGet();
      return null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.group && (t.group = String(e.group)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.seq = t.longs === String ? "0" : 0;

        r.group = "";
      }

      return null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.group && e.hasOwnProperty("group") && (r.group = e.group), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      GroupAttributeKeysRet = $root.GroupAttributeKeysRet = function () {
    function e(e) {
      if (this.keys = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.keys = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.keys && e.keys.length) for (var r = 0; r < e.keys.length; ++r) {
        t.uint32(18).string(e.keys[r]);
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.GroupAttributeKeysRet(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.keys && n.keys.length || (n.keys = []), n.keys.push(e.string());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";

      if (null != e.keys && e.hasOwnProperty("keys")) {
        if (!Array.isArray(e.keys)) return "keys: array expected";

        for (var t = 0; t < e.keys.length; ++t) {
          if (!$util.isString(e.keys[t])) return "keys: string[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.GroupAttributeKeysRet) return e;
      var t = new $root.GroupAttributeKeysRet();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), e.keys) {
        if (!Array.isArray(e.keys)) throw TypeError(".GroupAttributeKeysRet.keys: array expected");
        t.keys = [];

        for (var r = 0; r < e.keys.length; ++r) {
          t.keys[r] = String(e.keys[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if ((t.arrays || t.defaults) && (r.keys = []), t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), e.keys && e.keys.length) {
        r.keys = [];

        for (var o = 0; o < e.keys.length; ++o) {
          r.keys[o] = e.keys[o];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      SubscribeUserStatus = $root.SubscribeUserStatus = function () {
    function e(e) {
      if (this.users = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.users = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.users && e.users.length) for (var r = 0; r < e.users.length; ++r) {
        t.uint32(18).string(e.users[r]);
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.SubscribeUserStatus(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.users && n.users.length || (n.users = []), n.users.push(e.string());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";

      if (null != e.users && e.hasOwnProperty("users")) {
        if (!Array.isArray(e.users)) return "users: array expected";

        for (var t = 0; t < e.users.length; ++t) {
          if (!$util.isString(e.users[t])) return "users: string[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.SubscribeUserStatus) return e;
      var t = new $root.SubscribeUserStatus();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), e.users) {
        if (!Array.isArray(e.users)) throw TypeError(".SubscribeUserStatus.users: array expected");
        t.users = [];

        for (var r = 0; r < e.users.length; ++r) {
          t.users[r] = String(e.users[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if ((t.arrays || t.defaults) && (r.users = []), t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), e.users && e.users.length) {
        r.users = [];

        for (var o = 0; o < e.users.length; ++o) {
          r.users[o] = e.users[o];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UnsubscribeUserStatus = $root.UnsubscribeUserStatus = function () {
    function e(e) {
      if (this.users = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.users = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.users && e.users.length) for (var r = 0; r < e.users.length; ++r) {
        t.uint32(18).string(e.users[r]);
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UnsubscribeUserStatus(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.users && n.users.length || (n.users = []), n.users.push(e.string());
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";

      if (null != e.users && e.hasOwnProperty("users")) {
        if (!Array.isArray(e.users)) return "users: array expected";

        for (var t = 0; t < e.users.length; ++t) {
          if (!$util.isString(e.users[t])) return "users: string[] expected";
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UnsubscribeUserStatus) return e;
      var t = new $root.UnsubscribeUserStatus();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), e.users) {
        if (!Array.isArray(e.users)) throw TypeError(".UnsubscribeUserStatus.users: array expected");
        t.users = [];

        for (var r = 0; r < e.users.length; ++r) {
          t.users[r] = String(e.users[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if ((t.arrays || t.defaults) && (r.users = []), t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), e.users && e.users.length) {
        r.users = [];

        for (var o = 0; o < e.users.length; ++o) {
          r.users[o] = e.users[o];
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserJoinNotice = $root.UserJoinNotice = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.instance = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.user = "", e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.instance && Object.hasOwnProperty.call(e, "instance") && t.uint32(8).uint64(e.instance), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(16).uint64(e.seq), null != e.user && Object.hasOwnProperty.call(e, "user") && t.uint32(26).string(e.user), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserJoinNotice(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.instance = e.uint64();
            break;

          case 2:
            n.seq = e.uint64();
            break;

          case 3:
            n.user = e.string();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.instance && e.hasOwnProperty("instance") && !($util.isInteger(e.instance) || e.instance && $util.isInteger(e.instance.low) && $util.isInteger(e.instance.high)) ? "instance: integer|Long expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.user && e.hasOwnProperty("user") && !$util.isString(e.user) ? "user: string expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserJoinNotice) return e;
      var t = new $root.UserJoinNotice();
      return null != e.instance && ($util.Long ? (t.instance = $util.Long.fromValue(e.instance)).unsigned = !0 : "string" == typeof e.instance ? t.instance = parseInt(e.instance, 10) : "number" == typeof e.instance ? t.instance = e.instance : "object" === _typeof(e.instance) && (t.instance = new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0))), null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.user && (t.user = String(e.user)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.instance = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.instance = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var o = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.seq = t.longs === String ? "0" : 0;

        r.user = "";
      }

      return null != e.instance && e.hasOwnProperty("instance") && ("number" == typeof e.instance ? r.instance = t.longs === String ? String(e.instance) : e.instance : r.instance = t.longs === String ? $util.Long.prototype.toString.call(e.instance) : t.longs === Number ? new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0) : e.instance), null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.user && e.hasOwnProperty("user") && (r.user = e.user), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserQuitNotice = $root.UserQuitNotice = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.instance = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.user = "", e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.instance && Object.hasOwnProperty.call(e, "instance") && t.uint32(8).uint64(e.instance), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(16).uint64(e.seq), null != e.user && Object.hasOwnProperty.call(e, "user") && t.uint32(26).string(e.user), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserQuitNotice(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.instance = e.uint64();
            break;

          case 2:
            n.seq = e.uint64();
            break;

          case 3:
            n.user = e.string();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.instance && e.hasOwnProperty("instance") && !($util.isInteger(e.instance) || e.instance && $util.isInteger(e.instance.low) && $util.isInteger(e.instance.high)) ? "instance: integer|Long expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.user && e.hasOwnProperty("user") && !$util.isString(e.user) ? "user: string expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserQuitNotice) return e;
      var t = new $root.UserQuitNotice();
      return null != e.instance && ($util.Long ? (t.instance = $util.Long.fromValue(e.instance)).unsigned = !0 : "string" == typeof e.instance ? t.instance = parseInt(e.instance, 10) : "number" == typeof e.instance ? t.instance = e.instance : "object" === _typeof(e.instance) && (t.instance = new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0))), null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.user && (t.user = String(e.user)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.instance = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.instance = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var o = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.seq = t.longs === String ? "0" : 0;

        r.user = "";
      }

      return null != e.instance && e.hasOwnProperty("instance") && ("number" == typeof e.instance ? r.instance = t.longs === String ? String(e.instance) : e.instance : r.instance = t.longs === String ? $util.Long.prototype.toString.call(e.instance) : t.longs === Number ? new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0) : e.instance), null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.user && e.hasOwnProperty("user") && (r.user = e.user), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      UserWaitNotice = $root.UserWaitNotice = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.instance = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.user = "", e.encode = function (e, t) {
      return t || (t = $Writer.create()), null != e.instance && Object.hasOwnProperty.call(e, "instance") && t.uint32(8).uint64(e.instance), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(16).uint64(e.seq), null != e.user && Object.hasOwnProperty.call(e, "user") && t.uint32(26).string(e.user), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.UserWaitNotice(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.instance = e.uint64();
            break;

          case 2:
            n.seq = e.uint64();
            break;

          case 3:
            n.user = e.string();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.instance && e.hasOwnProperty("instance") && !($util.isInteger(e.instance) || e.instance && $util.isInteger(e.instance.low) && $util.isInteger(e.instance.high)) ? "instance: integer|Long expected" : null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.user && e.hasOwnProperty("user") && !$util.isString(e.user) ? "user: string expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.UserWaitNotice) return e;
      var t = new $root.UserWaitNotice();
      return null != e.instance && ($util.Long ? (t.instance = $util.Long.fromValue(e.instance)).unsigned = !0 : "string" == typeof e.instance ? t.instance = parseInt(e.instance, 10) : "number" == typeof e.instance ? t.instance = e.instance : "object" === _typeof(e.instance) && (t.instance = new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0))), null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), null != e.user && (t.user = String(e.user)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if ($util.Long) {
          var n = new $util.Long(0, 0, !0);
          r.instance = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.instance = t.longs === String ? "0" : 0;

        if ($util.Long) {
          var o = new $util.Long(0, 0, !0);
          r.seq = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.seq = t.longs === String ? "0" : 0;

        r.user = "";
      }

      return null != e.instance && e.hasOwnProperty("instance") && ("number" == typeof e.instance ? r.instance = t.longs === String ? String(e.instance) : e.instance : r.instance = t.longs === String ? $util.Long.prototype.toString.call(e.instance) : t.longs === Number ? new $util.LongBits(e.instance.low >>> 0, e.instance.high >>> 0).toNumber(!0) : e.instance), null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), null != e.user && e.hasOwnProperty("user") && (r.user = e.user), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      SubscribeResponse = $root.SubscribeResponse = function () {
    function e(e) {
      if (this.errors = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.seq = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, e.prototype.errors = $util.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer.create()), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(8).uint64(e.seq), null != e.errors && e.errors.length) for (var r = 0; r < e.errors.length; ++r) {
        $root.SubscribeResponse.SubscribeErrorsType.encode(e.errors[r], t.uint32(18).fork()).ldelim();
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader || (e = $Reader.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.SubscribeResponse(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.seq = e.uint64();
            break;

          case 2:
            n.errors && n.errors.length || (n.errors = []), n.errors.push($root.SubscribeResponse.SubscribeErrorsType.decode(e, e.uint32()));
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.seq && e.hasOwnProperty("seq") && !($util.isInteger(e.seq) || e.seq && $util.isInteger(e.seq.low) && $util.isInteger(e.seq.high))) return "seq: integer|Long expected";

      if (null != e.errors && e.hasOwnProperty("errors")) {
        if (!Array.isArray(e.errors)) return "errors: array expected";

        for (var t = 0; t < e.errors.length; ++t) {
          var r = $root.SubscribeResponse.SubscribeErrorsType.verify(e.errors[t]);
          if (r) return "errors." + r;
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root.SubscribeResponse) return e;
      var t = new $root.SubscribeResponse();

      if (null != e.seq && ($util.Long ? (t.seq = $util.Long.fromValue(e.seq)).unsigned = !0 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0))), e.errors) {
        if (!Array.isArray(e.errors)) throw TypeError(".SubscribeResponse.errors: array expected");
        t.errors = [];

        for (var r = 0; r < e.errors.length; ++r) {
          if ("object" !== _typeof(e.errors[r])) throw TypeError(".SubscribeResponse.errors: object expected");
          t.errors[r] = $root.SubscribeResponse.SubscribeErrorsType.fromObject(e.errors[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if ((t.arrays || t.defaults) && (r.errors = []), t.defaults) if ($util.Long) {
        var n = new $util.Long(0, 0, !0);
        r.seq = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.seq = t.longs === String ? "0" : 0;

      if (null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber(!0) : e.seq), e.errors && e.errors.length) {
        r.errors = [];

        for (var o = 0; o < e.errors.length; ++o) {
          r.errors[o] = $root.SubscribeResponse.SubscribeErrorsType.toObject(e.errors[o], t);
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.SubscribeErrorsType = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.account = "", e.prototype.code = 0, e.encode = function (e, t) {
        return t || (t = $Writer.create()), null != e.account && Object.hasOwnProperty.call(e, "account") && t.uint32(10).string(e.account), null != e.code && Object.hasOwnProperty.call(e, "code") && t.uint32(16).uint32(e.code), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader || (e = $Reader.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root.SubscribeResponse.SubscribeErrorsType(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.account = e.string();
              break;

            case 2:
              n.code = e.uint32();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.account && e.hasOwnProperty("account") && !$util.isString(e.account) ? "account: string expected" : null != e.code && e.hasOwnProperty("code") && !$util.isInteger(e.code) ? "code: integer expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root.SubscribeResponse.SubscribeErrorsType) return e;
        var t = new $root.SubscribeResponse.SubscribeErrorsType();
        return null != e.account && (t.account = String(e.account)), null != e.code && (t.code = e.code >>> 0), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};
        return t.defaults && (r.account = "", r.code = 0), null != e.account && e.hasOwnProperty("account") && (r.account = e.account), null != e.code && e.hasOwnProperty("code") && (r.code = e.code), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      ProtoPackets = Object.freeze({
    __proto__: null,
    Wrapper: Wrapper$1,
    Ping: Ping,
    Pong: Pong,
    UserJoin: UserJoin,
    UserResp: UserResp,
    UserQuit: UserQuit,
    UserDrop: UserDrop,
    GroupEnter: GroupEnter,
    GroupLeave: GroupLeave,
    GroupReply: GroupReply,
    GroupLeaveNotice: GroupLeaveNotice,
    GroupEnterNotice: GroupEnterNotice,
    Message: Message,
    Ack: Ack,
    FileUploadIndexGet: FileUploadIndexGet,
    FileUploadIndexRet: FileUploadIndexRet,
    FileUploadIndexSet: FileUploadIndexSet,
    FileUploadIndexFin: FileUploadIndexFin,
    FileUploadIndexErr: FileUploadIndexErr,
    FileDownloadIndexGet: FileDownloadIndexGet,
    FileDownloadIndexRet: FileDownloadIndexRet,
    FileDownloadIndexErr: FileDownloadIndexErr,
    GroupAllUsersList: GroupAllUsersList,
    GroupAllUsersResult: GroupAllUsersResult,
    UserStatusList: UserStatusList,
    UserStatusResult: UserStatusResult,
    UserAttributeGet: UserAttributeGet,
    UserAttributeRet: UserAttributeRet,
    UserAttributeSet: UserAttributeSet,
    UserAttributeMod: UserAttributeMod,
    UserAttributeDel: UserAttributeDel,
    UserAttributeErr: UserAttributeErr,
    UserAttributeKeysGet: UserAttributeKeysGet,
    UserAttributeKeysRet: UserAttributeKeysRet,
    UserAttributeRsp: UserAttributeRsp,
    GroupStatusList: GroupStatusList,
    GroupStatusResult: GroupStatusResult,
    GroupCountNotice: GroupCountNotice,
    GroupAttributeGet: GroupAttributeGet,
    GroupAttributeRet: GroupAttributeRet,
    GroupAttributeSet: GroupAttributeSet,
    GroupAttributeMod: GroupAttributeMod,
    GroupAttributeDel: GroupAttributeDel,
    GroupAttributeAlt: GroupAttributeAlt,
    GroupAttributeRsp: GroupAttributeRsp,
    GroupAttributeErr: GroupAttributeErr,
    GroupAttributeKeysGet: GroupAttributeKeysGet,
    GroupAttributeKeysRet: GroupAttributeKeysRet,
    SubscribeUserStatus: SubscribeUserStatus,
    UnsubscribeUserStatus: UnsubscribeUserStatus,
    UserJoinNotice: UserJoinNotice,
    UserQuitNotice: UserQuitNotice,
    UserWaitNotice: UserWaitNotice,
    SubscribeResponse: SubscribeResponse,
    default: $root
  });

  _export(_export.S, "Object", {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(e) {
      for (var t, r, n = _toIobject(e), o = _objectGopd.f, i = _ownKeys(n), s = {}, a = 0; i.length > a;) {
        void 0 !== (r = o(n, t = i[a++])) && _createProperty(s, t, r);
      }

      return s;
    }
  });

  var isBufferBrowser = function isBufferBrowser(e) {
    return e && "object" === _typeof(e) && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
  },
      inherits_browser = createCommonjsModule(function (e) {
    "function" == typeof Object.create ? e.exports = function (e, t) {
      e.super_ = t, e.prototype = Object.create(t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : e.exports = function (e, t) {
      e.super_ = t;

      var r = function r() {};

      r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
    };
  }),
      util = createCommonjsModule(function (e, t) {
    var r = Object.getOwnPropertyDescriptors || function (e) {
      for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) {
        r[t[n]] = Object.getOwnPropertyDescriptor(e, t[n]);
      }

      return r;
    },
        n = /%[sdj%]/g;

    t.format = function (e) {
      if (!b(e)) {
        for (var t = [], r = 0; r < arguments.length; r++) {
          t.push(s(arguments[r]));
        }

        return t.join(" ");
      }

      r = 1;

      for (var o = arguments, i = o.length, a = String(e).replace(n, function (e) {
        if ("%%" === e) return "%";
        if (r >= i) return e;

        switch (e) {
          case "%s":
            return String(o[r++]);

          case "%d":
            return Number(o[r++]);

          case "%j":
            try {
              return JSON.stringify(o[r++]);
            } catch (e) {
              return "[Circular]";
            }

          default:
            return e;
        }
      }), u = o[r]; r < i; u = o[++r]) {
        g(u) || !m(u) ? a += " " + u : a += " " + s(u);
      }

      return a;
    }, t.deprecate = function (e, r) {
      if ("undefined" != typeof process && !0 === process.noDeprecation) return e;
      if ("undefined" == typeof process) return function () {
        return t.deprecate(e, r).apply(this, arguments);
      };
      var n = !1;
      return function () {
        if (!n) {
          if (process.throwDeprecation) throw new Error(r);
          process.traceDeprecation ? console.trace(r) : console.error(r), n = !0;
        }

        return e.apply(this, arguments);
      };
    };
    var o,
        i = {};

    function s(e, r) {
      var n = {
        seen: [],
        stylize: u
      };
      return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), d(r) ? n.showHidden = r : r && t._extend(n, r), y(n.showHidden) && (n.showHidden = !1), y(n.depth) && (n.depth = 2), y(n.colors) && (n.colors = !1), y(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = a), l(n, e, n.depth);
    }

    function a(e, t) {
      var r = s.styles[t];
      return r ? "[" + s.colors[r][0] + "m" + e + "[" + s.colors[r][1] + "m" : e;
    }

    function u(e, t) {
      return e;
    }

    function l(e, r, n) {
      if (e.customInspect && r && O(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
        var o = r.inspect(n, e);
        return b(o) || (o = l(e, o, n)), o;
      }

      var i = function (e, t) {
        if (y(t)) return e.stylize("undefined", "undefined");

        if (b(t)) {
          var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return e.stylize(r, "string");
        }

        if (h(t)) return e.stylize("" + t, "number");
        if (d(t)) return e.stylize("" + t, "boolean");
        if (g(t)) return e.stylize("null", "null");
      }(e, r);

      if (i) return i;

      var s = Object.keys(r),
          a = function (e) {
        var t = {};
        return e.forEach(function (e, r) {
          t[e] = !0;
        }), t;
      }(s);

      if (e.showHidden && (s = Object.getOwnPropertyNames(r)), E(r) && (s.indexOf("message") >= 0 || s.indexOf("description") >= 0)) return c(r);

      if (0 === s.length) {
        if (O(r)) {
          var u = r.name ? ": " + r.name : "";
          return e.stylize("[Function" + u + "]", "special");
        }

        if (_(r)) return e.stylize(RegExp.prototype.toString.call(r), "regexp");
        if (v(r)) return e.stylize(Date.prototype.toString.call(r), "date");
        if (E(r)) return c(r);
      }

      var m,
          I = "",
          $ = !1,
          S = ["{", "}"];
      (f(r) && ($ = !0, S = ["[", "]"]), O(r)) && (I = " [Function" + (r.name ? ": " + r.name : "") + "]");
      return _(r) && (I = " " + RegExp.prototype.toString.call(r)), v(r) && (I = " " + Date.prototype.toUTCString.call(r)), E(r) && (I = " " + c(r)), 0 !== s.length || $ && 0 != r.length ? n < 0 ? _(r) ? e.stylize(RegExp.prototype.toString.call(r), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(r), m = $ ? function (e, t, r, n, o) {
        for (var i = [], s = 0, a = t.length; s < a; ++s) {
          w(t, String(s)) ? i.push(p(e, t, r, n, String(s), !0)) : i.push("");
        }

        return o.forEach(function (o) {
          o.match(/^\d+$/) || i.push(p(e, t, r, n, o, !0));
        }), i;
      }(e, r, n, a, s) : s.map(function (t) {
        return p(e, r, n, a, t, $);
      }), e.seen.pop(), function (e, t, r) {
        if (e.reduce(function (e, t) {
          return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0) > 60) return r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1];
        return r[0] + t + " " + e.join(", ") + " " + r[1];
      }(m, I, S)) : S[0] + I + S[1];
    }

    function c(e) {
      return "[" + Error.prototype.toString.call(e) + "]";
    }

    function p(e, t, r, n, o, i) {
      var s, a, u;

      if ((u = Object.getOwnPropertyDescriptor(t, o) || {
        value: t[o]
      }).get ? a = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (a = e.stylize("[Setter]", "special")), w(n, o) || (s = "[" + o + "]"), a || (e.seen.indexOf(u.value) < 0 ? (a = g(r) ? l(e, u.value, null) : l(e, u.value, r - 1)).indexOf("\n") > -1 && (a = i ? a.split("\n").map(function (e) {
        return "  " + e;
      }).join("\n").substr(2) : "\n" + a.split("\n").map(function (e) {
        return "   " + e;
      }).join("\n")) : a = e.stylize("[Circular]", "special")), y(s)) {
        if (i && o.match(/^\d+$/)) return a;
        (s = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s = s.substr(1, s.length - 2), s = e.stylize(s, "name")) : (s = s.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s = e.stylize(s, "string"));
      }

      return s + ": " + a;
    }

    function f(e) {
      return Array.isArray(e);
    }

    function d(e) {
      return "boolean" == typeof e;
    }

    function g(e) {
      return null === e;
    }

    function h(e) {
      return "number" == typeof e;
    }

    function b(e) {
      return "string" == typeof e;
    }

    function y(e) {
      return void 0 === e;
    }

    function _(e) {
      return m(e) && "[object RegExp]" === I(e);
    }

    function m(e) {
      return "object" === _typeof(e) && null !== e;
    }

    function v(e) {
      return m(e) && "[object Date]" === I(e);
    }

    function E(e) {
      return m(e) && ("[object Error]" === I(e) || e instanceof Error);
    }

    function O(e) {
      return "function" == typeof e;
    }

    function I(e) {
      return Object.prototype.toString.call(e);
    }

    function $(e) {
      return e < 10 ? "0" + e.toString(10) : e.toString(10);
    }

    t.debuglog = function (e) {
      if (y(o) && (o = process.env.NODE_DEBUG || ""), e = e.toUpperCase(), !i[e]) if (new RegExp("\\b" + e + "\\b", "i").test(o)) {
        var r = process.pid;

        i[e] = function () {
          var n = t.format.apply(t, arguments);
          console.error("%s %d: %s", e, r, n);
        };
      } else i[e] = function () {};
      return i[e];
    }, t.inspect = s, s.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, s.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      regexp: "red"
    }, t.isArray = f, t.isBoolean = d, t.isNull = g, t.isNullOrUndefined = function (e) {
      return null == e;
    }, t.isNumber = h, t.isString = b, t.isSymbol = function (e) {
      return "symbol" === _typeof(e);
    }, t.isUndefined = y, t.isRegExp = _, t.isObject = m, t.isDate = v, t.isError = E, t.isFunction = O, t.isPrimitive = function (e) {
      return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" === _typeof(e) || void 0 === e;
    }, t.isBuffer = isBufferBrowser;
    var S = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    function w(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }

    t.log = function () {
      var e, r;
      console.log("%s - %s", (e = new Date(), r = [$(e.getHours()), $(e.getMinutes()), $(e.getSeconds())].join(":"), [e.getDate(), S[e.getMonth()], r].join(" ")), t.format.apply(t, arguments));
    }, t.inherits = inherits_browser, t._extend = function (e, t) {
      if (!t || !m(t)) return e;

      for (var r = Object.keys(t), n = r.length; n--;) {
        e[r[n]] = t[r[n]];
      }

      return e;
    };
    var R = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;

    function A(e, t) {
      if (!e) {
        var r = new Error("Promise was rejected with a falsy value");
        r.reason = e, e = r;
      }

      return t(e);
    }

    t.promisify = function (e) {
      if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

      if (R && e[R]) {
        var t;
        if ("function" != typeof (t = e[R])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(t, R, {
          value: t,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), t;
      }

      function t() {
        for (var t, r, n = new Promise(function (e, n) {
          t = e, r = n;
        }), o = [], i = 0; i < arguments.length; i++) {
          o.push(arguments[i]);
        }

        o.push(function (e, n) {
          e ? r(e) : t(n);
        });

        try {
          e.apply(this, o);
        } catch (e) {
          r(e);
        }

        return n;
      }

      return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), R && Object.defineProperty(t, R, {
        value: t,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(t, r(e));
    }, t.promisify.custom = R, t.callbackify = function (e) {
      if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

      function t() {
        for (var t = [], r = 0; r < arguments.length; r++) {
          t.push(arguments[r]);
        }

        var n = t.pop();
        if ("function" != typeof n) throw new TypeError("The last argument must be of type Function");

        var o = this,
            i = function i() {
          return n.apply(o, arguments);
        };

        e.apply(this, t).then(function (e) {
          process.nextTick(i, null, e);
        }, function (e) {
          process.nextTick(A, e, i);
        });
      }

      return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, r(e)), t;
    };
  }),
      util_1 = util.format,
      util_2 = util.deprecate,
      util_3 = util.debuglog,
      util_4 = util.inspect,
      util_5 = util.isArray,
      util_6 = util.isBoolean,
      util_7 = util.isNull,
      util_8 = util.isNullOrUndefined,
      util_9 = util.isNumber,
      util_10 = util.isString,
      util_11 = util.isSymbol,
      util_12 = util.isUndefined,
      util_13 = util.isRegExp,
      util_14 = util.isObject,
      util_15 = util.isDate,
      util_16 = util.isError,
      util_17 = util.isFunction,
      util_18 = util.isPrimitive,
      util_19 = util.isBuffer,
      util_20 = util.log,
      util_21 = util.inherits,
      util_22 = util._extend,
      util_23 = util.promisify,
      util_24 = util.callbackify,
      now = function now() {
    return _root.Date.now();
  },
      now_1 = now,
      NAN = NaN,
      reTrim = /^\s+|\s+$/g,
      reIsBadHex = /^[-+]0x[0-9a-f]+$/i,
      reIsBinary = /^0b[01]+$/i,
      reIsOctal = /^0o[0-7]+$/i,
      freeParseInt = parseInt;

  function toNumber$1(e) {
    if ("number" == typeof e) return e;
    if (isSymbol_1(e)) return NAN;

    if (isObject_1(e)) {
      var t = "function" == typeof e.valueOf ? e.valueOf() : e;
      e = isObject_1(t) ? t + "" : t;
    }

    if ("string" != typeof e) return 0 === e ? e : +e;
    e = e.replace(reTrim, "");
    var r = reIsBinary.test(e);
    return r || reIsOctal.test(e) ? freeParseInt(e.slice(2), r ? 2 : 8) : reIsBadHex.test(e) ? NAN : +e;
  }

  var toNumber_1 = toNumber$1,
      FUNC_ERROR_TEXT$1 = "Expected a function",
      nativeMax$1 = Math.max,
      nativeMin = Math.min;

  function debounce(e, t, r) {
    var n,
        o,
        i,
        s,
        a,
        u,
        l = 0,
        c = !1,
        p = !1,
        f = !0;
    if ("function" != typeof e) throw new TypeError(FUNC_ERROR_TEXT$1);

    function d(t) {
      var r = n,
          i = o;
      return n = o = void 0, l = t, s = e.apply(i, r);
    }

    function g(e) {
      var r = e - u;
      return void 0 === u || r >= t || r < 0 || p && e - l >= i;
    }

    function h() {
      var e = now_1();
      if (g(e)) return b(e);
      a = setTimeout(h, function (e) {
        var r = t - (e - u);
        return p ? nativeMin(r, i - (e - l)) : r;
      }(e));
    }

    function b(e) {
      return a = void 0, f && n ? d(e) : (n = o = void 0, s);
    }

    function y() {
      var e = now_1(),
          r = g(e);

      if (n = arguments, o = this, u = e, r) {
        if (void 0 === a) return function (e) {
          return l = e, a = setTimeout(h, t), c ? d(e) : s;
        }(u);
        if (p) return clearTimeout(a), a = setTimeout(h, t), d(u);
      }

      return void 0 === a && (a = setTimeout(h, t)), s;
    }

    return t = toNumber_1(t) || 0, isObject_1(r) && (c = !!r.leading, i = (p = "maxWait" in r) ? nativeMax$1(toNumber_1(r.maxWait) || 0, t) : i, f = "trailing" in r ? !!r.trailing : f), y.cancel = function () {
      void 0 !== a && clearTimeout(a), l = 0, n = u = o = a = void 0;
    }, y.flush = function () {
      return void 0 === a ? s : b(now_1());
    }, y;
  }

  var debounce_1 = debounce;

  function _typeof$1(e) {
    return (_typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _classCallCheck$1(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _possibleConstructorReturn$1(e, t) {
    return !t || "object" !== _typeof$1(t) && "function" != typeof t ? _assertThisInitialized$1(e) : t;
  }

  function _assertThisInitialized$1(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _inherits$1(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$1(e, t);
  }

  function _wrapNativeSuper$1(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (_wrapNativeSuper$1 = function _wrapNativeSuper$1(e) {
      if (null === e || !_isNativeFunction$1(e)) return e;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, r);
      }

      function r() {
        return _construct$1(e, arguments, _getPrototypeOf$1(this).constructor);
      }

      return r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), _setPrototypeOf$1(r, e);
    })(e);
  }

  function isNativeReflectConstruct$1() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }

  function _construct$1(e, t, r) {
    return (_construct$1 = isNativeReflectConstruct$1() ? Reflect.construct : function (e, t, r) {
      var n = [null];
      n.push.apply(n, t);
      var o = new (Function.bind.apply(e, n))();
      return r && _setPrototypeOf$1(o, r.prototype), o;
    }).apply(null, arguments);
  }

  function _isNativeFunction$1(e) {
    return -1 !== Function.toString.call(e).indexOf("[native code]");
  }

  function _setPrototypeOf$1(e, t) {
    return (_setPrototypeOf$1 = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function _getPrototypeOf$1(e) {
    return (_getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var RtmBaseError = function (e) {
    function t(e, r) {
      var n;
      return _classCallCheck$1(this, t), (n = _possibleConstructorReturn$1(this, _getPrototypeOf$1(t).call(this, genErrorMessage(e, r)))).originalError = void 0, n.code = void 0, n.serverCode = void 0, "number" == typeof r ? n.code = r : "string" == typeof r ? n.name = r : void 0 !== r && (r.originalError && (n.originalError = r.originalError), void 0 !== r.code && (n.code = r.code), void 0 !== r.serverCode && (n.serverCode = r.serverCode)), n;
    }

    return _inherits$1(t, _wrapNativeSuper$1(Error)), t;
  }(),
      RtmInternalError = function (e) {
    function t(e, r) {
      var n;
      return _classCallCheck$1(this, t), (n = _possibleConstructorReturn$1(this, _getPrototypeOf$1(t).call(this, genErrorMessage(e, r)))).code = r, n.name = "RtmInternalError", n;
    }

    return _inherits$1(t, _wrapNativeSuper$1(Error)), t;
  }(),
      genError = function genError() {
    return function (e) {
      function t(e) {
        _classCallCheck$1(this, t);

        var r = Object.keys(e);
        return _possibleConstructorReturn$1(this, _getPrototypeOf$1(t).call(this, e[r[0]], r[0]));
      }

      return _inherits$1(t, RtmInternalError), t;
    }();
  },
      CommonError = genError(),
      RtmTimeoutError = function (e) {
    function t() {
      var e, r;

      _classCallCheck$1(this, t);

      for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) {
        o[i] = arguments[i];
      }

      return (r = _possibleConstructorReturn$1(this, (e = _getPrototypeOf$1(t)).call.apply(e, [this].concat(o)))).name = "RtmTimeoutError", r;
    }

    return _inherits$1(t, RtmBaseError), t;
  }(),
      RtmInvalidArgumentError = function (e) {
    function t() {
      var e, r;

      _classCallCheck$1(this, t);

      for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) {
        o[i] = arguments[i];
      }

      return (r = _possibleConstructorReturn$1(this, (e = _getPrototypeOf$1(t)).call.apply(e, [this].concat(o)))).name = "RtmInvalidArgumentError", r;
    }

    return _inherits$1(t, RtmBaseError), t;
  }(),
      RtmInvalidStatusError = function (e) {
    function t() {
      var e, r;

      _classCallCheck$1(this, t);

      for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) {
        o[i] = arguments[i];
      }

      return (r = _possibleConstructorReturn$1(this, (e = _getPrototypeOf$1(t)).call.apply(e, [this].concat(o)))).name = "RtmInvalidStatusError", r;
    }

    return _inherits$1(t, RtmBaseError), t;
  }(),
      RtmInterruptedError = function (e) {
    function t() {
      var e, r;

      _classCallCheck$1(this, t);

      for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) {
        o[i] = arguments[i];
      }

      return (r = _possibleConstructorReturn$1(this, (e = _getPrototypeOf$1(t)).call.apply(e, [this].concat(o)))).name = "RtmInterruptedError", r;
    }

    return _inherits$1(t, RtmBaseError), t;
  }(),
      RtmLimitExceededError = function (e) {
    function t() {
      var e, r;

      _classCallCheck$1(this, t);

      for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) {
        o[i] = arguments[i];
      }

      return (r = _possibleConstructorReturn$1(this, (e = _getPrototypeOf$1(t)).call.apply(e, [this].concat(o)))).name = "RtmLimitExceededError", r;
    }

    return _inherits$1(t, RtmBaseError), t;
  }(),
      RtmInvokeTooOftenError = function (e) {
    function t() {
      var e, r;

      _classCallCheck$1(this, t);

      for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) {
        o[i] = arguments[i];
      }

      return (r = _possibleConstructorReturn$1(this, (e = _getPrototypeOf$1(t)).call.apply(e, [this].concat(o)))).name = "RtmInvokeTooOftenError", r;
    }

    return _inherits$1(t, RtmBaseError), t;
  }(),
      RtmUnavailableError = function (e) {
    function t() {
      var e, r;

      _classCallCheck$1(this, t);

      for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) {
        o[i] = arguments[i];
      }

      return (r = _possibleConstructorReturn$1(this, (e = _getPrototypeOf$1(t)).call.apply(e, [this].concat(o)))).name = "RtmUnavailableError", r.serverCode = void 0, r.statusCode = void 0, r;
    }

    return _inherits$1(t, RtmBaseError), t;
  }(),
      RtmUnauthenticatedError = function (e) {
    function t() {
      var e, r;

      _classCallCheck$1(this, t);

      for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) {
        o[i] = arguments[i];
      }

      return (r = _possibleConstructorReturn$1(this, (e = _getPrototypeOf$1(t)).call.apply(e, [this].concat(o)))).name = "RtmUnauthenticatedError", r.serverCode = void 0, r;
    }

    return _inherits$1(t, RtmBaseError), t;
  }(),
      RtmUnknownError = function (e) {
    function t() {
      var e, r;

      _classCallCheck$1(this, t);

      for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) {
        o[i] = arguments[i];
      }

      return (r = _possibleConstructorReturn$1(this, (e = _getPrototypeOf$1(t)).call.apply(e, [this].concat(o)))).name = "RtmUnknownError", r;
    }

    return _inherits$1(t, RtmBaseError), t;
  }(),
      isTimeout = function isTimeout(e) {
    return e instanceof RtmTimeoutError || e instanceof TimeoutError;
  },
      isRtmError = function isRtmError(e) {
    return e instanceof RtmBaseError;
  },
      invalidArgumentMessage = "The %s in the arguments is invalid",
      genTimeoutMessage = function genTimeoutMessage(e, t, r) {
    return ['Executing "%s.%s" timed out after %ds', e, t, r / 1e3];
  },
      AP_CONCURRENT_REQ_NUM = 2,
      APP_ID_LENGTH = 32,
      CHANNEL_ATTRIBUTES_MAX_KEY_COUNT = 512,
      AP_REQUEST_TIMEOUT = 1e4,
      SOCKET_KEEPALIVE_TIMEOUT = 4500,
      KEEPALIVE_INTERVAL = 1e3,
      SOCKET_RETRY_INTERVAL = 1500,
      CLIENT_LOGIN_TIMEOUT = 1e4,
      LOGIN_RESP_TIMEOUT = 5e3,
      MESSAGE_MIN_COMPRESSION_LEN = 128,
      MESSAGE_SEND_TIMEOUT = 1e4,
      COMMON_REQUEST_TIMEOUT = 1e4,
      DIALOGUE_EXPIRE_TIMEOUT = 1e4,
      LRU_MAX_ITEMS = 1e4,
      MESSAGE_RETRY_TIMEOUT = 6e3,
      LOGOUT_SOCKET_CLOSE_TIMEOUT = 5e3,
      LOGIN_QPS_LIMIT = 2,
      MEDIA_MESSAGE_MAX_CONTENT_BYTES = 32768,
      TEXT_MESSAGE_MAX_TEXT_BYTES = 32768,
      ONLINE_MESSAGE_DEDUP_DELAY = 750,
      OFFLINE_MESSAGE_DEDUP_DELAY = 1500,
      MSG_DEDUP_MAX_LEN = 200,
      LOG_UPLOAD_MAX_ITEMS = 40,
      MAX_JOINED_CHANNELS = 20,
      INVITATION_EXPIRE_TIMEOUT = 6e4,
      INVITATION_EXTRA_MAX_BYTES = 8192,
      REMOTE_INVITATION_WAIT_ACCEPT_ACK_TIMEOUT = 5e3,
      REMOTE_INVITATION_ACCEPT_RESEND_INTERVAL = 1e3,
      LOCAL_INVITATION_ACK_TIMEOUT = 3e4,
      LOCAL_INVITATION_RESEND_INTERVAL = 2e3,
      MEMBER_COUNT_UPDATED_EVENT_INTERVAL = 1e3,
      CHANNEL_ATTRIBUTES_CACHE_MAX_LENGTH = 1e4,
      MEDIA_MESSAGE_UNIT_SIZE = 32768;

  function _slicedToArray$1(e, t) {
    return _arrayWithHoles$1(e) || _iterableToArrayLimit$1(e, t) || _nonIterableRest$1();
  }

  function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit$1(e, t) {
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }

  function _arrayWithHoles$1(e) {
    if (Array.isArray(e)) return e;
  }

  function isValidAppId(e) {
    return /^[\dA-Za-z]{32}$/.test(e);
  }

  function isValidId(e) {
    return "string" == typeof e && /^[\s\w!#$%&()+,.:;<=>?@[\]^{|}~-]{1,64}$/.test(e) && "null" !== e;
  }

  function isValidIp(e) {
    var t;

    try {
      t = e.split(".").map(function (e) {
        return Number(e);
      });
    } catch (e) {
      return !1;
    }

    if (4 !== t.length) return !1;
    if (0 === t[0]) return !1;
    var r = t,
        n = Array.isArray(r),
        o = 0;

    for (r = n ? r : r[Symbol.iterator]();;) {
      var i;

      if (n) {
        if (o >= r.length) break;
        i = r[o++];
      } else {
        if ((o = r.next()).done) break;
        i = o.value;
      }

      var s = i;
      if (!Number.isInteger(s)) return !1;
      if (s < 0 || s > 255) return !1;
    }

    return !0;
  }

  function checkValidAttrGetByKeysArgs(e, t) {
    if (!Array.isArray(t) || 0 === t.length || t.length > 32 || t.some(function (e) {
      return 0 === e.length || e.length > 32;
    })) throw new RtmInvalidArgumentError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);
    if (!isValidId(e)) throw new RtmInvalidArgumentError("ID is invalid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);
  }

  function validAttributes(e) {
    var t = e.attributes,
        r = e.attrSizeMap,
        n = e.maxAttrsCount,
        o = e.maxAttrValueSize,
        i = e.maxTotalSize;
    if (!isPlainObject$1(t)) throw new RtmInvalidArgumentError("attributes must be an object", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);
    if (Object.keys(t).length > n) throw new RtmLimitExceededError("Exceed the limit of ".concat(n, " attributes"), ATTRIBUTE_OPERATION_ERR_SIZE_OVERFLOW);
    if (0 === Object.keys(t).length) throw new RtmInvalidArgumentError("The attributes is an empty object", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

    for (var s = 0, a = 0, u = Object.entries(t); a < u.length; a++) {
      var l = _slicedToArray$1(u[a], 2),
          c = l[0],
          p = l[1],
          f = new Blob([c]).size,
          d = new Blob([p]).size;

      if (0 === f || f > 32) throw new RtmInvalidArgumentError("Invalid attribute key", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);
      if (d > o) throw new RtmLimitExceededError("Invalid attribute value, over the limit of ".concat(o, " bytes"), ATTRIBUTE_OPERATION_ERR_SIZE_OVERFLOW);
      if ("string" != typeof p || 0 === p.length) throw new RtmInvalidArgumentError("Invalid attribute value", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);
      s += f, s += d;
    }

    if (s > i) throw new RtmLimitExceededError("The attributes size overflow", ATTRIBUTE_OPERATION_ERR_SIZE_OVERFLOW);

    if (void 0 !== r) {
      if (Object.keys(r).length > n) throw new RtmLimitExceededError("Exceed the limit of ".concat(n, " attributes"), ATTRIBUTE_OPERATION_ERR_SIZE_OVERFLOW);

      for (var g = 0, h = 0, b = Object.entries(r); h < b.length; h++) {
        var y = _slicedToArray$1(b[h], 2),
            _ = (c = y[0], d = y[1], new Blob([c]).size);

        if (0 === _) throw new RtmInvalidArgumentError("Invalid attribute key", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);
        if (d > o) throw new RtmLimitExceededError("Invalid attribute value, over the limit of ".concat(o, " bytes"), ATTRIBUTE_OPERATION_ERR_SIZE_OVERFLOW);
        g += _, g += d;
      }

      if (g > i) throw new RtmLimitExceededError("The attributes size overflow", ATTRIBUTE_OPERATION_ERR_SIZE_OVERFLOW);
    }
  }

  function _typeof$2(e) {
    return (_typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _slicedToArray$2(e, t) {
    return _arrayWithHoles$2(e) || _iterableToArrayLimit$2(e, t) || _nonIterableRest$2();
  }

  function _nonIterableRest$2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit$2(e, t) {
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }

  function _arrayWithHoles$2(e) {
    if (Array.isArray(e)) return e;
  }

  function asyncGeneratorStep$1(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$1(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$1(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$1(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  function _toConsumableArray$1(e) {
    return _arrayWithoutHoles$1(e) || _iterableToArray$1(e) || _nonIterableSpread$1();
  }

  function _nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray$1(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _arrayWithoutHoles$1(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  var UINT32_MAX = 4294967295;

  function getRandomInt(e, t) {
    var r = Math.ceil(e),
        n = Math.floor(t);
    return Math.floor(Math.random() * (n - r + 1)) + e;
  }

  function getRandomUInt64() {
    var e = getRandomInt(0, UINT32_MAX),
        t = getRandomInt(1, UINT32_MAX);
    return new long_1(e, t, !0);
  }

  function getSid(e) {
    return e.toString().padEnd(32, "0");
  }

  function assertNever(e, t) {
    return new TypeError("Unexpected ".concat(e, ": ").concat(t));
  }

  function calIpDistance(e, t) {
    var r = e.split(".").map(function (e) {
      return Number(e);
    }),
        n = t.split(".").map(function (e) {
      return Number(e);
    });
    return Math.sqrt(1e3 * Math.pow(r[0] - n[0], 2) + 100 * Math.pow(r[1] - n[1], 2) + 10 * Math.pow(r[2] - n[2], 2) + 1 * Math.pow(r[3] - n[3], 2));
  }

  function longToStringIfNeeded(e) {
    return e.lessThanOrEqual(Number.MAX_SAFE_INTEGER) ? e.toNumber() : e.toString();
  }

  var prefixSeqMap = new Map();

  function uniquePrefixedId(e, t) {
    var r = "".concat(e).concat(t || ""),
        n = prefixSeqMap.get(r) || 1;
    return prefixSeqMap.set(r, n + 1), "".concat(e).concat(n);
  }

  var getUTCTimestamp = function getUTCTimestamp() {
    var e = new Date();
    return "".concat(e.toISOString().split("T")[1].replace(/\..+/, ""), ".").concat(e.getMilliseconds());
  },
      getKeys = Object.keys,
      getEntries = Object.entries.bind(Object);

  function isLongNum(e) {
    return "number" == typeof e || long_1.isLong(e);
  }

  var getName = function getName(e) {
    return Object.keys(e)[0];
  },
      addPeriodIfNeeded = function addPeriodIfNeeded(e) {
    return "string" == typeof e ? e.endsWith(".") ? e : "".concat(e, ".") : e;
  };

  function genErrorMessage(e, t) {
    var r,
        n = "number" == typeof t ? t : void 0 !== t && "string" != typeof t ? t.code : void 0,
        o = "number" != typeof t && "string" != typeof t && void 0 !== t && void 0 !== t.serverCode ? t.serverCode : void 0,
        i = "".concat(void 0 !== n ? " Error Code ".concat(n) : "").concat(void 0 !== o ? ", server Code ".concat(o) : "");
    return r = "string" == typeof e && e ? addPeriodIfNeeded(e) : Array.isArray(e) && "string" == typeof e[0] && e[0] ? addPeriodIfNeeded(util_1.apply(void 0, [e[0]].concat(_toConsumableArray$1(e.slice(1))))) : "", "".concat("" === i ? "" : "".concat(i, " - ")).concat(r);
  }

  function delay$1(e) {
    return _delay.apply(this, arguments);
  }

  function _delay() {
    return (_delay = _asyncToGenerator$1(regenerator.mark(function e(t) {
      return regenerator.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", new Promise(function (e) {
                setTimeout(function () {
                  e();
                }, t);
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }

  function isBlob(e) {
    return e instanceof Blob || "[object Blob]" === Object.prototype.toString.call(e);
  }

  function intIP2StrIP(e) {
    var t = 255 & e,
        r = e >> 8 & 255,
        n = e >> 16 & 255;
    return "".concat(e >> 24 & 255, ".").concat(n, ".").concat(r, ".").concat(t);
  }

  var toDataURL = function toDataURL(e) {
    var t = arrayBufferToBinaryString(e),
        r = btoa(t);
    return "data:;base64,".concat(r);
  };

  function postWithAbortSignal(e, t, r) {
    var n = t.body,
        o = t.headers,
        i = void 0 === o ? {} : o,
        s = t.timeout,
        a = void 0 === s ? 1e4 : s,
        u = t.signal,
        l = (r || {}).useBinaryResponse,
        c = void 0 !== l && l,
        p = new XMLHttpRequest();
    p.open("POST", e, !0), p.responseType = c ? "arraybuffer" : "text", p.timeout = a;
    var f = n instanceof FormData,
        d = Object.keys(i).filter(function (e) {
      return "content-type" === e.toLowerCase();
    });
    if (d.length > 1) throw new RangeError("multiple content-type");
    if (delete i[d[0]], f || p.setRequestHeader("Content-Type", "application/json"), 0 !== Object.keys(i).length) for (var g = 0, h = Object.entries(i); g < h.length; g++) {
      var b = _slicedToArray$2(h[g], 2),
          y = b[0],
          _ = b[1];

      p.setRequestHeader(y, _);
    }

    if (void 0 !== u) {
      u.addEventListener("abort", function e() {
        p.abort(), u.removeEventListener("abort", e);
      });
    }

    return f ? p.send(n) : p.send(JSON.stringify(n)), new Promise(function (e, t) {
      p.onload = function () {
        var r = p.status;
        if (r >= 200 && r < 300 || 304 === r) e(c ? {
          status: r,
          responseData: p.response
        } : {
          status: r,
          responseText: p.responseText
        });else {
          var n = new RtmUnavailableError(["Post XHR failure, status %d", r]);
          n.statusCode = r, n.message = p.response || "Request failed, status ".concat(p.status), t(n);
        }
      }, p.ontimeout = function (e) {
        t(new RtmTimeoutError(["XHR request timed out after %d ms", a], {
          originalError: e
        }));
      }, p.onerror = function () {
        var e = new RtmUnavailableError(["Post XHR failure, status %d", p.status]);
        e.statusCode = p.status, e.message = p.response || "Request failed, status ".concat(p.status), t(e);
      }, p.onabort = function () {
        try {
          t(new DOMException("The request aborted.", "AbortError"));
        } catch (r) {
          var e = new Error("The request aborted.");
          e.name = "AbortError", t(e);
        }
      };
    });
  }

  function getImageSize(e, t) {
    return _getImageSize.apply(this, arguments);
  }

  function _getImageSize() {
    return (_getImageSize = _asyncToGenerator$1(regenerator.mark(function e(t, r) {
      var n, o, i, s, a, u, l, c, p, f, d, _g, h;

      return regenerator.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (_g = function g() {
                return (_g = _asyncToGenerator$1(regenerator.mark(function e(t) {
                  var r;
                  return regenerator.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          return (r = new Image()).src = t, e.abrupt("return", new Promise(function (e, t) {
                            r.onload = function () {
                              e({
                                width: r.width,
                                height: r.height
                              });
                            }, r.onerror = t;
                          }));

                        case 3:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e);
                }))).apply(this, arguments);
              }, d = function d(e) {
                return _g.apply(this, arguments);
              }, n = t.thumbnailHeight, o = void 0 === n ? 0 : n, i = t.thumbnailWidth, s = void 0 === i ? 0 : i, a = t.width, u = void 0 === a ? 0 : a, l = t.height, c = void 0 === l ? 0 : l, p = t.thumbnail, f = new Array(), "number" == typeof o && "number" == typeof s && "number" == typeof u && "number" == typeof c) {
                e.next = 7;
                break;
              }

              throw new RtmInvalidArgumentError("Invalid message params", UPLOAD_MEDIA_ERR_INVALID_ARGUMENT);

            case 7:
              return h = function h(e) {
                return d(toDataURL(e));
              }, u <= 0 && c <= 0 && f.push(h(r).then(function (e) {
                u = e.width, c = e.height;
              })), s <= 0 && o <= 0 && void 0 !== p && f.push(blobToArrayBuffer(p).then(function () {
                var e = _asyncToGenerator$1(regenerator.mark(function e(t) {
                  var r;
                  return regenerator.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          return e.next = 2, h(t);

                        case 2:
                          r = e.sent, s = r.width, o = r.height;

                        case 5:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e);
                }));

                return function (t) {
                  return e.apply(this, arguments);
                };
              }())), e.next = 12, Promise.all(f).catch(function () {});

            case 12:
              return e.abrupt("return", {
                width: u,
                height: c,
                thumbnailWidth: s,
                thumbnailHeight: o
              });

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }

  function validMessage(e, t) {
    if (!isPlainObject$1(e)) throw new RtmInvalidArgumentError("message object is not a plain object", t);
    if (void 0 === e.messageType) if (e.rawMessage instanceof Uint8Array) {
      if (e.messageType = "RAW", void 0 !== e.text) throw new RtmInvalidArgumentError("Raw messages cannot have text property. Use description instead", t);
    } else {
      if ("string" != typeof e.text) throw new RtmInvalidArgumentError("messageType is undefined", t);
      if (e.messageType = "TEXT", void 0 !== e.rawMessage) throw new RtmInvalidArgumentError("Text messages cannot have rawMessage property", t);
    }
  }

  function commonSendMessage(e) {
    return _commonSendMessage.apply(this, arguments);
  }

  function _commonSendMessage() {
    return (_commonSendMessage = _asyncToGenerator$1(regenerator.mark(function e(t) {
      var r, n, o, i, s, a, u, l, c, p, f, d, g, h, b, y, _, m, v, E, O;

      return regenerator.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (r = t.message, n = t.peerId, o = t.toPeer, i = t.session, s = t.errorCodes, a = t.diff, u = t.logger, l = t.options, void 0 !== i) {
                e.next = 3;
                break;
              }

              throw new RtmInvalidStatusError("The client is not logged in. Cannot do the operation", s.NOT_LOGGED_IN);

            case 3:
              if (c = !1, "TEXT" !== r.messageType || !r.text.startsWith(END_CALL_PREFIX) || !o) {
                e.next = 11;
                break;
              }

              if (p = r.text.split("_"), f = _slicedToArray$2(p, 3), d = f[0], g = f[1], void 0 !== f[2] && isValidId(g) && d === END_CALL_PREFIX) {
                e.next = 10;
                break;
              }

              throw new RtmInvalidArgumentError("Message is not valid", PEER_MESSAGE_ERR_INVALID_MESSAGE);

            case 10:
              c = !0;

            case 11:
              if (h = Date.now(), b = i.messageSentTimes.length - 1, !((y = i.messageSentTimes[b]) && y + 3e3 < h)) {
                e.next = 18;
                break;
              }

              i.messageSentTimes = [h], e.next = 29;
              break;

            case 18:
              _ = b;

            case 19:
              if (!(_ >= 0)) {
                e.next = 28;
                break;
              }

              if (!(i.messageSentTimes[_] + 3e3 < h)) {
                e.next = 23;
                break;
              }

              return i.messageSentTimes = i.messageSentTimes.slice(_ + 1, b + 1), e.abrupt("break", 28);

            case 23:
              if (!(b - _ + 1 >= 180)) {
                e.next = 25;
                break;
              }

              throw new RtmLimitExceededError("Message sent failed, exceeded the 180 message in 3 seconds", s.TOO_OFTEN);

            case 25:
              _--, e.next = 19;
              break;

            case 28:
              i.messageSentTimes.push(h);

            case 29:
              e.t0 = r.messageType, e.next = "TEXT" === e.t0 ? 32 : "RAW" === e.t0 ? 37 : "FILE" === e.t0 ? 39 : "IMAGE" === e.t0 ? 39 : 40;
              break;

            case 32:
              if (!c) {
                e.next = 36;
                break;
              }

              return m = r.text.split("_"), v = _slicedToArray$2(m, 3), E = v[1], O = v[2], u.info("[rtm-API] EndCall message send api is called"), e.abrupt("return", i.sendInvitationMessage({
                peerId: n,
                type: "CallCancel",
                extra: O,
                channelId: E,
                callId: "0"
              }));

            case 36:
              return e.abrupt("return", i.sendTextMessage(r.text, n, o, l, MESSAGE_SEND_TIMEOUT - a));

            case 37:
              return void 0 === r.description && (r.description = ""), e.abrupt("return", i.sendRawMessage(r.rawMessage, r.description, n, o, l, MESSAGE_SEND_TIMEOUT - a));

            case 39:
              return e.abrupt("return", i.sendMediaMessage(r.messageType, r, n, o, l, MESSAGE_SEND_TIMEOUT - a));

            case 40:
              throw new RtmInvalidArgumentError("Invalid message type", PEER_MESSAGE_ERR_INVALID_MESSAGE);

            case 41:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))).apply(this, arguments);
  }

  function getDomain(e) {
    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
        r = e.replace(/(https?:\/\/)?(www.)?/i, "");
    return t || (r = r.split(".").slice(e.length - 2).join(".")), -1 !== r.indexOf("/") ? r.split("/")[0] : r;
  }

  function omitDeepLodash(e, t) {
    function r(r) {
      if (void 0 === e) return e;
      if (!Array.isArray(r) && !isPlainObject$1(r)) return r;
      if (Array.isArray(r)) return omitDeepLodash(r, t);

      for (var n = {}, o = 0, i = Object.entries(r); o < i.length; o++) {
        var s = _slicedToArray$2(i[o], 2),
            a = s[0],
            u = s[1];

        n[a] = isNil_1(u) ? u : omitDeepLodash(u, t);
      }

      return omit_1(n, t);
    }

    return arguments.length > 2 && (t = Array.prototype.slice.call(arguments).slice(1)), Array.isArray(e) ? e.map(r) : r(e);
  }

  function deepFreeze(e) {
    return Object.getOwnPropertyNames(e).forEach(function (t) {
      var r = e[t];
      "object" == _typeof$2(r) && null !== r && deepFreeze(r);
    }), Object.freeze(e);
  }

  function decodeUint8ArrayToString(e) {
    return new TextDecoder("utf-8").decode(e.buffer.slice(e.byteOffset, e.byteOffset + e.byteLength));
  }

  var isProd = !0,
      key$2 = "__global_unique_id__",
      gud = function gud() {
    return commonjsGlobal[key$2] = (commonjsGlobal[key$2] || 0) + 1;
  };

  _export(_export.S, "Reflect", {
    has: function has(e, t) {
      return t in e;
    }
  });

  var umd = createCommonjsModule(function (e, t) {
    !function (e) {
      var t = function t(e) {
        return "undefined" != typeof self && self && e in self ? self[e] : "undefined" != typeof window && window && e in window ? window[e] : void 0 !== commonjsGlobal && commonjsGlobal && e in commonjsGlobal ? commonjsGlobal[e] : "undefined" != typeof globalThis && globalThis ? globalThis[e] : void 0;
      },
          r = t("document"),
          n = t("Headers"),
          o = t("Response"),
          i = t("ReadableStream"),
          s = t("fetch"),
          a = t("AbortController"),
          u = t("FormData"),
          l = function l(e) {
        return null !== e && "object" === _typeof(e);
      },
          c = "function" == typeof a,
          p = "function" == typeof i,
          f = "function" == typeof u,
          d = function e() {
        for (var t = {}, r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
          n[o] = arguments[o];
        }

        for (var i = 0, s = n; i < s.length; i++) {
          var a = s[i];
          if (Array.isArray(a)) Array.isArray(t) || (t = []), t = [].concat(_toConsumableArray(t), _toConsumableArray(a));else if (l(a)) for (var u = 0, c = Object.entries(a); u < c.length; u++) {
            var p = _slicedToArray(c[u], 2),
                f = p[0],
                d = p[1];

            l(d) && Reflect.has(t, f) && (d = e(t[f], d)), t = _objectSpread2({}, t, _defineProperty({}, f, d));
          }
        }

        return t;
      },
          g = ["get", "post", "put", "patch", "head", "delete"],
          h = {
        json: "application/json",
        text: "text/*",
        formData: "multipart/form-data",
        arrayBuffer: "*/*",
        blob: "*/*"
      },
          b = new Set(["get", "put", "head", "delete", "options", "trace"]),
          y = new Set([408, 413, 429, 500, 502, 503, 504]),
          _ = new Set([413, 429, 503]),
          m = function (e) {
        function t(e) {
          var r;
          return _classCallCheck(this, t), (r = _possibleConstructorReturn(this, _getPrototypeOf(t).call(this, e.statusText))).name = "HTTPError", r.response = e, r;
        }

        return _inherits(t, e), t;
      }(_wrapNativeSuper(Error)),
          v = function (e) {
        function t() {
          var e;
          return _classCallCheck(this, t), (e = _possibleConstructorReturn(this, _getPrototypeOf(t).call(this, "Request timed out"))).name = "TimeoutError", e;
        }

        return _inherits(t, e), t;
      }(_wrapNativeSuper(Error)),
          E = function E(e) {
        return new Promise(function (t, r) {
          e > 2147483647 ? r(new RangeError("The `timeout` option cannot be greater than 2147483647")) : setTimeout(t, e);
        });
      },
          O = function O(e, t, r) {
        return new Promise(function (n, o) {
          e.then(n).catch(o), E(t).then(function () {
            c && r.abort(), o(new v());
          }).catch(o);
        });
      },
          I = function I(e) {
        return g.includes(e) ? e.toUpperCase() : e;
      },
          $ = function () {
        function e(t, i) {
          var s = this,
              l = i.timeout,
              g = void 0 === l ? 1e4 : l,
              y = i.hooks,
              _ = i.throwHttpErrors,
              v = void 0 === _ || _,
              O = i.searchParams,
              $ = i.json,
              S = _objectWithoutProperties(i, ["timeout", "hooks", "throwHttpErrors", "searchParams", "json"]);

          if (_classCallCheck(this, e), this._retryCount = 0, this._options = _objectSpread2({
            method: "get",
            credentials: "same-origin",
            retry: 2
          }, S), c && (this.abortController = new a(), this._options.signal && this._options.signal.addEventListener("abort", function () {
            s.abortController.abort();
          }), this._options.signal = this.abortController.signal), this._options.method = I(this._options.method), this._options.prefixUrl = String(this._options.prefixUrl || ""), this._input = String(t || ""), this._options.prefixUrl && this._input.startsWith("/")) throw new Error("`input` must not begin with a slash when using `prefixUrl`");

          if (this._options.prefixUrl && !this._options.prefixUrl.endsWith("/") && (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input, O) {
            var w = new URL(this._input, r && r.baseURI);
            if ("string" == typeof O || URLSearchParams && O instanceof URLSearchParams) w.search = O;else {
              if (!Object.values(O).every(function (e) {
                return "number" == typeof e || "string" == typeof e;
              })) throw new Error("The `searchParams` option must be either a string, `URLSearchParams` instance or an object with string and number values");
              w.search = new URLSearchParams(O).toString();
            }
            this._input = w.toString();
          }

          this._timeout = g, this._hooks = d({
            beforeRequest: [],
            afterResponse: []
          }, y), this._throwHttpErrors = v;
          var R = new n(this._options.headers || {});
          if ((f && this._options.body instanceof u || this._options.body instanceof URLSearchParams) && R.has("content-type")) throw new Error("The `content-type` header cannot be used with a ".concat(this._options.body.constructor.name, " body. It will be set automatically."));

          if ($) {
            if (this._options.body) throw new Error("The `json` option cannot be used with the `body` option");
            R.set("content-type", "application/json"), this._options.body = JSON.stringify($);
          }

          this._options.headers = R;

          for (var A, T = (A = _asyncToGenerator(regenerator.mark(function e() {
            var t, r, n, i, a, u, l;
            return regenerator.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, E(1);

                  case 2:
                    return e.next = 4, s._fetch();

                  case 4:
                    t = e.sent, r = s._hooks.afterResponse, n = Array.isArray(r), i = 0, r = n ? r : r[Symbol.iterator]();

                  case 6:
                    if (!n) {
                      e.next = 12;
                      break;
                    }

                    if (!(i >= r.length)) {
                      e.next = 9;
                      break;
                    }

                    return e.abrupt("break", 23);

                  case 9:
                    a = r[i++], e.next = 16;
                    break;

                  case 12:
                    if (!(i = r.next()).done) {
                      e.next = 15;
                      break;
                    }

                    return e.abrupt("break", 23);

                  case 15:
                    a = i.value;

                  case 16:
                    return u = a, e.next = 19, u(t.clone());

                  case 19:
                    (l = e.sent) instanceof o && (t = l);

                  case 21:
                    e.next = 6;
                    break;

                  case 23:
                    if (t.ok || !s._throwHttpErrors) {
                      e.next = 25;
                      break;
                    }

                    throw new m(t);

                  case 25:
                    if (!s._options.onDownloadProgress) {
                      e.next = 31;
                      break;
                    }

                    if ("function" == typeof s._options.onDownloadProgress) {
                      e.next = 28;
                      break;
                    }

                    throw new TypeError("The `onDownloadProgress` option must be a function");

                  case 28:
                    if (p) {
                      e.next = 30;
                      break;
                    }

                    throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");

                  case 30:
                    return e.abrupt("return", s._stream(t.clone(), s._options.onDownloadProgress));

                  case 31:
                    return e.abrupt("return", t);

                  case 32:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          })), function () {
            return A.apply(this, arguments);
          }), N = b.has(this._options.method.toLowerCase()), L = N ? this._retry(T) : T(), P = function P() {
            var e = _slicedToArray(k[C], 2),
                t = e[0],
                r = e[1];

            L[t] = _asyncToGenerator(regenerator.mark(function e() {
              return regenerator.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return R.set("accept", r), e.next = 3, L;

                    case 3:
                      return e.t0 = t, e.abrupt("return", e.sent.clone()[e.t0]());

                    case 5:
                    case "end":
                      return e.stop();
                  }
                }
              }, e);
            }));
          }, C = 0, k = Object.entries(h); C < k.length; C++) {
            P();
          }

          return L;
        }

        return _createClass(e, [{
          key: "_calculateRetryDelay",
          value: function value(e) {
            if (this._retryCount++, this._retryCount < this._options.retry && !(e instanceof v)) {
              if (e instanceof m) {
                if (!y.has(e.response.status)) return 0;
                var t = e.response.headers.get("Retry-After");

                if (t && _.has(e.response.status)) {
                  var r = Number(t);
                  return Number.isNaN(r) ? r = Date.parse(t) - Date.now() : r *= 1e3, r;
                }

                if (413 === e.response.status) return 0;
              }

              return .3 * Math.pow(2, this._retryCount - 1) * 1e3;
            }

            return 0;
          }
        }, {
          key: "_retry",
          value: (l = _asyncToGenerator(regenerator.mark(function e(t) {
            var r;
            return regenerator.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.prev = 0, e.next = 3, t();

                  case 3:
                    return e.abrupt("return", e.sent);

                  case 6:
                    if (e.prev = 6, e.t0 = e.catch(0), !(0 !== (r = this._calculateRetryDelay(e.t0)) && this._retryCount > 0)) {
                      e.next = 13;
                      break;
                    }

                    return e.next = 12, E(r);

                  case 12:
                    return e.abrupt("return", this._retry(t));

                  case 13:
                    if (!this._throwHttpErrors) {
                      e.next = 15;
                      break;
                    }

                    throw e.t0;

                  case 15:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[0, 6]]);
          })), function (e) {
            return l.apply(this, arguments);
          })
        }, {
          key: "_fetch",
          value: (t = _asyncToGenerator(regenerator.mark(function e() {
            var t, r, n, o, i;
            return regenerator.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    t = this._hooks.beforeRequest, r = Array.isArray(t), n = 0, t = r ? t : t[Symbol.iterator]();

                  case 1:
                    if (!r) {
                      e.next = 7;
                      break;
                    }

                    if (!(n >= t.length)) {
                      e.next = 4;
                      break;
                    }

                    return e.abrupt("break", 16);

                  case 4:
                    o = t[n++], e.next = 11;
                    break;

                  case 7:
                    if (!(n = t.next()).done) {
                      e.next = 10;
                      break;
                    }

                    return e.abrupt("break", 16);

                  case 10:
                    o = n.value;

                  case 11:
                    return i = o, e.next = 14, i(this._options);

                  case 14:
                    e.next = 1;
                    break;

                  case 16:
                    if (!1 !== this._timeout) {
                      e.next = 18;
                      break;
                    }

                    return e.abrupt("return", s(this._input, this._options));

                  case 18:
                    return e.abrupt("return", O(s(this._input, this._options), this._timeout, this.abortController));

                  case 19:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function () {
            return t.apply(this, arguments);
          })
        }, {
          key: "_stream",
          value: function value(e, t) {
            var r = Number(e.headers.get("content-length")) || 0,
                n = 0;
            return new o(new i({
              start: function start(o) {
                var i = e.body.getReader();

                function s() {
                  return a.apply(this, arguments);
                }

                function a() {
                  return (a = _asyncToGenerator(regenerator.mark(function e() {
                    var a, u, l;
                    return regenerator.wrap(function (e) {
                      for (;;) {
                        switch (e.prev = e.next) {
                          case 0:
                            return e.next = 2, i.read();

                          case 2:
                            if (a = e.sent, u = a.done, l = a.value, !u) {
                              e.next = 8;
                              break;
                            }

                            return o.close(), e.abrupt("return");

                          case 8:
                            t && (n += l.byteLength, t({
                              percent: 0 === r ? 0 : n / r,
                              transferredBytes: n,
                              totalBytes: r
                            }, l)), o.enqueue(l), s();

                          case 11:
                          case "end":
                            return e.stop();
                        }
                      }
                    }, e);
                  }))).apply(this, arguments);
                }

                t && t({
                  percent: 0,
                  transferredBytes: 0,
                  totalBytes: r
                }, new Uint8Array()), s();
              }
            }));
          }
        }]), e;
        var t, l;
      }(),
          S = function S() {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }

        for (var n = 0, o = t; n < o.length; n++) {
          var i = o[n];
          if ((!l(i) || Array.isArray(i)) && void 0 !== i) throw new TypeError("The `options` argument must be an object");
        }

        return d.apply(void 0, [{}].concat(t));
      },
          w = function e(t) {
        for (var r = function r(e, _r3) {
          return new $(e, S(t, _r3));
        }, n = function n() {
          var e = i[o];

          r[e] = function (r, n) {
            return new $(r, S(t, n, {
              method: e
            }));
          };
        }, o = 0, i = g; o < i.length; o++) {
          n();
        }

        return r.create = function (t) {
          return e(S(t));
        }, r.extend = function (r) {
          return e(S(t, r));
        }, r;
      }();

      e.HTTPError = m, e.TimeoutError = v, e.default = w, Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }(t);
  }),
      ky = unwrapExports(umd),
      hasProp = Object.prototype.hasOwnProperty;

  function throwsMessage(e) {
    return "[Throws: " + (e ? e.message : "?") + "]";
  }

  function safeGetValueFromPropertyOnObject(e, t) {
    if (hasProp.call(e, t)) try {
      return e[t];
    } catch (e) {
      return throwsMessage(e);
    }
    return e[t];
  }

  function ensureProperties(e) {
    var t = [];
    return function e(r) {
      if (null === r || "object" !== _typeof(r)) return r;
      if (-1 !== t.indexOf(r)) return "[Circular]";
      if (t.push(r), "function" == typeof r.toJSON) try {
        var n = e(r.toJSON());
        return t.pop(), n;
      } catch (e) {
        return throwsMessage(e);
      }

      if (Array.isArray(r)) {
        var o = r.map(e);
        return t.pop(), o;
      }

      var i = Object.keys(r).reduce(function (t, n) {
        return t[n] = e(safeGetValueFromPropertyOnObject(r, n)), t;
      }, {});
      return t.pop(), i;
    }(e);
  }

  var safeJsonStringify = function safeJsonStringify(e, t, r) {
    return JSON.stringify(ensureProperties(e), t, r);
  },
      ensureProperties_1 = ensureProperties;

  safeJsonStringify.ensureProperties = ensureProperties_1;

  var s = 1e3,
      m = 60 * s,
      h = 60 * m,
      d = 24 * h,
      w = 7 * d,
      y = 365.25 * d,
      ms = function ms(e, t) {
    t = t || {};

    var r = _typeof(e);

    if ("string" === r && e.length > 0) return parse(e);
    if ("number" === r && !1 === isNaN(e)) return t.long ? fmtLong(e) : fmtShort(e);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e));
  };

  function parse(e) {
    if (!((e = String(e)).length > 100)) {
      var t = /^((?:\d+)?\-?\d?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(e);

      if (t) {
        var r = parseFloat(t[1]);

        switch ((t[2] || "ms").toLowerCase()) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return r * y;

          case "weeks":
          case "week":
          case "w":
            return r * w;

          case "days":
          case "day":
          case "d":
            return r * d;

          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return r * h;

          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return r * m;

          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return r * s;

          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return r;

          default:
            return;
        }
      }
    }
  }

  function fmtShort(e) {
    var t = Math.abs(e);
    return t >= d ? Math.round(e / d) + "d" : t >= h ? Math.round(e / h) + "h" : t >= m ? Math.round(e / m) + "m" : t >= s ? Math.round(e / s) + "s" : e + "ms";
  }

  function fmtLong(e) {
    var t = Math.abs(e);
    return t >= d ? plural(e, t, d, "day") : t >= h ? plural(e, t, h, "hour") : t >= m ? plural(e, t, m, "minute") : t >= s ? plural(e, t, s, "second") : e + " ms";
  }

  function plural(e, t, r, n) {
    var o = t >= 1.5 * r;
    return Math.round(e / r) + " " + n + (o ? "s" : "");
  }

  function _toConsumableArray$2(e) {
    return _arrayWithoutHoles$2(e) || _iterableToArray$2(e) || _nonIterableSpread$2();
  }

  function _nonIterableSpread$2() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray$2(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _arrayWithoutHoles$2(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  function setup(e) {
    function t(e) {
      for (var t = 0, n = 0; n < e.length; n++) {
        t = (t << 5) - t + e.charCodeAt(n), t |= 0;
      }

      return r.colors[Math.abs(t) % r.colors.length];
    }

    function r(e) {
      var o,
          i = null;

      function s() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        if (s.enabled) {
          var i = s,
              a = Number(new Date()),
              u = a - (o || a);
          i.diff = u, i.prev = o, i.curr = a, o = a, t[0] = r.coerce(t[0]), "string" != typeof t[0] && t.unshift("%O");
          var l = 0;
          t[0] = t[0].replace(/%([a-zA-Z%])/g, function (e, n) {
            if ("%%" === e) return e;
            l++;
            var o = r.formatters[n];

            if ("function" == typeof o) {
              var s = t[l];
              e = o.call(i, s), t.splice(l, 1), l--;
            }

            return e;
          }), r.formatArgs.call(i, t), (i.log || r.log).apply(i, t);
        }
      }

      return s.namespace = e, s.useColors = r.useColors(), s.color = t(e), s.extend = n, s.destroy = r.destroy, Object.defineProperty(s, "enabled", {
        enumerable: !0,
        configurable: !1,
        get: function get() {
          return null === i ? r.enabled(e) : i;
        },
        set: function set(e) {
          i = e;
        }
      }), "function" == typeof r.init && r.init(s), s;
    }

    function n(e, t) {
      var n = r(this.namespace + (void 0 === t ? ":" : t) + e);
      return n.log = this.log, n;
    }

    function o(e) {
      return e.toString().substring(2, e.toString().length - 2).replace(/\.\*\?$/, "*");
    }

    return r.debug = r, r.default = r, r.coerce = function (e) {
      if (e instanceof Error) return e.stack || e.message;
      return e;
    }, r.disable = function () {
      var e = [].concat(_toConsumableArray$2(r.names.map(o)), _toConsumableArray$2(r.skips.map(o).map(function (e) {
        return "-" + e;
      }))).join(",");
      return r.enable(""), e;
    }, r.enable = function (e) {
      var t;
      r.save(e), r.names = [], r.skips = [];
      var n = ("string" == typeof e ? e : "").split(/[\s,]+/),
          o = n.length;

      for (t = 0; t < o; t++) {
        n[t] && ("-" === (e = n[t].replace(/\*/g, ".*?"))[0] ? r.skips.push(new RegExp("^" + e.substr(1) + "$")) : r.names.push(new RegExp("^" + e + "$")));
      }
    }, r.enabled = function (e) {
      if ("*" === e[e.length - 1]) return !0;
      var t, n;

      for (t = 0, n = r.skips.length; t < n; t++) {
        if (r.skips[t].test(e)) return !1;
      }

      for (t = 0, n = r.names.length; t < n; t++) {
        if (r.names[t].test(e)) return !0;
      }

      return !1;
    }, r.humanize = ms, r.destroy = function () {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }, Object.keys(e).forEach(function (t) {
      r[t] = e[t];
    }), r.names = [], r.skips = [], r.formatters = {}, r.selectColor = t, r.enable(r.load()), r;
  }

  var common = setup,
      browser = createCommonjsModule(function (e, t) {
    var r;
    t.formatArgs = function (t) {
      if (t[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + t[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors) return;
      var r = "color: " + this.color;
      t.splice(1, 0, r, "color: inherit");
      var n = 0,
          o = 0;
      t[0].replace(/%[a-zA-Z%]/g, function (e) {
        "%%" !== e && (n++, "%c" === e && (o = n));
      }), t.splice(o, 0, r);
    }, t.save = function (e) {
      try {
        e ? t.storage.setItem("debug", e) : t.storage.removeItem("debug");
      } catch (e) {}
    }, t.load = function () {
      var e;

      try {
        e = t.storage.getItem("debug");
      } catch (e) {}

      !e && "undefined" != typeof process && "env" in process && (e = process.env.DEBUG);
      return e;
    }, t.useColors = function () {
      if ("undefined" != typeof window && window.process && ("renderer" === window.process.type || window.process.__nwjs)) return !0;
      if ("undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
      return "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }, t.storage = function () {
      try {
        return localStorage;
      } catch (e) {}
    }(), t.destroy = (r = !1, function () {
      r || (r = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    }), t.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], t.log = console.debug || console.log || function () {}, e.exports = common(t), e.exports.formatters.j = function (e) {
      try {
        return JSON.stringify(e);
      } catch (e) {
        return "[UnexpectedJSONParseError]: " + e.message;
      }
    };
  }),
      browser_1 = browser.formatArgs,
      browser_2 = browser.save,
      browser_3 = browser.load,
      browser_4 = browser.useColors,
      browser_5 = browser.storage,
      browser_6 = browser.destroy,
      browser_7 = browser.colors,
      browser_8 = browser.log;

  function asyncGeneratorStep$2(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$2(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$2(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$2(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  function _classCallCheck$2(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties$1(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$1(e, t, r) {
    return t && _defineProperties$1(e.prototype, t), r && _defineProperties$1(e, r), e;
  }

  var uploadLog = browser("RTM:DEBUG"),
      UploadState;
  uploadLog.enabled = !isProd, function (e) {
    e[e.Uploading = 0] = "Uploading", e[e.Free = 1] = "Free";
  }(UploadState || (UploadState = {}));

  var LogUploader = function () {
    function e(t) {
      _classCallCheck$2(this, e), this.uploadRequest = void 0, this.uploadState = void 0, this.uploadResendCount = void 0, this.LogCache = void 0, this.LogsToPost = void 0, this.processId = void 0, this.sdkVersion = void 0, this.logId = void 0, this.processId = t.processId, this.sdkVersion = t.sdkVersion, this.uploadRequest = t.uploadRequest, this.uploadState = UploadState.Free, this.uploadResendCount = 0, this.LogCache = [], this.LogsToPost = [], this.logId = 0;
    }

    return _createClass$1(e, [{
      key: "upload",
      value: function value(e, t) {
        this.LogCache.push(e), this.uploadState === UploadState.Free && (this.LogsToPost = this.LogCache.length < LOG_UPLOAD_MAX_ITEMS ? this.LogCache.splice(0, this.LogCache.length) : this.LogCache.splice(0, LOG_UPLOAD_MAX_ITEMS), this.postLog(this.LogsToPost, t));
      }
    }, {
      key: "postLog",
      value: function value(e, t) {
        var r = this;
        this.uploadState = UploadState.Uploading, setTimeout(_asyncToGenerator$2(regenerator.mark(function n() {
          var o, i;
          return regenerator.wrap(function (n) {
            for (;;) {
              switch (n.prev = n.next) {
                case 0:
                  return o = {
                    sdk_version: r.sdkVersion,
                    process_id: r.processId,
                    payload: JSON.stringify(e)
                  }, n.prev = 1, n.next = 4, r.uploadRequest(o, t);

                case 4:
                  n.next = 11;
                  break;

                case 6:
                  return n.prev = 6, n.t0 = n.catch(1), i = r.uploadResendCount++ < 2 ? 200 : 1e4, setTimeout(function () {
                    return r.postLog(r.LogsToPost, t);
                  }, i), n.abrupt("return");

                case 11:
                  if (uploadLog('The logs uploaded for "process-'.concat(processId, '"')), 0 !== r.LogCache.length) {
                    n.next = 15;
                    break;
                  }

                  return r.uploadState = UploadState.Free, n.abrupt("return");

                case 15:
                  r.uploadResendCount = 0, r.LogsToPost = r.LogCache.length < LOG_UPLOAD_MAX_ITEMS ? r.LogCache.splice(0, r.LogCache.length) : r.LogCache.splice(0, LOG_UPLOAD_MAX_ITEMS), r.postLog(r.LogsToPost, t);

                case 18:
                case "end":
                  return n.stop();
              }
            }
          }, n, null, [[1, 6]]);
        })), 3e3);
      }
    }]), e;
  }();

  function _classCallCheck$3(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _possibleConstructorReturn$2(e, t) {
    return !t || "object" !== _typeof$3(t) && "function" != typeof t ? _assertThisInitialized$2(e) : t;
  }

  function _getPrototypeOf$2(e) {
    return (_getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _assertThisInitialized$2(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _inherits$2(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$2(e, t);
  }

  function _setPrototypeOf$2(e, t) {
    return (_setPrototypeOf$2 = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function _toConsumableArray$3(e) {
    return _arrayWithoutHoles$3(e) || _iterableToArray$3(e) || _nonIterableSpread$3();
  }

  function _nonIterableSpread$3() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray$3(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _arrayWithoutHoles$3(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  function _typeof$3(e) {
    return (_typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function asyncGeneratorStep$3(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$3(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$3(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$3(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  var LOG_SERVICE_MAIN_DOMAIN = "logservice-rtm.agora.io",
      LOG_SERVICE_BACKUP_DOMAIN = "logservice-rtm.agoraio.cn",
      uploadRequest = function () {
    var e = _asyncToGenerator$3(regenerator.mark(function e(t, r) {
      var n, o, i;
      return regenerator.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              e.next = 2;
              break;

            case 2:
              return n = {
                mode: "cors",
                cache: "no-cache",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(t),
                retry: 1,
                timeout: 1e4
              }, e.prev = 3, o = "https://".concat((null == r ? void 0 : r.LOG_UPLOAD_SERVER[0]) || LOG_SERVICE_MAIN_DOMAIN, "/upload/v1"), e.next = 7, ky.post(o, n);

            case 7:
              e.next = 14;
              break;

            case 9:
              return e.prev = 9, e.t0 = e.catch(3), i = "https://".concat((null == r ? void 0 : r.LOG_UPLOAD_SERVER[0]) || LOG_SERVICE_BACKUP_DOMAIN, "/upload/v1"), e.next = 14, ky.post(i, n);

            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[3, 9]]);
    }));

    return function (t, r) {
      return e.apply(this, arguments);
    };
  }(),
      logUploader = new LogUploader({
    processId: "process-".concat(processId),
    sdkVersion: "Agora_RTM_SDK_for_Web_".concat(BUILD),
    uploadRequest: uploadRequest
  }),
      blacklistedKeywords = ["text", "payload", "rawMessage", "thumbnail", "token", "detail", "ticket", "attributeInfos"],
      filterLogObject = function filterLogObject(e) {
    return omitDeepLodash(e, blacklistedKeywords);
  },
      getPlain = function getPlain(e) {
    return "object" === _typeof$3(e) ? isPlainObject$1(e) ? filterLogObject(e) : e.constructor && e.constructor.name : e;
  },
      formatLogTextAndParameters = function formatLogTextAndParameters(e, t) {
    if (e instanceof Error) return e.message;
    if ("string" != typeof e) return JSON.stringify(filterLogObject(e));
    var r = t.map(function (e) {
      return e instanceof Error ? e.message : "object" === _typeof$3(e) ? safeJsonStringify(Array.isArray(e) ? e.map(getPlain) : getPlain(e)) : e;
    });
    return util_1.apply(void 0, [e.replace(/%[%Oo]/g, function (e) {
      return "%%" === e ? "%" : "%o" === e || "%O" === e ? "%s" : e;
    })].concat(_toConsumableArray$3(r)));
  },
      logItemId = 1,
      logAndUploadGenerator = function logAndUploadGenerator(e, t, r) {
    var n = browser(e);
    n.enabled = !0, n.log = r, n.useColors = !1;
    return function (r) {
      for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++) {
        i[s - 1] = arguments[s];
      }

      if (t.enableLogUpload) {
        var a = addPeriodIfNeeded(r),
            u = formatLogTextAndParameters(a, i);
        logUploader.upload({
          log_item_id: "".concat(logItemId++),
          log_level: e,
          payload_str: "[".concat(getUTCTimestamp(), "] ").concat(e, " - ").concat(u.length > 256 ? u.slice(0, 256) : u)
        }, t._areaConfig);
      }

      var l = function l() {
        var e = u || formatLogTextAndParameters(addPeriodIfNeeded(r), i);
        n(e);
      };

      switch (e) {
        case "RTM:INFO":
          t.logFilter.info && l();
          break;

        case "RTM:WARN":
          t.logFilter.warn && l();
          break;

        case "RTM:ERROR":
          t.logFilter.error && l();
          break;

        case "RTM:TRACK":
          t.logFilter.track && l();
          break;

        case "RTM:MSG:RECV":
        case "RTM:MSG:SEND":
        case "RTM:DEBUG":
          t.logFilter.debug && l();
      }
    };
  },
      loggerId,
      prefixer = function prefixer(e) {
    return function (t) {
      var r = 1 === loggerId || void 0 === e ? "" : "Ins#".concat(e, " ");
      return "".concat(r).concat(t);
    };
  },
      loggerGenerator = function loggerGenerator(e, t, r) {
    var n = prefixer(loggerId);
    return logAndUploadGenerator("RTM:".concat(t), r, function (t) {
      return e(n(t));
    });
  },
      createEventBase = function createEventBase() {
    return function (e) {
      function t(e, r) {
        var n,
            o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];

        if (_classCallCheck$3(this, t), (n = _possibleConstructorReturn$2(this, _getPrototypeOf$2(t).call(this))).logger = e, n.name = r, n.logError = void 0, n.invokeTracker = void 0, n.resultTracker = void 0, n.errorTracker = void 0, n.eventTracker = void 0, n.info = void 0, n.warn = void 0, n.log = void 0, n.genLogger = void 0, n.loggerId = void 0, n.loggerId = e.loggerId, n.info = e.info, n.warn = e.warn, n.logError = e.logError, n.genLogger = e.genLogger, n.log = e.genLogger("RTM:DEBUG", "<".concat(r, "> ")), n.invokeTracker = e.genTracker("Invoke"), n.eventTracker = e.genTracker("Event"), n.resultTracker = e.genTracker("Result"), n.errorTracker = e.genTracker("Error"), o) {
          var i = n.emit.bind(_assertThisInitialized$2(n));

          n.emit = function () {
            for (var e, t = arguments.length, o = new Array(t), s = 0; s < t; s++) {
              o[s] = arguments[s];
            }

            var a = o[0],
                u = o.slice(1);
            (e = n).eventTracker.apply(e, ["%s: ".concat(u.length > 0 ? "%s emitted with args: ".concat(u.map(function () {
              return "%o";
            })) : "%s emitted"), r, a].concat(_toConsumableArray$3(u)));

            try {
              i.apply(void 0, o);
            } catch (e) {
              n.logError("Caught in the callback function of the event %s", a, e);
            }
          };
        }

        return n;
      }

      return _inherits$2(t, events), t;
    }();
  };

  function initLoggerId() {
    return loggerId = gud();
  }

  var genInfoLogger = function genInfoLogger(e) {
    return loggerGenerator(console.log, "INFO", e);
  },
      genWarnLogger = function genWarnLogger(e) {
    return loggerGenerator(console.warn, "WARN", e);
  },
      genErrorLogger = function genErrorLogger(e) {
    return loggerGenerator(console.error, "ERROR", e);
  },
      debugLoggerGenerator = function debugLoggerGenerator(e, t) {
    return function (r) {
      var n,
          o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          i = prefixer(e),
          s = null !== (n = console.debug) && void 0 !== n ? n : console.log,
          a = logAndUploadGenerator(r, t, function (e) {
        return s(i(e));
      });
      return function (e) {
        for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
          r[n - 1] = arguments[n];
        }

        return a.apply(void 0, [o + e].concat(r));
      };
    };
  },
      trackLoggerGenerator = function trackLoggerGenerator(e, t) {
    return function (r) {
      return debugLoggerGenerator(e, t)("RTM:TRACK", "[".concat(r, "] "));
    };
  };

  function logged(e, t, r) {
    var n = r;
    void 0 === n && (n = Object.getOwnPropertyDescriptor(e, t));
    var o = n.value;
    return n.value = function () {
      for (var e = this, r = arguments.length, n = new Array(r), i = 0; i < r; i++) {
        n[i] = arguments[i];
      }

      this.invokeTracker.apply(this, ["%s: ".concat(n.length > 0 ? "%s with args: ".concat(n.map(function () {
        return "%o";
      })) : "%s"), this.name, t].concat(n));

      try {
        var s = o.apply(this, n);
      } catch (e) {
        throw this.logError.apply(this, ["".concat(void 0 !== e.code ? "Error Code ".concat(e.code, ": ") : "", "%s failed").concat(n.length > 0 ? " with args: ".concat(n.map(function () {
          return "%o";
        })) : ""), t].concat(n)), e.originalError && this.logError(e.originalError), this.errorTracker(e), e;
      }

      var a = Date.now();
      return _asyncToGenerator$3(regenerator.mark(function r() {
        var o;
        return regenerator.wrap(function (r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                return r.prev = 0, r.next = 3, s;

              case 3:
                o = r.sent, r.next = 12;
                break;

              case 6:
                return r.prev = 6, r.t0 = r.catch(0), e.logError.apply(e, ["".concat(void 0 !== r.t0.code ? "Error Code ".concat(r.t0.code, ": ") : "", "%s failed").concat(n.length > 0 ? " with args: ".concat(n.map(function () {
                  return "%o";
                })) : ""), t].concat(n)), r.t0.originalError && e.logError(r.t0.originalError), e.errorTracker(r.t0), r.abrupt("return");

              case 12:
                o !== s ? void 0 === o ? e.resultTracker("%s promise resolves after %dms", t, Date.now() - a) : e.resultTracker("%s promise resolves after %dms, result is %o", t, Date.now() - a, o) : e.resultTracker("%s result is %o", t, o);

              case 13:
              case "end":
                return r.stop();
            }
          }
        }, r, null, [[0, 6]]);
      }))(), s;
    }, n;
  }

  function _objectWithoutProperties$1(e, t) {
    if (null == e) return {};

    var r,
        n,
        o = _objectWithoutPropertiesLoose$1(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (n = 0; n < i.length; n++) {
        r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }
    }

    return o;
  }

  function _objectWithoutPropertiesLoose$1(e, t) {
    if (null == e) return {};
    var r,
        n,
        o = {},
        i = Object.keys(e);

    for (n = 0; n < i.length; n++) {
      r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
    }

    return o;
  }

  var URI = $root.URI,
      Wrapper$2 = Wrapper$1,
      PacketsAndURI = _objectWithoutProperties$1(ProtoPackets, ["Wrapper"]),
      Packets = omit_1(PacketsAndURI, "URI"),
      nameToUri = function nameToUri(e) {
    var t = "".concat(e, "Uri"),
        r = URI[t];
    if ("number" != typeof r || 0 === r) throw new TypeError("Got Unknown URI Name");
    return r;
  };

  function uriToPacketName(e) {
    return URI[e].slice(0, -3);
  }

  function getWrappedByName(e, t) {
    var r = nameToUri(e),
        n = Packets[e],
        o = n.verify(t);
    if (null !== o) throw new TypeError(o);
    var i = new n(t),
        s = n.encode(i).finish();
    return new Wrapper$2({
      uri: r,
      data: s
    });
  }

  var nativeFloor = Math.floor,
      nativeRandom = Math.random;

  function baseRandom(e, t) {
    return e + nativeFloor(nativeRandom() * (t - e + 1));
  }

  var _baseRandom = baseRandom;

  function shuffleSelf(e, t) {
    var r = -1,
        n = e.length,
        o = n - 1;

    for (t = void 0 === t ? n : t; ++r < t;) {
      var i = _baseRandom(r, o),
          s = e[i];

      e[i] = e[r], e[r] = s;
    }

    return e.length = t, e;
  }

  var _shuffleSelf = shuffleSelf;

  function arrayShuffle(e) {
    return _shuffleSelf(_copyArray(e));
  }

  var _arrayShuffle = arrayShuffle;

  function baseValues(e, t) {
    return _arrayMap(t, function (t) {
      return e[t];
    });
  }

  var _baseValues = baseValues;

  function values(e) {
    return null == e ? [] : _baseValues(e, keys_1(e));
  }

  var values_1 = values;

  function baseShuffle(e) {
    return _shuffleSelf(values_1(e));
  }

  var _baseShuffle = baseShuffle;

  function shuffle(e) {
    return (isArray_1(e) ? _arrayShuffle : _baseShuffle)(e);
  }

  var shuffle_1 = shuffle;

  function _toConsumableArray$4(e) {
    return _arrayWithoutHoles$4(e) || _iterableToArray$4(e) || _nonIterableSpread$4();
  }

  function _nonIterableSpread$4() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray$4(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _arrayWithoutHoles$4(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  var AP_DOMAINS_CN = ["ap-web-1.agoraio.cn", "ap-web-2.agoraio.cn"],
      AP_DOMAINS_IO = ["ap-web-1.agora.io", "ap-web-2.agora.io"],
      AP_BACKUP_DOMAINS_CN = ["ap-web-3.agoraio.cn", "ap-web-4.agoraio.cn"],
      AP_BACKUP_DOMAINS_IO = ["ap-web-3.agora.io", "ap-web-4.agora.io"],
      EDGE_ENV_PORT = {
    0: 9591,
    1: 9593
  },
      getApUrl = function getApUrl(e) {
    return "https://".concat(e, "/api/v1");
  };

  function getEdgeDomain(e, t) {
    var r = t ? "agoraio.cn" : "agora.io";
    return "".concat(e.split(".").join("-"), ".edge.").concat(r);
  }

  var cnUrl$ = of.apply(void 0, _toConsumableArray$4(shuffle_1(AP_DOMAINS_CN.map(getApUrl)))),
      ioUrl$ = of.apply(void 0, _toConsumableArray$4(shuffle_1(AP_DOMAINS_IO.map(getApUrl)))),
      cnBackupUrl$ = of.apply(void 0, _toConsumableArray$4(shuffle_1(AP_BACKUP_DOMAINS_CN.map(getApUrl)))),
      ioBackupUrl$ = of.apply(void 0, _toConsumableArray$4(shuffle_1(AP_BACKUP_DOMAINS_IO.map(getApUrl))));

  function _typeof$4(e) {
    return (_typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _slicedToArray$3(e, t) {
    return _arrayWithHoles$3(e) || _iterableToArrayLimit$3(e, t) || _nonIterableRest$3();
  }

  function _nonIterableRest$3() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit$3(e, t) {
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }

  function _arrayWithHoles$3(e) {
    if (Array.isArray(e)) return e;
  }

  function _classCallCheck$4(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _possibleConstructorReturn$3(e, t) {
    return !t || "object" !== _typeof$4(t) && "function" != typeof t ? _assertThisInitialized$3(e) : t;
  }

  function _assertThisInitialized$3(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _getPrototypeOf$3(e) {
    return (_getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _defineProperties$2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$2(e, t, r) {
    return t && _defineProperties$2(e.prototype, t), r && _defineProperties$2(e, r), e;
  }

  function _inherits$3(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$3(e, t);
  }

  function _setPrototypeOf$3(e, t) {
    return (_setPrototypeOf$3 = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var SocketError = genError(),
      Socket = function (e) {
    function t(e, r, n, o, i, s) {
      var a;
      if (_classCallCheck$4(this, t), (a = _possibleConstructorReturn$3(this, _getPrototypeOf$3(t).call(this, i, uniquePrefixedId("Socket-", i.loggerId)))).ip = e, a.env = r, a.ticket = n, a.context = o, a.isActiveClose = !1, a.loggedIn = !1, a.useCnDomain = "CN" === a.context.area, a.receivedPacket = new Subject(), a.open$ = void 0, a.input$ = new Subject(), a.userJoin$ = new Subject(), a.attemptsSinceLastError = 0, a.message$ = new Subject(), a.socket$ = void 0, a.toClose = new Subject(), a.toReconnect = new Subject(), a.sendLogger = a.genLogger("RTM:MSG:SEND"), a.receiveLogger = a.genLogger("RTM:MSG:RECV"), a.getDomain = function () {
        return getEdgeDomain(a.ip, a.useCnDomain);
      }, a.socketReconnector = function (e) {
        var t = function t(e) {
          return a.attemptsSinceLastError += 1, a.warn("The %s of Env %d reconnecting %s", a.name, a.env, e.message), timer(SOCKET_RETRY_INTERVAL);
        };

        return e.pipe(catchError(function (e) {
          return a.log("socket connection closed"), a.loggedIn = !1, a.attemptsSinceLastError >= 2 ? (a.warn("socket connection failure"), a.emit("connectionFailure"), a.close(), throwError(e)) : a.isActiveClose ? EMPTY : (a.emit("reconnect"), a.useCnDomain = !a.useCnDomain, throwError(e));
        }), retryWhen(function (e) {
          return e.pipe(switchMap(t));
        }));
      }, 0 !== r && 1 !== r) throw new SocketError({
        ILLEGAL_RTM_ENV: "The env number is out of rtm env count"
      });
      if (!isValidIp(e)) throw new SocketError({
        IP_NOT_VALID: "The ip from ap is not valid"
      });
      void 0 !== s && (a.useCnDomain = s);
      var u = EDGE_ENV_PORT[r];
      a.log("Opening websocket address %s for the Env %d", a.ip, a.env);
      var l = merge(a.input$, a.userJoin$.pipe(rateLimit(LOGIN_QPS_LIMIT)), a.message$).pipe(map$1(function (e) {
        return Wrapper$1.encode(e).finish();
      })),
          c = merge(makeWebSocketObservable("", {
        protocols: [],
        makeWebSocket: function makeWebSocket() {
          var e = new WebSocket("wss://".concat(a.getDomain(), ":").concat(u));
          return e.binaryType = "arraybuffer", e;
        }
      }), a.toReconnect);
      return a.socket$ = race(c, NEVER.pipe(timeout(5e3), catchError(function (e) {
        return isTimeout(e) && a.warn("socket open timed out"), throwError(e);
      }))).pipe(map$1(function (e) {
        if (e instanceof Error) throw a.warn("Env_%d: Force reconnect the socket", a.env), e;
        return e(l).pipe(map$1(function (e) {
          return Wrapper$1.decode(new Uint8Array(e));
        }));
      }), a.socketReconnector), a.open$ = a.socket$.pipe(tap(function (e) {
        a.log("Websocket opened", a.name), e.subscribe(function (e) {
          var t = e.data,
              r = uriToPacketName(e.uri),
              n = Packets[r].decode(t),
              o = mergeWith_1({}, omit_1(n, "toJSON"), function (e, t) {
            return t instanceof long_1 ? longToStringIfNeeded(t) : t;
          }),
              i = !1;
          (n instanceof GroupEnterNotice || n instanceof GroupLeaveNotice) && n.instance.lessThanOrEqual(UINT32_MAX) && (i = !0);

          if (n instanceof Message || n instanceof Ack) {
            var s = n.instance,
                u = n.dialogue,
                l = n.sequence;
            (u.lessThanOrEqual(UINT32_MAX) || s.lessThanOrEqual(UINT32_MAX) || l.lessThan(1)) && (i = !0);
          }

          i ? a.warn("Env_%d: Illegal %s, abandoned %o", a.env, r, o) : ("Pong" !== r && a.receiveLogger("Env_%d: %s %o", a.env, r, o), a.receivedPacket.next([r, n]));
        }, function () {});
      }), mapTo(void 0), takeUntil(a.toClose), share()), a;
    }

    return _inherits$3(t, createEventBase()), _createClass$2(t, [{
      key: "address",
      get: function get() {
        return "".concat(this.ip, ":").concat(EDGE_ENV_PORT[this.env]);
      }
    }]), _createClass$2(t, [{
      key: "sendPacket",
      value: function value(e, t) {
        if ("Ping" !== e) {
          var r = mapValues_1(t, function (e) {
            return e instanceof long_1 ? longToStringIfNeeded(e) : e;
          });
          this.sendLogger("Env_%d: %s %o", this.env, e, r);
        }

        var n = getWrappedByName(e, t);
        "UserJoin" === e ? this.userJoin$.next(n) : "Message" === e ? this.message$.next(n) : this.input$.next(n);
      }
    }, {
      key: "close",
      value: function value() {
        this.isActiveClose = !0, this.loggedIn = !1, this.toClose.next();
      }
    }, {
      key: "fromReceived",
      value: function value(e) {
        var t = this;
        return this.receivedPacket.pipe(tap(function (e) {
          var r = _slicedToArray$3(e, 2),
              n = r[0],
              o = r[1];

          "UserResp" === n && (t.attemptsSinceLastError = 0, t.loggedIn = !0), "UserDrop" === n && t.emit("socketUserDrop", o);
        }), filter(function (t) {
          return _slicedToArray$3(t, 1)[0] === e;
        }), map$1(function (e) {
          return _slicedToArray$3(e, 2)[1];
        }));
      }
    }, {
      key: "forceReconnect",
      value: function value() {
        this.toReconnect.next(new SocketError({
          FORCE_RECONNECTING: "Connection seems broken, try force reconnecting"
        }));
      }
    }]), t;
  }(),
      AREA_CODE;

  function _toConsumableArray$5(e) {
    return _arrayWithoutHoles$5(e) || _iterableToArray$5(e) || _nonIterableSpread$5();
  }

  function _nonIterableSpread$5() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray$5(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _arrayWithoutHoles$5(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  function _slicedToArray$4(e, t) {
    return _arrayWithHoles$4(e) || _iterableToArrayLimit$4(e, t) || _nonIterableRest$4();
  }

  function _nonIterableRest$4() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit$4(e, t) {
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }

  function _arrayWithHoles$4(e) {
    if (Array.isArray(e)) return e;
  }

  function _objectWithoutProperties$2(e, t) {
    if (null == e) return {};

    var r,
        n,
        o = _objectWithoutPropertiesLoose$2(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (n = 0; n < i.length; n++) {
        r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }
    }

    return o;
  }

  function _objectWithoutPropertiesLoose$2(e, t) {
    if (null == e) return {};
    var r,
        n,
        o = {},
        i = Object.keys(e);

    for (n = 0; n < i.length; n++) {
      r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
    }

    return o;
  }

  function ownKeys$1(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function _objectSpread(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ownKeys$1(r, !0).forEach(function (t) {
        _defineProperty$2(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys$1(r).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function _defineProperty$2(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  !function (e) {
    e.CN = "CN", e.NA = "NA", e.EU = "EU", e.AS = "AS", e.JP = "JP", e.IN = "IN", e.GLOBAL = "GLOBAL", e.OC = "OC", e.SA = "SA", e.AF = "AF", e.OVS = "OVS";
  }(AREA_CODE || (AREA_CODE = {}));

  var AREA_DOMAIN_MAP = _objectSpread({
    AS: {
      CODE: AREA_CODE.AS,
      AP_DOMAINS: ["ap-web-1-asia.agora.io"],
      AP_BACKUP_DOMAINS: ["ap-web-2-asia.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-asia.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-asia.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-asia.agora.io"]
    },
    NA: {
      CODE: AREA_CODE.NA,
      AP_DOMAINS: ["ap-web-1-north-america.agora.io"],
      AP_BACKUP_DOMAINS: ["ap-web-2-north-america.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-north-america.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-north-america.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-north-america.agora.io"]
    },
    EU: {
      CODE: AREA_CODE.EU,
      AP_DOMAINS: ["ap-web-1-europe.agora.io"],
      AP_BACKUP_DOMAINS: ["ap-web-2-europe.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-europe.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-europe.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-europe.agora.io"]
    },
    JP: {
      CODE: AREA_CODE.JP,
      AP_DOMAINS: ["ap-web-1-japan.agora.io"],
      AP_BACKUP_DOMAINS: ["ap-web-2-japan.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-japan.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-japan.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-japan.agora.io"]
    },
    IN: {
      CODE: AREA_CODE.IN,
      AP_DOMAINS: ["ap-web-1-india.agora.io"],
      AP_BACKUP_DOMAINS: ["ap-web-2-india.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-india.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-india.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-india.agora.io"]
    },
    OVS: {
      CODE: AREA_CODE.OVS,
      AP_DOMAINS: ["ap-web-1-oversea.agora.io"],
      AP_BACKUP_DOMAINS: ["ap-web-2-oversea.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-oversea.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-oversea.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-oversea.agora.io"]
    },
    GLOB: {
      CODE: AREA_CODE.GLOBAL,
      AP_DOMAINS: ["ap-web-1.agora.io", "ap-web-2.agora.io"],
      AP_BACKUP_DOMAINS: ["ap-web-3.agora.io", "ap-web-4.agora.io"],
      EVENT_REPORT_DOMAIN: ["webcollector-rtm.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["webcollector-1.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-rtm.agora.io"]
    },
    OC: {
      CODE: AREA_CODE.OC,
      AP_DOMAINS: ["ap-web-1-oceania.agora.io"],
      AP_BACKUP_DOMAINS: ["ap-web-2-oceania.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-oceania.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-oceania.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-oceania.agora.io"]
    },
    SA: {
      CODE: AREA_CODE.SA,
      AP_DOMAINS: ["ap-web-1-south-america.agora.io"],
      AP_BACKUP_DOMAINS: ["ap-web-2-south-america.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-south-america.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-south-america.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-south-america.agora.io"]
    },
    AF: {
      CODE: AREA_CODE.AF,
      AP_DOMAINS: ["ap-web-1-africa.agora.io"],
      AP_BACKUP_DOMAINS: ["ap-web-2-africa.agora.io"],
      EVENT_REPORT_DOMAIN: ["statscollector-1-africa.agora.io"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-africa.agora.io"],
      LOG_UPLOAD_SERVER: ["logservice-south-africa.agora.io"]
    }
  }, {
    CN: {
      CODE: AREA_CODE.CN,
      AP_DOMAINS: ["ap-web-1.agoraio.cn", "ap-web-2.agoraio.cn"],
      AP_BACKUP_DOMAINS: ["ap-web-3.agoraio.cn", "ap-web-4.agoraio.cn"],
      EVENT_REPORT_DOMAIN: ["webcollector-rtm.agoraio.cn"],
      EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-4.agoraio.cn"],
      LOG_UPLOAD_SERVER: ["logservice-rtm.agoraio.cn"]
    }
  });

  AREA_DOMAIN_MAP = deepFreeze(AREA_DOMAIN_MAP);

  var getAreaDomainConfig = function getAreaDomainConfig(e) {
    var t = new Set(),
        r = e.map(function (e) {
      var r = AREA_DOMAIN_MAP[e];
      if (void 0 === r) throw new RtmInternalError("invalid area key");

      var n = r.CODE,
          o = _objectWithoutProperties$2(r, ["CODE"]);

      return t.add(n), o;
    });
    if (0 === r.length) throw new RtmInternalError("areas cannot be empty");
    return _objectSpread({
      CODES: t
    }, r.reduce(function (e, t) {
      var r = getEntries(e),
          n = Array.isArray(r),
          o = 0;

      for (r = n ? r : r[Symbol.iterator]();;) {
        var i;

        if (n) {
          if (o >= r.length) break;
          i = r[o++];
        } else {
          if ((o = r.next()).done) break;
          i = o.value;
        }

        var s = _slicedToArray$4(i, 2),
            a = s[0],
            u = s[1];

        e[a] = _toConsumableArray$5(new Set([].concat(_toConsumableArray$5(t[a]), _toConsumableArray$5(u))));
      }

      return e;
    }));
  };

  function _typeof$5(e) {
    return (_typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function ownKeys$2(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function _objectSpread$1(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ownKeys$2(r, !0).forEach(function (t) {
        _defineProperty$3(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys$2(r).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function _defineProperty$3(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function asyncGeneratorStep$4(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$4(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$4(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$4(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  function _toConsumableArray$6(e) {
    return _arrayWithoutHoles$6(e) || _iterableToArray$6(e) || _nonIterableSpread$6();
  }

  function _nonIterableSpread$6() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray$6(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _arrayWithoutHoles$6(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  function _classCallCheck$5(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _possibleConstructorReturn$4(e, t) {
    return !t || "object" !== _typeof$5(t) && "function" != typeof t ? _assertThisInitialized$4(e) : t;
  }

  function _assertThisInitialized$4(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _getPrototypeOf$4(e) {
    return (_getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _inherits$4(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$4(e, t);
  }

  function _setPrototypeOf$4(e, t) {
    return (_setPrototypeOf$4 = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var getAreaCodeByApUrl = function getAreaCodeByApUrl(e) {
    for (var t = getKeys(AREA_DOMAIN_MAP), r = getDomain(e), n = 0; n < t.length; n++) {
      var o = t[n],
          i = AREA_DOMAIN_MAP[o];
      if ((null == i ? void 0 : i.AP_DOMAINS.includes(r)) || (null == i ? void 0 : i.AP_BACKUP_DOMAINS.includes(r))) return i.CODE === AREA_CODE.OVS ? "".concat(AREA_CODE.AS, ",").concat(AREA_CODE.EU, ",").concat(AREA_CODE.AF, ",").concat(AREA_CODE.NA, ",").concat(AREA_CODE.SA, ",").concat(AREA_CODE.OC) : i.CODE;
    }

    return "GLOBAL,CN";
  },
      ApResErrorMessage = {
    INVALID_APP_ID: "Illegal App ID",
    NO_AUTHORIZED: "Signature verification failed",
    TOKEN_TIMEOUT: "Dynamic key expired",
    INVALID_TOKEN_UID: "UID in the security key(token) is not valid",
    APP_ID_NO_ACTIVATED: "The vendor is not activated",
    DYNAMIC_KEY_NOT_ENABLED: "The vendor did not enable the dynamic key, but uses the dynamic key",
    DYNAMIC_ENABLED_BUT_STATIC_KEY: "The vendor enabled the dynamic key, but uses the static key",
    TOKEN_EXPIRED: "The token has expired",
    INVALID_USER_ID: "The user ID to login does not match the token",
    FORBIDDEN_REGION: "Forbidden to access the request in this area",
    CANNOT_MEET_AREA_DEMAND: "Cannot allocate to meet the requirements of the given area limit"
  },
      ApRecoverableErrorMessage = {
    NO_SERVICE_AVAILABLE: "Ap service is currently unavailable"
  },
      ApResErrorCode = {
    5: "INVALID_APP_ID",
    7: "INVALID_USER_ID",
    9: "NO_AUTHORIZED",
    10: "TOKEN_TIMEOUT",
    11: "APP_ID_NO_ACTIVATED",
    12: "INVALID_TOKEN_UID",
    13: "TOKEN_EXPIRED",
    14: "DYNAMIC_KEY_NOT_ENABLED",
    15: "DYNAMIC_ENABLED_BUT_STATIC_KEY",
    18: "FORBIDDEN_REGION",
    19: "CANNOT_MEET_AREA_DEMAND"
  },
      AccessPoint = function (e) {
    function t(e, r) {
      var n;
      _classCallCheck$5(this, t), (n = _possibleConstructorReturn$4(this, _getPrototypeOf$4(t).call(this, r, "AccessPoint"))).context = e, n.apEdgeInfo$ = void 0, n.apEdgeInfoEndFirst$ = void 0, n.apFinish$ = new Subject(), n.usedUrl = [], n.failedAreas = new Set(), n.cnDomainUsed = !1, n.backupCnDomainUsed = !1, n.genUrl = function () {
        return void 0 === n.context.areaConfig ? zip(cnUrl$, ioUrl$).pipe(concatMap(function (e) {
          return of.apply(void 0, _toConsumableArray$6(e));
        })) : of.apply(void 0, _toConsumableArray$6(n.context.areaConfig.AP_DOMAINS.map(getApUrl)));
      }, n.genBackupUrl = function () {
        return void 0 === n.context.areaConfig ? zip(cnBackupUrl$, ioBackupUrl$).pipe(concatMap(function (e) {
          return of.apply(void 0, _toConsumableArray$6(e));
        })) : of.apply(void 0, _toConsumableArray$6(n.context.areaConfig.AP_BACKUP_DOMAINS.map(getApUrl)));
      }, n.getUrl$ = function () {
        return n.genUrl().pipe(filter(function (e) {
          return (!n.cnDomainUsed || !e.includes("agoraio.cn")) && (e.includes("agoraio.cn") && (n.cnDomainUsed = !0), !some_1(n.usedUrl, function (t) {
            return e[15] === t;
          }));
        }), tap(function (e) {
          void 0 === n.context.areaConfig && n.usedUrl.push(e[15]);
        }), take(AP_CONCURRENT_REQ_NUM), throwIfEmpty(function () {
          return t.runOutOfUrlSymbol;
        }), catchError(function (e, r) {
          return n.cnDomainUsed = !1, e === t.runOutOfUrlSymbol ? (n.usedUrl = [], r) : throwError(e);
        }));
      }, n.getBackupUrl$ = function () {
        return n.genBackupUrl().pipe(filter(function (e) {
          return (!n.backupCnDomainUsed || !e.includes("agoraio.cn")) && (e.includes("agoraio.cn") && (n.backupCnDomainUsed = !0), !some_1(n.usedUrl, function (t) {
            return e[15] === t;
          }));
        }), tap(function (e) {
          void 0 === n.context.areaConfig && n.usedUrl.push(e[15]);
        }), take(AP_CONCURRENT_REQ_NUM), throwIfEmpty(function () {
          return t.runOutOfUrlSymbol;
        }), catchError(function (e, r) {
          return n.backupCnDomainUsed = !1, e === t.runOutOfUrlSymbol ? (n.usedUrl = [], r) : throwError(e);
        }));
      }, n.fetchAp = function (e, t) {
        var r = uniquePrefixedId("AP-", n.loggerId);
        n.log("The AccessPoint requests %s(%s)", e, r);
        var o = new AbortController();
        return n.apFinish$.pipe(take(1)).subscribe(function () {
          return o.abort();
        }), defer$1(_asyncToGenerator$4(regenerator.mark(function i() {
          var s;
          return regenerator.wrap(function (i) {
            for (;;) {
              switch (i.prev = i.next) {
                case 0:
                  return s = getRandomInt(0, Number.MAX_SAFE_INTEGER), n.log("The %s request uid param is %d", r, s), i.abrupt("return", postWithAbortSignal(e, {
                    headers: {
                      "X-Packet-Service-Type": "0",
                      "X-Packet-URI": "69",
                      "Content-Type": "application/json"
                    },
                    body: {
                      flag: 128,
                      opid: 1,
                      key: t || n.context.key,
                      cname: n.context.uid,
                      detail: _objectSpread$1({}, void 0 === n.context.areaConfig ? {
                        11: "GLOBAL"
                      } : {
                        11: _toConsumableArray$6(n.context.areaConfig.CODES).join(",")
                      }),
                      uid: s,
                      sid: n.context.sid
                    },
                    signal: o.signal
                  }));

                case 3:
                case "end":
                  return i.stop();
              }
            }
          }, i);
        }))).pipe(catchError(function (t) {
          return "AbortError" !== t.name && (n.logError(t), n.warn("The AP server %s request failure", e)), EMPTY;
        }), mergeMap(function () {
          var t = _asyncToGenerator$4(regenerator.mark(function t(o) {
            var i, s, a, u, l, c, p, f, d, g, h, b, y, _, m, v, E, O, I, $, S, w;

            return regenerator.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (i = o.responseText, s = JSON.parse(i), n.log("The %s response is %o", r, s), u = (a = s).code, l = a.addresses, c = a.detail[9], 0 === u) {
                      t.next = 50;
                      break;
                    }

                    if (p = u, !(u.toString().length > 4)) {
                      t.next = 15;
                      break;
                    }

                    if (f = u.toString().padStart(8, "0"), d = f.slice(0, 4), 201 !== parseInt(d, 10)) {
                      t.next = 13;
                      break;
                    }

                    p = parseInt(f.slice(4, 8), 10), t.next = 15;
                    break;

                  case 13:
                    if (201 !== parseInt(d, 10) || !f.slice(4, 8).startsWith("101")) {
                      t.next = 15;
                      break;
                    }

                    return t.abrupt("return", throwError(new Error(ApRecoverableErrorMessage.NO_SERVICE_AVAILABLE)));

                  case 15:
                    if (g = p.toString(), Object.keys(ApResErrorCode).includes(g)) {
                      t.next = 21;
                      break;
                    }

                    return (h = new RtmUnavailableError(["Login is rejected by the server. The response code is %d", u], LOGIN_ERR_REJECTED)).serverCode = p, t.abrupt("return", throwError(h));

                  case 21:
                    b = ApResErrorCode[g], y = ApResErrorMessage[b], t.t0 = b, t.next = "INVALID_APP_ID" === t.t0 ? 26 : "APP_ID_NO_ACTIVATED" === t.t0 ? 26 : "INVALID_USER_ID" === t.t0 ? 29 : "TOKEN_EXPIRED" === t.t0 ? 32 : "TOKEN_TIMEOUT" === t.t0 ? 32 : "NO_AUTHORIZED" === t.t0 ? 35 : "INVALID_TOKEN_UID" === t.t0 ? 35 : "DYNAMIC_KEY_NOT_ENABLED" === t.t0 ? 35 : "DYNAMIC_ENABLED_BUT_STATIC_KEY" === t.t0 ? 35 : "CANNOT_MEET_AREA_DEMAND" === t.t0 ? 38 : "FORBIDDEN_REGION" === t.t0 ? 46 : 49;
                    break;

                  case 26:
                    return (_ = new RtmUnauthenticatedError(y, LOGIN_ERR_INVALID_APP_ID)).serverCode = u, t.abrupt("return", throwError(_));

                  case 29:
                    return (m = new RtmUnauthenticatedError(y, LOGIN_ERR_INVALID_ARGUMENT)).serverCode = u, t.abrupt("return", throwError(m));

                  case 32:
                    return (v = new RtmUnauthenticatedError(y, LOGIN_ERR_TOKEN_EXPIRED)).serverCode = u, t.abrupt("return", throwError(v));

                  case 35:
                    return (E = new RtmUnauthenticatedError(y, LOGIN_ERR_INVALID_TOKEN)).serverCode = u, t.abrupt("return", throwError(E));

                  case 38:
                    if (O = getAreaCodeByApUrl(e), n.failedAreas.add(O), I = void 0 === n.context.areaConfig ? 2 : n.context.areaConfig.CODES.size, n.failedAreas.size !== I) {
                      t.next = 45;
                      break;
                    }

                    return ($ = new RtmInvalidArgumentError(y, LOGIN_ERR_REJECTED)).serverCode = u, t.abrupt("return", throwError($));

                  case 45:
                    return t.abrupt("break", 50);

                  case 46:
                    return (S = new RtmUnavailableError(y, LOGIN_ERR_REJECTED)).serverCode = u, t.abrupt("return", throwError(S));

                  case 49:
                    return t.abrupt("return", throwError(assertNever("ApResErrType", b)));

                  case 50:
                    return w = l, void 0, n.context.area = c, t.abrupt("return", of.apply(void 0, _toConsumableArray$6(w).concat([queue$1])));

                  case 55:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          }));

          return function (e) {
            return t.apply(this, arguments);
          };
        }()), mergeAll(), filter(function (e) {
          return void 0 !== e && "string" == typeof e.ip && "string" == typeof e.ticket;
        }));
      };
      var o = 0;
      return n.apEdgeInfoEndFirst$ = timer(0, 1500).pipe(take(1), tap(function () {
        o += 1;
      }), mergeMap(function () {
        return o <= 2 ? n.getUrl$() : n.getBackupUrl$();
      }), mergeMap(function (e) {
        return n.fetchAp(e);
      }), timeout(AP_REQUEST_TIMEOUT), catchError(function (e) {
        return e instanceof TimeoutError && n.warn("AP request timeout"), throwError(e);
      }), distinct(function (e) {
        return e.ip;
      }), finalize(function () {
        o = 0, n.failedAreas.clear();
      }), takeUntil(n.apFinish$)), n.apEdgeInfo$ = timer(0, 1500).pipe(take(4), tap(function () {
        o += 1;
      }), mergeMap(function () {
        return o <= 2 ? n.getUrl$() : n.getBackupUrl$();
      }), mergeMap(function (e) {
        return n.fetchAp(e);
      }), timeout(AP_REQUEST_TIMEOUT), catchError(function (e) {
        return e instanceof TimeoutError && n.warn("AP request timeout"), throwError(e);
      }), distinct(function (e) {
        return e.ip;
      }), finalize(function () {
        o = 0, n.failedAreas.clear();
      }), takeUntil(n.apFinish$)), n;
    }

    return _inherits$4(t, createEventBase()), t;
  }();

  function _typeof$6(e) {
    return (_typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _toConsumableArray$7(e) {
    return _arrayWithoutHoles$7(e) || _iterableToArray$7(e) || _nonIterableSpread$7();
  }

  function _nonIterableSpread$7() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray$7(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _arrayWithoutHoles$7(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  function _classCallCheck$6(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties$3(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$3(e, t, r) {
    return t && _defineProperties$3(e.prototype, t), r && _defineProperties$3(e, r), e;
  }

  function _possibleConstructorReturn$5(e, t) {
    return !t || "object" !== _typeof$6(t) && "function" != typeof t ? _assertThisInitialized$5(e) : t;
  }

  function _assertThisInitialized$5(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _getPrototypeOf$5(e) {
    return (_getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _inherits$5(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$5(e, t);
  }

  function _setPrototypeOf$5(e, t) {
    return (_setPrototypeOf$5 = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  AccessPoint.runOutOfUrlSymbol = Symbol("AP urls are used up");

  var ConnectionError = genError(),
      Connection = function (e) {
    function t(e, r) {
      var n;
      _classCallCheck$6(this, t), (n = _possibleConstructorReturn$5(this, _getPrototypeOf$5(t).call(this, r, "Connection"))).context = e, n.logger = r, n.apClient = new AccessPoint(n.context, n.logger), n.lastOpenSockets = [new ReplaySubject(1), new ReplaySubject(1)], n.curOpenSockets = [void 0, void 0], n.ipIterator = 0, n.firstEnv = Math.random() >= .5 ? 1 : 0, n.firstSocketOpener = void 0, n.secondSocketOpener = void 0, n.firstOpenKeeperSubject = new Subject(), n.secondOpenKeeperSubject = new Subject(), n.edgeInfoReplayed = void 0, n.firstEnvOpenSocket = void 0, n.firstOpenKeeperSub = void 0, n.secondOpenKeeperSub = void 0, n.apClient.apFinish$.subscribe(function () {
        n.log("Ap client fetch finished");
      });
      var o,
          i = [];
      n.edgeInfoReplayed = n.apClient.apEdgeInfo$.pipe(filter(function (e) {
        return void 0 !== e && "string" == typeof e.ip && "string" == typeof e.ticket;
      }), throwIfEmpty(function () {
        return new ConnectionError({
          AP_NO_AVAILABLE_EDGE: "No available edge address to connect"
        });
      }), retryWhen(function (e) {
        return e.pipe(tap(function (e) {
          if (isRtmError(e)) throw e;
        }), delay(750), takeUntil(timer(7e3)));
      }), filter(function (e) {
        return !some_1(i, e);
      }), tap(function (e) {
        i.push(e), n.log("An edge info got %o", e);
      }), tap({
        error: function error(e) {
          n.emit("connectionInitFailure", e);
        }
      }), shareReplay()), n.firstEnvOpenSocket = n.edgeInfoReplayed.pipe(mergeMap(function (e) {
        if (void 0 === e) return throwError(new Error("Invalid edge info"));
        var t = e.ip,
            i = e.ticket,
            s = new Socket(t, n.firstEnv, i, n.context, r, o);
        return n.firstEnv = 1 === n.firstEnv ? 0 : 1, s.on("connectionFailure", function () {
          return n.onSocketConnectionFailure(s);
        }), o = !s.useCnDomain, s.open$.pipe(mapTo(s));
      }), tap(function (e) {
        n.log("The websocket of ENV_%d opened to %s:%d", e.env, e.ip, EDGE_ENV_PORT[e.env]), n.curOpenSockets[e.env] = e, n.lastOpenSockets[e.env].next(e), n.firstEnv = e.env, n.openSecondSocket(e.env, e.ip, e.useCnDomain);
      }), take(1), share()), n.firstSocketOpener = n.firstEnvOpenSocket.pipe(mergeMap(function (e) {
        return e.open$.pipe(tap(function () {
          n.log("The websocket of first ENV_%d re-opened to %s:%d", e.env, e.ip, EDGE_ENV_PORT[e.env]), n.curOpenSockets[e.env] = e, n.lastOpenSockets[e.env].next(e);
        }));
      }));
      var s = n.firstOpenKeeperSubject.pipe(switchAll());
      return n.firstOpenKeeperSub = s.subscribe({
        error: n.logError
      }), n;
    }

    return _inherits$5(t, createEventBase()), _createClass$3(t, [{
      key: "initConnection",
      value: function value() {
        this.firstOpenKeeperSubject.next(this.firstSocketOpener);
      }
    }, {
      key: "closeSocket",
      value: function value(e, t) {
        if (![0, 1].includes(e)) throw new CommonError({
          INVALID_ENV: "The env argument is not 0 or 1"
        });
        var r;
        e === this.firstEnv ? (r = this.firstOpenKeeperSub, this.firstOpenKeeperSub = void 0) : (r = this.secondOpenKeeperSub, this.firstOpenKeeperSub = void 0);
        var n = this.curOpenSockets[e];
        this.curOpenSockets[e] = void 0, n && (n.isActiveClose = !0, setTimeout(function () {
          n.close();
        }, t)), void 0 !== r && setTimeout(function () {
          var e;
          null === (e = r) || void 0 === e || e.unsubscribe();
        }, t);
      }
    }, {
      key: "waitClosing",
      value: function value(e) {
        var t = this;
        return e.isActiveClose = !0, e.open$.pipe(ignoreElements(), catchError(function (e) {
          return e.message === lib_es5_1 ? EMPTY : throwError(e);
        }), timeout(LOGOUT_SOCKET_CLOSE_TIMEOUT), catchError(function (r) {
          return r instanceof TimeoutError ? (t.warn("Force closing the ENV_%d connection", e.env), EMPTY) : throwError(r);
        }));
      }
    }, {
      key: "onSocketConnectionFailure",
      value: function value(e) {
        var t = [0, 1].filter(function (t) {
          return t !== e.env;
        })[0],
            r = this.curOpenSockets[t];
        r && r.loggedIn ? this.reopenSocketWithApRequest(e.env) : this.emit("socketsFailure");
      }
    }, {
      key: "openSecondSocket",
      value: function value(e, t, r) {
        var n = this,
            o = 1 === e ? 0 : 1;
        this.secondSocketOpener = this.edgeInfoReplayed.pipe(reduce(function (e, t) {
          return [].concat(_toConsumableArray$7(e), [t]);
        }, []), map$1(function (e) {
          return sortBy_1(e, function (e) {
            var r = e.ip;
            return calIpDistance(t, r);
          }).slice(-1)[0];
        }), take(1), mergeMap(function (e) {
          if (void 0 === e) return throwError(new Error("Invalid edge info"));
          var t = e.ip,
              i = e.ticket,
              s = new Socket(t, o, i, n.context, n.logger, r);
          return s.on("connectionFailure", function () {
            return n.onSocketConnectionFailure(s);
          }), s.open$.pipe(tap(function () {
            n.lastOpenSockets[o].next(s), n.curOpenSockets[o] = s;
          }));
        }), share());
        var i = this.secondOpenKeeperSubject.pipe(switchAll());
        this.secondOpenKeeperSub = i.subscribe({
          error: this.logError
        }), this.secondOpenKeeperSubject.next(this.secondSocketOpener);
      }
    }, {
      key: "reopenSocketWithApRequest",
      value: function value(e) {
        var t = this,
            r = [0, 1].filter(function (t) {
          return t !== e;
        })[0],
            n = this.curOpenSockets[r];

        if (void 0 !== n) {
          var o,
              i = n.ip,
              s = this.apClient.apEdgeInfoEndFirst$.pipe(filter(function (e) {
            return void 0 !== e && "string" == typeof e.ip && "string" == typeof e.ticket;
          }), throwIfEmpty(function () {
            return new ConnectionError({
              AP_NO_AVAILABLE_EDGE: "No available edge address to connect"
            });
          }), retryWhen(function (e) {
            return e.pipe(tap(function (e) {
              if (e.code === LOGIN_ERR_TOKEN_EXPIRED) return t.emit("tokenExpired"), void t.apClient.apFinish$.next(void 0);
              if (isRtmError(e)) throw e;
            }), delay(750), takeUntil(timer(7e3)));
          }), tap(function (e) {
            t.log("An edge info got %o", e);
          })).pipe(reduce(function (e, t) {
            return [].concat(_toConsumableArray$7(e), [t]);
          }, []), map$1(function (e) {
            var r = sortBy_1(e, function (e) {
              var t = e.ip;
              return calIpDistance(i, t);
            });
            return r.length - 1 >= t.ipIterator ? r.slice(-t.ipIterator++ - 1)[0] : (t.ipIterator = 0, r.slice(-1)[0]);
          }), throwIfEmpty(), mergeMap(function (r) {
            if (void 0 === r) return throwError(new Error("Invalid edge info"));
            var n = r.ip,
                i = r.ticket,
                s = new Socket(n, e, i, t.context, t.logger, o);
            return s.on("connectionFailure", function () {
              return t.onSocketConnectionFailure(s);
            }), o = !s.useCnDomain, s.open$.pipe(mapTo(s));
          }), tap(function (r) {
            t.log("The websocket of ENV_%d re-opened to %s:%d using ap", r.env, r.ip, EDGE_ENV_PORT[r.env]), t.curOpenSockets[e] = r, t.lastOpenSockets[e].next(r);
          }), mergeMap(function (r) {
            return r.open$.pipe(tap(function () {
              t.log("The websocket of ENV_%d re-opened to %s:%d", r.env, r.ip, EDGE_ENV_PORT[r.env]), t.curOpenSockets[e] = r, t.lastOpenSockets[e].next(r);
            }));
          }), share());
          e === this.firstEnv ? this.firstOpenKeeperSubject.next(s) : this.secondOpenKeeperSubject.next(s);
        }
      }
    }]), t;
  }(),
      $Reader$1 = indexMinimal_4,
      $Writer$1 = indexMinimal_2,
      $util$1 = indexMinimal_6,
      $root$1 = indexMinimal_8.default || (indexMinimal_8.default = {}),
      Session = $root$1.Session = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.appId = "", e.prototype.ver = "", e.prototype.buildno = 0, e.prototype.installId = "", e.prototype.os = 0, e.prototype.did = "", e.prototype.index = null, e.prototype.token = "", e.prototype.version = 0, e.prototype.subVersion = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.appId && Object.hasOwnProperty.call(e, "appId") && t.uint32(42).string(e.appId), null != e.ver && Object.hasOwnProperty.call(e, "ver") && t.uint32(50).string(e.ver), null != e.buildno && Object.hasOwnProperty.call(e, "buildno") && t.uint32(56).int32(e.buildno), null != e.installId && Object.hasOwnProperty.call(e, "installId") && t.uint32(66).string(e.installId), null != e.os && Object.hasOwnProperty.call(e, "os") && t.uint32(128).int32(e.os), null != e.did && Object.hasOwnProperty.call(e, "did") && t.uint32(138).string(e.did), null != e.index && Object.hasOwnProperty.call(e, "index") && $root$1.Session.CommonIndex.encode(e.index, t.uint32(162).fork()).ldelim(), null != e.token && Object.hasOwnProperty.call(e, "token") && t.uint32(170).string(e.token), null != e.version && Object.hasOwnProperty.call(e, "version") && t.uint32(176).int32(e.version), null != e.subVersion && Object.hasOwnProperty.call(e, "subVersion") && t.uint32(184).int32(e.subVersion), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.Session(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 5:
            n.appId = e.string();
            break;

          case 6:
            n.ver = e.string();
            break;

          case 7:
            n.buildno = e.int32();
            break;

          case 8:
            n.installId = e.string();
            break;

          case 16:
            n.os = e.int32();
            break;

          case 17:
            n.did = e.string();
            break;

          case 20:
            n.index = $root$1.Session.CommonIndex.decode(e, e.uint32());
            break;

          case 21:
            n.token = e.string();
            break;

          case 22:
            n.version = e.int32();
            break;

          case 23:
            n.subVersion = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid)) return "sid: string expected";
      if (null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId)) return "userId: string expected";
      if (null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high))) return "lts: integer|Long expected";
      if (null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high))) return "elapse: integer|Long expected";
      if (null != e.appId && e.hasOwnProperty("appId") && !$util$1.isString(e.appId)) return "appId: string expected";
      if (null != e.ver && e.hasOwnProperty("ver") && !$util$1.isString(e.ver)) return "ver: string expected";
      if (null != e.buildno && e.hasOwnProperty("buildno") && !$util$1.isInteger(e.buildno)) return "buildno: integer expected";
      if (null != e.installId && e.hasOwnProperty("installId") && !$util$1.isString(e.installId)) return "installId: string expected";
      if (null != e.os && e.hasOwnProperty("os") && !$util$1.isInteger(e.os)) return "os: integer expected";
      if (null != e.did && e.hasOwnProperty("did") && !$util$1.isString(e.did)) return "did: string expected";

      if (null != e.index && e.hasOwnProperty("index")) {
        var t = $root$1.Session.CommonIndex.verify(e.index);
        if (t) return "index." + t;
      }

      return null != e.token && e.hasOwnProperty("token") && !$util$1.isString(e.token) ? "token: string expected" : null != e.version && e.hasOwnProperty("version") && !$util$1.isInteger(e.version) ? "version: integer expected" : null != e.subVersion && e.hasOwnProperty("subVersion") && !$util$1.isInteger(e.subVersion) ? "subVersion: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.Session) return e;
      var t = new $root$1.Session();

      if (null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.appId && (t.appId = String(e.appId)), null != e.ver && (t.ver = String(e.ver)), null != e.buildno && (t.buildno = 0 | e.buildno), null != e.installId && (t.installId = String(e.installId)), null != e.os && (t.os = 0 | e.os), null != e.did && (t.did = String(e.did)), null != e.index) {
        if ("object" !== _typeof(e.index)) throw TypeError(".Session.index: object expected");
        t.index = $root$1.Session.CommonIndex.fromObject(e.index);
      }

      return null != e.token && (t.token = String(e.token)), null != e.version && (t.version = 0 | e.version), null != e.subVersion && (t.subVersion = 0 | e.subVersion), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.appId = "", r.ver = "", r.buildno = 0, r.installId = "", r.os = 0, r.did = "", r.index = null, r.token = "", r.version = 0, r.subVersion = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.appId && e.hasOwnProperty("appId") && (r.appId = e.appId), null != e.ver && e.hasOwnProperty("ver") && (r.ver = e.ver), null != e.buildno && e.hasOwnProperty("buildno") && (r.buildno = e.buildno), null != e.installId && e.hasOwnProperty("installId") && (r.installId = e.installId), null != e.os && e.hasOwnProperty("os") && (r.os = e.os), null != e.did && e.hasOwnProperty("did") && (r.did = e.did), null != e.index && e.hasOwnProperty("index") && (r.index = $root$1.Session.CommonIndex.toObject(e.index, t)), null != e.token && e.hasOwnProperty("token") && (r.token = e.token), null != e.version && e.hasOwnProperty("version") && (r.version = e.version), null != e.subVersion && e.hasOwnProperty("subVersion") && (r.subVersion = e.subVersion), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.CommonIndex = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.index1 = "", e.prototype.index2 = "", e.prototype.index3 = "", e.encode = function (e, t) {
        return t || (t = $Writer$1.create()), null != e.index1 && Object.hasOwnProperty.call(e, "index1") && t.uint32(10).string(e.index1), null != e.index2 && Object.hasOwnProperty.call(e, "index2") && t.uint32(18).string(e.index2), null != e.index3 && Object.hasOwnProperty.call(e, "index3") && t.uint32(26).string(e.index3), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader$1 || (e = $Reader$1.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.Session.CommonIndex(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.index1 = e.string();
              break;

            case 2:
              n.index2 = e.string();
              break;

            case 3:
              n.index3 = e.string();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.index1 && e.hasOwnProperty("index1") && !$util$1.isString(e.index1) ? "index1: string expected" : null != e.index2 && e.hasOwnProperty("index2") && !$util$1.isString(e.index2) ? "index2: string expected" : null != e.index3 && e.hasOwnProperty("index3") && !$util$1.isString(e.index3) ? "index3: string expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root$1.Session.CommonIndex) return e;
        var t = new $root$1.Session.CommonIndex();
        return null != e.index1 && (t.index1 = String(e.index1)), null != e.index2 && (t.index2 = String(e.index2)), null != e.index3 && (t.index3 = String(e.index3)), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};
        return t.defaults && (r.index1 = "", r.index2 = "", r.index3 = ""), null != e.index1 && e.hasOwnProperty("index1") && (r.index1 = e.index1), null != e.index2 && e.hasOwnProperty("index2") && (r.index2 = e.index2), null != e.index3 && e.hasOwnProperty("index3") && (r.index3 = e.index3), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      ApEvent = $root$1.ApEvent = function () {
    function e(e) {
      if (this.linkServerList = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.apAddr = "", e.prototype.linkServerList = $util$1.emptyArray, e.prototype.errCode = 0, e.prototype.serverErrCode = 0, e.prototype.isp = "", e.prototype.opId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.envId = 0, e.prototype.flag = 0, e.prototype.area = "", e.prototype.responseTime = 0, e.prototype.apLinkType = "", e.encode = function (e, t) {
      if (t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.apAddr && Object.hasOwnProperty.call(e, "apAddr") && t.uint32(50).string(e.apAddr), null != e.linkServerList && e.linkServerList.length) for (var r = 0; r < e.linkServerList.length; ++r) {
        t.uint32(58).string(e.linkServerList[r]);
      }
      return null != e.errCode && Object.hasOwnProperty.call(e, "errCode") && t.uint32(72).int32(e.errCode), null != e.serverErrCode && Object.hasOwnProperty.call(e, "serverErrCode") && t.uint32(80).int32(e.serverErrCode), null != e.isp && Object.hasOwnProperty.call(e, "isp") && t.uint32(90).string(e.isp), null != e.opId && Object.hasOwnProperty.call(e, "opId") && t.uint32(96).int64(e.opId), null != e.envId && Object.hasOwnProperty.call(e, "envId") && t.uint32(104).int32(e.envId), null != e.flag && Object.hasOwnProperty.call(e, "flag") && t.uint32(112).int32(e.flag), null != e.area && Object.hasOwnProperty.call(e, "area") && t.uint32(122).string(e.area), null != e.responseTime && Object.hasOwnProperty.call(e, "responseTime") && t.uint32(128).int32(e.responseTime), null != e.apLinkType && Object.hasOwnProperty.call(e, "apLinkType") && t.uint32(138).string(e.apLinkType), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.ApEvent(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.apAddr = e.string();
            break;

          case 7:
            n.linkServerList && n.linkServerList.length || (n.linkServerList = []), n.linkServerList.push(e.string());
            break;

          case 9:
            n.errCode = e.int32();
            break;

          case 10:
            n.serverErrCode = e.int32();
            break;

          case 11:
            n.isp = e.string();
            break;

          case 12:
            n.opId = e.int64();
            break;

          case 13:
            n.envId = e.int32();
            break;

          case 14:
            n.flag = e.int32();
            break;

          case 15:
            n.area = e.string();
            break;

          case 16:
            n.responseTime = e.int32();
            break;

          case 17:
            n.apLinkType = e.string();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid)) return "sid: string expected";
      if (null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId)) return "userId: string expected";
      if (null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high))) return "lts: integer|Long expected";
      if (null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high))) return "elapse: integer|Long expected";
      if (null != e.apAddr && e.hasOwnProperty("apAddr") && !$util$1.isString(e.apAddr)) return "apAddr: string expected";

      if (null != e.linkServerList && e.hasOwnProperty("linkServerList")) {
        if (!Array.isArray(e.linkServerList)) return "linkServerList: array expected";

        for (var t = 0; t < e.linkServerList.length; ++t) {
          if (!$util$1.isString(e.linkServerList[t])) return "linkServerList: string[] expected";
        }
      }

      return null != e.errCode && e.hasOwnProperty("errCode") && !$util$1.isInteger(e.errCode) ? "errCode: integer expected" : null != e.serverErrCode && e.hasOwnProperty("serverErrCode") && !$util$1.isInteger(e.serverErrCode) ? "serverErrCode: integer expected" : null != e.isp && e.hasOwnProperty("isp") && !$util$1.isString(e.isp) ? "isp: string expected" : null != e.opId && e.hasOwnProperty("opId") && !($util$1.isInteger(e.opId) || e.opId && $util$1.isInteger(e.opId.low) && $util$1.isInteger(e.opId.high)) ? "opId: integer|Long expected" : null != e.envId && e.hasOwnProperty("envId") && !$util$1.isInteger(e.envId) ? "envId: integer expected" : null != e.flag && e.hasOwnProperty("flag") && !$util$1.isInteger(e.flag) ? "flag: integer expected" : null != e.area && e.hasOwnProperty("area") && !$util$1.isString(e.area) ? "area: string expected" : null != e.responseTime && e.hasOwnProperty("responseTime") && !$util$1.isInteger(e.responseTime) ? "responseTime: integer expected" : null != e.apLinkType && e.hasOwnProperty("apLinkType") && !$util$1.isString(e.apLinkType) ? "apLinkType: string expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.ApEvent) return e;
      var t = new $root$1.ApEvent();

      if (null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.apAddr && (t.apAddr = String(e.apAddr)), e.linkServerList) {
        if (!Array.isArray(e.linkServerList)) throw TypeError(".ApEvent.linkServerList: array expected");
        t.linkServerList = [];

        for (var r = 0; r < e.linkServerList.length; ++r) {
          t.linkServerList[r] = String(e.linkServerList[r]);
        }
      }

      return null != e.errCode && (t.errCode = 0 | e.errCode), null != e.serverErrCode && (t.serverErrCode = 0 | e.serverErrCode), null != e.isp && (t.isp = String(e.isp)), null != e.opId && ($util$1.Long ? (t.opId = $util$1.Long.fromValue(e.opId)).unsigned = !1 : "string" == typeof e.opId ? t.opId = parseInt(e.opId, 10) : "number" == typeof e.opId ? t.opId = e.opId : "object" === _typeof(e.opId) && (t.opId = new $util$1.LongBits(e.opId.low >>> 0, e.opId.high >>> 0).toNumber())), null != e.envId && (t.envId = 0 | e.envId), null != e.flag && (t.flag = 0 | e.flag), null != e.area && (t.area = String(e.area)), null != e.responseTime && (t.responseTime = 0 | e.responseTime), null != e.apLinkType && (t.apLinkType = String(e.apLinkType)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if ((t.arrays || t.defaults) && (r.linkServerList = []), t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        if (r.apAddr = "", r.errCode = 0, r.serverErrCode = 0, r.isp = "", $util$1.Long) {
          var i = new $util$1.Long(0, 0, !1);
          r.opId = t.longs === String ? i.toString() : t.longs === Number ? i.toNumber() : i;
        } else r.opId = t.longs === String ? "0" : 0;

        r.envId = 0, r.flag = 0, r.area = "", r.responseTime = 0, r.apLinkType = "";
      }

      if (null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.apAddr && e.hasOwnProperty("apAddr") && (r.apAddr = e.apAddr), e.linkServerList && e.linkServerList.length) {
        r.linkServerList = [];

        for (var s = 0; s < e.linkServerList.length; ++s) {
          r.linkServerList[s] = e.linkServerList[s];
        }
      }

      return null != e.errCode && e.hasOwnProperty("errCode") && (r.errCode = e.errCode), null != e.serverErrCode && e.hasOwnProperty("serverErrCode") && (r.serverErrCode = e.serverErrCode), null != e.isp && e.hasOwnProperty("isp") && (r.isp = e.isp), null != e.opId && e.hasOwnProperty("opId") && ("number" == typeof e.opId ? r.opId = t.longs === String ? String(e.opId) : e.opId : r.opId = t.longs === String ? $util$1.Long.prototype.toString.call(e.opId) : t.longs === Number ? new $util$1.LongBits(e.opId.low >>> 0, e.opId.high >>> 0).toNumber() : e.opId), null != e.envId && e.hasOwnProperty("envId") && (r.envId = e.envId), null != e.flag && e.hasOwnProperty("flag") && (r.flag = e.flag), null != e.area && e.hasOwnProperty("area") && (r.area = e.area), null != e.responseTime && e.hasOwnProperty("responseTime") && (r.responseTime = e.responseTime), null != e.apLinkType && e.hasOwnProperty("apLinkType") && (r.apLinkType = e.apLinkType), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      Link = $root$1.Link = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.ec = 0, e.prototype.sc = 0, e.prototype.destServerIp = "", e.prototype.ackedServerIp = "", e.prototype.responseTime = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.ec && Object.hasOwnProperty.call(e, "ec") && t.uint32(40).int32(e.ec), null != e.sc && Object.hasOwnProperty.call(e, "sc") && t.uint32(48).int32(e.sc), null != e.destServerIp && Object.hasOwnProperty.call(e, "destServerIp") && t.uint32(58).string(e.destServerIp), null != e.ackedServerIp && Object.hasOwnProperty.call(e, "ackedServerIp") && t.uint32(66).string(e.ackedServerIp), null != e.responseTime && Object.hasOwnProperty.call(e, "responseTime") && t.uint32(72).int32(e.responseTime), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.Link(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 5:
            n.ec = e.int32();
            break;

          case 6:
            n.sc = e.int32();
            break;

          case 7:
            n.destServerIp = e.string();
            break;

          case 8:
            n.ackedServerIp = e.string();
            break;

          case 9:
            n.responseTime = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.ec && e.hasOwnProperty("ec") && !$util$1.isInteger(e.ec) ? "ec: integer expected" : null != e.sc && e.hasOwnProperty("sc") && !$util$1.isInteger(e.sc) ? "sc: integer expected" : null != e.destServerIp && e.hasOwnProperty("destServerIp") && !$util$1.isString(e.destServerIp) ? "destServerIp: string expected" : null != e.ackedServerIp && e.hasOwnProperty("ackedServerIp") && !$util$1.isString(e.ackedServerIp) ? "ackedServerIp: string expected" : null != e.responseTime && e.hasOwnProperty("responseTime") && !$util$1.isInteger(e.responseTime) ? "responseTime: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.Link) return e;
      var t = new $root$1.Link();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.ec && (t.ec = 0 | e.ec), null != e.sc && (t.sc = 0 | e.sc), null != e.destServerIp && (t.destServerIp = String(e.destServerIp)), null != e.ackedServerIp && (t.ackedServerIp = String(e.ackedServerIp)), null != e.responseTime && (t.responseTime = 0 | e.responseTime), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.ec = 0, r.sc = 0, r.destServerIp = "", r.ackedServerIp = "", r.responseTime = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.ec && e.hasOwnProperty("ec") && (r.ec = e.ec), null != e.sc && e.hasOwnProperty("sc") && (r.sc = e.sc), null != e.destServerIp && e.hasOwnProperty("destServerIp") && (r.destServerIp = e.destServerIp), null != e.ackedServerIp && e.hasOwnProperty("ackedServerIp") && (r.ackedServerIp = e.ackedServerIp), null != e.responseTime && e.hasOwnProperty("responseTime") && (r.responseTime = e.responseTime), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      Logout = $root$1.Logout = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.Logout(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.Logout) return e;
      var t = new $root$1.Logout();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      TxMessage = $root$1.TxMessage = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.insId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.dialId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.seq = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.srcId = "", e.prototype.dstId = "", e.prototype.dstType = 0, e.prototype.payload = "", e.prototype.messageId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.isOfflineMessage = !1, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.insId && Object.hasOwnProperty.call(e, "insId") && t.uint32(48).int64(e.insId), null != e.dialId && Object.hasOwnProperty.call(e, "dialId") && t.uint32(56).int64(e.dialId), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(64).int64(e.seq), null != e.srcId && Object.hasOwnProperty.call(e, "srcId") && t.uint32(74).string(e.srcId), null != e.dstId && Object.hasOwnProperty.call(e, "dstId") && t.uint32(82).string(e.dstId), null != e.dstType && Object.hasOwnProperty.call(e, "dstType") && t.uint32(88).int32(e.dstType), null != e.payload && Object.hasOwnProperty.call(e, "payload") && t.uint32(98).string(e.payload), null != e.messageId && Object.hasOwnProperty.call(e, "messageId") && t.uint32(104).int64(e.messageId), null != e.isOfflineMessage && Object.hasOwnProperty.call(e, "isOfflineMessage") && t.uint32(112).bool(e.isOfflineMessage), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.TxMessage(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.insId = e.int64();
            break;

          case 7:
            n.dialId = e.int64();
            break;

          case 8:
            n.seq = e.int64();
            break;

          case 9:
            n.srcId = e.string();
            break;

          case 10:
            n.dstId = e.string();
            break;

          case 11:
            n.dstType = e.int32();
            break;

          case 12:
            n.payload = e.string();
            break;

          case 13:
            n.messageId = e.int64();
            break;

          case 14:
            n.isOfflineMessage = e.bool();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.insId && e.hasOwnProperty("insId") && !($util$1.isInteger(e.insId) || e.insId && $util$1.isInteger(e.insId.low) && $util$1.isInteger(e.insId.high)) ? "insId: integer|Long expected" : null != e.dialId && e.hasOwnProperty("dialId") && !($util$1.isInteger(e.dialId) || e.dialId && $util$1.isInteger(e.dialId.low) && $util$1.isInteger(e.dialId.high)) ? "dialId: integer|Long expected" : null != e.seq && e.hasOwnProperty("seq") && !($util$1.isInteger(e.seq) || e.seq && $util$1.isInteger(e.seq.low) && $util$1.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.srcId && e.hasOwnProperty("srcId") && !$util$1.isString(e.srcId) ? "srcId: string expected" : null != e.dstId && e.hasOwnProperty("dstId") && !$util$1.isString(e.dstId) ? "dstId: string expected" : null != e.dstType && e.hasOwnProperty("dstType") && !$util$1.isInteger(e.dstType) ? "dstType: integer expected" : null != e.payload && e.hasOwnProperty("payload") && !$util$1.isString(e.payload) ? "payload: string expected" : null != e.messageId && e.hasOwnProperty("messageId") && !($util$1.isInteger(e.messageId) || e.messageId && $util$1.isInteger(e.messageId.low) && $util$1.isInteger(e.messageId.high)) ? "messageId: integer|Long expected" : null != e.isOfflineMessage && e.hasOwnProperty("isOfflineMessage") && "boolean" != typeof e.isOfflineMessage ? "isOfflineMessage: boolean expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.TxMessage) return e;
      var t = new $root$1.TxMessage();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.insId && ($util$1.Long ? (t.insId = $util$1.Long.fromValue(e.insId)).unsigned = !1 : "string" == typeof e.insId ? t.insId = parseInt(e.insId, 10) : "number" == typeof e.insId ? t.insId = e.insId : "object" === _typeof(e.insId) && (t.insId = new $util$1.LongBits(e.insId.low >>> 0, e.insId.high >>> 0).toNumber())), null != e.dialId && ($util$1.Long ? (t.dialId = $util$1.Long.fromValue(e.dialId)).unsigned = !1 : "string" == typeof e.dialId ? t.dialId = parseInt(e.dialId, 10) : "number" == typeof e.dialId ? t.dialId = e.dialId : "object" === _typeof(e.dialId) && (t.dialId = new $util$1.LongBits(e.dialId.low >>> 0, e.dialId.high >>> 0).toNumber())), null != e.seq && ($util$1.Long ? (t.seq = $util$1.Long.fromValue(e.seq)).unsigned = !1 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util$1.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber())), null != e.srcId && (t.srcId = String(e.srcId)), null != e.dstId && (t.dstId = String(e.dstId)), null != e.dstType && (t.dstType = 0 | e.dstType), null != e.payload && (t.payload = String(e.payload)), null != e.messageId && ($util$1.Long ? (t.messageId = $util$1.Long.fromValue(e.messageId)).unsigned = !1 : "string" == typeof e.messageId ? t.messageId = parseInt(e.messageId, 10) : "number" == typeof e.messageId ? t.messageId = e.messageId : "object" === _typeof(e.messageId) && (t.messageId = new $util$1.LongBits(e.messageId.low >>> 0, e.messageId.high >>> 0).toNumber())), null != e.isOfflineMessage && (t.isOfflineMessage = Boolean(e.isOfflineMessage)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var i = new $util$1.Long(0, 0, !1);
          r.insId = t.longs === String ? i.toString() : t.longs === Number ? i.toNumber() : i;
        } else r.insId = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var s = new $util$1.Long(0, 0, !1);
          r.dialId = t.longs === String ? s.toString() : t.longs === Number ? s.toNumber() : s;
        } else r.dialId = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var a = new $util$1.Long(0, 0, !1);
          r.seq = t.longs === String ? a.toString() : t.longs === Number ? a.toNumber() : a;
        } else r.seq = t.longs === String ? "0" : 0;

        if (r.srcId = "", r.dstId = "", r.dstType = 0, r.payload = "", $util$1.Long) {
          var u = new $util$1.Long(0, 0, !1);
          r.messageId = t.longs === String ? u.toString() : t.longs === Number ? u.toNumber() : u;
        } else r.messageId = t.longs === String ? "0" : 0;

        r.isOfflineMessage = !1;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.insId && e.hasOwnProperty("insId") && ("number" == typeof e.insId ? r.insId = t.longs === String ? String(e.insId) : e.insId : r.insId = t.longs === String ? $util$1.Long.prototype.toString.call(e.insId) : t.longs === Number ? new $util$1.LongBits(e.insId.low >>> 0, e.insId.high >>> 0).toNumber() : e.insId), null != e.dialId && e.hasOwnProperty("dialId") && ("number" == typeof e.dialId ? r.dialId = t.longs === String ? String(e.dialId) : e.dialId : r.dialId = t.longs === String ? $util$1.Long.prototype.toString.call(e.dialId) : t.longs === Number ? new $util$1.LongBits(e.dialId.low >>> 0, e.dialId.high >>> 0).toNumber() : e.dialId), null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util$1.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util$1.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber() : e.seq), null != e.srcId && e.hasOwnProperty("srcId") && (r.srcId = e.srcId), null != e.dstId && e.hasOwnProperty("dstId") && (r.dstId = e.dstId), null != e.dstType && e.hasOwnProperty("dstType") && (r.dstType = e.dstType), null != e.payload && e.hasOwnProperty("payload") && (r.payload = e.payload), null != e.messageId && e.hasOwnProperty("messageId") && ("number" == typeof e.messageId ? r.messageId = t.longs === String ? String(e.messageId) : e.messageId : r.messageId = t.longs === String ? $util$1.Long.prototype.toString.call(e.messageId) : t.longs === Number ? new $util$1.LongBits(e.messageId.low >>> 0, e.messageId.high >>> 0).toNumber() : e.messageId), null != e.isOfflineMessage && e.hasOwnProperty("isOfflineMessage") && (r.isOfflineMessage = e.isOfflineMessage), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      RxMessage = $root$1.RxMessage = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.insId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.dialId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.seq = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.srcId = "", e.prototype.dstId = "", e.prototype.dstType = 0, e.prototype.payload = "", e.prototype.messageId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.serverReceivedTs = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.isOfflineMessage = !1, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.insId && Object.hasOwnProperty.call(e, "insId") && t.uint32(48).int64(e.insId), null != e.dialId && Object.hasOwnProperty.call(e, "dialId") && t.uint32(56).int64(e.dialId), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(64).int64(e.seq), null != e.srcId && Object.hasOwnProperty.call(e, "srcId") && t.uint32(74).string(e.srcId), null != e.dstId && Object.hasOwnProperty.call(e, "dstId") && t.uint32(82).string(e.dstId), null != e.dstType && Object.hasOwnProperty.call(e, "dstType") && t.uint32(88).int32(e.dstType), null != e.payload && Object.hasOwnProperty.call(e, "payload") && t.uint32(98).string(e.payload), null != e.messageId && Object.hasOwnProperty.call(e, "messageId") && t.uint32(104).int64(e.messageId), null != e.serverReceivedTs && Object.hasOwnProperty.call(e, "serverReceivedTs") && t.uint32(112).int64(e.serverReceivedTs), null != e.isOfflineMessage && Object.hasOwnProperty.call(e, "isOfflineMessage") && t.uint32(120).bool(e.isOfflineMessage), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.RxMessage(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.insId = e.int64();
            break;

          case 7:
            n.dialId = e.int64();
            break;

          case 8:
            n.seq = e.int64();
            break;

          case 9:
            n.srcId = e.string();
            break;

          case 10:
            n.dstId = e.string();
            break;

          case 11:
            n.dstType = e.int32();
            break;

          case 12:
            n.payload = e.string();
            break;

          case 13:
            n.messageId = e.int64();
            break;

          case 14:
            n.serverReceivedTs = e.int64();
            break;

          case 15:
            n.isOfflineMessage = e.bool();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.insId && e.hasOwnProperty("insId") && !($util$1.isInteger(e.insId) || e.insId && $util$1.isInteger(e.insId.low) && $util$1.isInteger(e.insId.high)) ? "insId: integer|Long expected" : null != e.dialId && e.hasOwnProperty("dialId") && !($util$1.isInteger(e.dialId) || e.dialId && $util$1.isInteger(e.dialId.low) && $util$1.isInteger(e.dialId.high)) ? "dialId: integer|Long expected" : null != e.seq && e.hasOwnProperty("seq") && !($util$1.isInteger(e.seq) || e.seq && $util$1.isInteger(e.seq.low) && $util$1.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.srcId && e.hasOwnProperty("srcId") && !$util$1.isString(e.srcId) ? "srcId: string expected" : null != e.dstId && e.hasOwnProperty("dstId") && !$util$1.isString(e.dstId) ? "dstId: string expected" : null != e.dstType && e.hasOwnProperty("dstType") && !$util$1.isInteger(e.dstType) ? "dstType: integer expected" : null != e.payload && e.hasOwnProperty("payload") && !$util$1.isString(e.payload) ? "payload: string expected" : null != e.messageId && e.hasOwnProperty("messageId") && !($util$1.isInteger(e.messageId) || e.messageId && $util$1.isInteger(e.messageId.low) && $util$1.isInteger(e.messageId.high)) ? "messageId: integer|Long expected" : null != e.serverReceivedTs && e.hasOwnProperty("serverReceivedTs") && !($util$1.isInteger(e.serverReceivedTs) || e.serverReceivedTs && $util$1.isInteger(e.serverReceivedTs.low) && $util$1.isInteger(e.serverReceivedTs.high)) ? "serverReceivedTs: integer|Long expected" : null != e.isOfflineMessage && e.hasOwnProperty("isOfflineMessage") && "boolean" != typeof e.isOfflineMessage ? "isOfflineMessage: boolean expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.RxMessage) return e;
      var t = new $root$1.RxMessage();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.insId && ($util$1.Long ? (t.insId = $util$1.Long.fromValue(e.insId)).unsigned = !1 : "string" == typeof e.insId ? t.insId = parseInt(e.insId, 10) : "number" == typeof e.insId ? t.insId = e.insId : "object" === _typeof(e.insId) && (t.insId = new $util$1.LongBits(e.insId.low >>> 0, e.insId.high >>> 0).toNumber())), null != e.dialId && ($util$1.Long ? (t.dialId = $util$1.Long.fromValue(e.dialId)).unsigned = !1 : "string" == typeof e.dialId ? t.dialId = parseInt(e.dialId, 10) : "number" == typeof e.dialId ? t.dialId = e.dialId : "object" === _typeof(e.dialId) && (t.dialId = new $util$1.LongBits(e.dialId.low >>> 0, e.dialId.high >>> 0).toNumber())), null != e.seq && ($util$1.Long ? (t.seq = $util$1.Long.fromValue(e.seq)).unsigned = !1 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util$1.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber())), null != e.srcId && (t.srcId = String(e.srcId)), null != e.dstId && (t.dstId = String(e.dstId)), null != e.dstType && (t.dstType = 0 | e.dstType), null != e.payload && (t.payload = String(e.payload)), null != e.messageId && ($util$1.Long ? (t.messageId = $util$1.Long.fromValue(e.messageId)).unsigned = !1 : "string" == typeof e.messageId ? t.messageId = parseInt(e.messageId, 10) : "number" == typeof e.messageId ? t.messageId = e.messageId : "object" === _typeof(e.messageId) && (t.messageId = new $util$1.LongBits(e.messageId.low >>> 0, e.messageId.high >>> 0).toNumber())), null != e.serverReceivedTs && ($util$1.Long ? (t.serverReceivedTs = $util$1.Long.fromValue(e.serverReceivedTs)).unsigned = !1 : "string" == typeof e.serverReceivedTs ? t.serverReceivedTs = parseInt(e.serverReceivedTs, 10) : "number" == typeof e.serverReceivedTs ? t.serverReceivedTs = e.serverReceivedTs : "object" === _typeof(e.serverReceivedTs) && (t.serverReceivedTs = new $util$1.LongBits(e.serverReceivedTs.low >>> 0, e.serverReceivedTs.high >>> 0).toNumber())), null != e.isOfflineMessage && (t.isOfflineMessage = Boolean(e.isOfflineMessage)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var i = new $util$1.Long(0, 0, !1);
          r.insId = t.longs === String ? i.toString() : t.longs === Number ? i.toNumber() : i;
        } else r.insId = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var s = new $util$1.Long(0, 0, !1);
          r.dialId = t.longs === String ? s.toString() : t.longs === Number ? s.toNumber() : s;
        } else r.dialId = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var a = new $util$1.Long(0, 0, !1);
          r.seq = t.longs === String ? a.toString() : t.longs === Number ? a.toNumber() : a;
        } else r.seq = t.longs === String ? "0" : 0;

        if (r.srcId = "", r.dstId = "", r.dstType = 0, r.payload = "", $util$1.Long) {
          var u = new $util$1.Long(0, 0, !1);
          r.messageId = t.longs === String ? u.toString() : t.longs === Number ? u.toNumber() : u;
        } else r.messageId = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var l = new $util$1.Long(0, 0, !1);
          r.serverReceivedTs = t.longs === String ? l.toString() : t.longs === Number ? l.toNumber() : l;
        } else r.serverReceivedTs = t.longs === String ? "0" : 0;

        r.isOfflineMessage = !1;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.insId && e.hasOwnProperty("insId") && ("number" == typeof e.insId ? r.insId = t.longs === String ? String(e.insId) : e.insId : r.insId = t.longs === String ? $util$1.Long.prototype.toString.call(e.insId) : t.longs === Number ? new $util$1.LongBits(e.insId.low >>> 0, e.insId.high >>> 0).toNumber() : e.insId), null != e.dialId && e.hasOwnProperty("dialId") && ("number" == typeof e.dialId ? r.dialId = t.longs === String ? String(e.dialId) : e.dialId : r.dialId = t.longs === String ? $util$1.Long.prototype.toString.call(e.dialId) : t.longs === Number ? new $util$1.LongBits(e.dialId.low >>> 0, e.dialId.high >>> 0).toNumber() : e.dialId), null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util$1.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util$1.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber() : e.seq), null != e.srcId && e.hasOwnProperty("srcId") && (r.srcId = e.srcId), null != e.dstId && e.hasOwnProperty("dstId") && (r.dstId = e.dstId), null != e.dstType && e.hasOwnProperty("dstType") && (r.dstType = e.dstType), null != e.payload && e.hasOwnProperty("payload") && (r.payload = e.payload), null != e.messageId && e.hasOwnProperty("messageId") && ("number" == typeof e.messageId ? r.messageId = t.longs === String ? String(e.messageId) : e.messageId : r.messageId = t.longs === String ? $util$1.Long.prototype.toString.call(e.messageId) : t.longs === Number ? new $util$1.LongBits(e.messageId.low >>> 0, e.messageId.high >>> 0).toNumber() : e.messageId), null != e.serverReceivedTs && e.hasOwnProperty("serverReceivedTs") && ("number" == typeof e.serverReceivedTs ? r.serverReceivedTs = t.longs === String ? String(e.serverReceivedTs) : e.serverReceivedTs : r.serverReceivedTs = t.longs === String ? $util$1.Long.prototype.toString.call(e.serverReceivedTs) : t.longs === Number ? new $util$1.LongBits(e.serverReceivedTs.low >>> 0, e.serverReceivedTs.high >>> 0).toNumber() : e.serverReceivedTs), null != e.isOfflineMessage && e.hasOwnProperty("isOfflineMessage") && (r.isOfflineMessage = e.isOfflineMessage), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      KickedOff = $root$1.KickedOff = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.linkId = 0, e.prototype.code = 0, e.prototype.server = "", e.prototype.serverCode = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.linkId && Object.hasOwnProperty.call(e, "linkId") && t.uint32(48).int32(e.linkId), null != e.code && Object.hasOwnProperty.call(e, "code") && t.uint32(56).int32(e.code), null != e.server && Object.hasOwnProperty.call(e, "server") && t.uint32(66).string(e.server), null != e.serverCode && Object.hasOwnProperty.call(e, "serverCode") && t.uint32(72).int32(e.serverCode), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.KickedOff(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.linkId = e.int32();
            break;

          case 7:
            n.code = e.int32();
            break;

          case 8:
            n.server = e.string();
            break;

          case 9:
            n.serverCode = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.linkId && e.hasOwnProperty("linkId") && !$util$1.isInteger(e.linkId) ? "linkId: integer expected" : null != e.code && e.hasOwnProperty("code") && !$util$1.isInteger(e.code) ? "code: integer expected" : null != e.server && e.hasOwnProperty("server") && !$util$1.isString(e.server) ? "server: string expected" : null != e.serverCode && e.hasOwnProperty("serverCode") && !$util$1.isInteger(e.serverCode) ? "serverCode: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.KickedOff) return e;
      var t = new $root$1.KickedOff();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.linkId && (t.linkId = 0 | e.linkId), null != e.code && (t.code = 0 | e.code), null != e.server && (t.server = String(e.server)), null != e.serverCode && (t.serverCode = 0 | e.serverCode), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.linkId = 0, r.code = 0, r.server = "", r.serverCode = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.linkId && e.hasOwnProperty("linkId") && (r.linkId = e.linkId), null != e.code && e.hasOwnProperty("code") && (r.code = e.code), null != e.server && e.hasOwnProperty("server") && (r.server = e.server), null != e.serverCode && e.hasOwnProperty("serverCode") && (r.serverCode = e.serverCode), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      TxMessageRes = $root$1.TxMessageRes = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.insId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.dialId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.seq = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.srcId = "", e.prototype.dstId = "", e.prototype.dstType = 0, e.prototype.messageId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.errCode = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.insId && Object.hasOwnProperty.call(e, "insId") && t.uint32(48).int64(e.insId), null != e.dialId && Object.hasOwnProperty.call(e, "dialId") && t.uint32(56).int64(e.dialId), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(64).int64(e.seq), null != e.srcId && Object.hasOwnProperty.call(e, "srcId") && t.uint32(74).string(e.srcId), null != e.dstId && Object.hasOwnProperty.call(e, "dstId") && t.uint32(82).string(e.dstId), null != e.dstType && Object.hasOwnProperty.call(e, "dstType") && t.uint32(88).int32(e.dstType), null != e.messageId && Object.hasOwnProperty.call(e, "messageId") && t.uint32(96).int64(e.messageId), null != e.errCode && Object.hasOwnProperty.call(e, "errCode") && t.uint32(104).int32(e.errCode), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.TxMessageRes(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.insId = e.int64();
            break;

          case 7:
            n.dialId = e.int64();
            break;

          case 8:
            n.seq = e.int64();
            break;

          case 9:
            n.srcId = e.string();
            break;

          case 10:
            n.dstId = e.string();
            break;

          case 11:
            n.dstType = e.int32();
            break;

          case 12:
            n.messageId = e.int64();
            break;

          case 13:
            n.errCode = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.insId && e.hasOwnProperty("insId") && !($util$1.isInteger(e.insId) || e.insId && $util$1.isInteger(e.insId.low) && $util$1.isInteger(e.insId.high)) ? "insId: integer|Long expected" : null != e.dialId && e.hasOwnProperty("dialId") && !($util$1.isInteger(e.dialId) || e.dialId && $util$1.isInteger(e.dialId.low) && $util$1.isInteger(e.dialId.high)) ? "dialId: integer|Long expected" : null != e.seq && e.hasOwnProperty("seq") && !($util$1.isInteger(e.seq) || e.seq && $util$1.isInteger(e.seq.low) && $util$1.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.srcId && e.hasOwnProperty("srcId") && !$util$1.isString(e.srcId) ? "srcId: string expected" : null != e.dstId && e.hasOwnProperty("dstId") && !$util$1.isString(e.dstId) ? "dstId: string expected" : null != e.dstType && e.hasOwnProperty("dstType") && !$util$1.isInteger(e.dstType) ? "dstType: integer expected" : null != e.messageId && e.hasOwnProperty("messageId") && !($util$1.isInteger(e.messageId) || e.messageId && $util$1.isInteger(e.messageId.low) && $util$1.isInteger(e.messageId.high)) ? "messageId: integer|Long expected" : null != e.errCode && e.hasOwnProperty("errCode") && !$util$1.isInteger(e.errCode) ? "errCode: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.TxMessageRes) return e;
      var t = new $root$1.TxMessageRes();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.insId && ($util$1.Long ? (t.insId = $util$1.Long.fromValue(e.insId)).unsigned = !1 : "string" == typeof e.insId ? t.insId = parseInt(e.insId, 10) : "number" == typeof e.insId ? t.insId = e.insId : "object" === _typeof(e.insId) && (t.insId = new $util$1.LongBits(e.insId.low >>> 0, e.insId.high >>> 0).toNumber())), null != e.dialId && ($util$1.Long ? (t.dialId = $util$1.Long.fromValue(e.dialId)).unsigned = !1 : "string" == typeof e.dialId ? t.dialId = parseInt(e.dialId, 10) : "number" == typeof e.dialId ? t.dialId = e.dialId : "object" === _typeof(e.dialId) && (t.dialId = new $util$1.LongBits(e.dialId.low >>> 0, e.dialId.high >>> 0).toNumber())), null != e.seq && ($util$1.Long ? (t.seq = $util$1.Long.fromValue(e.seq)).unsigned = !1 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util$1.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber())), null != e.srcId && (t.srcId = String(e.srcId)), null != e.dstId && (t.dstId = String(e.dstId)), null != e.dstType && (t.dstType = 0 | e.dstType), null != e.messageId && ($util$1.Long ? (t.messageId = $util$1.Long.fromValue(e.messageId)).unsigned = !1 : "string" == typeof e.messageId ? t.messageId = parseInt(e.messageId, 10) : "number" == typeof e.messageId ? t.messageId = e.messageId : "object" === _typeof(e.messageId) && (t.messageId = new $util$1.LongBits(e.messageId.low >>> 0, e.messageId.high >>> 0).toNumber())), null != e.errCode && (t.errCode = 0 | e.errCode), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var i = new $util$1.Long(0, 0, !1);
          r.insId = t.longs === String ? i.toString() : t.longs === Number ? i.toNumber() : i;
        } else r.insId = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var s = new $util$1.Long(0, 0, !1);
          r.dialId = t.longs === String ? s.toString() : t.longs === Number ? s.toNumber() : s;
        } else r.dialId = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var a = new $util$1.Long(0, 0, !1);
          r.seq = t.longs === String ? a.toString() : t.longs === Number ? a.toNumber() : a;
        } else r.seq = t.longs === String ? "0" : 0;

        if (r.srcId = "", r.dstId = "", r.dstType = 0, $util$1.Long) {
          var u = new $util$1.Long(0, 0, !1);
          r.messageId = t.longs === String ? u.toString() : t.longs === Number ? u.toNumber() : u;
        } else r.messageId = t.longs === String ? "0" : 0;

        r.errCode = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.insId && e.hasOwnProperty("insId") && ("number" == typeof e.insId ? r.insId = t.longs === String ? String(e.insId) : e.insId : r.insId = t.longs === String ? $util$1.Long.prototype.toString.call(e.insId) : t.longs === Number ? new $util$1.LongBits(e.insId.low >>> 0, e.insId.high >>> 0).toNumber() : e.insId), null != e.dialId && e.hasOwnProperty("dialId") && ("number" == typeof e.dialId ? r.dialId = t.longs === String ? String(e.dialId) : e.dialId : r.dialId = t.longs === String ? $util$1.Long.prototype.toString.call(e.dialId) : t.longs === Number ? new $util$1.LongBits(e.dialId.low >>> 0, e.dialId.high >>> 0).toNumber() : e.dialId), null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util$1.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util$1.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber() : e.seq), null != e.srcId && e.hasOwnProperty("srcId") && (r.srcId = e.srcId), null != e.dstId && e.hasOwnProperty("dstId") && (r.dstId = e.dstId), null != e.dstType && e.hasOwnProperty("dstType") && (r.dstType = e.dstType), null != e.messageId && e.hasOwnProperty("messageId") && ("number" == typeof e.messageId ? r.messageId = t.longs === String ? String(e.messageId) : e.messageId : r.messageId = t.longs === String ? $util$1.Long.prototype.toString.call(e.messageId) : t.longs === Number ? new $util$1.LongBits(e.messageId.low >>> 0, e.messageId.high >>> 0).toNumber() : e.messageId), null != e.errCode && e.hasOwnProperty("errCode") && (r.errCode = e.errCode), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      ChnJoin = $root$1.ChnJoin = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.cname = "", e.prototype.errCode = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.cname && Object.hasOwnProperty.call(e, "cname") && t.uint32(50).string(e.cname), null != e.errCode && Object.hasOwnProperty.call(e, "errCode") && t.uint32(56).int32(e.errCode), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.ChnJoin(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.cname = e.string();
            break;

          case 7:
            n.errCode = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.cname && e.hasOwnProperty("cname") && !$util$1.isString(e.cname) ? "cname: string expected" : null != e.errCode && e.hasOwnProperty("errCode") && !$util$1.isInteger(e.errCode) ? "errCode: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.ChnJoin) return e;
      var t = new $root$1.ChnJoin();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.cname && (t.cname = String(e.cname)), null != e.errCode && (t.errCode = 0 | e.errCode), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.cname = "", r.errCode = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.cname && e.hasOwnProperty("cname") && (r.cname = e.cname), null != e.errCode && e.hasOwnProperty("errCode") && (r.errCode = e.errCode), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      ChnJoinRes = $root$1.ChnJoinRes = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.cname = "", e.prototype.errCode = 0, e.prototype.serverErrCode = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.cname && Object.hasOwnProperty.call(e, "cname") && t.uint32(50).string(e.cname), null != e.errCode && Object.hasOwnProperty.call(e, "errCode") && t.uint32(56).int32(e.errCode), null != e.serverErrCode && Object.hasOwnProperty.call(e, "serverErrCode") && t.uint32(64).int32(e.serverErrCode), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.ChnJoinRes(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.cname = e.string();
            break;

          case 7:
            n.errCode = e.int32();
            break;

          case 8:
            n.serverErrCode = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.cname && e.hasOwnProperty("cname") && !$util$1.isString(e.cname) ? "cname: string expected" : null != e.errCode && e.hasOwnProperty("errCode") && !$util$1.isInteger(e.errCode) ? "errCode: integer expected" : null != e.serverErrCode && e.hasOwnProperty("serverErrCode") && !$util$1.isInteger(e.serverErrCode) ? "serverErrCode: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.ChnJoinRes) return e;
      var t = new $root$1.ChnJoinRes();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.cname && (t.cname = String(e.cname)), null != e.errCode && (t.errCode = 0 | e.errCode), null != e.serverErrCode && (t.serverErrCode = 0 | e.serverErrCode), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.cname = "", r.errCode = 0, r.serverErrCode = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.cname && e.hasOwnProperty("cname") && (r.cname = e.cname), null != e.errCode && e.hasOwnProperty("errCode") && (r.errCode = e.errCode), null != e.serverErrCode && e.hasOwnProperty("serverErrCode") && (r.serverErrCode = e.serverErrCode), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      ChnLeave = $root$1.ChnLeave = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.cname = "", e.prototype.errCode = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.cname && Object.hasOwnProperty.call(e, "cname") && t.uint32(50).string(e.cname), null != e.errCode && Object.hasOwnProperty.call(e, "errCode") && t.uint32(56).int32(e.errCode), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.ChnLeave(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.cname = e.string();
            break;

          case 7:
            n.errCode = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.cname && e.hasOwnProperty("cname") && !$util$1.isString(e.cname) ? "cname: string expected" : null != e.errCode && e.hasOwnProperty("errCode") && !$util$1.isInteger(e.errCode) ? "errCode: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.ChnLeave) return e;
      var t = new $root$1.ChnLeave();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.cname && (t.cname = String(e.cname)), null != e.errCode && (t.errCode = 0 | e.errCode), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.cname = "", r.errCode = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.cname && e.hasOwnProperty("cname") && (r.cname = e.cname), null != e.errCode && e.hasOwnProperty("errCode") && (r.errCode = e.errCode), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      ChnGetMembers = $root$1.ChnGetMembers = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.cname = "", e.prototype.errCode = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.cname && Object.hasOwnProperty.call(e, "cname") && t.uint32(50).string(e.cname), null != e.errCode && Object.hasOwnProperty.call(e, "errCode") && t.uint32(56).int32(e.errCode), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.ChnGetMembers(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.cname = e.string();
            break;

          case 7:
            n.errCode = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.cname && e.hasOwnProperty("cname") && !$util$1.isString(e.cname) ? "cname: string expected" : null != e.errCode && e.hasOwnProperty("errCode") && !$util$1.isInteger(e.errCode) ? "errCode: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.ChnGetMembers) return e;
      var t = new $root$1.ChnGetMembers();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.cname && (t.cname = String(e.cname)), null != e.errCode && (t.errCode = 0 | e.errCode), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.cname = "", r.errCode = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.cname && e.hasOwnProperty("cname") && (r.cname = e.cname), null != e.errCode && e.hasOwnProperty("errCode") && (r.errCode = e.errCode), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      ChnGetMembersRes = $root$1.ChnGetMembersRes = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.cname = "", e.prototype.errCode = 0, e.prototype.size = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.cname && Object.hasOwnProperty.call(e, "cname") && t.uint32(50).string(e.cname), null != e.errCode && Object.hasOwnProperty.call(e, "errCode") && t.uint32(56).int32(e.errCode), null != e.size && Object.hasOwnProperty.call(e, "size") && t.uint32(64).int32(e.size), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.ChnGetMembersRes(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.cname = e.string();
            break;

          case 7:
            n.errCode = e.int32();
            break;

          case 8:
            n.size = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.cname && e.hasOwnProperty("cname") && !$util$1.isString(e.cname) ? "cname: string expected" : null != e.errCode && e.hasOwnProperty("errCode") && !$util$1.isInteger(e.errCode) ? "errCode: integer expected" : null != e.size && e.hasOwnProperty("size") && !$util$1.isInteger(e.size) ? "size: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.ChnGetMembersRes) return e;
      var t = new $root$1.ChnGetMembersRes();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.cname && (t.cname = String(e.cname)), null != e.errCode && (t.errCode = 0 | e.errCode), null != e.size && (t.size = 0 | e.size), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.cname = "", r.errCode = 0, r.size = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.cname && e.hasOwnProperty("cname") && (r.cname = e.cname), null != e.errCode && e.hasOwnProperty("errCode") && (r.errCode = e.errCode), null != e.size && e.hasOwnProperty("size") && (r.size = e.size), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      ChnMemberJoined = $root$1.ChnMemberJoined = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.cname = "", e.prototype.memberId = "", e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.cname && Object.hasOwnProperty.call(e, "cname") && t.uint32(50).string(e.cname), null != e.memberId && Object.hasOwnProperty.call(e, "memberId") && t.uint32(58).string(e.memberId), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.ChnMemberJoined(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.cname = e.string();
            break;

          case 7:
            n.memberId = e.string();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.cname && e.hasOwnProperty("cname") && !$util$1.isString(e.cname) ? "cname: string expected" : null != e.memberId && e.hasOwnProperty("memberId") && !$util$1.isString(e.memberId) ? "memberId: string expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.ChnMemberJoined) return e;
      var t = new $root$1.ChnMemberJoined();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.cname && (t.cname = String(e.cname)), null != e.memberId && (t.memberId = String(e.memberId)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.cname = "", r.memberId = "";
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.cname && e.hasOwnProperty("cname") && (r.cname = e.cname), null != e.memberId && e.hasOwnProperty("memberId") && (r.memberId = e.memberId), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      ChnMemberLeft = $root$1.ChnMemberLeft = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.cname = "", e.prototype.memberId = "", e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.cname && Object.hasOwnProperty.call(e, "cname") && t.uint32(50).string(e.cname), null != e.memberId && Object.hasOwnProperty.call(e, "memberId") && t.uint32(58).string(e.memberId), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.ChnMemberLeft(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.cname = e.string();
            break;

          case 7:
            n.memberId = e.string();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.cname && e.hasOwnProperty("cname") && !$util$1.isString(e.cname) ? "cname: string expected" : null != e.memberId && e.hasOwnProperty("memberId") && !$util$1.isString(e.memberId) ? "memberId: string expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.ChnMemberLeft) return e;
      var t = new $root$1.ChnMemberLeft();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.cname && (t.cname = String(e.cname)), null != e.memberId && (t.memberId = String(e.memberId)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.cname = "", r.memberId = "";
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.cname && e.hasOwnProperty("cname") && (r.cname = e.cname), null != e.memberId && e.hasOwnProperty("memberId") && (r.memberId = e.memberId), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      QueryPeersOnlineStatus = $root$1.QueryPeersOnlineStatus = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.peerCount = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.peerCount && Object.hasOwnProperty.call(e, "peerCount") && t.uint32(48).int32(e.peerCount), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.QueryPeersOnlineStatus(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.peerCount = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.peerCount && e.hasOwnProperty("peerCount") && !$util$1.isInteger(e.peerCount) ? "peerCount: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.QueryPeersOnlineStatus) return e;
      var t = new $root$1.QueryPeersOnlineStatus();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.peerCount && (t.peerCount = 0 | e.peerCount), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.peerCount = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.peerCount && e.hasOwnProperty("peerCount") && (r.peerCount = e.peerCount), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      QueryPeersOnlineStatusRes = $root$1.QueryPeersOnlineStatusRes = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.peerCount = 0, e.prototype.errCode = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.peerCount && Object.hasOwnProperty.call(e, "peerCount") && t.uint32(48).int32(e.peerCount), null != e.errCode && Object.hasOwnProperty.call(e, "errCode") && t.uint32(56).int32(e.errCode), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.QueryPeersOnlineStatusRes(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.peerCount = e.int32();
            break;

          case 7:
            n.errCode = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.peerCount && e.hasOwnProperty("peerCount") && !$util$1.isInteger(e.peerCount) ? "peerCount: integer expected" : null != e.errCode && e.hasOwnProperty("errCode") && !$util$1.isInteger(e.errCode) ? "errCode: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.QueryPeersOnlineStatusRes) return e;
      var t = new $root$1.QueryPeersOnlineStatusRes();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.peerCount && (t.peerCount = 0 | e.peerCount), null != e.errCode && (t.errCode = 0 | e.errCode), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.peerCount = 0, r.errCode = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.peerCount && e.hasOwnProperty("peerCount") && (r.peerCount = e.peerCount), null != e.errCode && e.hasOwnProperty("errCode") && (r.errCode = e.errCode), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      RenewToken = $root$1.RenewToken = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.cname = "", e.prototype.token = "", e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.cname && Object.hasOwnProperty.call(e, "cname") && t.uint32(50).string(e.cname), null != e.token && Object.hasOwnProperty.call(e, "token") && t.uint32(58).string(e.token), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.RenewToken(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 6:
            n.cname = e.string();
            break;

          case 7:
            n.token = e.string();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.cname && e.hasOwnProperty("cname") && !$util$1.isString(e.cname) ? "cname: string expected" : null != e.token && e.hasOwnProperty("token") && !$util$1.isString(e.token) ? "token: string expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.RenewToken) return e;
      var t = new $root$1.RenewToken();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.cname && (t.cname = String(e.cname)), null != e.token && (t.token = String(e.token)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.cname = "", r.token = "";
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.cname && e.hasOwnProperty("cname") && (r.cname = e.cname), null != e.token && e.hasOwnProperty("token") && (r.token = e.token), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      OperateAttribute = $root$1.OperateAttribute = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.cname = "", e.prototype.destId = "", e.prototype.attributeType = 0, e.prototype.operationType = 0, e.prototype.seq = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.cname && Object.hasOwnProperty.call(e, "cname") && t.uint32(42).string(e.cname), null != e.destId && Object.hasOwnProperty.call(e, "destId") && t.uint32(50).string(e.destId), null != e.attributeType && Object.hasOwnProperty.call(e, "attributeType") && t.uint32(56).int32(e.attributeType), null != e.operationType && Object.hasOwnProperty.call(e, "operationType") && t.uint32(64).int32(e.operationType), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(72).int64(e.seq), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.OperateAttribute(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 5:
            n.cname = e.string();
            break;

          case 6:
            n.destId = e.string();
            break;

          case 7:
            n.attributeType = e.int32();
            break;

          case 8:
            n.operationType = e.int32();
            break;

          case 9:
            n.seq = e.int64();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.cname && e.hasOwnProperty("cname") && !$util$1.isString(e.cname) ? "cname: string expected" : null != e.destId && e.hasOwnProperty("destId") && !$util$1.isString(e.destId) ? "destId: string expected" : null != e.attributeType && e.hasOwnProperty("attributeType") && !$util$1.isInteger(e.attributeType) ? "attributeType: integer expected" : null != e.operationType && e.hasOwnProperty("operationType") && !$util$1.isInteger(e.operationType) ? "operationType: integer expected" : null != e.seq && e.hasOwnProperty("seq") && !($util$1.isInteger(e.seq) || e.seq && $util$1.isInteger(e.seq.low) && $util$1.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.OperateAttribute) return e;
      var t = new $root$1.OperateAttribute();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.cname && (t.cname = String(e.cname)), null != e.destId && (t.destId = String(e.destId)), null != e.attributeType && (t.attributeType = 0 | e.attributeType), null != e.operationType && (t.operationType = 0 | e.operationType), null != e.seq && ($util$1.Long ? (t.seq = $util$1.Long.fromValue(e.seq)).unsigned = !1 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util$1.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber())), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        if (r.cname = "", r.destId = "", r.attributeType = 0, r.operationType = 0, $util$1.Long) {
          var i = new $util$1.Long(0, 0, !1);
          r.seq = t.longs === String ? i.toString() : t.longs === Number ? i.toNumber() : i;
        } else r.seq = t.longs === String ? "0" : 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.cname && e.hasOwnProperty("cname") && (r.cname = e.cname), null != e.destId && e.hasOwnProperty("destId") && (r.destId = e.destId), null != e.attributeType && e.hasOwnProperty("attributeType") && (r.attributeType = e.attributeType), null != e.operationType && e.hasOwnProperty("operationType") && (r.operationType = e.operationType), null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util$1.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util$1.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber() : e.seq), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      OperateAttributeRes = $root$1.OperateAttributeRes = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.cname = "", e.prototype.destId = "", e.prototype.attributeType = 0, e.prototype.seq = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.code = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.cname && Object.hasOwnProperty.call(e, "cname") && t.uint32(42).string(e.cname), null != e.destId && Object.hasOwnProperty.call(e, "destId") && t.uint32(50).string(e.destId), null != e.attributeType && Object.hasOwnProperty.call(e, "attributeType") && t.uint32(56).int32(e.attributeType), null != e.seq && Object.hasOwnProperty.call(e, "seq") && t.uint32(64).int64(e.seq), null != e.code && Object.hasOwnProperty.call(e, "code") && t.uint32(72).int32(e.code), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.OperateAttributeRes(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 5:
            n.cname = e.string();
            break;

          case 6:
            n.destId = e.string();
            break;

          case 7:
            n.attributeType = e.int32();
            break;

          case 8:
            n.seq = e.int64();
            break;

          case 9:
            n.code = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.cname && e.hasOwnProperty("cname") && !$util$1.isString(e.cname) ? "cname: string expected" : null != e.destId && e.hasOwnProperty("destId") && !$util$1.isString(e.destId) ? "destId: string expected" : null != e.attributeType && e.hasOwnProperty("attributeType") && !$util$1.isInteger(e.attributeType) ? "attributeType: integer expected" : null != e.seq && e.hasOwnProperty("seq") && !($util$1.isInteger(e.seq) || e.seq && $util$1.isInteger(e.seq.low) && $util$1.isInteger(e.seq.high)) ? "seq: integer|Long expected" : null != e.code && e.hasOwnProperty("code") && !$util$1.isInteger(e.code) ? "code: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.OperateAttributeRes) return e;
      var t = new $root$1.OperateAttributeRes();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.cname && (t.cname = String(e.cname)), null != e.destId && (t.destId = String(e.destId)), null != e.attributeType && (t.attributeType = 0 | e.attributeType), null != e.seq && ($util$1.Long ? (t.seq = $util$1.Long.fromValue(e.seq)).unsigned = !1 : "string" == typeof e.seq ? t.seq = parseInt(e.seq, 10) : "number" == typeof e.seq ? t.seq = e.seq : "object" === _typeof(e.seq) && (t.seq = new $util$1.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber())), null != e.code && (t.code = 0 | e.code), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        if (r.cname = "", r.destId = "", r.attributeType = 0, $util$1.Long) {
          var i = new $util$1.Long(0, 0, !1);
          r.seq = t.longs === String ? i.toString() : t.longs === Number ? i.toNumber() : i;
        } else r.seq = t.longs === String ? "0" : 0;

        r.code = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.cname && e.hasOwnProperty("cname") && (r.cname = e.cname), null != e.destId && e.hasOwnProperty("destId") && (r.destId = e.destId), null != e.attributeType && e.hasOwnProperty("attributeType") && (r.attributeType = e.attributeType), null != e.seq && e.hasOwnProperty("seq") && ("number" == typeof e.seq ? r.seq = t.longs === String ? String(e.seq) : e.seq : r.seq = t.longs === String ? $util$1.Long.prototype.toString.call(e.seq) : t.longs === Number ? new $util$1.LongBits(e.seq.low >>> 0, e.seq.high >>> 0).toNumber() : e.seq), null != e.code && e.hasOwnProperty("code") && (r.code = e.code), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      ApRequest = $root$1.ApRequest = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.apAddr = "", e.prototype.opId = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.envId = 0, e.prototype.flag = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.apAddr && Object.hasOwnProperty.call(e, "apAddr") && t.uint32(42).string(e.apAddr), null != e.opId && Object.hasOwnProperty.call(e, "opId") && t.uint32(48).int64(e.opId), null != e.envId && Object.hasOwnProperty.call(e, "envId") && t.uint32(56).int32(e.envId), null != e.flag && Object.hasOwnProperty.call(e, "flag") && t.uint32(64).int32(e.flag), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.ApRequest(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 5:
            n.apAddr = e.string();
            break;

          case 6:
            n.opId = e.int64();
            break;

          case 7:
            n.envId = e.int32();
            break;

          case 8:
            n.flag = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.apAddr && e.hasOwnProperty("apAddr") && !$util$1.isString(e.apAddr) ? "apAddr: string expected" : null != e.opId && e.hasOwnProperty("opId") && !($util$1.isInteger(e.opId) || e.opId && $util$1.isInteger(e.opId.low) && $util$1.isInteger(e.opId.high)) ? "opId: integer|Long expected" : null != e.envId && e.hasOwnProperty("envId") && !$util$1.isInteger(e.envId) ? "envId: integer expected" : null != e.flag && e.hasOwnProperty("flag") && !$util$1.isInteger(e.flag) ? "flag: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.ApRequest) return e;
      var t = new $root$1.ApRequest();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.apAddr && (t.apAddr = String(e.apAddr)), null != e.opId && ($util$1.Long ? (t.opId = $util$1.Long.fromValue(e.opId)).unsigned = !1 : "string" == typeof e.opId ? t.opId = parseInt(e.opId, 10) : "number" == typeof e.opId ? t.opId = e.opId : "object" === _typeof(e.opId) && (t.opId = new $util$1.LongBits(e.opId.low >>> 0, e.opId.high >>> 0).toNumber())), null != e.envId && (t.envId = 0 | e.envId), null != e.flag && (t.flag = 0 | e.flag), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        if (r.apAddr = "", $util$1.Long) {
          var i = new $util$1.Long(0, 0, !1);
          r.opId = t.longs === String ? i.toString() : t.longs === Number ? i.toNumber() : i;
        } else r.opId = t.longs === String ? "0" : 0;

        r.envId = 0, r.flag = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.apAddr && e.hasOwnProperty("apAddr") && (r.apAddr = e.apAddr), null != e.opId && e.hasOwnProperty("opId") && ("number" == typeof e.opId ? r.opId = t.longs === String ? String(e.opId) : e.opId : r.opId = t.longs === String ? $util$1.Long.prototype.toString.call(e.opId) : t.longs === Number ? new $util$1.LongBits(e.opId.low >>> 0, e.opId.high >>> 0).toNumber() : e.opId), null != e.envId && e.hasOwnProperty("envId") && (r.envId = e.envId), null != e.flag && e.hasOwnProperty("flag") && (r.flag = e.flag), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      LinkTcpEvent = $root$1.LinkTcpEvent = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.destServerIp = "", e.prototype.action = "", e.prototype.code = 0, e.prototype.responseTime = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.destServerIp && Object.hasOwnProperty.call(e, "destServerIp") && t.uint32(42).string(e.destServerIp), null != e.action && Object.hasOwnProperty.call(e, "action") && t.uint32(50).string(e.action), null != e.code && Object.hasOwnProperty.call(e, "code") && t.uint32(56).int32(e.code), null != e.responseTime && Object.hasOwnProperty.call(e, "responseTime") && t.uint32(64).int32(e.responseTime), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.LinkTcpEvent(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 5:
            n.destServerIp = e.string();
            break;

          case 6:
            n.action = e.string();
            break;

          case 7:
            n.code = e.int32();
            break;

          case 8:
            n.responseTime = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.destServerIp && e.hasOwnProperty("destServerIp") && !$util$1.isString(e.destServerIp) ? "destServerIp: string expected" : null != e.action && e.hasOwnProperty("action") && !$util$1.isString(e.action) ? "action: string expected" : null != e.code && e.hasOwnProperty("code") && !$util$1.isInteger(e.code) ? "code: integer expected" : null != e.responseTime && e.hasOwnProperty("responseTime") && !$util$1.isInteger(e.responseTime) ? "responseTime: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.LinkTcpEvent) return e;
      var t = new $root$1.LinkTcpEvent();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.destServerIp && (t.destServerIp = String(e.destServerIp)), null != e.action && (t.action = String(e.action)), null != e.code && (t.code = 0 | e.code), null != e.responseTime && (t.responseTime = 0 | e.responseTime), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.destServerIp = "", r.action = "", r.code = 0, r.responseTime = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.destServerIp && e.hasOwnProperty("destServerIp") && (r.destServerIp = e.destServerIp), null != e.action && e.hasOwnProperty("action") && (r.action = e.action), null != e.code && e.hasOwnProperty("code") && (r.code = e.code), null != e.responseTime && e.hasOwnProperty("responseTime") && (r.responseTime = e.responseTime), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      LinkLoginRequest = $root$1.LinkLoginRequest = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.destServerIp = "", e.prototype.linkId = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.destServerIp && Object.hasOwnProperty.call(e, "destServerIp") && t.uint32(42).string(e.destServerIp), null != e.linkId && Object.hasOwnProperty.call(e, "linkId") && t.uint32(48).int32(e.linkId), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.LinkLoginRequest(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 5:
            n.destServerIp = e.string();
            break;

          case 6:
            n.linkId = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.destServerIp && e.hasOwnProperty("destServerIp") && !$util$1.isString(e.destServerIp) ? "destServerIp: string expected" : null != e.linkId && e.hasOwnProperty("linkId") && !$util$1.isInteger(e.linkId) ? "linkId: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.LinkLoginRequest) return e;
      var t = new $root$1.LinkLoginRequest();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.destServerIp && (t.destServerIp = String(e.destServerIp)), null != e.linkId && (t.linkId = 0 | e.linkId), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.destServerIp = "", r.linkId = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.destServerIp && e.hasOwnProperty("destServerIp") && (r.destServerIp = e.destServerIp), null != e.linkId && e.hasOwnProperty("linkId") && (r.linkId = e.linkId), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      ConnectionStateChange = $root$1.ConnectionStateChange = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.userId = "", e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.oldState = 0, e.prototype.newState = 0, e.prototype.reason = 0, e.prototype.reconnId = 0, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.userId && Object.hasOwnProperty.call(e, "userId") && t.uint32(18).string(e.userId), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(24).int64(e.lts), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(32).int64(e.elapse), null != e.oldState && Object.hasOwnProperty.call(e, "oldState") && t.uint32(40).int32(e.oldState), null != e.newState && Object.hasOwnProperty.call(e, "newState") && t.uint32(48).int32(e.newState), null != e.reason && Object.hasOwnProperty.call(e, "reason") && t.uint32(56).int32(e.reason), null != e.reconnId && Object.hasOwnProperty.call(e, "reconnId") && t.uint32(64).int32(e.reconnId), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.ConnectionStateChange(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.userId = e.string();
            break;

          case 3:
            n.lts = e.int64();
            break;

          case 4:
            n.elapse = e.int64();
            break;

          case 5:
            n.oldState = e.int32();
            break;

          case 6:
            n.newState = e.int32();
            break;

          case 7:
            n.reason = e.int32();
            break;

          case 8:
            n.reconnId = e.int32();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.userId && e.hasOwnProperty("userId") && !$util$1.isString(e.userId) ? "userId: string expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.oldState && e.hasOwnProperty("oldState") && !$util$1.isInteger(e.oldState) ? "oldState: integer expected" : null != e.newState && e.hasOwnProperty("newState") && !$util$1.isInteger(e.newState) ? "newState: integer expected" : null != e.reason && e.hasOwnProperty("reason") && !$util$1.isInteger(e.reason) ? "reason: integer expected" : null != e.reconnId && e.hasOwnProperty("reconnId") && !$util$1.isInteger(e.reconnId) ? "reconnId: integer expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.ConnectionStateChange) return e;
      var t = new $root$1.ConnectionStateChange();
      return null != e.sid && (t.sid = String(e.sid)), null != e.userId && (t.userId = String(e.userId)), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.oldState && (t.oldState = 0 | e.oldState), null != e.newState && (t.newState = 0 | e.newState), null != e.reason && (t.reason = 0 | e.reason), null != e.reconnId && (t.reconnId = 0 | e.reconnId), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.userId = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.lts = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.elapse = t.longs === String ? "0" : 0;

        r.oldState = 0, r.newState = 0, r.reason = 0, r.reconnId = 0;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.userId && e.hasOwnProperty("userId") && (r.userId = e.userId), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.oldState && e.hasOwnProperty("oldState") && (r.oldState = e.oldState), null != e.newState && e.hasOwnProperty("newState") && (r.newState = e.newState), null != e.reason && e.hasOwnProperty("reason") && (r.reason = e.reason), null != e.reconnId && e.hasOwnProperty("reconnId") && (r.reconnId = e.reconnId), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      ApiExec = $root$1.ApiExec = function () {
    function e(e) {
      if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.cname = "", e.prototype.cid = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.ip = "", e.prototype.uid = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.success = !1, e.prototype.elapse = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.peer = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.apiPayload = "", e.prototype.isCache = !1, e.prototype.isNotificationSuppressed = !1, e.encode = function (e, t) {
      return t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.cname && Object.hasOwnProperty.call(e, "cname") && t.uint32(18).string(e.cname), null != e.cid && Object.hasOwnProperty.call(e, "cid") && t.uint32(24).int64(e.cid), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(32).int64(e.lts), null != e.ip && Object.hasOwnProperty.call(e, "ip") && t.uint32(42).string(e.ip), null != e.uid && Object.hasOwnProperty.call(e, "uid") && t.uint32(48).int64(e.uid), null != e.success && Object.hasOwnProperty.call(e, "success") && t.uint32(56).bool(e.success), null != e.elapse && Object.hasOwnProperty.call(e, "elapse") && t.uint32(64).int64(e.elapse), null != e.peer && Object.hasOwnProperty.call(e, "peer") && t.uint32(72).int64(e.peer), null != e.apiPayload && Object.hasOwnProperty.call(e, "apiPayload") && t.uint32(82).string(e.apiPayload), null != e.isCache && Object.hasOwnProperty.call(e, "isCache") && t.uint32(88).bool(e.isCache), null != e.isNotificationSuppressed && Object.hasOwnProperty.call(e, "isNotificationSuppressed") && t.uint32(96).bool(e.isNotificationSuppressed), t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.ApiExec(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.cname = e.string();
            break;

          case 3:
            n.cid = e.int64();
            break;

          case 4:
            n.lts = e.int64();
            break;

          case 5:
            n.ip = e.string();
            break;

          case 6:
            n.uid = e.int64();
            break;

          case 7:
            n.success = e.bool();
            break;

          case 8:
            n.elapse = e.int64();
            break;

          case 9:
            n.peer = e.int64();
            break;

          case 10:
            n.apiPayload = e.string();
            break;

          case 11:
            n.isCache = e.bool();
            break;

          case 12:
            n.isNotificationSuppressed = e.bool();
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      return "object" !== _typeof(e) || null === e ? "object expected" : null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid) ? "sid: string expected" : null != e.cname && e.hasOwnProperty("cname") && !$util$1.isString(e.cname) ? "cname: string expected" : null != e.cid && e.hasOwnProperty("cid") && !($util$1.isInteger(e.cid) || e.cid && $util$1.isInteger(e.cid.low) && $util$1.isInteger(e.cid.high)) ? "cid: integer|Long expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.ip && e.hasOwnProperty("ip") && !$util$1.isString(e.ip) ? "ip: string expected" : null != e.uid && e.hasOwnProperty("uid") && !($util$1.isInteger(e.uid) || e.uid && $util$1.isInteger(e.uid.low) && $util$1.isInteger(e.uid.high)) ? "uid: integer|Long expected" : null != e.success && e.hasOwnProperty("success") && "boolean" != typeof e.success ? "success: boolean expected" : null != e.elapse && e.hasOwnProperty("elapse") && !($util$1.isInteger(e.elapse) || e.elapse && $util$1.isInteger(e.elapse.low) && $util$1.isInteger(e.elapse.high)) ? "elapse: integer|Long expected" : null != e.peer && e.hasOwnProperty("peer") && !($util$1.isInteger(e.peer) || e.peer && $util$1.isInteger(e.peer.low) && $util$1.isInteger(e.peer.high)) ? "peer: integer|Long expected" : null != e.apiPayload && e.hasOwnProperty("apiPayload") && !$util$1.isString(e.apiPayload) ? "apiPayload: string expected" : null != e.isCache && e.hasOwnProperty("isCache") && "boolean" != typeof e.isCache ? "isCache: boolean expected" : null != e.isNotificationSuppressed && e.hasOwnProperty("isNotificationSuppressed") && "boolean" != typeof e.isNotificationSuppressed ? "isNotificationSuppressed: boolean expected" : null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.ApiExec) return e;
      var t = new $root$1.ApiExec();
      return null != e.sid && (t.sid = String(e.sid)), null != e.cname && (t.cname = String(e.cname)), null != e.cid && ($util$1.Long ? (t.cid = $util$1.Long.fromValue(e.cid)).unsigned = !1 : "string" == typeof e.cid ? t.cid = parseInt(e.cid, 10) : "number" == typeof e.cid ? t.cid = e.cid : "object" === _typeof(e.cid) && (t.cid = new $util$1.LongBits(e.cid.low >>> 0, e.cid.high >>> 0).toNumber())), null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.ip && (t.ip = String(e.ip)), null != e.uid && ($util$1.Long ? (t.uid = $util$1.Long.fromValue(e.uid)).unsigned = !1 : "string" == typeof e.uid ? t.uid = parseInt(e.uid, 10) : "number" == typeof e.uid ? t.uid = e.uid : "object" === _typeof(e.uid) && (t.uid = new $util$1.LongBits(e.uid.low >>> 0, e.uid.high >>> 0).toNumber())), null != e.success && (t.success = Boolean(e.success)), null != e.elapse && ($util$1.Long ? (t.elapse = $util$1.Long.fromValue(e.elapse)).unsigned = !1 : "string" == typeof e.elapse ? t.elapse = parseInt(e.elapse, 10) : "number" == typeof e.elapse ? t.elapse = e.elapse : "object" === _typeof(e.elapse) && (t.elapse = new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber())), null != e.peer && ($util$1.Long ? (t.peer = $util$1.Long.fromValue(e.peer)).unsigned = !1 : "string" == typeof e.peer ? t.peer = parseInt(e.peer, 10) : "number" == typeof e.peer ? t.peer = e.peer : "object" === _typeof(e.peer) && (t.peer = new $util$1.LongBits(e.peer.low >>> 0, e.peer.high >>> 0).toNumber())), null != e.apiPayload && (t.apiPayload = String(e.apiPayload)), null != e.isCache && (t.isCache = Boolean(e.isCache)), null != e.isNotificationSuppressed && (t.isNotificationSuppressed = Boolean(e.isNotificationSuppressed)), t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};

      if (t.defaults) {
        if (r.sid = "", r.cname = "", $util$1.Long) {
          var n = new $util$1.Long(0, 0, !1);
          r.cid = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
        } else r.cid = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var o = new $util$1.Long(0, 0, !1);
          r.lts = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
        } else r.lts = t.longs === String ? "0" : 0;

        if (r.ip = "", $util$1.Long) {
          var i = new $util$1.Long(0, 0, !1);
          r.uid = t.longs === String ? i.toString() : t.longs === Number ? i.toNumber() : i;
        } else r.uid = t.longs === String ? "0" : 0;

        if (r.success = !1, $util$1.Long) {
          var s = new $util$1.Long(0, 0, !1);
          r.elapse = t.longs === String ? s.toString() : t.longs === Number ? s.toNumber() : s;
        } else r.elapse = t.longs === String ? "0" : 0;

        if ($util$1.Long) {
          var a = new $util$1.Long(0, 0, !1);
          r.peer = t.longs === String ? a.toString() : t.longs === Number ? a.toNumber() : a;
        } else r.peer = t.longs === String ? "0" : 0;

        r.apiPayload = "", r.isCache = !1, r.isNotificationSuppressed = !1;
      }

      return null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.cname && e.hasOwnProperty("cname") && (r.cname = e.cname), null != e.cid && e.hasOwnProperty("cid") && ("number" == typeof e.cid ? r.cid = t.longs === String ? String(e.cid) : e.cid : r.cid = t.longs === String ? $util$1.Long.prototype.toString.call(e.cid) : t.longs === Number ? new $util$1.LongBits(e.cid.low >>> 0, e.cid.high >>> 0).toNumber() : e.cid), null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.ip && e.hasOwnProperty("ip") && (r.ip = e.ip), null != e.uid && e.hasOwnProperty("uid") && ("number" == typeof e.uid ? r.uid = t.longs === String ? String(e.uid) : e.uid : r.uid = t.longs === String ? $util$1.Long.prototype.toString.call(e.uid) : t.longs === Number ? new $util$1.LongBits(e.uid.low >>> 0, e.uid.high >>> 0).toNumber() : e.uid), null != e.success && e.hasOwnProperty("success") && (r.success = e.success), null != e.elapse && e.hasOwnProperty("elapse") && ("number" == typeof e.elapse ? r.elapse = t.longs === String ? String(e.elapse) : e.elapse : r.elapse = t.longs === String ? $util$1.Long.prototype.toString.call(e.elapse) : t.longs === Number ? new $util$1.LongBits(e.elapse.low >>> 0, e.elapse.high >>> 0).toNumber() : e.elapse), null != e.peer && e.hasOwnProperty("peer") && ("number" == typeof e.peer ? r.peer = t.longs === String ? String(e.peer) : e.peer : r.peer = t.longs === String ? $util$1.Long.prototype.toString.call(e.peer) : t.longs === Number ? new $util$1.LongBits(e.peer.low >>> 0, e.peer.high >>> 0).toNumber() : e.peer), null != e.apiPayload && e.hasOwnProperty("apiPayload") && (r.apiPayload = e.apiPayload), null != e.isCache && e.hasOwnProperty("isCache") && (r.isCache = e.isCache), null != e.isNotificationSuppressed && e.hasOwnProperty("isNotificationSuppressed") && (r.isNotificationSuppressed = e.isNotificationSuppressed), r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e;
  }(),
      Counter = $root$1.Counter = function () {
    function e(e) {
      if (this.items = [], e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
        null != e[t[r]] && (this[t[r]] = e[t[r]]);
      }
    }

    return e.prototype.sid = "", e.prototype.peer = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.items = $util$1.emptyArray, e.encode = function (e, t) {
      if (t || (t = $Writer$1.create()), null != e.sid && Object.hasOwnProperty.call(e, "sid") && t.uint32(10).string(e.sid), null != e.peer && Object.hasOwnProperty.call(e, "peer") && t.uint32(16).int64(e.peer), null != e.items && e.items.length) for (var r = 0; r < e.items.length; ++r) {
        $root$1.Counter.CounterItem.encode(e.items[r], t.uint32(26).fork()).ldelim();
      }
      return t;
    }, e.encodeDelimited = function (e, t) {
      return this.encode(e, t).ldelim();
    }, e.decode = function (e, t) {
      e instanceof $Reader$1 || (e = $Reader$1.create(e));

      for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.Counter(); e.pos < r;) {
        var o = e.uint32();

        switch (o >>> 3) {
          case 1:
            n.sid = e.string();
            break;

          case 2:
            n.peer = e.int64();
            break;

          case 3:
            n.items && n.items.length || (n.items = []), n.items.push($root$1.Counter.CounterItem.decode(e, e.uint32()));
            break;

          default:
            e.skipType(7 & o);
        }
      }

      return n;
    }, e.decodeDelimited = function (e) {
      return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
    }, e.verify = function (e) {
      if ("object" !== _typeof(e) || null === e) return "object expected";
      if (null != e.sid && e.hasOwnProperty("sid") && !$util$1.isString(e.sid)) return "sid: string expected";
      if (null != e.peer && e.hasOwnProperty("peer") && !($util$1.isInteger(e.peer) || e.peer && $util$1.isInteger(e.peer.low) && $util$1.isInteger(e.peer.high))) return "peer: integer|Long expected";

      if (null != e.items && e.hasOwnProperty("items")) {
        if (!Array.isArray(e.items)) return "items: array expected";

        for (var t = 0; t < e.items.length; ++t) {
          var r = $root$1.Counter.CounterItem.verify(e.items[t]);
          if (r) return "items." + r;
        }
      }

      return null;
    }, e.fromObject = function (e) {
      if (e instanceof $root$1.Counter) return e;
      var t = new $root$1.Counter();

      if (null != e.sid && (t.sid = String(e.sid)), null != e.peer && ($util$1.Long ? (t.peer = $util$1.Long.fromValue(e.peer)).unsigned = !1 : "string" == typeof e.peer ? t.peer = parseInt(e.peer, 10) : "number" == typeof e.peer ? t.peer = e.peer : "object" === _typeof(e.peer) && (t.peer = new $util$1.LongBits(e.peer.low >>> 0, e.peer.high >>> 0).toNumber())), e.items) {
        if (!Array.isArray(e.items)) throw TypeError(".Counter.items: array expected");
        t.items = [];

        for (var r = 0; r < e.items.length; ++r) {
          if ("object" !== _typeof(e.items[r])) throw TypeError(".Counter.items: object expected");
          t.items[r] = $root$1.Counter.CounterItem.fromObject(e.items[r]);
        }
      }

      return t;
    }, e.toObject = function (e, t) {
      t || (t = {});
      var r = {};
      if ((t.arrays || t.defaults) && (r.items = []), t.defaults) if (r.sid = "", $util$1.Long) {
        var n = new $util$1.Long(0, 0, !1);
        r.peer = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
      } else r.peer = t.longs === String ? "0" : 0;

      if (null != e.sid && e.hasOwnProperty("sid") && (r.sid = e.sid), null != e.peer && e.hasOwnProperty("peer") && ("number" == typeof e.peer ? r.peer = t.longs === String ? String(e.peer) : e.peer : r.peer = t.longs === String ? $util$1.Long.prototype.toString.call(e.peer) : t.longs === Number ? new $util$1.LongBits(e.peer.low >>> 0, e.peer.high >>> 0).toNumber() : e.peer), e.items && e.items.length) {
        r.items = [];

        for (var o = 0; o < e.items.length; ++o) {
          r.items[o] = $root$1.Counter.CounterItem.toObject(e.items[o], t);
        }
      }

      return r;
    }, e.prototype.toJSON = function () {
      return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
    }, e.CounterItem = function () {
      function e(e) {
        if (e) for (var t = Object.keys(e), r = 0; r < t.length; ++r) {
          null != e[t[r]] && (this[t[r]] = e[t[r]]);
        }
      }

      return e.prototype.lts = $util$1.Long ? $util$1.Long.fromBits(0, 0, !1) : 0, e.prototype.id = 0, e.prototype.value = 0, e.prototype.tagErrorCode = 0, e.prototype.streamId = 0, e.encode = function (e, t) {
        return t || (t = $Writer$1.create()), null != e.lts && Object.hasOwnProperty.call(e, "lts") && t.uint32(8).int64(e.lts), null != e.id && Object.hasOwnProperty.call(e, "id") && t.uint32(16).int32(e.id), null != e.value && Object.hasOwnProperty.call(e, "value") && t.uint32(24).int32(e.value), null != e.tagErrorCode && Object.hasOwnProperty.call(e, "tagErrorCode") && t.uint32(32).int32(e.tagErrorCode), null != e.streamId && Object.hasOwnProperty.call(e, "streamId") && t.uint32(40).uint32(e.streamId), t;
      }, e.encodeDelimited = function (e, t) {
        return this.encode(e, t).ldelim();
      }, e.decode = function (e, t) {
        e instanceof $Reader$1 || (e = $Reader$1.create(e));

        for (var r = void 0 === t ? e.len : e.pos + t, n = new $root$1.Counter.CounterItem(); e.pos < r;) {
          var o = e.uint32();

          switch (o >>> 3) {
            case 1:
              n.lts = e.int64();
              break;

            case 2:
              n.id = e.int32();
              break;

            case 3:
              n.value = e.int32();
              break;

            case 4:
              n.tagErrorCode = e.int32();
              break;

            case 5:
              n.streamId = e.uint32();
              break;

            default:
              e.skipType(7 & o);
          }
        }

        return n;
      }, e.decodeDelimited = function (e) {
        return e instanceof $Reader$1 || (e = new $Reader$1(e)), this.decode(e, e.uint32());
      }, e.verify = function (e) {
        return "object" !== _typeof(e) || null === e ? "object expected" : null != e.lts && e.hasOwnProperty("lts") && !($util$1.isInteger(e.lts) || e.lts && $util$1.isInteger(e.lts.low) && $util$1.isInteger(e.lts.high)) ? "lts: integer|Long expected" : null != e.id && e.hasOwnProperty("id") && !$util$1.isInteger(e.id) ? "id: integer expected" : null != e.value && e.hasOwnProperty("value") && !$util$1.isInteger(e.value) ? "value: integer expected" : null != e.tagErrorCode && e.hasOwnProperty("tagErrorCode") && !$util$1.isInteger(e.tagErrorCode) ? "tagErrorCode: integer expected" : null != e.streamId && e.hasOwnProperty("streamId") && !$util$1.isInteger(e.streamId) ? "streamId: integer expected" : null;
      }, e.fromObject = function (e) {
        if (e instanceof $root$1.Counter.CounterItem) return e;
        var t = new $root$1.Counter.CounterItem();
        return null != e.lts && ($util$1.Long ? (t.lts = $util$1.Long.fromValue(e.lts)).unsigned = !1 : "string" == typeof e.lts ? t.lts = parseInt(e.lts, 10) : "number" == typeof e.lts ? t.lts = e.lts : "object" === _typeof(e.lts) && (t.lts = new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber())), null != e.id && (t.id = 0 | e.id), null != e.value && (t.value = 0 | e.value), null != e.tagErrorCode && (t.tagErrorCode = 0 | e.tagErrorCode), null != e.streamId && (t.streamId = e.streamId >>> 0), t;
      }, e.toObject = function (e, t) {
        t || (t = {});
        var r = {};

        if (t.defaults) {
          if ($util$1.Long) {
            var n = new $util$1.Long(0, 0, !1);
            r.lts = t.longs === String ? n.toString() : t.longs === Number ? n.toNumber() : n;
          } else r.lts = t.longs === String ? "0" : 0;

          r.id = 0, r.value = 0, r.tagErrorCode = 0, r.streamId = 0;
        }

        return null != e.lts && e.hasOwnProperty("lts") && ("number" == typeof e.lts ? r.lts = t.longs === String ? String(e.lts) : e.lts : r.lts = t.longs === String ? $util$1.Long.prototype.toString.call(e.lts) : t.longs === Number ? new $util$1.LongBits(e.lts.low >>> 0, e.lts.high >>> 0).toNumber() : e.lts), null != e.id && e.hasOwnProperty("id") && (r.id = e.id), null != e.value && e.hasOwnProperty("value") && (r.value = e.value), null != e.tagErrorCode && e.hasOwnProperty("tagErrorCode") && (r.tagErrorCode = e.tagErrorCode), null != e.streamId && e.hasOwnProperty("streamId") && (r.streamId = e.streamId), r;
      }, e.prototype.toJSON = function () {
        return this.constructor.toObject(this, indexMinimal_6.toJSONOptions);
      }, e;
    }(), e;
  }(),
      ProtoPackets$1 = Object.freeze({
    __proto__: null,
    Session: Session,
    ApEvent: ApEvent,
    Link: Link,
    Logout: Logout,
    TxMessage: TxMessage,
    RxMessage: RxMessage,
    KickedOff: KickedOff,
    TxMessageRes: TxMessageRes,
    ChnJoin: ChnJoin,
    ChnJoinRes: ChnJoinRes,
    ChnLeave: ChnLeave,
    ChnGetMembers: ChnGetMembers,
    ChnGetMembersRes: ChnGetMembersRes,
    ChnMemberJoined: ChnMemberJoined,
    ChnMemberLeft: ChnMemberLeft,
    QueryPeersOnlineStatus: QueryPeersOnlineStatus,
    QueryPeersOnlineStatusRes: QueryPeersOnlineStatusRes,
    RenewToken: RenewToken,
    OperateAttribute: OperateAttribute,
    OperateAttributeRes: OperateAttributeRes,
    ApRequest: ApRequest,
    LinkTcpEvent: LinkTcpEvent,
    LinkLoginRequest: LinkLoginRequest,
    ConnectionStateChange: ConnectionStateChange,
    ApiExec: ApiExec,
    Counter: Counter,
    default: $root$1
  }),
      Counter$1 = 1,
      ApiExec$1 = 154,
      Session$1 = 164,
      ApEvent$1 = 165,
      Link$1 = 166,
      Logout$1 = 167,
      TxMessage$1 = 168,
      RxMessage$1 = 169,
      KickedOff$1 = 170,
      TxMessageRes$1 = 171,
      ChnJoin$1 = 172,
      ChnJoinRes$1 = 173,
      ChnLeave$1 = 174,
      ChnGetMembers$1 = 175,
      ChnGetMembersRes$1 = 176,
      ChnMemberJoined$1 = 177,
      ChnMemberLeft$1 = 178,
      QueryPeersOnlineStatus$1 = 179,
      QueryPeersOnlineStatusRes$1 = 180,
      RenewToken$1 = 181,
      OperateAttribute$1 = 186,
      OperateAttributeRes$1 = 187,
      ApRequest$1 = 188,
      LinkTcpEvent$1 = 189,
      LinkLoginRequest$1 = 190,
      ConnectionStateChange$1 = 191,
      reportId = {
    Counter: Counter$1,
    ApiExec: ApiExec$1,
    Session: Session$1,
    ApEvent: ApEvent$1,
    Link: Link$1,
    Logout: Logout$1,
    TxMessage: TxMessage$1,
    RxMessage: RxMessage$1,
    KickedOff: KickedOff$1,
    TxMessageRes: TxMessageRes$1,
    ChnJoin: ChnJoin$1,
    ChnJoinRes: ChnJoinRes$1,
    ChnLeave: ChnLeave$1,
    ChnGetMembers: ChnGetMembers$1,
    ChnGetMembersRes: ChnGetMembersRes$1,
    ChnMemberJoined: ChnMemberJoined$1,
    ChnMemberLeft: ChnMemberLeft$1,
    QueryPeersOnlineStatus: QueryPeersOnlineStatus$1,
    QueryPeersOnlineStatusRes: QueryPeersOnlineStatusRes$1,
    RenewToken: RenewToken$1,
    OperateAttribute: OperateAttribute$1,
    OperateAttributeRes: OperateAttributeRes$1,
    ApRequest: ApRequest$1,
    LinkTcpEvent: LinkTcpEvent$1,
    LinkLoginRequest: LinkLoginRequest$1,
    ConnectionStateChange: ConnectionStateChange$1
  },
      ReportId = Object.freeze({
    __proto__: null,
    Counter: Counter$1,
    ApiExec: ApiExec$1,
    Session: Session$1,
    ApEvent: ApEvent$1,
    Link: Link$1,
    Logout: Logout$1,
    TxMessage: TxMessage$1,
    RxMessage: RxMessage$1,
    KickedOff: KickedOff$1,
    TxMessageRes: TxMessageRes$1,
    ChnJoin: ChnJoin$1,
    ChnJoinRes: ChnJoinRes$1,
    ChnLeave: ChnLeave$1,
    ChnGetMembers: ChnGetMembers$1,
    ChnGetMembersRes: ChnGetMembersRes$1,
    ChnMemberJoined: ChnMemberJoined$1,
    ChnMemberLeft: ChnMemberLeft$1,
    QueryPeersOnlineStatus: QueryPeersOnlineStatus$1,
    QueryPeersOnlineStatusRes: QueryPeersOnlineStatusRes$1,
    RenewToken: RenewToken$1,
    OperateAttribute: OperateAttribute$1,
    OperateAttributeRes: OperateAttributeRes$1,
    ApRequest: ApRequest$1,
    LinkTcpEvent: LinkTcpEvent$1,
    LinkLoginRequest: LinkLoginRequest$1,
    ConnectionStateChange: ConnectionStateChange$1,
    default: reportId
  });

  function asyncGeneratorStep$5(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$5(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$5(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$5(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  var EVENT_REPORT_DOMAIN = "webcollector-rtm.agora.io",
      EVENT_REPORT_BACKUP_DOMAIN = "webcollector-rtm.agoraio.cn";

  function sendReport(e, t, r, n) {
    return _sendReport.apply(this, arguments);
  }

  function _sendReport() {
    return (_sendReport = _asyncToGenerator$5(regenerator.mark(function e(t, r, n, o) {
      var i, s, a;
      return regenerator.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              e.next = 2;
              break;

            case 2:
              return i = ProtoPackets$1[t].encode(r).finish(), (s = new URLSearchParams()).append("sentTs", Math.ceil(Date.now() / 1e3).toString()), s.append("id", ReportId[t].toString()), a = function a(e) {
                return ky.post("https://".concat(e, ":6443/events/proto-raw"), {
                  body: i,
                  retry: 1,
                  timeout: 1e4,
                  searchParams: s,
                  headers: {
                    "Content-Type": "application/octet-stream"
                  },
                  mode: "cors",
                  cache: "no-cache",
                  credentials: "same-origin"
                });
              }, e.prev = 7, e.next = 10, a(n || EVENT_REPORT_DOMAIN);

            case 10:
              e.next = 16;
              break;

            case 12:
              return e.prev = 12, e.t0 = e.catch(7), e.next = 16, a(o || EVENT_REPORT_BACKUP_DOMAIN);

            case 16:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[7, 12]]);
    }))).apply(this, arguments);
  }

  function getElapse(e) {
    return void 0 === e ? long_1.fromNumber(0) : long_1.fromNumber(Date.now() - e);
  }

  function _typeof$7(e) {
    return (_typeof$7 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _toConsumableArray$8(e) {
    return _arrayWithoutHoles$8(e) || _iterableToArray$8(e) || _nonIterableSpread$8();
  }

  function _nonIterableSpread$8() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray$8(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _arrayWithoutHoles$8(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  function _classCallCheck$7(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties$4(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$4(e, t, r) {
    return t && _defineProperties$4(e.prototype, t), r && _defineProperties$4(e, r), e;
  }

  function _possibleConstructorReturn$6(e, t) {
    return !t || "object" !== _typeof$7(t) && "function" != typeof t ? _assertThisInitialized$6(e) : t;
  }

  function _assertThisInitialized$6(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _getPrototypeOf$6(e) {
    return (_getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _inherits$6(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$6(e, t);
  }

  function _setPrototypeOf$6(e, t) {
    return (_setPrototypeOf$6 = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var Context = function (e) {
    function t(e, r) {
      var n;
      return _classCallCheck$7(this, t), (n = _possibleConstructorReturn$6(this, _getPrototypeOf$6(t).call(this, r, "Context"))).appId = e, n._token = void 0, n.areaConfig = void 0, n._uid = void 0, n._sid = void 0, n._area = void 0, n;
    }

    return _inherits$6(t, createEventBase()), _createClass$4(t, [{
      key: "setAreaConfig",
      value: function value(e) {
        if (0 === e.CODES.size) throw new RtmInternalError("Cannot set illegal areas");
        this.log("areas set to %s", _toConsumableArray$8(e.CODES).join(", ")), this.areaConfig = e;
      }
    }, {
      key: "token",
      set: function set(e) {
        this._token = "string" == typeof e && e ? e : void 0;
      }
    }, {
      key: "uid",
      set: function set(e) {
        if (this.log("The user ID is set to %s", e), !isValidId(e)) throw new RtmInternalError();
        this._uid = e;
      },
      get: function get() {
        if ("string" == typeof this._uid && this._uid) return this._uid;
        throw new RtmInternalError("Cannot get illegal uid");
      }
    }, {
      key: "key",
      get: function get() {
        if ("string" == typeof this._token && this._token) return this._token;
        if ("string" == typeof this.appId && this.appId) return this.appId;
        throw new RtmInternalError("Cannot get illegal key");
      }
    }, {
      key: "sid",
      get: function get() {
        if ("string" == typeof this._sid && this._sid) return this._sid;
        throw new RtmInternalError("Cannot get illegal sid");
      },
      set: function set(e) {
        if (this.log("sid is set to %s", e), "string" != typeof e || !e) throw new RtmInternalError();
        this._sid = e;
      }
    }, {
      key: "area",
      get: function get() {
        if ("string" == typeof this._area && this._area) return this._area;
        throw new RtmInternalError("Cannot get illegal area");
      },
      set: function set(e) {
        this.log("area is set to %s", e), this._area = "string" == typeof e && e ? e : "CN";
      }
    }]), t;
  }(),
      sha1 = createCommonjsModule(function (module) {
    /*
    	   * [js-sha1]{@link https://github.com/emn178/js-sha1}
    	   *
    	   * @version 0.6.0
    	   * @author Chen, Yi-Cyuan [emn178@gmail.com]
    	   * @copyright Chen, Yi-Cyuan 2014-2017
    	   * @license MIT
    	   */
    !function () {
      var root = "object" === ("undefined" == typeof window ? "undefined" : _typeof(window)) ? window : {},
          NODE_JS = !root.JS_SHA1_NO_NODE_JS && "object" === ("undefined" == typeof process ? "undefined" : _typeof(process)) && process.versions && process.versions.node;
      NODE_JS && (root = commonjsGlobal);

      var COMMON_JS = !root.JS_SHA1_NO_COMMON_JS && module.exports,
          HEX_CHARS = "0123456789abcdef".split(""),
          EXTRA = [-2147483648, 8388608, 32768, 128],
          SHIFT = [24, 16, 8, 0],
          OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"],
          blocks = [],
          createOutputMethod = function createOutputMethod(e) {
        return function (t) {
          return new Sha1(!0).update(t)[e]();
        };
      },
          createMethod = function createMethod() {
        var e = createOutputMethod("hex");
        NODE_JS && (e = nodeWrap(e)), e.create = function () {
          return new Sha1();
        }, e.update = function (t) {
          return e.create().update(t);
        };

        for (var t = 0; t < OUTPUT_TYPES.length; ++t) {
          var r = OUTPUT_TYPES[t];
          e[r] = createOutputMethod(r);
        }

        return e;
      },
          nodeWrap = function nodeWrap(method) {
        var crypto = eval("require('crypto')"),
            Buffer = eval("require('buffer').Buffer"),
            nodeMethod = function nodeMethod(e) {
          if ("string" == typeof e) return crypto.createHash("sha1").update(e, "utf8").digest("hex");
          if (e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (void 0 === e.length) return method(e);
          return crypto.createHash("sha1").update(new Buffer(e)).digest("hex");
        };

        return nodeMethod;
      };

      function Sha1(e) {
        e ? (blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this.h0 = 1732584193, this.h1 = 4023233417, this.h2 = 2562383102, this.h3 = 271733878, this.h4 = 3285377520, this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0;
      }

      Sha1.prototype.update = function (e) {
        if (!this.finalized) {
          var t = "string" != typeof e;
          t && e.constructor === root.ArrayBuffer && (e = new Uint8Array(e));

          for (var r, n, o = 0, i = e.length || 0, s = this.blocks; o < i;) {
            if (this.hashed && (this.hashed = !1, s[0] = this.block, s[16] = s[1] = s[2] = s[3] = s[4] = s[5] = s[6] = s[7] = s[8] = s[9] = s[10] = s[11] = s[12] = s[13] = s[14] = s[15] = 0), t) for (n = this.start; o < i && n < 64; ++o) {
              s[n >> 2] |= e[o] << SHIFT[3 & n++];
            } else for (n = this.start; o < i && n < 64; ++o) {
              (r = e.charCodeAt(o)) < 128 ? s[n >> 2] |= r << SHIFT[3 & n++] : r < 2048 ? (s[n >> 2] |= (192 | r >> 6) << SHIFT[3 & n++], s[n >> 2] |= (128 | 63 & r) << SHIFT[3 & n++]) : r < 55296 || r >= 57344 ? (s[n >> 2] |= (224 | r >> 12) << SHIFT[3 & n++], s[n >> 2] |= (128 | r >> 6 & 63) << SHIFT[3 & n++], s[n >> 2] |= (128 | 63 & r) << SHIFT[3 & n++]) : (r = 65536 + ((1023 & r) << 10 | 1023 & e.charCodeAt(++o)), s[n >> 2] |= (240 | r >> 18) << SHIFT[3 & n++], s[n >> 2] |= (128 | r >> 12 & 63) << SHIFT[3 & n++], s[n >> 2] |= (128 | r >> 6 & 63) << SHIFT[3 & n++], s[n >> 2] |= (128 | 63 & r) << SHIFT[3 & n++]);
            }
            this.lastByteIndex = n, this.bytes += n - this.start, n >= 64 ? (this.block = s[16], this.start = n - 64, this.hash(), this.hashed = !0) : this.start = n;
          }

          return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
        }
      }, Sha1.prototype.finalize = function () {
        if (!this.finalized) {
          this.finalized = !0;
          var e = this.blocks,
              t = this.lastByteIndex;
          e[16] = this.block, e[t >> 2] |= EXTRA[3 & t], this.block = e[16], t >= 56 && (this.hashed || this.hash(), e[0] = this.block, e[16] = e[1] = e[2] = e[3] = e[4] = e[5] = e[6] = e[7] = e[8] = e[9] = e[10] = e[11] = e[12] = e[13] = e[14] = e[15] = 0), e[14] = this.hBytes << 3 | this.bytes >>> 29, e[15] = this.bytes << 3, this.hash();
        }
      }, Sha1.prototype.hash = function () {
        var e,
            t,
            r = this.h0,
            n = this.h1,
            o = this.h2,
            i = this.h3,
            s = this.h4,
            a = this.blocks;

        for (e = 16; e < 80; ++e) {
          t = a[e - 3] ^ a[e - 8] ^ a[e - 14] ^ a[e - 16], a[e] = t << 1 | t >>> 31;
        }

        for (e = 0; e < 20; e += 5) {
          r = (t = (n = (t = (o = (t = (i = (t = (s = (t = r << 5 | r >>> 27) + (n & o | ~n & i) + s + 1518500249 + a[e] << 0) << 5 | s >>> 27) + (r & (n = n << 30 | n >>> 2) | ~r & o) + i + 1518500249 + a[e + 1] << 0) << 5 | i >>> 27) + (s & (r = r << 30 | r >>> 2) | ~s & n) + o + 1518500249 + a[e + 2] << 0) << 5 | o >>> 27) + (i & (s = s << 30 | s >>> 2) | ~i & r) + n + 1518500249 + a[e + 3] << 0) << 5 | n >>> 27) + (o & (i = i << 30 | i >>> 2) | ~o & s) + r + 1518500249 + a[e + 4] << 0, o = o << 30 | o >>> 2;
        }

        for (; e < 40; e += 5) {
          r = (t = (n = (t = (o = (t = (i = (t = (s = (t = r << 5 | r >>> 27) + (n ^ o ^ i) + s + 1859775393 + a[e] << 0) << 5 | s >>> 27) + (r ^ (n = n << 30 | n >>> 2) ^ o) + i + 1859775393 + a[e + 1] << 0) << 5 | i >>> 27) + (s ^ (r = r << 30 | r >>> 2) ^ n) + o + 1859775393 + a[e + 2] << 0) << 5 | o >>> 27) + (i ^ (s = s << 30 | s >>> 2) ^ r) + n + 1859775393 + a[e + 3] << 0) << 5 | n >>> 27) + (o ^ (i = i << 30 | i >>> 2) ^ s) + r + 1859775393 + a[e + 4] << 0, o = o << 30 | o >>> 2;
        }

        for (; e < 60; e += 5) {
          r = (t = (n = (t = (o = (t = (i = (t = (s = (t = r << 5 | r >>> 27) + (n & o | n & i | o & i) + s - 1894007588 + a[e] << 0) << 5 | s >>> 27) + (r & (n = n << 30 | n >>> 2) | r & o | n & o) + i - 1894007588 + a[e + 1] << 0) << 5 | i >>> 27) + (s & (r = r << 30 | r >>> 2) | s & n | r & n) + o - 1894007588 + a[e + 2] << 0) << 5 | o >>> 27) + (i & (s = s << 30 | s >>> 2) | i & r | s & r) + n - 1894007588 + a[e + 3] << 0) << 5 | n >>> 27) + (o & (i = i << 30 | i >>> 2) | o & s | i & s) + r - 1894007588 + a[e + 4] << 0, o = o << 30 | o >>> 2;
        }

        for (; e < 80; e += 5) {
          r = (t = (n = (t = (o = (t = (i = (t = (s = (t = r << 5 | r >>> 27) + (n ^ o ^ i) + s - 899497514 + a[e] << 0) << 5 | s >>> 27) + (r ^ (n = n << 30 | n >>> 2) ^ o) + i - 899497514 + a[e + 1] << 0) << 5 | i >>> 27) + (s ^ (r = r << 30 | r >>> 2) ^ n) + o - 899497514 + a[e + 2] << 0) << 5 | o >>> 27) + (i ^ (s = s << 30 | s >>> 2) ^ r) + n - 899497514 + a[e + 3] << 0) << 5 | n >>> 27) + (o ^ (i = i << 30 | i >>> 2) ^ s) + r - 899497514 + a[e + 4] << 0, o = o << 30 | o >>> 2;
        }

        this.h0 = this.h0 + r << 0, this.h1 = this.h1 + n << 0, this.h2 = this.h2 + o << 0, this.h3 = this.h3 + i << 0, this.h4 = this.h4 + s << 0;
      }, Sha1.prototype.hex = function () {
        this.finalize();
        var e = this.h0,
            t = this.h1,
            r = this.h2,
            n = this.h3,
            o = this.h4;
        return HEX_CHARS[e >> 28 & 15] + HEX_CHARS[e >> 24 & 15] + HEX_CHARS[e >> 20 & 15] + HEX_CHARS[e >> 16 & 15] + HEX_CHARS[e >> 12 & 15] + HEX_CHARS[e >> 8 & 15] + HEX_CHARS[e >> 4 & 15] + HEX_CHARS[15 & e] + HEX_CHARS[t >> 28 & 15] + HEX_CHARS[t >> 24 & 15] + HEX_CHARS[t >> 20 & 15] + HEX_CHARS[t >> 16 & 15] + HEX_CHARS[t >> 12 & 15] + HEX_CHARS[t >> 8 & 15] + HEX_CHARS[t >> 4 & 15] + HEX_CHARS[15 & t] + HEX_CHARS[r >> 28 & 15] + HEX_CHARS[r >> 24 & 15] + HEX_CHARS[r >> 20 & 15] + HEX_CHARS[r >> 16 & 15] + HEX_CHARS[r >> 12 & 15] + HEX_CHARS[r >> 8 & 15] + HEX_CHARS[r >> 4 & 15] + HEX_CHARS[15 & r] + HEX_CHARS[n >> 28 & 15] + HEX_CHARS[n >> 24 & 15] + HEX_CHARS[n >> 20 & 15] + HEX_CHARS[n >> 16 & 15] + HEX_CHARS[n >> 12 & 15] + HEX_CHARS[n >> 8 & 15] + HEX_CHARS[n >> 4 & 15] + HEX_CHARS[15 & n] + HEX_CHARS[o >> 28 & 15] + HEX_CHARS[o >> 24 & 15] + HEX_CHARS[o >> 20 & 15] + HEX_CHARS[o >> 16 & 15] + HEX_CHARS[o >> 12 & 15] + HEX_CHARS[o >> 8 & 15] + HEX_CHARS[o >> 4 & 15] + HEX_CHARS[15 & o];
      }, Sha1.prototype.toString = Sha1.prototype.hex, Sha1.prototype.digest = function () {
        this.finalize();
        var e = this.h0,
            t = this.h1,
            r = this.h2,
            n = this.h3,
            o = this.h4;
        return [e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e, t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, 255 & t, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, 255 & r, n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, 255 & n, o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o];
      }, Sha1.prototype.array = Sha1.prototype.digest, Sha1.prototype.arrayBuffer = function () {
        this.finalize();
        var e = new ArrayBuffer(20),
            t = new DataView(e);
        return t.setUint32(0, this.h0), t.setUint32(4, this.h1), t.setUint32(8, this.h2), t.setUint32(12, this.h3), t.setUint32(16, this.h4), e;
      };
      var exports = createMethod();
      COMMON_JS ? module.exports = exports : root.sha1 = exports;
    }();
  });

  function _toConsumableArray$9(e) {
    return _arrayWithoutHoles$9(e) || _iterableToArray$9(e) || _nonIterableSpread$9();
  }

  function _nonIterableSpread$9() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray$9(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _arrayWithoutHoles$9(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  function asyncGeneratorStep$6(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$6(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$6(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$6(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  var sha256Digest = function () {
    var e = _asyncToGenerator$6(regenerator.mark(function e(t) {
      return regenerator.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.t0 = Uint8Array, e.next = 3, crypto.subtle.digest("SHA-256", t);

            case 3:
              return e.t1 = e.sent, e.abrupt("return", new e.t0(e.t1));

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));

    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
      digestToHex = function digestToHex(e) {
    return _toConsumableArray$9(e).map(function (e) {
      return e.toString(16).padStart(2, "0");
    }).join("");
  },
      hexToDigest = function hexToDigest(e) {
    if ("string" != typeof e) throw new TypeError("Expected input to be a string");
    if (e.length % 2 != 0) throw new RangeError("Expected string to be an even number of characters");

    for (var t = new Uint8Array(e.length / 2), r = 0; r < e.length; r += 2) {
      t[r / 2] = parseInt(e.substring(r, r + 2), 16);
    }

    return t;
  },
      digestToBase64 = function digestToBase64(e) {
    return btoa(String.fromCharCode.apply(String, _toConsumableArray$9(e))).replace(/={1,2}$/, "");
  },
      sha1DigestStr = function () {
    var e = _asyncToGenerator$6(regenerator.mark(function e(t) {
      var r;
      return regenerator.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, crypto.subtle.digest("SHA-1", t);

            case 3:
              r = e.sent, e.next = 9;
              break;

            case 6:
              e.prev = 6, e.t0 = e.catch(0), r = sha1.arrayBuffer(t);

            case 9:
              return e.abrupt("return", digestToBase64(new Uint8Array(r)));

            case 10:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 6]]);
    }));

    return function (t) {
      return e.apply(this, arguments);
    };
  }();

  function hexToBase64(e) {
    return btoa(String.fromCharCode.apply({}, e.replace(/\r|\n/g, "").replace(/([\dA-Fa-f]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ").map(function (e) {
      return parseInt(e, 16);
    }))).replace(/={1,2}$/, "");
  }

  function _typeof$8(e) {
    return (_typeof$8 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _slicedToArray$5(e, t) {
    return _arrayWithHoles$5(e) || _iterableToArrayLimit$5(e, t) || _nonIterableRest$5();
  }

  function _nonIterableRest$5() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit$5(e, t) {
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }

  function _arrayWithHoles$5(e) {
    if (Array.isArray(e)) return e;
  }

  function asyncGeneratorStep$7(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$7(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$7(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$7(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  function _toConsumableArray$a(e) {
    return _arrayWithoutHoles$a(e) || _iterableToArray$a(e) || _nonIterableSpread$a();
  }

  function _nonIterableSpread$a() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray$a(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _arrayWithoutHoles$a(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  function _classCallCheck$8(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties$5(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$5(e, t, r) {
    return t && _defineProperties$5(e.prototype, t), r && _defineProperties$5(e, r), e;
  }

  function _possibleConstructorReturn$7(e, t) {
    return !t || "object" !== _typeof$8(t) && "function" != typeof t ? _assertThisInitialized$7(e) : t;
  }

  function _assertThisInitialized$7(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _getPrototypeOf$7(e) {
    return (_getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _inherits$7(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$7(e, t);
  }

  function _setPrototypeOf$7(e, t) {
    return (_setPrototypeOf$7 = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var setServer = function setServer(e, t, r, n) {
    n[t] = !0, r.has(e) ? r.get(e).add(t) : r.set(e, new Set([t]));
  },
      ChunkDownloadManager = function (e) {
    function t(e, r, n, o) {
      var i;
      _classCallCheck$8(this, t), (i = _possibleConstructorReturn$7(this, _getPrototypeOf$7(t).call(this, n, "ChunkDownloadManager"))).metaInfo = e, i.transHandler = r, i.abortController = new AbortController(), i.downloadedSize = 0, i.successCount = 0, i.timer = void 0, i.chunks = [], i.retUnit = void 0, i.singleThread = !1, i.initialized = !1, i.ee = void 0, i.chunkCount = void 0, i.aborted = !1, i.serverToIndices = new Map(), i.backupToIndices = new Map(), i.indexToBackupServers = [], i.busyBackupServers = new Map(), i.downloadingChunks = new Set(), i.ee = void 0 === o ? new events() : o;
      var s = e,
          a = s.size,
          u = s.unit;
      if (0 === a) throw new RtmInternalError("size cannot be 0");
      return void 0 !== r.cancelSignal && r.cancelSignal.addEventListener("abort", function () {
        i.abortController.abort();
      }, {
        once: !0
      }), i.abortController.signal.addEventListener("abort", function () {
        i.aborted = !0;
      }, {
        once: !0
      }), i.chunkCount = Math.ceil(a / (u * MEDIA_MESSAGE_UNIT_SIZE)), i;
    }

    return _inherits$7(t, createEventBase()), _createClass$5(t, [{
      key: "setInfoByResponse",
      value: function value(e) {
        var t = this,
            r = e.serverList,
            n = e.backupList,
            o = e.unit;
        if (r.length < this.chunkCount && n.length < this.chunkCount) throw new RtmInternalError("servers is not enough");
        this.updateProgress(0), this.initialized = !0;
        var i = new Array(this.chunkCount).fill(!1);
        if (r.forEach(function (e, r) {
          return e.forEach(function (e) {
            return setServer(e, r, t.serverToIndices, i);
          });
        }), n.forEach(function (e, r) {
          return e.forEach(function (e) {
            return setServer(e, r, t.backupToIndices, i);
          });
        }), i.some(function () {
          return !1;
        })) throw new RtmUnavailableError("Not enough servers to download", DOWNLOAD_MEDIA_ERR_FAILURE);
        this.indexToBackupServers = n.map(function (e) {
          return new Set(e);
        }), this.retUnit = o;
      }
    }, {
      key: "downloadChunks",
      value: function value() {
        this.aborted ? this.warn("downloadChunks after abort, ignored") : 1 === this.serverToIndices.size && 0 === _toConsumableArray$a(this.serverToIndices.keys())[0] ? this.serversDownload(this.backupToIndices) : this.serverToIndices.size >= 1 ? this.serversDownload(this.serverToIndices, !0) : this.ee.emit("error", new RtmUnavailableError("not enough servers to download", DOWNLOAD_MEDIA_ERR_FAILURE));
      }
    }, {
      key: "updateProgress",
      value: function value(e) {
        var t = this,
            r = this.downloadedSize + e;
        if (this.downloadedSize > this.metaInfo.size) return this.warn("Invalid download size, overflowed"), void this.ee.emit("error", new RtmUnknownError("Invalid download size", DOWNLOAD_MEDIA_ERR_FAILURE));
        this.downloadedSize = r, void 0 !== this.timer && 0 !== e && (clearTimeout(this.timer), this.timer = void 0), void 0 === this.timer && this.successCount !== this.chunkCount && (this.timer = setTimeout(function () {
          t.ee.emit("timedOut"), t.abortController.abort();
        }, 12e4)), this.initialized && 0 === e || void 0 !== this.transHandler.onOperationProgress && this.transHandler.onOperationProgress({
          totalSize: this.metaInfo.size,
          currentSize: this.downloadedSize
        });
      }
    }, {
      key: "getPayload",
      value: function value() {
        var e = 0,
            t = this.chunks,
            r = Array.isArray(t),
            n = 0;

        for (t = r ? t : t[Symbol.iterator]();;) {
          var o;

          if (r) {
            if (n >= t.length) break;
            o = t[n++];
          } else {
            if ((n = t.next()).done) break;
            o = n.value;
          }

          e += o.byteLength;
        }

        if (e !== this.metaInfo.size) throw new RtmInternalError("invalid chunks total size");
        var i = new Uint8Array(e),
            s = 0,
            a = this.chunks,
            u = Array.isArray(a),
            l = 0;

        for (a = u ? a : a[Symbol.iterator]();;) {
          var c;

          if (u) {
            if (l >= a.length) break;
            c = a[l++];
          } else {
            if ((l = a.next()).done) break;
            c = l.value;
          }

          var p = c;
          i.set(new Uint8Array(p), s), s += p.byteLength;
        }

        return arrayBufferToBlob(i.buffer);
      }
    }, {
      key: "getDownloadUrl",
      value: function value(e) {
        var t = this.metaInfo.isAreaCN ? "agoraio.cn" : "agora.io";
        return "https://".concat(intIP2StrIP(e).split(".").join("-"), ".edge.").concat(t, ":9601/api/v1/chuck/download");
      }
    }, {
      key: "serversDownload",
      value: function () {
        var e = _asyncToGenerator$7(regenerator.mark(function e(t) {
          var r,
              n = this,
              o = arguments;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return r = o.length > 1 && void 0 !== o[1] && o[1], e.next = 3, Promise.all(_toConsumableArray$a(t.entries()).map(function (e) {
                    var t = _slicedToArray$5(e, 2),
                        o = t[0],
                        i = t[1];

                    return n.postDownloadRequest(o, _toConsumableArray$a(i), r).catch(function (e) {
                      if (404 === e.statusCode) return n.ee.emit("notExist"), void n.abortController.abort();

                      if ("AbortError" !== e.name) {
                        if (isTimeout(e)) return n.singleThread ? (n.abortController.abort(), void n.ee.emit("timedOut")) : (n.warn("%d download timed out after %d, retrying use single thread", e.index, n.singleThread ? 6e4 : 3e4), n.abortController.abort(), n.singleThread = !0, void n.ee.emit("multiTimeOut"));
                        n.ee.emit("error", e), n.abortController.abort();
                      }
                    });
                  }));

                case 3:
                case "end":
                  return e.stop();
              }
            }
          }, e);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "postDownloadRequest",
      value: function () {
        var e = _asyncToGenerator$7(regenerator.mark(function e(t, r, n) {
          var o,
              i,
              s,
              a,
              u,
              l,
              c,
              p,
              _f,
              d = this;

          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (_f = function f() {
                    return (_f = _asyncToGenerator$7(regenerator.mark(function e(i) {
                      var s, f, d, g, h, b, y, _, m;

                      return regenerator.wrap(function (e) {
                        for (;;) {
                          switch (e.prev = e.next) {
                            case 0:
                              if (e.prev = 0, void 0 !== i || 0 !== t) {
                                e.next = 5;
                                break;
                              }

                              throw new RtmInternalError("Invalid serverIp");

                            case 5:
                              s = void 0 === i ? c.getDownloadUrl(t) : i;

                            case 6:
                              return c.downloadingChunks.add(o), e.next = 9, l(s);

                            case 9:
                              return f = e.sent, d = f.responseData, c.downloadingChunks.delete(o), e.abrupt("return", d);

                            case 15:
                              if (e.prev = 15, e.t0 = e.catch(0), c.downloadingChunks.delete(o), r.unshift(o), c.metaInfo.isAreaCN = !1, "AbortError" !== e.t0.name) {
                                e.next = 22;
                                break;
                              }

                              throw e.t0;

                            case 22:
                              if (!isTimeout(e.t0)) {
                                e.next = 25;
                                break;
                              }

                              throw e.t0.index = o, e.t0;

                            case 25:
                              if (g = a, a += 1, !(g < 2)) {
                                e.next = 30;
                                break;
                              }

                              return e.t0 instanceof RtmInternalError || c.warn("%o, %d download failed, retrying", e.t0, o), e.abrupt("return", p());

                            case 30:
                              if (504 !== e.t0.statusCode) {
                                e.next = 34;
                                break;
                              }

                              throw (h = new RtmTimeoutError("download server timed out", {
                                originalError: e.t0,
                                serverCode: 504
                              })).index = o, h;

                            case 34:
                              if (!n || 2 !== g || 0 === u[0]) {
                                e.next = 45;
                                break;
                              }

                              return e.t0 instanceof RtmInternalError || c.warn("%d download failed, using backup: %d, %o", o, u[0], e.t0), e.next = 38, c.busyBackupServers.get(u[0]);

                            case 38:
                              return b = p(c.getDownloadUrl(u[0])), c.busyBackupServers.set(u[0], b), e.next = 42, b;

                            case 42:
                              return y = e.sent, c.busyBackupServers.delete(u[0]), e.abrupt("return", y);

                            case 45:
                              if (!(n && g > 2 && void 0 !== u[1] && 0 !== u[1])) {
                                e.next = 56;
                                break;
                              }

                              return c.warn("%d download failed, using backup 1: %d", o, u[1]), e.next = 49, c.busyBackupServers.get(u[1]);

                            case 49:
                              return _ = p(c.getDownloadUrl(u[1])), c.busyBackupServers.set(u[1], _), e.next = 53, _;

                            case 53:
                              return m = e.sent, c.busyBackupServers.delete(u[1]), e.abrupt("return", m);

                            case 56:
                              throw e.t0.index = o, e.t0;

                            case 58:
                            case "end":
                              return e.stop();
                          }
                        }
                      }, e, null, [[0, 15]]);
                    }))).apply(this, arguments);
                  }, p = function p(e) {
                    return _f.apply(this, arguments);
                  }, !this.aborted) {
                    e.next = 4;
                    break;
                  }

                  throw new RtmInternalError("download already aborted");

                case 4:
                  if (void 0 !== (o = r.shift())) {
                    e.next = 8;
                    break;
                  }

                  return this.log("%s download finished", t), e.abrupt("return");

                case 8:
                  if (!(this.singleThread && this.downloadingChunks.size > 0)) {
                    e.next = 10;
                    break;
                  }

                  return e.abrupt("return");

                case 10:
                  if (!this.downloadingChunks.has(o)) {
                    e.next = 13;
                    break;
                  }

                  return this.log("%s already downloading, return", o), e.abrupt("return");

                case 13:
                  if (void 0 === this.chunks[o]) {
                    e.next = 19;
                    break;
                  }

                  return this.successCount === this.chunkCount && (this.log("chunks all download"), this.ee.emit("finished")), this.log("%s already downloaded, do next", o), e.next = 18, this.postDownloadRequest(t, r, n);

                case 18:
                  return e.abrupt("return");

                case 19:
                  return i = new FormData(), s = {
                    hash: hexToBase64(this.metaInfo.hashHexStr),
                    unit: void 0 === this.retUnit ? this.metaInfo.unit : this.retUnit,
                    instance: this.metaInfo.instance,
                    loginOpt: this.metaInfo.loginOpt,
                    ticket: this.metaInfo.ticket,
                    index: o
                  }, i.append("parameter", JSON.stringify(s)), a = 0, u = _toConsumableArray$a(this.indexToBackupServers[o]), l = function l(e) {
                    return postWithAbortSignal(e, {
                      body: i,
                      signal: d.abortController.signal,
                      timeout: d.singleThread ? 12e4 : 3e4
                    }, {
                      useBinaryResponse: !0
                    });
                  }, c = this, e.next = 28, p().then(function (e) {
                    return void 0 !== d.chunks[o] ? d.log("chunk %d download duplicated", o) : (d.chunks[o] = e, d.log("chunk %d downloaded", o), d.successCount += 1, d.updateProgress(d.chunks[o].byteLength)), d.successCount === d.chunkCount && (d.log("chunks all download"), d.ee.emit("finished")), d.singleThread ? (d.downloadChunks(), Promise.resolve()) : d.postDownloadRequest(t, r, n);
                  });

                case 28:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t, r, n) {
          return e.apply(this, arguments);
        };
      }()
    }]), t;
  }();

  function _typeof$9(e) {
    return (_typeof$9 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _slicedToArray$6(e, t) {
    return _arrayWithHoles$6(e) || _iterableToArrayLimit$6(e, t) || _nonIterableRest$6();
  }

  function _nonIterableRest$6() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit$6(e, t) {
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }

  function _arrayWithHoles$6(e) {
    if (Array.isArray(e)) return e;
  }

  function asyncGeneratorStep$8(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$8(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$8(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$8(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  function _classCallCheck$9(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties$6(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$6(e, t, r) {
    return t && _defineProperties$6(e.prototype, t), r && _defineProperties$6(e, r), e;
  }

  function _possibleConstructorReturn$8(e, t) {
    return !t || "object" !== _typeof$9(t) && "function" != typeof t ? _assertThisInitialized$8(e) : t;
  }

  function _assertThisInitialized$8(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _getPrototypeOf$8(e) {
    return (_getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _inherits$8(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$8(e, t);
  }

  function _setPrototypeOf$8(e, t) {
    return (_setPrototypeOf$8 = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var ChunkUploadManager = function (e) {
    function t(e, r, n, o) {
      var i;
      if (_classCallCheck$9(this, t), (i = _possibleConstructorReturn$8(this, _getPrototypeOf$8(t).call(this, n, "ChunkUploadManager"))).metaInfo = e, i.transHandler = r, i.chunkCount = 0, i.chunks = [], i.uploadedChunks = [], i.totalFailures = 0, i.timer = void 0, i.initState = "uninitialized", i.ee = void 0, i.unit = 0, i.uploadedSize = 0, i.singleThread = !1, i.abortController = new AbortController(), i.servers = [], i.aborted = !1, i.ee = void 0 === o ? new events() : o, 0 === e.file.length) throw new RtmInvalidArgumentError("file not found or is empty", UPLOAD_MEDIA_ERR_INVALID_ARGUMENT);
      return void 0 !== r.cancelSignal && r.cancelSignal.addEventListener("abort", function () {
        i.abortController.abort();
      }, {
        once: !0
      }), i.abortController.signal.addEventListener("abort", function () {
        i.aborted = !0;
      }, {
        once: !0
      }), i;
    }

    return _inherits$8(t, createEventBase()), _createClass$6(t, [{
      key: "initChunks",
      value: function () {
        var e = _asyncToGenerator$8(regenerator.mark(function e(t) {
          var r,
              n,
              o,
              i,
              s,
              a,
              u,
              l = this;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if ("initialized" !== this.initState && "initializing" !== this.initState) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInternalError("cannot re-initialize");

                case 2:
                  this.initState = "initializing", this.unit = t, r = this.sliceFile(t, this.metaInfo.file), this.chunkCount = r.length, n = [], o = function o() {
                    if (s) {
                      if (a >= i.length) return "break";
                      u = i[a++];
                    } else {
                      if ((a = i.next()).done) return "break";
                      u = a.value;
                    }

                    var e = _slicedToArray$6(u, 2),
                        t = e[0],
                        r = e[1],
                        o = sha1DigestStr(r).then(function (e) {
                      l.chunks[t] = {
                        payload: r,
                        sha1: e,
                        uploadedTo: void 0,
                        index: t,
                        processed: !1
                      };
                    });

                    n.push(o);
                  }, i = r.entries(), s = Array.isArray(i), a = 0, i = s ? i : i[Symbol.iterator]();

                case 9:
                  if ("break" !== o()) {
                    e.next = 12;
                    break;
                  }

                  return e.abrupt("break", 14);

                case 12:
                  e.next = 9;
                  break;

                case 14:
                  return e.next = 16, Promise.all(n);

                case 16:
                  this.updateProgress(0), this.initState = "initialized", this.log("upload chunks initialized");

                case 19:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "uploadToServers",
      value: function value() {
        var e = this;

        if (!this.aborted) {
          var t = this.chunks.filter(function (e) {
            return !e.processed;
          }),
              r = function r() {
            if (o) {
              if (i >= n.length) return "break";
              s = n[i++];
            } else {
              if ((i = n.next()).done) return "break";
              s = i.value;
            }

            var t = s,
                r = e.servers.filter(function (e) {
              return !e.isUploading;
            }).sort(function (e, t) {
              return e.successCount - t.successCount;
            }).sort(function (e, t) {
              return e.failureCount - t.failureCount;
            })[0];
            if (void 0 === r || r.failureCount > 1) return e.log("Upload server not available, waiting"), e.ee.emit("serverUsedUp"), delay$1(1e3).then(function () {
              e.totalFailures > 2 * e.chunkCount && e.ee.emit("error"), e.totalFailures += 1, void 0 !== r && (r.failureCount = 0), e.uploadToServers();
            }).catch(function () {}), "break";
            t.processed = !0, r.isUploading = !0, e.log("uploading chunk %d to server %s", t.index, intIP2StrIP(r.ip));
            var a = e.getUploadUrl(r.ip);
            return _asyncToGenerator$8(regenerator.mark(function n() {
              var o;
              return regenerator.wrap(function (n) {
                for (;;) {
                  switch (n.prev = n.next) {
                    case 0:
                      return n.prev = 0, n.next = 3, e.postChunk(t.payload, a, t.index);

                    case 3:
                      o = e.chunks.findIndex(function (e) {
                        return e === t;
                      }), t.uploadedTo = r.ip, e.chunks.splice(o, 1), e.uploadedChunks.push(t), r.successCount += 1, r.isUploading = !1, e.updateProgress(t.payload.byteLength), e.log("upload chunk %d successfully", t.index), n.next = 31;
                      break;

                    case 13:
                      if (n.prev = 13, n.t0 = n.catch(0), r.isUploading = !1, t.processed = !1, 504 !== n.t0.statusCode && !isTimeout(n.t0)) {
                        n.next = 27;
                        break;
                      }

                      if (e.singleThread) {
                        n.next = 24;
                        break;
                      }

                      return e.warn("%d upload timed out after %d, retrying use single thread", t.index, e.singleThread ? 12e4 : 3e4), e.abortController.abort(), e.singleThread = !0, e.ee.emit("multiTimeOut"), n.abrupt("return");

                    case 24:
                      return e.ee.emit("timedOut"), e.abortController.abort(), n.abrupt("return");

                    case 27:
                      return e.metaInfo.isAreaCN = !1, r.failureCount += 1, n.next = 31, delay$1(1e3);

                    case 31:
                      e.uploadedChunks.length === e.chunkCount ? (e.log("chunks uploaded"), e.ee.emit("finished")) : (e.singleThread || 1 === e.chunks.filter(function (e) {
                        return !e.processed;
                      }).length) && e.uploadToServers();

                    case 32:
                    case "end":
                      return n.stop();
                  }
                }
              }, n, null, [[0, 13]]);
            }))(), e.singleThread ? "break" : void 0;
          },
              n = t,
              o = Array.isArray(n),
              i = 0;

          for (n = o ? n : n[Symbol.iterator]();;) {
            var s;
            if ("break" === r()) break;
          }

          0 === t.length && this.uploadedChunks.length !== this.chunkCount && this.log("%d chunks left uploading", this.chunkCount - this.uploadedChunks.length);
        }
      }
    }, {
      key: "getUploadServerIPs",
      value: function value() {
        var e = !0,
            t = [],
            r = this.uploadedChunks.sort(function (e, t) {
          return e.index - t.index;
        }).values(),
            n = Array.isArray(r),
            o = 0;

        for (r = n ? r : r[Symbol.iterator]();;) {
          var i;

          if (n) {
            if (o >= r.length) break;
            i = r[o++];
          } else {
            if ((o = r.next()).done) break;
            i = o.value;
          }

          var s = i.uploadedTo;

          if (void 0 === s) {
            e = !1;
            break;
          }

          t.push(s);
        }

        if (!e) throw new RtmInternalError("some chunks not uploaded, cannot get upload server ips");
        return t;
      }
    }, {
      key: "addServers",
      value: function value(e) {
        var t = this;
        e.forEach(function (e) {
          var r = t.servers.findIndex(function (t) {
            return t.ip === e;
          });
          -1 === r ? (t.log("server %s added", intIP2StrIP(e)), t.servers.push({
            successCount: 0,
            isUploading: !1,
            ip: e,
            failureCount: 0
          })) : t.servers[r].failureCount = 0;
        });
      }
    }, {
      key: "updateProgress",
      value: function value(e) {
        var t = this,
            r = void 0 !== e ? this.uploadedSize + e : this.metaInfo.file.length;
        if (r > this.metaInfo.file.length) return this.warn("Invalid upload size, overflowed"), void this.ee.emit("error", new RtmUnknownError("Invalid upload size", UPLOAD_MEDIA_ERR_FAILURE));
        this.uploadedSize = r, void 0 !== this.timer && 0 !== e && (clearTimeout(this.timer), this.timer = void 0), void 0 === this.timer && void 0 !== e && this.uploadedChunks.length !== this.chunkCount && (this.timer = setTimeout(function () {
          t.ee.emit("timedOut"), t.abortController.abort();
        }, 12e4)), "initialized" === this.initState && 0 === e || void 0 !== this.transHandler.onOperationProgress && this.transHandler.onOperationProgress({
          totalSize: this.metaInfo.file.length,
          currentSize: this.uploadedSize
        });
      }
    }, {
      key: "sliceFile",
      value: function value(e, t) {
        for (var r = 0, n = [], o = t.length, i = 1024 * e * 32; r < o;) {
          var s = r + i;
          n.push(t.slice(r, s)), r += i;
        }

        return this.log("chunks split into %d", n.length), n;
      }
    }, {
      key: "postChunk",
      value: function () {
        var e = _asyncToGenerator$8(regenerator.mark(function e(t, r, n) {
          var o, i, s, a, u, l, c, p;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!this.aborted) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInternalError("upload already aborted");

                case 2:
                  if (void 0 !== this.unit) {
                    e.next = 4;
                    break;
                  }

                  throw new RtmInternalError("unit is undefined");

                case 4:
                  return o = this.metaInfo, i = o.ticket, s = o.instance, a = o.loginOpt, u = o.hashStr, e.t0 = n, e.t1 = u, e.next = 9, sha1DigestStr(t);

                case 9:
                  return e.t2 = e.sent, e.t3 = this.unit, e.t4 = i, e.t5 = s, e.t6 = a, l = {
                    index: e.t0,
                    hash: e.t1,
                    sha1: e.t2,
                    unit: e.t3,
                    ticket: e.t4,
                    instance: e.t5,
                    loginOpt: e.t6
                  }, (c = new FormData()).append("parameter", JSON.stringify(l)), c.append("payload", new Blob([t])), e.next = 20, postWithAbortSignal(r, {
                    headers: {
                      Accept: "application/json"
                    },
                    body: c,
                    timeout: this.singleThread ? 12e4 : 3e4,
                    signal: this.abortController.signal
                  });

                case 20:
                  if (p = e.sent, 201 === p.status) {
                    e.next = 24;
                    break;
                  }

                  throw new RtmUnavailableError("uploading chunk ".concat(n, " failed"));

                case 24:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t, r, n) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "getUploadUrl",
      value: function value(e) {
        var t = this.metaInfo.isAreaCN ? "agoraio.cn" : "agora.io";
        return "https://".concat(intIP2StrIP(e).split(".").join("-"), ".edge.").concat(t, ":9601/api/v1/chuck/upload");
      }
    }]), t;
  }();

  function _typeof$a(e) {
    return (_typeof$a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function asyncGeneratorStep$9(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$9(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$9(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$9(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  function _slicedToArray$7(e, t) {
    return _arrayWithHoles$7(e) || _iterableToArrayLimit$7(e, t) || _nonIterableRest$7();
  }

  function _nonIterableRest$7() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit$7(e, t) {
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }

  function _arrayWithHoles$7(e) {
    if (Array.isArray(e)) return e;
  }

  function _classCallCheck$a(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties$7(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$7(e, t, r) {
    return t && _defineProperties$7(e.prototype, t), r && _defineProperties$7(e, r), e;
  }

  function _possibleConstructorReturn$9(e, t) {
    return !t || "object" !== _typeof$a(t) && "function" != typeof t ? _assertThisInitialized$9(e) : t;
  }

  function _assertThisInitialized$9(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _getPrototypeOf$9(e) {
    return (_getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _inherits$9(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$9(e, t);
  }

  function _setPrototypeOf$9(e, t) {
    return (_setPrototypeOf$9 = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var MediaTaskManager = function (e) {
    function t(e) {
      var r;
      return _classCallCheck$a(this, t), (r = _possibleConstructorReturn$9(this, _getPrototypeOf$9(t).call(this, e, "MediaTaskManager"))).isProcessing = !1, r.authInfo = void 0, r.taskFinishers = {}, r.mediaTasks = new Map(), r.ongoingTask = void 0, r.on("connectionStateChanged", function (e) {
        if (e === RtmStatusCode$1.ConnectionState.ABORTED || e === RtmStatusCode$1.ConnectionState.DISCONNECTED) {
          void 0 !== r.ongoingTask && r.cancelTask(r.ongoingTask);
          var t = r.mediaTasks.entries(),
              n = Array.isArray(t),
              o = 0;

          for (t = n ? t : t[Symbol.iterator]();;) {
            var i;

            if (n) {
              if (o >= t.length) break;
              i = t[o++];
            } else {
              if ((o = t.next()).done) break;
              i = o.value;
            }

            var s = _slicedToArray$7(i, 2)[1];

            r.cancelTask(s);
          }

          r.mediaTasks.clear(), r.taskFinishers = {};
        } else e === RtmStatusCode$1.ConnectionState.RECONNECTING ? void 0 !== r.ongoingTask && r.ongoingTask.manager.abortController.abort() : e === RtmStatusCode$1.ConnectionState.CONNECTED && void 0 !== r.ongoingTask && r.ongoingTask.manager.ee.emit("reconnected");
      }), r;
    }

    return _inherits$9(t, createEventBase()), _createClass$7(t, [{
      key: "setAuthInfo",
      value: function value(e) {
        this.authInfo = e;
      }
    }, {
      key: "waitMediaTask",
      value: function value(e) {
        var t = this;
        return new Promise(function (r, n) {
          t.taskFinishers[e] = {
            resolve: r,
            reject: n
          }, t.isProcessing || t.processMediaTask();
        }).finally(function () {
          void 0 !== t.ongoingTask && void 0 !== t.ongoingTask.manager.timer && clearTimeout(t.ongoingTask.manager.timer), delete t.taskFinishers[e], 0 !== t.mediaTasks.size ? t.processMediaTask() : t.isProcessing = !1;
        });
      }
    }, {
      key: "addUploadTask",
      value: function value(e, r, n, o) {
        var i = e.file,
            s = e.hash;
        if (void 0 === this.authInfo) throw new RtmInternalError("session not found");
        if (this.mediaTasks.size >= t.MAX_PENDING_TASK_COUNT - 1) throw new RtmLimitExceededError("Upload media failed, exceed max pending jobs", UPLOAD_MEDIA_ERR_CONCURRENCY_LIMIT_EXCEEDED);
        var a = new ChunkUploadManager({
          hashStr: digestToBase64(s),
          file: i,
          ticket: this.authInfo.ticket,
          instance: this.authInfo.instance.toString(),
          loginOpt: this.authInfo.loginOpt.toString(),
          isAreaCN: this.authInfo.isAreaCN
        }, o, this.logger),
            u = v4_1();
        return this.mediaTasks.set(u, {
          type: "UPLOAD",
          manager: a,
          hash: s,
          setter: n,
          fetcher: r,
          taskId: u
        }), u;
      }
    }, {
      key: "addDownloadTask",
      value: function value(e, r, n) {
        var o = e.hashHexStr,
            i = e.size,
            s = e.unit,
            a = e.zone;
        if (void 0 === this.authInfo) throw new RtmInternalError("session not found");
        if (this.mediaTasks.size >= t.MAX_PENDING_TASK_COUNT - 1) throw new RtmLimitExceededError("Download media failed, exceed max pending jobs", DOWNLOAD_MEDIA_ERR_CONCURRENCY_LIMIT_EXCEEDED);
        var u = new ChunkDownloadManager({
          hashHexStr: o,
          ticket: this.authInfo.ticket,
          isAreaCN: this.authInfo.isAreaCN,
          instance: this.authInfo.instance.toString(),
          loginOpt: this.authInfo.loginOpt.toString(),
          size: i,
          zone: a,
          unit: s
        }, n, this.logger),
            l = v4_1();
        return this.mediaTasks.set(l, {
          type: "DOWNLOAD",
          manager: u,
          fetcher: r,
          taskId: l
        }), l;
      }
    }, {
      key: "doDownloadTaskImpl",
      value: function () {
        var e = _asyncToGenerator$9(regenerator.mark(function e(t, r) {
          var n,
              o,
              i,
              s,
              a,
              u,
              l,
              c,
              p = this,
              f = arguments;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return n = f.length > 2 && void 0 !== f[2] && f[2], o = t.manager, i = o, n && (o = new ChunkDownloadManager(i.metaInfo, i.transHandler, this.logger, i.ee)), s = t.fetcher, e.next = 7, s();

                case 7:
                  if (a = e.sent, u = a.serverList, l = a.backupList, c = a.unit, !n || c === i.retUnit) {
                    e.next = 13;
                    break;
                  }

                  throw new RtmUnavailableError("download unit is different, reject to continue", DOWNLOAD_MEDIA_ERR_FAILURE);

                case 13:
                  n && (t.manager = o, o.downloadedSize = i.downloadedSize, o.successCount = i.successCount, o.timer = i.timer, o.chunks = i.chunks, o.initialized = i.initialized, o.singleThread = i.singleThread, o.updateProgress(0)), o.ee.once("reconnected", function () {
                    o.ee.removeAllListeners(), p.doDownloadTaskImpl(t, r, !0).catch(function (e) {
                      r.reject(e);
                    });
                  }), o.ee.once("multiTimeOut", function () {
                    o.ee.removeAllListeners(), p.doDownloadTaskImpl(t, r, !0).catch(function (e) {
                      r.reject(e);
                    });
                  }), o.ee.once("error", function (e) {
                    o.ee.removeAllListeners(), r.reject(new RtmUnavailableError(["download file file, index %d", e.index], {
                      code: DOWNLOAD_MEDIA_ERR_FAILURE,
                      originalError: e
                    }));
                  }), o.ee.once("notExist", function () {
                    o.abortController.abort(), o.ee.removeAllListeners(), r.reject(new RtmUnavailableError("download file not found", DOWNLOAD_MEDIA_ERR_NOT_EXIST));
                  }), o.ee.once("timedOut", function () {
                    o.ee.removeAllListeners(), o.abortController.abort(), r.reject(new RtmTimeoutError("download timed out", DOWNLOAD_MEDIA_ERR_TIMEOUT));
                  }), void 0 !== o.transHandler.cancelSignal && o.transHandler.cancelSignal.addEventListener("abort", function () {
                    r.reject(new RtmInterruptedError("Downloading canceled", DOWNLOAD_MEDIA_ERR_INTERRUPTED));
                  }, {
                    once: !0
                  }), o.ee.once("finished", function () {
                    r.resolve({
                      type: "DOWNLOAD",
                      payload: o.getPayload()
                    });
                  }), o.setInfoByResponse({
                    serverList: u,
                    backupList: l,
                    unit: c
                  }), o.downloadChunks();

                case 23:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t, r) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "doDownloadTask",
      value: function value(e, t) {
        var r = this,
            n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            o = e.taskId;
        return n || (this.mediaTasks.delete(o), this.ongoingTask = e), new Promise(function (o, i) {
          r.doDownloadTaskImpl(e, t, n).then(o).catch(i);
        });
      }
    }, {
      key: "doUploadTaskImpl",
      value: function () {
        var e = _asyncToGenerator$9(regenerator.mark(function e(t, r) {
          var n,
              o,
              i,
              s,
              a,
              u,
              l,
              c,
              p,
              f = this,
              d = arguments;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return n = d.length > 2 && void 0 !== d[2] && d[2], o = t.manager, i = o, n && (o = new ChunkUploadManager(i.metaInfo, i.transHandler, this.logger, i.ee)), s = t.fetcher, a = new Subject(), l = new Promise(function (e, l) {
                    var c = s(),
                        p = c.fin,
                        f = c.ret,
                        d = c.err,
                        g = c.timeout;
                    p.pipe(takeUntil(a)).subscribe({
                      next: function next(e) {
                        var t = e.unit,
                            n = e.zone;
                        r.resolve({
                          type: "UPLOAD",
                          retUnit: t,
                          zone: n
                        });
                      },
                      complete: function complete() {
                        e({
                          hasExist: !0
                        }), a.next(), a.complete();
                      }
                    }), f.pipe(takeUntil(a), mergeMap(function () {
                      var e = _asyncToGenerator$9(regenerator.mark(function e(s) {
                        var a, l;
                        return regenerator.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                if (a = s.servers, l = s.unit, n && i.unit !== l ? r.reject(new RtmUnavailableError("upload unit is different, reject to continue", UPLOAD_MEDIA_ERR_FAILURE)) : n && (t.manager = o, o.chunkCount = i.chunkCount, o.chunks = i.chunks, o.totalFailures = i.totalFailures, o.uploadedChunks = i.uploadedChunks, o.timer = i.timer, o.initState = i.initState, o.unit = i.unit, o.uploadedSize = i.uploadedSize, o.singleThread = i.singleThread, o.updateProgress(0)), o.addServers(a), "uninitialized" !== o.initState) {
                                  e.next = 7;
                                  break;
                                }

                                return u = o.initChunks(l), e.next = 7, u;

                              case 7:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e);
                      }));

                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }())).subscribe({
                      complete: function complete() {
                        return e({
                          hasExist: !1
                        });
                      },
                      error: l
                    });

                    var h = function h(t) {
                      "uninitialized" !== o.initState && u ? e(u.then(function () {
                        return {
                          hasExist: !1
                        };
                      })) : l(t);
                    };

                    d.pipe(takeUntil(a)).subscribe({
                      error: h
                    }), g.pipe(takeUntil(a)).subscribe({
                      error: h
                    });
                  }), e.next = 9, l;

                case 9:
                  if (c = e.sent, !c.hasExist) {
                    e.next = 15;
                    break;
                  }

                  return o.updateProgress(), this.log("file already exists, skipping upload"), e.abrupt("return");

                case 15:
                  a.next(), a.complete(), this.log("chunks initialization promise resolved"), p = fromEvent(o.ee, "serverUsedUp").pipe(takeWhile(function () {
                    return o.chunkCount !== o.uploadedChunks.length;
                  }), throttleTime(5e3, void 0, {
                    leading: !1
                  }), exhaustMap(function () {
                    return s().ret;
                  })).subscribe(function (e) {
                    var t = e.servers;
                    o.addServers(t);
                  }), o.ee.once("reconnected", function () {
                    o.ee.removeAllListeners(), f.doUploadTask(t, r, !0).catch(function (e) {
                      r.reject(e);
                    });
                  }), o.ee.once("multiTimeOut", function () {
                    o.ee.removeAllListeners(), f.doUploadTask(t, r, !0).catch(function (e) {
                      r.reject(e);
                    });
                  }), o.ee.once("timedOut", function () {
                    p.unsubscribe(), o.ee.removeAllListeners(), o.abortController.abort(), r.reject(new RtmTimeoutError("upload timed out", UPLOAD_MEDIA_ERR_TIMEOUT));
                  }), o.ee.once("error", function (e) {
                    p.unsubscribe(), o.ee.removeAllListeners(), o.abortController.abort(), r.reject(e || new RtmUnavailableError("upload error", UPLOAD_MEDIA_ERR_FAILURE));
                  }), void 0 !== o.transHandler.cancelSignal && o.transHandler.cancelSignal.addEventListener("abort", function () {
                    r.reject(new RtmInterruptedError("Uploading canceled", UPLOAD_MEDIA_ERR_INTERRUPTED));
                  }, {
                    once: !0
                  }), o.ee.once("finished", _asyncToGenerator$9(regenerator.mark(function e() {
                    var n, i, s;
                    return regenerator.wrap(function (e) {
                      for (;;) {
                        switch (e.prev = e.next) {
                          case 0:
                            return p.unsubscribe(), e.next = 3, t.setter(o.unit, o.getUploadServerIPs());

                          case 3:
                            n = e.sent, i = n.zone, s = n.unit, o.ee.removeAllListeners(), r.resolve({
                              type: "UPLOAD",
                              retUnit: s,
                              zone: i
                            });

                          case 8:
                          case "end":
                            return e.stop();
                        }
                      }
                    }, e);
                  }))), o.uploadToServers();

                case 26:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t, r) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "doUploadTask",
      value: function value(e, t) {
        var r = this,
            n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            o = e.taskId;
        return n || (this.mediaTasks.delete(o), this.ongoingTask = e), new Promise(function (o, i) {
          r.doUploadTaskImpl(e, t, n).then(o).catch(i);
        });
      }
    }, {
      key: "processMediaTask",
      value: function () {
        var e = _asyncToGenerator$9(regenerator.mark(function e() {
          var t, r, n;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (0 !== this.mediaTasks.size) {
                    e.next = 2;
                    break;
                  }

                  throw new Error("no upload tasks");

                case 2:
                  if (this.isProcessing = !0, t = this.mediaTasks.keys().next().value, void 0 !== (r = this.taskFinishers[t])) {
                    e.next = 7;
                    break;
                  }

                  throw new Error("top task not found");

                case 7:
                  if (void 0 !== (n = this.mediaTasks.get(t))) {
                    e.next = 10;
                    break;
                  }

                  throw new RtmInternalError("task invalid");

                case 10:
                  if ("UPLOAD" !== n.type) {
                    e.next = 15;
                    break;
                  }

                  return e.next = 13, this.doUploadTask(n, r).catch(function (e) {
                    n.manager.ee.removeAllListeners(), r.reject(e);
                  });

                case 13:
                  e.next = 18;
                  break;

                case 15:
                  if ("DOWNLOAD" !== n.type) {
                    e.next = 18;
                    break;
                  }

                  return e.next = 18, this.doDownloadTask(n, r).catch(function (e) {
                    n.manager.ee.removeAllListeners(), r.reject(e);
                  });

                case 18:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function () {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "cancelTask",
      value: function value(e) {
        var t = "DOWNLOAD" === e.type ? DOWNLOAD_MEDIA_ERR_INTERRUPTED : UPLOAD_MEDIA_ERR_INTERRUPTED;
        e.manager.ee.removeAllListeners(), e.manager.abortController.abort(), void 0 !== this.taskFinishers[e.taskId] && this.taskFinishers[e.taskId].reject(new RtmInterruptedError("User logged out or kicked off, media task canceled", t));
      }
    }]), t;
  }();

  function compact(e) {
    for (var t = -1, r = null == e ? 0 : e.length, n = 0, o = []; ++t < r;) {
      var i = e[t];
      i && (o[n++] = i);
    }

    return o;
  }

  MediaTaskManager.MAX_PENDING_TASK_COUNT = 9;
  var compact_1 = compact,
      UZIP_1 = createCommonjsModule(function (e) {
    var t,
        r,
        n = {};
    e.exports = n, n.parse = function (e, t) {
      for (var r = n.bin.readUshort, o = n.bin.readUint, i = 0, s = {}, a = new Uint8Array(e), u = a.length - 4; 101010256 != o(a, u);) {
        u--;
      }

      i = u;
      i += 4;
      var l = r(a, i += 4),
          c = (r(a, i += 2), o(a, i += 2)),
          p = o(a, i += 4);
      i += 4, i = p;

      for (var f = 0; f < l; f++) {
        o(a, i);
        i += 4, i += 4, i += 4;
        o(a, i += 4), c = o(a, i += 4);
        var d = o(a, i += 4),
            g = r(a, i += 4),
            h = r(a, i + 2),
            b = r(a, i + 4);
        i += 6;
        var y = o(a, i += 8);
        i += 4, i += g + h + b, n._readLocal(a, y, s, c, d, t);
      }

      return s;
    }, n._readLocal = function (e, t, r, o, i, s) {
      var a = n.bin.readUshort,
          u = n.bin.readUint,
          l = (u(e, t), a(e, t += 4), a(e, t += 2), a(e, t += 2));
      u(e, t += 2), u(e, t += 4);
      t += 4;
      var c = a(e, t += 8),
          p = a(e, t += 2);
      t += 2;
      var f = n.bin.readUTF8(e, t, c);
      if (t += c, t += p, s) r[f] = {
        size: i,
        csize: o
      };else {
        var d = new Uint8Array(e.buffer, t);
        if (0 == l) r[f] = new Uint8Array(d.buffer.slice(t, t + o));else {
          if (8 != l) throw "unknown compression method: " + l;
          var g = new Uint8Array(i);
          n.inflateRaw(d, g), r[f] = g;
        }
      }
    }, n.inflateRaw = function (e, t) {
      return n.F.inflate(e, t);
    }, n.inflate = function (e, t) {
      e[0], e[1];
      return n.inflateRaw(new Uint8Array(e.buffer, e.byteOffset + 2, e.length - 6), t);
    }, n.deflate = function (e, t) {
      null == t && (t = {
        level: 6
      });
      var r = 0,
          o = new Uint8Array(50 + Math.floor(1.1 * e.length));
      o[r] = 120, o[r + 1] = 156, r += 2, r = n.F.deflateRaw(e, o, r, t.level);
      var i = n.adler(e, 0, e.length);
      return o[r + 0] = i >>> 24 & 255, o[r + 1] = i >>> 16 & 255, o[r + 2] = i >>> 8 & 255, o[r + 3] = i >>> 0 & 255, new Uint8Array(o.buffer, 0, r + 4);
    }, n.deflateRaw = function (e, t) {
      null == t && (t = {
        level: 6
      });
      var r = new Uint8Array(50 + Math.floor(1.1 * e.length)),
          o = n.F.deflateRaw(e, r, o, t.level);
      return new Uint8Array(r.buffer, 0, o);
    }, n.encode = function (e, t) {
      null == t && (t = !1);
      var r = 0,
          o = n.bin.writeUint,
          i = n.bin.writeUshort,
          s = {};

      for (var a in e) {
        var u = !n._noNeed(a) && !t,
            l = e[a],
            c = n.crc.crc(l, 0, l.length);
        s[a] = {
          cpr: u,
          usize: l.length,
          crc: c,
          file: u ? n.deflateRaw(l) : l
        };
      }

      for (var a in s) {
        r += s[a].file.length + 30 + 46 + 2 * n.bin.sizeUTF8(a);
      }

      r += 22;
      var p = new Uint8Array(r),
          f = 0,
          d = [];

      for (var a in s) {
        var g = s[a];
        d.push(f), f = n._writeHeader(p, f, a, g, 0);
      }

      var h = 0,
          b = f;

      for (var a in s) {
        g = s[a];
        d.push(f), f = n._writeHeader(p, f, a, g, 1, d[h++]);
      }

      var y = f - b;
      return o(p, f, 101010256), f += 4, i(p, f += 4, h), i(p, f += 2, h), o(p, f += 2, y), o(p, f += 4, b), f += 4, f += 2, p.buffer;
    }, n._noNeed = function (e) {
      var t = e.split(".").pop().toLowerCase();
      return -1 != "png,jpg,jpeg,zip".indexOf(t);
    }, n._writeHeader = function (e, t, r, o, i, s) {
      var a = n.bin.writeUint,
          u = n.bin.writeUshort,
          l = o.file;
      return a(e, t, 0 == i ? 67324752 : 33639248), t += 4, 1 == i && (t += 2), u(e, t, 20), u(e, t += 2, 0), u(e, t += 2, o.cpr ? 8 : 0), a(e, t += 2, 0), a(e, t += 4, o.crc), a(e, t += 4, l.length), a(e, t += 4, o.usize), u(e, t += 4, n.bin.sizeUTF8(r)), u(e, t += 2, 0), t += 2, 1 == i && (t += 2, t += 2, a(e, t += 6, s), t += 4), t += n.bin.writeUTF8(e, t, r), 0 == i && (e.set(l, t), t += l.length), t;
    }, n.crc = {
      table: function () {
        for (var e = new Uint32Array(256), t = 0; t < 256; t++) {
          for (var r = t, n = 0; n < 8; n++) {
            1 & r ? r = 3988292384 ^ r >>> 1 : r >>>= 1;
          }

          e[t] = r;
        }

        return e;
      }(),
      update: function update(e, t, r, o) {
        for (var i = 0; i < o; i++) {
          e = n.crc.table[255 & (e ^ t[r + i])] ^ e >>> 8;
        }

        return e;
      },
      crc: function crc(e, t, r) {
        return 4294967295 ^ n.crc.update(4294967295, e, t, r);
      }
    }, n.adler = function (e, t, r) {
      for (var n = 1, o = 0, i = t, s = t + r; i < s;) {
        for (var a = Math.min(i + 5552, s); i < a;) {
          o += n += e[i++];
        }

        n %= 65521, o %= 65521;
      }

      return o << 16 | n;
    }, n.bin = {
      readUshort: function readUshort(e, t) {
        return e[t] | e[t + 1] << 8;
      },
      writeUshort: function writeUshort(e, t, r) {
        e[t] = 255 & r, e[t + 1] = r >> 8 & 255;
      },
      readUint: function readUint(e, t) {
        return 16777216 * e[t + 3] + (e[t + 2] << 16 | e[t + 1] << 8 | e[t]);
      },
      writeUint: function writeUint(e, t, r) {
        e[t] = 255 & r, e[t + 1] = r >> 8 & 255, e[t + 2] = r >> 16 & 255, e[t + 3] = r >> 24 & 255;
      },
      readASCII: function readASCII(e, t, r) {
        for (var n = "", o = 0; o < r; o++) {
          n += String.fromCharCode(e[t + o]);
        }

        return n;
      },
      writeASCII: function writeASCII(e, t, r) {
        for (var n = 0; n < r.length; n++) {
          e[t + n] = r.charCodeAt(n);
        }
      },
      pad: function pad(e) {
        return e.length < 2 ? "0" + e : e;
      },
      readUTF8: function readUTF8(e, t, r) {
        for (var o, i = "", s = 0; s < r; s++) {
          i += "%" + n.bin.pad(e[t + s].toString(16));
        }

        try {
          o = decodeURIComponent(i);
        } catch (o) {
          return n.bin.readASCII(e, t, r);
        }

        return o;
      },
      writeUTF8: function writeUTF8(e, t, r) {
        for (var n = r.length, o = 0, i = 0; i < n; i++) {
          var s = r.charCodeAt(i);
          if (0 == (4294967168 & s)) e[t + o] = s, o++;else if (0 == (4294965248 & s)) e[t + o] = 192 | s >> 6, e[t + o + 1] = 128 | s >> 0 & 63, o += 2;else if (0 == (4294901760 & s)) e[t + o] = 224 | s >> 12, e[t + o + 1] = 128 | s >> 6 & 63, e[t + o + 2] = 128 | s >> 0 & 63, o += 3;else {
            if (0 != (4292870144 & s)) throw "e";
            e[t + o] = 240 | s >> 18, e[t + o + 1] = 128 | s >> 12 & 63, e[t + o + 2] = 128 | s >> 6 & 63, e[t + o + 3] = 128 | s >> 0 & 63, o += 4;
          }
        }

        return o;
      },
      sizeUTF8: function sizeUTF8(e) {
        for (var t = e.length, r = 0, n = 0; n < t; n++) {
          var o = e.charCodeAt(n);
          if (0 == (4294967168 & o)) r++;else if (0 == (4294965248 & o)) r += 2;else if (0 == (4294901760 & o)) r += 3;else {
            if (0 != (4292870144 & o)) throw "e";
            r += 4;
          }
        }

        return r;
      }
    }, n.F = {}, n.F.deflateRaw = function (e, t, r, o) {
      var i = [[0, 0, 0, 0, 0], [4, 4, 8, 4, 0], [4, 5, 16, 8, 0], [4, 6, 16, 16, 0], [4, 10, 16, 32, 0], [8, 16, 32, 32, 0], [8, 16, 128, 128, 0], [8, 32, 128, 256, 0], [32, 128, 258, 1024, 1], [32, 258, 258, 4096, 1]][o],
          s = n.F.U,
          a = n.F._goodIndex,
          u = (n.F._hash, n.F._putsE),
          l = 0,
          c = r << 3,
          p = 0,
          f = e.length;

      if (0 == o) {
        for (; l < f;) {
          u(t, c, l + ($ = Math.min(65535, f - l)) == f ? 1 : 0), c = n.F._copyExact(e, l, $, t, c + 8), l += $;
        }

        return c >>> 3;
      }

      var d = s.lits,
          g = s.strt,
          h = s.prev,
          b = 0,
          y = 0,
          _ = 0,
          m = 0,
          v = 0,
          E = 0;

      for (f > 2 && (g[E = n.F._hash(e, 0)] = 0), l = 0; l < f; l++) {
        if (v = E, l + 1 < f - 2) {
          E = n.F._hash(e, l + 1);
          var O = l + 1 & 32767;
          h[O] = g[E], g[E] = O;
        }

        if (p <= l) {
          (b > 14e3 || y > 26697) && f - l > 100 && (p < l && (d[b] = l - p, b += 2, p = l), c = n.F._writeBlock(l == f - 1 || p == f ? 1 : 0, d, b, m, e, _, l - _, t, c), b = y = m = 0, _ = l);
          var I = 0;
          l < f - 2 && (I = n.F._bestMatch(e, l, h, v, Math.min(i[2], f - l), i[3]));
          var $ = I >>> 16,
              S = 65535 & I;

          if (0 != I) {
            S = 65535 & I;
            var w = a($ = I >>> 16, s.of0);
            s.lhst[257 + w]++;
            var R = a(S, s.df0);
            s.dhst[R]++, m += s.exb[w] + s.dxb[R], d[b] = $ << 23 | l - p, d[b + 1] = S << 16 | w << 8 | R, b += 2, p = l + $;
          } else s.lhst[e[l]]++;

          y++;
        }
      }

      for (_ == l && 0 != e.length || (p < l && (d[b] = l - p, b += 2, p = l), c = n.F._writeBlock(1, d, b, m, e, _, l - _, t, c), b = 0, y = 0, b = y = m = 0, _ = l); 0 != (7 & c);) {
        c++;
      }

      return c >>> 3;
    }, n.F._bestMatch = function (e, t, r, o, i, s) {
      var a = 32767 & t,
          u = r[a],
          l = a - u + 32768 & 32767;
      if (u == a || o != n.F._hash(e, t - l)) return 0;

      for (var c = 0, p = 0, f = Math.min(32767, t); l <= f && 0 != --s && u != a;) {
        if (0 == c || e[t + c] == e[t + c - l]) {
          var d = n.F._howLong(e, t, l);

          if (d > c) {
            if (p = l, (c = d) >= i) break;
            l + 2 < d && (d = l + 2);

            for (var g = 0, h = 0; h < d - 2; h++) {
              var b = t - l + h + 32768 & 32767,
                  y = b - r[b] + 32768 & 32767;
              y > g && (g = y, u = b);
            }
          }
        }

        l += (a = u) - (u = r[a]) + 32768 & 32767;
      }

      return c << 16 | p;
    }, n.F._howLong = function (e, t, r) {
      if (e[t] != e[t - r] || e[t + 1] != e[t + 1 - r] || e[t + 2] != e[t + 2 - r]) return 0;
      var n = t,
          o = Math.min(e.length, t + 258);

      for (t += 3; t < o && e[t] == e[t - r];) {
        t++;
      }

      return t - n;
    }, n.F._hash = function (e, t) {
      return (e[t] << 8 | e[t + 1]) + (e[t + 2] << 4) & 65535;
    }, n.saved = 0, n.F._writeBlock = function (e, t, r, o, i, s, a, u, l) {
      var c,
          p,
          f,
          d,
          g,
          h,
          b,
          y,
          _,
          m = n.F.U,
          v = n.F._putsF,
          E = n.F._putsE;

      m.lhst[256]++, p = (c = n.F.getTrees())[0], f = c[1], d = c[2], g = c[3], h = c[4], b = c[5], y = c[6], _ = c[7];
      var O = 32 + (0 == (l + 3 & 7) ? 0 : 8 - (l + 3 & 7)) + (a << 3),
          I = o + n.F.contSize(m.fltree, m.lhst) + n.F.contSize(m.fdtree, m.dhst),
          $ = o + n.F.contSize(m.ltree, m.lhst) + n.F.contSize(m.dtree, m.dhst);
      $ += 14 + 3 * b + n.F.contSize(m.itree, m.ihst) + (2 * m.ihst[16] + 3 * m.ihst[17] + 7 * m.ihst[18]);

      for (var S = 0; S < 286; S++) {
        m.lhst[S] = 0;
      }

      for (S = 0; S < 30; S++) {
        m.dhst[S] = 0;
      }

      for (S = 0; S < 19; S++) {
        m.ihst[S] = 0;
      }

      var w = O < I && O < $ ? 0 : I < $ ? 1 : 2;

      if (v(u, l, e), v(u, l + 1, w), l += 3, 0 == w) {
        for (; 0 != (7 & l);) {
          l++;
        }

        l = n.F._copyExact(i, s, a, u, l);
      } else {
        var R, A;

        if (1 == w && (R = m.fltree, A = m.fdtree), 2 == w) {
          n.F.makeCodes(m.ltree, p), n.F.revCodes(m.ltree, p), n.F.makeCodes(m.dtree, f), n.F.revCodes(m.dtree, f), n.F.makeCodes(m.itree, d), n.F.revCodes(m.itree, d), R = m.ltree, A = m.dtree, E(u, l, g - 257), E(u, l += 5, h - 1), E(u, l += 5, b - 4), l += 4;

          for (var T = 0; T < b; T++) {
            E(u, l + 3 * T, m.itree[1 + (m.ordr[T] << 1)]);
          }

          l += 3 * b, l = n.F._codeTiny(y, m.itree, u, l), l = n.F._codeTiny(_, m.itree, u, l);
        }

        for (var N = s, L = 0; L < r; L += 2) {
          for (var P = t[L], C = P >>> 23, k = N + (8388607 & P); N < k;) {
            l = n.F._writeLit(i[N++], R, u, l);
          }

          if (0 != C) {
            var x = t[L + 1],
                M = x >> 16,
                q = x >> 8 & 255,
                j = 255 & x;
            E(u, l = n.F._writeLit(257 + q, R, u, l), C - m.of0[q]), l += m.exb[q], v(u, l = n.F._writeLit(j, A, u, l), M - m.df0[j]), l += m.dxb[j], N += C;
          }
        }

        l = n.F._writeLit(256, R, u, l);
      }

      return l;
    }, n.F._copyExact = function (e, t, r, n, o) {
      var i = o >>> 3;
      return n[i] = r, n[i + 1] = r >>> 8, n[i + 2] = 255 - n[i], n[i + 3] = 255 - n[i + 1], i += 4, n.set(new Uint8Array(e.buffer, t, r), i), o + (r + 4 << 3);
    }, n.F.getTrees = function () {
      for (var e = n.F.U, t = n.F._hufTree(e.lhst, e.ltree, 15), r = n.F._hufTree(e.dhst, e.dtree, 15), o = [], i = n.F._lenCodes(e.ltree, o), s = [], a = n.F._lenCodes(e.dtree, s), u = 0; u < o.length; u += 2) {
        e.ihst[o[u]]++;
      }

      for (u = 0; u < s.length; u += 2) {
        e.ihst[s[u]]++;
      }

      for (var l = n.F._hufTree(e.ihst, e.itree, 7), c = 19; c > 4 && 0 == e.itree[1 + (e.ordr[c - 1] << 1)];) {
        c--;
      }

      return [t, r, l, i, a, c, o, s];
    }, n.F.getSecond = function (e) {
      for (var t = [], r = 0; r < e.length; r += 2) {
        t.push(e[r + 1]);
      }

      return t;
    }, n.F.nonZero = function (e) {
      for (var t = "", r = 0; r < e.length; r += 2) {
        0 != e[r + 1] && (t += (r >> 1) + ",");
      }

      return t;
    }, n.F.contSize = function (e, t) {
      for (var r = 0, n = 0; n < t.length; n++) {
        r += t[n] * e[1 + (n << 1)];
      }

      return r;
    }, n.F._codeTiny = function (e, t, r, o) {
      for (var i = 0; i < e.length; i += 2) {
        var s = e[i],
            a = e[i + 1];
        o = n.F._writeLit(s, t, r, o);
        var u = 16 == s ? 2 : 17 == s ? 3 : 7;
        s > 15 && (n.F._putsE(r, o, a, u), o += u);
      }

      return o;
    }, n.F._lenCodes = function (e, t) {
      for (var r = e.length; 2 != r && 0 == e[r - 1];) {
        r -= 2;
      }

      for (var n = 0; n < r; n += 2) {
        var o = e[n + 1],
            i = n + 3 < r ? e[n + 3] : -1,
            s = n + 5 < r ? e[n + 5] : -1,
            a = 0 == n ? -1 : e[n - 1];

        if (0 == o && i == o && s == o) {
          for (var u = n + 5; u + 2 < r && e[u + 2] == o;) {
            u += 2;
          }

          (l = Math.min(u + 1 - n >>> 1, 138)) < 11 ? t.push(17, l - 3) : t.push(18, l - 11), n += 2 * l - 2;
        } else if (o == a && i == o && s == o) {
          for (u = n + 5; u + 2 < r && e[u + 2] == o;) {
            u += 2;
          }

          var l = Math.min(u + 1 - n >>> 1, 6);
          t.push(16, l - 3), n += 2 * l - 2;
        } else t.push(o, 0);
      }

      return r >>> 1;
    }, n.F._hufTree = function (e, t, r) {
      var o = [],
          i = e.length,
          s = t.length,
          a = 0;

      for (a = 0; a < s; a += 2) {
        t[a] = 0, t[a + 1] = 0;
      }

      for (a = 0; a < i; a++) {
        0 != e[a] && o.push({
          lit: a,
          f: e[a]
        });
      }

      var u = o.length,
          l = o.slice(0);
      if (0 == u) return 0;

      if (1 == u) {
        var c = o[0].lit;
        l = 0 == c ? 1 : 0;
        return t[1 + (c << 1)] = 1, t[1 + (l << 1)] = 1, 1;
      }

      o.sort(function (e, t) {
        return e.f - t.f;
      });
      var p = o[0],
          f = o[1],
          d = 0,
          g = 1,
          h = 2;

      for (o[0] = {
        lit: -1,
        f: p.f + f.f,
        l: p,
        r: f,
        d: 0
      }; g != u - 1;) {
        p = d != g && (h == u || o[d].f < o[h].f) ? o[d++] : o[h++], f = d != g && (h == u || o[d].f < o[h].f) ? o[d++] : o[h++], o[g++] = {
          lit: -1,
          f: p.f + f.f,
          l: p,
          r: f
        };
      }

      var b = n.F.setDepth(o[g - 1], 0);

      for (b > r && (n.F.restrictDepth(l, r, b), b = r), a = 0; a < u; a++) {
        t[1 + (l[a].lit << 1)] = l[a].d;
      }

      return b;
    }, n.F.setDepth = function (e, t) {
      return -1 != e.lit ? (e.d = t, t) : Math.max(n.F.setDepth(e.l, t + 1), n.F.setDepth(e.r, t + 1));
    }, n.F.restrictDepth = function (e, t, r) {
      var n = 0,
          o = 1 << r - t,
          i = 0;

      for (e.sort(function (e, t) {
        return t.d == e.d ? e.f - t.f : t.d - e.d;
      }), n = 0; n < e.length && e[n].d > t; n++) {
        var s = e[n].d;
        e[n].d = t, i += o - (1 << r - s);
      }

      for (i >>>= r - t; i > 0;) {
        (s = e[n].d) < t ? (e[n].d++, i -= 1 << t - s - 1) : n++;
      }

      for (; n >= 0; n--) {
        e[n].d == t && i < 0 && (e[n].d--, i++);
      }

      0 != i && console.log("debt left");
    }, n.F._goodIndex = function (e, t) {
      var r = 0;
      return t[16 | r] <= e && (r |= 16), t[8 | r] <= e && (r |= 8), t[4 | r] <= e && (r |= 4), t[2 | r] <= e && (r |= 2), t[1 | r] <= e && (r |= 1), r;
    }, n.F._writeLit = function (e, t, r, o) {
      return n.F._putsF(r, o, t[e << 1]), o + t[1 + (e << 1)];
    }, n.F.inflate = function (e, t) {
      var r = Uint8Array;
      if (3 == e[0] && 0 == e[1]) return t || new r(0);
      var o = n.F,
          i = o._bitsF,
          s = o._bitsE,
          a = o._decodeTiny,
          u = o.makeCodes,
          l = o.codes2map,
          c = o._get17,
          p = o.U,
          f = null == t;
      f && (t = new r(e.length >>> 2 << 3));

      for (var d, g, h = 0, b = 0, y = 0, _ = 0, m = 0, v = 0, E = 0, O = 0, I = 0; 0 == h;) {
        if (h = i(e, I, 1), b = i(e, I + 1, 2), I += 3, 0 != b) {
          if (f && (t = n.F._check(t, O + (1 << 17))), 1 == b && (d = p.flmap, g = p.fdmap, v = 511, E = 31), 2 == b) {
            y = s(e, I, 5) + 257, _ = s(e, I + 5, 5) + 1, m = s(e, I + 10, 4) + 4, I += 14;

            for (var $ = 0; $ < 38; $ += 2) {
              p.itree[$] = 0, p.itree[$ + 1] = 0;
            }

            var S = 1;

            for ($ = 0; $ < m; $++) {
              var w = s(e, I + 3 * $, 3);
              p.itree[1 + (p.ordr[$] << 1)] = w, w > S && (S = w);
            }

            I += 3 * m, u(p.itree, S), l(p.itree, S, p.imap), d = p.lmap, g = p.dmap, I = a(p.imap, (1 << S) - 1, y + _, e, I, p.ttree);

            var R = o._copyOut(p.ttree, 0, y, p.ltree);

            v = (1 << R) - 1;

            var A = o._copyOut(p.ttree, y, _, p.dtree);

            E = (1 << A) - 1, u(p.ltree, R), l(p.ltree, R, d), u(p.dtree, A), l(p.dtree, A, g);
          }

          for (;;) {
            var T = d[c(e, I) & v];
            I += 15 & T;
            var N = T >>> 4;
            if (N >>> 8 == 0) t[O++] = N;else {
              if (256 == N) break;
              var L = O + N - 254;

              if (N > 264) {
                var P = p.ldef[N - 257];
                L = O + (P >>> 3) + s(e, I, 7 & P), I += 7 & P;
              }

              var C = g[c(e, I) & E];
              I += 15 & C;
              var k = C >>> 4,
                  x = p.ddef[k],
                  M = (x >>> 4) + i(e, I, 15 & x);

              for (I += 15 & x, f && (t = n.F._check(t, O + (1 << 17))); O < L;) {
                t[O] = t[O++ - M], t[O] = t[O++ - M], t[O] = t[O++ - M], t[O] = t[O++ - M];
              }

              O = L;
            }
          }
        } else {
          0 != (7 & I) && (I += 8 - (7 & I));
          var q = 4 + (I >>> 3),
              j = e[q - 4] | e[q - 3] << 8;
          f && (t = n.F._check(t, O + j)), t.set(new r(e.buffer, e.byteOffset + q, j), O), I = q + j << 3, O += j;
        }
      }

      return t.length == O ? t : t.slice(0, O);
    }, n.F._check = function (e, t) {
      var r = e.length;
      if (t <= r) return e;
      var n = new Uint8Array(Math.max(r << 1, t));
      return n.set(e, 0), n;
    }, n.F._decodeTiny = function (e, t, r, o, i, s) {
      for (var a = n.F._bitsE, u = n.F._get17, l = 0; l < r;) {
        var c = e[u(o, i) & t];
        i += 15 & c;
        var p = c >>> 4;
        if (p <= 15) s[l] = p, l++;else {
          var f = 0,
              d = 0;
          16 == p ? (d = 3 + a(o, i, 2), i += 2, f = s[l - 1]) : 17 == p ? (d = 3 + a(o, i, 3), i += 3) : 18 == p && (d = 11 + a(o, i, 7), i += 7);

          for (var g = l + d; l < g;) {
            s[l] = f, l++;
          }
        }
      }

      return i;
    }, n.F._copyOut = function (e, t, r, n) {
      for (var o = 0, i = 0, s = n.length >>> 1; i < r;) {
        var a = e[i + t];
        n[i << 1] = 0, n[1 + (i << 1)] = a, a > o && (o = a), i++;
      }

      for (; i < s;) {
        n[i << 1] = 0, n[1 + (i << 1)] = 0, i++;
      }

      return o;
    }, n.F.makeCodes = function (e, t) {
      for (var r, o, i, s, a = n.F.U, u = e.length, l = a.bl_count, c = 0; c <= t; c++) {
        l[c] = 0;
      }

      for (c = 1; c < u; c += 2) {
        l[e[c]]++;
      }

      var p = a.next_code;

      for (r = 0, l[0] = 0, o = 1; o <= t; o++) {
        r = r + l[o - 1] << 1, p[o] = r;
      }

      for (i = 0; i < u; i += 2) {
        0 != (s = e[i + 1]) && (e[i] = p[s], p[s]++);
      }
    }, n.F.codes2map = function (e, t, r) {
      for (var o = e.length, i = n.F.U.rev15, s = 0; s < o; s += 2) {
        if (0 != e[s + 1]) for (var a = s >> 1, u = e[s + 1], l = a << 4 | u, c = t - u, p = e[s] << c, f = p + (1 << c); p != f;) {
          r[i[p] >>> 15 - t] = l, p++;
        }
      }
    }, n.F.revCodes = function (e, t) {
      for (var r = n.F.U.rev15, o = 15 - t, i = 0; i < e.length; i += 2) {
        var s = e[i] << t - e[i + 1];
        e[i] = r[s] >>> o;
      }
    }, n.F._putsE = function (e, t, r) {
      r <<= 7 & t;
      var n = t >>> 3;
      e[n] |= r, e[n + 1] |= r >>> 8;
    }, n.F._putsF = function (e, t, r) {
      r <<= 7 & t;
      var n = t >>> 3;
      e[n] |= r, e[n + 1] |= r >>> 8, e[n + 2] |= r >>> 16;
    }, n.F._bitsE = function (e, t, r) {
      return (e[t >>> 3] | e[1 + (t >>> 3)] << 8) >>> (7 & t) & (1 << r) - 1;
    }, n.F._bitsF = function (e, t, r) {
      return (e[t >>> 3] | e[1 + (t >>> 3)] << 8 | e[2 + (t >>> 3)] << 16) >>> (7 & t) & (1 << r) - 1;
    }, n.F._get17 = function (e, t) {
      return (e[t >>> 3] | e[1 + (t >>> 3)] << 8 | e[2 + (t >>> 3)] << 16) >>> (7 & t);
    }, n.F._get25 = function (e, t) {
      return (e[t >>> 3] | e[1 + (t >>> 3)] << 8 | e[2 + (t >>> 3)] << 16 | e[3 + (t >>> 3)] << 24) >>> (7 & t);
    }, n.F.U = (t = Uint16Array, r = Uint32Array, {
      next_code: new t(16),
      bl_count: new t(16),
      ordr: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
      of0: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 999, 999, 999],
      exb: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0],
      ldef: new t(32),
      df0: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 65535, 65535],
      dxb: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0],
      ddef: new r(32),
      flmap: new t(512),
      fltree: [],
      fdmap: new t(32),
      fdtree: [],
      lmap: new t(32768),
      ltree: [],
      ttree: [],
      dmap: new t(32768),
      dtree: [],
      imap: new t(512),
      itree: [],
      rev15: new t(32768),
      lhst: new r(286),
      dhst: new r(30),
      ihst: new r(19),
      lits: new r(15e3),
      strt: new t(65536),
      prev: new t(32768)
    }), function () {
      for (var e = n.F.U, t = 0; t < 32768; t++) {
        var r = t;
        r = (4278255360 & (r = (4042322160 & (r = (3435973836 & (r = (2863311530 & r) >>> 1 | (1431655765 & r) << 1)) >>> 2 | (858993459 & r) << 2)) >>> 4 | (252645135 & r) << 4)) >>> 8 | (16711935 & r) << 8, e.rev15[t] = (r >>> 16 | r << 16) >>> 17;
      }

      function o(e, t, r) {
        for (; 0 != t--;) {
          e.push(0, r);
        }
      }

      for (t = 0; t < 32; t++) {
        e.ldef[t] = e.of0[t] << 3 | e.exb[t], e.ddef[t] = e.df0[t] << 4 | e.dxb[t];
      }

      o(e.fltree, 144, 8), o(e.fltree, 112, 9), o(e.fltree, 24, 7), o(e.fltree, 8, 8), n.F.makeCodes(e.fltree, 9), n.F.codes2map(e.fltree, 9, e.flmap), n.F.revCodes(e.fltree, 9), o(e.fdtree, 32, 5), n.F.makeCodes(e.fdtree, 5), n.F.codes2map(e.fdtree, 5, e.fdmap), n.F.revCodes(e.fdtree, 5), o(e.itree, 19, 0), o(e.ltree, 286, 0), o(e.dtree, 30, 0), o(e.ttree, 320, 0);
    }();
  }),
      UZIP_2 = UZIP_1.deflate,
      UZIP_3 = UZIP_1.inflate;

  function createFind(e) {
    return function (t, r, n) {
      var o = Object(t);

      if (!isArrayLike_1(t)) {
        var i = _baseIteratee(r);

        t = keys_1(t), r = function r(e) {
          return i(o[e], e, o);
        };
      }

      var s = e(t, r, n);
      return s > -1 ? o[i ? t[s] : s] : void 0;
    };
  }

  var _createFind = createFind,
      INFINITY$3 = 1 / 0,
      MAX_INTEGER = 1.7976931348623157e308;

  function toFinite(e) {
    return e ? (e = toNumber_1(e)) === INFINITY$3 || e === -INFINITY$3 ? (e < 0 ? -1 : 1) * MAX_INTEGER : e == e ? e : 0 : 0 === e ? e : 0;
  }

  var toFinite_1 = toFinite;

  function toInteger(e) {
    var t = toFinite_1(e),
        r = t % 1;
    return t == t ? r ? t - r : t : 0;
  }

  var toInteger_1 = toInteger,
      nativeMax$2 = Math.max;

  function findIndex(e, t, r) {
    var n = null == e ? 0 : e.length;
    if (!n) return -1;
    var o = null == r ? 0 : toInteger_1(r);
    return o < 0 && (o = nativeMax$2(n + o, 0)), _baseFindIndex(e, _baseIteratee(t), o);
  }

  var findIndex_1 = findIndex,
      find = _createFind(findIndex_1),
      find_1 = find;

  function uniqWith(e, t) {
    return t = "function" == typeof t ? t : void 0, e && e.length ? _baseUniq(e, void 0, t) : [];
  }

  var uniqWith_1 = uniqWith;

  function _slicedToArray$8(e, t) {
    return _arrayWithHoles$8(e) || _iterableToArrayLimit$8(e, t) || _nonIterableRest$8();
  }

  function _nonIterableRest$8() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit$8(e, t) {
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }

  function _arrayWithHoles$8(e) {
    if (Array.isArray(e)) return e;
  }

  function _classCallCheck$b(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties$8(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$8(e, t, r) {
    return t && _defineProperties$8(e.prototype, t), r && _defineProperties$8(e, r), e;
  }

  function comparator(e, t) {
    return long_1.fromValue(e).eq(t);
  }

  function validateField(e, t) {
    var r = void 0 === t ? e.val : t,
        n = e.isBoolean,
        o = e.isNumber,
        i = e.oneof,
        s = e.len;
    if (2 !== [n, o, i].filter(function (e) {
      return !e;
    }).length) throw new TypeError("invalid field type");

    if (void 0 !== r) {
      var a = !1;

      if (void 0 !== i) {
        var u = values_1(i);
        uniqWith_1(u, comparator).length === u.length && void 0 !== find_1(u, function (e) {
          return comparator(r, e);
        }) && (a = !0);
      }

      var l = void 0 !== n && (0 === r || 1 === r) && 1 === s,
          c = void 0 !== o && r.toString(2).length <= s;
      if (!(a || l || c)) throw new Error("invalid field value");
    }
  }

  var Struct = function () {
    function e() {
      _classCallCheck$b(this, e), this.size = 0, this.fields = new Map();
    }

    return _createClass$8(e, [{
      key: "define",
      value: function value(e, t, r) {
        if (this.size += r, this.size > 64) throw new RangeError("the struct over 64 bits is not supported");
        var n = {
          val: 0,
          isNumber: "number" === t,
          isBoolean: "boolean" === t,
          oneof: "number" === t || "boolean" === t ? void 0 : t,
          len: r
        };
        validateField(n), this.fields.set(e, n);
      }
    }, {
      key: "set",
      value: function value(e, t) {
        var r = this.fields.get(e);
        if (!r) throw new Error("field not found");
        var n,
            o = r.oneof;
        if (long_1.isLong(t) || "number" == typeof t) n = t;else if ("boolean" == typeof t) n = t ? 1 : 0;else {
          if (void 0 === o) throw new Error("invalid field type");
          var i = o[t];
          if (void 0 === i) throw new Error("field type not found");
          n = i;
        }
        validateField(r, n), r.val = n;
      }
    }, {
      key: "toNumber",
      value: function value() {
        var e = 0,
            t = 0,
            r = this.fields,
            n = Array.isArray(r),
            o = 0;

        for (r = n ? r : r[Symbol.iterator]();;) {
          var i;

          if (n) {
            if (o >= r.length) break;
            i = r[o++];
          } else {
            if ((o = r.next()).done) break;
            i = o.value;
          }

          var s = _slicedToArray$8(i, 2)[1],
              a = s.len,
              u = s.val;

          void 0 !== u && (e += long_1.fromValue(u).shiftLeft(t).toNumber(), t += a);
        }

        return e;
      }
    }, {
      key: "toLong",
      value: function value() {
        var e = long_1.fromNumber(0, !0),
            t = 0,
            r = this.fields,
            n = Array.isArray(r),
            o = 0;

        for (r = n ? r : r[Symbol.iterator]();;) {
          var i;

          if (n) {
            if (o >= r.length) break;
            i = r[o++];
          } else {
            if ((o = r.next()).done) break;
            i = o.value;
          }

          var s = _slicedToArray$8(i, 2)[1],
              a = s.len,
              u = s.val;

          void 0 !== u && (e = long_1.fromValue(u).shiftLeft(t).add(e), t += a);
        }

        return e;
      }
    }, {
      key: "assert",
      value: function value(e, t) {
        var r = this.fields.get(e);
        if (!r) throw new Error("field not found");
        var n = r.oneof;

        function o(e) {
          var t;
          if (long_1.isLong(e) || "number" == typeof e) t = e;else if ("boolean" == typeof e) t = e ? 1 : 0;else {
            if (void 0 === n) throw new Error("invalid field type");
            var o = n[e];
            if (void 0 === o) throw new Error("field type not found");
            t = o;
          }
          return validateField(r, t), comparator(t, r.val);
        }

        if (!Array.isArray(t)) return o(t);
        if (1 === t.length) return o(t[0]);
        if (t.every(function (e) {
          return "string" == typeof e;
        }) && void 0 !== n) return t.some(function (e) {
          return o(e);
        });
        throw new Error("invalid valueTypes");
      }
    }, {
      key: "from",
      value: function value(e) {
        var t = long_1.fromValue(e),
            r = 0,
            n = this.fields,
            o = Array.isArray(n),
            i = 0;

        for (n = o ? n : n[Symbol.iterator]();;) {
          var s;

          if (o) {
            if (i >= n.length) break;
            s = n[i++];
          } else {
            if ((i = n.next()).done) break;
            s = i.value;
          }

          var a = _slicedToArray$8(s, 2)[1],
              u = a.len,
              l = long_1.fromNumber(Math.pow(2, u) - 1, !0).shiftLeft(r),
              c = t.and(l).shiftRightUnsigned(r);

          validateField(a, c), a.val = c, r += u;
        }
      }
    }, {
      key: "typeOf",
      value: function value(e) {
        var t = this.fields.get(e);

        if (void 0 !== t) {
          var r = t.oneof,
              n = t.val;
          if (void 0 !== r) for (var o = 0, i = Object.entries(r); o < i.length; o++) {
            var s = _slicedToArray$8(i[o], 2),
                a = s[0];

            if (comparator(n, s[1])) return a;
          }
        }

        throw new TypeError("can only get type of oneof type");
      }
    }]), e;
  }();

  function _typeof$b(e) {
    return (_typeof$b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _classCallCheck$c(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _possibleConstructorReturn$a(e, t) {
    return !t || "object" !== _typeof$b(t) && "function" != typeof t ? _assertThisInitialized$a(e) : t;
  }

  function _assertThisInitialized$a(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _getPrototypeOf$a(e) {
    return (_getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _inherits$a(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$a(e, t);
  }

  function _setPrototypeOf$a(e, t) {
    return (_setPrototypeOf$a = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var UserJoinOptions = function (e) {
    function t(e) {
      var r;
      return _classCallCheck$c(this, t), (r = _possibleConstructorReturn$a(this, _getPrototypeOf$a(t).call(this))).define("Rejoin", "boolean", 1), r.define("Unused", "number", 31), r.define("Platform", "number", 8), r.define("Version", "number", 12), r.define("Subversion", "number", 12), r.set("Platform", WEB_PLATFORM_TYPE), r.set("Version", VERSION_NO), r.set("Subversion", SUBVERSION), r.set("Rejoin", e), r;
    }

    return _inherits$a(t, Struct), t;
  }();

  function _typeof$c(e) {
    return (_typeof$c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _slicedToArray$9(e, t) {
    return _arrayWithHoles$9(e) || _iterableToArrayLimit$9(e, t) || _nonIterableRest$9();
  }

  function _nonIterableRest$9() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit$9(e, t) {
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }

  function _arrayWithHoles$9(e) {
    if (Array.isArray(e)) return e;
  }

  function _classCallCheck$d(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties$9(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$9(e, t, r) {
    return t && _defineProperties$9(e.prototype, t), r && _defineProperties$9(e, r), e;
  }

  function _possibleConstructorReturn$b(e, t) {
    return !t || "object" !== _typeof$c(t) && "function" != typeof t ? _assertThisInitialized$b(e) : t;
  }

  function _assertThisInitialized$b(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _getPrototypeOf$b(e) {
    return (_getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _inherits$b(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$b(e, t);
  }

  function _setPrototypeOf$b(e, t) {
    return (_setPrototypeOf$b = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function ownKeys$3(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function _objectSpread$2(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ownKeys$3(r, !0).forEach(function (t) {
        _defineProperty$4(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys$3(r).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function _defineProperty$4(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  var TextMessageDstType = {
    PeerTextMessage: 0,
    ChannelTextMessage: 1,
    VendorTextMessage: 2
  },
      RawMessageDstType = {
    PeerRawMessage: 3,
    ChannelRawMessage: 4,
    VendorRawMessage: 5
  },
      ImageMessageDstType = {
    PeerImageMessage: 6,
    ChannelImageMessage: 7,
    VendorImageMessage: 8
  },
      FileMessageDstType = {
    PeerFileMessage: 15,
    ChannelFileMessage: 16,
    VendorFileMessage: 17
  },
      MessageDstType = _objectSpread$2({}, TextMessageDstType, {}, RawMessageDstType, {}, ImageMessageDstType, {}, FileMessageDstType),
      InvitationType = {
    CallInvite: 101,
    CallAccept: 102,
    CallReject: 103,
    CallCancel: 104
  },
      MessageType = _objectSpread$2({}, MessageDstType, {}, InvitationType),
      CompressionMethod = {
    Uncompressed: 0,
    Zlib: 1
  },
      MessageOption = function (e) {
    function t(e) {
      var r;
      if (_classCallCheck$d(this, t), (r = _possibleConstructorReturn$b(this, _getPrototypeOf$b(t).call(this))).define("MessageType", MessageType, 8), r.define("BroadcastJumps", "number", 2), r.define("ToCache", "boolean", 1), r.define("FromCache", "boolean", 1), r.define("CompressionMethod", CompressionMethod, 2), r.define("IterationNumber", "number", 4), r.define("BufferedMessage", "boolean", 1), r.define("ToArchive", "boolean", 1), r.define("FromArchive", "boolean", 1), isLongNum(e)) r.from(e);else if (void 0 !== e) {
        var n = getEntries(e),
            o = Array.isArray(n),
            i = 0;

        for (n = o ? n : n[Symbol.iterator]();;) {
          var s;

          if (o) {
            if (i >= n.length) break;
            s = n[i++];
          } else {
            if ((i = n.next()).done) break;
            s = i.value;
          }

          var a = _slicedToArray$9(s, 2),
              u = a[0],
              l = a[1];

          r.set(u, l);
        }
      }
      return r;
    }

    return _inherits$b(t, Struct), _createClass$9(t, [{
      key: "isTextMessage",
      value: function value() {
        return this.assert("MessageType", ["PeerTextMessage", "ChannelTextMessage", "VendorTextMessage"]);
      }
    }, {
      key: "isRawMessage",
      value: function value() {
        return this.assert("MessageType", ["ChannelRawMessage", "PeerRawMessage", "VendorRawMessage"]);
      }
    }, {
      key: "isRawPeerMessage",
      value: function value() {
        return this.assert("MessageType", "PeerRawMessage");
      }
    }, {
      key: "isRawChannelMessage",
      value: function value() {
        return this.assert("MessageType", "ChannelRawMessage");
      }
    }, {
      key: "isPeerTextMessage",
      value: function value() {
        return this.assert("MessageType", "PeerTextMessage");
      }
    }, {
      key: "isChannelTextMessage",
      value: function value() {
        return this.assert("MessageType", "ChannelTextMessage");
      }
    }, {
      key: "isInvitation",
      value: function value(e) {
        var t = this;
        return void 0 !== e ? this.assert("MessageType", e) : getKeys(InvitationType).some(function (e) {
          return t.assert("MessageType", e);
        });
      }
    }, {
      key: "isFileMessage",
      value: function value() {
        return this.assert("MessageType", ["PeerFileMessage", "ChannelFileMessage", "VendorFileMessage"]);
      }
    }, {
      key: "isImageMessage",
      value: function value() {
        return this.assert("MessageType", ["PeerImageMessage", "ChannelImageMessage", "VendorImageMessage"]);
      }
    }, {
      key: "isPeerMessage",
      value: function value() {
        return this.assert("MessageType", ["PeerFileMessage", "PeerTextMessage", "PeerImageMessage", "PeerRawMessage"]);
      }
    }, {
      key: "isZlibCompressed",
      value: function value() {
        return this.assert("CompressionMethod", "Zlib");
      }
    }, {
      key: "isFromCache",
      value: function value() {
        return this.assert("FromCache", !0);
      }
    }, {
      key: "isBufferedMessage",
      value: function value() {
        return this.assert("BufferedMessage", !0);
      }
    }, {
      key: "isFromArchive",
      value: function value() {
        return this.assert("FromArchive", !0);
      }
    }, {
      key: "getInvitationType",
      value: function value() {
        if (!this.isInvitation()) throw new TypeError("cannot get InvitationType of a normal message type");
        return this.typeOf("MessageType");
      }
    }]), t;
  }();

  function _typeof$d(e) {
    return (_typeof$d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _classCallCheck$e(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties$a(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$a(e, t, r) {
    return t && _defineProperties$a(e.prototype, t), r && _defineProperties$a(e, r), e;
  }

  function _possibleConstructorReturn$c(e, t) {
    return !t || "object" !== _typeof$d(t) && "function" != typeof t ? _assertThisInitialized$c(e) : t;
  }

  function _assertThisInitialized$c(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _getPrototypeOf$c(e) {
    return (_getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _inherits$c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$c(e, t);
  }

  function _setPrototypeOf$c(e, t) {
    return (_setPrototypeOf$c = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var ChatManager = function (e) {
    function t(e) {
      var r;
      return _classCallCheck$e(this, t), (r = _possibleConstructorReturn$c(this, _getPrototypeOf$c(t).call(this, e, "ChatManager"))).dialogueLru = new TLRUCache(void 0, {
        maxlen: LRU_MAX_ITEMS,
        ttl: DIALOGUE_EXPIRE_TIMEOUT
      }), r;
    }

    return _inherits$c(t, createEventBase()), _createClass$a(t, [{
      key: "getChatInfo",
      value: function value(e) {
        var t = this.dialogueLru.get(e);

        if (this.dialogueLru.prune(), t) {
          var r = t.dialogue,
              n = t.sequence.add(1),
              o = {
            dialogue: r,
            sequence: n
          };
          return this.dialogueLru.set(e, {
            dialogue: r,
            sequence: n
          }), o;
        }

        var i = {
          dialogue: getRandomUInt64(),
          sequence: long_1.fromNumber(1, !0)
        };
        return this.dialogueLru.set(e, i), i;
      }
    }]), t;
  }();

  function _typeof$e(e) {
    return (_typeof$e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _slicedToArray$a(e, t) {
    return _arrayWithHoles$a(e) || _iterableToArrayLimit$a(e, t) || _nonIterableRest$a();
  }

  function _nonIterableRest$a() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit$a(e, t) {
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }

  function _arrayWithHoles$a(e) {
    if (Array.isArray(e)) return e;
  }

  function asyncGeneratorStep$a(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$a(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$a(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$a(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  function ownKeys$4(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function _objectSpread$3(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ownKeys$4(r, !0).forEach(function (t) {
        _defineProperty$5(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys$4(r).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function _defineProperty$5(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function _objectWithoutProperties$3(e, t) {
    if (null == e) return {};

    var r,
        n,
        o = _objectWithoutPropertiesLoose$3(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (n = 0; n < i.length; n++) {
        r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }
    }

    return o;
  }

  function _objectWithoutPropertiesLoose$3(e, t) {
    if (null == e) return {};
    var r,
        n,
        o = {},
        i = Object.keys(e);

    for (n = 0; n < i.length; n++) {
      r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
    }

    return o;
  }

  function _toConsumableArray$b(e) {
    return _arrayWithoutHoles$b(e) || _iterableToArray$b(e) || _nonIterableSpread$b();
  }

  function _nonIterableSpread$b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray$b(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _arrayWithoutHoles$b(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  function _classCallCheck$f(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _possibleConstructorReturn$d(e, t) {
    return !t || "object" !== _typeof$e(t) && "function" != typeof t ? _assertThisInitialized$d(e) : t;
  }

  function _assertThisInitialized$d(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _getPrototypeOf$d(e) {
    return (_getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _defineProperties$b(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$b(e, t, r) {
    return t && _defineProperties$b(e.prototype, t), r && _defineProperties$b(e, r), e;
  }

  function _inherits$d(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$d(e, t);
  }

  function _setPrototypeOf$d(e, t) {
    return (_setPrototypeOf$d = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var Session$2 = function (e) {
    function t(e, r, n, o) {
      var i;
      return _classCallCheck$f(this, t), (i = _possibleConstructorReturn$d(this, _getPrototypeOf$d(t).call(this, o, "Session"))).context = e, i.connection = r, i.instanceId = n, i.chatManager = new ChatManager(i.logger), i.joinedChannels = new Set(), i.msgDedupLru = new LRUCache(void 0, {
        maxlen: MSG_DEDUP_MAX_LEN
      }), i.startTime = Date.now(), i.seq = long_1.fromNumber(1, !0), i.userJoinOptions = new UserJoinOptions(!1), i.seqSentStatuses = [!1, !1], i.dialogueSequenceLru = new LRUCache(void 0, {
        maxlen: LRU_MAX_ITEMS
      }), i.messageSentTimes = [], i.curLoginSockets = [void 0, void 0], i.loginSocketSubs = [{
        channels: new Map(),
        receivers: []
      }, {
        channels: new Map(),
        receivers: []
      }], i.lastLoginSockets = [new ReplaySubject(1), new ReplaySubject(1)], i.dialPendingMsgSubjectMaps = [new Map(), new Map()], i.registerSocketsFailureListener = function () {
        i.connection.once("socketsFailure", function () {
          i.log("socketsFailure, creating a new connection"), defer$1(function () {
            return i.connection.removeAllListeners(), i.connection = new Connection(i.context, i.logger), i.loginHandler(6e3, !0);
          }).pipe(retryWhen(function (e) {
            return e.pipe(delay(1500));
          }), takeUntil(i.connection.apClient.apFinish$)).subscribe(function () {
            i.log("new connection connected");
          });
        }), 0 === i.connection.listenerCount("tokenExpired") && i.connection.on("tokenExpired", function () {
          i.emit("tokenExpired");
        });
      }, i.log("The instanceId is %s", i.instanceId.toString()), i;
    }

    return _inherits$d(t, createEventBase()), _createClass$b(t, null, [{
      key: "sendMessageAck",
      value: function value(e, t) {
        var r = new MessageOption(e.options);
        (r.isInvitation() || r.isPeerMessage()) && t.sendPacket("Ack", {
          code: 0,
          dialogue: e.dialogue,
          instance: e.instance,
          sequence: e.sequence
        });
      }
    }]), _createClass$b(t, [{
      key: "fetchFileUploadIndexGet",
      value: function value(e) {
        var r = e.hash,
            n = e.size,
            o = this.getLoginSockets();
        if (0 === o.length) throw new RtmInvalidStatusError("Client is not logged in");
        var i = this.incGetSeq();
        return o.forEach(function (e) {
          e.sendPacket("FileUploadIndexGet", {
            seq: i,
            hash: r,
            size: n
          });
        }), {
          ret: race.apply(void 0, _toConsumableArray$b(o.map(function (e) {
            return e.fromReceived("FileUploadIndexRet").pipe(first(function (e) {
              var t = e.seq;
              return i.eq(t);
            }));
          }))),
          fin: race.apply(void 0, _toConsumableArray$b(o.map(function (e) {
            return e.fromReceived("FileUploadIndexFin").pipe(first(function (e) {
              var t = e.seq;
              return i.eq(t);
            }));
          }))),
          err: merge.apply(void 0, _toConsumableArray$b(o.map(function (e) {
            return e.fromReceived("FileUploadIndexErr").pipe(first(function (e) {
              var t = e.seq;
              return i.eq(t);
            }), map$1(function (e) {
              var t = e.code;
              throw new RtmUnavailableError(["The media message upload failure, code %d", t], UPLOAD_MEDIA_ERR_FAILURE);
            }));
          }))),
          timeout: t.genTimeoutError(UPLOAD_MEDIA_ERR_TIMEOUT)
        };
      }
    }, {
      key: "requestFileUploadIndexSet",
      value: function value(e) {
        var r = e.hash,
            n = e.unit,
            o = e.servers,
            i = this.getLoginSockets();
        if (0 === i.length) throw new RtmInvalidStatusError("Client is not logged in");
        var s = this.incGetSeq();
        return i.forEach(function (e) {
          e.sendPacket("FileUploadIndexSet", {
            seq: s,
            servers: o,
            hash: r,
            unit: n
          });
        }), race.apply(void 0, [t.genTimeoutError(UPLOAD_MEDIA_ERR_TIMEOUT)].concat(_toConsumableArray$b(i.map(function (e) {
          return e.fromReceived("FileUploadIndexErr").pipe(first(function (e) {
            var t = e.seq;
            return s.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            throw new RtmUnavailableError(["FileUploadIndexSet failure, code %d", t], UPLOAD_MEDIA_ERR_FAILURE);
          }));
        })), _toConsumableArray$b(i.map(function (e) {
          return e.fromReceived("FileUploadIndexFin").pipe(first(function (e) {
            var t = e.seq;
            return s.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestFileDownloadIndexGet",
      value: function value(e) {
        var r = e.size,
            n = e.zone,
            o = e.unit,
            i = e.hash,
            s = this.getLoginSockets();
        if (0 === s.length) throw new RtmInvalidStatusError("Client is not logged in");
        var a = this.incGetSeq();
        s.forEach(function (e) {
          e.sendPacket("FileDownloadIndexGet", {
            seq: a,
            size: r,
            zone: n,
            unit: o,
            hash: i
          });
        });
        var u = race.apply(void 0, _toConsumableArray$b(s.map(function (e) {
          return e.fromReceived("FileDownloadIndexRet").pipe(first(function (e) {
            var t = e.seq;
            return a.eq(t);
          }));
        }))).pipe(map$1(function (e) {
          var t = e.backups,
              r = e.servers,
              n = _objectWithoutProperties$3(e, ["backups", "servers"]);

          return _objectSpread$3({
            backupList: t.map(function (e) {
              return [e];
            }),
            serverList: r.map(function (e) {
              return [e];
            })
          }, n);
        }), delay(500));
        return race(u, forkJoin(s.map(function (e) {
          return e.fromReceived("FileDownloadIndexRet").pipe(first(function (e) {
            var t = e.seq;
            return a.eq(t);
          }));
        })).pipe(map$1(function (e) {
          return e.reduce(function (e, t) {
            var r = e.backupList,
                n = e.serverList,
                o = t.backups,
                i = t.servers,
                s = _objectWithoutProperties$3(t, ["backups", "servers"]);

            return _objectSpread$3({
              backupList: o.map(function (e, t) {
                return [e].concat(_toConsumableArray$b(void 0 !== r && Array.isArray(r[t]) ? r[t] : []));
              }),
              serverList: i.map(function (e, t) {
                return [e].concat(_toConsumableArray$b(void 0 !== r && Array.isArray(n[t]) ? n[t] : []));
              })
            }, s);
          }, {});
        })), t.genTimeoutError(UPLOAD_MEDIA_ERR_TIMEOUT));
      }
    }, {
      key: "loginHandler",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : CLIENT_LOGIN_TIMEOUT,
            r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        r && this.registerSocketsFailureListener(), this.connection.initConnection();
        var n = this.seq,
            o = this.getSocketLoginObservables(this.connection.lastOpenSockets, n),
            i = Date.now();
        return o.forEach(function (t, n) {
          var o = e.loginSocketSubs[n].login;
          void 0 !== o && o.unsubscribe(), e.loginSocketSubs[n].login = t.pipe(tap(function (t) {
            var o, s;
            e.curLoginSockets[n] = t;
            var a = Date.now();
            sendReport("Link", {
              ackedServerIp: t.address,
              destServerIp: t.ip,
              ec: 0,
              sc: 0,
              elapse: getElapse(e.startTime),
              lts: long_1.fromNumber(a),
              responseTime: i - a,
              sid: getSid(e.instanceId),
              userId: e.context.uid
            }, null === (o = e.context.areaConfig) || void 0 === o ? void 0 : o.EVENT_REPORT_DOMAIN[0], null === (s = e.context.areaConfig) || void 0 === s ? void 0 : s.EVENT_REPORT_BACKUP_DOMAIN[0]), e.emit("userJoined", t.env), r && e.connection.apClient.apFinish$.next(void 0);
          })).subscribe(e.lastLoginSockets[n]);
        }), this.initKeepAliveSender(), this.initKeepAliveReconnector(), this.initLoginReceiver(), merge.apply(void 0, _toConsumableArray$b(o).concat([fromEvent(this.connection, "connectionInitFailure").pipe(tap(function (e) {
          if (isRtmError(e) || isTimeout(e)) throw e;
          throw new RtmUnavailableError("Login failure", {
            code: LOGIN_ERR_UNKNOWN,
            originalError: e
          });
        }))])).pipe(take(1), timeout(t), catchError(function (t) {
          return t instanceof TimeoutError && e.warn("Client login timeout"), t && t.code === LOGIN_ERR_TOKEN_EXPIRED && (e.connection.emit("tokenExpired"), e.connection.apClient.apFinish$.next(void 0)), e.clearSockets(0, r), throwError(t);
        }), tap(function () {
          r || e.registerSocketsFailureListener();
        }), finalize(function () {
          r || e.connection.apClient.apFinish$.next(void 0);
        }));
      }
    }, {
      key: "logoutHandler",
      value: function () {
        var e = _asyncToGenerator$a(regenerator.mark(function e() {
          var t,
              r,
              n,
              o = this;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return t = this.getLoginSockets(), r = t.map(function (e) {
                    return e.sendPacket("UserQuit", {}), o.connection.waitClosing(e);
                  }), this.clearSockets(LOGOUT_SOCKET_CLOSE_TIMEOUT), n = t.map(function (e) {
                    return e.env;
                  }), [0, 1].filter(function (e) {
                    return !n.includes(e);
                  }).forEach(function (e) {
                    o.connection.closeSocket(e, 0);
                  }), e.abrupt("return", merge.apply(void 0, _toConsumableArray$b(r)).toPromise());

                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function () {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "requestChannelJoin",
      value: function () {
        var e = _asyncToGenerator$a(regenerator.mark(function e(t, r) {
          var n,
              o,
              i,
              s = this;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (0 !== this.getLoginSockets().length) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidStatusError("Client is not logged in. Cannot join the channel", JOIN_CHANNEL_ERR_USER_NOT_LOGGED_IN);

                case 2:
                  return n = fromEvent(this, "channelLeft").pipe(filter(function (e) {
                    return e === t;
                  }), take(1)), o = this.incGetSeq(), (i = this.lastLoginSockets.map(function (e) {
                    return e.pipe(switchMap(function (e, t) {
                      0 !== t && s.incSeqIfNeeded(e.env);
                      var n = 0 === t ? o : s.seq;
                      return e.sendPacket("GroupEnter", {
                        account: r,
                        seq: n
                      }), e.fromReceived("GroupReply").pipe(first(function (e) {
                        var t = e.seq;
                        return n.eq(t);
                      }), tap(function (e) {
                        var t = e.code;
                        if (0 !== t) throw new RtmUnavailableError(["Channel join failure. The response code is %d", t], JOIN_CHANNEL_ERR_FAILURE);
                      }));
                    }), takeUntil(n), share());
                  })).forEach(function (e, r) {
                    var n = function n() {
                      return s.loginSocketSubs[r].channels.delete(t.channelId);
                    };

                    s.loginSocketSubs[r].channels.set(t.channelId, e.subscribe({
                      error: n,
                      complete: n
                    }));
                  }), e.next = 8, merge.apply(void 0, _toConsumableArray$b(i)).pipe(take(1), timeout(COMMON_REQUEST_TIMEOUT), catchError(function (e) {
                    return e instanceof TimeoutError && s.warn("Channel join timeout"), throwError(e);
                  })).toPromise();

                case 8:
                  this.joinedChannels.add(t);

                case 9:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t, r) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "requestChannelLeave",
      value: function value(e, t) {
        this.joinedChannels.delete(e), this.getLoginSockets().forEach(function (e) {
          e.sendPacket("GroupLeave", {
            account: t
          });
        });
      }
    }, {
      key: "requestChannelMemberList",
      value: function value(e) {
        var r = this.getLoginSockets();
        if (0 === r.length) throw new RtmInvalidStatusError("Client is not logged in. Cannot get the channel members", GET_MEMBERS_ERR_REJECTED);
        var n = this.incGetSeq();
        return r.forEach(function (t) {
          t.sendPacket("GroupAllUsersList", {
            group: e,
            pageNumber: 0,
            pageSize: 200,
            seq: n
          });
        }), race.apply(void 0, [t.genTimeoutError(GET_CHANNEL_MEMBER_COUNT_ERR_TIMEOUT)].concat(_toConsumableArray$b(r.map(function (t) {
          return t.fromReceived("GroupAllUsersResult").pipe(first(function (t) {
            var r = t.group,
                o = t.seq;
            return r === e && n.eq(o);
          }));
        }))));
      }
    }, {
      key: "requestPeersOnlineStatus",
      value: function value(e) {
        var r = this.getLoginSockets();
        if (0 === r.length) throw new RtmInvalidStatusError("Client is not logged in");
        var n = this.incGetSeq();
        return r.forEach(function (t) {
          t.sendPacket("UserStatusList", {
            users: e,
            seq: n
          });
        }), race.apply(void 0, [t.genTimeoutError(QUERY_PEERS_ONLINE_STATUS_ERR_TIMEOUT)].concat(_toConsumableArray$b(r.map(function (e) {
          return e.fromReceived("UserStatusResult").pipe(first(function (e) {
            var t = e.seq;
            return n.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestSetLocalUserAttributes",
      value: function value(e, r) {
        var n = this,
            o = this.getLoginSockets();
        if (0 === o.length) throw new RtmInvalidStatusError("Client is not logged in");
        var i = this.incGetSeq();
        return o.forEach(function (t, o) {
          void 0 !== r && o !== r || t.sendPacket("UserAttributeSet", {
            account: n.context.uid,
            attributeInfos: Object.entries(e).map(function (e) {
              var t = _slicedToArray$a(e, 2);

              return {
                key: t[0],
                value: t[1]
              };
            }),
            seq: i
          });
        }), race.apply(void 0, _toConsumableArray$b(o.map(function (e) {
          return e.fromReceived("UserAttributeErr").pipe(first(function (e) {
            var t = e.seq;
            return i.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            throw new RtmUnavailableError(["The user attributes set failure, code %d", t], ATTRIBUTE_OPERATION_ERR_FAILURE);
          }));
        })).concat([t.genTimeoutError(ATTRIBUTE_OPERATION_ERR_TIMEOUT)], _toConsumableArray$b(o.map(function (e) {
          return e.fromReceived("UserAttributeRsp").pipe(first(function (e) {
            var t = e.seq;
            return i.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestSetChannelAttributes",
      value: function value(e, r, n) {
        var o = this.getLoginSockets();
        if (0 === o.length) throw new RtmInvalidStatusError("Client is not logged in");
        var i = this.incGetSeq();
        return o.forEach(function (t) {
          t.sendPacket("GroupAttributeSet", {
            broadcast: n,
            group: e,
            attributeInfos: Object.entries(r).map(function (e) {
              var t = _slicedToArray$a(e, 2);

              return {
                key: t[0],
                value: t[1]
              };
            }),
            seq: i
          });
        }), race.apply(void 0, _toConsumableArray$b(o.map(function (e) {
          return e.fromReceived("GroupAttributeErr").pipe(first(function (e) {
            var t = e.seq;
            return i.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            throw new RtmUnavailableError(["The group attributes set failure, code %d", t], ATTRIBUTE_OPERATION_ERR_FAILURE);
          }));
        })).concat([t.genTimeoutError(ATTRIBUTE_OPERATION_ERR_TIMEOUT)], _toConsumableArray$b(o.map(function (e) {
          return e.fromReceived("GroupAttributeRsp").pipe(first(function (e) {
            var t = e.seq;
            return i.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestAddOrUpdateLocalUserAttributes",
      value: function value(e) {
        var r = this,
            n = this.getLoginSockets();
        if (0 === n.length) throw new RtmInvalidStatusError("Client is not logged in");
        var o = this.incGetSeq();
        return n.forEach(function (t) {
          t.sendPacket("UserAttributeMod", {
            account: r.context.uid,
            attributeInfos: Object.entries(e).map(function (e) {
              var t = _slicedToArray$a(e, 2);

              return {
                key: t[0],
                value: t[1]
              };
            }),
            seq: o
          });
        }), race.apply(void 0, _toConsumableArray$b(n.map(function (e) {
          return e.fromReceived("UserAttributeErr").pipe(first(function (e) {
            var t = e.seq;
            return o.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            throw new RtmUnavailableError(["The user attributes add or update failure, code %d", t], ATTRIBUTE_OPERATION_ERR_FAILURE);
          }));
        })).concat([t.genTimeoutError(ATTRIBUTE_OPERATION_ERR_TIMEOUT)], _toConsumableArray$b(n.map(function (e) {
          return e.fromReceived("UserAttributeRsp").pipe(first(function (e) {
            var t = e.seq;
            return o.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestAddOrUpdateChannelAttributes",
      value: function value(e, r, n) {
        var o = this.getLoginSockets();
        if (0 === o.length) throw new RtmInvalidStatusError("Client is not logged in");
        var i = this.incGetSeq();
        return o.forEach(function (t) {
          t.sendPacket("GroupAttributeMod", {
            broadcast: n,
            group: e,
            attributeInfos: Object.entries(r).map(function (e) {
              var t = _slicedToArray$a(e, 2);

              return {
                key: t[0],
                value: t[1]
              };
            }),
            seq: i
          });
        }), race.apply(void 0, _toConsumableArray$b(o.map(function (e) {
          return e.fromReceived("GroupAttributeErr").pipe(first(function (e) {
            var t = e.seq;
            return i.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            throw new RtmUnavailableError(["The group attributes add or update failure, code %d", t], ATTRIBUTE_OPERATION_ERR_FAILURE);
          }));
        })).concat([t.genTimeoutError(ATTRIBUTE_OPERATION_ERR_TIMEOUT)], _toConsumableArray$b(o.map(function (e) {
          return e.fromReceived("GroupAttributeRsp").pipe(first(function (e) {
            var t = e.seq;
            return i.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestDeleteLocalUserAttributesByKeys",
      value: function value(e) {
        var r = this,
            n = this.getLoginSockets();
        if (0 === n.length) throw new RtmInvalidStatusError("Client is not logged in");
        var o = this.incGetSeq();
        return n.forEach(function (t) {
          t.sendPacket("UserAttributeDel", {
            account: r.context.uid,
            attributes: e,
            seq: o
          });
        }), race.apply(void 0, _toConsumableArray$b(n.map(function (e) {
          return e.fromReceived("UserAttributeErr").pipe(first(function (e) {
            var t = e.seq;
            return o.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            throw new RtmUnavailableError(["The user attributes delete failure, code %d", t], ATTRIBUTE_OPERATION_ERR_FAILURE);
          }));
        })).concat([t.genTimeoutError(ATTRIBUTE_OPERATION_ERR_TIMEOUT)], _toConsumableArray$b(n.map(function (e) {
          return e.fromReceived("UserAttributeRsp").pipe(first(function (e) {
            var t = e.seq;
            return o.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestDeleteChannelAttributesByKeys",
      value: function value(e, r, n) {
        var o = this.getLoginSockets();
        if (0 === o.length) throw new RtmInvalidStatusError("Client is not logged in");
        var i = this.incGetSeq();
        return o.forEach(function (t) {
          t.sendPacket("GroupAttributeDel", {
            group: e,
            broadcast: n,
            attributes: r,
            seq: i
          });
        }), race.apply(void 0, _toConsumableArray$b(o.map(function (e) {
          return e.fromReceived("GroupAttributeErr").pipe(first(function (e) {
            var t = e.seq;
            return i.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            throw new RtmUnavailableError(["The channel attributes delete failure, code %d", t], ATTRIBUTE_OPERATION_ERR_FAILURE);
          }));
        })).concat([t.genTimeoutError(ATTRIBUTE_OPERATION_ERR_TIMEOUT)], _toConsumableArray$b(o.map(function (e) {
          return e.fromReceived("GroupAttributeRsp").pipe(first(function (e) {
            var t = e.seq;
            return i.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestClearLocalUserAttributes",
      value: function value() {
        var e = this,
            r = this.getLoginSockets();
        if (0 === r.length) throw new RtmInvalidStatusError("Client is not logged in");
        var n = this.incGetSeq();
        return r.forEach(function (t) {
          t.sendPacket("UserAttributeSet", {
            account: e.context.uid,
            seq: n,
            attributeInfos: []
          });
        }), race.apply(void 0, _toConsumableArray$b(r.map(function (e) {
          return e.fromReceived("UserAttributeErr").pipe(first(function (e) {
            var t = e.seq;
            return n.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            throw new RtmUnavailableError(["The user attributes clear failure, code %d", t], ATTRIBUTE_OPERATION_ERR_FAILURE);
          }));
        })).concat([t.genTimeoutError(ATTRIBUTE_OPERATION_ERR_TIMEOUT)], _toConsumableArray$b(r.map(function (e) {
          return e.fromReceived("UserAttributeRsp").pipe(first(function (e) {
            var t = e.seq;
            return n.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestClearChannelAttributes",
      value: function value(e, r) {
        var n = this.getLoginSockets();
        if (0 === n.length) throw new RtmInvalidStatusError("Client is not logged in");
        var o = this.incGetSeq();
        return n.forEach(function (t) {
          t.sendPacket("GroupAttributeSet", {
            group: e,
            seq: o,
            attributeInfos: [],
            broadcast: r
          });
        }), race.apply(void 0, _toConsumableArray$b(n.map(function (e) {
          return e.fromReceived("GroupAttributeErr").pipe(first(function (e) {
            var t = e.seq;
            return o.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            throw new RtmUnavailableError(["The channel attributes clear failure, code %d", t], ATTRIBUTE_OPERATION_ERR_FAILURE);
          }));
        })).concat([t.genTimeoutError(ATTRIBUTE_OPERATION_ERR_TIMEOUT)], _toConsumableArray$b(n.map(function (e) {
          return e.fromReceived("GroupAttributeRsp").pipe(first(function (e) {
            var t = e.seq;
            return o.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestGetUserAttributesByKeys",
      value: function value(e, r) {
        var n = this.getLoginSockets();
        if (0 === n.length) throw new RtmInvalidStatusError("Client is not logged in");
        var o = this.incGetSeq();
        return n.forEach(function (t) {
          t.sendPacket("UserAttributeGet", {
            account: e,
            seq: o,
            attributes: r
          });
        }), race.apply(void 0, [t.genTimeoutError(ATTRIBUTE_OPERATION_ERR_TIMEOUT)].concat(_toConsumableArray$b(n.map(function (e) {
          return e.fromReceived("UserAttributeErr").pipe(first(function (e) {
            var t = e.seq;
            return o.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            if (10008 === t) throw new RtmUnavailableError("The user requested is not online", ATTRIBUTE_OPERATION_ERR_USER_NOT_FOUND);
            throw new RtmUnknownError(["User attribute operation unknown error code: %d", t], ATTRIBUTE_OPERATION_ERR_FAILURE);
          }));
        })), _toConsumableArray$b(n.map(function (e) {
          return e.fromReceived("UserAttributeRet").pipe(first(function (e) {
            var t = e.seq;
            return o.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestGetChannelAttributesByKeys",
      value: function value(e, r) {
        var n = this.getLoginSockets();
        if (0 === n.length) throw new RtmInvalidStatusError("Client is not logged in");
        var o = this.incGetSeq();
        return n.forEach(function (t) {
          t.sendPacket("GroupAttributeGet", {
            group: e,
            seq: o,
            attributes: r
          });
        }), race.apply(void 0, [t.genTimeoutError(ATTRIBUTE_OPERATION_ERR_TIMEOUT)].concat(_toConsumableArray$b(n.map(function (e) {
          return e.fromReceived("GroupAttributeErr").pipe(first(function (e) {
            var t = e.seq;
            return o.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            throw new RtmUnavailableError(["The channel attributes get failure, code %d", t], ATTRIBUTE_OPERATION_ERR_FAILURE);
          }));
        })), _toConsumableArray$b(n.map(function (e) {
          return e.fromReceived("GroupAttributeRet").pipe(first(function (e) {
            var t = e.seq;
            return o.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestGetUserAttributeKeys",
      value: function value(e) {
        var r = this.getLoginSockets();
        if (0 === r.length) throw new RtmInvalidStatusError("Client is not logged in");
        var n = this.incGetSeq();
        return r.forEach(function (t) {
          t.sendPacket("UserAttributeKeysGet", {
            account: e,
            seq: n
          });
        }), race.apply(void 0, [t.genTimeoutError(ATTRIBUTE_OPERATION_ERR_TIMEOUT)].concat(_toConsumableArray$b(r.map(function (e) {
          return e.fromReceived("UserAttributeErr").pipe(first(function (e) {
            var t = e.seq;
            return n.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            if (10008 === t) throw new RtmUnavailableError("The user requested is not online", ATTRIBUTE_OPERATION_ERR_USER_NOT_FOUND);
            throw new RtmUnknownError(["User attribute operation unknown error code: %d", t], ATTRIBUTE_OPERATION_ERR_FAILURE);
          }));
        })), _toConsumableArray$b(r.map(function (e) {
          return e.fromReceived("UserAttributeKeysRet").pipe(first(function (e) {
            var t = e.seq;
            return n.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestGetChannelAttributesKeys",
      value: function value(e) {
        var r = this.getLoginSockets();
        if (0 === r.length) throw new RtmInvalidStatusError("Client is not logged in");
        var n = this.incGetSeq();
        return r.forEach(function (t) {
          t.sendPacket("GroupAttributeKeysGet", {
            group: e,
            seq: n
          });
        }), race.apply(void 0, [t.genTimeoutError(ATTRIBUTE_OPERATION_ERR_TIMEOUT)].concat(_toConsumableArray$b(r.map(function (e) {
          return e.fromReceived("GroupAttributeErr").pipe(first(function (e) {
            var t = e.seq;
            return n.eq(t);
          }), map$1(function (e) {
            var t = e.code;
            throw new RtmUnknownError(["Channel attribute operation unknown error code: %d", t], ATTRIBUTE_OPERATION_ERR_FAILURE);
          }));
        })), _toConsumableArray$b(r.map(function (e) {
          return e.fromReceived("GroupAttributeKeysRet").pipe(first(function (e) {
            var t = e.seq;
            return n.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestGetChannelMemberCount",
      value: function value(e) {
        var r = this.getLoginSockets();
        if (0 === r.length) throw new RtmInvalidStatusError("Client is not logged in");
        var n = this.incGetSeq();
        return r.forEach(function (t) {
          t.sendPacket("GroupStatusList", {
            groups: e,
            seq: n
          });
        }), race.apply(void 0, [t.genTimeoutError(GET_CHANNEL_MEMBER_COUNT_ERR_TIMEOUT)].concat(_toConsumableArray$b(r.map(function (e) {
          return e.fromReceived("GroupStatusResult").pipe(first(function (e) {
            var t = e.seq;
            return n.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestSubscribePeersOnlineStatus",
      value: function value(e) {
        var r = this.getLoginSockets();
        if (0 === r.length) throw new RtmInvalidStatusError("Client is not logged in");
        var n = this.incGetSeq();
        return r.forEach(function (t) {
          t.sendPacket("SubscribeUserStatus", {
            seq: n,
            users: e
          });
        }), race.apply(void 0, [t.genTimeoutError(PEER_SUBSCRIPTION_STATUS_ERR_TIMEOUT)].concat(_toConsumableArray$b(r.map(function (e) {
          return e.fromReceived("SubscribeResponse").pipe(first(function (e) {
            var t = e.seq;
            return n.eq(t);
          }));
        }))));
      }
    }, {
      key: "requestUnsubscribePeersOnlineStatus",
      value: function value(e) {
        var t = this.getLoginSockets();
        if (0 === t.length) throw new RtmInvalidStatusError("Client is not logged in");
        var r = this.incGetSeq();
        t.forEach(function (t) {
          t.sendPacket("UnsubscribeUserStatus", {
            seq: r,
            users: e
          });
        });
      }
    }, {
      key: "sendInvitationMessage",
      value: function () {
        var e = _asyncToGenerator$a(regenerator.mark(function e(t) {
          var r,
              n,
              o,
              i,
              s,
              a,
              u,
              l,
              c,
              p,
              f,
              d,
              g = this;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (r = t.peerId, n = t.callId, o = t.extra, i = t.isAcceptAck, s = t.channelId, a = t.type, u = {
                    callId: n
                  }, void 0 === i) {
                    e.next = 6;
                    break;
                  }

                  if ("CallAccept" === a) {
                    e.next = 5;
                    break;
                  }

                  throw new Error("invalid invitation type");

                case 5:
                  u.type = i ? "ack" : "request";

                case 6:
                  return u.channel = s, ("CallInvite" === a || "CallCancel" === a || "CallReject" === a || "CallAccept" === a && !1 === i) && void 0 !== o && (u.extra = o), l = getRandomUInt64(), this.log("The sent invitation body is %o", u), c = function c(e) {
                    return {
                      MiscMap: {},
                      sequence: long_1.fromNumber(1),
                      dialogue: l,
                      instance: g.instanceId,
                      dst: r,
                      ms: long_1.fromNumber(Date.now(), !0),
                      options: new MessageOption({
                        IterationNumber: e,
                        MessageType: a
                      }).toLong(),
                      payload: new TextEncoder().encode(JSON.stringify(u)),
                      src: g.context.uid
                    };
                  }, e.next = 14, from(this.sendMessageToRetry(c, !0)).pipe(timeout(MESSAGE_SEND_TIMEOUT), catchError(function (e) {
                    return e instanceof TimeoutError && g.warn("Send invitation timeout"), throwError(e);
                  })).toPromise();

                case 14:
                  return p = e.sent, f = p.code, d = p.retryTimes, e.abrupt("return", {
                    hasPeerReceived: 0 === f,
                    hasReSent: 0 !== d
                  });

                case 18:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "sendMediaMessage",
      value: function () {
        var e = _asyncToGenerator$a(regenerator.mark(function e(t, r, n, o, i, s) {
          var a,
              u,
              l,
              c,
              p,
              f,
              d,
              g,
              h,
              b,
              y,
              _,
              m,
              v,
              E,
              O,
              I,
              $,
              S,
              w,
              R,
              A,
              T,
              N,
              L,
              P,
              C,
              k,
              x,
              M = this;

          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (u = r.width, l = void 0 === u ? 0 : u, c = r.height, p = void 0 === c ? 0 : c, f = r.fileName, d = void 0 === f ? "" : f, g = r.description, h = void 0 === g ? "" : g, b = r.thumbnail, y = void 0 === b ? new Blob() : b, _ = r.thumbnailHeight, m = void 0 === _ ? 0 : _, v = r.thumbnailWidth, E = void 0 === v ? 0 : v, O = r.size, I = void 0 === O ? 0 : O, $ = r.mediaId, S = i.enableOfflineMessaging, w = i.enableHistoricalMessaging, isValidId(n)) {
                    e.next = 4;
                    break;
                  }

                  throw new RtmInvalidArgumentError("The send message arguments are not valid", o ? PEER_MESSAGE_ERR_INVALID_USERID : CHANNEL_MESSAGE_ERR_FAILURE);

                case 4:
                  if (!(new Blob([d, y, h]).size > MEDIA_MESSAGE_MAX_CONTENT_BYTES)) {
                    e.next = 6;
                    break;
                  }

                  throw new RtmInvalidArgumentError("The size of message overflowed ", o ? PEER_MESSAGE_ERR_INVALID_MESSAGE : CHANNEL_MESSAGE_ERR_INVALID_MESSAGE);

                case 6:
                  return R = this.chatManager.getChatInfo(n), A = R.dialogue, T = R.sequence, N = this.instanceId, this.log('A%s media message is sending to %s: "'.concat(N, "-").concat(A, "#").concat(T, '"'), o ? " peer" : " channel", n), _defineProperty$5(a = {}, MESSAGE_MEDIA_DESCRIPTION_KEY, h), _defineProperty$5(a, MESSAGE_MEDIA_WIDTH_KEY, l), _defineProperty$5(a, MESSAGE_MEDIA_HEIGHT_KEY, p), _defineProperty$5(a, MESSAGE_MEDIA_THUMBNAILWIDTH_KEY, E), _defineProperty$5(a, MESSAGE_MEDIA_THUMBNAILHEIGHT_KEY, m), _defineProperty$5(a, MESSAGE_MEDIA_SIZE_KEY, I), _defineProperty$5(a, MESSAGE_MEDIA_ID_KEY, $), _defineProperty$5(a, MESSAGE_MEDIA_FILENAME_KEY, d), L = mapValues_1(a, function (e) {
                    return new TextEncoder().encode(e.toString());
                  }), e.t0 = Uint8Array, e.next = 14, blobToArrayBuffer(y);

                case 14:
                  return e.t1 = e.sent, L[MESSAGE_MEDIA_THUMBNAIL_KEY] = new e.t0(e.t1), P = o && "IMAGE" === t ? "PeerImageMessage" : o && "FILE" === t ? "PeerFileMessage" : o || "IMAGE" !== t ? "ChannelFileMessage" : "ChannelImageMessage", C = function C(e) {
                    return {
                      MiscMap: L,
                      sequence: T,
                      dialogue: A,
                      instance: N,
                      dst: n,
                      ms: long_1.fromNumber(Date.now(), !0),
                      options: new MessageOption({
                        IterationNumber: e,
                        CompressionMethod: "Uncompressed",
                        MessageType: P,
                        ToCache: S,
                        ToArchive: w
                      }).toLong(),
                      payload: new Uint8Array(),
                      src: M.context.uid
                    };
                  }, e.next = 20, from(this.sendMessageToRetry(C, !0)).pipe(timeout(void 0 === s ? MESSAGE_SEND_TIMEOUT : s), catchError(function (e) {
                    return e instanceof TimeoutError && M.warn("Send message timeout"), throwError(e);
                  })).toPromise();

                case 20:
                  if (k = e.sent, 2 !== (x = k.code)) {
                    e.next = 24;
                    break;
                  }

                  throw new RtmUnavailableError("The peer does not support this type of message", PEER_MESSAGE_ERR_INCOMPATIBLE_MESSAGE);

                case 24:
                  return e.abrupt("return", {
                    hasPeerReceived: 0 === x
                  });

                case 25:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t, r, n, o, i, s) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "sendRawMessage",
      value: function () {
        var e = _asyncToGenerator$a(regenerator.mark(function e(t, r, n, o, i, s) {
          var a,
              u,
              l,
              c,
              p,
              f,
              d,
              g,
              h,
              b,
              y = this;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (a = i.enableOfflineMessaging, u = i.enableHistoricalMessaging, isValidId(n) && t instanceof Uint8Array && "string" == typeof r) {
                    e.next = 3;
                    break;
                  }

                  throw new RtmInvalidArgumentError("The send message arguments are not valid", o ? PEER_MESSAGE_ERR_INVALID_USERID : CHANNEL_MESSAGE_ERR_FAILURE);

                case 3:
                  if (!(t.byteLength + new Blob([r]).size > TEXT_MESSAGE_MAX_TEXT_BYTES)) {
                    e.next = 5;
                    break;
                  }

                  throw new RtmLimitExceededError("The message size is over the 32KB limit", o ? PEER_MESSAGE_ERR_INVALID_MESSAGE : CHANNEL_MESSAGE_ERR_INVALID_MESSAGE);

                case 5:
                  return l = t.byteLength >= MESSAGE_MIN_COMPRESSION_LEN, c = this.chatManager.getChatInfo(n), p = c.dialogue, f = c.sequence, d = this.instanceId, this.log('A%s %s raw message is sending to %s: "'.concat(d, "-").concat(p, "#").concat(f, '"'), l ? " compressed" : "", o ? "peer" : "channel", n), g = function g(e) {
                    return {
                      MiscMap: {
                        description: new TextEncoder().encode(r)
                      },
                      sequence: f,
                      dialogue: p,
                      instance: d,
                      dst: n,
                      ms: long_1.fromNumber(Date.now(), !0),
                      options: new MessageOption({
                        IterationNumber: e,
                        CompressionMethod: l ? "Zlib" : "Uncompressed",
                        MessageType: o ? "PeerRawMessage" : "ChannelRawMessage",
                        ToCache: a,
                        ToArchive: u
                      }).toLong(),
                      payload: l ? UZIP_2(t) : t,
                      src: y.context.uid
                    };
                  }, e.next = 12, from(this.sendMessageToRetry(g, !0)).pipe(timeout(void 0 === s ? MESSAGE_SEND_TIMEOUT : s), catchError(function (e) {
                    return e instanceof TimeoutError && y.warn("Send message timeout"), throwError(e);
                  })).toPromise();

                case 12:
                  return h = e.sent, b = h.code, e.abrupt("return", {
                    hasPeerReceived: 0 === b
                  });

                case 15:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t, r, n, o, i, s) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "sendTextMessage",
      value: function () {
        var e = _asyncToGenerator$a(regenerator.mark(function e(t, r, n, o, i) {
          var s,
              a,
              u,
              l,
              c,
              p,
              f,
              d,
              g,
              h,
              b = this;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (s = o.enableOfflineMessaging, a = o.enableHistoricalMessaging, isValidId(r)) {
                    e.next = 3;
                    break;
                  }

                  throw new RtmInvalidArgumentError("The send message arguments are not valid", n ? PEER_MESSAGE_ERR_INVALID_USERID : CHANNEL_MESSAGE_ERR_FAILURE);

                case 3:
                  if (!(new Blob([t]).size > TEXT_MESSAGE_MAX_TEXT_BYTES)) {
                    e.next = 5;
                    break;
                  }

                  throw new RtmLimitExceededError("The message size is over the 32KB limit", n ? PEER_MESSAGE_ERR_INVALID_MESSAGE : CHANNEL_MESSAGE_ERR_INVALID_MESSAGE);

                case 5:
                  return u = new Blob([t]).size >= MESSAGE_MIN_COMPRESSION_LEN, l = this.chatManager.getChatInfo(r), c = l.dialogue, p = l.sequence, f = this.instanceId, this.log('A%s %s message is sending to %s: "'.concat(f, "-").concat(c, "#").concat(p, '"'), u ? " compressed" : "", n ? "peer" : "channel", r), d = function d(e) {
                    return {
                      MiscMap: {},
                      sequence: p,
                      dialogue: c,
                      instance: f,
                      dst: r,
                      ms: long_1.fromNumber(Date.now(), !0),
                      options: new MessageOption({
                        IterationNumber: e,
                        CompressionMethod: u ? "Zlib" : "Uncompressed",
                        MessageType: n ? "PeerTextMessage" : "ChannelTextMessage",
                        ToCache: s,
                        ToArchive: a
                      }).toLong(),
                      payload: u ? UZIP_2(new TextEncoder().encode(t)) : new TextEncoder().encode(t),
                      src: b.context.uid
                    };
                  }, e.next = 12, from(this.sendMessageToRetry(d, !0)).pipe(timeout(void 0 === i ? COMMON_REQUEST_TIMEOUT : i), catchError(function (e) {
                    return e instanceof TimeoutError && b.warn("Send message timeout"), throwError(e);
                  })).toPromise();

                case 12:
                  return g = e.sent, h = g.code, e.abrupt("return", {
                    hasPeerReceived: 0 === h
                  });

                case 15:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t, r, n, o, i) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "cleanLoginSubs",
      value: function value(e, t) {
        Object.entries(this.loginSocketSubs[e]).forEach(function (e) {
          var r = _slicedToArray$a(e, 2),
              n = r[0],
              o = r[1];

          "channels" === n && t || (Array.isArray(o) || o instanceof Map ? o.forEach(function (e) {
            return e.unsubscribe();
          }) : o && o.unsubscribe());
        }), this.loginSocketSubs[e] = {
          channels: t ? this.loginSocketSubs[e].channels : new Map(),
          receivers: []
        };
      }
    }, {
      key: "sendMessageToRetry",
      value: function () {
        var e = _asyncToGenerator$a(regenerator.mark(function e(t, r) {
          var n,
              o,
              i,
              s,
              a,
              u,
              l,
              c,
              p,
              f = this,
              d = arguments;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = d.length > 2 && void 0 !== d[2] ? d[2] : 0, this.log("Attempt to send the message ".concat(r ? " with retrying, %o" : "without retrying"), {
                    retryTimes: n
                  }), 0 !== (o = this.getLoginSockets()).length) {
                    e.next = 5;
                    break;
                  }

                  throw new Error("no logged-in sockets");

                case 5:
                  return i = t(n), o.forEach(function (e) {
                    e.sendPacket("Message", i);
                  }), s = i.dialogue, a = i.sequence, u = i.instance, l = o.map(function (e) {
                    return e.fromReceived("Ack").pipe(filter(function (e) {
                      return s.eq(e.dialogue) && a.eq(e.sequence) && u.eq(e.instance);
                    }));
                  }), e.prev = 9, e.next = 12, merge.apply(void 0, _toConsumableArray$b(l)).pipe(timeout(MESSAGE_RETRY_TIMEOUT), catchError(function (e) {
                    return isTimeout(e) && f.warn("Send message retry timeout"), throwError(e);
                  }), take(1)).toPromise();

                case 12:
                  return c = e.sent, p = c.code, this.log("The message has been acked, %o", {
                    code: p
                  }), e.abrupt("return", {
                    code: p,
                    retryTimes: n
                  });

                case 18:
                  if (e.prev = 18, e.t0 = e.catch(9), !(e.t0 instanceof TimeoutError && r)) {
                    e.next = 22;
                    break;
                  }

                  return e.abrupt("return", this.sendMessageToRetry(t, !1, n + 1));

                case 22:
                  throw e.t0;

                case 23:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[9, 18]]);
        }));

        return function (t, r) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "initKeepAliveSender",
      value: function value() {
        var e = this;
        this.lastLoginSockets.map(function (t) {
          return t.pipe(switchMap(function (t) {
            return timer(0, KEEPALIVE_INTERVAL).pipe(tap(function () {
              e.incSeqIfNeeded(t.env), t.sendPacket("Ping", {
                ms: long_1.fromNumber(Date.now(), !0),
                seq: e.seq
              });
            }));
          }));
        }).forEach(function (t, r) {
          var n = e.loginSocketSubs[r].keepAlive;
          void 0 !== n && n.unsubscribe(), e.loginSocketSubs[r].keepAlive = t.subscribe({
            error: function error() {}
          });
        });
      }
    }, {
      key: "initKeepAliveReconnector",
      value: function value() {
        var e = this;
        this.lastLoginSockets.map(function (e) {
          return e.pipe(switchMap(function (e) {
            var t,
                r = !1,
                n = e.userJoin$.pipe(tap(function () {
              r = !0;
            })),
                o = e.input$.pipe(tap(function (e) {
              "Ping" !== uriToPacketName(e.uri) && (r = !1);
            }));
            return merge(timer(LOGIN_RESP_TIMEOUT, SOCKET_KEEPALIVE_TIMEOUT).pipe(withLatestFrom(e.receivedPacket), tap(function (n) {
              var o = _slicedToArray$a(n, 2),
                  i = _slicedToArray$a(o[1], 2)[1];

              t !== i || r || e.forceReconnect(), t = i;
            })), n, o);
          }));
        }).forEach(function (t, r) {
          var n = e.loginSocketSubs[r].keepAliveReconnector;
          void 0 !== n && n.unsubscribe(), e.loginSocketSubs[r].keepAliveReconnector = t.subscribe({
            error: function error() {}
          });
        });
      }
    }, {
      key: "initLoginReceiver",
      value: function value() {
        var e = this;
        this.lastLoginSockets.map(function (t) {
          return t.pipe(switchMap(function (t) {
            return merge(fromEvent(t, "reconnect").pipe(tap(e.onSocketReconnect(t))), t.fromReceived("Message").pipe(tap(e.onMessage(t))), t.fromReceived("GroupEnterNotice").pipe(tap(e.onGroupEnterNotice())), t.fromReceived("GroupLeaveNotice").pipe(tap(e.onGroupLeaveNotice())), t.fromReceived("GroupCountNotice").pipe(tap(e.onGroupCountNotice())), t.fromReceived("GroupAttributeAlt").pipe(tap(e.onGroupAttributeAlt())), t.fromReceived("UserJoinNotice").pipe(tap(e.onUserNotice(RtmStatusCode$1.PeerOnlineState.ONLINE))), t.fromReceived("UserQuitNotice").pipe(tap(e.onUserNotice(RtmStatusCode$1.PeerOnlineState.OFFLINE))), t.fromReceived("UserWaitNotice").pipe(tap(e.onUserNotice(RtmStatusCode$1.PeerOnlineState.UNREACHABLE)))).pipe(mapTo(void 0));
          }));
        }).forEach(function (t, r) {
          e.loginSocketSubs[r].receivers.push(t.subscribe({
            error: function error() {}
          }));
        });
      }
    }, {
      key: "requestSocketLogin",
      value: function value(e, t, r) {
        var n = this;
        return concat(defer$1(function () {
          n.userJoinOptions = new UserJoinOptions(t), e.sendPacket("UserJoin", {
            account: n.context.uid,
            instance: n.instanceId,
            opt: n.userJoinOptions.toLong(),
            seq: r,
            ticket: e.ticket
          });
        }), e.fromReceived("UserResp").pipe(first(function (e) {
          return r.eq(e.seq);
        }), tap(function (t) {
          var r = t.code;
          if (0 !== r) throw n.clearSockets(), n.logError("Connected to gateway success but the Rtm server rejected login"), new RtmUnavailableError(["Login failure. The response code from the RTM service is %d", r], LOGIN_ERR_REJECTED);
          n.log("ENV_%d logged in", e.env);
        }), mapTo(e), timeout(LOGIN_RESP_TIMEOUT))).pipe(filter(function (e) {
          return void 0 !== e;
        }), catchError(function (e) {
          return e instanceof TimeoutError && n.warn("Login response timeout, rejoin: %s", t), throwError(e);
        }));
      }
    }, {
      key: "getSocketLoginObservables",
      value: function value(e, t) {
        var r = this;
        return e.map(function (e) {
          return e.pipe(tap(function (e) {
            0 === e.listenerCount("socketUserDrop") && e.on("socketUserDrop", function (t) {
              return r.onUserDrop(t, e);
            });
          }), switchMap(function (e, n) {
            return r.incSeqIfNeeded(e.env), r.requestSocketLogin(e, 0 !== n, 0 === n ? t : r.seq);
          }), share());
        });
      }
    }, {
      key: "incSeqIfNeeded",
      value: function value(e) {
        if (![0, 1].includes(e)) throw new CommonError({
          INVALID_ENV: "The env argument is not 0 or 1"
        });
        this.seqSentStatuses[e] && (this.seq = this.seq.add(1), this.seqSentStatuses = [!1, !1]), this.seqSentStatuses[e] = !0;
      }
    }, {
      key: "incGetSeq",
      value: function value() {
        return this.seq = this.seq.add(1), this.seqSentStatuses = [!0, !0], this.seq;
      }
    }, {
      key: "getLoginSockets",
      value: function value() {
        return compact_1(this.curLoginSockets);
      }
    }, {
      key: "emitMessage",
      value: function value(e, r) {
        var n = e.options,
            o = e.payload,
            i = e.src,
            s = e.dst,
            a = e.instance,
            u = e.dialogue,
            l = e.sequence,
            c = e.ms,
            p = e.MiscMap;
        this.dialogueSequenceLru.set(u.toString(), l);
        var f = "".concat(a, "-").concat(u, "#").concat(l);
        if (this.msgDedupLru.has(f)) this.warn("Env_%d: Messages out-of-order or not start with 1: %s", r, f);else {
          this.msgDedupLru.set(f, void 0);
          var d = new MessageOption(n);
          this.lastLoginSockets.forEach(function () {
            var r = _asyncToGenerator$a(regenerator.mark(function r(n) {
              var o;
              return regenerator.wrap(function (r) {
                for (;;) {
                  switch (r.prev = r.next) {
                    case 0:
                      return r.next = 2, n.pipe(take(1)).toPromise();

                    case 2:
                      o = r.sent, t.sendMessageAck(e, o);

                    case 4:
                    case "end":
                      return r.stop();
                  }
                }
              }, r);
            }));

            return function (e) {
              return r.apply(this, arguments);
            };
          }());
          var g = d.isZlibCompressed();

          if (d.isInvitation()) {
            var h = decodeUint8ArrayToString(g ? UZIP_3(o) : o),
                b = JSON.parse(h);
            this.log("The received invitation body is %o", b), this.emit("invitationMessage", {
              body: b,
              type: d.getInvitationType(),
              peerId: i,
              serverReceivedTs: c.toNumber()
            });
          } else if (d.isTextMessage()) {
            var y = d.isPeerTextMessage(),
                _ = decodeUint8ArrayToString(g ? UZIP_3(o) : o);

            if (this.info("Received a%s %s text message from %s to %s, %s", g ? " compressed" : "", y ? "peer" : "channel", i, s, f), y) {
              var m = {
                text: _,
                peerId: i,
                properties: {
                  serverReceivedTs: c.toNumber(),
                  isOfflineMessage: d.isFromCache(),
                  isHistoricalMessage: d.isFromArchive()
                }
              };
              this.emit("peerTextMessage", m);
            } else this.emit("channelTextMessage", {
              channelId: s,
              memberId: i,
              text: _,
              properties: {
                serverReceivedTs: c.toNumber(),
                isOfflineMessage: !1,
                isHistoricalMessage: d.isFromArchive()
              }
            });
          } else if (d.isRawMessage()) {
            var v = d.isRawPeerMessage(),
                E = p.description,
                O = void 0 === E ? "" : decodeUint8ArrayToString(E),
                I = g ? UZIP_3(o) : o;

            if (this.info("Received a%s %s raw message from %s to %s, %s", g ? " compressed" : "", v ? "peer" : "channel", i, s, f), v) {
              var $ = {
                desc: O,
                raw: I,
                peerId: i,
                properties: {
                  serverReceivedTs: c.toNumber(),
                  isOfflineMessage: d.isFromCache(),
                  isHistoricalMessage: d.isFromArchive()
                }
              };
              this.emit("peerRawMessage", $);
            } else this.emit("channelRawMessage", {
              desc: O,
              raw: I,
              channelId: s,
              memberId: i,
              properties: {
                serverReceivedTs: c.toNumber(),
                isOfflineMessage: !1,
                isHistoricalMessage: d.isFromArchive()
              }
            });
          } else if (d.isImageMessage() || d.isFileMessage()) {
            var S = d.isPeerMessage();
            this.info("Received a %s media message from %s to %s, %s", S ? "peer" : "channel", i, s, f), S ? this.emit("peerMediaMessage", {
              messageType: d.isImageMessage() ? "IMAGE" : "FILE",
              details: p,
              peerId: i,
              properties: {
                serverReceivedTs: c.toNumber(),
                isOfflineMessage: d.isFromCache(),
                isHistoricalMessage: d.isFromArchive()
              }
            }) : this.emit("channelMediaMessage", {
              messageType: d.isImageMessage() ? "IMAGE" : "FILE",
              details: p,
              memberId: i,
              channelId: s,
              properties: {
                serverReceivedTs: c.toNumber(),
                isOfflineMessage: d.isFromCache(),
                isHistoricalMessage: d.isFromArchive()
              }
            });
          }
        }
      }
    }, {
      key: "onSocketReconnect",
      value: function value(e) {
        var t = this;
        return function () {
          var r = [0, 1].filter(function (t) {
            return t !== e.env;
          })[0],
              n = t.connection.curOpenSockets[r];
          n && !n.loggedIn && t.emit("connectionLost");
        };
      }
    }, {
      key: "onUserDrop",
      value: function value(e, t) {
        var r,
            n,
            o = e.code;

        if (sendReport("KickedOff", {
          code: 0,
          elapse: getElapse(this.startTime),
          linkId: parseInt(t.name.split("-")[1], 10),
          lts: long_1.fromNumber(Date.now()),
          server: t.address,
          serverCode: o,
          sid: getSid(this.instanceId),
          userId: this.context.uid
        }, null === (r = this.context.areaConfig) || void 0 === r ? void 0 : r.EVENT_REPORT_DOMAIN[0], null === (n = this.context.areaConfig) || void 0 === n ? void 0 : n.EVENT_REPORT_BACKUP_DOMAIN[0]), 10006 !== o && 10001 !== o) {
          if (10009 === o) return this.warn("The instance ID conflicts, reconnecting"), this.instanceId = getRandomUInt64(), this.context.sid = getSid(this.instanceId), void this.emit("instanceChanged", this.instanceId);
          [11, 14, 15, 16].includes(o) && (this.emit("userDrop", o), this.clearSockets());
        } else this.warn("Login too often and kicked off, reconnect and login");
      }
    }, {
      key: "clearSockets",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        [0, 1].forEach(function (n) {
          e.cleanLoginSubs(n, r), e.connection.closeSocket(n, t);
        });
      }
    }, {
      key: "onMessage",
      value: function value(e) {
        var t = this;
        return function (r) {
          var n = r.dialogue,
              o = r.instance,
              i = r.sequence,
              s = r.options;

          if (r.src !== t.context.uid) {
            var a = n.toString(),
                u = t.dialPendingMsgSubjectMaps[e.env].get(a),
                l = "".concat(o, "-").concat(n, "#").concat(i);
            if (u) return u.next(r), void t.log("Env_%d: The dialogue has pending messages, next: %s", e.env, l);
            var c = t.dialogueSequenceLru.get(a),
                p = !c && i.eq(1),
                f = void 0 !== c && i.sub(c).eq(1);
            if (p || f) t.emitMessage(r, e.env);else {
              if (c) {
                if (i.lte(c)) return;
                t.log("Env_%d: The message pended, the sequence is not continuous with the last: %s", e.env, l);
              } else t.log("Env_%d: The message pended, the first sequence is not equal to 1: %s", e.env, l);

              var d = new Subject();
              t.dialPendingMsgSubjectMaps[e.env].set(a, d);
              var g = d.pipe(observeOn(async), scan(function (e, t) {
                return [].concat(_toConsumableArray$b(e), [t]);
              }, []), map$1(function (e) {
                return e.sort(function (e, t) {
                  var r = e.sequence,
                      n = t.sequence;
                  return r.eq(n) ? 0 : r.gt(n) ? 1 : -1;
                });
              }), shareReplay(1)),
                  h = new MessageOption(s),
                  b = !h.isFromCache() && !h.isBufferedMessage();
              g.pipe(takeUntil(timer(b ? ONLINE_MESSAGE_DEDUP_DELAY : OFFLINE_MESSAGE_DEDUP_DELAY)), first(function (e) {
                if (e.length < 2) return !1;

                for (var t = void 0 === c ? long_1.fromNumber(1, !0) : c.add(1), r = 0; r < e.length; t = t.add(1), r++) {
                  if (!e[r].sequence.eq(t)) return !1;
                }

                return !0;
              }), finalize(function () {
                t.dialPendingMsgSubjectMaps[e.env].delete(a);
              })).subscribe(function (r) {
                r.forEach(function (r) {
                  t.emitMessage(r, e.env), t.log("Env_%d: The message queue has fully ordered, emitting: %s", e.env, "".concat(r.instance, "-").concat(r.dialogue, "#").concat(r.sequence));
                });
              }, function (r) {
                r instanceof EmptyError && g.pipe(take(1)).subscribe(function (r) {
                  return r.forEach(function (r) {
                    t.log("Env_%d: The message pending queue expired, emitting: %s", e.env, "".concat(r.instance, "-").concat(r.dialogue, "#").concat(r.sequence)), t.emitMessage(r, e.env);
                  });
                });
              }), d.next(r);
            }
          } else t.log("The message is from the local account, ignored");
        };
      }
    }, {
      key: "onGroupEnterNotice",
      value: function value() {
        var e = this;
        return function (t) {
          var r = t.group,
              n = t.instance,
              o = t.seq,
              i = t.user,
              s = t.size;
          e.emit("memberNotice", {
            channelId: r,
            seq: o,
            instance: n,
            memberId: i,
            type: "MemberJoined",
            size: s
          });
        };
      }
    }, {
      key: "onGroupLeaveNotice",
      value: function value() {
        var e = this;
        return function (t) {
          var r = t.group,
              n = t.instance,
              o = t.seq,
              i = t.user,
              s = t.size;
          e.emit("memberNotice", {
            channelId: r,
            seq: o,
            instance: n,
            memberId: i,
            type: "MemberLeft",
            size: s
          });
        };
      }
    }, {
      key: "onGroupCountNotice",
      value: function value() {
        var e = this;
        return function (t) {
          var r = t.group,
              n = t.instance,
              o = t.size,
              i = t.seq;
          e.emit("memberNotice", {
            channelId: r,
            seq: i,
            instance: n,
            type: "MemberCountUpdated",
            size: o
          });
        };
      }
    }, {
      key: "onGroupAttributeAlt",
      value: function value() {
        var e = this;
        return function (t) {
          var r = t.group,
              n = _objectWithoutProperties$3(t, ["group"]);

          e.emit("channelAttributesUpdated", _objectSpread$3({
            channelId: r
          }, n));
        };
      }
    }, {
      key: "onUserNotice",
      value: function value(e) {
        var t = this;
        return function (r) {
          var n = r.instance,
              o = r.seq,
              i = r.user;
          t.emit("peerOnlineStatusChanged", {
            peerId: i,
            instance: n,
            seq: o,
            state: e
          });
        };
      }
    }]), t;
  }();

  function genGetSession(e) {
    return function () {
      var t = e();
      if (!t) throw new RtmInvalidStatusError("Client is not logged in. Cannot do the operation");
      return t;
    };
  }

  function _typeof$f(e) {
    return (_typeof$f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function asyncGeneratorStep$b(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$b(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$b(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$b(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  function _classCallCheck$g(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _possibleConstructorReturn$e(e, t) {
    return !t || "object" !== _typeof$f(t) && "function" != typeof t ? _assertThisInitialized$e(e) : t;
  }

  function _getPrototypeOf$e(e) {
    return (_getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _assertThisInitialized$e(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _defineProperties$c(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$c(e, t, r) {
    return t && _defineProperties$c(e.prototype, t), r && _defineProperties$c(e, r), e;
  }

  function _inherits$e(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$e(e, t);
  }

  function _setPrototypeOf$e(e, t) {
    return (_setPrototypeOf$e = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  Session$2.genTimeoutError = function (e, t) {
    return of(void 0).pipe(delay(void 0 === t ? COMMON_REQUEST_TIMEOUT : t), map$1(function () {
      throw new RtmTimeoutError(["Request timed out after %ds", void 0 === t ? COMMON_REQUEST_TIMEOUT : t], e);
    }));
  };

  var LocalInvitationFailureReason = RtmStatusCode$1.LocalInvitationFailureReason,
      LocalInvitationState = RtmStatusCode$1.LocalInvitationState,
      RemoteInvitationFailureReason = RtmStatusCode$1.RemoteInvitationFailureReason,
      RemoteInvitationState = RtmStatusCode$1.RemoteInvitationState,
      EndedInvitationLogMessage = "The invitation has ended, skipped emitting the %s event",
      InvitationError = genError(),
      RtmLocalInvitation = function (e) {
    function t(e, r, n) {
      var o;
      return _classCallCheck$g(this, t), (o = _possibleConstructorReturn$e(this, _getPrototypeOf$e(t).call(this, n, "RtmLocalInvitation", !0))).calleeId = e, o.getSession = r, o.state = LocalInvitationState.IDLE, o.localInvitationEnd$ = merge(fromEvent(_assertThisInitialized$e(o), "LocalInvitationAccepted"), fromEvent(_assertThisInitialized$e(o), "LocalInvitationRefused"), fromEvent(_assertThisInitialized$e(o), "LocalInvitationFailure"), fromEvent(_assertThisInitialized$e(o), "LocalInvitationCanceled")).pipe(take(1), subscribeOn(async)), o.callId = v4_1(), o._content = "", o._channelId = "", o._response = "", o.onLocalInvitationAccepted = function () {
        o.state === LocalInvitationState.RECEIVED_BY_REMOTE ? o.state = LocalInvitationState.ACCEPTED_BY_REMOTE : o.log(EndedInvitationLogMessage, "LocalInvitationAccepted");
      }, o.onLocalInvitationCanceled = function () {
        o.isLocalInvitationEnd() ? o.log(EndedInvitationLogMessage, "LocalInvitationCanceled") : o.state = LocalInvitationState.CANCELED;
      }, o.onLocalInvitationFailure = function () {
        o.isLocalInvitationEnd() ? o.log(EndedInvitationLogMessage, "LocalInvitationFailure") : o.state = LocalInvitationState.FAILURE;
      }, o.onLocalInvitationReceivedByPeer = function () {
        o.state === LocalInvitationState.SENT_TO_REMOTE ? o.state = LocalInvitationState.RECEIVED_BY_REMOTE : o.log(EndedInvitationLogMessage, "LocalInvitationReceivedByPeer");
      }, o.onLocalInvitationRefused = function () {
        o.state === LocalInvitationState.RECEIVED_BY_REMOTE ? o.state = LocalInvitationState.REFUSED_BY_REMOTE : o.log(EndedInvitationLogMessage, "LocalInvitationRefused");
      }, o;
    }

    return _inherits$e(t, createEventBase()), _createClass$c(t, [{
      key: "channelId",
      get: function get() {
        return this._channelId;
      },
      set: function set(e) {
        if (!isValidId(e)) throw new RtmInvalidArgumentError("Illegal invitation channel ID", INVITATION_API_CALL_ERR_INVALID_ARGUMENT);
        if (this.state !== LocalInvitationState.IDLE) throw new RtmInvalidStatusError(["Cannot set the channel ID under the %s state", this.state], INVITATION_API_CALL_ERR_ALREADY_SENT);
        this._channelId = e;
      }
    }, {
      key: "content",
      get: function get() {
        return this._content;
      },
      set: function set(e) {
        if (this.state !== LocalInvitationState.IDLE && this.state !== LocalInvitationState.SENT_TO_REMOTE && this.state !== LocalInvitationState.RECEIVED_BY_REMOTE) throw new RtmInvalidStatusError(["Cannot set the content under the %s state", this.state], INVITATION_API_CALL_ERR_ALREADY_SENT);
        if (new Blob([e]).size > INVITATION_EXTRA_MAX_BYTES) throw new RtmInvalidArgumentError('The length of the "content" overflows. The number of bytes representing content must not exceed 8 × 1024 if encoded in UTF-8.', INVITATION_API_CALL_ERR_INVALID_ARGUMENT);
        this._content = e;
      }
    }, {
      key: "response",
      get: function get() {
        return this._response;
      },
      set: function set(e) {
        throw new RtmInvalidArgumentError('Cannot set the "response" of the LocalInvitation instance.', INVITATION_API_CALL_ERR_INVALID_ARGUMENT);
      }
    }]), _createClass$c(t, [{
      key: "send",
      value: function value() {
        var e,
            t = this;
        if (this.state === LocalInvitationState.SENT_TO_REMOTE || this.state === LocalInvitationState.RECEIVED_BY_REMOTE) throw new RtmInvalidStatusError("The local invitation send failure. The call invitation has already been sent.", INVITATION_API_CALL_ERR_ALREADY_SENT);
        if (this.isLocalInvitationEnd()) throw new RtmInvalidStatusError("The local invitation send failure. The call invitation has ended.", INVITATION_API_CALL_ERR_ALREADY_END);
        this.state = LocalInvitationState.SENT_TO_REMOTE, defer$1(_asyncToGenerator$b(regenerator.mark(function r() {
          var n, o, i;
          return regenerator.wrap(function (r) {
            for (;;) {
              switch (r.prev = r.next) {
                case 0:
                  return r.next = 2, t.getSession().sendInvitationMessage({
                    peerId: t.calleeId,
                    callId: t.callId,
                    extra: t.content,
                    type: "CallInvite",
                    channelId: t.channelId
                  });

                case 2:
                  if (n = r.sent, o = n.hasPeerReceived, i = n.hasReSent, t.log("The local invitation has sent to the callee"), o || i) {
                    r.next = 9;
                    break;
                  }

                  throw e = new InvitationError({
                    PEER_NOT_ONLINE: "The peer of the invitation is not online"
                  });

                case 9:
                  if (o) {
                    r.next = 12;
                    break;
                  }

                  throw e = new InvitationError({
                    RESENT_AND_OFFLINE: "Resent and the peer of the invitation is not online"
                  });

                case 12:
                case "end":
                  return r.stop();
              }
            }
          }, r);
        }))).pipe(retryWhen(function (e) {
          return e.pipe(tap(function (e) {
            if (!(e instanceof InvitationError)) throw e;
          }), delay(LOCAL_INVITATION_RESEND_INTERVAL));
        }), timeout(LOCAL_INVITATION_ACK_TIMEOUT), catchError(function (e) {
          return isTimeout(e) && t.warn("local invitation ack timed out"), throwError(e);
        }), takeUntil(this.localInvitationEnd$)).subscribe({
          next: function next() {
            t.isLocalInvitationEnd() ? t.log(EndedInvitationLogMessage, "LocalInvitationReceivedByPeer") : t.state !== LocalInvitationState.RECEIVED_BY_REMOTE ? (t.info("The peer received the local invitation %s.", t.callId), t.onLocalInvitationReceivedByPeer(), t.emit("LocalInvitationReceivedByPeer"), t.localInvitationEnd$.pipe(timeout(INVITATION_EXPIRE_TIMEOUT), catchError(function (e) {
              return isTimeout(e) && t.warn("local invitation expired"), throwError(e);
            }), takeUntil(t.localInvitationEnd$)).subscribe({
              error: function error(e) {
                t.isLocalInvitationEnd() ? t.log(EndedInvitationLogMessage, "LocalInvitationFailure") : (t.state = LocalInvitationState.FAILURE, isTimeout(e) ? t.emit("LocalInvitationFailure", LocalInvitationFailureReason.INVITATION_EXPIRE) : e instanceof RtmInvalidStatusError ? t.emit("LocalInvitationFailure", LocalInvitationFailureReason.NOT_LOGGEDIN) : t.emit("LocalInvitationFailure", LocalInvitationFailureReason.UNKNOWN), t.onLocalInvitationFailure());
              }
            })) : t.log('The local invitation state is already "RECEIVED_BY_REMOTE", skipped emitting "LocalInvitationReceivedByPeer"');
          },
          error: function error(r) {
            if (t.isLocalInvitationEnd()) t.log(EndedInvitationLogMessage, "LocalInvitationFailure");else {
              if (t.onLocalInvitationFailure(), isTimeout(r) && e) {
                if ("PEER_NOT_ONLINE" === e.code) return void t.emit("LocalInvitationFailure", LocalInvitationFailureReason.PEER_OFFLINE);
                if ("RESENT_AND_OFFLINE" === e.code) return void t.emit("LocalInvitationFailure", LocalInvitationFailureReason.PEER_NO_RESPONSE);
              }

              t.emit("LocalInvitationFailure", LocalInvitationFailureReason.UNKNOWN);
            }
          }
        });
      }
    }, {
      key: "cancel",
      value: function value() {
        if (this.isLocalInvitationEnd()) throw new RtmInvalidStatusError("The local invitation cancel failure", INVITATION_API_CALL_ERR_ALREADY_END);
        if (this.state === LocalInvitationState.IDLE) throw new RtmInvalidStatusError("The local invitation has not been sent", INVITATION_API_CALL_ERR_NOT_STARTED);
        this.getSession().sendInvitationMessage({
          callId: this.callId,
          peerId: this.calleeId,
          type: "CallCancel",
          channelId: this.channelId,
          extra: this.content
        }), this.onLocalInvitationCanceled(), this.emit("LocalInvitationCanceled");
      }
    }, {
      key: "onAcceptReceived",
      value: function value(e) {
        this.isLocalInvitationEnd() ? this.log(EndedInvitationLogMessage, "LocalInvitationAccepted") : (this._response = e, this.onLocalInvitationAccepted(), this.emit("LocalInvitationAccepted", e), this.getSession().sendInvitationMessage({
          callId: this.callId,
          isAcceptAck: !0,
          type: "CallAccept",
          peerId: this.calleeId,
          channelId: this.channelId
        }));
      }
    }, {
      key: "onRefuseReceived",
      value: function value(e) {
        this.isLocalInvitationEnd() ? this.log(EndedInvitationLogMessage, "LocalInvitationRefused") : (this._response = e, this.onLocalInvitationRefused(), this.emit("LocalInvitationRefused", e));
      }
    }, {
      key: "isLocalInvitationEnd",
      value: function value() {
        return [LocalInvitationState.CANCELED, LocalInvitationState.FAILURE, LocalInvitationState.ACCEPTED_BY_REMOTE, LocalInvitationState.REFUSED_BY_REMOTE].includes(this.state);
      }
    }]), t;
  }(),
      RtmRemoteInvitation = function (e) {
    function t(e, r, n, o, i, s) {
      var a;
      return _classCallCheck$g(this, t), (a = _possibleConstructorReturn$e(this, _getPrototypeOf$e(t).call(this, o, "RtmRemoteInvitation", !0))).callerId = e, a.callId = r, a.getSession = n, a.logger = o, a._content = i, a._channelId = s, a.state = RemoteInvitationState.INVITATION_RECEIVED, a.remoteInvitationEnd$ = merge(fromEvent(_assertThisInitialized$e(a), "RemoteInvitationCanceled"), fromEvent(_assertThisInitialized$e(a), "RemoteInvitationRefused"), fromEvent(_assertThisInitialized$e(a), "RemoteInvitationAccepted"), fromEvent(_assertThisInitialized$e(a), "RemoteInvitationFailure")).pipe(take(1), subscribeOn(async)), a._response = "", a.onRemoteInvitationAccepted = function () {
        a.state === RemoteInvitationState.ACCEPT_SENT_TO_LOCAL ? a.state = RemoteInvitationState.ACCEPTED : a.log(EndedInvitationLogMessage, "RemoteInvitationAccepted");
      }, a.onRemoteInvitationCanceled = function () {
        a.isRemoteInvitationEnd() ? a.log(EndedInvitationLogMessage, "RemoteInvitationCanceled") : a.state = RemoteInvitationState.CANCELED;
      }, a.onRemoteInvitationFailure = function () {
        a.isRemoteInvitationEnd() ? a.log(EndedInvitationLogMessage, "RemoteInvitationFailure") : a.state = RemoteInvitationState.FAILURE;
      }, a.onRemoteInvitationRefused = function () {
        a.state === RemoteInvitationState.INVITATION_RECEIVED ? a.state = RemoteInvitationState.REFUSED : a.log(EndedInvitationLogMessage, "RemoteInvitationRefused");
      }, a.remoteInvitationEnd$.pipe(timeout(INVITATION_EXPIRE_TIMEOUT), takeUntil(a.remoteInvitationEnd$), catchError(function (e) {
        return isTimeout(e) && a.warn("Remote invitation expired"), throwError(e);
      })).subscribe({
        error: function error(e) {
          a.isRemoteInvitationEnd() ? a.log(EndedInvitationLogMessage, "RemoteInvitationFailure") : (a.onRemoteInvitationFailure(), isTimeout(e) ? a.emit("RemoteInvitationFailure", RemoteInvitationFailureReason.INVITATION_EXPIRE) : a.emit("RemoteInvitationFailure", RemoteInvitationFailureReason.UNKNOWN));
        }
      }), a;
    }

    return _inherits$e(t, createEventBase()), _createClass$c(t, [{
      key: "channelId",
      get: function get() {
        return this._channelId;
      },
      set: function set(e) {
        throw new RtmInvalidArgumentError('Cannot set the "response" of the RemoteInvitation instance.', INVITATION_API_CALL_ERR_INVALID_ARGUMENT);
      }
    }, {
      key: "content",
      get: function get() {
        return this._content;
      },
      set: function set(e) {
        throw new RtmInvalidArgumentError('Cannot set the "content" of the RemoteInvitation instance.', INVITATION_API_CALL_ERR_INVALID_ARGUMENT);
      }
    }, {
      key: "response",
      get: function get() {
        return this._response;
      },
      set: function set(e) {
        if (this.isRemoteInvitationEnd()) throw new RtmInvalidStatusError("The response set failure. The call invitation has already ended.", INVITATION_API_CALL_ERR_ALREADY_END);
        if (this.state !== RemoteInvitationState.INVITATION_RECEIVED) throw new RtmInvalidStatusError(["Cannot set the response under the %s state", this.state], INVITATION_API_CALL_ERR_ALREADY_ACCEPT);
        if (new Blob([e]).size > INVITATION_EXTRA_MAX_BYTES) throw new RtmInvalidArgumentError('The length of the "content" overflows. The number of bytes representing content must not exceed 8 × 1024 if encoded in UTF-8.', INVITATION_API_CALL_ERR_INVALID_ARGUMENT);
        this._response = e;
      }
    }]), _createClass$c(t, [{
      key: "accept",
      value: function value() {
        var e = this;
        if (this.isRemoteInvitationEnd()) throw new RtmInvalidStatusError("The local invitation has ended. Cannot accept.", INVITATION_API_CALL_ERR_ALREADY_END);
        if (this.state === RemoteInvitationState.ACCEPT_SENT_TO_LOCAL) throw new RtmInvalidStatusError("The remote invitation is accepting. Cannot do the operation.", INVITATION_API_CALL_ERR_ALREADY_ACCEPT);
        this.state = RemoteInvitationState.ACCEPT_SENT_TO_LOCAL, defer$1(_asyncToGenerator$b(regenerator.mark(function t() {
          var r;
          return regenerator.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, e.getSession().sendInvitationMessage({
                    peerId: e.callerId,
                    callId: e.callId,
                    extra: e.response,
                    type: "CallAccept",
                    isAcceptAck: !1,
                    channelId: e.channelId
                  });

                case 2:
                  if (r = t.sent, r.hasPeerReceived) {
                    t.next = 6;
                    break;
                  }

                  throw new RtmUnavailableError();

                case 6:
                  return t.next = 8, fromEvent(e, "RemoteInvitationAccepted").toPromise();

                case 8:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }))).pipe(retryWhen(function (e) {
          return e.pipe(delay(REMOTE_INVITATION_ACCEPT_RESEND_INTERVAL));
        }), timeout(REMOTE_INVITATION_WAIT_ACCEPT_ACK_TIMEOUT), catchError(function (t) {
          return isTimeout(t) && e.warn("remote invitation ack timed out"), throwError(t);
        }), takeUntil(this.remoteInvitationEnd$), throwIfEmpty()).subscribe({
          error: function error(t) {
            e.isRemoteInvitationEnd() ? t instanceof EmptyError || e.log(EndedInvitationLogMessage, "RemoteInvitationFailure") : (e.logError(t), e.onRemoteInvitationFailure(), e.emit("RemoteInvitationFailure", RemoteInvitationFailureReason.ACCEPT_FAILURE));
          }
        });
      }
    }, {
      key: "refuse",
      value: function value() {
        if (this.state === RemoteInvitationState.ACCEPT_SENT_TO_LOCAL) throw new RtmInvalidStatusError("The remote invitation is accepting. Cannot do the operation.", INVITATION_API_CALL_ERR_ALREADY_ACCEPT);
        if (this.isRemoteInvitationEnd()) throw new RtmInvalidStatusError("The invitation is end. Cannot refuse", INVITATION_API_CALL_ERR_ALREADY_END);
        this.getSession().sendInvitationMessage({
          peerId: this.callerId,
          callId: this.callId,
          extra: this.response,
          type: "CallReject",
          channelId: this.channelId
        }), this.onRemoteInvitationRefused(), this.emit("RemoteInvitationRefused");
      }
    }, {
      key: "onCancelReceived",
      value: function value(e) {
        this.isRemoteInvitationEnd() ? this.log(EndedInvitationLogMessage, "RemoteInvitationCanceled") : (this._content = e, this.onRemoteInvitationCanceled(), this.emit("RemoteInvitationCanceled", e));
      }
    }, {
      key: "onAcceptAckReceived",
      value: function value() {
        this.isRemoteInvitationEnd() ? this.log(EndedInvitationLogMessage, "RemoteInvitationAccepted") : (this.onRemoteInvitationAccepted(), this.emit("RemoteInvitationAccepted"));
      }
    }, {
      key: "isRemoteInvitationEnd",
      value: function value() {
        return [RemoteInvitationState.ACCEPTED, RemoteInvitationState.REFUSED, RemoteInvitationState.CANCELED, RemoteInvitationState.FAILURE].includes(this.state);
      }
    }]), t;
  }(),
      InvitationManager = function (e) {
    function t(e, r) {
      var n;
      return _classCallCheck$g(this, t), (n = _possibleConstructorReturn$e(this, _getPrototypeOf$e(t).call(this, r, "InvitationManager"))).logger = r, n.getSession = void 0, n.invitationDispatcher = new events(), n.outgoingLocalInvitations = new Map(), n.receivedRemoteInvitations = new LRUCache(void 0, {
        maxlen: LRU_MAX_ITEMS
      }), n.getSession = genGetSession(e), n.invitationDispatcher.on("remoteInvitationToManager", function (e) {
        var t = e.callId,
            o = e.extra,
            i = e.callerId,
            s = e.channelId;

        if (!n.receivedRemoteInvitations.has(t)) {
          var a = new RtmRemoteInvitation(i, t, n.getSession, r, o, s);
          a.remoteInvitationEnd$.subscribe(function () {
            n.receivedRemoteInvitations.delete(t), a.removeAllListeners();
          }), n.receivedRemoteInvitations.set(t, a), n.emit("remoteInvitationInstance", a);
        }
      }), n.invitationDispatcher.on("acceptAckToRemoteInvitation", function (e) {
        var t = e.callId,
            r = n.receivedRemoteInvitations.get(t);
        r && r.onAcceptAckReceived();
      }), n.invitationDispatcher.on("cancelToRemoteInvitation", function (e) {
        var t = e.callId,
            r = e.extra,
            o = n.receivedRemoteInvitations.get(t);
        o && o.onCancelReceived(r);
      }), n.invitationDispatcher.on("acceptToLocalInvitation", function (e) {
        var t = e.callId,
            r = e.extra,
            o = n.outgoingLocalInvitations.get(t);
        o && o.onAcceptReceived(r);
      }), n.invitationDispatcher.on("refuseToLocalInvitation", function (e) {
        var t = e.callId,
            r = e.extra,
            o = n.outgoingLocalInvitations.get(t);
        o && o.onRefuseReceived(r);
      }), n;
    }

    return _inherits$e(t, createEventBase()), _createClass$c(t, [{
      key: "invitationMessageHandler",
      value: function value(e) {
        var t = e.body,
            r = t.callId,
            n = t.extra,
            o = void 0 === n ? "" : n,
            i = t.type,
            s = t.channel,
            a = void 0 === s ? "" : s,
            u = e.type,
            l = e.peerId,
            c = e.serverReceivedTs;

        switch (u) {
          case "CallAccept":
            return void ("ack" === i ? this.invitationDispatcher.emit("acceptAckToRemoteInvitation", {
              callId: r
            }) : "request" === i && this.invitationDispatcher.emit("acceptToLocalInvitation", {
              callId: r,
              extra: o
            }));

          case "CallInvite":
            return void this.invitationDispatcher.emit("remoteInvitationToManager", {
              callId: r,
              callerId: l,
              extra: o,
              channelId: a
            });

          case "CallCancel":
            if ("0" === r) {
              var p = "".concat(END_CALL_PREFIX, "_").concat(a, "_").concat(o);
              return void this.getSession().emit("peerTextMessage", {
                peerId: l,
                properties: {
                  serverReceivedTs: c,
                  isOfflineMessage: !1,
                  isHistoricalMessage: !1
                },
                text: p
              });
            }

            return void this.invitationDispatcher.emit("cancelToRemoteInvitation", {
              callId: r,
              extra: o
            });

          case "CallReject":
            return void this.invitationDispatcher.emit("refuseToLocalInvitation", {
              callId: r,
              extra: o
            });

          default:
            throw assertNever("invitationType", u);
        }
      }
    }, {
      key: "genLocalInvitation",
      value: function value(e) {
        var t = this,
            r = new RtmLocalInvitation(e, this.getSession, this.logger);
        return r.localInvitationEnd$.subscribe(function () {
          r.removeAllListeners(), t.outgoingLocalInvitations.delete(r.callId);
        }), this.outgoingLocalInvitations.set(r.callId, r), r;
      }
    }]), t;
  }(),
      FUNC_ERROR_TEXT$2 = "Expected a function";

  function throttle(e, t, r) {
    var n = !0,
        o = !0;
    if ("function" != typeof e) throw new TypeError(FUNC_ERROR_TEXT$2);
    return isObject_1(r) && (n = "leading" in r ? !!r.leading : n, o = "trailing" in r ? !!r.trailing : o), debounce_1(e, t, {
      leading: n,
      maxWait: t,
      trailing: o
    });
  }

  var throttle_1 = throttle,
      _class,
      _temp,
      MemberJoinState;

  function _typeof$g(e) {
    return (_typeof$g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _toConsumableArray$c(e) {
    return _arrayWithoutHoles$c(e) || _iterableToArray$c(e) || _nonIterableSpread$c();
  }

  function _nonIterableSpread$c() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _iterableToArray$c(e) {
    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
  }

  function _arrayWithoutHoles$c(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = new Array(e.length); t < e.length; t++) {
        r[t] = e[t];
      }

      return r;
    }
  }

  function asyncGeneratorStep$c(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$c(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$c(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$c(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  function _classCallCheck$h(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties$d(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$d(e, t, r) {
    return t && _defineProperties$d(e.prototype, t), r && _defineProperties$d(e, r), e;
  }

  function _possibleConstructorReturn$f(e, t) {
    return !t || "object" !== _typeof$g(t) && "function" != typeof t ? _assertThisInitialized$f(e) : t;
  }

  function _assertThisInitialized$f(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _getPrototypeOf$f(e) {
    return (_getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _inherits$f(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$f(e, t);
  }

  function _setPrototypeOf$f(e, t) {
    return (_setPrototypeOf$f = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function _applyDecoratedDescriptor(e, t, r, n, o) {
    var i = {};
    return Object.keys(n).forEach(function (e) {
      i[e] = n[e];
    }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
      return n(e, t, r) || r;
    }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
  }

  !function (e) {
    e[e.JOINED = 0] = "JOINED", e[e.LEFT = 1] = "LEFT";
  }(MemberJoinState || (MemberJoinState = {}));

  var ConnectionState = RtmStatusCode$1.ConnectionState,
      Channel = (_temp = function (e) {
    function t(e, r, n, o) {
      var i;
      return _classCallCheck$h(this, t), (i = _possibleConstructorReturn$f(this, _getPrototypeOf$f(t).call(this, o, "RtmChannel", !0))).channelId = e, i.client = n, i.onMemberCountUpdated = throttle_1(function (e) {
        e !== i.memberCount && (i.memberCount = e, i.emit("MemberCountUpdated", e));
      }, MEMBER_COUNT_UPDATED_EVENT_INTERVAL), i.getSession = void 0, i.memberCount = 0, i.memberJoinedLru = new LRUCache(void 0, {
        maxlen: LRU_MAX_ITEMS
      }), i.memberLeftLru = new LRUCache(void 0, {
        maxlen: LRU_MAX_ITEMS
      }), i.memberJoinStateLru = new LRUCache(void 0, {
        maxlen: LRU_MAX_ITEMS
      }), i.attributesSeqLru = new LRUCache(void 0, {
        maxlen: LRU_MAX_ITEMS
      }), i.onAttributesUpdated = function (e) {
        var t = e.channelId,
            r = e.attributeMaps,
            n = e.instance,
            o = e.seq,
            s = n.toString(),
            a = i.attributesSeqLru.get(s);

        if ((!a || o.greaterThan(a)) && (i.attributesSeqLru.set(s, o), t === i.channelId)) {
          var u = {},
              l = r,
              c = Array.isArray(l),
              p = 0;

          for (l = c ? l : l[Symbol.iterator]();;) {
            var f;

            if (c) {
              if (p >= l.length) break;
              f = l[p++];
            } else {
              if ((p = l.next()).done) break;
              f = p.value;
            }

            var d = f,
                g = d.key,
                h = d.ms,
                b = d.value,
                y = d.origin;
            if ("string" != typeof g || !long_1.isLong(h) || "string" != typeof b || !isValidId(y)) break;
            u[g] = {
              value: b,
              lastUpdateUserId: y,
              lastUpdateTs: h.toNumber()
            };
          }

          i.emit("AttributesUpdated", u);
        }
      }, i.onChannelTextMessage = function (e) {
        var t = e.memberId,
            r = e.text,
            n = e.channelId,
            o = e.properties;
        n === i.channelId && i.emit("ChannelMessage", {
          text: r,
          messageType: RtmStatusCode$1.MessageType.TEXT
        }, t, o);
      }, i.onChannelMediaMessage = function (e) {
        var t = e.memberId,
            r = e.channelId,
            n = e.properties,
            o = e.details,
            s = e.messageType;
        r === i.channelId && ("FILE" === s ? i.emit("ChannelMessage", {
          messageType: RtmStatusCode$1.MessageType.FILE,
          size: parseInt(decodeUint8ArrayToString(o[MESSAGE_MEDIA_SIZE_KEY]), 10),
          description: decodeUint8ArrayToString(o[MESSAGE_MEDIA_DESCRIPTION_KEY]),
          fileName: decodeUint8ArrayToString(o[MESSAGE_MEDIA_FILENAME_KEY]),
          mediaId: decodeUint8ArrayToString(o[MESSAGE_MEDIA_ID_KEY]),
          thumbnail: new Blob([o[MESSAGE_MEDIA_THUMBNAIL_KEY]])
        }, t, n) : "IMAGE" === s && i.emit("ChannelMessage", {
          messageType: RtmStatusCode$1.MessageType.IMAGE,
          size: parseInt(decodeUint8ArrayToString(o[MESSAGE_MEDIA_SIZE_KEY]), 10),
          description: decodeUint8ArrayToString(o[MESSAGE_MEDIA_DESCRIPTION_KEY]),
          fileName: decodeUint8ArrayToString(o[MESSAGE_MEDIA_FILENAME_KEY]),
          mediaId: decodeUint8ArrayToString(o[MESSAGE_MEDIA_ID_KEY]),
          thumbnail: new Blob([o[MESSAGE_MEDIA_THUMBNAIL_KEY]]),
          height: parseInt(decodeUint8ArrayToString(o[MESSAGE_MEDIA_HEIGHT_KEY]), 10),
          width: parseInt(decodeUint8ArrayToString(o[MESSAGE_MEDIA_WIDTH_KEY]), 10),
          thumbnailHeight: parseInt(decodeUint8ArrayToString(o[MESSAGE_MEDIA_THUMBNAILHEIGHT_KEY]), 10),
          thumbnailWidth: parseInt(decodeUint8ArrayToString(o[MESSAGE_MEDIA_THUMBNAILWIDTH_KEY]), 10)
        }, t, n));
      }, i.onChannelRawMessage = function (e) {
        var t = e.desc,
            r = e.raw,
            n = e.memberId,
            o = e.channelId,
            s = e.properties;
        o === i.channelId && i.emit("ChannelMessage", {
          messageType: RtmStatusCode$1.MessageType.RAW,
          rawMessage: r,
          description: t
        }, n, s);
      }, i.onMemberNotice = function (e) {
        var t = e.channelId,
            r = e.instance,
            n = e.memberId,
            o = e.seq,
            s = e.type,
            a = e.size;

        if (t === i.channelId) {
          var u = r.toString(),
              l = o.toString(),
              c = {
            MemberLeft: i.memberLeftLru,
            MemberJoined: i.memberJoinedLru,
            MemberCountUpdated: void 0
          }[s];

          if (c) {
            if (c.has(u + l)) return void i.log("received duplicated %s notice (seq: %s), channel '%s', member '%s'", s, l, i.channelId, n);
            if (c.set(u + l, void 0), "string" != typeof n) return;

            if (n !== i.getSession().context.uid) {
              var p = i.memberJoinStateLru.get(n);
              if (p === MemberJoinState.JOINED && "MemberJoined" === s) return void i.log("received duplicated %s state (seq: %s), channel '%s', member '%s'", s, l, i.channelId, n);
              if (p === MemberJoinState.LEFT && "MemberLeft" === s) return void i.log("received duplicated %s state (seq: %s), channel '%s', member '%s'", s, l, i.channelId, n);
            }

            i.memberJoinStateLru.set(n, "MemberJoined" === s ? MemberJoinState.JOINED : MemberJoinState.LEFT);
          }

          i.info("Channel %s - %s, memberId: %s", s, i.channelId, "MemberCountUpdated" === s ? "[unknown]" : n);
          var f = n === i.getSession().context.uid;
          "MemberLeft" === s && isValidId(n) ? (f || i.emit(s, n), i.onMemberCountUpdated(a)) : "MemberJoined" === s && isValidId(n) ? (f || i.emit(s, n), i.onMemberCountUpdated(a)) : "MemberCountUpdated" === s && "number" == typeof a && i.onMemberCountUpdated(a);
        }
      }, i.getSession = genGetSession(r), i.info("A channel created, id %s", e), i;
    }

    return _inherits$f(t, createEventBase()), _createClass$d(t, [{
      key: "join",
      value: function () {
        var e = _asyncToGenerator$c(regenerator.mark(function e() {
          var t, r, n, o, i, s, a, u, l, c, p, f, d;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (isValidId(this.channelId)) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidArgumentError([invalidArgumentMessage, "channelId"], JOIN_CHANNEL_ERR_INVALID_ARGUMENT);

                case 2:
                  e.prev = 2, t = this.getSession(), e.next = 9;
                  break;

                case 6:
                  throw e.prev = 6, e.t0 = e.catch(2), new RtmInvalidStatusError("The client is not logged in. Cannot do the operation", JOIN_CHANNEL_ERR_USER_NOT_LOGGED_IN);

                case 9:
                  if (!t.joinedChannels.has(this)) {
                    e.next = 12;
                    break;
                  }

                  throw sendReport("ChnJoin", {
                    cname: this.channelId,
                    lts: long_1.fromNumber(Date.now()),
                    userId: t.context.uid,
                    elapse: getElapse(t.startTime),
                    errCode: JOIN_CHANNEL_ERR_ALREADY_JOINED,
                    sid: getSid(t.instanceId)
                  }, null === (r = t.context.areaConfig) || void 0 === r ? void 0 : r.EVENT_REPORT_DOMAIN[0], null === (n = t.context.areaConfig) || void 0 === n ? void 0 : n.EVENT_REPORT_BACKUP_DOMAIN[0]), new RtmInvalidStatusError("The channel has joined. Cannot rejoin", JOIN_CHANNEL_ERR_ALREADY_JOINED);

                case 12:
                  if (e.prev = 12, this.log("Joining the channel %s", this.channelId), !this.hasOtherChannelJoined()) {
                    e.next = 17;
                    break;
                  }

                  throw sendReport("ChnJoin", {
                    cname: this.channelId,
                    lts: long_1.fromNumber(Date.now()),
                    userId: t.context.uid,
                    elapse: getElapse(t.startTime),
                    errCode: JOIN_CHANNEL_ERR_ALREADY_JOINED_CHANNEL_OF_SAME_ID,
                    sid: getSid(t.instanceId)
                  }, null === (u = t.context.areaConfig) || void 0 === u ? void 0 : u.EVENT_REPORT_DOMAIN[0], null === (l = t.context.areaConfig) || void 0 === l ? void 0 : l.EVENT_REPORT_BACKUP_DOMAIN[0]), new RtmInvalidStatusError("A channel of the same channel ID has already joined. Cannot rejoin", JOIN_CHANNEL_ERR_ALREADY_JOINED_CHANNEL_OF_SAME_ID);

                case 17:
                  if (t.joinedChannels.size !== MAX_JOINED_CHANNELS) {
                    e.next = 20;
                    break;
                  }

                  throw sendReport("ChnJoin", {
                    cname: this.channelId,
                    lts: long_1.fromNumber(Date.now()),
                    userId: t.context.uid,
                    elapse: getElapse(t.startTime),
                    errCode: JOIN_CHANNEL_ERR_EXCEED_LIMIT,
                    sid: getSid(t.instanceId)
                  }, null === (c = t.context.areaConfig) || void 0 === c ? void 0 : c.EVENT_REPORT_DOMAIN[0], null === (p = t.context.areaConfig) || void 0 === p ? void 0 : p.EVENT_REPORT_BACKUP_DOMAIN[0]), new RtmLimitExceededError("The joined channels has exceeded the limit of 20", JOIN_CHANNEL_ERR_EXCEED_LIMIT);

                case 20:
                  return sendReport("ChnJoin", {
                    cname: this.channelId,
                    lts: long_1.fromNumber(Date.now()),
                    userId: t.context.uid,
                    elapse: getElapse(t.startTime),
                    errCode: 0,
                    sid: getSid(t.instanceId)
                  }, null === (o = t.context.areaConfig) || void 0 === o ? void 0 : o.EVENT_REPORT_DOMAIN[0], null === (i = t.context.areaConfig) || void 0 === i ? void 0 : i.EVENT_REPORT_BACKUP_DOMAIN[0]), e.next = 23, t.requestChannelJoin(this, this.channelId);

                case 23:
                  sendReport("ChnJoinRes", {
                    cname: this.channelId,
                    lts: long_1.fromNumber(Date.now()),
                    elapse: getElapse(t.startTime),
                    errCode: 0,
                    sid: getSid(t.instanceId),
                    serverErrCode: 0,
                    userId: t.context.uid
                  }, null === (s = t.context.areaConfig) || void 0 === s ? void 0 : s.EVENT_REPORT_DOMAIN[0], null === (a = t.context.areaConfig) || void 0 === a ? void 0 : a.EVENT_REPORT_BACKUP_DOMAIN[0]), this.info("The channel %s joined successfully", this.channelId), t.on("channelTextMessage", this.onChannelTextMessage), t.on("channelRawMessage", this.onChannelRawMessage), t.on("channelMediaMessage", this.onChannelMediaMessage), t.on("memberNotice", this.onMemberNotice), t.on("channelAttributesUpdated", this.onAttributesUpdated), e.next = 41;
                  break;

                case 32:
                  if (e.prev = 32, e.t1 = e.catch(12), this.logError(e.t1), !isRtmError(e.t1)) {
                    e.next = 37;
                    break;
                  }

                  throw e.t1;

                case 37:
                  if (!isTimeout(e.t1)) {
                    e.next = 40;
                    break;
                  }

                  throw sendReport("ChnJoinRes", {
                    cname: this.channelId,
                    lts: long_1.fromNumber(Date.now()),
                    elapse: getElapse(t.startTime),
                    errCode: JOIN_CHANNEL_TIMEOUT,
                    sid: getSid(t.instanceId),
                    serverErrCode: 0,
                    userId: t.context.uid
                  }, null === (f = t.context.areaConfig) || void 0 === f ? void 0 : f.EVENT_REPORT_DOMAIN[0], null === (d = t.context.areaConfig) || void 0 === d ? void 0 : d.EVENT_REPORT_BACKUP_DOMAIN[0]), new RtmTimeoutError(["Join channel %s timed out", this.channelId], JOIN_CHANNEL_TIMEOUT);

                case 40:
                  throw new RtmUnknownError(["The channel %s join failure", this.channelId], {
                    code: JOIN_CHANNEL_ERR_FAILURE,
                    originalError: e.t1
                  });

                case 41:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[2, 6], [12, 32]]);
        }));

        return function () {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "leave",
      value: function () {
        var e = _asyncToGenerator$c(regenerator.mark(function e() {
          var t, r, n, o, i, s, a;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  e.prev = 0, n = this.getSession(), e.next = 7;
                  break;

                case 4:
                  throw e.prev = 4, e.t0 = e.catch(0), new RtmInvalidStatusError("The client is not logged in. Cannot do the operation", LEAVE_CHANNEL_ERR_USER_NOT_LOGGED_IN);

                case 7:
                  if (n.joinedChannels.has(this)) {
                    e.next = 9;
                    break;
                  }

                  throw new RtmInvalidStatusError("The channel does not join. Cannot do the operation", LEAVE_CHANNEL_ERR_NOT_IN_CHANNEL);

                case 9:
                  e.prev = 9, n.requestChannelLeave(this, this.channelId), this.memberLeftLru.empty(), this.memberJoinedLru.empty(), this.attributesSeqLru.empty(), this.memberJoinStateLru.empty(), this.memberCount = 0, n.removeListener("channelTextMessage", this.onChannelTextMessage), n.removeListener("channelRawMessage", this.onChannelRawMessage), n.removeListener("channelMediaMessage", this.onChannelMediaMessage), n.removeListener("memberNotice", this.onMemberNotice), n.removeListener("channelAttributesUpdated", this.onAttributesUpdated), e.next = 32;
                  break;

                case 23:
                  if (e.prev = 23, e.t1 = e.catch(9), this.logError(e.t1), !isRtmError(e.t1)) {
                    e.next = 30;
                    break;
                  }

                  throw void 0 === e.t1.code && (e.t1.code = LEAVE_CHANNEL_ERR_REJECTED), sendReport("ChnLeave", {
                    cname: this.channelId,
                    lts: long_1.fromNumber(Date.now()),
                    elapse: getElapse(n.startTime),
                    errCode: LEAVE_CHANNEL_ERR_REJECTED,
                    sid: getSid(n.instanceId),
                    userId: n.context.uid
                  }, null === (s = n.context.areaConfig) || void 0 === s ? void 0 : s.EVENT_REPORT_DOMAIN[0], null === (a = n.context.areaConfig) || void 0 === a ? void 0 : a.EVENT_REPORT_BACKUP_DOMAIN[0]), e.t1;

                case 30:
                  throw sendReport("ChnLeave", {
                    cname: this.channelId,
                    lts: long_1.fromNumber(Date.now()),
                    elapse: getElapse(n.startTime),
                    errCode: LEAVE_CHANNEL_ERR_FAILURE,
                    sid: getSid(n.instanceId),
                    userId: n.context.uid
                  }, null === (o = n.context.areaConfig) || void 0 === o ? void 0 : o.EVENT_REPORT_DOMAIN[0], null === (i = n.context.areaConfig) || void 0 === i ? void 0 : i.EVENT_REPORT_BACKUP_DOMAIN[0]), new RtmUnknownError("The channel leave failure", {
                    code: LEAVE_CHANNEL_ERR_FAILURE,
                    originalError: e.t1
                  });

                case 32:
                  sendReport("ChnLeave", {
                    cname: this.channelId,
                    lts: long_1.fromNumber(Date.now()),
                    elapse: getElapse(n.startTime),
                    errCode: 0,
                    sid: getSid(n.instanceId),
                    userId: n.context.uid
                  }, null === (t = n.context.areaConfig) || void 0 === t ? void 0 : t.EVENT_REPORT_DOMAIN[0], null === (r = n.context.areaConfig) || void 0 === r ? void 0 : r.EVENT_REPORT_BACKUP_DOMAIN[0]);

                case 33:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[0, 4], [9, 23]]);
        }));

        return function () {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "sendMessage",
      value: function () {
        var e = _asyncToGenerator$c(regenerator.mark(function e(t) {
          var r,
              n,
              o,
              i,
              s,
              a = this,
              u = arguments;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  r = u.length > 1 && void 0 !== u[1] ? u[1] : {}, n = r.enableHistoricalMessaging, o = void 0 !== n && n, validMessage(t, CHANNEL_MESSAGE_ERR_INVALID_MESSAGE), e.prev = 2, i = this.getSession(), e.next = 9;
                  break;

                case 6:
                  throw e.prev = 6, e.t0 = e.catch(2), new RtmInvalidStatusError("The client is not logged in. Cannot do the operation", CHANNEL_MESSAGE_ERR_USER_NOT_LOGGED_IN);

                case 9:
                  if (i.joinedChannels.has(this)) {
                    e.next = 11;
                    break;
                  }

                  throw new RtmInvalidStatusError("The channel does not join. Cannot do the operation", CHANNEL_MESSAGE_ERR_USER_NOT_LOGGED_IN);

                case 11:
                  if (this.client.connectionState !== ConnectionState.RECONNECTING) {
                    e.next = 16;
                    break;
                  }

                  return s = Date.now(), e.next = 15, new Promise(function (e, r) {
                    var n,
                        i = function () {
                      var i = _asyncToGenerator$c(regenerator.mark(function i() {
                        var u;
                        return regenerator.wrap(function (i) {
                          for (;;) {
                            switch (i.prev = i.next) {
                              case 0:
                                return u = Date.now() - s, i.prev = 1, i.next = 4, commonSendMessage({
                                  message: t,
                                  peerId: a.channelId,
                                  toPeer: !1,
                                  session: a.getSession(),
                                  errorCodes: {
                                    NOT_LOGGED_IN: CHANNEL_MESSAGE_ERR_USER_NOT_LOGGED_IN,
                                    TOO_OFTEN: CHANNEL_MESSAGE_ERR_TOO_OFTEN
                                  },
                                  diff: u,
                                  logger: a.logger,
                                  options: {
                                    enableHistoricalMessaging: o,
                                    enableOfflineMessaging: !1
                                  }
                                });

                              case 4:
                                e(), i.next = 12;
                                break;

                              case 7:
                                i.prev = 7, i.t0 = i.catch(1), isTimeout(i.t0) && r(new RtmTimeoutError(genTimeoutMessage(a.name, "sendMessageToPeer", MESSAGE_SEND_TIMEOUT), CHANNEL_MESSAGE_ERR_TIMEOUT)), isRtmError(i.t0) && r(i.t0), r(new RtmUnavailableError("Channel message send failure", {
                                  code: CHANNEL_MESSAGE_ERR_FAILURE,
                                  originalError: i.t0
                                }));

                              case 12:
                                return i.prev = 12, clearTimeout(n), i.finish(12);

                              case 15:
                              case "end":
                                return i.stop();
                            }
                          }
                        }, i, null, [[1, 7, 12, 15]]);
                      }));

                      return function () {
                        return i.apply(this, arguments);
                      };
                    }();

                    a.client.internalEmitter.once("RECONNECTED", i), n = setTimeout(function () {
                      a.client.internalEmitter.off("RECONNECTED", i), r(new RtmTimeoutError(genTimeoutMessage(a.name, "sendMessageToPeer", MESSAGE_SEND_TIMEOUT), CHANNEL_MESSAGE_ERR_TIMEOUT));
                    }, 9e3);
                  });

                case 15:
                  return e.abrupt("return");

                case 16:
                  if (this.client.connectionState === ConnectionState.CONNECTED) {
                    e.next = 18;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in. Cannot do the operation", CHANNEL_MESSAGE_ERR_USER_NOT_LOGGED_IN);

                case 18:
                  return e.prev = 18, e.next = 21, commonSendMessage({
                    message: t,
                    peerId: this.channelId,
                    toPeer: !1,
                    session: this.getSession(),
                    errorCodes: {
                      NOT_LOGGED_IN: CHANNEL_MESSAGE_ERR_USER_NOT_LOGGED_IN,
                      TOO_OFTEN: CHANNEL_MESSAGE_ERR_TOO_OFTEN
                    },
                    diff: 0,
                    logger: this.logger,
                    options: {
                      enableHistoricalMessaging: o,
                      enableOfflineMessaging: !1
                    }
                  });

                case 21:
                  e.next = 31;
                  break;

                case 23:
                  if (e.prev = 23, e.t1 = e.catch(18), !isTimeout(e.t1)) {
                    e.next = 27;
                    break;
                  }

                  throw new RtmTimeoutError(genTimeoutMessage(this.name, "sendMessage", MESSAGE_SEND_TIMEOUT), CHANNEL_MESSAGE_ERR_TIMEOUT);

                case 27:
                  if (!isRtmError(e.t1)) {
                    e.next = 30;
                    break;
                  }

                  throw this.logError(e.t1), e.t1;

                case 30:
                  throw new RtmUnknownError("The channel message send failure", CHANNEL_MESSAGE_ERR_FAILURE);

                case 31:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[2, 6], [18, 23]]);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "getMembers",
      value: function () {
        var e = _asyncToGenerator$c(regenerator.mark(function e() {
          var t, r, n;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  e.prev = 0, e.prev = 1, t = this.getSession(), e.next = 8;
                  break;

                case 5:
                  throw e.prev = 5, e.t0 = e.catch(1), new RtmInvalidStatusError("The client is not logged in. Cannot do the operation", GET_MEMBERS_ERR_USER_NOT_LOGGED_IN);

                case 8:
                  if (t.joinedChannels.has(this)) {
                    e.next = 10;
                    break;
                  }

                  throw new RtmInvalidStatusError("The channel does not join. Cannot do the operation", GET_MEMBERS_ERR_NOT_IN_CHANNEL);

                case 10:
                  return r = this.getSession().requestChannelMemberList(this.channelId), e.next = 13, r.pipe(map$1(function (e) {
                    return e.memberInfos.map(function (e) {
                      return e.account;
                    });
                  })).toPromise();

                case 13:
                  return n = e.sent, this.info("Channel %s - get members success, %o", this.channelId, n), e.abrupt("return", n);

                case 18:
                  if (e.prev = 18, e.t1 = e.catch(0), !isRtmError(e.t1)) {
                    e.next = 23;
                    break;
                  }

                  throw this.logError(e.t1), e.t1;

                case 23:
                  throw new RtmUnknownError("The channel members get failure", GET_MEMBERS_ERR_FAILURE);

                case 24:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[0, 18], [1, 5]]);
        }));

        return function () {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "hasOtherChannelJoined",
      value: function value() {
        var e = this;
        return !this.getSession().joinedChannels.has(this) && _toConsumableArray$c(this.getSession().joinedChannels).some(function (t) {
          return t.channelId === e.channelId;
        });
      }
    }]), t;
  }(), _class = _temp, _applyDecoratedDescriptor(_class.prototype, "join", [logged], Object.getOwnPropertyDescriptor(_class.prototype, "join"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "leave", [logged], Object.getOwnPropertyDescriptor(_class.prototype, "leave"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sendMessage", [logged], Object.getOwnPropertyDescriptor(_class.prototype, "sendMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getMembers", [logged], Object.getOwnPropertyDescriptor(_class.prototype, "getMembers"), _class.prototype), _class),
      _class$1,
      _temp$1;

  function _typeof$h(e) {
    return (_typeof$h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function _slicedToArray$b(e, t) {
    return _arrayWithHoles$b(e) || _iterableToArrayLimit$b(e, t) || _nonIterableRest$b();
  }

  function _nonIterableRest$b() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  function _iterableToArrayLimit$b(e, t) {
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var s, a = e[Symbol.iterator](); !(n = (s = a.next()).done) && (r.push(s.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == a.return || a.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }

  function _arrayWithHoles$b(e) {
    if (Array.isArray(e)) return e;
  }

  function ownKeys$5(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function _objectSpread$4(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ownKeys$5(r, !0).forEach(function (t) {
        _defineProperty$6(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys$5(r).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function _defineProperty$6(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function asyncGeneratorStep$d(e, t, r, n, o, i, s) {
    try {
      var a = e[i](s),
          u = a.value;
    } catch (e) {
      return void r(e);
    }

    a.done ? t(u) : Promise.resolve(u).then(n, o);
  }

  function _asyncToGenerator$d(e) {
    return function () {
      var t = this,
          r = arguments;
      return new Promise(function (n, o) {
        var i = e.apply(t, r);

        function s(e) {
          asyncGeneratorStep$d(i, n, o, s, a, "next", e);
        }

        function a(e) {
          asyncGeneratorStep$d(i, n, o, s, a, "throw", e);
        }

        s(void 0);
      });
    };
  }

  function _classCallCheck$i(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties$e(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function _createClass$e(e, t, r) {
    return t && _defineProperties$e(e.prototype, t), r && _defineProperties$e(e, r), e;
  }

  function _possibleConstructorReturn$g(e, t) {
    return !t || "object" !== _typeof$h(t) && "function" != typeof t ? _assertThisInitialized$g(e) : t;
  }

  function _getPrototypeOf$g(e) {
    return (_getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function _assertThisInitialized$g(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _inherits$g(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && _setPrototypeOf$g(e, t);
  }

  function _setPrototypeOf$g(e, t) {
    return (_setPrototypeOf$g = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function _applyDecoratedDescriptor$1(e, t, r, n, o) {
    var i = {};
    return Object.keys(n).forEach(function (e) {
      i[e] = n[e];
    }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
      return n(e, t, r) || r;
    }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
  }

  var ConnectionChangeReason = RtmStatusCode$1.ConnectionChangeReason,
      ConnectionState$1 = RtmStatusCode$1.ConnectionState,
      connectionStateCodeMap = {
    DISCONNECTED: 1,
    CONNECTING: 2,
    CONNECTED: 3,
    RECONNECTING: 4,
    ABORTED: 5
  },
      connectionStateChangeReason = {
    LOGIN: 1,
    LOGIN_SUCCESS: 2,
    LOGIN_FAILURE: 3,
    LOGIN_TIMEOUT: 4,
    INTERRUPTED: 5,
    LOGOUT: 6,
    BANNED_BY_SERVER: 7,
    REMOTE_LOGIN: 8
  },
      Client = (_temp$1 = function (e) {
    function t(e, r, n, o, i) {
      var s;
      return _classCallCheck$i(this, t), (s = _possibleConstructorReturn$g(this, _getPrototypeOf$g(t).call(this, r, "RtmClient", !0))).parameters = n, s.setParameters = o, s.connectionState = ConnectionState$1.DISCONNECTED, s.internalEmitter = new events(), s.context = void 0, s.attributes = {}, s.loginPromise = void 0, s.attributeDrafts = new Set(), s.session = void 0, s.lastLoginTime = void 0, s.reconnId = 0, s.channelAttributesCacheLru = new LRUCache(void 0, {
        maxlen: CHANNEL_ATTRIBUTES_CACHE_MAX_LENGTH
      }), s.invitationManager = new InvitationManager(function () {
        return s.session;
      }, s.logger), s.subscribedPeerStatusCache = {}, s.peerStatusSeqLru = new LRUCache(void 0, {
        maxlen: LRU_MAX_ITEMS
      }), s.peerUnreachableTimers = {}, s.mediaTaskManager = void 0, s.userDropHandler = function (e) {
        if (s.connectionState !== ConnectionState$1.ABORTED) switch (e) {
          case 11:
            return s.logError("Kicked off by remote session"), void s.onConnectionStateChanged(ConnectionState$1.ABORTED, ConnectionChangeReason.REMOTE_LOGIN);

          case 14:
          case 15:
          case 16:
            return s.logError("Server banned because of illegal ".concat({
              14: "User ID",
              15: "IP",
              16: "Channel Name"
            }[e])), void s.onConnectionStateChanged(ConnectionState$1.ABORTED, ConnectionChangeReason.BANNED_BY_SERVER);

          default:
            s.logError("User kicked off for unknown code: ".concat(e)), s.onConnectionStateChanged(ConnectionState$1.ABORTED, ConnectionChangeReason.INTERRUPTED);
        }
      }, s.context = new Context(e, r), s.mediaTaskManager = new MediaTaskManager(r), s.setParameters = o.bind(_assertThisInitialized$g(s)), void 0 !== i && s.context.setAreaConfig(i), s.invitationManager.on("remoteInvitationInstance", function (e) {
        s.emit("RemoteInvitationReceived", e);
      }), s;
    }

    return _inherits$g(t, createEventBase()), _createClass$e(t, [{
      key: "renewToken",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r,
              n,
              o,
              i = this;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if ("string" == typeof t && 0 !== t.length) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidArgumentError("Invalid argument", RENEW_TOKEN_ERR_INVALID_ARGUMENT);

                case 2:
                  if ("string" != typeof t) {
                    e.next = 5;
                    break;
                  }

                  if (!(t.length < APP_ID_LENGTH || t.slice(3, APP_ID_LENGTH + 3) !== this.context.appId)) {
                    e.next = 5;
                    break;
                  }

                  throw new RtmInvalidArgumentError("Invalid token", RENEW_TOKEN_ERR_INVALID_TOKEN);

                case 5:
                  if (this.connectionState !== ConnectionState$1.ABORTED) {
                    e.next = 8;
                    break;
                  }

                  return e.next = 8, new Promise(function () {});

                case 8:
                  if (this.connectionState === ConnectionState$1.CONNECTED || this.connectionState === ConnectionState$1.RECONNECTING) {
                    e.next = 10;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", RENEW_TOKEN_ERR_USER_NOT_LOGGED_IN);

                case 10:
                  if (void 0 !== this.session) {
                    e.next = 12;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 12:
                  return e.prev = 12, r = this.context.token, this.context.token = t, e.next = 17, this.session.connection.apClient.apEdgeInfo$.pipe(throwIfEmpty(function () {
                    return new Error("No available edge address to connect");
                  }), retryWhen(function (e) {
                    return e.pipe(tap(function (e) {
                      if (isRtmError(e)) throw e;
                    }), delay(1500), take(4));
                  }), take(1), timeout(1e4), catchError(function (e) {
                    return isTimeout(e) && i.warn("renewToken timed out"), throwError(e);
                  })).toPromise();

                case 17:
                  n = e.sent, o = n.ticket, e.next = 30;
                  break;

                case 21:
                  if (e.prev = 21, e.t0 = e.catch(12), this.context.token = r, e.t0.code !== LOGIN_ERR_INVALID_APP_ID && e.t0.code !== LOGIN_ERR_INVALID_TOKEN) {
                    e.next = 26;
                    break;
                  }

                  throw new RtmUnauthenticatedError("Invalid token", RENEW_TOKEN_ERR_INVALID_TOKEN);

                case 26:
                  if (e.t0.code !== LOGIN_ERR_TOKEN_EXPIRED) {
                    e.next = 28;
                    break;
                  }

                  throw new RtmUnauthenticatedError("The token expired", RENEW_TOKEN_ERR_TOKEN_EXPIRED);

                case 28:
                  if (!isTimeout(e.t0)) {
                    e.next = 30;
                    break;
                  }

                  throw new RtmTimeoutError("Renew token timed out", RENEW_TOKEN_ERR_FAILURE);

                case 30:
                  this.session.curLoginSockets.filter(function (e) {
                    return void 0 !== e;
                  }).forEach(function (e) {
                    return e.ticket = o;
                  });

                case 31:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[12, 21]]);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "queryPeersOnlineStatus",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r,
              n,
              o = this;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", QUERY_PEERS_ONLINE_STATUS_ERR_USER_NOT_LOGGED_IN);

                case 2:
                  if (void 0 !== this.session) {
                    e.next = 4;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 4:
                  if (!(!Array.isArray(t) || 0 === t.length || t.some(function (e) {
                    return !isValidId(e);
                  }) || t.length > 256)) {
                    e.next = 6;
                    break;
                  }

                  throw new RtmInvalidArgumentError("invalid arguments", QUERY_PEERS_ONLINE_STATUS_ERR_INVALID_ARGUMENT);

                case 6:
                  return e.next = 8, this.session.requestPeersOnlineStatus(t).toPromise();

                case 8:
                  return r = e.sent, n = mapValues_1(keyBy_1(r.userInfos, "account"), function (e) {
                    var t = e.ts;
                    return Boolean(t);
                  }), Object.keys(n).forEach(function (e) {
                    if (e in o.subscribedPeerStatusCache && o.subscribedPeerStatusCache[e] !== RtmStatusCode$1.PeerOnlineState.UNREACHABLE) {
                      var t = n[e] ? RtmStatusCode$1.PeerOnlineState.ONLINE : RtmStatusCode$1.PeerOnlineState.OFFLINE;
                      o.emit("PeersOnlineStatusChanged", _defineProperty$6({}, e, t)), o.subscribedPeerStatusCache[e] = t;
                    }
                  }), e.abrupt("return", n);

                case 12:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "getChannelMemberCount",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r,
              n,
              o,
              i,
              s,
              a,
              u,
              l,
              c,
              p,
              f,
              d,
              g,
              h = this;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", GET_CHANNEL_MEMBER_COUNT_ERR_USER_NOT_LOGGED_IN);

                case 2:
                  if (void 0 !== this.session) {
                    e.next = 4;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 4:
                  if (Array.isArray(t) && t.every(function (e) {
                    return "string" == typeof e;
                  }) && 0 !== t.length) {
                    e.next = 6;
                    break;
                  }

                  throw new RtmInvalidArgumentError("Invalid arguments: channelIds", GET_CHANNEL_MEMBER_COUNT_ERR_INVALID_ARGUMENT);

                case 6:
                  if (!(t.length > 32)) {
                    e.next = 8;
                    break;
                  }

                  throw new RtmInvalidArgumentError("getChannelMemberCount exceed limit of 32 channelIds", GET_CHANNEL_MEMBER_COUNT_ERR_EXCEED_LIMIT);

                case 8:
                  r = t, n = Array.isArray(r), o = 0, r = n ? r : r[Symbol.iterator]();

                case 9:
                  if (!n) {
                    e.next = 15;
                    break;
                  }

                  if (!(o >= r.length)) {
                    e.next = 12;
                    break;
                  }

                  return e.abrupt("break", 24);

                case 12:
                  i = r[o++], e.next = 19;
                  break;

                case 15:
                  if (!(o = r.next()).done) {
                    e.next = 18;
                    break;
                  }

                  return e.abrupt("break", 24);

                case 18:
                  i = o.value;

                case 19:
                  if (isValidId(s = i)) {
                    e.next = 22;
                    break;
                  }

                  throw new RtmInvalidArgumentError(["getChannelMemberCount channel id %s is invalid", s], GET_CHANNEL_MEMBER_COUNT_ERR_INVALID_ARGUMENT);

                case 22:
                  e.next = 9;
                  break;

                case 24:
                  return e.next = 26, this.session.requestGetChannelMemberCount(t).toPromise();

                case 26:
                  a = e.sent, u = a.groupInfos, l = {}, c = function c() {
                    if (f) {
                      if (d >= p.length) return "break";
                      g = p[d++];
                    } else {
                      if ((d = p.next()).done) return "break";
                      g = d.value;
                    }

                    var e = g,
                        t = e.group,
                        r = e.memberCount;
                    isValidId(t) && "number" == typeof r && (h.session.joinedChannels.forEach(function (e) {
                      e.channelId === t && e.onMemberCountUpdated(r);
                    }), l[t] = r);
                  }, p = u, f = Array.isArray(p), d = 0, p = f ? p : p[Symbol.iterator]();

                case 31:
                  if ("break" !== c()) {
                    e.next = 34;
                    break;
                  }

                  return e.abrupt("break", 36);

                case 34:
                  e.next = 31;
                  break;

                case 36:
                  return e.abrupt("return", l);

                case 37:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "setLocalUserAttributes",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r, n;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (validAttributes({
                    attributes: t,
                    maxAttrValueSize: 8192,
                    maxAttrsCount: 32,
                    maxTotalSize: 16384
                  }), this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 3;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN);

                case 3:
                  if (void 0 !== this.session) {
                    e.next = 5;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 5:
                  return r = this.session.requestSetLocalUserAttributes(t).toPromise(), n = {
                    attribute: t,
                    promise: r
                  }, this.attributeDrafts.add(n), e.prev = 8, e.next = 11, r;

                case 11:
                  this.attributes = t, e.next = 19;
                  break;

                case 14:
                  if (e.prev = 14, e.t0 = e.catch(8), !isRtmError(e.t0)) {
                    e.next = 18;
                    break;
                  }

                  throw e.t0;

                case 18:
                  throw new RtmInvalidArgumentError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 19:
                  return e.prev = 19, this.attributeDrafts.delete(n), e.finish(19);

                case 22:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[8, 14, 19, 22]]);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "setChannelAttributes",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t, r) {
          var n,
              o,
              i,
              s,
              a,
              u = arguments;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = u.length > 2 && void 0 !== u[2] ? u[2] : {}, o = n.enableNotificationToChannelMembers, i = void 0 !== o && o, validAttributes({
                    attributes: r,
                    maxAttrValueSize: 8192,
                    maxAttrsCount: 32,
                    maxTotalSize: 32768
                  }), this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 4;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN);

                case 4:
                  if (void 0 !== this.session) {
                    e.next = 6;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 6:
                  return s = this.session.requestSetChannelAttributes(t, r, i).toPromise(), e.prev = 7, e.next = 10, s;

                case 10:
                  a = mapValues_1(r, function (e) {
                    return new Blob([e]).size;
                  }), this.channelAttributesCacheLru.set(t, a), e.next = 19;
                  break;

                case 14:
                  if (e.prev = 14, e.t0 = e.catch(7), !isRtmError(e.t0)) {
                    e.next = 18;
                    break;
                  }

                  throw e.t0;

                case 18:
                  throw new RtmInvalidArgumentError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 19:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[7, 14]]);
        }));

        return function (t, r) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "addOrUpdateLocalUserAttributes",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r, n, o;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (r = _objectSpread$4({}, this.attributes, {}, t), validAttributes({
                    attributes: t,
                    maxAttrValueSize: 8192,
                    maxAttrsCount: 32,
                    maxTotalSize: 16384
                  }), validAttributes({
                    attributes: r,
                    maxAttrValueSize: 8192,
                    maxAttrsCount: 32,
                    maxTotalSize: 16384
                  }), this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 5;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN);

                case 5:
                  if (void 0 !== this.session) {
                    e.next = 7;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 7:
                  return n = this.session.requestAddOrUpdateLocalUserAttributes(t).toPromise(), o = {
                    attribute: r,
                    promise: n
                  }, this.attributeDrafts.add(o), e.prev = 10, e.next = 13, n;

                case 13:
                  this.attributes = r, e.next = 21;
                  break;

                case 16:
                  if (e.prev = 16, e.t0 = e.catch(10), !isRtmError(e.t0)) {
                    e.next = 20;
                    break;
                  }

                  throw e.t0;

                case 20:
                  throw new RtmInvalidArgumentError("arguments is not valid", QUERY_PEERS_ONLINE_STATUS_ERR_INVALID_ARGUMENT);

                case 21:
                  return e.prev = 21, this.attributeDrafts.delete(o), e.finish(21);

                case 24:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[10, 16, 21, 24]]);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "addOrUpdateChannelAttributes",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t, r) {
          var n,
              o,
              i,
              s,
              a,
              u,
              l,
              c = arguments;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = c.length > 2 && void 0 !== c[2] ? c[2] : {}, o = n.enableNotificationToChannelMembers, i = void 0 !== o && o, s = this.channelAttributesCacheLru.get(t, {}), a = mapValues_1(r, function (e) {
                    return new Blob([e]).size;
                  }), u = _objectSpread$4({}, s, {}, a), validAttributes({
                    attributes: r,
                    attrSizeMap: u,
                    maxAttrValueSize: 8192,
                    maxAttrsCount: 32,
                    maxTotalSize: 32768
                  }), this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 7;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN);

                case 7:
                  if (void 0 !== this.session) {
                    e.next = 9;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 9:
                  return l = this.session.requestAddOrUpdateChannelAttributes(t, r, i).toPromise(), e.prev = 10, e.next = 13, l;

                case 13:
                  this.channelAttributesCacheLru.set(t, u), e.next = 21;
                  break;

                case 16:
                  if (e.prev = 16, e.t0 = e.catch(10), !isRtmError(e.t0)) {
                    e.next = 20;
                    break;
                  }

                  throw e.t0;

                case 20:
                  throw new RtmInvalidArgumentError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 21:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[10, 16]]);
        }));

        return function (t, r) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "deleteLocalUserAttributesByKeys",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r, n, o, i, s, a, u;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (Array.isArray(t) && 0 !== t.length && !t.some(function (e) {
                    return 0 === e.length;
                  })) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidStatusError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 2:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 4;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN);

                case 4:
                  if (void 0 !== this.session) {
                    e.next = 6;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 6:
                  return r = this.session.requestDeleteLocalUserAttributesByKeys(t).toPromise(), n = {
                    attribute: omit_1(this.attributes, t),
                    promise: r
                  }, this.attributeDrafts.add(n), e.prev = 9, e.next = 12, r;

                case 12:
                  o = t, i = Array.isArray(o), s = 0, o = i ? o : o[Symbol.iterator]();

                case 13:
                  if (!i) {
                    e.next = 19;
                    break;
                  }

                  if (!(s >= o.length)) {
                    e.next = 16;
                    break;
                  }

                  return e.abrupt("break", 27);

                case 16:
                  a = o[s++], e.next = 23;
                  break;

                case 19:
                  if (!(s = o.next()).done) {
                    e.next = 22;
                    break;
                  }

                  return e.abrupt("break", 27);

                case 22:
                  a = s.value;

                case 23:
                  u = a, delete this.attributes[u];

                case 25:
                  e.next = 13;
                  break;

                case 27:
                  e.next = 34;
                  break;

                case 29:
                  if (e.prev = 29, e.t0 = e.catch(9), !isRtmError(e.t0)) {
                    e.next = 33;
                    break;
                  }

                  throw e.t0;

                case 33:
                  throw new RtmInvalidArgumentError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 34:
                  return e.prev = 34, this.attributeDrafts.delete(n), e.finish(34);

                case 37:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[9, 29, 34, 37]]);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "deleteChannelAttributesByKeys",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t, r) {
          var n,
              o,
              i,
              s,
              a,
              u,
              l,
              c,
              p,
              f = arguments;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = f.length > 2 && void 0 !== f[2] ? f[2] : {}, o = n.enableNotificationToChannelMembers, i = void 0 !== o && o, Array.isArray(r) && 0 !== r.length && isValidId(t) && !r.some(function (e) {
                    return 0 === e.length || e.length > CHANNEL_ATTRIBUTES_MAX_KEY_COUNT;
                  })) {
                    e.next = 3;
                    break;
                  }

                  throw new RtmInvalidStatusError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 3:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 5;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN);

                case 5:
                  if (void 0 !== this.session) {
                    e.next = 7;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 7:
                  return s = this.session.requestDeleteChannelAttributesByKeys(t, r, i).toPromise(), e.prev = 8, e.next = 11, s;

                case 11:
                  if (!(a = this.channelAttributesCacheLru.get(t))) {
                    e.next = 28;
                    break;
                  }

                  u = r, l = Array.isArray(u), c = 0, u = l ? u : u[Symbol.iterator]();

                case 14:
                  if (!l) {
                    e.next = 20;
                    break;
                  }

                  if (!(c >= u.length)) {
                    e.next = 17;
                    break;
                  }

                  return e.abrupt("break", 28);

                case 17:
                  p = u[c++], e.next = 24;
                  break;

                case 20:
                  if (!(c = u.next()).done) {
                    e.next = 23;
                    break;
                  }

                  return e.abrupt("break", 28);

                case 23:
                  p = c.value;

                case 24:
                  delete a[p];

                case 26:
                  e.next = 14;
                  break;

                case 28:
                  e.next = 35;
                  break;

                case 30:
                  if (e.prev = 30, e.t0 = e.catch(8), !isRtmError(e.t0)) {
                    e.next = 34;
                    break;
                  }

                  throw e.t0;

                case 34:
                  throw new RtmInvalidArgumentError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 35:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[8, 30]]);
        }));

        return function (t, r) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "clearLocalUserAttributes",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e() {
          var t, r;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN);

                case 2:
                  if (void 0 !== this.session) {
                    e.next = 4;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 4:
                  return t = this.session.requestClearLocalUserAttributes().toPromise(), r = {
                    attribute: {},
                    promise: t
                  }, this.attributeDrafts.add(r), e.prev = 7, e.next = 10, t;

                case 10:
                  this.attributes = {}, e.next = 18;
                  break;

                case 13:
                  if (e.prev = 13, e.t0 = e.catch(7), !isRtmError(e.t0)) {
                    e.next = 17;
                    break;
                  }

                  throw e.t0;

                case 17:
                  throw new RtmInvalidArgumentError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 18:
                  return e.prev = 18, this.attributeDrafts.delete(r), e.finish(18);

                case 21:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[7, 13, 18, 21]]);
        }));

        return function () {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "clearChannelAttributes",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r,
              n,
              o,
              i,
              s = arguments;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (r = s.length > 1 && void 0 !== s[1] ? s[1] : {}, n = r.enableNotificationToChannelMembers, o = void 0 !== n && n, this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 3;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN);

                case 3:
                  if (void 0 !== this.session) {
                    e.next = 5;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 5:
                  return i = this.session.requestClearChannelAttributes(t, o).toPromise(), e.prev = 6, e.next = 9, i;

                case 9:
                  this.channelAttributesCacheLru.delete(t), e.next = 17;
                  break;

                case 12:
                  if (e.prev = 12, e.t0 = e.catch(6), !isRtmError(e.t0)) {
                    e.next = 16;
                    break;
                  }

                  throw e.t0;

                case 16:
                  throw new RtmInvalidArgumentError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 17:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[6, 12]]);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "getUserAttributes",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r, n, o;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (isValidId(t)) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidArgumentError("Not a valid user ID", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 2:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 4;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN);

                case 4:
                  if (void 0 !== this.session) {
                    e.next = 6;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 6:
                  return e.prev = 6, e.next = 9, this.session.requestGetUserAttributeKeys(t).toPromise();

                case 9:
                  return r = e.sent, n = r.keys, e.next = 13, this.session.requestGetUserAttributesByKeys(t, n.slice(0, CHANNEL_ATTRIBUTES_MAX_KEY_COUNT)).toPromise();

                case 13:
                  o = e.sent, e.next = 21;
                  break;

                case 16:
                  if (e.prev = 16, e.t0 = e.catch(6), !isRtmError(e.t0)) {
                    e.next = 20;
                    break;
                  }

                  throw e.t0;

                case 20:
                  throw new RtmInvalidArgumentError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 21:
                  return e.abrupt("return", fromPairs_1(o.attributeInfos.map(function (e) {
                    return [e.key, e.value];
                  })));

                case 22:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[6, 16]]);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "getChannelAttributes",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r, n, o, i, s, a, u, l, c, p, f, d, g, h;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (isValidId(t)) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidArgumentError("Not a valid channel ID", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 2:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 4;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN);

                case 4:
                  if (void 0 !== this.session) {
                    e.next = 6;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 6:
                  return e.prev = 6, e.next = 9, this.session.requestGetChannelAttributesKeys(t).toPromise();

                case 9:
                  return r = e.sent, n = r.keys, e.next = 13, this.session.requestGetChannelAttributesByKeys(t, n).toPromise();

                case 13:
                  o = e.sent, i = o.attributeMaps, e.next = 22;
                  break;

                case 17:
                  if (e.prev = 17, e.t0 = e.catch(6), !isRtmError(e.t0)) {
                    e.next = 21;
                    break;
                  }

                  throw e.t0;

                case 21:
                  throw new RtmInvalidArgumentError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 22:
                  s = {}, a = i, u = Array.isArray(a), l = 0, a = u ? a : a[Symbol.iterator]();

                case 24:
                  if (!u) {
                    e.next = 30;
                    break;
                  }

                  if (!(l >= a.length)) {
                    e.next = 27;
                    break;
                  }

                  return e.abrupt("break", 40);

                case 27:
                  c = a[l++], e.next = 34;
                  break;

                case 30:
                  if (!(l = a.next()).done) {
                    e.next = 33;
                    break;
                  }

                  return e.abrupt("break", 40);

                case 33:
                  c = l.value;

                case 34:
                  if (f = (p = c).key, d = p.ms, g = p.value, h = p.origin, "string" == typeof f && long_1.isLong(d) && "string" == typeof g && isValidId(h)) {
                    e.next = 37;
                    break;
                  }

                  return e.abrupt("break", 40);

                case 37:
                  s[f] = {
                    value: g,
                    lastUpdateUserId: h,
                    lastUpdateTs: d.toNumber()
                  };

                case 38:
                  e.next = 24;
                  break;

                case 40:
                  return this.channelAttributesCacheLru.set(t, mapValues_1(s, function (e) {
                    var t = e.value;
                    return new Blob([t]).size;
                  })), e.abrupt("return", s);

                case 42:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[6, 17]]);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "getChannelAttributesByKeys",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t, r) {
          var n, o, i, s, a, u, l, c, p, f, d, g, h;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN);

                case 2:
                  if (void 0 !== this.session) {
                    e.next = 4;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 4:
                  return checkValidAttrGetByKeysArgs(t, r), e.prev = 5, e.next = 8, this.session.requestGetChannelAttributesByKeys(t, r).toPromise();

                case 8:
                  n = e.sent, o = n.attributeMaps, e.next = 17;
                  break;

                case 12:
                  if (e.prev = 12, e.t0 = e.catch(5), !isRtmError(e.t0)) {
                    e.next = 16;
                    break;
                  }

                  throw e.t0;

                case 16:
                  throw new RtmInvalidArgumentError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 17:
                  i = {}, s = this.channelAttributesCacheLru.get(t, {}), a = o, u = Array.isArray(a), l = 0, a = u ? a : a[Symbol.iterator]();

                case 20:
                  if (!u) {
                    e.next = 26;
                    break;
                  }

                  if (!(l >= a.length)) {
                    e.next = 23;
                    break;
                  }

                  return e.abrupt("break", 37);

                case 23:
                  c = a[l++], e.next = 30;
                  break;

                case 26:
                  if (!(l = a.next()).done) {
                    e.next = 29;
                    break;
                  }

                  return e.abrupt("break", 37);

                case 29:
                  c = l.value;

                case 30:
                  if (f = (p = c).key, d = p.ms, g = p.value, h = p.origin, "string" == typeof f && long_1.isLong(d) && "string" == typeof g && isValidId(h)) {
                    e.next = 33;
                    break;
                  }

                  return e.abrupt("break", 37);

                case 33:
                  s[f] = new Blob([g]).size, i[f] = {
                    value: g,
                    lastUpdateUserId: h,
                    lastUpdateTs: d.toNumber()
                  };

                case 35:
                  e.next = 20;
                  break;

                case 37:
                  return this.channelAttributesCacheLru.set(t, s), e.abrupt("return", i);

                case 39:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[5, 12]]);
        }));

        return function (t, r) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "getUserAttributesByKeys",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t, r) {
          var n;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", ATTRIBUTE_OPERATION_ERR_USER_NOT_LOGGED_IN);

                case 2:
                  if (void 0 !== this.session) {
                    e.next = 4;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 4:
                  return checkValidAttrGetByKeysArgs(t, r), e.prev = 5, e.next = 8, this.session.requestGetUserAttributesByKeys(t, r).toPromise();

                case 8:
                  n = e.sent, e.next = 16;
                  break;

                case 11:
                  if (e.prev = 11, e.t0 = e.catch(5), !isRtmError(e.t0)) {
                    e.next = 15;
                    break;
                  }

                  throw e.t0;

                case 15:
                  throw new RtmInvalidArgumentError("arguments is not valid", ATTRIBUTE_OPERATION_ERR_INVALID_ARGUMENT);

                case 16:
                  return e.abrupt("return", fromPairs_1(n.attributeInfos.map(function (e) {
                    return [e.key, e.value];
                  })));

                case 17:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[5, 11]]);
        }));

        return function (t, r) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "login",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r, n, o, i, s, a, u;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (o = getRandomUInt64(), i = t.token, t.token === this.context.appId && (i = void 0), sendReport("Session", {
                    appId: this.context.appId,
                    did: navigator.userAgent,
                    elapse: getElapse(this.session && this.session.startTime),
                    index: {
                      index1: t.uid,
                      index2: this.context.appId,
                      index3: "enableLogUpload=".concat(this.parameters.enableLogUpload)
                    },
                    installId: processId,
                    lts: long_1.fromNumber(Date.now()),
                    os: WEB_PLATFORM_TYPE,
                    sid: getSid(o),
                    token: i || "",
                    userId: t.uid,
                    ver: version,
                    buildno: 100 * VERSION_NO + SUBVERSION,
                    subVersion: SUBVERSION,
                    version: VERSION_NO
                  }, null === (r = this.context.areaConfig) || void 0 === r ? void 0 : r.EVENT_REPORT_DOMAIN[0], null === (n = this.context.areaConfig) || void 0 === n ? void 0 : n.EVENT_REPORT_BACKUP_DOMAIN[0]), isPlainObject$1(t) && isValidId(t.uid)) {
                    e.next = 6;
                    break;
                  }

                  throw new RtmInvalidArgumentError("not a valid user id", LOGIN_ERR_INVALID_ARGUMENT);

                case 6:
                  if ("string" != typeof i || !i) {
                    e.next = 12;
                    break;
                  }

                  if (!(i.length < APP_ID_LENGTH + 3 || i.slice(3, APP_ID_LENGTH + 3) !== this.context.appId)) {
                    e.next = 9;
                    break;
                  }

                  throw new RtmInvalidArgumentError("Invalid token", LOGIN_ERR_INVALID_TOKEN);

                case 9:
                  this.context.token = i, e.next = 14;
                  break;

                case 12:
                  if ("string" == typeof i || isNil_1(i)) {
                    e.next = 14;
                    break;
                  }

                  throw new RtmInvalidArgumentError('The "token" is not a valid string.', LOGIN_ERR_INVALID_ARGUMENT);

                case 14:
                  return s = Date.now(), this.context.sid = getSid(o), this.loginPromise = this.loginImpl({
                    uid: t.uid,
                    instanceId: o
                  }), this.info("RTM Client logging in as ".concat(t.uid)), e.prev = 18, e.next = 21, this.loginPromise;

                case 21:
                  e.next = 28;
                  break;

                case 23:
                  throw e.prev = 23, e.t0 = e.catch(18), isRtmError(e.t0) && sendReport("Link", {
                    ackedServerIp: "",
                    destServerIp: "",
                    ec: e.t0.code || 1,
                    sc: e.t0.serverCode,
                    elapse: getElapse(this.session && this.session.startTime),
                    lts: long_1.fromNumber(Date.now()),
                    responseTime: Date.now() - s,
                    sid: getSid(o),
                    userId: t.uid
                  }, null === (a = this.context.areaConfig) || void 0 === a ? void 0 : a.EVENT_REPORT_DOMAIN[0], null === (u = this.context.areaConfig) || void 0 === u ? void 0 : u.EVENT_REPORT_BACKUP_DOMAIN[0]), this.context.token = void 0, e.t0;

                case 28:
                  return e.prev = 28, this.loginPromise = void 0, e.finish(28);

                case 31:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[18, 23, 28, 31]]);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "logout",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e() {
          var t, r;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!this.loginPromise) {
                    e.next = 3;
                    break;
                  }

                  return e.next = 3, this.loginPromise;

                case 3:
                  if (this.connectionState !== ConnectionState$1.DISCONNECTED) {
                    e.next = 6;
                    break;
                  }

                  throw this.logError("Already in logout state"), new RtmInvalidStatusError("Logout failure. The client has already been logged out", LOGOUT_ERR_USER_NOT_LOGGED_IN);

                case 6:
                  if (this.connectionState !== ConnectionState$1.ABORTED) {
                    e.next = 10;
                    break;
                  }

                  return this.info('Reset connection state from "ABORTED" to "DISCONNECTED"'), this.onConnectionStateChanged(ConnectionState$1.DISCONNECTED, ConnectionChangeReason.LOGOUT), e.abrupt("return");

                case 10:
                  if (void 0 !== this.session) {
                    e.next = 13;
                    break;
                  }

                  return this.onConnectionStateChanged(ConnectionState$1.DISCONNECTED, ConnectionChangeReason.LOGOUT), e.abrupt("return");

                case 13:
                  return sendReport("Logout", {
                    elapse: getElapse(this.session.startTime),
                    lts: long_1.fromNumber(Date.now()),
                    sid: getSid(this.session.instanceId),
                    userId: this.context.uid
                  }, null === (t = this.context.areaConfig) || void 0 === t ? void 0 : t.EVENT_REPORT_DOMAIN[0], null === (r = this.context.areaConfig) || void 0 === r ? void 0 : r.EVENT_REPORT_BACKUP_DOMAIN[0]), e.next = 16, this.session.logoutHandler();

                case 16:
                  this.onConnectionStateChanged(ConnectionState$1.DISCONNECTED, ConnectionChangeReason.LOGOUT), this.log("Log out success");

                case 18:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function () {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "logoutSync",
      value: function value() {
        var e,
            t,
            r = this;
        if (this.connectionState === ConnectionState$1.DISCONNECTED) throw this.logError("Already in logout state"), new RtmInvalidStatusError("Logout failure. The client has already been logged out", LOGOUT_ERR_USER_NOT_LOGGED_IN);
        if (this.connectionState === ConnectionState$1.ABORTED) return this.info('Reset connection state from "ABORTED" to "DISCONNECTED"'), void this.onConnectionStateChanged(ConnectionState$1.DISCONNECTED, ConnectionChangeReason.LOGOUT);
        void 0 !== this.session ? (sendReport("Logout", {
          elapse: getElapse(this.session.startTime),
          lts: long_1.fromNumber(Date.now()),
          sid: getSid(this.session.instanceId),
          userId: this.context.uid
        }, null === (e = this.context.areaConfig) || void 0 === e ? void 0 : e.EVENT_REPORT_DOMAIN[0], null === (t = this.context.areaConfig) || void 0 === t ? void 0 : t.EVENT_REPORT_BACKUP_DOMAIN[0]), this.session.logoutHandler().then(function () {
          r.log("Log out success");
        }), this.onConnectionStateChanged(ConnectionState$1.DISCONNECTED, ConnectionChangeReason.LOGOUT)) : this.onConnectionStateChanged(ConnectionState$1.DISCONNECTED, ConnectionChangeReason.LOGOUT);
      }
    }, {
      key: "sendMessageToPeer",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t, r) {
          var n,
              o,
              i,
              s,
              a,
              u,
              l = this,
              c = arguments;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (n = c.length > 2 && void 0 !== c[2] ? c[2] : {}, o = n.enableOfflineMessaging, i = void 0 !== o && o, s = n.enableHistoricalMessaging, a = void 0 !== s && s, validMessage(t, PEER_MESSAGE_ERR_INVALID_MESSAGE), this.connectionState !== ConnectionState$1.RECONNECTING) {
                    e.next = 5;
                    break;
                  }

                  return u = Date.now(), e.abrupt("return", new Promise(function (e, n) {
                    var o,
                        s = function () {
                      var s = _asyncToGenerator$d(regenerator.mark(function s() {
                        var c;
                        return regenerator.wrap(function (s) {
                          for (;;) {
                            switch (s.prev = s.next) {
                              case 0:
                                if (void 0 !== l.session) {
                                  s.next = 2;
                                  break;
                                }

                                throw new CommonError({
                                  SESSION_NOT_FOUND: "Failed to get session of the client"
                                });

                              case 2:
                                return c = Date.now() - u, s.prev = 3, s.t0 = e, s.next = 7, commonSendMessage({
                                  message: t,
                                  peerId: r,
                                  toPeer: !0,
                                  session: l.session,
                                  errorCodes: {
                                    NOT_LOGGED_IN: PEER_MESSAGE_ERR_USER_NOT_LOGGED_IN,
                                    TOO_OFTEN: PEER_MESSAGE_ERR_TOO_OFTEN
                                  },
                                  diff: c,
                                  logger: l.logger,
                                  options: {
                                    enableHistoricalMessaging: a,
                                    enableOfflineMessaging: i
                                  }
                                });

                              case 7:
                                s.t1 = s.sent, (0, s.t0)(s.t1), s.next = 16;
                                break;

                              case 11:
                                s.prev = 11, s.t2 = s.catch(3), isTimeout(s.t2) && n(new RtmTimeoutError(genTimeoutMessage(l.name, "sendMessageToPeer", MESSAGE_SEND_TIMEOUT), PEER_MESSAGE_ERR_TIMEOUT)), isRtmError(s.t2) && n(s.t2), n(new RtmUnavailableError("Peer-to-peer message send failure", {
                                  code: PEER_MESSAGE_ERR_FAILURE,
                                  originalError: s.t2
                                }));

                              case 16:
                                return s.prev = 16, clearTimeout(o), s.finish(16);

                              case 19:
                              case "end":
                                return s.stop();
                            }
                          }
                        }, s, null, [[3, 11, 16, 19]]);
                      }));

                      return function () {
                        return s.apply(this, arguments);
                      };
                    }();

                    l.internalEmitter.once("RECONNECTED", s), o = setTimeout(function () {
                      l.internalEmitter.off("RECONNECTED", s), n(new RtmTimeoutError(genTimeoutMessage(l.name, "sendMessageToPeer", MESSAGE_SEND_TIMEOUT), PEER_MESSAGE_ERR_TIMEOUT));
                    }, 9e3);
                  }));

                case 5:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 7;
                    break;
                  }

                  throw new RtmInvalidStatusError("Failed to send the peer-to-peer message. The client is not logged in", PEER_MESSAGE_ERR_USER_NOT_LOGGED_IN);

                case 7:
                  if (void 0 !== this.session) {
                    e.next = 9;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 9:
                  return e.prev = 9, e.next = 12, commonSendMessage({
                    message: t,
                    peerId: r,
                    toPeer: !0,
                    session: this.session,
                    errorCodes: {
                      NOT_LOGGED_IN: PEER_MESSAGE_ERR_USER_NOT_LOGGED_IN,
                      TOO_OFTEN: PEER_MESSAGE_ERR_TOO_OFTEN
                    },
                    diff: 0,
                    logger: this.logger,
                    options: {
                      enableHistoricalMessaging: a,
                      enableOfflineMessaging: i
                    }
                  });

                case 12:
                  return e.abrupt("return", e.sent);

                case 15:
                  if (e.prev = 15, e.t0 = e.catch(9), !isTimeout(e.t0)) {
                    e.next = 19;
                    break;
                  }

                  throw new RtmTimeoutError(genTimeoutMessage(this.name, "sendMessageToPeer", MESSAGE_SEND_TIMEOUT), PEER_MESSAGE_ERR_TIMEOUT);

                case 19:
                  if (!isRtmError(e.t0)) {
                    e.next = 21;
                    break;
                  }

                  throw e.t0;

                case 21:
                  throw new RtmUnavailableError("Peer-to-peer message send failure", {
                    code: PEER_MESSAGE_ERR_FAILURE,
                    originalError: e.t0
                  });

                case 22:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[9, 15]]);
        }));

        return function (t, r) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "createChannel",
      value: function value(e) {
        var t = this;
        if (!isValidId(e)) throw new RtmInvalidArgumentError([invalidArgumentMessage, getName({
          channelId: e
        })], CREATE_CHANNEL_ERR_INVALID_ARGUMENT);
        return new Channel(e, function () {
          return t.session;
        }, this, this.logger);
      }
    }, {
      key: "createLocalInvitation",
      value: function value(e) {
        if (!isValidId(e)) throw new RtmInvalidArgumentError([invalidArgumentMessage, getName({
          calleeId: e
        })], INVITATION_API_CALL_ERR_INVALID_ARGUMENT);
        return this.invitationManager.genLocalInvitation(e);
      }
    }, {
      key: "subscribePeersOnlineStatus",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r,
              n,
              o,
              i,
              s,
              a,
              u,
              l,
              c,
              p,
              f,
              d,
              g,
              h,
              b,
              y,
              _,
              m,
              v,
              E,
              O,
              I = this;

          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", PEER_SUBSCRIPTION_STATUS_ERR_USER_NOT_LOGGED_IN);

                case 2:
                  if (void 0 !== this.session) {
                    e.next = 4;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 4:
                  if (Array.isArray(t) && 0 !== t.length) {
                    e.next = 6;
                    break;
                  }

                  throw new RtmInvalidArgumentError("Invalid arguments: peerIds", PEER_SUBSCRIPTION_STATUS_ERR_INVALID_ARGUMENT);

                case 6:
                  r = t, n = Array.isArray(r), o = 0, r = n ? r : r[Symbol.iterator]();

                case 7:
                  if (!n) {
                    e.next = 13;
                    break;
                  }

                  if (!(o >= r.length)) {
                    e.next = 10;
                    break;
                  }

                  return e.abrupt("break", 22);

                case 10:
                  i = r[o++], e.next = 17;
                  break;

                case 13:
                  if (!(o = r.next()).done) {
                    e.next = 16;
                    break;
                  }

                  return e.abrupt("break", 22);

                case 16:
                  i = o.value;

                case 17:
                  if (isValidId(s = i)) {
                    e.next = 20;
                    break;
                  }

                  throw new RtmInvalidArgumentError(["subscribePeersOnlineStatus peer id %s is invalid", s], PEER_SUBSCRIPTION_STATUS_ERR_INVALID_ARGUMENT);

                case 20:
                  e.next = 7;
                  break;

                case 22:
                  if (!((a = uniq_1(t)).length + Object.keys(this.subscribedPeerStatusCache).length > 512)) {
                    e.next = 25;
                    break;
                  }

                  throw new RtmLimitExceededError("Subscribed peers overflows", PEER_SUBSCRIPTION_STATUS_ERR_OVERFLOW);

                case 25:
                  return e.next = 27, this.session.requestSubscribePeersOnlineStatus(a).toPromise();

                case 27:
                  u = e.sent, l = u.errors, c = [], p = [], f = l, d = Array.isArray(f), g = 0, f = d ? f : f[Symbol.iterator]();

                case 32:
                  if (!d) {
                    e.next = 38;
                    break;
                  }

                  if (!(g >= f.length)) {
                    e.next = 35;
                    break;
                  }

                  return e.abrupt("break", 48);

                case 35:
                  h = f[g++], e.next = 42;
                  break;

                case 38:
                  if (!(g = f.next()).done) {
                    e.next = 41;
                    break;
                  }

                  return e.abrupt("break", 48);

                case 41:
                  h = g.value;

                case 42:
                  if (y = (b = h).code, "string" == typeof (_ = b.account)) {
                    e.next = 45;
                    break;
                  }

                  throw new RtmUnavailableError("Returned account is invalid", PEER_SUBSCRIPTION_STATUS_ERR_FAILURE);

                case 45:
                  0 !== y && c.push(_);

                case 46:
                  e.next = 32;
                  break;

                case 48:
                  m = a, v = Array.isArray(m), E = 0, m = v ? m : m[Symbol.iterator]();

                case 49:
                  if (!v) {
                    e.next = 55;
                    break;
                  }

                  if (!(E >= m.length)) {
                    e.next = 52;
                    break;
                  }

                  return e.abrupt("break", 63);

                case 52:
                  O = m[E++], e.next = 59;
                  break;

                case 55:
                  if (!(E = m.next()).done) {
                    e.next = 58;
                    break;
                  }

                  return e.abrupt("break", 63);

                case 58:
                  O = E.value;

                case 59:
                  _ = O, c.includes(_) || (p.push(_), this.subscribedPeerStatusCache[_] = void 0);

                case 61:
                  e.next = 49;
                  break;

                case 63:
                  if (this.session.requestPeersOnlineStatus(p).pipe(map$1(function (e) {
                    var t = e.userInfos;
                    return mapValues_1(keyBy_1(t, "account"), function (e) {
                      var t = e.ts;
                      return Boolean(t);
                    });
                  })).subscribe(function (e) {
                    var t = mapValues_1(e, function (e, t) {
                      var r = e ? RtmStatusCode$1.PeerOnlineState.ONLINE : RtmStatusCode$1.PeerOnlineState.OFFLINE;
                      return I.subscribedPeerStatusCache[t] = r, r;
                    });
                    I.emit("PeersOnlineStatusChanged", t);
                  }), 0 === c.length) {
                    e.next = 66;
                    break;
                  }

                  throw new RtmUnavailableError("Subscription failed", PEER_SUBSCRIPTION_STATUS_ERR_FAILURE);

                case 66:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "unsubscribePeersOnlineStatus",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r, n, o, i, s, a, u, l, c, p, f;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", PEER_SUBSCRIPTION_STATUS_ERR_USER_NOT_LOGGED_IN);

                case 2:
                  if (void 0 !== this.session) {
                    e.next = 4;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 4:
                  if (Array.isArray(t) && 0 !== t.length) {
                    e.next = 6;
                    break;
                  }

                  throw new RtmInvalidArgumentError("Invalid arguments: peerIds", PEER_SUBSCRIPTION_STATUS_ERR_INVALID_ARGUMENT);

                case 6:
                  r = t, n = Array.isArray(r), o = 0, r = n ? r : r[Symbol.iterator]();

                case 7:
                  if (!n) {
                    e.next = 13;
                    break;
                  }

                  if (!(o >= r.length)) {
                    e.next = 10;
                    break;
                  }

                  return e.abrupt("break", 22);

                case 10:
                  i = r[o++], e.next = 17;
                  break;

                case 13:
                  if (!(o = r.next()).done) {
                    e.next = 16;
                    break;
                  }

                  return e.abrupt("break", 22);

                case 16:
                  i = o.value;

                case 17:
                  if (isValidId(s = i)) {
                    e.next = 20;
                    break;
                  }

                  throw new RtmInvalidArgumentError(["subscribePeersOnlineStatus peer id %s is invalid", s], PEER_SUBSCRIPTION_STATUS_ERR_INVALID_ARGUMENT);

                case 20:
                  e.next = 7;
                  break;

                case 22:
                  if (!(t.length > 512)) {
                    e.next = 24;
                    break;
                  }

                  throw new RtmLimitExceededError("Unsubscribed peers overflows", PEER_SUBSCRIPTION_STATUS_ERR_OVERFLOW);

                case 24:
                  a = uniq_1(t), this.session.requestUnsubscribePeersOnlineStatus(a), u = a, l = Array.isArray(u), c = 0, u = l ? u : u[Symbol.iterator]();

                case 27:
                  if (!l) {
                    e.next = 33;
                    break;
                  }

                  if (!(c >= u.length)) {
                    e.next = 30;
                    break;
                  }

                  return e.abrupt("break", 41);

                case 30:
                  p = u[c++], e.next = 37;
                  break;

                case 33:
                  if (!(c = u.next()).done) {
                    e.next = 36;
                    break;
                  }

                  return e.abrupt("break", 41);

                case 36:
                  p = c.value;

                case 37:
                  f = p, delete this.subscribedPeerStatusCache[f];

                case 39:
                  e.next = 27;
                  break;

                case 41:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "queryPeersBySubscriptionOption",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 2;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", PEER_SUBSCRIPTION_STATUS_ERR_USER_NOT_LOGGED_IN);

                case 2:
                  if (t !== RtmStatusCode$1.PeerSubscriptionOption.ONLINE_STATUS) {
                    e.next = 4;
                    break;
                  }

                  return e.abrupt("return", Object.keys(this.subscribedPeerStatusCache));

                case 4:
                  throw new RtmInvalidArgumentError("Subscription option not supported", PEER_SUBSCRIPTION_STATUS_ERR_INVALID_ARGUMENT);

                case 5:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "createMessage",
      value: function value(e) {
        return "IMAGE" === e.messageType ? _objectSpread$4({
          width: 0,
          height: 0,
          fileName: "",
          description: "",
          thumbnail: new Blob(),
          thumbnailWidth: 0,
          thumbnailHeight: 0,
          size: 0
        }, e) : "FILE" === e.messageType ? _objectSpread$4({
          fileName: "",
          description: "",
          thumbnail: new Blob(),
          size: 0
        }, e) : e;
      }
    }, {
      key: "downloadMedia",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r,
              n,
              o,
              i,
              s,
              a,
              u,
              l,
              c,
              p,
              f,
              d,
              g,
              h,
              b = this,
              y = arguments;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (r = y.length > 1 && void 0 !== y[1] ? y[1] : {}, "string" == typeof t) {
                    e.next = 3;
                    break;
                  }

                  throw new RtmInvalidArgumentError("invalid mediaId format", DOWNLOAD_MEDIA_ERR_INVALID_ARGUMENT);

                case 3:
                  if (e.prev = 3, n = t.split("z"), o = _slicedToArray$b(n, 3), i = o[0], s = o[1], a = o[2], u = i.slice(1, 65), l = hexToDigest(u), c = parseInt(i.slice(65), 10), p = parseInt(s, 10), f = parseInt(a, 10), !(Number.isNaN(c) || Number.isNaN(p) || Number.isNaN(f))) {
                    e.next = 12;
                    break;
                  }

                  throw new RtmInvalidArgumentError("Invalid mediaId content", DOWNLOAD_MEDIA_ERR_INVALID_ARGUMENT);

                case 12:
                  e.next = 19;
                  break;

                case 14:
                  if (e.prev = 14, e.t0 = e.catch(3), !isRtmError(e.t0)) {
                    e.next = 18;
                    break;
                  }

                  throw e.t0;

                case 18:
                  throw new RtmInvalidArgumentError("parse mediaId failure", {
                    code: DOWNLOAD_MEDIA_ERR_INVALID_ARGUMENT,
                    originalError: e.t0
                  });

                case 19:
                  if (this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 21;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in, cannot download", DOWNLOAD_MEDIA_ERR_NOT_LOGGED_IN);

                case 21:
                  if (void 0 !== this.session) {
                    e.next = 23;
                    break;
                  }

                  throw new CommonError({
                    SESSION_NOT_FOUND: "Failed to get session of the client"
                  });

                case 23:
                  return d = this.mediaTaskManager.addDownloadTask({
                    unit: p,
                    zone: c,
                    hashHexStr: u,
                    size: f
                  }, function () {
                    if (void 0 === b.session) throw new CommonError({
                      SESSION_NOT_FOUND: "Failed to get session of the client"
                    });
                    return b.session.requestFileDownloadIndexGet({
                      hash: l,
                      zone: c,
                      unit: p,
                      size: f
                    }).toPromise();
                  }, r), e.next = 26, this.mediaTaskManager.waitMediaTask(d);

                case 26:
                  return g = e.sent, h = g.payload, e.abrupt("return", h);

                case 29:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[3, 14]]);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "createMediaMessageByUploading",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r,
              n,
              o,
              i,
              s,
              a,
              u,
              l,
              c,
              p,
              f,
              d,
              g,
              h,
              b,
              y,
              _,
              m,
              v,
              E,
              O,
              I,
              $,
              S,
              w = this,
              R = arguments;

          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (r = R.length > 1 && void 0 !== R[1] ? R[1] : {}, n = R.length > 2 && void 0 !== R[2] ? R[2] : {}, isPlainObject$1(r)) {
                    e.next = 4;
                    break;
                  }

                  throw new RtmInvalidArgumentError("Invalid params", UPLOAD_MEDIA_ERR_INVALID_ARGUMENT);

                case 4:
                  if (o = "thumbnailWidth" in r || "thumbnailHeight" in r || "width" in r || "height" in r, i = r.messageType, s = void 0 === i ? o ? "IMAGE" : "FILE" : i, a = r.description, u = void 0 === a ? "" : a, l = r.fileName, c = void 0 === l ? "" : l, p = r.thumbnail, "string" == typeof r.messageType && "string" == typeof u && "string" == typeof c && (isBlob(p) || void 0 === p) && isBlob(t)) {
                    e.next = 8;
                    break;
                  }

                  throw new RtmInvalidArgumentError("Invalid message params type", UPLOAD_MEDIA_ERR_INVALID_ARGUMENT);

                case 8:
                  if (!o || "FILE" !== s) {
                    e.next = 10;
                    break;
                  }

                  throw new RtmInvalidArgumentError("Invalid message params, unexpected field in RtmFileMessage", UPLOAD_MEDIA_ERR_INVALID_ARGUMENT);

                case 10:
                  if ("FILE" === s || "IMAGE" === s) {
                    e.next = 12;
                    break;
                  }

                  throw new RtmInvalidArgumentError(["Invalid messageType in params, unknown type %s", s], UPLOAD_MEDIA_ERR_INVALID_ARGUMENT);

                case 12:
                  if (!((f = t.size) > 33554432)) {
                    e.next = 15;
                    break;
                  }

                  throw new RtmLimitExceededError("The payload size overflow 32 MB", UPLOAD_MEDIA_ERR_SIZE_OVERFLOW);

                case 15:
                  return e.next = 17, blobToArrayBuffer(t);

                case 17:
                  return d = e.sent, e.next = 20, sha256Digest(d);

                case 20:
                  if (g = e.sent, this.connectionState === ConnectionState$1.CONNECTED) {
                    e.next = 23;
                    break;
                  }

                  throw new RtmInvalidStatusError("The client is not logged in", UPLOAD_MEDIA_ERR_NOT_LOGGED_IN);

                case 23:
                  if ("IMAGE" !== s) {
                    e.next = 31;
                    break;
                  }

                  return e.next = 26, getImageSize(r, d);

                case 26:
                  h = e.sent, b = h.height, y = h.width, _ = h.thumbnailWidth, m = h.thumbnailHeight;

                case 31:
                  return v = this.mediaTaskManager.addUploadTask({
                    file: new Uint8Array(d),
                    hash: g
                  }, function () {
                    if (void 0 === w.session) throw new CommonError({
                      SESSION_NOT_FOUND: "Failed to get session of the client"
                    });
                    return w.session.fetchFileUploadIndexGet({
                      hash: g,
                      size: f
                    });
                  }, function (e, t) {
                    if (void 0 === w.session) throw new CommonError({
                      SESSION_NOT_FOUND: "Failed to get session of the client"
                    });
                    return w.session.requestFileUploadIndexSet({
                      hash: g,
                      unit: e,
                      servers: t
                    }).toPromise();
                  }, n), e.next = 34, this.mediaTaskManager.waitMediaTask(v);

                case 34:
                  if (E = e.sent, O = E.zone, I = E.retUnit, "IMAGE" !== s) {
                    e.next = 40;
                    break;
                  }

                  return $ = {
                    height: b,
                    width: y,
                    fileName: c,
                    size: f,
                    description: u,
                    thumbnail: p,
                    messageType: s,
                    thumbnailWidth: _,
                    thumbnailHeight: m,
                    mediaId: "0".concat(digestToHex(g)).concat(O, "z").concat(I, "z").concat(f, "z").concat(b, "z").concat(y)
                  }, e.abrupt("return", $);

                case 40:
                  return S = {
                    fileName: c,
                    size: f,
                    description: u,
                    mediaId: "0".concat(digestToHex(g)).concat(O, "z").concat(I, "z").concat(f),
                    thumbnail: p,
                    messageType: s
                  }, e.abrupt("return", S);

                case 42:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "loginImpl",
      value: function () {
        var e = _asyncToGenerator$d(regenerator.mark(function e(t) {
          var r,
              n,
              o,
              i,
              s,
              a = this;
          return regenerator.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (r = t.uid, n = t.instanceId, o = n, !(void 0 !== this.lastLoginTime && Date.now() - this.lastLoginTime < 1e3 / LOGIN_QPS_LIMIT)) {
                    e.next = 4;
                    break;
                  }

                  throw new RtmInvokeTooOftenError(["The frequency of login exceeded the limit of %d queries per second", LOGIN_QPS_LIMIT], LOGIN_ERR_TOO_OFTEN);

                case 4:
                  if (this.connectionState === ConnectionState$1.DISCONNECTED) {
                    e.next = 6;
                    break;
                  }

                  throw new RtmInvalidStatusError("The SDK is either logging in or has logged in the Agora RTM system", LOGIN_ERR_ALREADY_LOGIN);

                case 6:
                  e.prev = 6, this.context.uid = r, e.next = 13;
                  break;

                case 10:
                  throw e.prev = 10, e.t0 = e.catch(6), new RtmInvalidArgumentError([invalidArgumentMessage, getName({
                    uid: r
                  })], LOGIN_ERR_INVALID_ARGUMENT);

                case 13:
                  return this.onConnectionStateChanged(ConnectionState$1.CONNECTING, ConnectionChangeReason.LOGIN), i = new Session$2(this.context, new Connection(this.context, this.logger), o, this.logger), this.session = i, s = function s() {
                    a.connectionState === ConnectionState$1.CONNECTED && (a.onConnectionStateChanged(ConnectionState$1.RECONNECTING, ConnectionChangeReason.INTERRUPTED), a.session && a.session.once("userJoined", function () {
                      a.onConnectionStateChanged(ConnectionState$1.CONNECTED, ConnectionChangeReason.LOGIN_SUCCESS);
                    }));
                  }, i.on("connectionLost", s), i.on("tokenExpired", function () {
                    a.emit("TokenExpired");
                  }), i.once("userDrop", this.userDropHandler), this.session.on("peerTextMessage", function (e) {
                    var t = e.peerId,
                        r = e.text,
                        n = e.properties;
                    a.emit("MessageFromPeer", {
                      text: r,
                      messageType: RtmStatusCode$1.MessageType.TEXT
                    }, t, n);
                  }), this.session.on("peerMediaMessage", function (e) {
                    var t = e.peerId,
                        r = e.properties,
                        n = e.messageType,
                        o = e.details;
                    "FILE" === n ? a.emit("MessageFromPeer", {
                      messageType: RtmStatusCode$1.MessageType.FILE,
                      size: parseInt(decodeUint8ArrayToString(o[MESSAGE_MEDIA_SIZE_KEY]), 10),
                      description: decodeUint8ArrayToString(o[MESSAGE_MEDIA_DESCRIPTION_KEY]),
                      fileName: decodeUint8ArrayToString(o[MESSAGE_MEDIA_FILENAME_KEY]),
                      mediaId: decodeUint8ArrayToString(o[MESSAGE_MEDIA_ID_KEY]),
                      thumbnail: new Blob([o[MESSAGE_MEDIA_THUMBNAIL_KEY]])
                    }, t, r) : "IMAGE" === n && a.emit("MessageFromPeer", {
                      messageType: RtmStatusCode$1.MessageType.IMAGE,
                      size: parseInt(decodeUint8ArrayToString(o[MESSAGE_MEDIA_SIZE_KEY]), 10),
                      description: decodeUint8ArrayToString(o[MESSAGE_MEDIA_DESCRIPTION_KEY]),
                      fileName: decodeUint8ArrayToString(o[MESSAGE_MEDIA_FILENAME_KEY]),
                      mediaId: decodeUint8ArrayToString(o[MESSAGE_MEDIA_ID_KEY]),
                      thumbnail: new Blob([o[MESSAGE_MEDIA_THUMBNAIL_KEY]]),
                      height: parseInt(decodeUint8ArrayToString(o[MESSAGE_MEDIA_HEIGHT_KEY]), 10),
                      width: parseInt(decodeUint8ArrayToString(o[MESSAGE_MEDIA_WIDTH_KEY]), 10),
                      thumbnailHeight: parseInt(decodeUint8ArrayToString(o[MESSAGE_MEDIA_THUMBNAILHEIGHT_KEY]), 10),
                      thumbnailWidth: parseInt(decodeUint8ArrayToString(o[MESSAGE_MEDIA_THUMBNAILWIDTH_KEY]), 10)
                    }, t, r);
                  }), this.session.on("peerRawMessage", function (e) {
                    var t = e.desc,
                        r = e.raw,
                        n = e.properties,
                        o = e.peerId;
                    a.emit("MessageFromPeer", {
                      rawMessage: r,
                      description: t,
                      messageType: RtmStatusCode$1.MessageType.RAW
                    }, o, n);
                  }), i.on("instanceChanged", function (e) {
                    return o = e;
                  }), i.on("peerOnlineStatusChanged", function (e) {
                    var t = e.instance.toString() + e.state,
                        r = a.peerStatusSeqLru.get(t);
                    !r || e.seq.greaterThan(r) ? (a.peerStatusSeqLru.set(t, e.seq), e.state !== a.subscribedPeerStatusCache[e.peerId] ? a.emit("PeersOnlineStatusChanged", _defineProperty$6({}, e.peerId, e.state)) : a.log("peer status for %s not changed, previous %s", e.peerId, e.state), a.subscribedPeerStatusCache[e.peerId] = e.state, clearTimeout(a.peerUnreachableTimers[t]), e.state === RtmStatusCode$1.PeerOnlineState.UNREACHABLE && (a.peerUnreachableTimers[t] = setTimeout(function () {
                      a.subscribedPeerStatusCache[e.peerId] === RtmStatusCode$1.PeerOnlineState.UNREACHABLE && (a.subscribedPeerStatusCache[e.peerId] = RtmStatusCode$1.PeerOnlineState.ONLINE, a.emit("PeersOnlineStatusChanged", _defineProperty$6({}, e.peerId, RtmStatusCode$1.PeerOnlineState.ONLINE)));
                    }, 3e4))) : a.log("peerOnlineStatusChanged dedup for %s, %d", t, e.seq.toNumber());
                  }), i.on("invitationMessage", this.invitationManager.invitationMessageHandler.bind(this.invitationManager)), i.on("channelAttributesUpdated", function (e) {
                    var t = e.channelId,
                        r = {},
                        n = e.attributeMaps,
                        o = Array.isArray(n),
                        i = 0;

                    for (n = o ? n : n[Symbol.iterator]();;) {
                      var s;

                      if (o) {
                        if (i >= n.length) break;
                        s = n[i++];
                      } else {
                        if ((i = n.next()).done) break;
                        s = i.value;
                      }

                      var u = s,
                          l = u.key,
                          c = u.ms,
                          p = u.value,
                          f = u.origin;
                      if ("string" != typeof l || !long_1.isLong(c) || "string" != typeof p || !isValidId(f)) break;
                      r[l] = new Blob([p]).size;
                    }

                    a.channelAttributesCacheLru.set(t, r);
                  }), i.on("userJoined", function (e) {
                    if (0 !== Object.keys(a.attributes).length) {
                      if (void 0 === a.session) return;
                      a.session.requestSetLocalUserAttributes(a.attributes, e).toPromise();
                    }

                    if (0 !== a.attributeDrafts.size) {
                      var t = function t() {
                        if (n) {
                          if (o >= r.length) return "break";
                          s = r[o++];
                        } else {
                          if ((o = r.next()).done) return "break";
                          s = o.value;
                        }

                        var t = s,
                            i = t.promise,
                            u = t.attribute;
                        i.then(function () {
                          void 0 !== a.session && a.session.requestSetLocalUserAttributes(u, e).toPromise();
                        });
                      },
                          r = a.attributeDrafts,
                          n = Array.isArray(r),
                          o = 0;

                      for (r = n ? r : r[Symbol.iterator]();;) {
                        var s;
                        if ("break" === t()) break;
                      }
                    }

                    0 !== Object.keys(a.subscribedPeerStatusCache).length && i.requestSubscribePeersOnlineStatus(Object.keys(a.subscribedPeerStatusCache));
                  }), this.lastLoginTime = Date.now(), e.prev = 29, e.next = 32, i.loginHandler().toPromise();

                case 32:
                  this.mediaTaskManager.setAuthInfo({
                    ticket: i.connection.curOpenSockets.filter(function (e) {
                      return void 0 !== e;
                    })[0].ticket,
                    instance: i.instanceId,
                    isAreaCN: "CN" === this.context.area,
                    loginOpt: i.userJoinOptions.toLong()
                  }), e.next = 44;
                  break;

                case 35:
                  if (e.prev = 35, e.t1 = e.catch(29), !isTimeout(e.t1)) {
                    e.next = 40;
                    break;
                  }

                  throw this.onConnectionStateChanged(ConnectionState$1.DISCONNECTED, ConnectionChangeReason.LOGIN_TIMEOUT), new RtmTimeoutError(genTimeoutMessage(this.name, "login", CLIENT_LOGIN_TIMEOUT), LOGIN_ERR_TIMEOUT);

                case 40:
                  if (this.onConnectionStateChanged(ConnectionState$1.DISCONNECTED, ConnectionChangeReason.LOGIN_FAILURE), !isRtmError(e.t1)) {
                    e.next = 43;
                    break;
                  }

                  throw e.t1;

                case 43:
                  throw new RtmUnavailableError("Login failure", {
                    code: LOGIN_ERR_UNKNOWN,
                    originalError: e.t1
                  });

                case 44:
                  this.onConnectionStateChanged(ConnectionState$1.CONNECTED, ConnectionChangeReason.LOGIN_SUCCESS);

                case 45:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[6, 10], [29, 35]]);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      key: "onConnectionStateChanged",
      value: function value(e, t) {
        var r,
            n,
            o = this;
        e === ConnectionState$1.RECONNECTING && (this.reconnId += 1), sendReport("ConnectionStateChange", {
          elapse: getElapse(this.session && this.session.startTime),
          lts: long_1.fromNumber(Date.now()),
          newState: connectionStateCodeMap[e],
          oldState: connectionStateCodeMap[this.connectionState],
          reason: connectionStateChangeReason[t],
          sid: getSid(this.session && this.session.instanceId || long_1.fromNumber(0)),
          userId: this.context.uid,
          reconnId: this.reconnId
        }, null === (r = this.context.areaConfig) || void 0 === r ? void 0 : r.EVENT_REPORT_DOMAIN[0], null === (n = this.context.areaConfig) || void 0 === n ? void 0 : n.EVENT_REPORT_BACKUP_DOMAIN[0]), this.connectionState === ConnectionState$1.RECONNECTING && e === ConnectionState$1.CONNECTED && (0 !== Object.keys(this.subscribedPeerStatusCache).length && void 0 !== this.session && this.session.requestPeersOnlineStatus(Object.keys(this.subscribedPeerStatusCache)).pipe(map$1(function (e) {
          var t = e.userInfos;
          return mapValues_1(keyBy_1(t, "account"), function (e) {
            var t = e.ts;
            return Boolean(t);
          });
        })).subscribe(function (e) {
          var t = mapValues_1(e, function (e, t) {
            var r = e ? RtmStatusCode$1.PeerOnlineState.ONLINE : RtmStatusCode$1.PeerOnlineState.OFFLINE;
            return o.subscribedPeerStatusCache[t] = r, r;
          });
          o.emit("PeersOnlineStatusChanged", t);
        }), this.internalEmitter.emit("RECONNECTED")), this.connectionState = e, e !== ConnectionState$1.ABORTED && e !== ConnectionState$1.DISCONNECTED || (this.reconnId = 0, this.attributes = {}, this.session && (this.session.removeAllListeners(), this.session.joinedChannels.clear(), this.session.msgDedupLru.empty(), this.session.dialogueSequenceLru.empty()), this.session = void 0, this.channelAttributesCacheLru.empty(), this.peerStatusSeqLru.empty(), this.peerUnreachableTimers = {}, this.subscribedPeerStatusCache = {}, this.attributeDrafts.clear(), this.context.token = void 0), this.mediaTaskManager.emit("connectionStateChanged", e), this.emit("ConnectionStateChanged", e, t);
      }
    }]), t;
  }(), _class$1 = _temp$1, _applyDecoratedDescriptor$1(_class$1.prototype, "renewToken", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "renewToken"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "queryPeersOnlineStatus", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "queryPeersOnlineStatus"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "getChannelMemberCount", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "getChannelMemberCount"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "setLocalUserAttributes", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "setLocalUserAttributes"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "setChannelAttributes", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "setChannelAttributes"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "addOrUpdateLocalUserAttributes", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "addOrUpdateLocalUserAttributes"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "addOrUpdateChannelAttributes", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "addOrUpdateChannelAttributes"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "deleteLocalUserAttributesByKeys", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "deleteLocalUserAttributesByKeys"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "deleteChannelAttributesByKeys", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "deleteChannelAttributesByKeys"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "clearLocalUserAttributes", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "clearLocalUserAttributes"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "clearChannelAttributes", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "clearChannelAttributes"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "getUserAttributes", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "getUserAttributes"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "getChannelAttributes", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "getChannelAttributes"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "getChannelAttributesByKeys", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "getChannelAttributesByKeys"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "getUserAttributesByKeys", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "getUserAttributesByKeys"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "login", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "login"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "logout", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "logout"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "logoutSync", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "logoutSync"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "sendMessageToPeer", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "sendMessageToPeer"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "createChannel", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "createChannel"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "createLocalInvitation", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "createLocalInvitation"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "subscribePeersOnlineStatus", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "subscribePeersOnlineStatus"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "unsubscribePeersOnlineStatus", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "unsubscribePeersOnlineStatus"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "queryPeersBySubscriptionOption", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "queryPeersBySubscriptionOption"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "createMessage", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "createMessage"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "downloadMedia", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "downloadMedia"), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, "createMediaMessageByUploading", [logged], Object.getOwnPropertyDescriptor(_class$1.prototype, "createMediaMessageByUploading"), _class$1.prototype), _class$1);

  function ownKeys$6(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function _objectSpread$5(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? ownKeys$6(r, !0).forEach(function (t) {
        _defineProperty$7(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys$6(r).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function _defineProperty$7(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  if (!window.console || 0 === Object.keys(window.console).length) {
    var originalConsole = window.console;
    window.console = {
      log: function log() {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }

        null == originalConsole || originalConsole.log.apply(originalConsole, t);
      },
      info: function info() {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }

        null == originalConsole || originalConsole.log.apply(originalConsole, t);
      },
      error: function error() {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }

        null == originalConsole || originalConsole.error.apply(originalConsole, t);
      },
      warn: function warn() {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }

        null == originalConsole || originalConsole.warn.apply(originalConsole, t);
      },
      debug: function debug() {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }

        null == originalConsole || originalConsole.log.apply(originalConsole, t);
      }
    };
  }

  var ConnectionChangeReason$1 = RtmStatusCode$1.ConnectionChangeReason,
      ConnectionState$2 = RtmStatusCode$1.ConnectionState,
      LocalInvitationFailureReason$1 = RtmStatusCode$1.LocalInvitationFailureReason,
      LocalInvitationState$1 = RtmStatusCode$1.LocalInvitationState,
      RemoteInvitationFailureReason$1 = RtmStatusCode$1.RemoteInvitationFailureReason,
      RemoteInvitationState$1 = RtmStatusCode$1.RemoteInvitationState,
      MessageType$1 = RtmStatusCode$1.MessageType,
      PeerOnlineState = RtmStatusCode$1.PeerOnlineState,
      PeerSubscriptionOption = RtmStatusCode$1.PeerSubscriptionOption;
  void 0 === Number.MAX_SAFE_INTEGER && (Number.MAX_SAFE_INTEGER = 9007199254740991);
  var LogFilter = {
    LOG_FILTER_OFF: {
      error: !1,
      warn: !1,
      info: !1,
      track: !1,
      debug: !1
    },
    LOG_FILTER_ERROR: {
      error: !0,
      warn: !1,
      info: !1,
      track: !1,
      debug: !1
    },
    LOG_FILTER_WARNING: {
      error: !0,
      warn: !0,
      info: !1,
      track: !1,
      debug: !1
    },
    LOG_FILTER_INFO: {
      error: !0,
      warn: !0,
      info: !0,
      track: !1,
      debug: !1
    },
    LOG_FILTER_DEBUG: {
      error: !0,
      warn: !0,
      info: !0,
      track: !0,
      debug: !0
    }
  };

  function createInstance(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.enableLogUpload,
        n = void 0 !== r && r,
        o = t.logFilter,
        i = void 0 === o ? LogFilter.LOG_FILTER_INFO : o,
        s = arguments.length > 2 ? arguments[2] : void 0;
    if (!isValidAppId(e)) throw new RtmInvalidArgumentError([invalidArgumentMessage, getName({
      appId: e
    })], CREATE_INSTANCE_ERR_INVALID_ARGUMENT);

    try {
      var a,
          u = {
        enableLogUpload: n,
        logFilter: i
      };
      null != s && (a = getAreaDomainConfig(s), u._areaConfig = a);
      var l = initLoggerId(),
          c = genInfoLogger(u),
          p = genWarnLogger(u),
          f = genErrorLogger(u),
          d = trackLoggerGenerator(l, u),
          g = debugLoggerGenerator(l, u),
          h = g("RTM:DEBUG", "<Entry> ");
      return c("The Agora RTM Web SDK version is %s", version), h("Creating an RtmClient instance"), h('The Git commit ID is "'.concat(BUILD, '"')), c("The process ID is %s", processId), c("The build is %s", BUILD), h("process.env.NODE_ENV is %s", "production"), new Client(e, {
        genLogger: g,
        genTracker: d,
        info: c,
        warn: p,
        logError: f,
        loggerId: l
      }, u, function (e) {
        var t = getKeys(e),
            r = Array.isArray(t),
            n = 0;

        for (t = r ? t : t[Symbol.iterator]();;) {
          var o;

          if (r) {
            if (n >= t.length) break;
            o = t[n++];
          } else {
            if ((n = t.next()).done) break;
            o = n.value;
          }

          var i = o;

          try {
            var s = e[i];
            null != s && (u[i] = s);
          } catch (e) {
            throw new RtmInvalidArgumentError([invalidArgumentMessage, i], void 0);
          }
        }
      }, a);
    } catch (e) {
      throw e;
    }
  }

  var index = _objectSpread$5({
    createInstance: createInstance,
    BUILD: BUILD,
    VERSION: version,
    END_CALL_PREFIX: END_CALL_PREFIX,
    processId: processId,
    ConnectionChangeReason: ConnectionChangeReason$1,
    ConnectionState: ConnectionState$2,
    LocalInvitationFailureReason: LocalInvitationFailureReason$1,
    LocalInvitationState: LocalInvitationState$1,
    RemoteInvitationFailureReason: RemoteInvitationFailureReason$1,
    RemoteInvitationState: RemoteInvitationState$1,
    MessageType: MessageType$1,
    PeerOnlineState: PeerOnlineState,
    PeerSubscriptionOption: PeerSubscriptionOption
  }, LogFilter);

  return index;
});